{
  "level": "mt02",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:mt02",
    "objects": "AREAS.E3:mt02.e3",
    "mesh": "TREES.E3:mt02.e3"
  },
  "spawn_point": {
    "position": [
      -1199.4972079407935,
      -3414.11077431581,
      24.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      -1199.4972079407935,
      -3314.11077431581,
      24.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -3085.076904296875,
      -4395.6328125,
      0.0
    ],
    "bbox_max": [
      -602.25048828125,
      -2421.921875,
      1574.9000244140625
    ],
    "vertex_count": 3111,
    "vertices": [
      [
        -660.0,
        -2993.1591796875,
        1302.5999755859375
      ],
      [
        -660.0,
        -3153.4228515625,
        1141.43310546875
      ],
      [
        -660.0,
        -3181.474609375,
        1094.8697509765625
      ],
      [
        -660.0,
        -3189.680419921875,
        1104.97119140625
      ],
      [
        -660.0,
        -3153.4228515625,
        1141.43310546875
      ],
      [
        -660.0,
        -3181.474609375,
        1094.86962890625
      ],
      [
        -660.0,
        -3350.221435546875,
        1302.5999755859375
      ],
      [
        -1223.9951171875,
        -3650.0,
        0.0
      ],
      [
        -917.23828125,
        -3650.0,
        0.0
      ],
      [
        -1145.534912109375,
        -3506.523681640625,
        267.0
      ],
      [
        -1145.534912109375,
        -3506.523681640625,
        267.0
      ],
      [
        -1182.7503662109375,
        -3440.52197265625,
        267.0
      ],
      [
        -1182.7503662109375,
        -3440.52197265625,
        267.0
      ],
      [
        -1198.09375,
        -3408.409912109375,
        267.0
      ],
      [
        -1198.09375,
        -3408.409912109375,
        267.0
      ],
      [
        -1207.7008056640625,
        -3394.232421875,
        267.0
      ],
      [
        -1207.7008056640625,
        -3394.232421875,
        267.0
      ],
      [
        -1208.414794921875,
        -3395.00634765625,
        267.0
      ],
      [
        -1188.102294921875,
        -3479.90869140625,
        69.50926208496094
      ],
      [
        -1200.9185791015625,
        -3466.518310546875,
        120.43780517578125
      ],
      [
        -1188.102294921875,
        -3479.90869140625,
        69.50926208496094
      ],
      [
        -1224.45458984375,
        -3411.963134765625,
        267.0
      ],
      [
        -1224.1302490234375,
        -3411.97802734375,
        267.0
      ],
      [
        -1224.50634765625,
        -3412.418212890625,
        267.0
      ],
      [
        -1224.45458984375,
        -3411.963134765625,
        267.0
      ],
      [
        -1200.9185791015625,
        -3466.518310546875,
        120.43780517578125
      ],
      [
        -1214.2481689453125,
        -3448.7548828125,
        252.16676330566406
      ],
      [
        -1220.430419921875,
        -3442.76953125,
        267.0
      ],
      [
        -1224.5528564453125,
        -3412.828125,
        267.0
      ],
      [
        -1214.2481689453125,
        -3448.7548828125,
        252.16676330566406
      ],
      [
        -1224.5528564453125,
        -3412.828125,
        267.0
      ],
      [
        -1224.07470703125,
        -3411.980712890625,
        267.0
      ],
      [
        -1224.07470703125,
        -3411.980712890625,
        267.0
      ],
      [
        -977.0939331054688,
        -3650.0,
        267.0
      ],
      [
        -1007.23779296875,
        -3650.0,
        6.0961198806762695
      ],
      [
        -1007.23779296875,
        -3650.0,
        6.09613037109375
      ],
      [
        -1007.8887329101562,
        -3650.0,
        2.6302847862243652
      ],
      [
        -1047.466064453125,
        -3650.0,
        9.05340576171875
      ],
      [
        -1066.54833984375,
        -3650.0,
        267.0
      ],
      [
        -1188.968017578125,
        -3525.123779296875,
        267.0
      ],
      [
        -1201.617919921875,
        -3515.152099609375,
        267.0
      ],
      [
        -1188.968017578125,
        -3525.123779296875,
        267.0
      ],
      [
        -1201.617919921875,
        -3515.152099609375,
        267.0
      ],
      [
        -1203.474609375,
        -3510.526123046875,
        267.0
      ],
      [
        -1203.686767578125,
        -3509.99755859375,
        267.0
      ],
      [
        -1045.9185791015625,
        -3650.0,
        0.0
      ],
      [
        -1047.466064453125,
        -3650.0,
        9.053411483764648
      ],
      [
        -1196.880615234375,
        -3513.037353515625,
        228.58932495117188
      ],
      [
        -1197.494384765625,
        -3512.52685546875,
        230.0940399169922
      ],
      [
        -1204.3563232421875,
        -3508.329345703125,
        267.0
      ],
      [
        -1197.494384765625,
        -3512.52685546875,
        230.0940399169922
      ],
      [
        -1196.880615234375,
        -3513.037353515625,
        228.58932495117188
      ],
      [
        -1215.0838623046875,
        -3481.6015625,
        267.0
      ],
      [
        -1215.0838623046875,
        -3481.6015625,
        267.0
      ],
      [
        -1008.3827514648438,
        -3650.0,
        0.0
      ],
      [
        -844.3095703125,
        -2426.030029296875,
        640.658935546875
      ],
      [
        -806.9904174804688,
        -2445.872802734375,
        640.5751342773438
      ],
      [
        -852.0359497070312,
        -2421.921875,
        664.2813110351562
      ],
      [
        -841.2787475585938,
        -2427.641357421875,
        682.542236328125
      ],
      [
        -846.2428588867188,
        -2425.002197265625,
        646.314208984375
      ],
      [
        -852.0359497070312,
        -2421.921875,
        664.2813110351562
      ],
      [
        -844.3095703125,
        -2426.030029296875,
        640.658935546875
      ],
      [
        -846.2428588867188,
        -2425.002197265625,
        646.314208984375
      ],
      [
        -841.2787475585938,
        -2427.641357421875,
        682.542236328125
      ],
      [
        -836.911376953125,
        -2429.963623046875,
        687.8262939453125
      ],
      [
        -806.9904174804688,
        -2445.872802734375,
        640.5751342773438
      ],
      [
        -798.2432250976562,
        -2450.52392578125,
        640.5693969726562
      ],
      [
        -883.9695434570312,
        -2510.893798828125,
        695.8771362304688
      ],
      [
        -900.268310546875,
        -2502.2275390625,
        675.9594116210938
      ],
      [
        -904.4310913085938,
        -2500.01416015625,
        668.8807983398438
      ],
      [
        -900.268310546875,
        -2502.2275390625,
        675.9594116210938
      ],
      [
        -883.9695434570312,
        -2510.893798828125,
        695.8771362304688
      ],
      [
        -880.8256225585938,
        -2512.5654296875,
        696.2402954101562
      ],
      [
        -904.4310913085938,
        -2500.01416015625,
        668.8807983398438
      ],
      [
        -904.178466796875,
        -2500.1484375,
        667.9860229492188
      ],
      [
        -846.969482421875,
        -2530.56689453125,
        643.8728637695312
      ],
      [
        -885.7332153320312,
        -2509.9560546875,
        644.1735229492188
      ],
      [
        -885.7332153320312,
        -2509.9560546875,
        644.1735229492188
      ],
      [
        -896.2223510742188,
        -2504.37890625,
        643.792724609375
      ],
      [
        -896.2223510742188,
        -2504.37890625,
        643.792724609375
      ],
      [
        -896.3795776367188,
        -2504.29541015625,
        644.2561645507812
      ],
      [
        -879.661376953125,
        -2513.1845703125,
        696.3748168945312
      ],
      [
        -858.8065795898438,
        -2524.273193359375,
        695.8198852539062
      ],
      [
        -902.9319458007812,
        -2500.811279296875,
        663.5715942382812
      ],
      [
        -879.661376953125,
        -2513.1845703125,
        696.3748168945312
      ],
      [
        -902.9319458007812,
        -2500.811279296875,
        663.5715942382812
      ],
      [
        -918.32568359375,
        -2575.4931640625,
        717.738525390625
      ],
      [
        -941.46484375,
        -2571.4130859375,
        685.9884033203125
      ],
      [
        -915.2291870117188,
        -2576.0390625,
        725.8607788085938
      ],
      [
        -918.32568359375,
        -2575.4931640625,
        717.738525390625
      ],
      [
        -915.2291870117188,
        -2576.0390625,
        725.8607788085938
      ],
      [
        -912.107177734375,
        -2576.589599609375,
        726.2710571289062
      ],
      [
        -941.46484375,
        -2571.4130859375,
        685.9884033203125
      ],
      [
        -940.4493408203125,
        -2571.592041015625,
        684.4713134765625
      ],
      [
        -910.4232788085938,
        -2576.886474609375,
        726.4923095703125
      ],
      [
        -910.0775756835938,
        -2576.947509765625,
        726.5377197265625
      ],
      [
        -938.7444458007812,
        -2571.892578125,
        681.9244995117188
      ],
      [
        -888.8445434570312,
        -2580.69140625,
        726.1139526367188
      ],
      [
        -907.9686279296875,
        -2577.3193359375,
        726.8148803710938
      ],
      [
        -907.9686279296875,
        -2577.3193359375,
        726.8148803710938
      ],
      [
        -888.8445434570312,
        -2580.69140625,
        726.1139526367188
      ],
      [
        -886.7967529296875,
        -2581.052490234375,
        722.434814453125
      ],
      [
        -886.6625366210938,
        -2581.076171875,
        722.1937255859375
      ],
      [
        -870.6910400390625,
        -2583.89208984375,
        654.4735717773438
      ],
      [
        -916.9639282226562,
        -2575.733154296875,
        655.4043579101562
      ],
      [
        -929.5636596679688,
        -2573.511474609375,
        655.013916015625
      ],
      [
        -916.9639282226562,
        -2575.733154296875,
        655.4043579101562
      ],
      [
        -929.5636596679688,
        -2573.511474609375,
        655.013916015625
      ],
      [
        -929.7709350585938,
        -2573.474853515625,
        655.6619262695312
      ],
      [
        -860.8630981445312,
        -2585.62548828125,
        684.910888671875
      ],
      [
        -884.07763671875,
        -2581.53173828125,
        717.5496826171875
      ],
      [
        -884.07763671875,
        -2581.53173828125,
        717.5496826171875
      ],
      [
        -937.6468505859375,
        -2572.086181640625,
        680.2847900390625
      ],
      [
        -937.6468505859375,
        -2572.086181640625,
        680.2847900390625
      ],
      [
        -968.2777709960938,
        -2640.0,
        742.4426879882812
      ],
      [
        -983.5679931640625,
        -2640.0,
        708.0625
      ],
      [
        -983.5679931640625,
        -2640.0,
        708.0625
      ],
      [
        -985.4205932617188,
        -2640.0,
        705.8635864257812
      ],
      [
        -985.4205932617188,
        -2640.0,
        705.8635864257812
      ],
      [
        -940.1668701171875,
        -2580.30615234375,
        678.852294921875
      ],
      [
        -984.8797607421875,
        -2640.0,
        705.1128540039062
      ],
      [
        -940.1668701171875,
        -2580.30615234375,
        678.852294921875
      ],
      [
        -935.3463134765625,
        -2572.491943359375,
        673.092529296875
      ],
      [
        -957.8712158203125,
        -2640.0,
        666.6993408203125
      ],
      [
        -881.5084838867188,
        -2640.0,
        666.6993408203125
      ],
      [
        -878.090576171875,
        -2640.0,
        666.505859375
      ],
      [
        -881.5084838867188,
        -2640.0,
        666.6993408203125
      ],
      [
        -958.4671630859375,
        -2640.0,
        668.449462890625
      ],
      [
        -957.8712158203125,
        -2640.0,
        666.6993408203125
      ],
      [
        -958.4671630859375,
        -2640.0,
        668.449462890625
      ],
      [
        -882.9166870117188,
        -2640.0,
        742.6649169921875
      ],
      [
        -864.775634765625,
        -2640.0,
        708.57958984375
      ],
      [
        -862.9345092773438,
        -2640.0,
        705.8839111328125
      ],
      [
        -864.775634765625,
        -2640.0,
        708.57958984375
      ],
      [
        -882.9166870117188,
        -2640.0,
        742.6649169921875
      ],
      [
        -895.7581787109375,
        -2640.0,
        767.9290771484375
      ],
      [
        -895.7581787109375,
        -2640.0,
        767.9290771484375
      ],
      [
        -897.95458984375,
        -2640.0,
        770.9197387695312
      ],
      [
        -898.71923828125,
        -2640.0,
        771.9608154296875
      ],
      [
        -952.3094482421875,
        -2640.0,
        771.9608154296875
      ],
      [
        -968.2777709960938,
        -2640.0,
        742.4426879882812
      ],
      [
        -955.9262084960938,
        -2640.0,
        767.9290771484375
      ],
      [
        -952.3094482421875,
        -2640.0,
        771.9608154296875
      ],
      [
        -955.9262084960938,
        -2640.0,
        767.9290771484375
      ],
      [
        -898.71923828125,
        -2640.0,
        771.9608154296875
      ],
      [
        -977.0639038085938,
        -2859.5,
        761.111083984375
      ],
      [
        -959.8472290039062,
        -2859.5,
        761.111083984375
      ],
      [
        -903.5572509765625,
        -2859.5,
        761.111083984375
      ],
      [
        -878.493408203125,
        -2859.5,
        761.111083984375
      ],
      [
        -959.8472290039062,
        -2859.5,
        761.111083984375
      ],
      [
        -941.3390502929688,
        -2859.5,
        761.111083984375
      ],
      [
        -903.5572509765625,
        -2859.5,
        761.111083984375
      ],
      [
        -941.3390502929688,
        -2859.5,
        761.111083984375
      ],
      [
        -877.9636840820312,
        -2920.0,
        788.0
      ],
      [
        -966.0363159179688,
        -2920.0,
        788.0
      ],
      [
        -906.0615234375,
        -2930.0,
        790.5328369140625
      ],
      [
        -933.5289916992188,
        -2930.0,
        790.5328369140625
      ],
      [
        -940.072265625,
        -2930.0,
        790.5327758789062
      ],
      [
        -939.038330078125,
        -2930.0,
        790.4069213867188
      ],
      [
        -933.5289916992188,
        -2930.0,
        790.5328369140625
      ],
      [
        -903.927734375,
        -2930.0,
        790.5327758789062
      ],
      [
        -939.038330078125,
        -2930.0,
        790.4069213867188
      ],
      [
        -939.1234741210938,
        -2930.0,
        790.5327758789062
      ],
      [
        -941.6363525390625,
        -2930.0,
        792.4444580078125
      ],
      [
        -902.3636474609375,
        -2930.0,
        792.4444580078125
      ],
      [
        -940.416259765625,
        -2930.0,
        792.4444580078125
      ],
      [
        -906.0615234375,
        -2930.0,
        790.5328369140625
      ],
      [
        -904.2719116210938,
        -2930.0,
        792.4444580078125
      ],
      [
        -932.0,
        -2859.5,
        821.4066162109375
      ],
      [
        -932.0,
        -2859.5,
        817.4066162109375
      ],
      [
        -871.1350708007812,
        -2920.0,
        801.7215576171875
      ],
      [
        -887.615478515625,
        -2920.0,
        825.2523803710938
      ],
      [
        -902.0224609375,
        -2920.0,
        845.8228759765625
      ],
      [
        -887.615478515625,
        -2920.0,
        825.2523803710938
      ],
      [
        -914.6135864257812,
        -2920.0,
        863.8005981445312
      ],
      [
        -902.0224609375,
        -2920.0,
        845.8228759765625
      ],
      [
        -869.7720336914062,
        -2859.5,
        790.45849609375
      ],
      [
        -871.22314453125,
        -2859.5,
        792.14794921875
      ],
      [
        -869.7720336914062,
        -2859.5,
        790.45849609375
      ],
      [
        -869.8526611328125,
        -2859.5,
        790.1911010742188
      ],
      [
        -890.6571655273438,
        -2930.0,
        792.7325439453125
      ],
      [
        -883.2512817382812,
        -2930.0,
        818.8846435546875
      ],
      [
        -886.1357421875,
        -2920.0,
        800.3511962890625
      ],
      [
        -889.6334228515625,
        -2920.0,
        788.0
      ],
      [
        -881.5404052734375,
        -2920.0,
        816.5783081054688
      ],
      [
        -886.1357421875,
        -2920.0,
        800.3511962890625
      ],
      [
        -871.61669921875,
        -2859.5,
        784.3419189453125
      ],
      [
        -890.6571655273438,
        -2930.0,
        792.7325439453125
      ],
      [
        -891.4382934570312,
        -2930.0,
        792.7470703125
      ],
      [
        -883.2512817382812,
        -2930.0,
        818.8846435546875
      ],
      [
        -883.5030517578125,
        -2930.0,
        820.7681884765625
      ],
      [
        -877.9344482421875,
        -2859.5,
        763.3938598632812
      ],
      [
        -877.9344482421875,
        -2859.5,
        763.3938598632812
      ],
      [
        -878.493408203125,
        -2859.5,
        761.111083984375
      ],
      [
        -889.681884765625,
        -2920.0,
        788.0
      ],
      [
        -888.96728515625,
        -2920.0,
        790.3522338867188
      ],
      [
        -908.3773803710938,
        -2930.0,
        845.7208251953125
      ],
      [
        -886.190185546875,
        -2930.0,
        823.2562255859375
      ],
      [
        -883.9012451171875,
        -2920.0,
        819.9491577148438
      ],
      [
        -888.56396484375,
        -2920.0,
        824.670166015625
      ],
      [
        -904.548583984375,
        -2920.0,
        840.8545532226562
      ],
      [
        -888.56396484375,
        -2920.0,
        824.670166015625
      ],
      [
        -927.2113037109375,
        -2920.0,
        863.8005981445312
      ],
      [
        -904.548583984375,
        -2920.0,
        840.8545532226562
      ],
      [
        -883.5282592773438,
        -2930.0,
        820.9566040039062
      ],
      [
        -886.190185546875,
        -2930.0,
        823.2562255859375
      ],
      [
        -883.5282592773438,
        -2930.0,
        820.9566040039062
      ],
      [
        -908.3773803710938,
        -2930.0,
        845.7208251953125
      ],
      [
        -908.921142578125,
        -2930.0,
        845.7208251953125
      ],
      [
        -932.0,
        -2863.125,
        833.59375
      ],
      [
        -932.0,
        -2925.0,
        844.0625
      ],
      [
        -914.0,
        -2859.5,
        832.9804077148438
      ],
      [
        -914.0,
        -2916.164306640625,
        842.5675659179688
      ],
      [
        -914.0,
        -2920.0,
        843.216552734375
      ],
      [
        -914.0,
        -2916.164306640625,
        842.5675659179688
      ],
      [
        -932.0,
        -2920.0,
        863.8005981445312
      ],
      [
        -932.0,
        -2920.0,
        843.216552734375
      ],
      [
        -914.0,
        -2920.0,
        843.2164916992188
      ],
      [
        -914.0,
        -2920.0,
        850.4241333007812
      ],
      [
        -914.0,
        -2925.0,
        844.0625
      ],
      [
        -932.0,
        -2925.0,
        844.0625
      ],
      [
        -932.0,
        -2930.0,
        845.7208251953125
      ],
      [
        -914.0,
        -2930.0,
        845.7208251953125
      ],
      [
        -906.88134765625,
        -2920.0,
        843.2164916992188
      ],
      [
        -932.0,
        -2859.5,
        817.4066162109375
      ],
      [
        -914.0,
        -2859.5,
        817.4066162109375
      ],
      [
        -914.0,
        -2859.5,
        817.4066162109375
      ],
      [
        -914.0,
        -2859.5,
        821.4066162109375
      ],
      [
        -932.0,
        -2863.125,
        833.59375
      ],
      [
        -914.0,
        -2863.125,
        833.59375
      ],
      [
        -914.0,
        -2859.5,
        832.5732421875
      ],
      [
        -932.0,
        -2859.5,
        832.5732421875
      ],
      [
        -932.0,
        -2920.0,
        840.0
      ],
      [
        -914.0,
        -2920.0,
        840.0
      ],
      [
        -914.0,
        -2920.0,
        843.2164916992188
      ],
      [
        -899.6533813476562,
        -2859.5,
        832.5732421875
      ],
      [
        -889.454833984375,
        -2863.125,
        818.7603149414062
      ],
      [
        -889.0310668945312,
        -2859.5,
        817.4066162109375
      ],
      [
        -906.3441162109375,
        -2859.5,
        832.5732421875
      ],
      [
        -906.3441162109375,
        -2859.5,
        832.5732421875
      ],
      [
        -899.6533813476562,
        -2859.5,
        832.5732421875
      ],
      [
        -904.9830932617188,
        -2920.0,
        840.0
      ],
      [
        -903.70458984375,
        -2920.0,
        840.0
      ],
      [
        -904.9830932617188,
        -2920.0,
        840.0
      ],
      [
        -871.8587036132812,
        -2859.5,
        792.8878784179688
      ],
      [
        -871.8587036132812,
        -2859.5,
        792.8878784179688
      ],
      [
        -932.0,
        -2930.0,
        838.0
      ],
      [
        -932.0,
        -2920.0,
        838.0
      ],
      [
        -901.729248046875,
        -2920.0,
        838.0
      ],
      [
        -932.0,
        -2920.0,
        838.0
      ],
      [
        -884.0911865234375,
        -2920.0,
        807.571044921875
      ],
      [
        -894.0,
        -2923.890625,
        789.7291870117188
      ],
      [
        -894.0,
        -2930.0,
        792.794677734375
      ],
      [
        -901.9560546875,
        -2930.0,
        792.9425659179688
      ],
      [
        -903.77392578125,
        -2930.0,
        792.9763793945312
      ],
      [
        -903.77392578125,
        -2930.0,
        792.9763793945312
      ],
      [
        -972.8826293945312,
        -2920.0,
        805.2472534179688
      ],
      [
        -957.2628784179688,
        -2920.0,
        825.7915649414062
      ],
      [
        -957.2628784179688,
        -2920.0,
        825.7915649414062
      ],
      [
        -941.999755859375,
        -2920.0,
        845.86669921875
      ],
      [
        -941.999755859375,
        -2920.0,
        845.86669921875
      ],
      [
        -932.0,
        -2920.0,
        859.0191040039062
      ],
      [
        -962.0082397460938,
        -2930.0,
        820.943359375
      ],
      [
        -956.3948974609375,
        -2930.0,
        826.6268920898438
      ],
      [
        -962.0082397460938,
        -2930.0,
        820.943359375
      ],
      [
        -962.000732421875,
        -2930.0,
        819.2536010742188
      ],
      [
        -985.7762451171875,
        -2859.5,
        790.45849609375
      ],
      [
        -985.7095336914062,
        -2859.5,
        790.23095703125
      ],
      [
        -985.7762451171875,
        -2859.5,
        790.45849609375
      ],
      [
        -984.927490234375,
        -2859.5,
        791.2595825195312
      ],
      [
        -954.5962524414062,
        -2930.0,
        792.7979125976562
      ],
      [
        -961.9993286132812,
        -2930.0,
        818.93994140625
      ],
      [
        -956.1746826171875,
        -2920.0,
        788.0
      ],
      [
        -959.533203125,
        -2920.0,
        799.8598022460938
      ],
      [
        -959.533203125,
        -2920.0,
        799.8598022460938
      ],
      [
        -964.2676391601562,
        -2920.0,
        816.578369140625
      ],
      [
        -983.5852661132812,
        -2859.5,
        782.986328125
      ],
      [
        -952.7792358398438,
        -2930.0,
        792.8374633789062
      ],
      [
        -954.5962524414062,
        -2930.0,
        792.7979125976562
      ],
      [
        -961.9993286132812,
        -2930.0,
        818.93994140625
      ],
      [
        -977.84033203125,
        -2859.5,
        763.3938598632812
      ],
      [
        -956.1475219726562,
        -2920.0,
        788.0
      ],
      [
        -956.8463745117188,
        -2920.0,
        790.3719482421875
      ],
      [
        -977.0639038085938,
        -2859.5,
        761.111083984375
      ],
      [
        -977.84033203125,
        -2859.5,
        763.3938598632812
      ],
      [
        -939.4589233398438,
        -2930.0,
        843.7745361328125
      ],
      [
        -956.4358520507812,
        -2920.0,
        825.2838745117188
      ],
      [
        -961.7053833007812,
        -2920.0,
        819.948486328125
      ],
      [
        -956.4358520507812,
        -2920.0,
        825.2838745117188
      ],
      [
        -939.9971923828125,
        -2920.0,
        841.927978515625
      ],
      [
        -939.9971923828125,
        -2920.0,
        841.927978515625
      ],
      [
        -932.0,
        -2920.0,
        850.0250854492188
      ],
      [
        -937.571044921875,
        -2930.0,
        845.6749267578125
      ],
      [
        -935.4811401367188,
        -2930.0,
        845.7122802734375
      ],
      [
        -937.571044921875,
        -2930.0,
        845.6749267578125
      ],
      [
        -939.4589233398438,
        -2930.0,
        843.7745361328125
      ],
      [
        -932.0,
        -2920.0,
        843.216552734375
      ],
      [
        -938.7245483398438,
        -2920.0,
        843.216552734375
      ],
      [
        -935.0020141601562,
        -2930.0,
        845.7208251953125
      ],
      [
        -935.0020141601562,
        -2930.0,
        845.7208251953125
      ],
      [
        -953.0294189453125,
        -2859.5,
        832.5732421875
      ],
      [
        -983.2022094726562,
        -2859.5,
        792.8878784179688
      ],
      [
        -983.2022094726562,
        -2859.5,
        792.8878784179688
      ],
      [
        -950.0,
        -2930.0,
        792.89794921875
      ],
      [
        -950.0,
        -2923.65380859375,
        789.6239013671875
      ],
      [
        -942.1470947265625,
        -2930.0,
        793.0687255859375
      ],
      [
        -940.857421875,
        -2930.0,
        793.0968017578125
      ],
      [
        -940.857421875,
        -2930.0,
        793.0968017578125
      ],
      [
        -943.8286743164062,
        -2859.5,
        832.5732421875
      ],
      [
        -953.0294189453125,
        -2859.5,
        832.5732421875
      ],
      [
        -943.8286743164062,
        -2859.5,
        832.5732421875
      ],
      [
        -970.0,
        -2712.0,
        720.0
      ],
      [
        -970.0,
        -2712.0,
        670.0
      ],
      [
        -980.0,
        -2712.0,
        720.0
      ],
      [
        -970.0,
        -2712.0,
        720.0
      ],
      [
        -981.5535278320312,
        -2674.543212890625,
        678.9081420898438
      ],
      [
        -970.0,
        -2674.54345703125,
        678.9081420898438
      ],
      [
        -970.0,
        -2677.65380859375,
        680.2904663085938
      ],
      [
        -990.0,
        -2712.0,
        695.5555419921875
      ],
      [
        -970.0,
        -2677.65380859375,
        680.2904663085938
      ],
      [
        -970.0,
        -2712.0,
        695.5555419921875
      ],
      [
        -994.123291015625,
        -2682.291259765625,
        694.1002197265625
      ],
      [
        -1007.907958984375,
        -2697.0,
        720.0
      ],
      [
        -1007.4884643554688,
        -2695.500244140625,
        720.0
      ],
      [
        -981.5535278320312,
        -2674.543212890625,
        678.9081420898438
      ],
      [
        -994.123291015625,
        -2682.291259765625,
        694.1002197265625
      ],
      [
        -972.8922729492188,
        -2710.0,
        748.4310302734375
      ],
      [
        -980.0,
        -2712.0,
        720.0
      ],
      [
        -971.9118041992188,
        -2712.0,
        752.3527221679688
      ],
      [
        -1011.9400024414062,
        -2701.77294921875,
        732.2994384765625
      ],
      [
        -1000.169921875,
        -2710.0,
        748.4310913085938
      ],
      [
        -1009.0059204101562,
        -2697.0,
        722.940673828125
      ],
      [
        -968.076904296875,
        -2674.54345703125,
        678.9081420898438
      ],
      [
        -897.6017456054688,
        -2712.0,
        695.5555419921875
      ],
      [
        -896.08935546875,
        -2674.543212890625,
        678.9081420898438
      ],
      [
        -870.4964599609375,
        -2674.543212890625,
        678.9081420898438
      ],
      [
        -865.0618896484375,
        -2712.0,
        695.5555419921875
      ],
      [
        -968.076904296875,
        -2674.54345703125,
        678.9081420898438
      ],
      [
        -951.5470581054688,
        -2674.543212890625,
        678.9081420898438
      ],
      [
        -949.479736328125,
        -2712.0,
        695.5555419921875
      ],
      [
        -896.08935546875,
        -2674.543212890625,
        678.9081420898438
      ],
      [
        -897.6017456054688,
        -2712.0,
        695.5555419921875
      ],
      [
        -949.479736328125,
        -2712.0,
        695.5555419921875
      ],
      [
        -951.5470581054688,
        -2674.543212890625,
        678.9081420898438
      ],
      [
        -894.0,
        -2712.0,
        670.0
      ],
      [
        -894.0,
        -2674.543212890625,
        678.9081420898438
      ],
      [
        -894.0,
        -2712.0,
        695.5555419921875
      ],
      [
        -894.0,
        -2712.0,
        720.0
      ],
      [
        -877.0875244140625,
        -2712.0,
        720.0
      ],
      [
        -885.9562377929688,
        -2712.0,
        720.0
      ],
      [
        -870.0,
        -2712.0,
        720.0
      ],
      [
        -877.0875244140625,
        -2712.0,
        720.0
      ],
      [
        -894.0,
        -2712.0,
        720.0
      ],
      [
        -885.9562377929688,
        -2712.0,
        720.0
      ],
      [
        -865.2177734375,
        -2712.0,
        752.3527221679688
      ],
      [
        -853.125,
        -2712.0,
        735.8872680664062
      ],
      [
        -853.125,
        -2701.77294921875,
        732.2994384765625
      ],
      [
        -858.5,
        -2650.0,
        668.0
      ],
      [
        -991.0,
        -2650.0,
        668.0
      ],
      [
        -932.0,
        -2712.0,
        766.3236694335938
      ],
      [
        -932.0,
        -2712.0,
        762.3236694335938
      ],
      [
        -932.0,
        -2640.0,
        757.0
      ],
      [
        -932.0,
        -2650.0,
        757.0
      ],
      [
        -932.0,
        -2650.0,
        757.0
      ],
      [
        -932.0,
        -2650.0,
        748.0
      ],
      [
        -932.0,
        -2645.0,
        667.578125
      ],
      [
        -932.0,
        -2640.0,
        666.6993408203125
      ],
      [
        -895.098388671875,
        -2647.400634765625,
        668.0
      ],
      [
        -932.0,
        -2650.0,
        668.0
      ],
      [
        -932.0,
        -2647.400634765625,
        668.0
      ],
      [
        -895.098388671875,
        -2647.400634765625,
        668.0
      ],
      [
        -894.743408203125,
        -2650.0,
        668.4568481445312
      ],
      [
        -862.1634521484375,
        -2650.0,
        710.0059814453125
      ],
      [
        -890.2030639648438,
        -2640.0,
        757.0
      ],
      [
        -886.0501098632812,
        -2650.0,
        757.0
      ],
      [
        -932.0,
        -2640.0,
        668.0
      ],
      [
        -860.2403564453125,
        -2660.0,
        714.3930053710938
      ],
      [
        -883.2678833007812,
        -2656.699462890625,
        757.0
      ],
      [
        -880.7991943359375,
        -2660.0,
        754.8399047851562
      ],
      [
        -914.0,
        -2660.0,
        754.0
      ],
      [
        -932.0,
        -2660.0,
        754.0
      ],
      [
        -914.0,
        -2660.0,
        750.0
      ],
      [
        -914.0,
        -2660.0,
        754.0
      ],
      [
        -880.7991943359375,
        -2660.0,
        754.8399047851562
      ],
      [
        -883.2678833007812,
        -2656.699462890625,
        757.0
      ],
      [
        -882.3856201171875,
        -2660.0,
        757.0
      ],
      [
        -898.5655517578125,
        -2660.0,
        779.0304565429688
      ],
      [
        -932.0,
        -2640.0,
        771.9608154296875
      ],
      [
        -932.0,
        -2660.0,
        779.0304565429688
      ],
      [
        -909.0,
        -2648.0,
        774.7887573242188
      ],
      [
        -909.0,
        -2642.0,
        772.6678466796875
      ],
      [
        -927.0,
        -2642.0,
        772.6678466796875
      ],
      [
        -927.0,
        -2648.0,
        774.7887573242188
      ],
      [
        -915.0,
        -2648.0,
        774.7887573242188
      ],
      [
        -909.0,
        -2648.0,
        774.7887573242188
      ],
      [
        -927.0,
        -2648.0,
        774.7887573242188
      ],
      [
        -921.0,
        -2648.0,
        774.7887573242188
      ],
      [
        -898.5655517578125,
        -2660.0,
        779.0304565429688
      ],
      [
        -890.8987426757812,
        -2712.0,
        787.3197021484375
      ],
      [
        -932.0,
        -2697.0,
        792.109375
      ],
      [
        -932.0,
        -2712.0,
        762.3236694335938
      ],
      [
        -914.0,
        -2712.0,
        762.3236694335938
      ],
      [
        -897.8980712890625,
        -2712.0,
        795.4685668945312
      ],
      [
        -932.0,
        -2697.0,
        792.109375
      ],
      [
        -932.0,
        -2712.0,
        795.468505859375
      ],
      [
        -914.0,
        -2712.0,
        762.3236694335938
      ],
      [
        -914.0,
        -2712.0,
        766.3236694335938
      ],
      [
        -897.8980712890625,
        -2712.0,
        795.468505859375
      ],
      [
        -890.8987426757812,
        -2712.0,
        787.3197021484375
      ],
      [
        -990.860595703125,
        -2650.0,
        709.5540771484375
      ],
      [
        -967.8666381835938,
        -2650.0,
        757.0
      ],
      [
        -961.2227783203125,
        -2640.0,
        757.0
      ],
      [
        -965.4456787109375,
        -2650.0,
        668.0
      ],
      [
        -989.3621826171875,
        -2650.0,
        705.541015625
      ],
      [
        -957.2064208984375,
        -2640.0,
        666.6993408203125
      ],
      [
        -989.3621826171875,
        -2650.0,
        705.541015625
      ],
      [
        -990.860595703125,
        -2650.0,
        709.5540771484375
      ],
      [
        -952.5738525390625,
        -2645.0,
        667.578125
      ],
      [
        -951.8910522460938,
        -2640.0,
        666.6993408203125
      ],
      [
        -995.3317260742188,
        -2660.0,
        714.0372314453125
      ],
      [
        -975.557373046875,
        -2660.0,
        754.8399047851562
      ],
      [
        -972.317626953125,
        -2656.699462890625,
        757.0
      ],
      [
        -972.0087280273438,
        -2660.0,
        672.4444580078125
      ],
      [
        -990.8366088867188,
        -2660.0,
        701.9979858398438
      ],
      [
        -990.8366088867188,
        -2660.0,
        701.9979858398438
      ],
      [
        -995.3317260742188,
        -2660.0,
        714.0372314453125
      ],
      [
        -972.3176879882812,
        -2656.699462890625,
        757.0
      ],
      [
        -975.557373046875,
        -2660.0,
        754.8399047851562
      ],
      [
        -973.61962890625,
        -2660.0,
        757.0
      ],
      [
        -953.8565673828125,
        -2660.0,
        779.0304565429688
      ],
      [
        -953.8565673828125,
        -2660.0,
        779.0304565429688
      ],
      [
        -932.0,
        -2660.0,
        779.0304565429688
      ],
      [
        -940.0,
        -2642.0,
        772.6678466796875
      ],
      [
        -940.0,
        -2648.0,
        774.7887573242188
      ],
      [
        -940.0,
        -2648.0,
        774.7887573242188
      ],
      [
        -934.0,
        -2648.0,
        774.7887573242188
      ],
      [
        -990.4483642578125,
        -2712.0,
        760.0
      ],
      [
        -965.9404907226562,
        -2712.0,
        787.3197021484375
      ],
      [
        -957.3062744140625,
        -2712.0,
        795.468505859375
      ],
      [
        -970.0,
        -2712.0,
        782.79443359375
      ],
      [
        -970.0,
        -2712.0,
        760.0
      ],
      [
        -970.0,
        -2712.0,
        760.0
      ],
      [
        -957.3062744140625,
        -2712.0,
        795.4685668945312
      ],
      [
        -965.9404907226562,
        -2712.0,
        787.3197021484375
      ],
      [
        -873.5,
        -2712.0,
        695.5555419921875
      ],
      [
        -873.5,
        -2839.021728515625,
        752.0096435546875
      ],
      [
        -868.5,
        -2790.5,
        730.4443359375
      ],
      [
        -853.5,
        -2795.0,
        732.4443359375
      ],
      [
        -868.5,
        -2790.5,
        730.4443359375
      ],
      [
        -873.5,
        -2775.0,
        723.555419921875
      ],
      [
        -873.5,
        -2747.351318359375,
        776.0315551757812
      ],
      [
        -873.5,
        -2712.0,
        763.6296997070312
      ],
      [
        -868.5,
        -2790.5,
        784.36083984375
      ],
      [
        -853.5,
        -2795.0,
        765.5157470703125
      ],
      [
        -868.5,
        -2790.5,
        784.36083984375
      ],
      [
        -873.5,
        -2775.0,
        785.7310791015625
      ],
      [
        -873.5,
        -2854.677490234375,
        794.2353515625
      ],
      [
        -873.5,
        -2788.75,
        786.5337524414062
      ],
      [
        -868.5,
        -2790.5,
        780.9170532226562
      ],
      [
        -853.5,
        -2795.0,
        763.9791870117188
      ],
      [
        -868.5,
        -2790.5,
        780.9170532226562
      ],
      [
        -873.5,
        -2775.0,
        784.9275512695312
      ],
      [
        -873.5,
        -2859.5,
        795.2313232421875
      ],
      [
        -873.5,
        -2854.677490234375,
        794.2353515625
      ],
      [
        -873.5,
        -2859.5,
        778.097412109375
      ],
      [
        -873.5,
        -2846.85400390625,
        763.2899169921875
      ],
      [
        -873.5,
        -2846.85400390625,
        763.2899169921875
      ],
      [
        -873.5,
        -2839.021728515625,
        752.0096435546875
      ],
      [
        -854.5233764648438,
        -2794.69287109375,
        765.134765625
      ],
      [
        -862.13427734375,
        -2792.409912109375,
        731.2930908203125
      ],
      [
        -855.143798828125,
        -2794.5068359375,
        762.8594970703125
      ],
      [
        -863.8128662109375,
        -2791.90625,
        731.0692749023438
      ],
      [
        -869.0645751953125,
        -2788.75,
        781.3699340820312
      ],
      [
        -873.5,
        -2747.351318359375,
        776.0315551757812
      ],
      [
        -873.5,
        -2775.000244140625,
        783.045654296875
      ],
      [
        -873.5,
        -2735.5,
        735.0
      ],
      [
        -873.5,
        -2735.5,
        721.0
      ],
      [
        -873.5,
        -2712.0,
        720.0
      ],
      [
        -873.5,
        -2788.75,
        786.5337524414062
      ],
      [
        -970.0,
        -2788.75,
        803.5133056640625
      ],
      [
        -970.0,
        -2718.603271484375,
        785.2112426757812
      ],
      [
        -1012.8992919921875,
        -2776.0673828125,
        759.7164306640625
      ],
      [
        -1012.9002685546875,
        -2776.0,
        759.6979370117188
      ],
      [
        -1012.8992919921875,
        -2776.0673828125,
        759.7164306640625
      ],
      [
        -1020.0,
        -2776.0,
        752.997314453125
      ],
      [
        -1013.0123901367188,
        -2776.0,
        760.0
      ],
      [
        -1012.8981323242188,
        -2776.0,
        759.7000122070312
      ],
      [
        -1012.5802612304688,
        -2776.0,
        760.0
      ],
      [
        -1006.9607543945312,
        -2776.0,
        720.0
      ],
      [
        -1017.3652954101562,
        -2776.0,
        755.4839477539062
      ],
      [
        -1004.9563598632812,
        -2776.0,
        720.0
      ],
      [
        -1017.1087646484375,
        -2776.0,
        755.7260131835938
      ],
      [
        -970.0,
        -2718.603271484375,
        785.2112426757812
      ],
      [
        -970.0,
        -2712.0,
        782.79443359375
      ],
      [
        -1012.5723876953125,
        -2776.49169921875,
        758.9419555664062
      ],
      [
        -1016.6103515625,
        -2776.0,
        754.2606811523438
      ],
      [
        -1012.8981323242188,
        -2776.0,
        759.7000122070312
      ],
      [
        -1012.5502319335938,
        -2776.0,
        758.7865600585938
      ],
      [
        -1012.565673828125,
        -2776.0,
        758.7694091796875
      ],
      [
        -1012.5723876953125,
        -2776.49169921875,
        758.9419555664062
      ],
      [
        -1011.461669921875,
        -2776.0,
        760.0
      ],
      [
        -970.0,
        -2788.75,
        803.5133056640625
      ],
      [
        -970.0,
        -2818.693115234375,
        804.289794921875
      ],
      [
        -970.0,
        -2818.693115234375,
        804.289794921875
      ],
      [
        -970.0,
        -2859.5,
        810.2523193359375
      ],
      [
        -970.0,
        -2831.384521484375,
        748.6153564453125
      ],
      [
        -970.0,
        -2859.5,
        761.111083984375
      ],
      [
        -970.0,
        -2831.384521484375,
        748.6153564453125
      ],
      [
        -990.0,
        -2767.0,
        720.0
      ],
      [
        -970.0,
        -2767.0,
        720.0
      ],
      [
        -990.0,
        -2776.0,
        724.0001831054688
      ],
      [
        -978.9999389648438,
        -2776.0,
        724.000244140625
      ],
      [
        -1006.3170166015625,
        -2776.0,
        724.0001220703125
      ],
      [
        -990.0,
        -2776.0,
        724.0001831054688
      ],
      [
        -978.9999389648438,
        -2776.0,
        724.000244140625
      ],
      [
        -980.0,
        -2766.99951171875,
        720.0
      ],
      [
        -1011.430908203125,
        -2790.0,
        760.0
      ],
      [
        -1012.6257934570312,
        -2790.0,
        763.3161010742188
      ],
      [
        -970.0,
        -2712.0,
        695.5555419921875
      ],
      [
        -894.0,
        -2712.0,
        695.5555419921875
      ],
      [
        -894.0,
        -2767.0,
        720.0
      ],
      [
        -894.0,
        -2767.0,
        720.0
      ],
      [
        -880.5184326171875,
        -2766.999755859375,
        720.0
      ],
      [
        -874.5,
        -2775.0,
        723.5556030273438
      ],
      [
        -873.5,
        -2775.0,
        723.5556030273438
      ],
      [
        -885.3666381835938,
        -2775.0,
        723.5556030273438
      ],
      [
        -874.5,
        -2775.0,
        723.5556030273438
      ],
      [
        -887.5,
        -2766.999755859375,
        720.0
      ],
      [
        -885.3666381835938,
        -2775.0,
        723.5556030273438
      ],
      [
        -894.0,
        -2788.75,
        810.4005737304688
      ],
      [
        -894.0,
        -2712.0,
        790.9302978515625
      ],
      [
        -894.0,
        -2859.5,
        824.5013427734375
      ],
      [
        -894.0,
        -2794.44287109375,
        811.0656127929688
      ],
      [
        -894.0,
        -2794.44287109375,
        811.0656127929688
      ],
      [
        -894.0,
        -2788.75,
        810.4005737304688
      ],
      [
        -884.5225219726562,
        -2724.955322265625,
        783.182861328125
      ],
      [
        -873.5,
        -2719.897216796875,
        766.4002075195312
      ],
      [
        -878.5,
        -2727.294921875,
        720.0
      ],
      [
        -878.5,
        -2712.0,
        720.0
      ],
      [
        -878.5,
        -2727.294921875,
        720.0
      ],
      [
        -878.5,
        -2762.8076171875,
        720.0
      ],
      [
        -878.5,
        -2735.5,
        720.0
      ],
      [
        -878.5,
        -2775.0,
        723.5556030273438
      ],
      [
        -932.0,
        -2788.75,
        794.9854736328125
      ],
      [
        -932.0,
        -2788.75,
        790.9854736328125
      ],
      [
        -932.0,
        -2788.75,
        812.65625
      ],
      [
        -932.0,
        -2712.0,
        795.468505859375
      ],
      [
        -932.0,
        -2788.75,
        790.9854736328125
      ],
      [
        -914.0,
        -2788.75,
        790.9854736328125
      ],
      [
        -914.0,
        -2788.75,
        790.9854736328125
      ],
      [
        -914.0,
        -2788.75,
        794.9854736328125
      ],
      [
        -914.0,
        -2855.230712890625,
        831.371337890625
      ],
      [
        -932.0,
        -2854.642578125,
        831.205810546875
      ],
      [
        -932.0,
        -2859.5,
        832.5732421875
      ],
      [
        -914.0,
        -2859.5,
        832.5732421875
      ],
      [
        -914.0,
        -2855.230712890625,
        831.371337890625
      ],
      [
        -914.0,
        -2833.164306640625,
        825.159423828125
      ],
      [
        -932.0,
        -2854.642578125,
        831.205810546875
      ],
      [
        -932.0,
        -2836.284423828125,
        826.0377197265625
      ],
      [
        -932.0,
        -2836.284423828125,
        826.0377197265625
      ],
      [
        -914.0,
        -2833.164306640625,
        825.159423828125
      ],
      [
        -914.0,
        -2788.75,
        812.65625
      ],
      [
        -932.0,
        -2788.75,
        812.65625
      ],
      [
        -1372.200439453125,
        -3108.999267578125,
        780.0
      ],
      [
        -1332.0350341796875,
        -3091.116455078125,
        780.0
      ],
      [
        -1344.8778076171875,
        -3096.834228515625,
        577.0269775390625
      ],
      [
        -1334.0955810546875,
        -3092.033935546875,
        711.556884765625
      ],
      [
        -1333.9539794921875,
        -3091.970703125,
        712.7704467773438
      ],
      [
        -1333.54833984375,
        -3091.7900390625,
        718.38525390625
      ],
      [
        -1334.0955810546875,
        -3092.033935546875,
        711.556884765625
      ],
      [
        -1333.9539794921875,
        -3091.970703125,
        712.7704467773438
      ],
      [
        -1352.1126708984375,
        -3100.0556640625,
        613.0665893554688
      ],
      [
        -1344.8778076171875,
        -3096.834228515625,
        577.0269165039062
      ],
      [
        -1365.9962158203125,
        -3106.23681640625,
        638.2857666015625
      ],
      [
        -1352.1126708984375,
        -3100.0556640625,
        613.0665893554688
      ],
      [
        -1367.46875,
        -3106.892333984375,
        662.6285400390625
      ],
      [
        -1365.9962158203125,
        -3106.23681640625,
        638.2857666015625
      ],
      [
        -1367.46875,
        -3106.892333984375,
        662.6285400390625
      ],
      [
        -1367.668701171875,
        -3106.9814453125,
        690.6090087890625
      ],
      [
        -1350.734130859375,
        -3098.3779296875,
        724.0
      ],
      [
        -1367.9073486328125,
        -3107.087646484375,
        724.0
      ],
      [
        -1350.734130859375,
        -3098.3779296875,
        724.0
      ],
      [
        -1334.3448486328125,
        -3089.99560546875,
        724.0
      ],
      [
        -1334.3448486328125,
        -3089.99560546875,
        724.0
      ],
      [
        -1334.3070068359375,
        -3090.04638671875,
        724.0
      ],
      [
        -1333.1427001953125,
        -3091.609375,
        724.0
      ],
      [
        -1367.9959716796875,
        -3107.127197265625,
        736.406982421875
      ],
      [
        -1372.2021484375,
        -3109.0,
        780.0
      ],
      [
        -1367.9959716796875,
        -3107.127197265625,
        736.406982421875
      ],
      [
        -1348.809814453125,
        -3059.905029296875,
        780.0
      ],
      [
        -1347.9261474609375,
        -3061.589599609375,
        779.9943237304688
      ],
      [
        -1348.7978515625,
        -3059.904052734375,
        780.0
      ],
      [
        -1348.800048828125,
        -3059.89990234375,
        780.0
      ],
      [
        -1348.7978515625,
        -3059.904052734375,
        780.0
      ],
      [
        -1348.8089599609375,
        -3059.90673828125,
        780.0
      ],
      [
        -1348.809814453125,
        -3059.905029296875,
        780.0
      ],
      [
        -1348.800048828125,
        -3059.89990234375,
        780.0
      ],
      [
        -1348.8089599609375,
        -3059.90673828125,
        780.0
      ],
      [
        -1330.6363525390625,
        -3087.7412109375,
        780.0
      ],
      [
        -1329.0966796875,
        -3089.80810546875,
        780.0
      ],
      [
        -1332.0350341796875,
        -3091.116455078125,
        770.0
      ],
      [
        -1371.2357177734375,
        -3108.569580078125,
        770.0
      ],
      [
        -1332.0350341796875,
        -3091.116455078125,
        770.0
      ],
      [
        -1332.0350341796875,
        -3091.116455078125,
        780.0
      ],
      [
        -1215.00341796875,
        -3039.0107421875,
        1295.0087890625
      ],
      [
        -1325.112548828125,
        -3088.034423828125,
        833.904541015625
      ],
      [
        -1206.3187255859375,
        -3035.14404296875,
        1278.9141845703125
      ],
      [
        -1197.2042236328125,
        -3031.0859375,
        1302.5999755859375
      ],
      [
        -1206.3187255859375,
        -3035.14404296875,
        1278.9141845703125
      ],
      [
        -1212.1756591796875,
        -3037.751708984375,
        1292.5638427734375
      ],
      [
        -1212.1756591796875,
        -3037.751708984375,
        1292.563720703125
      ],
      [
        -1215.00341796875,
        -3039.0107421875,
        1295.0089111328125
      ],
      [
        -1368.22216796875,
        -3050.077880859375,
        788.1644287109375
      ],
      [
        -1357.9627685546875,
        -3042.148681640625,
        839.0567016601562
      ],
      [
        -1338.36474609375,
        -3091.689453125,
        783.7042236328125
      ],
      [
        -1348.800048828125,
        -3059.89990234375,
        825.9383544921875
      ],
      [
        -1356.784423828125,
        -3066.077880859375,
        786.3157348632812
      ],
      [
        -1339.6785888671875,
        -3066.496337890625,
        839.0
      ],
      [
        -1344.1917724609375,
        -3068.8095703125,
        819.3839721679688
      ],
      [
        -1350.2852783203125,
        -3071.93310546875,
        792.8978881835938
      ],
      [
        -1349.80224609375,
        -3071.68505859375,
        794.9983520507812
      ],
      [
        -1349.80224609375,
        -3071.68505859375,
        794.9983520507812
      ],
      [
        -1349.796630859375,
        -3071.69482421875,
        794.99267578125
      ],
      [
        -1339.2152099609375,
        -3092.128662109375,
        780.0
      ],
      [
        -1338.36474609375,
        -3091.689453125,
        783.7042236328125
      ],
      [
        -1353.24755859375,
        -3073.4609375,
        780.0
      ],
      [
        -1350.2852783203125,
        -3071.93310546875,
        792.8978881835938
      ],
      [
        -1344.192138671875,
        -3068.8095703125,
        780.0
      ],
      [
        -1344.8546142578125,
        -3080.385986328125,
        790.0009765625
      ],
      [
        -1347.1490478515625,
        -3081.573974609375,
        780.0
      ],
      [
        -1344.8558349609375,
        -3080.38671875,
        789.9956665039062
      ],
      [
        -1344.1917724609375,
        -3068.8095703125,
        819.3839721679688
      ],
      [
        -1347.1929931640625,
        -3063.007080078125,
        823.6526489257812
      ],
      [
        -1347.1929931640625,
        -3063.007080078125,
        823.6526489257812
      ],
      [
        -1348.800048828125,
        -3059.89990234375,
        825.9383544921875
      ],
      [
        -1346.1680908203125,
        -3057.86328125,
        839.0
      ],
      [
        -1339.6785888671875,
        -3066.496337890625,
        839.0
      ],
      [
        -1336.6976318359375,
        -3050.535400390625,
        839.0
      ],
      [
        -1368.22216796875,
        -3050.077880859375,
        788.1644287109375
      ],
      [
        -1357.8485107421875,
        -3064.591064453125,
        786.4833374023438
      ],
      [
        -1356.784423828125,
        -3066.077880859375,
        786.3157348632812
      ],
      [
        -1357.8485107421875,
        -3064.591064453125,
        786.4833374023438
      ],
      [
        -1357.6507568359375,
        -3042.587646484375,
        839.0
      ],
      [
        -1357.6507568359375,
        -3042.587646484375,
        839.0
      ],
      [
        -1357.9627685546875,
        -3042.148681640625,
        839.0567016601562
      ],
      [
        -1325.327392578125,
        -3088.130126953125,
        832.169189453125
      ],
      [
        -1325.2467041015625,
        -3088.09423828125,
        833.34326171875
      ],
      [
        -1325.327392578125,
        -3088.130126953125,
        832.169189453125
      ],
      [
        -1356.511474609375,
        -3102.013916015625,
        964.08837890625
      ],
      [
        -1377.009033203125,
        -3111.14013671875,
        832.7509765625
      ],
      [
        -1356.511474609375,
        -3102.013916015625,
        1302.5999755859375
      ],
      [
        -1356.511474609375,
        -3102.013916015625,
        964.08837890625
      ],
      [
        -1595.0,
        -3174.36669921875,
        1302.5999755859375
      ],
      [
        -1518.1849365234375,
        -3165.98095703125,
        1302.5999755859375
      ],
      [
        -1542.645263671875,
        -3184.885986328125,
        1260.7716064453125
      ],
      [
        -1595.0,
        -3208.19580078125,
        1215.4404296875
      ],
      [
        -1465.0,
        -3124.875244140625,
        850.0
      ],
      [
        -1465.0,
        -3124.875244140625,
        919.0
      ],
      [
        -1465.0,
        -3124.875244140625,
        850.0
      ],
      [
        -1465.0,
        -3124.875244140625,
        919.0
      ],
      [
        -1440.436767578125,
        -3139.3798828125,
        919.0
      ],
      [
        -1440.436767578125,
        -3139.3798828125,
        849.997802734375
      ],
      [
        -1344.1956787109375,
        -3068.802001953125,
        839.0
      ],
      [
        -1344.1956787109375,
        -3068.802001953125,
        839.0
      ],
      [
        -1339.683837890625,
        -3066.489501953125,
        839.0
      ],
      [
        -1346.1680908203125,
        -3057.86328125,
        839.0
      ],
      [
        -1359.813232421875,
        -3101.888916015625,
        789.9998168945312
      ],
      [
        -1365.4051513671875,
        -3090.97802734375,
        789.99609375
      ],
      [
        -1359.851318359375,
        -3101.8447265625,
        783.8978271484375
      ],
      [
        -1374.31640625,
        -3095.515380859375,
        790.0186157226562
      ],
      [
        -1378.6759033203125,
        -3108.95849609375,
        785.0433959960938
      ],
      [
        -1369.7767333984375,
        -3104.3974609375,
        785.0340576171875
      ],
      [
        -1378.6759033203125,
        -3108.95849609375,
        785.0433959960938
      ],
      [
        -1374.31640625,
        -3095.515625,
        790.0186157226562
      ],
      [
        -1369.7767333984375,
        -3104.3974609375,
        785.0340576171875
      ],
      [
        -1351.8116455078125,
        -3097.791748046875,
        789.9998168945312
      ],
      [
        -1357.412841796875,
        -3086.86279296875,
        789.99609375
      ],
      [
        -1365.4051513671875,
        -3090.97802734375,
        789.99609375
      ],
      [
        -1359.813232421875,
        -3101.888916015625,
        789.9998168945312
      ],
      [
        -1357.412841796875,
        -3086.86279296875,
        789.99609375
      ],
      [
        -1351.8116455078125,
        -3097.791748046875,
        789.9998168945312
      ],
      [
        -1351.8377685546875,
        -3097.7412109375,
        783.8877563476562
      ],
      [
        -1378.6656494140625,
        -3108.953369140625,
        785.0433959960938
      ],
      [
        -1378.6719970703125,
        -3108.958251953125,
        780.0
      ],
      [
        -1359.8756103515625,
        -3101.816650390625,
        780.0
      ],
      [
        -1351.8543701171875,
        -3097.709228515625,
        780.0
      ],
      [
        -1465.0,
        -3149.810302734375,
        850.0
      ],
      [
        -1465.0,
        -3150.316162109375,
        850.0
      ],
      [
        -1465.0,
        -3150.316162109375,
        919.0
      ],
      [
        -1465.0,
        -3149.810302734375,
        919.0
      ],
      [
        -1466.4793701171875,
        -3150.954833984375,
        1302.5999755859375
      ],
      [
        -1465.99853515625,
        -3150.7607421875,
        1302.5999755859375
      ],
      [
        -1466.539794921875,
        -3151.001708984375,
        1302.5567626953125
      ],
      [
        -1465.0,
        -3150.316162109375,
        850.0
      ],
      [
        -1465.0,
        -3149.810302734375,
        850.0
      ],
      [
        -1440.436767578125,
        -3139.3798828125,
        849.997802734375
      ],
      [
        -1440.436767578125,
        -3139.3798828125,
        919.0
      ],
      [
        -1465.0,
        -3149.810302734375,
        919.0
      ],
      [
        -1465.0,
        -3150.316162109375,
        919.0
      ],
      [
        -1501.1502685546875,
        -3166.4111328125,
        1296.699951171875
      ],
      [
        -1497.2191162109375,
        -3164.660888671875,
        1300.1038818359375
      ],
      [
        -1501.1502685546875,
        -3166.4111328125,
        1296.7000732421875
      ],
      [
        -1498.0899658203125,
        -3165.048583984375,
        1299.30517578125
      ],
      [
        -1497.9498291015625,
        -3164.986083984375,
        1299.470703125
      ],
      [
        -1498.0899658203125,
        -3165.048583984375,
        1299.30517578125
      ],
      [
        -1497.427978515625,
        -3164.75390625,
        1300.087158203125
      ],
      [
        -1497.427978515625,
        -3164.75390625,
        1300.087158203125
      ],
      [
        -1359.0218505859375,
        -3062.949462890625,
        786.6734619140625
      ],
      [
        -1437.266845703125,
        -3128.351806640625,
        849.9962158203125
      ],
      [
        -1465.0,
        -3149.810302734375,
        871.9390258789062
      ],
      [
        -1465.0,
        -3124.875244140625,
        864.711669921875
      ],
      [
        -1465.0,
        -3149.810302734375,
        872.0136108398438
      ],
      [
        -1465.0,
        -3124.875244140625,
        864.7236938476562
      ],
      [
        -1377.009033203125,
        -3111.14013671875,
        832.7509765625
      ],
      [
        -1373.194091796875,
        -3109.441650390625,
        790.2850341796875
      ],
      [
        -1351.5003662109375,
        -3098.39990234375,
        780.0
      ],
      [
        -1351.5244140625,
        -3098.352294921875,
        790.0
      ],
      [
        -1359.5267333984375,
        -3102.44775390625,
        790.0
      ],
      [
        -1359.5224609375,
        -3102.505615234375,
        780.0
      ],
      [
        -1351.5244140625,
        -3098.352294921875,
        790.0
      ],
      [
        -1359.5267333984375,
        -3102.44775390625,
        790.0
      ],
      [
        -1372.228271484375,
        -3109.01171875,
        784.842529296875
      ],
      [
        -1373.1944580078125,
        -3109.44189453125,
        790.2847290039062
      ],
      [
        -1372.2021484375,
        -3109.0,
        780.0
      ],
      [
        -1372.228271484375,
        -3109.01171875,
        784.842529296875
      ],
      [
        -1359.5035400390625,
        -3102.4931640625,
        790.0
      ],
      [
        -1359.5035400390625,
        -3102.4931640625,
        790.0
      ],
      [
        -1325.112548828125,
        -3088.034423828125,
        833.904541015625
      ],
      [
        -1325.222900390625,
        -3088.083740234375,
        833.690185546875
      ],
      [
        -1325.222900390625,
        -3088.083740234375,
        833.690185546875
      ],
      [
        -945.3875122070312,
        -2991.783447265625,
        805.1602783203125
      ],
      [
        -945.3875122070312,
        -2991.783447265625,
        805.1602783203125
      ],
      [
        -945.4766235351562,
        -2991.7421875,
        805.267333984375
      ],
      [
        -905.461181640625,
        -2930.0,
        791.174072265625
      ],
      [
        -956.5881958007812,
        -2985.588623046875,
        821.1409912109375
      ],
      [
        -945.5826416015625,
        -2991.693359375,
        805.3947143554688
      ],
      [
        -945.5826416015625,
        -2991.693359375,
        805.3947143554688
      ],
      [
        -956.5881958007812,
        -2985.588623046875,
        821.1409912109375
      ],
      [
        -956.5836181640625,
        -2985.567138671875,
        821.1939697265625
      ],
      [
        -961.32958984375,
        -2936.900634765625,
        823.9703979492188
      ],
      [
        -961.32958984375,
        -2936.900634765625,
        823.9703979492188
      ],
      [
        -960.6317138671875,
        -2930.0,
        822.3370971679688
      ],
      [
        -891.6376342773438,
        -2984.5185546875,
        820.1068115234375
      ],
      [
        -891.5132446289062,
        -2984.51708984375,
        820.1036987304688
      ],
      [
        -891.6376342773438,
        -2984.5185546875,
        820.1068115234375
      ],
      [
        -891.5132446289062,
        -2984.51708984375,
        820.1036987304688
      ],
      [
        -884.869873046875,
        -2930.0,
        813.1690063476562
      ],
      [
        -891.4490356445312,
        -2984.441162109375,
        820.2880859375
      ],
      [
        -892.9903564453125,
        -2976.009765625,
        841.2613525390625
      ],
      [
        -912.193115234375,
        -2930.0,
        845.7208251953125
      ],
      [
        -891.4276123046875,
        -2984.415771484375,
        820.3496704101562
      ],
      [
        -892.9903564453125,
        -2976.009765625,
        841.2613525390625
      ],
      [
        -891.4276123046875,
        -2984.415771484375,
        820.3496704101562
      ],
      [
        -957.56005859375,
        -2977.45703125,
        841.3392944335938
      ],
      [
        -956.5671997070312,
        -2985.490234375,
        821.3839111328125
      ],
      [
        -956.5671997070312,
        -2985.490234375,
        821.3839111328125
      ],
      [
        -957.56005859375,
        -2977.45703125,
        841.3392944335938
      ],
      [
        -957.3480834960938,
        -2977.376220703125,
        841.527587890625
      ],
      [
        -946.9004516601562,
        -2996.380615234375,
        807.35546875
      ],
      [
        -946.6434326171875,
        -2991.10498046875,
        806.9124755859375
      ],
      [
        -946.9004516601562,
        -2996.380615234375,
        807.35546875
      ],
      [
        -660.0,
        -3173.34326171875,
        1108.3670654296875
      ],
      [
        -760.7306518554688,
        -3392.85400390625,
        1302.5999755859375
      ],
      [
        -1201.8896484375,
        -3085.17333984375,
        1227.2801513671875
      ],
      [
        -1201.8896484375,
        -3085.17333984375,
        1227.280029296875
      ],
      [
        -1247.3983154296875,
        -3053.433837890625,
        1159.3487548828125
      ],
      [
        -931.9616088867188,
        -2984.3896484375,
        860.2791748046875
      ],
      [
        -947.2314453125,
        -3031.210693359375,
        810.24658203125
      ],
      [
        -923.9130249023438,
        -2969.66943359375,
        858.7217407226562
      ],
      [
        -931.9616088867188,
        -2984.3896484375,
        860.2791748046875
      ],
      [
        -970.10693359375,
        -3068.086669921875,
        828.5869140625
      ],
      [
        -1025.741455078125,
        -3163.423828125,
        857.3399658203125
      ],
      [
        -970.10693359375,
        -3068.086669921875,
        828.5869140625
      ],
      [
        -887.7254638671875,
        -3045.440185546875,
        848.5906372070312
      ],
      [
        -887.7254638671875,
        -3045.440185546875,
        848.5906372070312
      ],
      [
        -887.49853515625,
        -3045.895263671875,
        844.41015625
      ],
      [
        -893.23828125,
        -2975.936767578125,
        841.456298828125
      ],
      [
        -891.5535888671875,
        -2984.517578125,
        820.104736328125
      ],
      [
        -887.9783325195312,
        -3047.949951171875,
        826.7776489257812
      ],
      [
        -887.49853515625,
        -3045.895263671875,
        844.41015625
      ],
      [
        -887.9783325195312,
        -3047.949951171875,
        826.7776489257812
      ],
      [
        -892.4285278320312,
        -3048.86474609375,
        822.4208374023438
      ],
      [
        -905.6151733398438,
        -3049.037353515625,
        810.6986083984375
      ],
      [
        -892.4285278320312,
        -3048.86474609375,
        822.4208374023438
      ],
      [
        -893.1610717773438,
        -3049.0068359375,
        821.7789306640625
      ],
      [
        -956.9534912109375,
        -3045.031982421875,
        823.232666015625
      ],
      [
        -947.376220703125,
        -3046.445068359375,
        811.5111083984375
      ],
      [
        -671.1575317382812,
        -2973.337646484375,
        1302.5999755859375
      ],
      [
        -660.0,
        -3031.7900390625,
        1263.7513427734375
      ],
      [
        -821.4185180664062,
        -3043.2802734375,
        963.815185546875
      ],
      [
        -841.7717895507812,
        -3045.536376953125,
        914.62158203125
      ],
      [
        -821.4185180664062,
        -3043.2802734375,
        963.815185546875
      ],
      [
        -841.7717895507812,
        -3045.536376953125,
        914.62158203125
      ],
      [
        -853.132080078125,
        -3045.537841796875,
        904.8870849609375
      ],
      [
        -887.9212646484375,
        -3048.962646484375,
        826.880859375
      ],
      [
        -887.540283203125,
        -3046.073974609375,
        842.8760986328125
      ],
      [
        -887.5009155273438,
        -3047.984375,
        841.0252685546875
      ],
      [
        -887.9212646484375,
        -3048.962646484375,
        826.880859375
      ],
      [
        -892.3948364257812,
        -3049.0048828125,
        822.4606323242188
      ],
      [
        -892.3948364257812,
        -3049.0048828125,
        822.4606323242188
      ],
      [
        -863.9329833984375,
        -3045.5390625,
        895.6318969726562
      ],
      [
        -887.567626953125,
        -3047.428955078125,
        848.7921752929688
      ],
      [
        -887.567626953125,
        -3047.428955078125,
        848.7921752929688
      ],
      [
        -887.379150390625,
        -3047.700927734375,
        845.1235961914062
      ],
      [
        -887.379150390625,
        -3047.700927734375,
        845.1235961914062
      ],
      [
        -863.9329833984375,
        -3045.5390625,
        895.6318969726562
      ],
      [
        -853.132080078125,
        -3045.537841796875,
        904.8870849609375
      ],
      [
        -873.3448486328125,
        -3069.9794921875,
        844.1968994140625
      ],
      [
        -887.2271118164062,
        -3061.287353515625,
        828.1368408203125
      ],
      [
        -887.5009155273438,
        -3047.984375,
        841.0252685546875
      ],
      [
        -902.1748046875,
        -3049.02880859375,
        813.7594604492188
      ],
      [
        -889.9364013671875,
        -3059.231689453125,
        825.3636474609375
      ],
      [
        -887.2271118164062,
        -3061.287353515625,
        828.1368408203125
      ],
      [
        -889.9364013671875,
        -3059.231689453125,
        825.3636474609375
      ],
      [
        -877.2920532226562,
        -3077.17919921875,
        829.90478515625
      ],
      [
        -873.3448486328125,
        -3069.9794921875,
        844.1968994140625
      ],
      [
        -875.5863647460938,
        -3087.461181640625,
        822.6123046875
      ],
      [
        -877.2920532226562,
        -3077.17919921875,
        829.90478515625
      ],
      [
        -875.5863647460938,
        -3087.461181640625,
        822.6123046875
      ],
      [
        -859.8419189453125,
        -3104.3193359375,
        833.787109375
      ],
      [
        -954.449951171875,
        -3045.4013671875,
        820.1685791015625
      ],
      [
        -905.2882690429688,
        -3072.352783203125,
        812.6204223632812
      ],
      [
        -886.8619384765625,
        -3072.021240234375,
        828.9940795898438
      ],
      [
        -886.62353515625,
        -3072.00390625,
        829.22900390625
      ],
      [
        -901.7431030273438,
        -3045.5439453125,
        863.2323608398438
      ],
      [
        -886.62353515625,
        -3072.00390625,
        829.22900390625
      ],
      [
        -886.8619384765625,
        -3072.021240234375,
        828.9940795898438
      ],
      [
        -958.6651000976562,
        -3047.46533203125,
        825.5189208984375
      ],
      [
        -952.4312133789062,
        -3053.239501953125,
        818.2352905273438
      ],
      [
        -905.2880249023438,
        -3072.369873046875,
        812.621826171875
      ],
      [
        -905.055419921875,
        -3072.3486328125,
        812.8273315429688
      ],
      [
        -886.6162719726562,
        -3070.885498046875,
        831.2197875976562
      ],
      [
        -1068.0897216796875,
        -3650.0,
        281.8211669921875
      ],
      [
        -1105.7723388671875,
        -3650.0,
        660.0
      ],
      [
        -1113.656494140625,
        -3636.16650390625,
        660.0
      ],
      [
        -1124.04736328125,
        -3625.868896484375,
        652.0028686523438
      ],
      [
        -1112.8206787109375,
        -3635.74853515625,
        660.0
      ],
      [
        -1113.7535400390625,
        -3636.215087890625,
        660.0
      ],
      [
        -1242.9605712890625,
        -3523.752197265625,
        568.603271484375
      ],
      [
        -1241.79443359375,
        -3523.3154296875,
        568.6787719726562
      ],
      [
        -1240.4544677734375,
        -3523.43115234375,
        569.0844116210938
      ],
      [
        -1124.04736328125,
        -3625.868896484375,
        652.0028686523438
      ],
      [
        -1113.656494140625,
        -3636.16650390625,
        660.0
      ],
      [
        -1123.5289306640625,
        -3620.42236328125,
        606.5253295898438
      ],
      [
        -1116.2999267578125,
        -3627.469482421875,
        606.9952392578125
      ],
      [
        -1122.1151123046875,
        -3621.659912109375,
        607.4821166992188
      ],
      [
        -1231.052978515625,
        -3526.295166015625,
        533.7691650390625
      ],
      [
        -1140.2744140625,
        -3605.76318359375,
        595.1940307617188
      ],
      [
        -1123.5289306640625,
        -3620.42236328125,
        606.5253295898438
      ],
      [
        -1140.2744140625,
        -3605.763427734375,
        595.1940307617188
      ],
      [
        -1130.4464111328125,
        -3614.75146484375,
        604.8349609375
      ],
      [
        -1129.3582763671875,
        -3620.13427734375,
        639.978271484375
      ],
      [
        -1156.8714599609375,
        -3602.75,
        631.5980834960938
      ],
      [
        -1146.9259033203125,
        -3601.264404296875,
        600.9776611328125
      ],
      [
        -1152.5810546875,
        -3600.75927734375,
        631.6778564453125
      ],
      [
        -1146.9259033203125,
        -3601.264404296875,
        600.9776611328125
      ],
      [
        -1130.4464111328125,
        -3614.75146484375,
        604.8349609375
      ],
      [
        -1129.3582763671875,
        -3620.13427734375,
        639.978271484375
      ],
      [
        -1136.913330078125,
        -3620.802734375,
        646.0672607421875
      ],
      [
        -1134.010498046875,
        -3617.101318359375,
        644.906005859375
      ],
      [
        -1240.5849609375,
        -3522.844482421875,
        565.326416015625
      ],
      [
        -1241.7305908203125,
        -3523.225341796875,
        556.07275390625
      ],
      [
        -1237.9278564453125,
        -3522.915771484375,
        549.6126098632812
      ],
      [
        -1237.9278564453125,
        -3522.915771484375,
        549.6126098632812
      ],
      [
        -1236.5616455078125,
        -3523.58740234375,
        546.4645385742188
      ],
      [
        -1236.5616455078125,
        -3523.58740234375,
        546.4645385742188
      ],
      [
        -1231.052978515625,
        -3526.295166015625,
        533.7691650390625
      ],
      [
        -1174.7884521484375,
        -3580.720703125,
        612.0061645507812
      ],
      [
        -1175.051025390625,
        -3580.985595703125,
        615.672119140625
      ],
      [
        -1195.3304443359375,
        -3563.029541015625,
        600.3699951171875
      ],
      [
        -1195.389404296875,
        -3563.087890625,
        601.184814453125
      ],
      [
        -1240.4544677734375,
        -3523.43115234375,
        569.0844116210938
      ],
      [
        -1241.79443359375,
        -3523.3154296875,
        568.6787719726562
      ],
      [
        -1240.906982421875,
        -3522.98095703125,
        568.3588256835938
      ],
      [
        -1111.8336181640625,
        -3635.51513671875,
        648.3139038085938
      ],
      [
        -1111.3021240234375,
        -3636.540283203125,
        654.0177612304688
      ],
      [
        -1114.6973876953125,
        -3629.991943359375,
        617.5802612304688
      ],
      [
        -1111.8336181640625,
        -3635.51513671875,
        648.3139038085938
      ],
      [
        -1116.2999267578125,
        -3627.469482421875,
        606.9952392578125
      ],
      [
        -1114.6973876953125,
        -3629.991943359375,
        617.580322265625
      ],
      [
        -1109.3212890625,
        -3637.773681640625,
        640.5932006835938
      ],
      [
        -1105.0377197265625,
        -3650.0,
        630.7821044921875
      ],
      [
        -1104.101806640625,
        -3650.0,
        641.0706787109375
      ],
      [
        -1104.3135986328125,
        -3649.27734375,
        642.104736328125
      ],
      [
        -1110.956298828125,
        -3636.771240234375,
        652.4913330078125
      ],
      [
        -1110.4176025390625,
        -3637.101318359375,
        648.5728759765625
      ],
      [
        -1110.4176025390625,
        -3637.101318359375,
        648.5728759765625
      ],
      [
        -1109.3212890625,
        -3637.773681640625,
        640.5932006835938
      ],
      [
        -1111.3021240234375,
        -3636.540283203125,
        654.0177612304688
      ],
      [
        -1110.956298828125,
        -3636.771240234375,
        652.4913330078125
      ],
      [
        -1110.995849609375,
        -3636.739013671875,
        652.7423095703125
      ],
      [
        -1104.3135986328125,
        -3649.27734375,
        642.104736328125
      ],
      [
        -1104.101806640625,
        -3650.0,
        641.0706787109375
      ],
      [
        -1103.9747314453125,
        -3650.0,
        641.9547119140625
      ],
      [
        -1197.915283203125,
        -3565.591552734375,
        636.095947265625
      ],
      [
        -1195.963623046875,
        -3563.6572265625,
        609.1212768554688
      ],
      [
        -1195.963623046875,
        -3563.6572265625,
        609.1212768554688
      ],
      [
        -1176.79248046875,
        -3582.7421875,
        639.978271484375
      ],
      [
        -1175.4969482421875,
        -3581.435546875,
        621.8959350585938
      ],
      [
        -1175.4969482421875,
        -3581.435546875,
        621.8959350585938
      ],
      [
        -1176.79248046875,
        -3582.7421875,
        639.978271484375
      ],
      [
        -1179.875732421875,
        -3581.075927734375,
        645.9127807617188
      ],
      [
        -1149.0364990234375,
        -3605.5234375,
        646.978271484375
      ],
      [
        -1135.0489501953125,
        -3616.549560546875,
        646.978271484375
      ],
      [
        -1152.8753662109375,
        -3601.919677734375,
        642.4915771484375
      ],
      [
        -1149.0364990234375,
        -3605.5234375,
        646.978271484375
      ],
      [
        -1154.1099853515625,
        -3600.622802734375,
        639.978271484375
      ],
      [
        -1154.1099853515625,
        -3600.622802734375,
        639.978271484375
      ],
      [
        -1152.8753662109375,
        -3601.919677734375,
        642.4915771484375
      ],
      [
        -1134.18359375,
        -3616.988525390625,
        645.08935546875
      ],
      [
        -1134.18359375,
        -3616.988525390625,
        645.08935546875
      ],
      [
        -1135.0489501953125,
        -3616.549560546875,
        646.978271484375
      ],
      [
        -1106.6961669921875,
        -3641.150634765625,
        653.7352294921875
      ],
      [
        -1101.3798828125,
        -3650.0,
        660.0
      ],
      [
        -1104.3472900390625,
        -3644.052734375,
        660.0
      ],
      [
        -1110.952880859375,
        -3636.766845703125,
        652.5633544921875
      ],
      [
        -1110.332275390625,
        -3637.083984375,
        648.9888916015625
      ],
      [
        -1110.332275390625,
        -3637.083984375,
        648.9888916015625
      ],
      [
        -1109.866943359375,
        -3637.43896484375,
        644.5646362304688
      ],
      [
        -1109.74462890625,
        -3637.38427734375,
        645.6044311523438
      ],
      [
        -1110.952880859375,
        -3636.766845703125,
        652.5633544921875
      ],
      [
        -1109.1982421875,
        -3637.66357421875,
        642.4576416015625
      ],
      [
        -1106.6961669921875,
        -3641.150634765625,
        653.7352294921875
      ],
      [
        -1109.1982421875,
        -3637.66357421875,
        642.4576416015625
      ],
      [
        -1066.54833984375,
        -3650.0,
        267.0
      ],
      [
        -1068.0897216796875,
        -3650.0,
        281.8211669921875
      ],
      [
        -1203.474365234375,
        -3510.526611328125,
        267.0
      ],
      [
        -1240.6727294921875,
        -3522.888916015625,
        567.5443725585938
      ],
      [
        -1206.89111328125,
        -3508.74365234375,
        286.2550048828125
      ],
      [
        -1240.4945068359375,
        -3522.814453125,
        566.0574340820312
      ],
      [
        -1239.2996826171875,
        -3522.87890625,
        557.7251586914062
      ],
      [
        -1240.95556640625,
        -3523.00732421875,
        569.8958740234375
      ],
      [
        -1240.85107421875,
        -3522.959716796875,
        568.309814453125
      ],
      [
        -1240.7171630859375,
        -3523.169677734375,
        568.6631469726562
      ],
      [
        -1240.8531494140625,
        -3522.960693359375,
        568.3394165039062
      ],
      [
        -1240.7275390625,
        -3523.11669921875,
        568.58544921875
      ],
      [
        -1240.795654296875,
        -3522.9375,
        568.0107421875
      ],
      [
        -1240.6727294921875,
        -3522.888916015625,
        567.5443725585938
      ],
      [
        -1240.85107421875,
        -3522.959716796875,
        568.309814453125
      ],
      [
        -1240.795654296875,
        -3522.9375,
        568.0107421875
      ],
      [
        -1240.7645263671875,
        -3522.92724609375,
        568.3074951171875
      ],
      [
        -1245.0706787109375,
        -3524.878662109375,
        632.373291015625
      ],
      [
        -1246.8746337890625,
        -3525.7001953125,
        660.0
      ],
      [
        -1124.3631591796875,
        -3625.555908203125,
        651.7598266601562
      ],
      [
        -1112.7955322265625,
        -3635.73583984375,
        660.0
      ],
      [
        -1240.4049072265625,
        -3523.435546875,
        569.0994262695312
      ],
      [
        -1124.3631591796875,
        -3625.555908203125,
        651.7598266601562
      ],
      [
        -1174.998291015625,
        -3580.932373046875,
        614.9359741210938
      ],
      [
        -1175.051025390625,
        -3580.985595703125,
        615.6720581054688
      ],
      [
        -1175.0428466796875,
        -3580.9560546875,
        615.658935546875
      ],
      [
        -1195.3551025390625,
        -3563.07763671875,
        601.1883544921875
      ],
      [
        -1195.389404296875,
        -3563.087890625,
        601.184814453125
      ],
      [
        -1240.4049072265625,
        -3523.435546875,
        569.0994262695312
      ],
      [
        -1240.724609375,
        -3523.1318359375,
        568.6075439453125
      ],
      [
        -1152.5810546875,
        -3600.759521484375,
        631.677978515625
      ],
      [
        -1152.4573974609375,
        -3600.7705078125,
        631.0070190429688
      ],
      [
        -1152.55419921875,
        -3600.7470703125,
        631.678466796875
      ],
      [
        -1133.5897216796875,
        -3617.375732421875,
        644.4603881835938
      ],
      [
        -1134.010498046875,
        -3617.101318359375,
        644.906005859375
      ],
      [
        -1133.9940185546875,
        -3617.08056640625,
        644.8994140625
      ],
      [
        -1196.519287109375,
        -3565.357421875,
        639.978271484375
      ],
      [
        -1195.6573486328125,
        -3563.666748046875,
        611.2037963867188
      ],
      [
        -1195.6573486328125,
        -3563.666748046875,
        611.2037963867188
      ],
      [
        -1176.54248046875,
        -3581.751708984375,
        639.978271484375
      ],
      [
        -1175.503173828125,
        -3581.200439453125,
        623.1245727539062
      ],
      [
        -1175.503173828125,
        -3581.200439453125,
        623.1245727539062
      ],
      [
        -1179.7132568359375,
        -3579.67138671875,
        646.238037109375
      ],
      [
        -1193.1112060546875,
        -3568.782958984375,
        647.521484375
      ],
      [
        -1193.1112060546875,
        -3568.782958984375,
        647.521484375
      ],
      [
        -1196.519287109375,
        -3565.357421875,
        639.978271484375
      ],
      [
        -1176.54248046875,
        -3581.751708984375,
        639.978271484375
      ],
      [
        -1179.7132568359375,
        -3579.67138671875,
        646.238037109375
      ],
      [
        -1148.641357421875,
        -3605.233154296875,
        646.978271484375
      ],
      [
        -1134.97412109375,
        -3616.449462890625,
        646.978271484375
      ],
      [
        -1153.75048828125,
        -3600.456787109375,
        639.978271484375
      ],
      [
        -1152.351318359375,
        -3601.83154296875,
        642.698974609375
      ],
      [
        -1148.641357421875,
        -3605.233154296875,
        646.978271484375
      ],
      [
        -1153.75048828125,
        -3600.456787109375,
        639.978271484375
      ],
      [
        -1152.351318359375,
        -3601.83154296875,
        642.698974609375
      ],
      [
        -1134.1549072265625,
        -3616.963134765625,
        645.0740356445312
      ],
      [
        -1134.97412109375,
        -3616.449462890625,
        646.978271484375
      ],
      [
        -1134.1549072265625,
        -3616.963134765625,
        645.0740356445312
      ],
      [
        -1172.0745849609375,
        -3571.747802734375,
        611.6719970703125
      ],
      [
        -1112.6732177734375,
        -3635.6748046875,
        660.0
      ],
      [
        -1123.244873046875,
        -3620.53125,
        607.5767211914062
      ],
      [
        -1123.244873046875,
        -3620.53125,
        607.5767211914062
      ],
      [
        -1172.0745849609375,
        -3571.747802734375,
        611.6719970703125
      ],
      [
        -1129.7899169921875,
        -3614.048095703125,
        608.774169921875
      ],
      [
        -1128.4976806640625,
        -3618.030517578125,
        639.978271484375
      ],
      [
        -1152.55419921875,
        -3600.7470703125,
        631.678466796875
      ],
      [
        -1144.9478759765625,
        -3599.145263671875,
        612.8455200195312
      ],
      [
        -1147.3653564453125,
        -3598.339599609375,
        631.7750854492188
      ],
      [
        -1144.9478759765625,
        -3599.145263671875,
        612.8455200195312
      ],
      [
        -1129.7899169921875,
        -3614.048095703125,
        608.774169921875
      ],
      [
        -1128.4976806640625,
        -3618.030517578125,
        639.978271484375
      ],
      [
        -1133.9940185546875,
        -3617.08056640625,
        644.8994140625
      ],
      [
        -1133.3232421875,
        -3616.225341796875,
        644.6310424804688
      ],
      [
        -1131.8887939453125,
        -3614.952392578125,
        643.8668823242188
      ],
      [
        -1131.8887939453125,
        -3614.952392578125,
        643.8668823242188
      ],
      [
        -1133.3232421875,
        -3616.225341796875,
        644.6310424804688
      ],
      [
        -1132.038818359375,
        -3614.833984375,
        644.244384765625
      ],
      [
        -1188.7039794921875,
        -3561.078125,
        601.8727416992188
      ],
      [
        -1173.697265625,
        -3576.083984375,
        613.4913330078125
      ],
      [
        -1173.697265625,
        -3576.083984375,
        613.4913330078125
      ],
      [
        -1175.0428466796875,
        -3580.9560546875,
        615.658935546875
      ],
      [
        -1240.2393798828125,
        -3522.7294921875,
        568.1181640625
      ],
      [
        -1240.2393798828125,
        -3522.7294921875,
        568.1181640625
      ],
      [
        -1188.7039794921875,
        -3561.078125,
        601.8727416992188
      ],
      [
        -1195.3551025390625,
        -3563.07763671875,
        601.1883544921875
      ],
      [
        -1240.684326171875,
        -3523.170166015625,
        568.66943359375
      ],
      [
        -1240.7275390625,
        -3523.116455078125,
        568.5850219726562
      ],
      [
        -1240.699462890625,
        -3523.176025390625,
        568.889404296875
      ],
      [
        -1240.7701416015625,
        -3523.095947265625,
        568.829833984375
      ],
      [
        -1245.0706787109375,
        -3524.878662109375,
        632.373291015625
      ],
      [
        -1147.299072265625,
        -3604.2470703125,
        646.978271484375
      ],
      [
        -1134.4500732421875,
        -3615.74853515625,
        646.978271484375
      ],
      [
        -1151.5899658203125,
        -3599.45849609375,
        639.978271484375
      ],
      [
        -1150.1488037109375,
        -3599.631103515625,
        631.7232666015625
      ],
      [
        -1149.94580078125,
        -3601.42724609375,
        643.6510009765625
      ],
      [
        -1147.299072265625,
        -3604.2470703125,
        646.978271484375
      ],
      [
        -1151.5899658203125,
        -3599.45849609375,
        639.978271484375
      ],
      [
        -1149.94580078125,
        -3601.42724609375,
        643.6510009765625
      ],
      [
        -1133.448486328125,
        -3616.33642578125,
        644.69775390625
      ],
      [
        -1134.4500732421875,
        -3615.74853515625,
        646.978271484375
      ],
      [
        -1133.448486328125,
        -3616.33642578125,
        644.69775390625
      ],
      [
        -1133.4244384765625,
        -3616.354248046875,
        644.6715087890625
      ],
      [
        -1144.6947021484375,
        -3602.33349609375,
        646.978271484375
      ],
      [
        -1133.124755859375,
        -3613.97607421875,
        646.978271484375
      ],
      [
        -1148.4129638671875,
        -3597.990478515625,
        639.978271484375
      ],
      [
        -1148.4129638671875,
        -3597.990478515625,
        639.978271484375
      ],
      [
        -1146.086181640625,
        -3600.77880859375,
        645.1785278320312
      ],
      [
        -1146.086181640625,
        -3600.77880859375,
        645.1785278320312
      ],
      [
        -1144.6947021484375,
        -3602.33349609375,
        646.978271484375
      ],
      [
        -1133.124755859375,
        -3613.97607421875,
        646.978271484375
      ],
      [
        -1148.46826171875,
        -3487.271484375,
        369.31988525390625
      ],
      [
        -1139.98095703125,
        -3485.4150390625,
        621.925537109375
      ],
      [
        -1135.727294921875,
        -3493.7353515625,
        641.6961059570312
      ],
      [
        -1143.2298583984375,
        -3508.48583984375,
        267.0
      ],
      [
        -1135.727294921875,
        -3493.7353515625,
        641.6961059570312
      ],
      [
        -1139.98095703125,
        -3485.4150390625,
        621.925537109375
      ],
      [
        -1137.28759765625,
        -3484.58642578125,
        656.460205078125
      ],
      [
        -1134.301025390625,
        -3493.292236328125,
        660.0
      ],
      [
        -1134.0615234375,
        -3494.06884765625,
        660.0
      ],
      [
        -1134.301025390625,
        -3493.292236328125,
        660.0
      ],
      [
        -1137.28759765625,
        -3484.58642578125,
        656.460205078125
      ],
      [
        -1136.84423828125,
        -3484.438720703125,
        660.0
      ],
      [
        -1155.2579345703125,
        -3489.280029296875,
        267.0
      ],
      [
        -1152.176513671875,
        -3488.46923828125,
        332.6519775390625
      ],
      [
        -1152.176513671875,
        -3488.46923828125,
        332.6519775390625
      ],
      [
        -1148.46826171875,
        -3487.271240234375,
        369.31988525390625
      ],
      [
        -949.8262939453125,
        -3650.0,
        660.0
      ],
      [
        -976.505615234375,
        -3650.0,
        275.85992431640625
      ],
      [
        -977.0939331054688,
        -3650.0,
        267.0
      ],
      [
        -976.505615234375,
        -3650.0,
        275.8599548339844
      ],
      [
        -1131.06005859375,
        -3503.157958984375,
        660.0
      ],
      [
        -1131.06005859375,
        -3503.157958984375,
        660.0
      ],
      [
        -1131.7891845703125,
        -3501.4384765625,
        660.0
      ],
      [
        -1131.7891845703125,
        -3501.4384765625,
        660.0
      ],
      [
        -1110.5205078125,
        -3634.598388671875,
        660.0
      ],
      [
        -1112.212158203125,
        -3635.4443359375,
        660.0
      ],
      [
        -1112.212158203125,
        -3635.4443359375,
        660.0
      ],
      [
        -1110.646484375,
        -3636.29443359375,
        660.0
      ],
      [
        -1110.5205078125,
        -3634.598388671875,
        660.0
      ],
      [
        -1129.640869140625,
        -3613.888427734375,
        609.6682739257812
      ],
      [
        -1126.1817626953125,
        -3612.368896484375,
        639.978271484375
      ],
      [
        -1144.155029296875,
        -3598.295654296875,
        617.6029663085938
      ],
      [
        -1129.640869140625,
        -3613.888427734375,
        609.6682739257812
      ],
      [
        -1147.3653564453125,
        -3598.339599609375,
        631.7750244140625
      ],
      [
        -1144.155029296875,
        -3598.295654296875,
        617.6029663085938
      ],
      [
        -1143.5546875,
        -3596.57177734375,
        631.845947265625
      ],
      [
        -1126.1817626953125,
        -3612.368896484375,
        639.978271484375
      ],
      [
        -1127.377197265625,
        -3610.949462890625,
        641.4635009765625
      ],
      [
        -1127.377197265625,
        -3610.949462890625,
        641.4635009765625
      ],
      [
        -1132.038818359375,
        -3614.833984375,
        644.2445068359375
      ],
      [
        -1127.8212890625,
        -3610.265869140625,
        642.97509765625
      ],
      [
        -1110.5943603515625,
        -3636.3115234375,
        660.0
      ],
      [
        -1109.4552001953125,
        -3636.905517578125,
        653.262451171875
      ],
      [
        -1108.632080078125,
        -3636.554931640625,
        660.0
      ],
      [
        -1109.4552001953125,
        -3636.905517578125,
        653.262451171875
      ],
      [
        -1110.1240234375,
        -3637.1904296875,
        647.7892456054688
      ],
      [
        -1110.646484375,
        -3636.29443359375,
        660.0
      ],
      [
        -1110.5943603515625,
        -3636.3115234375,
        660.0
      ],
      [
        -1108.0408935546875,
        -3636.628173828125,
        660.0
      ],
      [
        -1107.9796142578125,
        -3636.773193359375,
        660.0
      ],
      [
        -1108.072509765625,
        -3636.624267578125,
        660.0
      ],
      [
        -1108.072509765625,
        -3636.624267578125,
        660.0
      ],
      [
        -1108.0408935546875,
        -3636.628173828125,
        660.0
      ],
      [
        -1107.9796142578125,
        -3636.773193359375,
        660.0
      ],
      [
        -1141.775634765625,
        -3595.746337890625,
        631.8790893554688
      ],
      [
        -1128.6259765625,
        -3604.862548828125,
        639.978271484375
      ],
      [
        -1141.775634765625,
        -3595.746337890625,
        631.8790893554688
      ],
      [
        -1128.6259765625,
        -3604.862548828125,
        639.978271484375
      ],
      [
        -1126.7498779296875,
        -3609.10546875,
        642.652587890625
      ],
      [
        -1126.7498779296875,
        -3609.10546875,
        642.652587890625
      ],
      [
        -1204.57861328125,
        -3507.775390625,
        267.0
      ],
      [
        -894.7830810546875,
        -3650.0,
        1288.113037109375
      ],
      [
        -949.8262939453125,
        -3650.0,
        660.0
      ],
      [
        -804.115478515625,
        -3362.595947265625,
        1217.9327392578125
      ],
      [
        -1132.9666748046875,
        -3486.420166015625,
        684.1095581054688
      ],
      [
        -1133.350341796875,
        -3483.275146484375,
        687.8972778320312
      ],
      [
        -1114.8494873046875,
        -3477.976318359375,
        999.9696044921875
      ],
      [
        -1097.50732421875,
        -3476.419189453125,
        1217.9898681640625
      ],
      [
        -1097.50732421875,
        -3476.419189453125,
        1217.9898681640625
      ],
      [
        -1108.127197265625,
        -3475.992919921875,
        1102.3118896484375
      ],
      [
        -894.7830810546875,
        -3650.0,
        1288.1129150390625
      ],
      [
        -893.34814453125,
        -3650.0,
        1302.5999755859375
      ],
      [
        -1136.681396484375,
        -3485.005615234375,
        660.0
      ],
      [
        -1133.350341796875,
        -3483.275146484375,
        687.8972778320312
      ],
      [
        -1132.9666748046875,
        -3486.420166015625,
        684.1095581054688
      ],
      [
        -1109.4647216796875,
        -3476.43408203125,
        1090.7999267578125
      ],
      [
        -1131.9222412109375,
        -3494.98193359375,
        673.7976684570312
      ],
      [
        -1108.1988525390625,
        -3476.015625,
        1101.51708984375
      ],
      [
        -1108.1988525390625,
        -3476.015625,
        1101.51708984375
      ],
      [
        -1109.4647216796875,
        -3476.43408203125,
        1090.7999267578125
      ],
      [
        -1133.9759521484375,
        -3494.23974609375,
        660.38525390625
      ],
      [
        -1131.9222412109375,
        -3494.98193359375,
        673.7976684570312
      ],
      [
        -1134.008544921875,
        -3494.24072265625,
        660.0
      ],
      [
        -1133.9759521484375,
        -3494.23974609375,
        660.38525390625
      ],
      [
        -1131.270263671875,
        -3502.662109375,
        660.0
      ],
      [
        -1258.1507568359375,
        -3530.838623046875,
        833.2398071289062
      ],
      [
        -1258.0595703125,
        -3530.794189453125,
        831.288330078125
      ],
      [
        -1125.0511474609375,
        -3650.0,
        1021.7411499023438
      ],
      [
        -1105.7723388671875,
        -3650.0,
        660.0
      ],
      [
        -1148.2236328125,
        -3650.0,
        1302.5999755859375
      ],
      [
        -1127.74462890625,
        -3650.0,
        1047.7374267578125
      ],
      [
        -1108.596435546875,
        -3643.9736328125,
        662.2799072265625
      ],
      [
        -1105.9620361328125,
        -3650.0,
        663.5565185546875
      ],
      [
        -1107.3037109375,
        -3650.0,
        663.5450439453125
      ],
      [
        -1111.58544921875,
        -3637.121826171875,
        660.7158203125
      ],
      [
        -1108.596435546875,
        -3643.9736328125,
        662.2799072265625
      ],
      [
        -1112.34326171875,
        -3636.141357421875,
        660.3259887695312
      ],
      [
        -1111.9892578125,
        -3636.436767578125,
        660.56982421875
      ],
      [
        -1112.8165283203125,
        -3635.74658203125,
        660.0
      ],
      [
        -1112.34326171875,
        -3636.141357421875,
        660.3259887695312
      ],
      [
        -1111.831298828125,
        -3636.568603515625,
        660.6786499023438
      ],
      [
        -1111.7984619140625,
        -3636.647705078125,
        660.7279663085938
      ],
      [
        -1111.6629638671875,
        -3636.9580078125,
        660.793701171875
      ],
      [
        -1111.58544921875,
        -3637.121826171875,
        660.7158203125
      ],
      [
        -1111.7178955078125,
        -3636.841796875,
        660.848876953125
      ],
      [
        -1111.7178955078125,
        -3636.841796875,
        660.848876953125
      ],
      [
        -1127.74462890625,
        -3650.0,
        1047.7374267578125
      ],
      [
        -1125.0511474609375,
        -3650.0,
        1021.7411499023438
      ],
      [
        -1174.573486328125,
        -3625.216064453125,
        1302.5999755859375
      ],
      [
        -1269.7215576171875,
        -3536.478271484375,
        1080.853515625
      ],
      [
        -1258.1507568359375,
        -3530.838623046875,
        833.2398681640625
      ],
      [
        -1111.201904296875,
        -3637.067138671875,
        660.6630859375
      ],
      [
        -1105.266845703125,
        -3641.81640625,
        661.3656005859375
      ],
      [
        -1100.9259033203125,
        -3650.0,
        663.157470703125
      ],
      [
        -1105.0445556640625,
        -3650.0,
        663.5643920898438
      ],
      [
        -1100.9259033203125,
        -3650.0,
        663.157470703125
      ],
      [
        -1105.266845703125,
        -3641.81640625,
        661.3656005859375
      ],
      [
        -1105.659423828125,
        -3641.42333984375,
        660.0
      ],
      [
        -1105.0445556640625,
        -3650.0,
        663.5643920898438
      ],
      [
        -1111.584228515625,
        -3636.77490234375,
        660.848876953125
      ],
      [
        -1111.201904296875,
        -3637.067138671875,
        660.6630859375
      ],
      [
        -1111.584228515625,
        -3636.77490234375,
        660.848876953125
      ],
      [
        -1258.0595703125,
        -3530.794189453125,
        831.288330078125
      ],
      [
        -1112.1827392578125,
        -3636.275390625,
        660.4365844726562
      ],
      [
        -1112.342041015625,
        -3636.135009765625,
        660.3230590820312
      ],
      [
        -1112.79541015625,
        -3635.736083984375,
        660.0
      ],
      [
        -1112.342041015625,
        -3636.135009765625,
        660.3230590820312
      ],
      [
        -865.1904296875,
        -3320.0,
        1098.7425537109375
      ],
      [
        -1027.87646484375,
        -3320.0,
        1018.707763671875
      ],
      [
        -1085.4853515625,
        -3320.0,
        869.3729248046875
      ],
      [
        -1027.87646484375,
        -3320.0,
        1018.707763671875
      ],
      [
        -1085.4853515625,
        -3320.0,
        869.3729248046875
      ],
      [
        -1105.0,
        -3320.0,
        872.9010620117188
      ],
      [
        -1105.0,
        -3304.406494140625,
        872.9010620117188
      ],
      [
        -1105.0,
        -3304.406494140625,
        872.9010620117188
      ],
      [
        -1105.0,
        -3293.0009765625,
        871.3569946289062
      ],
      [
        -1067.857177734375,
        -3254.84521484375,
        862.6844482421875
      ],
      [
        -1067.857177734375,
        -3254.84521484375,
        862.6844482421875
      ],
      [
        -1105.0,
        -3293.0009765625,
        871.3569946289062
      ],
      [
        -1105.0,
        -3291.5771484375,
        872.9010620117188
      ],
      [
        -1074.35498046875,
        -3258.607177734375,
        867.3606567382812
      ],
      [
        -1105.0,
        -3276.348876953125,
        889.4143676757812
      ],
      [
        -1105.0,
        -3152.747802734375,
        1023.4471435546875
      ],
      [
        -1105.0,
        -3338.26953125,
        872.9010620117188
      ],
      [
        -1105.0,
        -3434.97412109375,
        1159.3406982421875
      ],
      [
        -1105.0,
        -3434.97412109375,
        1159.3406982421875
      ],
      [
        -1105.0,
        -3475.00244140625,
        1136.998046875
      ],
      [
        -1105.0,
        -3338.26953125,
        872.9010620117188
      ],
      [
        -1175.486083984375,
        -3320.0,
        640.3673095703125
      ],
      [
        -1163.886474609375,
        -3320.0,
        715.0223388671875
      ],
      [
        -1293.459228515625,
        -3183.87109375,
        533.1758422851562
      ],
      [
        -1293.459228515625,
        -3183.87109375,
        533.1758422851562
      ],
      [
        -1324.617431640625,
        -3140.562255859375,
        540.0993041992188
      ],
      [
        -1324.617431640625,
        -3140.562255859375,
        540.0993041992188
      ],
      [
        -1341.437744140625,
        -3116.5771484375,
        546.7369384765625
      ],
      [
        -1347.9879150390625,
        -3098.218994140625,
        592.5193481445312
      ],
      [
        -1352.2418212890625,
        -3100.781982421875,
        552.8644409179688
      ],
      [
        -1352.2418212890625,
        -3100.781982421875,
        552.8644409179688
      ],
      [
        -1341.437744140625,
        -3116.5771484375,
        546.7369384765625
      ],
      [
        -1163.886474609375,
        -3320.0,
        715.0223388671875
      ],
      [
        -1333.1427001953125,
        -3091.609375,
        724.0
      ],
      [
        -1175.145263671875,
        -3303.725341796875,
        724.0
      ],
      [
        -1163.808349609375,
        -3320.0,
        715.8345947265625
      ],
      [
        -1276.442626953125,
        -3320.0,
        466.3150939941406
      ],
      [
        -1282.109375,
        -3320.0,
        465.73052978515625
      ],
      [
        -1284.31787109375,
        -3320.0,
        472.17510986328125
      ],
      [
        -1282.109375,
        -3320.0,
        465.73052978515625
      ],
      [
        -1284.31787109375,
        -3320.0,
        472.17510986328125
      ],
      [
        -1286.2840576171875,
        -3320.0,
        480.18701171875
      ],
      [
        -1328.328857421875,
        -3320.0,
        538.2327880859375
      ],
      [
        -1331.0455322265625,
        -3320.0,
        561.276123046875
      ],
      [
        -1324.8673095703125,
        -3320.0,
        508.53228759765625
      ],
      [
        -1328.328857421875,
        -3320.0,
        538.2327880859375
      ],
      [
        -1324.77734375,
        -3320.0,
        508.1073303222656
      ],
      [
        -1324.8673095703125,
        -3320.0,
        508.53228759765625
      ],
      [
        -1324.7630615234375,
        -3320.0,
        508.04010009765625
      ],
      [
        -1287.4573974609375,
        -3320.0,
        484.96807861328125
      ],
      [
        -1287.4573974609375,
        -3320.0,
        484.96807861328125
      ],
      [
        -1324.7630615234375,
        -3320.0,
        508.04010009765625
      ],
      [
        -1235.3033447265625,
        -3318.94921875,
        472.8973083496094
      ],
      [
        -1235.176513671875,
        -3320.0,
        470.5718994140625
      ],
      [
        -1234.159423828125,
        -3317.593505859375,
        473.12396240234375
      ],
      [
        -1233.32861328125,
        -3320.0,
        466.6517028808594
      ],
      [
        -1235.176513671875,
        -3320.0,
        470.5718994140625
      ],
      [
        -1235.3033447265625,
        -3318.94921875,
        472.8973083496094
      ],
      [
        -1233.32861328125,
        -3320.0,
        466.6517028808594
      ],
      [
        -1234.159423828125,
        -3317.593505859375,
        473.12396240234375
      ],
      [
        -1233.12890625,
        -3319.2275390625,
        472.50262451171875
      ],
      [
        -1232.81396484375,
        -3320.0,
        470.816162109375
      ],
      [
        -1232.641845703125,
        -3320.0,
        472.2089538574219
      ],
      [
        -1337.023193359375,
        -3320.0,
        611.8834228515625
      ],
      [
        -1386.6923828125,
        -3174.371337890625,
        724.0
      ],
      [
        -1400.39306640625,
        -3123.563720703125,
        724.0
      ],
      [
        -1336.9337158203125,
        -3320.0,
        610.9191284179688
      ],
      [
        -1353.09228515625,
        -3290.031982421875,
        698.0
      ],
      [
        -1356.4564208984375,
        -3320.0,
        698.0
      ],
      [
        -1345.010986328125,
        -3320.0,
        698.0
      ],
      [
        -1356.4564208984375,
        -3320.0,
        700.5
      ],
      [
        -1353.3177490234375,
        -3290.0556640625,
        700.5
      ],
      [
        -1345.2430419921875,
        -3320.0,
        700.5
      ],
      [
        -1353.09228515625,
        -3290.031982421875,
        698.0
      ],
      [
        -1353.3177490234375,
        -3290.0556640625,
        700.5
      ],
      [
        -1351.2083740234375,
        -3297.878173828125,
        700.5
      ],
      [
        -1353.3280029296875,
        -3298.10107421875,
        724.0
      ],
      [
        -1344.489990234375,
        -3306.724365234375,
        653.7886352539062
      ],
      [
        -1345.6170654296875,
        -3302.318115234375,
        653.1282958984375
      ],
      [
        -1344.7900390625,
        -3302.231201171875,
        643.9597778320312
      ],
      [
        -1345.6170654296875,
        -3302.318115234375,
        653.1282958984375
      ],
      [
        -1344.131591796875,
        -3306.686767578125,
        649.8157348632812
      ],
      [
        -1344.489990234375,
        -3306.724365234375,
        653.7886352539062
      ],
      [
        -1343.6630859375,
        -3306.6376953125,
        644.6200561523438
      ],
      [
        -1344.131591796875,
        -3306.686767578125,
        649.8157348632812
      ],
      [
        -1343.6630859375,
        -3306.6376953125,
        644.6200561523438
      ],
      [
        -1344.7900390625,
        -3302.231201171875,
        643.9597778320312
      ],
      [
        -1336.874267578125,
        -3320.0,
        610.715576171875
      ],
      [
        -1336.9337158203125,
        -3320.0,
        610.9191284179688
      ],
      [
        -1336.874267578125,
        -3320.0,
        610.715576171875
      ],
      [
        -1381.0400390625,
        -3192.75048828125,
        724.0
      ],
      [
        -1386.6923828125,
        -3174.371337890625,
        724.0
      ],
      [
        -1337.023193359375,
        -3320.0,
        611.8834228515625
      ],
      [
        -1337.0296630859375,
        -3320.0,
        612.0330810546875
      ],
      [
        -1388.2457275390625,
        -3117.4443359375,
        630.4634399414062
      ],
      [
        -1400.39306640625,
        -3123.563720703125,
        724.0
      ],
      [
        -1398.0760498046875,
        -3122.388671875,
        724.0
      ],
      [
        -1388.2457275390625,
        -3117.4443359375,
        630.4634399414062
      ],
      [
        -1233.12890625,
        -3319.2275390625,
        472.50262451171875
      ],
      [
        -1231.2933349609375,
        -3320.0,
        483.1204528808594
      ],
      [
        -1231.2933349609375,
        -3320.0,
        483.1204528808594
      ],
      [
        -1226.1395263671875,
        -3320.0,
        487.03826904296875
      ],
      [
        -1210.5164794921875,
        -3320.0,
        498.9146728515625
      ],
      [
        -1210.5164794921875,
        -3320.0,
        498.9146728515625
      ],
      [
        -1210.31494140625,
        -3320.0,
        501.2149658203125
      ],
      [
        -1341.9053955078125,
        -3320.0,
        724.0
      ],
      [
        -1350.086669921875,
        -3289.716064453125,
        698.0
      ],
      [
        -1340.773193359375,
        -3320.0,
        698.0
      ],
      [
        -1350.1922607421875,
        -3289.72705078125,
        700.5
      ],
      [
        -1340.8819580078125,
        -3320.0,
        700.5
      ],
      [
        -1350.086669921875,
        -3289.716064453125,
        698.0
      ],
      [
        -1350.1922607421875,
        -3289.72705078125,
        700.5
      ],
      [
        -1347.795654296875,
        -3297.51953125,
        700.5
      ],
      [
        -1348.7869873046875,
        -3297.623779296875,
        724.0
      ],
      [
        -1343.9488525390625,
        -3302.142822265625,
        644.8056640625
      ],
      [
        -1344.353271484375,
        -3302.185302734375,
        654.3991088867188
      ],
      [
        -1342.842529296875,
        -3306.55126953125,
        650.5403442382812
      ],
      [
        -1343.041015625,
        -3306.572021484375,
        655.2455444335938
      ],
      [
        -1342.6363525390625,
        -3306.52978515625,
        645.6524658203125
      ],
      [
        -1342.842529296875,
        -3306.55126953125,
        650.5403442382812
      ],
      [
        -1343.041015625,
        -3306.572021484375,
        655.2455444335938
      ],
      [
        -1344.353271484375,
        -3302.185302734375,
        654.3991088867188
      ],
      [
        -1342.6363525390625,
        -3306.52978515625,
        645.6524658203125
      ],
      [
        -1343.9488525390625,
        -3302.142822265625,
        644.8056640625
      ],
      [
        -1191.8505859375,
        -3320.0,
        542.9447021484375
      ],
      [
        -1175.486083984375,
        -3320.0,
        640.3673095703125
      ],
      [
        -1367.9073486328125,
        -3107.087646484375,
        724.0
      ],
      [
        -1209.5694580078125,
        -3320.0,
        509.7249450683594
      ],
      [
        -1191.8505859375,
        -3320.0,
        542.9447021484375
      ],
      [
        -1209.5694580078125,
        -3320.0,
        509.7249450683594
      ],
      [
        -1323.274658203125,
        -3320.0,
        700.5
      ],
      [
        -1323.274658203125,
        -3320.0,
        698.0
      ],
      [
        -1323.274658203125,
        -3320.0,
        700.5
      ],
      [
        -1323.274658203125,
        -3320.0,
        698.0
      ],
      [
        -1336.3236083984375,
        -3305.8662109375,
        651.9998779296875
      ],
      [
        -1336.7939453125,
        -3301.390869140625,
        651.9999389648438
      ],
      [
        -1336.3236083984375,
        -3305.8662109375,
        691.0
      ],
      [
        -1331.3509521484375,
        -3305.343505859375,
        691.0
      ],
      [
        -1331.8214111328125,
        -3300.8681640625,
        691.0
      ],
      [
        -1336.7939453125,
        -3301.390869140625,
        691.0
      ],
      [
        -1339.2802734375,
        -3301.65234375,
        698.0
      ],
      [
        -1338.8099365234375,
        -3306.127685546875,
        698.0
      ],
      [
        -1338.8099365234375,
        -3306.127685546875,
        691.0
      ],
      [
        -1339.2802734375,
        -3301.65234375,
        691.0
      ],
      [
        -1339.2802734375,
        -3301.65234375,
        691.0
      ],
      [
        -1338.8099365234375,
        -3306.127685546875,
        691.0
      ],
      [
        -1332.135009765625,
        -3297.884521484375,
        698.0
      ],
      [
        -1332.135009765625,
        -3297.884521484375,
        691.0
      ],
      [
        -1332.135009765625,
        -3297.884521484375,
        691.0
      ],
      [
        -1328.86474609375,
        -3305.08203125,
        691.0
      ],
      [
        -1328.86474609375,
        -3305.08203125,
        698.0
      ],
      [
        -1328.86474609375,
        -3305.08203125,
        691.0
      ],
      [
        -1325.2857666015625,
        -3320.0,
        724.0
      ],
      [
        -1325.2857666015625,
        -3320.0,
        700.5
      ],
      [
        -1163.808349609375,
        -3320.0,
        715.8345947265625
      ],
      [
        -1175.145263671875,
        -3303.725341796875,
        724.0
      ],
      [
        -1163.061767578125,
        -3320.0,
        724.0
      ],
      [
        -1304.650390625,
        -3468.60302734375,
        616.72265625
      ],
      [
        -1308.97265625,
        -3472.448974609375,
        638.3435668945312
      ],
      [
        -1280.75146484375,
        -3493.8330078125,
        610.4110107421875
      ],
      [
        -1285.0738525390625,
        -3497.6787109375,
        632.0310668945312
      ],
      [
        -1304.650390625,
        -3468.60302734375,
        616.72265625
      ],
      [
        -1296.2344970703125,
        -3474.97998046875,
        608.3931884765625
      ],
      [
        -1283.3319091796875,
        -3490.00048828125,
        608.3931884765625
      ],
      [
        -1280.75146484375,
        -3493.8330078125,
        610.4110107421875
      ],
      [
        -1240.936767578125,
        -3522.816650390625,
        568.1181640625
      ],
      [
        -1240.494384765625,
        -3522.814208984375,
        566.0579833984375
      ],
      [
        -1240.6817626953125,
        -3522.80419921875,
        567.364501953125
      ],
      [
        -1240.936767578125,
        -3522.816650390625,
        568.1181640625
      ],
      [
        -1240.88525390625,
        -3522.972900390625,
        568.3509521484375
      ],
      [
        -1291.38037109375,
        -3374.413818359375,
        504.2046813964844
      ],
      [
        -1319.2325439453125,
        -3429.749267578125,
        621.0050048828125
      ],
      [
        -1350.945556640625,
        -3372.433349609375,
        698.0
      ],
      [
        -1342.3243408203125,
        -3404.533935546875,
        698.0
      ],
      [
        -1342.83984375,
        -3404.587890625,
        700.5
      ],
      [
        -1350.604736328125,
        -3375.675537109375,
        700.5
      ],
      [
        -1342.83984375,
        -3404.587890625,
        700.5
      ],
      [
        -1342.3243408203125,
        -3404.533935546875,
        698.0
      ],
      [
        -1344.94091796875,
        -3396.7646484375,
        700.5
      ],
      [
        -1348.3504638671875,
        -3397.123046875,
        717.0403442382812
      ],
      [
        -1336.3409423828125,
        -3391.3359375,
        653.0486450195312
      ],
      [
        -1334.63330078125,
        -3391.15673828125,
        644.7656860351562
      ],
      [
        -1337.400634765625,
        -3386.922607421875,
        652.4561157226562
      ],
      [
        -1336.3409423828125,
        -3391.3359375,
        653.0486450195312
      ],
      [
        -1335.693115234375,
        -3386.7431640625,
        644.1729736328125
      ],
      [
        -1337.400634765625,
        -3386.922607421875,
        652.4561157226562
      ],
      [
        -1334.63330078125,
        -3391.15673828125,
        644.7656860351562
      ],
      [
        -1335.693115234375,
        -3386.7431640625,
        644.1729736328125
      ],
      [
        -1319.2325439453125,
        -3429.749267578125,
        621.0050048828125
      ],
      [
        -1322.521484375,
        -3419.20751953125,
        633.7772216796875
      ],
      [
        -1339.1156005859375,
        -3404.196533203125,
        700.5
      ],
      [
        -1347.4595947265625,
        -3320.0,
        700.5
      ],
      [
        -1346.7169189453125,
        -3323.0673828125,
        700.5
      ],
      [
        -1339.7030029296875,
        -3364.13720703125,
        700.5
      ],
      [
        -1347.164794921875,
        -3320.0,
        698.0
      ],
      [
        -1338.5029296875,
        -3404.13232421875,
        698.0
      ],
      [
        -1339.05908203125,
        -3366.20166015625,
        698.0
      ],
      [
        -1346.43408203125,
        -3323.017822265625,
        698.0
      ],
      [
        -1339.1156005859375,
        -3404.196533203125,
        700.5
      ],
      [
        -1338.5029296875,
        -3404.13232421875,
        698.0
      ],
      [
        -1330.0411376953125,
        -3386.149169921875,
        649.8560791015625
      ],
      [
        -1331.0679931640625,
        -3386.257080078125,
        658.8236083984375
      ],
      [
        -1330.338623046875,
        -3390.705078125,
        659.0840454101562
      ],
      [
        -1329.3118896484375,
        -3390.597412109375,
        650.1165161132812
      ],
      [
        -1331.0679931640625,
        -3386.257080078125,
        658.8236083984375
      ],
      [
        -1330.338623046875,
        -3390.705078125,
        659.0840454101562
      ],
      [
        -1329.3118896484375,
        -3390.597412109375,
        650.1165161132812
      ],
      [
        -1330.0411376953125,
        -3386.149169921875,
        649.8560791015625
      ],
      [
        -1337.0296630859375,
        -3320.0,
        612.033203125
      ],
      [
        -1339.2333984375,
        -3396.164794921875,
        700.5
      ],
      [
        -1344.9915771484375,
        -3396.77001953125,
        724.0
      ],
      [
        -1346.949462890625,
        -3320.0,
        698.0
      ],
      [
        -1347.24072265625,
        -3320.0,
        700.5
      ],
      [
        -1337.089111328125,
        -3320.0,
        613.3963012695312
      ],
      [
        -1312.7127685546875,
        -3320.0,
        500.58746337890625
      ],
      [
        -1291.38037109375,
        -3374.413818359375,
        504.2046813964844
      ],
      [
        -1322.521484375,
        -3419.20751953125,
        633.7772216796875
      ],
      [
        -1332.4990234375,
        -3380.387939453125,
        672.1159057617188
      ],
      [
        -1344.8831787109375,
        -3320.0,
        698.0
      ],
      [
        -1339.2353515625,
        -3354.178466796875,
        698.0
      ],
      [
        -1345.1156005859375,
        -3320.0,
        700.5
      ],
      [
        -1339.8861083984375,
        -3351.646728515625,
        700.5
      ],
      [
        -1329.534423828125,
        -3386.095947265625,
        650.3655395507812
      ],
      [
        -1330.37109375,
        -3386.183837890625,
        659.5243530273438
      ],
      [
        -1329.658447265625,
        -3390.633544921875,
        659.7679443359375
      ],
      [
        -1328.82177734375,
        -3390.5458984375,
        650.609375
      ],
      [
        -1330.37109375,
        -3386.183837890625,
        659.5243530273438
      ],
      [
        -1329.658447265625,
        -3390.633544921875,
        659.7679443359375
      ],
      [
        -1328.82177734375,
        -3390.5458984375,
        650.609375
      ],
      [
        -1329.534423828125,
        -3386.095947265625,
        650.3655395507812
      ],
      [
        -1337.1494140625,
        -3320.0,
        614.7799072265625
      ],
      [
        -1332.4990234375,
        -3380.387939453125,
        672.1159057617188
      ],
      [
        -1340.3204345703125,
        -3321.824462890625,
        700.4888916015625
      ],
      [
        -1340.3204345703125,
        -3321.824462890625,
        700.4888916015625
      ],
      [
        -1340.7921142578125,
        -3320.55224609375,
        702.3347778320312
      ],
      [
        -1340.9385986328125,
        -3320.0,
        701.7993774414062
      ],
      [
        -1340.7730712890625,
        -3320.0,
        698.0
      ],
      [
        -1339.634521484375,
        -3326.95947265625,
        698.0
      ],
      [
        -1340.2159423828125,
        -3321.811767578125,
        698.0
      ],
      [
        -1340.8819580078125,
        -3320.0,
        700.5
      ],
      [
        -1340.32373046875,
        -3321.79931640625,
        700.5
      ],
      [
        -1340.4205322265625,
        -3320.0,
        698.0
      ],
      [
        -1340.7564697265625,
        -3320.0,
        700.5
      ],
      [
        -1340.43701171875,
        -3320.796142578125,
        700.5
      ],
      [
        -1327.56640625,
        -3385.88916015625,
        652.344482421875
      ],
      [
        -1329.5323486328125,
        -3386.095703125,
        660.36767578125
      ],
      [
        -1329.38623046875,
        -3390.60498046875,
        660.0416870117188
      ],
      [
        -1327.4202880859375,
        -3390.398681640625,
        652.0185546875
      ],
      [
        -1327.4202880859375,
        -3390.398681640625,
        652.0185546875
      ],
      [
        -1327.56640625,
        -3385.88916015625,
        652.344482421875
      ],
      [
        -1329.5323486328125,
        -3386.095703125,
        660.36767578125
      ],
      [
        -1329.38623046875,
        -3390.60498046875,
        660.0416870117188
      ],
      [
        -1339.711181640625,
        -3321.730712890625,
        698.0
      ],
      [
        -1340.40576171875,
        -3320.0,
        698.0
      ],
      [
        -1340.334716796875,
        -3321.051025390625,
        700.5
      ],
      [
        -1267.69873046875,
        -3510.23681640625,
        724.0
      ],
      [
        -1292.409912109375,
        -3484.34423828125,
        724.0
      ],
      [
        -1240.95556640625,
        -3523.00732421875,
        569.8958740234375
      ],
      [
        -1325.396728515625,
        -3452.548583984375,
        724.0
      ],
      [
        -1292.409912109375,
        -3484.34423828125,
        724.0
      ],
      [
        -1279.7242431640625,
        -3491.638427734375,
        663.3931884765625
      ],
      [
        -1278.19384765625,
        -3490.6787109375,
        637.4962768554688
      ],
      [
        -1302.337158203125,
        -3465.75,
        641.2197265625
      ],
      [
        -1303.6473388671875,
        -3466.57177734375,
        663.3931884765625
      ],
      [
        -1303.6473388671875,
        -3466.57177734375,
        663.3931884765625
      ],
      [
        -1279.7242431640625,
        -3491.638427734375,
        663.3931884765625
      ],
      [
        -1302.337158203125,
        -3465.75,
        641.2197265625
      ],
      [
        -1289.040771484375,
        -3477.446533203125,
        618.6305541992188
      ],
      [
        -1278.19384765625,
        -3490.6787109375,
        637.4962768554688
      ],
      [
        -1289.040771484375,
        -3477.446533203125,
        618.6305541992188
      ],
      [
        -1240.85302734375,
        -3522.960693359375,
        568.33935546875
      ],
      [
        -1240.914306640625,
        -3522.884521484375,
        568.2194213867188
      ],
      [
        -1325.396728515625,
        -3452.548583984375,
        724.0
      ],
      [
        -1325.949951171875,
        -3449.20068359375,
        724.0
      ],
      [
        -1240.9207763671875,
        -3522.814697265625,
        568.1181640625
      ],
      [
        -1240.9207763671875,
        -3522.814697265625,
        568.1181640625
      ],
      [
        -1240.880615234375,
        -3522.81396484375,
        567.9523315429688
      ],
      [
        -1329.06494140625,
        -3430.349365234375,
        724.0
      ],
      [
        -1340.5382080078125,
        -3328.757080078125,
        724.0
      ],
      [
        -1340.450439453125,
        -3321.840087890625,
        703.5836181640625
      ],
      [
        -1331.1131591796875,
        -3403.35546875,
        700.5
      ],
      [
        -1340.32373046875,
        -3321.79931640625,
        700.5
      ],
      [
        -1339.634521484375,
        -3326.95947265625,
        698.0
      ],
      [
        -1331.008056640625,
        -3403.344482421875,
        698.0
      ],
      [
        -1331.1131591796875,
        -3403.35546875,
        700.5
      ],
      [
        -1331.008056640625,
        -3403.344482421875,
        698.0
      ],
      [
        -1340.3209228515625,
        -3321.824462890625,
        700.5
      ],
      [
        -1340.3232421875,
        -3321.81689453125,
        700.5
      ],
      [
        -1332.010986328125,
        -3395.40576171875,
        700.5
      ],
      [
        -1332.9993896484375,
        -3395.509765625,
        724.0
      ],
      [
        -1340.450439453125,
        -3321.840087890625,
        703.5836181640625
      ],
      [
        -1329.06494140625,
        -3430.349365234375,
        724.0
      ],
      [
        -1317.072509765625,
        -3379.008544921875,
        700.5
      ],
      [
        -1317.197021484375,
        -3377.82470703125,
        698.0
      ],
      [
        -1317.072509765625,
        -3379.008544921875,
        700.5
      ],
      [
        -1317.197021484375,
        -3377.82470703125,
        698.0
      ],
      [
        -1240.7899169921875,
        -3522.79833984375,
        568.1181640625
      ],
      [
        -1240.7899169921875,
        -3522.79833984375,
        568.1181640625
      ],
      [
        -1240.7646484375,
        -3522.927490234375,
        568.3074951171875
      ],
      [
        -1327.4384765625,
        -3390.400634765625,
        691.0
      ],
      [
        -1322.466064453125,
        -3389.878173828125,
        691.0
      ],
      [
        -1322.9365234375,
        -3385.40234375,
        691.0
      ],
      [
        -1327.908935546875,
        -3385.925048828125,
        691.0
      ],
      [
        -1330.3953857421875,
        -3386.186279296875,
        691.0
      ],
      [
        -1329.9249267578125,
        -3390.661865234375,
        691.0
      ],
      [
        -1320.4500732421875,
        -3385.14111328125,
        691.0
      ],
      [
        -1319.9796142578125,
        -3389.616943359375,
        691.0
      ],
      [
        -1319.9796142578125,
        -3389.616943359375,
        698.0
      ],
      [
        -1320.4500732421875,
        -3385.14111328125,
        698.0
      ],
      [
        -1319.9796142578125,
        -3389.616943359375,
        691.0
      ],
      [
        -1320.4500732421875,
        -3385.14111328125,
        691.0
      ],
      [
        -1318.627685546875,
        -3383.34765625,
        724.0
      ],
      [
        -1319.7972412109375,
        -3372.2197265625,
        700.5
      ],
      [
        -1145.9208984375,
        -3422.269775390625,
        724.0
      ],
      [
        -1137.0072021484375,
        -3453.29931640625,
        724.0
      ],
      [
        -1131.2100830078125,
        -3482.662109375,
        724.0
      ],
      [
        -1137.0072021484375,
        -3453.29931640625,
        724.0
      ],
      [
        -1160.6263427734375,
        -3329.75439453125,
        724.0
      ],
      [
        -1153.3792724609375,
        -3396.30615234375,
        724.0
      ],
      [
        -1153.3792724609375,
        -3396.30615234375,
        724.0
      ],
      [
        -1198.85009765625,
        -3320.0,
        529.8218994140625
      ],
      [
        -1160.6263427734375,
        -3329.75439453125,
        724.0
      ],
      [
        -1161.8470458984375,
        -3321.635986328125,
        724.0
      ],
      [
        -1161.8470458984375,
        -3321.635986328125,
        724.0
      ],
      [
        -1214.751220703125,
        -3320.0,
        495.6954345703125
      ],
      [
        -1196.9259033203125,
        -3408.011474609375,
        278.63458251953125
      ],
      [
        -1232.81396484375,
        -3320.0,
        470.81585693359375
      ],
      [
        -1195.7606201171875,
        -3413.29296875,
        267.0
      ],
      [
        -1196.9259033203125,
        -3408.011474609375,
        278.63458251953125
      ],
      [
        -1289.0367431640625,
        -3320.0,
        485.9448547363281
      ],
      [
        -1298.87109375,
        -3355.306884765625,
        502.93450927734375
      ],
      [
        -1339.7364501953125,
        -3320.0,
        698.0
      ],
      [
        -1339.711181640625,
        -3321.730712890625,
        698.0
      ],
      [
        -1340.996826171875,
        -3320.0,
        703.1358032226562
      ],
      [
        -1340.7921142578125,
        -3320.55224609375,
        702.3347778320312
      ],
      [
        -1340.35009765625,
        -3320.0,
        700.5
      ],
      [
        -1340.334716796875,
        -3321.051025390625,
        700.5
      ],
      [
        -1251.379638671875,
        -3527.336181640625,
        724.0
      ],
      [
        -1251.379638671875,
        -3527.336181640625,
        724.0
      ],
      [
        -1251.0538330078125,
        -3527.603515625,
        724.0
      ],
      [
        -1325.2857666015625,
        -3320.0,
        700.5
      ],
      [
        -1319.7972412109375,
        -3372.2197265625,
        700.5
      ],
      [
        -1325.2857666015625,
        -3320.0,
        698.0
      ],
      [
        -1319.921630859375,
        -3371.036376953125,
        698.0
      ],
      [
        -1341.3077392578125,
        -3321.943359375,
        724.0
      ],
      [
        -1341.3077392578125,
        -3321.943359375,
        724.0
      ],
      [
        -1314.535400390625,
        -3083.3251953125,
        878.1983032226562
      ],
      [
        -1105.0,
        -3286.692138671875,
        878.1983032226562
      ],
      [
        -1146.5478515625,
        -3314.0,
        861.2327880859375
      ],
      [
        -1126.0,
        -3314.0,
        876.88232421875
      ],
      [
        -1126.9766845703125,
        -3314.0,
        878.1983032226562
      ],
      [
        -1141.140625,
        -3314.0,
        878.1983032226562
      ],
      [
        -1126.0,
        -3322.0,
        868.207275390625
      ],
      [
        -1140.92724609375,
        -3322.0,
        860.0
      ],
      [
        -1135.1270751953125,
        -3322.0,
        878.1983032226562
      ],
      [
        -1133.4146728515625,
        -3322.0,
        878.1983032226562
      ],
      [
        -1126.0,
        -3314.0,
        876.88232421875
      ],
      [
        -1126.0,
        -3322.0,
        868.207275390625
      ],
      [
        -1146.0,
        -3315.25146484375,
        860.0
      ],
      [
        -1146.5478515625,
        -3314.0,
        861.2327880859375
      ],
      [
        -1116.1199951171875,
        -3348.679931640625,
        874.9114379882812
      ],
      [
        -1126.0,
        -3322.0,
        876.6976928710938
      ],
      [
        -1133.22900390625,
        -3322.0,
        877.9481811523438
      ],
      [
        -1132.574951171875,
        -3322.0,
        877.8864135742188
      ],
      [
        -1126.0,
        -3314.573486328125,
        876.2603149414062
      ],
      [
        -1126.0,
        -3322.0,
        876.6976928710938
      ],
      [
        -1126.0,
        -3317.8046875,
        876.69775390625
      ],
      [
        -1126.0,
        -3314.170166015625,
        876.69775390625
      ],
      [
        -1133.2774658203125,
        -3322.0,
        878.013427734375
      ],
      [
        -1116.1199951171875,
        -3348.679931640625,
        874.9114379882812
      ],
      [
        -1105.0,
        -3340.057861328125,
        878.1983032226562
      ],
      [
        -1114.98486328125,
        -3348.796142578125,
        878.1983032226562
      ],
      [
        -1126.0,
        -3314.0,
        878.1983032226562
      ],
      [
        -1126.0,
        -3322.0,
        878.1983032226562
      ],
      [
        -1126.0,
        -3322.0,
        878.1983032226562
      ],
      [
        -1126.0,
        -3314.0,
        878.1983032226562
      ],
      [
        -1117.7437744140625,
        -3350.2001953125,
        875.2050170898438
      ],
      [
        -1146.5098876953125,
        -3322.0,
        861.1472778320312
      ],
      [
        -1135.193359375,
        -3322.0,
        877.9904174804688
      ],
      [
        -1148.6920166015625,
        -3314.0,
        866.0571899414062
      ],
      [
        -1141.6875,
        -3314.0,
        876.482421875
      ],
      [
        -1148.6920166015625,
        -3314.0,
        866.0571899414062
      ],
      [
        -1146.5098876953125,
        -3322.0,
        861.1472778320312
      ],
      [
        -1117.7437744140625,
        -3350.2001953125,
        875.2050170898438
      ],
      [
        -1116.0537109375,
        -3349.731689453125,
        878.1983032226562
      ],
      [
        -1134.300048828125,
        -3339.750732421875,
        878.1983032226562
      ],
      [
        -1123.043701171875,
        -3355.161865234375,
        876.1632080078125
      ],
      [
        -1134.300048828125,
        -3339.750732421875,
        878.1983032226562
      ],
      [
        -1123.043701171875,
        -3355.161865234375,
        876.1632080078125
      ],
      [
        -1122.6217041015625,
        -3355.479736328125,
        878.1983032226562
      ],
      [
        -1148.606689453125,
        -3322.0,
        865.864990234375
      ],
      [
        -1147.6640625,
        -3322.0,
        876.1748046875
      ],
      [
        -1147.0052490234375,
        -3322.0,
        878.1983032226562
      ],
      [
        -1147.0052490234375,
        -3314.0,
        878.1983032226562
      ],
      [
        -1147.0052490234375,
        -3322.0,
        878.1983032226562
      ],
      [
        -1147.6640625,
        -3322.0,
        876.1748046875
      ],
      [
        -1150.0,
        -3319.7373046875,
        869.0
      ],
      [
        -1147.0052490234375,
        -3314.0,
        878.1983032226562
      ],
      [
        -1150.0,
        -3319.7373046875,
        869.0
      ],
      [
        -1148.606689453125,
        -3322.0,
        865.864990234375
      ],
      [
        -1363.64990234375,
        -3249.2958984375,
        724.0
      ],
      [
        -1445.0,
        -3200.81640625,
        878.1983032226562
      ],
      [
        -1465.0,
        -3200.816162109375,
        878.1983032226562
      ],
      [
        -1370.0,
        -3410.0,
        878.1983032226562
      ],
      [
        -1370.0,
        -3368.0,
        878.1983032226562
      ],
      [
        -1405.0,
        -3368.0,
        878.1983032226562
      ],
      [
        -1405.0,
        -3410.0,
        878.1983032226562
      ],
      [
        -1405.0,
        -3368.0,
        878.1983032226562
      ],
      [
        -1370.0,
        -3368.0,
        878.1983032226562
      ],
      [
        -1356.0,
        -3323.0,
        878.1983032226562
      ],
      [
        -1356.0,
        -3315.0,
        878.1983032226562
      ],
      [
        -1356.0,
        -3374.0,
        878.1983032226562
      ],
      [
        -1356.0,
        -3366.0,
        878.1983032226562
      ],
      [
        -1347.2169189453125,
        -3374.0,
        860.0
      ],
      [
        -1356.0,
        -3374.0,
        878.1983032226562
      ],
      [
        -1349.2327880859375,
        -3374.0,
        878.1983032226562
      ],
      [
        -1356.0,
        -3366.0,
        878.1983032226562
      ],
      [
        -1347.956298828125,
        -3366.0,
        860.0
      ],
      [
        -1349.97216796875,
        -3366.0,
        878.1983032226562
      ],
      [
        -1347.956298828125,
        -3366.0,
        860.0
      ],
      [
        -1347.2169189453125,
        -3374.0,
        860.0
      ],
      [
        -1351.93017578125,
        -3323.0,
        860.0
      ],
      [
        -1356.0,
        -3323.0,
        878.1983032226562
      ],
      [
        -1353.9461669921875,
        -3323.0,
        878.1983032226562
      ],
      [
        -1356.0,
        -3315.0,
        878.1983032226562
      ],
      [
        -1352.669677734375,
        -3315.0,
        860.0
      ],
      [
        -1354.6854248046875,
        -3315.0,
        878.1983032226562
      ],
      [
        -1352.669677734375,
        -3315.0,
        860.0
      ],
      [
        -1351.93017578125,
        -3323.0,
        860.0
      ],
      [
        -1465.0,
        -3155.0,
        878.1983032226562
      ],
      [
        -1465.0,
        -3150.316162109375,
        878.1983032226562
      ],
      [
        -1465.0,
        -3155.0,
        878.1983032226562
      ],
      [
        -1465.0,
        -3200.816162109375,
        878.1983032226562
      ],
      [
        -1445.0,
        -3155.0,
        878.1983032226562
      ],
      [
        -1445.0,
        -3200.81640625,
        878.1983032226562
      ],
      [
        -1445.0,
        -3155.0,
        878.1983032226562
      ],
      [
        -1440.436767578125,
        -3139.3798828125,
        878.1983032226562
      ],
      [
        -1445.0,
        -3141.41162109375,
        849.9982299804688
      ],
      [
        -1324.8431396484375,
        -3453.082275390625,
        724.0
      ],
      [
        -1333.894287109375,
        -3456.440673828125,
        878.1983032226562
      ],
      [
        -1347.87158203125,
        -3374.0,
        865.9097900390625
      ],
      [
        -1348.5267333984375,
        -3374.0,
        878.1983032226562
      ],
      [
        -1349.9464111328125,
        -3366.0,
        878.1983032226562
      ],
      [
        -1349.922607421875,
        -3366.0,
        877.7510986328125
      ],
      [
        -1333.894287109375,
        -3456.440673828125,
        878.1983032226562
      ],
      [
        -1295.989013671875,
        -3496.095458984375,
        878.1983032226562
      ],
      [
        -1291.3076171875,
        -3500.86328125,
        878.1983032226562
      ],
      [
        -1295.989013671875,
        -3496.095458984375,
        878.1983032226562
      ],
      [
        -1286.1650390625,
        -3499.70263671875,
        798.7042846679688
      ],
      [
        -1351.4095458984375,
        -3315.0,
        860.0
      ],
      [
        -1352.674560546875,
        -3315.0,
        878.1983032226562
      ],
      [
        -1348.7904052734375,
        -3323.0,
        860.0
      ],
      [
        -1350.0330810546875,
        -3323.0,
        878.1983032226562
      ],
      [
        -1349.2763671875,
        -3323.0,
        867.3114624023438
      ],
      [
        -1351.4095458984375,
        -3315.0,
        860.0
      ],
      [
        -1348.7904052734375,
        -3323.0,
        860.0
      ],
      [
        -1348.7904052734375,
        -3322.9326171875,
        860.0
      ],
      [
        -1286.1650390625,
        -3499.70263671875,
        798.7042846679688
      ],
      [
        -1284.170654296875,
        -3495.6044921875,
        750.545166015625
      ],
      [
        -1284.170654296875,
        -3495.6044921875,
        750.545166015625
      ],
      [
        -1282.6756591796875,
        -3494.5439453125,
        724.0
      ],
      [
        -1334.7640380859375,
        -3366.0,
        862.7809448242188
      ],
      [
        -1335.8358154296875,
        -3366.0,
        878.1983032226562
      ],
      [
        -1334.9947509765625,
        -3374.0,
        878.1983032226562
      ],
      [
        -1332.70556640625,
        -3374.0,
        871.167236328125
      ],
      [
        -1332.47998046875,
        -3374.0,
        867.9201049804688
      ],
      [
        -1334.7640380859375,
        -3366.0,
        862.7809448242188
      ],
      [
        -1332.47998046875,
        -3374.0,
        867.9201049804688
      ],
      [
        -1332.70556640625,
        -3374.0,
        871.167236328125
      ],
      [
        -1334.9947509765625,
        -3374.0,
        878.1983032226562
      ],
      [
        -1334.9947509765625,
        -3368.547119140625,
        878.1983032226562
      ],
      [
        -1348.7681884765625,
        -3323.0,
        860.0
      ],
      [
        -1348.7681884765625,
        -3323.0,
        860.0
      ],
      [
        -1399.47509765625,
        -3123.09814453125,
        724.0
      ],
      [
        -1284.0076904296875,
        -3495.48876953125,
        747.6505737304688
      ],
      [
        -1280.76708984375,
        -3496.543701171875,
        724.0
      ],
      [
        -1411.0396728515625,
        -3128.560791015625,
        878.1983032226562
      ],
      [
        -1352.54150390625,
        -3315.0,
        878.1983032226562
      ],
      [
        -1352.54150390625,
        -3315.0,
        876.2842407226562
      ],
      [
        -1134.4197998046875,
        -3417.484375,
        878.1983032226562
      ],
      [
        -1122.068603515625,
        -3480.0439453125,
        878.1983032226562
      ],
      [
        -1137.91455078125,
        -3366.0,
        860.0
      ],
      [
        -1126.0,
        -3366.0,
        876.6976928710938
      ],
      [
        -1134.2296142578125,
        -3366.0,
        878.185546875
      ],
      [
        -1126.0,
        -3374.0,
        876.6976928710938
      ],
      [
        -1135.9693603515625,
        -3374.0,
        860.0
      ],
      [
        -1132.3531494140625,
        -3374.0,
        877.8463134765625
      ],
      [
        -1126.0,
        -3366.0,
        876.6976928710938
      ],
      [
        -1126.0,
        -3374.0,
        876.6976928710938
      ],
      [
        -1135.9693603515625,
        -3374.0,
        860.0
      ],
      [
        -1137.91455078125,
        -3366.0,
        860.0
      ],
      [
        -1126.0,
        -3366.0,
        878.1983032226562
      ],
      [
        -1134.22705078125,
        -3366.0,
        878.1983032226562
      ],
      [
        -1126.0,
        -3366.0,
        878.1983032226562
      ],
      [
        -1126.0,
        -3374.0,
        878.1983032226562
      ],
      [
        -1126.0,
        -3374.0,
        878.1983032226562
      ],
      [
        -1132.2818603515625,
        -3374.0,
        878.1983032226562
      ],
      [
        -1134.3958740234375,
        -3407.154296875,
        878.1983032226562
      ],
      [
        -1136.4671630859375,
        -3374.0,
        860.0
      ],
      [
        -1134.3193359375,
        -3374.0,
        878.1983032226562
      ],
      [
        -1136.4671630859375,
        -3374.0,
        860.0
      ],
      [
        -1136.46240234375,
        -3371.97216796875,
        860.0
      ],
      [
        -1134.4036865234375,
        -3366.0,
        877.32666015625
      ],
      [
        -1134.30078125,
        -3366.0,
        878.1983032226562
      ],
      [
        -1141.1036376953125,
        -3374.0,
        860.0
      ],
      [
        -1139.381591796875,
        -3374.0,
        878.1983032226562
      ],
      [
        -1142.3065185546875,
        -3366.0,
        860.0
      ],
      [
        -1140.5845947265625,
        -3366.0,
        878.1983032226562
      ],
      [
        -1141.1036376953125,
        -3374.0,
        860.0
      ],
      [
        -1142.3065185546875,
        -3366.0,
        860.0
      ],
      [
        -1159.6761474609375,
        -3338.47998046875,
        724.0
      ],
      [
        -1134.4197998046875,
        -3417.484375,
        878.1983032226562
      ],
      [
        -1145.7242431640625,
        -3366.0,
        860.0
      ],
      [
        -1144.5843505859375,
        -3366.0,
        878.1983032226562
      ],
      [
        -1144.144775390625,
        -3374.0,
        860.0
      ],
      [
        -1143.0048828125,
        -3374.0,
        878.1983032226562
      ],
      [
        -1144.144775390625,
        -3374.0,
        860.0
      ],
      [
        -1145.7242431640625,
        -3366.0,
        860.0
      ],
      [
        -1287.793701171875,
        -3504.442138671875,
        878.1983032226562
      ],
      [
        -1367.96533203125,
        -3107.113525390625,
        732.121826171875
      ],
      [
        -1261.143310546875,
        -3531.583984375,
        878.1983032226562
      ],
      [
        -1392.043212890625,
        -3119.3125,
        878.1983032226562
      ],
      [
        -1369.9161376953125,
        -3107.982177734375,
        878.1983032226562
      ],
      [
        -1411.0396728515625,
        -3128.560791015625,
        878.1983032226562
      ],
      [
        -1392.043212890625,
        -3119.3125,
        878.1983032226562
      ],
      [
        -1261.143310546875,
        -3531.583984375,
        878.1983032226562
      ],
      [
        -1260.6123046875,
        -3531.997802734375,
        878.1983032226562
      ],
      [
        -1334.9947509765625,
        -3315.0,
        878.1983032226562
      ],
      [
        -1334.9947509765625,
        -3323.0,
        878.1983032226562
      ],
      [
        -1334.9947509765625,
        -3323.0,
        878.1983032226562
      ],
      [
        -1334.9947509765625,
        -3315.0,
        878.1983032226562
      ],
      [
        -1147.0052490234375,
        -3374.0,
        878.1983032226562
      ],
      [
        -1147.0052490234375,
        -3366.0,
        878.1983032226562
      ],
      [
        -1334.9947509765625,
        -3366.0,
        878.1983032226562
      ],
      [
        -1147.0052490234375,
        -3366.0,
        878.1983032226562
      ],
      [
        -1147.0052490234375,
        -3374.0,
        878.1983032226562
      ],
      [
        -1334.9947509765625,
        -3366.0,
        878.1983032226562
      ],
      [
        -1462.1907958984375,
        -3446.39501953125,
        1302.5999755859375
      ],
      [
        -1520.6458740234375,
        -3432.515380859375,
        1302.5999755859375
      ],
      [
        -1462.1907958984375,
        -3446.39501953125,
        1302.5999755859375
      ],
      [
        -1595.0,
        -3426.5,
        892.0
      ],
      [
        -1455.3385009765625,
        -3426.5,
        892.0
      ],
      [
        -1460.4158935546875,
        -3426.5,
        915.0
      ],
      [
        -1595.0,
        -3426.5,
        915.0
      ],
      [
        -1595.0,
        -3411.5,
        892.0
      ],
      [
        -1518.510986328125,
        -3411.5,
        892.0
      ],
      [
        -1455.3385009765625,
        -3426.5,
        892.0
      ],
      [
        -1595.0,
        -3426.5,
        892.0
      ],
      [
        -1595.0,
        -3419.54296875,
        1040.4466552734375
      ],
      [
        -1595.0,
        -3405.03955078125,
        1115.2313232421875
      ],
      [
        -1595.0,
        -3419.54296875,
        1040.4466552734375
      ],
      [
        -1595.0,
        -3398.449462890625,
        989.502685546875
      ],
      [
        -1334.2330322265625,
        -3454.531982421875,
        878.1983032226562
      ],
      [
        -1542.2252197265625,
        -3389.01025390625,
        1192.60498046875
      ],
      [
        -1520.6458740234375,
        -3432.515380859375,
        1302.5999755859375
      ],
      [
        -1534.71923828125,
        -3409.7333984375,
        1302.5999755859375
      ],
      [
        -1542.2252197265625,
        -3389.01025390625,
        1192.60498046875
      ],
      [
        -1576.020751953125,
        -3379.77587890625,
        1243.6004638671875
      ],
      [
        -1595.0,
        -3388.281494140625,
        1201.640625
      ],
      [
        -1595.0,
        -3388.281494140625,
        1201.640625
      ],
      [
        -1576.020751953125,
        -3379.77587890625,
        1243.6004638671875
      ],
      [
        -1595.0,
        -3375.162109375,
        1275.9561767578125
      ],
      [
        -1595.0,
        -3394.36962890625,
        979.6495971679688
      ],
      [
        -1595.0,
        -3368.02783203125,
        912.5338745117188
      ],
      [
        -1542.261474609375,
        -3366.172119140625,
        900.3103637695312
      ],
      [
        -1595.0,
        -3394.36962890625,
        979.6495971679688
      ],
      [
        -1513.8604736328125,
        -3411.5,
        892.0
      ],
      [
        -1513.0611572265625,
        -3412.7939453125,
        892.0
      ],
      [
        -1542.261474609375,
        -3366.172119140625,
        900.3103637695312
      ],
      [
        -1595.0,
        -3368.02783203125,
        912.5338745117188
      ],
      [
        -1595.0,
        -3362.948486328125,
        912.6388549804688
      ],
      [
        -1544.2786865234375,
        -3362.948486328125,
        900.8460083007812
      ],
      [
        -1483.8258056640625,
        -3376.197021484375,
        917.5480346679688
      ],
      [
        -1498.367919921875,
        -3364.627685546875,
        890.1369018554688
      ],
      [
        -1483.8258056640625,
        -3376.197021484375,
        917.5480346679688
      ],
      [
        -1335.944091796875,
        -3444.89208984375,
        878.1983032226562
      ],
      [
        -1380.0,
        -3424.746826171875,
        892.0
      ],
      [
        -1394.5,
        -3417.417724609375,
        892.0
      ],
      [
        -1406.20703125,
        -3411.5,
        892.0
      ],
      [
        -1394.5,
        -3417.417724609375,
        892.0
      ],
      [
        -1405.0,
        -3410.0,
        878.289794921875
      ],
      [
        -1405.0,
        -3409.98583984375,
        878.1983032226562
      ],
      [
        -1380.0,
        -3426.5,
        903.3905639648438
      ],
      [
        -1383.534912109375,
        -3426.5,
        915.0
      ],
      [
        -1380.0,
        -3424.746826171875,
        892.0
      ],
      [
        -1380.0,
        -3426.5,
        903.3905639648438
      ],
      [
        -1498.367919921875,
        -3364.627685546875,
        890.1369018554688
      ],
      [
        -1501.9542236328125,
        -3362.948486328125,
        891.0054321289062
      ],
      [
        -1131.1561279296875,
        -3362.948486328125,
        878.1983032226562
      ],
      [
        -1105.0,
        -3362.948486328125,
        946.0004272460938
      ],
      [
        -1110.0399169921875,
        -3476.598876953125,
        1081.098388671875
      ],
      [
        -1130.6844482421875,
        -3436.404052734375,
        878.1983032226562
      ],
      [
        -1130.744384765625,
        -3374.0,
        912.0
      ],
      [
        -1133.8756103515625,
        -3374.0,
        878.1983032226562
      ],
      [
        -1130.78955078125,
        -3374.0,
        911.8829956054688
      ],
      [
        -1126.0,
        -3369.847900390625,
        912.0
      ],
      [
        -1126.0,
        -3366.0,
        900.6027221679688
      ],
      [
        -1134.17333984375,
        -3366.0,
        879.4154052734375
      ],
      [
        -1134.2847900390625,
        -3366.0,
        878.1983032226562
      ],
      [
        -1126.0,
        -3366.0,
        900.6027221679688
      ],
      [
        -1130.744384765625,
        -3374.0,
        912.0
      ],
      [
        -1126.0,
        -3369.847900390625,
        912.0
      ],
      [
        -1131.1878662109375,
        -3366.0,
        912.0
      ],
      [
        -1130.77880859375,
        -3374.0,
        912.0
      ],
      [
        -1131.1878662109375,
        -3366.0,
        912.0
      ],
      [
        -1130.77880859375,
        -3374.0,
        912.0
      ],
      [
        -1132.3359375,
        -3374.0,
        895.0037231445312
      ],
      [
        -1134.3193359375,
        -3374.0,
        878.1983032226562
      ],
      [
        -1134.30078125,
        -3366.0,
        878.1983032226562
      ],
      [
        -1134.2293701171875,
        -3366.0,
        878.8035888671875
      ],
      [
        -1342.1177978515625,
        -3410.108642578125,
        878.1983032226562
      ],
      [
        -1370.0,
        -3407.306640625,
        894.0
      ],
      [
        -1373.0,
        -3406.188720703125,
        894.0
      ],
      [
        -1405.0,
        -3394.263671875,
        894.0
      ],
      [
        -1401.5,
        -3395.56787109375,
        894.0
      ],
      [
        -1375.0,
        -3405.443359375,
        894.0
      ],
      [
        -1399.5,
        -3396.313232421875,
        894.0
      ],
      [
        -1405.0,
        -3394.263671875,
        894.0
      ],
      [
        -1405.0,
        -3386.67529296875,
        878.1983032226562
      ],
      [
        -1370.0,
        -3407.306640625,
        894.0
      ],
      [
        -1370.0,
        -3399.71826171875,
        878.1983032226562
      ],
      [
        -1405.0,
        -3411.5,
        892.0
      ],
      [
        -1405.0,
        -3412.110107421875,
        892.0
      ],
      [
        -1380.0,
        -3411.5,
        894.0
      ],
      [
        -1380.0,
        -3425.0546875,
        894.0
      ],
      [
        -1401.5,
        -3395.56787109375,
        894.0
      ],
      [
        -1401.5,
        -3405.65234375,
        915.0
      ],
      [
        -1399.5,
        -3406.397705078125,
        915.0
      ],
      [
        -1399.5,
        -3396.313232421875,
        894.0
      ],
      [
        -1401.5,
        -3405.65234375,
        915.0
      ],
      [
        -1399.5,
        -3407.238037109375,
        916.75
      ],
      [
        -1399.5,
        -3410.0,
        916.75
      ],
      [
        -1375.0,
        -3410.0,
        903.4888916015625
      ],
      [
        -1381.4814453125,
        -3410.0,
        908.5185546875
      ],
      [
        -1381.4814453125,
        -3410.0,
        908.5185546875
      ],
      [
        -1389.833740234375,
        -3410.0,
        915.0
      ],
      [
        -1389.833740234375,
        -3410.0,
        915.0
      ],
      [
        -1392.410888671875,
        -3410.0,
        917.0
      ],
      [
        -1380.0,
        -3411.5,
        910.4931640625
      ],
      [
        -1380.0,
        -3413.664306640625,
        915.0
      ],
      [
        -1382.0,
        -3426.5,
        915.0
      ],
      [
        -1382.0,
        -3426.5,
        909.958984375
      ],
      [
        -1375.0,
        -3405.443359375,
        894.0
      ],
      [
        -1375.0,
        -3410.0,
        903.4888916015625
      ],
      [
        -1373.0,
        -3410.0,
        901.9366455078125
      ],
      [
        -1373.0,
        -3406.188720703125,
        894.0
      ],
      [
        -1396.5,
        -3403.674072265625,
        907.0
      ],
      [
        -1399.5,
        -3403.516357421875,
        909.0
      ],
      [
        -1396.5,
        -3397.725341796875,
        894.6127319335938
      ],
      [
        -1396.5,
        -3398.5,
        896.2255859375
      ],
      [
        -1396.5,
        -3397.725341796875,
        894.6127319335938
      ],
      [
        -1396.5,
        -3397.43115234375,
        894.0
      ],
      [
        -1396.5,
        -3402.713623046875,
        905.0
      ],
      [
        -1396.5,
        -3403.674072265625,
        907.0
      ],
      [
        -1399.5,
        -3396.5,
        894.3890991210938
      ],
      [
        -1398.99853515625,
        -3396.5,
        894.0
      ],
      [
        -1396.5,
        -3402.71337890625,
        905.0
      ],
      [
        -1399.0,
        -3401.78173828125,
        905.0
      ],
      [
        -1397.5,
        -3408.82373046875,
        918.5
      ],
      [
        -1397.5,
        -3408.103515625,
        917.0
      ],
      [
        -1392.410888671875,
        -3410.0,
        917.0
      ],
      [
        -1394.3436279296875,
        -3410.0,
        918.5
      ],
      [
        -1397.5,
        -3408.82373046875,
        918.5
      ],
      [
        -1399.5,
        -3406.397705078125,
        915.0
      ],
      [
        -1397.5,
        -3408.103515625,
        917.0
      ],
      [
        -1477.9952392578125,
        -3362.948486328125,
        885.4348754882812
      ],
      [
        -1405.0,
        -3368.0,
        884.3970947265625
      ],
      [
        -1370.0,
        -3368.0,
        882.0145263671875
      ],
      [
        -1370.0,
        -3379.22998046875,
        894.0
      ],
      [
        -1370.0,
        -3368.0,
        882.0145263671875
      ],
      [
        -1370.0,
        -3379.22998046875,
        894.0
      ],
      [
        -1373.0,
        -3379.038818359375,
        894.0
      ],
      [
        -1405.0,
        -3376.99755859375,
        894.0
      ],
      [
        -1401.5,
        -3377.220947265625,
        894.0
      ],
      [
        -1375.0,
        -3378.9111328125,
        894.0
      ],
      [
        -1399.5,
        -3377.348388671875,
        894.0
      ],
      [
        -1405.0,
        -3368.0,
        884.3970947265625
      ],
      [
        -1405.0,
        -3376.99755859375,
        894.0
      ],
      [
        -1373.0,
        -3398.715087890625,
        915.0
      ],
      [
        -1373.0,
        -3379.038818359375,
        894.0
      ],
      [
        -1375.0,
        -3378.9111328125,
        894.0
      ],
      [
        -1375.0,
        -3398.58740234375,
        915.0
      ],
      [
        -1373.0,
        -3398.715087890625,
        915.0
      ],
      [
        -1375.0,
        -3410.0,
        916.75
      ],
      [
        -1375.0,
        -3400.22705078125,
        916.75
      ],
      [
        -1401.5,
        -3377.220947265625,
        894.0
      ],
      [
        -1401.5,
        -3396.897216796875,
        915.0
      ],
      [
        -1399.5,
        -3397.0244140625,
        915.0
      ],
      [
        -1399.5,
        -3377.348388671875,
        894.0
      ],
      [
        -1401.5,
        -3396.897216796875,
        915.0
      ],
      [
        -1399.5,
        -3398.66455078125,
        916.75
      ],
      [
        -1399.5,
        -3407.238037109375,
        916.75
      ],
      [
        -1397.5,
        -3400.431640625,
        918.5
      ],
      [
        -1377.0,
        -3401.7392578125,
        918.5
      ],
      [
        -1377.0,
        -3400.333740234375,
        917.0
      ],
      [
        -1397.5,
        -3399.026123046875,
        917.0
      ],
      [
        -1375.2857666015625,
        -3410.0,
        917.0
      ],
      [
        -1377.0,
        -3401.7392578125,
        918.5
      ],
      [
        -1375.2857666015625,
        -3400.443115234375,
        917.0
      ],
      [
        -1399.2142333984375,
        -3398.9169921875,
        917.0
      ],
      [
        -1397.5,
        -3400.431640625,
        918.5
      ],
      [
        -1399.2142333984375,
        -3407.464599609375,
        917.0
      ],
      [
        -1375.0,
        -3401.5,
        915.0
      ],
      [
        -1377.0,
        -3401.5,
        917.0
      ],
      [
        -1375.2857666015625,
        -3401.5,
        917.0
      ],
      [
        -1375.0,
        -3401.5,
        916.75
      ],
      [
        -1399.5,
        -3401.5,
        915.0
      ],
      [
        -1397.5,
        -3401.5,
        917.0
      ],
      [
        -1399.2142333984375,
        -3401.5,
        917.0
      ],
      [
        -1399.5,
        -3401.5,
        916.75
      ],
      [
        -1399.5,
        -3397.0244140625,
        915.0
      ],
      [
        -1397.5,
        -3399.026123046875,
        917.0
      ],
      [
        -1375.0,
        -3398.58740234375,
        915.0
      ],
      [
        -1377.0,
        -3400.333740234375,
        917.0
      ],
      [
        -1376.0,
        -3388.685546875,
        904.5
      ],
      [
        -1379.0,
        -3398.332275390625,
        915.0
      ],
      [
        -1376.0,
        -3388.685546875,
        904.5
      ],
      [
        -1375.0,
        -3388.749267578125,
        904.5
      ],
      [
        -1379.0,
        -3385.0,
        897.25
      ],
      [
        -1348.526611328125,
        -3374.0,
        878.1983032226562
      ],
      [
        -1356.0,
        -3374.0,
        887.4649658203125
      ],
      [
        -1348.9952392578125,
        -3374.0,
        886.9880981445312
      ],
      [
        -1356.0,
        -3374.0,
        887.4649658203125
      ],
      [
        -1356.0,
        -3368.0,
        878.1983032226562
      ],
      [
        -1356.0,
        -3368.0,
        881.0613403320312
      ],
      [
        -1356.0,
        -3366.0,
        878.9268188476562
      ],
      [
        -1349.9466552734375,
        -3366.0,
        878.1983032226562
      ],
      [
        -1349.9635009765625,
        -3366.0,
        878.515869140625
      ],
      [
        -1356.0,
        -3366.0,
        878.9268188476562
      ],
      [
        -1337.6041259765625,
        -3374.0,
        886.212646484375
      ],
      [
        -1337.6041259765625,
        -3374.0,
        886.212646484375
      ],
      [
        -1334.9947509765625,
        -3366.6572265625,
        878.1983032226562
      ],
      [
        -1345.2991943359375,
        -3366.0,
        878.1983032226562
      ],
      [
        -1474.6434326171875,
        -3362.948486328125,
        884.6555786132812
      ],
      [
        -1357.415283203125,
        -3362.948486328125,
        878.5943603515625
      ],
      [
        -1350.0,
        -3362.948486328125,
        878.1983032226562
      ],
      [
        -1357.415283203125,
        -3362.948486328125,
        878.5943603515625
      ],
      [
        -1554.104736328125,
        -3378.35205078125,
        1302.5999755859375
      ],
      [
        -1595.0,
        -3370.693603515625,
        1301.2681884765625
      ],
      [
        -1595.0,
        -3370.693603515625,
        1301.2681884765625
      ],
      [
        -1595.0,
        -3368.8896484375,
        1301.6318359375
      ],
      [
        -1562.950927734375,
        -3362.948486328125,
        1288.6993408203125
      ],
      [
        -1594.4798583984375,
        -3362.948486328125,
        1302.5999755859375
      ],
      [
        -1595.0,
        -3364.086181640625,
        1302.5999755859375
      ],
      [
        -1346.0,
        -3368.0,
        912.0
      ],
      [
        -1335.471923828125,
        -3368.0,
        879.6638793945312
      ],
      [
        -1340.1395263671875,
        -3374.0,
        894.0
      ],
      [
        -1356.0,
        -3374.0,
        894.0
      ],
      [
        -1356.0,
        -3374.0,
        894.0
      ],
      [
        -1356.0,
        -3368.0,
        881.0613403320312
      ],
      [
        -1356.0,
        -3368.0,
        894.0
      ],
      [
        -1375.2857666015625,
        -3400.443115234375,
        917.0
      ],
      [
        -1375.2857666015625,
        -3374.5,
        917.0
      ],
      [
        -1399.2142333984375,
        -3374.5,
        917.0
      ],
      [
        -1399.2142333984375,
        -3398.9169921875,
        917.0
      ],
      [
        -1375.2857666015625,
        -3374.5,
        917.0
      ],
      [
        -1399.2142333984375,
        -3374.5,
        917.0
      ],
      [
        -1375.0,
        -3400.22705078125,
        916.7499389648438
      ],
      [
        -1375.0,
        -3374.5,
        916.7499389648438
      ],
      [
        -1399.5,
        -3374.5,
        916.7499389648438
      ],
      [
        -1399.5,
        -3398.66455078125,
        916.7499389648438
      ],
      [
        -1356.0,
        -3368.0,
        912.0
      ],
      [
        -1356.0,
        -3368.0,
        912.0
      ],
      [
        -1346.0,
        -3368.0,
        912.0
      ],
      [
        -1555.170654296875,
        -3373.374755859375,
        1302.5999755859375
      ],
      [
        -1556.3189697265625,
        -3366.0,
        1302.5999755859375
      ],
      [
        -1556.447998046875,
        -3366.0,
        1301.4490966796875
      ],
      [
        -1556.447998046875,
        -3366.0,
        1301.4490966796875
      ],
      [
        -1558.5130615234375,
        -3366.0,
        1287.1690673828125
      ],
      [
        -1560.65283203125,
        -3366.0,
        1287.071044921875
      ],
      [
        -1560.9947509765625,
        -3366.0,
        1287.2218017578125
      ],
      [
        -1558.5130615234375,
        -3366.0,
        1287.1690673828125
      ],
      [
        -1560.65283203125,
        -3366.0,
        1287.071044921875
      ],
      [
        -1555.170654296875,
        -3373.374755859375,
        1302.5999755859375
      ],
      [
        -1554.104736328125,
        -3378.35205078125,
        1302.5999755859375
      ],
      [
        -1556.3770751953125,
        -3365.626953125,
        1302.5999755859375
      ],
      [
        -1557.062744140625,
        -3362.948486328125,
        1302.5999755859375
      ],
      [
        -1559.0848388671875,
        -3362.948486328125,
        1288.6171875
      ],
      [
        -1559.0848388671875,
        -3362.948486328125,
        1288.6171875
      ],
      [
        -1562.4183349609375,
        -3362.948486328125,
        1288.4644775390625
      ],
      [
        -1562.4183349609375,
        -3362.948486328125,
        1288.4644775390625
      ],
      [
        -1556.3770751953125,
        -3365.626953125,
        1302.5999755859375
      ],
      [
        -1474.6434326171875,
        -3362.948486328125,
        884.6555786132812
      ],
      [
        -1440.436767578125,
        -3139.3798828125,
        915.8756103515625
      ],
      [
        -1465.0,
        -3150.316162109375,
        918.0631713867188
      ],
      [
        -1356.0,
        -3323.0,
        878.4849853515625
      ],
      [
        -1356.0,
        -3315.0,
        898.5742797851562
      ],
      [
        -1356.0,
        -3316.65380859375,
        895.3721923828125
      ],
      [
        -1356.0,
        -3315.0,
        898.5742797851562
      ],
      [
        -1352.5413818359375,
        -3315.0,
        878.1983032226562
      ],
      [
        -1352.5413818359375,
        -3315.0,
        895.8692626953125
      ],
      [
        -1350.031494140625,
        -3323.0,
        878.1983032226562
      ],
      [
        -1356.0,
        -3323.0,
        878.4849853515625
      ],
      [
        -1350.0911865234375,
        -3323.0,
        878.4635009765625
      ],
      [
        -1350.031494140625,
        -3323.0,
        878.4168090820312
      ],
      [
        -1595.0,
        -3252.21533203125,
        1102.025146484375
      ],
      [
        -1595.0,
        -3325.190185546875,
        911.740966796875
      ],
      [
        -1595.0,
        -3252.21533203125,
        1102.025146484375
      ],
      [
        -1595.0,
        -3351.9326171875,
        912.8665771484375
      ],
      [
        -1595.0,
        -3325.190185546875,
        911.740966796875
      ],
      [
        -1595.0,
        -3351.9326171875,
        912.8665771484375
      ],
      [
        -1406.996826171875,
        -3344.551025390625,
        881.2424926757812
      ],
      [
        -1406.996826171875,
        -3344.551025390625,
        881.2424926757812
      ],
      [
        -1455.6510009765625,
        -3362.948486328125,
        883.673583984375
      ],
      [
        -1356.0,
        -3323.0,
        878.5187377929688
      ],
      [
        -1355.3221435546875,
        -3323.0,
        878.4825439453125
      ],
      [
        -1356.0,
        -3323.0,
        878.5187377929688
      ],
      [
        -1356.0,
        -3322.9873046875,
        878.5187377929688
      ],
      [
        -1356.0,
        -3323.0,
        883.0848388671875
      ],
      [
        -1356.0,
        -3323.0,
        883.0848388671875
      ],
      [
        -1184.539306640625,
        -3256.2646484375,
        878.1983032226562
      ],
      [
        -1203.061767578125,
        -3084.35595703125,
        1225.5303955078125
      ],
      [
        -1336.7191162109375,
        -3315.0,
        883.4946899414062
      ],
      [
        -1336.7191162109375,
        -3315.0,
        883.4946899414062
      ],
      [
        -1334.9947509765625,
        -3317.038818359375,
        878.1983032226562
      ],
      [
        -1349.7520751953125,
        -3323.0,
        878.1983032226562
      ],
      [
        -1136.8853759765625,
        -3314.0,
        891.550048828125
      ],
      [
        -1141.140625,
        -3314.0,
        878.1983032226562
      ],
      [
        -1126.9766845703125,
        -3314.0,
        878.1983032226562
      ],
      [
        -1133.4146728515625,
        -3322.0,
        878.1983032226562
      ],
      [
        -1135.1270751953125,
        -3322.0,
        878.1983032226562
      ],
      [
        -1134.6126708984375,
        -3322.0,
        879.8125
      ],
      [
        -1126.0,
        -3319.810546875,
        912.0
      ],
      [
        -1126.0,
        -3322.0,
        906.8358154296875
      ],
      [
        -1130.3677978515625,
        -3314.0,
        912.0
      ],
      [
        -1126.0,
        -3322.0,
        906.8358154296875
      ],
      [
        -1130.3677978515625,
        -3314.0,
        912.0
      ],
      [
        -1126.0,
        -3319.810546875,
        912.0
      ],
      [
        -1114.98486328125,
        -3348.796142578125,
        878.1983032226562
      ],
      [
        -1105.0,
        -3349.819580078125,
        907.11279296875
      ],
      [
        -1346.2037353515625,
        -3323.0,
        878.1983032226562
      ],
      [
        -1350.0032958984375,
        -3323.0,
        878.394775390625
      ],
      [
        -1580.328125,
        -3331.9921875,
        1302.5999755859375
      ],
      [
        -1564.6063232421875,
        -3333.48291015625,
        1302.5999755859375
      ],
      [
        -1580.328125,
        -3331.9921875,
        1302.5999755859375
      ],
      [
        -1564.6063232421875,
        -3333.48291015625,
        1302.5999755859375
      ],
      [
        -1650.8538818359375,
        -3434.6806640625,
        1302.5999755859375
      ],
      [
        -1634.891845703125,
        -3372.7666015625,
        1302.5999755859375
      ],
      [
        -1597.9923095703125,
        -3370.631591796875,
        1302.5999755859375
      ],
      [
        -1634.891845703125,
        -3372.7666015625,
        1302.5999755859375
      ],
      [
        -1595.0,
        -3417.57666015625,
        1035.6976318359375
      ],
      [
        -1660.675537109375,
        -3373.532470703125,
        935.89306640625
      ],
      [
        -1660.675537109375,
        -3373.532470703125,
        935.89306640625
      ],
      [
        -1660.4217529296875,
        -3370.329833984375,
        927.6970825195312
      ],
      [
        -1595.0,
        -3366.591796875,
        912.5635375976562
      ],
      [
        -1660.4217529296875,
        -3370.329833984375,
        927.6970825195312
      ],
      [
        -1660.3753662109375,
        -3370.148193359375,
        927.6900634765625
      ],
      [
        -1659.8751220703125,
        -3368.18701171875,
        927.6143188476562
      ],
      [
        -1638.9671630859375,
        -3362.948486328125,
        922.8613891601562
      ],
      [
        -1595.0,
        -3362.948486328125,
        912.6388549804688
      ],
      [
        -1658.5599365234375,
        -3362.948486328125,
        927.1087036132812
      ],
      [
        -1638.9671630859375,
        -3362.948486328125,
        922.8613891601562
      ],
      [
        -1659.8751220703125,
        -3368.18701171875,
        927.6143188476562
      ],
      [
        -1597.9923095703125,
        -3370.631591796875,
        1302.5999755859375
      ],
      [
        -1760.0,
        -3455.78955078125,
        1064.9735107421875
      ],
      [
        -1650.8538818359375,
        -3434.6806640625,
        1302.5999755859375
      ],
      [
        -1739.9085693359375,
        -3467.27099609375,
        1302.5999755859375
      ],
      [
        -1760.0,
        -3471.65673828125,
        1265.1668701171875
      ],
      [
        -1760.0,
        -3471.65673828125,
        1265.1668701171875
      ],
      [
        -1739.9085693359375,
        -3467.27099609375,
        1302.5999755859375
      ],
      [
        -1760.0,
        -3491.47998046875,
        1302.5999755859375
      ],
      [
        -1760.0,
        -3412.328125,
        1019.3680419921875
      ],
      [
        -1760.0,
        -3383.83349609375,
        951.1689453125
      ],
      [
        -1760.0,
        -3455.78955078125,
        1064.9735107421875
      ],
      [
        -1760.0,
        -3412.328125,
        1019.3680419921875
      ],
      [
        -1660.37548828125,
        -3370.148193359375,
        927.6900634765625
      ],
      [
        -1660.1552734375,
        -3369.285400390625,
        927.65673828125
      ],
      [
        -1671.2335205078125,
        -3362.948486328125,
        929.8560791015625
      ],
      [
        -1760.0,
        -3383.83349609375,
        951.1689453125
      ],
      [
        -1760.0,
        -3362.948486328125,
        950.2378540039062
      ],
      [
        -1671.2335205078125,
        -3362.948486328125,
        929.8560791015625
      ],
      [
        -1760.0,
        -3340.234130859375,
        948.6456909179688
      ],
      [
        -1760.0,
        -3244.978515625,
        1192.2745361328125
      ],
      [
        -1595.0,
        -3326.0556640625,
        911.7774047851562
      ],
      [
        -1760.0,
        -3203.987060546875,
        1302.5999755859375
      ],
      [
        -1760.0,
        -3244.978515625,
        1192.2745361328125
      ],
      [
        -1760.0,
        -3357.116455078125,
        949.9778442382812
      ],
      [
        -1760.0,
        -3340.234130859375,
        948.6456909179688
      ],
      [
        -1760.0,
        -3357.116455078125,
        949.9778442382812
      ],
      [
        -1093.373046875,
        -4309.1923828125,
        155.50106811523438
      ],
      [
        -1081.6805419921875,
        -4311.3466796875,
        267.0
      ],
      [
        -1093.373046875,
        -4309.1923828125,
        155.5010528564453
      ],
      [
        -1165.8682861328125,
        -4276.1318359375,
        267.0
      ],
      [
        -1114.1038818359375,
        -4171.7958984375,
        39.380271911621094
      ],
      [
        -1114.1038818359375,
        -4171.7958984375,
        39.380271911621094
      ],
      [
        -1109.2020263671875,
        -4162.927734375,
        22.76639175415039
      ],
      [
        -1102.48486328125,
        -4150.77587890625,
        0.0
      ],
      [
        -1159.0166015625,
        -4244.61376953125,
        267.0
      ],
      [
        -1118.4781494140625,
        -4159.87744140625,
        93.89517974853516
      ],
      [
        -1090.2904052734375,
        -4108.06298828125,
        0.0
      ],
      [
        -1118.4781494140625,
        -4159.87744140625,
        93.89518737792969
      ],
      [
        -1144.364501953125,
        -4213.98681640625,
        204.43331909179688
      ],
      [
        -1092.7037353515625,
        -3924.0,
        462.91717529296875
      ],
      [
        -1082.5556640625,
        -3857.140380859375,
        615.8033447265625
      ],
      [
        -1064.787353515625,
        -3924.0,
        267.0
      ],
      [
        -1071.756103515625,
        -3718.8271484375,
        627.1876831054688
      ],
      [
        -1070.221923828125,
        -3722.0146484375,
        626.797607421875
      ],
      [
        -1099.3856201171875,
        -3661.427734375,
        634.2156982421875
      ],
      [
        -1071.756103515625,
        -3718.8271484375,
        627.1876831054688
      ],
      [
        -1102.8795166015625,
        -3654.169189453125,
        635.10400390625
      ],
      [
        -1099.3856201171875,
        -3661.427734375,
        634.2156982421875
      ],
      [
        -1067.032958984375,
        -3742.721435546875,
        628.290771484375
      ],
      [
        -1068.0098876953125,
        -3748.1083984375,
        629.7718505859375
      ],
      [
        -1068.0098876953125,
        -3748.1083984375,
        629.7718505859375
      ],
      [
        -1077.490234375,
        -3800.383056640625,
        644.1446533203125
      ],
      [
        -1069.257080078125,
        -3730.187255859375,
        654.3456420898438
      ],
      [
        -1069.2579345703125,
        -3732.5166015625,
        659.746337890625
      ],
      [
        -1069.0823974609375,
        -3731.666748046875,
        659.332763671875
      ],
      [
        -1069.257080078125,
        -3730.187255859375,
        654.3456420898438
      ],
      [
        -1070.221923828125,
        -3722.0146484375,
        626.797607421875
      ],
      [
        -1120.069580078125,
        -3916.04296875,
        634.3931884765625
      ],
      [
        -1118.85009765625,
        -3916.062255859375,
        660.0
      ],
      [
        -1117.336669921875,
        -3916.613037109375,
        660.0
      ],
      [
        -1069.2579345703125,
        -3732.5166015625,
        659.746337890625
      ],
      [
        -1068.8636474609375,
        -3734.324951171875,
        654.171875
      ],
      [
        -1067.032958984375,
        -3742.721435546875,
        628.290771484375
      ],
      [
        -1068.8636474609375,
        -3734.324951171875,
        654.171875
      ],
      [
        -1114.3341064453125,
        -3918.13037109375,
        634.3931884765625
      ],
      [
        -1117.2698974609375,
        -3916.637451171875,
        660.0
      ],
      [
        -1100.6282958984375,
        -3886.067626953125,
        645.6766357421875
      ],
      [
        -1102.2703857421875,
        -3885.232421875,
        660.0
      ],
      [
        -1107.002197265625,
        -3883.51025390625,
        660.0
      ],
      [
        -1100.6282958984375,
        -3886.067626953125,
        645.6766357421875
      ],
      [
        -1103.1268310546875,
        -3894.6650390625,
        634.3931884765625
      ],
      [
        -1102.8795166015625,
        -3654.169189453125,
        635.10400390625
      ],
      [
        -1104.732666015625,
        -3650.0,
        634.1361694335938
      ],
      [
        -1082.5556640625,
        -3857.140380859375,
        615.8033447265625
      ],
      [
        -1092.7037353515625,
        -3924.0,
        462.91717529296875
      ],
      [
        -1109.6734619140625,
        -3924.0,
        660.0
      ],
      [
        -1088.8924560546875,
        -3864.400146484375,
        660.0
      ],
      [
        -1110.3929443359375,
        -3919.140380859375,
        660.0
      ],
      [
        -1105.5054931640625,
        -3912.046142578125,
        660.0
      ],
      [
        -1101.7889404296875,
        -3904.016357421875,
        649.3531494140625
      ],
      [
        -1110.3929443359375,
        -3919.140380859375,
        660.0
      ],
      [
        -1101.7889404296875,
        -3904.016357421875,
        649.3531494140625
      ],
      [
        -1099.26416015625,
        -3894.14599609375,
        660.0
      ],
      [
        -1098.544921875,
        -3886.58837890625,
        660.0
      ],
      [
        -1098.544921875,
        -3886.58837890625,
        660.0
      ],
      [
        -1100.2403564453125,
        -3904.403564453125,
        660.0
      ],
      [
        -1100.2403564453125,
        -3904.403564453125,
        660.0
      ],
      [
        -1071.6829833984375,
        -3718.8369140625,
        627.6624145507812
      ],
      [
        -1070.1964111328125,
        -3722.006103515625,
        627.004638671875
      ],
      [
        -1096.00341796875,
        -3666.99267578125,
        638.4271850585938
      ],
      [
        -1071.6829833984375,
        -3718.8369140625,
        627.6624145507812
      ],
      [
        -1103.9747314453125,
        -3650.0,
        641.9547119140625
      ],
      [
        -1096.00341796875,
        -3666.99267578125,
        638.4271850585938
      ],
      [
        -1070.1964111328125,
        -3722.006103515625,
        627.004638671875
      ],
      [
        -1067.064453125,
        -3719.458984375,
        657.6233520507812
      ],
      [
        -1066.857177734375,
        -3720.89306640625,
        654.0894165039062
      ],
      [
        -1078.6783447265625,
        -3695.497802734375,
        660.0
      ],
      [
        -1067.064453125,
        -3719.458984375,
        657.6233520507812
      ],
      [
        -1067.203857421875,
        -3718.49462890625,
        660.0
      ],
      [
        -1101.3798828125,
        -3650.0,
        660.0
      ],
      [
        -1078.6783447265625,
        -3695.497802734375,
        660.0
      ],
      [
        -1068.4652099609375,
        -3728.678955078125,
        657.8787231445312
      ],
      [
        -1068.4652099609375,
        -3728.678955078125,
        657.8787231445312
      ],
      [
        -1066.857177734375,
        -3720.89306640625,
        654.0894165039062
      ],
      [
        -1067.2076416015625,
        -3743.684326171875,
        628.5555419921875
      ],
      [
        -1067.856201171875,
        -3747.9580078125,
        630.83447265625
      ],
      [
        -1067.856201171875,
        -3747.9580078125,
        630.83447265625
      ],
      [
        -1081.54736328125,
        -3827.976318359375,
        660.0
      ],
      [
        -1076.1566162109375,
        -3802.64990234375,
        660.0
      ],
      [
        -1069.2362060546875,
        -3732.50927734375,
        659.9230346679688
      ],
      [
        -1068.847900390625,
        -3734.3359375,
        654.2261352539062
      ],
      [
        -1068.847900390625,
        -3734.3359375,
        654.2261352539062
      ],
      [
        -1068.323486328125,
        -3736.80224609375,
        646.5361938476562
      ],
      [
        -1069.1236572265625,
        -3731.86669921875,
        659.4300537109375
      ],
      [
        -1069.2362060546875,
        -3732.50927734375,
        659.9230346679688
      ],
      [
        -823.8580932617188,
        -3924.0,
        660.0
      ],
      [
        -832.831787109375,
        -3924.0,
        536.4684448242188
      ],
      [
        -854.8887939453125,
        -3924.0,
        267.0
      ],
      [
        -832.831787109375,
        -3924.0,
        536.4684448242188
      ],
      [
        -1063.12353515625,
        -3741.41845703125,
        660.0
      ],
      [
        -1063.637451171875,
        -3743.8330078125,
        660.0
      ],
      [
        -1063.637451171875,
        -3743.8330078125,
        660.0
      ],
      [
        -1069.2266845703125,
        -3732.506103515625,
        660.0
      ],
      [
        -1067.166015625,
        -3735.51513671875,
        660.0
      ],
      [
        -1063.12353515625,
        -3741.41845703125,
        660.0
      ],
      [
        -1067.166015625,
        -3735.51513671875,
        660.0
      ],
      [
        -1067.9898681640625,
        -3727.773193359375,
        660.0
      ],
      [
        -1069.2266845703125,
        -3732.506103515625,
        660.0
      ],
      [
        -1067.9898681640625,
        -3727.773193359375,
        660.0
      ],
      [
        -1066.12841796875,
        -3720.650146484375,
        660.0
      ],
      [
        -1066.6981201171875,
        -3719.50830078125,
        660.0
      ],
      [
        -1066.12841796875,
        -3720.650146484375,
        660.0
      ],
      [
        -1066.6981201171875,
        -3719.50830078125,
        660.0
      ],
      [
        -1179.889404296875,
        -4279.337890625,
        660.0
      ],
      [
        -1180.0,
        -4279.1728515625,
        656.4935302734375
      ],
      [
        -1180.0,
        -4279.1845703125,
        648.2435913085938
      ],
      [
        -1180.0,
        -4279.1845703125,
        648.2435913085938
      ],
      [
        -1180.0,
        -4279.7255859375,
        595.3397216796875
      ],
      [
        -1169.992431640625,
        -4295.1025390625,
        267.0
      ],
      [
        -1180.0,
        -4279.7255859375,
        595.3397216796875
      ],
      [
        -1180.0,
        -4279.255859375,
        597.8519897460938
      ],
      [
        -1155.7435302734375,
        -4229.5576171875,
        267.0
      ],
      [
        -1180.0,
        -4276.08544921875,
        614.8013916015625
      ],
      [
        -1180.0,
        -4265.19921875,
        660.0
      ],
      [
        -1180.0,
        -4270.4228515625,
        645.0784301757812
      ],
      [
        -1180.0,
        -4270.4228515625,
        645.078369140625
      ],
      [
        -1131.6746826171875,
        -3995.992919921875,
        615.3554077148438
      ],
      [
        -1141.0499267578125,
        -4044.262939453125,
        635.32080078125
      ],
      [
        -1146.1490478515625,
        -4070.515869140625,
        646.1795043945312
      ],
      [
        -1141.0499267578125,
        -4044.262939453125,
        635.32080078125
      ],
      [
        -1133.8623046875,
        -3975.595703125,
        660.0
      ],
      [
        -1129.724853515625,
        -3980.498046875,
        626.7885131835938
      ],
      [
        -1131.2237548828125,
        -3977.70654296875,
        660.0
      ],
      [
        -1150.2139892578125,
        -4077.727783203125,
        660.0
      ],
      [
        -1152.44677734375,
        -4080.470947265625,
        660.0
      ],
      [
        -1146.1490478515625,
        -4070.515869140625,
        646.1795043945312
      ],
      [
        -1150.2139892578125,
        -4077.727783203125,
        660.0
      ],
      [
        -1147.661376953125,
        -4074.591796875,
        660.0
      ],
      [
        -1129.724853515625,
        -3980.498046875,
        626.7885131835938
      ],
      [
        -1130.109619140625,
        -3983.555419921875,
        624.532470703125
      ],
      [
        -1130.109619140625,
        -3983.555419921875,
        624.532470703125
      ],
      [
        -1131.6746826171875,
        -3995.992919921875,
        615.3554077148438
      ],
      [
        -1152.44677734375,
        -4080.470947265625,
        660.0
      ],
      [
        -1155.15673828125,
        -4081.012939453125,
        660.0
      ],
      [
        -1136.138427734375,
        -3964.7041015625,
        660.0
      ],
      [
        -1126.6912841796875,
        -3950.9912109375,
        660.0
      ],
      [
        -1126.352294921875,
        -3949.875732421875,
        657.4804077148438
      ],
      [
        -1126.352294921875,
        -3949.875732421875,
        657.4804077148438
      ],
      [
        -1125.306640625,
        -3942.830078125,
        660.0
      ],
      [
        -1124.2904052734375,
        -3932.152099609375,
        660.0
      ],
      [
        -1124.2904052734375,
        -3932.152099609375,
        660.0
      ],
      [
        -1132.7476806640625,
        -3929.073974609375,
        660.0
      ],
      [
        -1144.5955810546875,
        -3961.6259765625,
        660.0
      ],
      [
        -1136.138427734375,
        -3964.7041015625,
        660.0
      ],
      [
        -1130.1776123046875,
        -3996.491943359375,
        629.9266357421875
      ],
      [
        -1138.773193359375,
        -4032.541015625,
        630.472412109375
      ],
      [
        -1127.7564697265625,
        -3981.154052734375,
        645.9474487304688
      ],
      [
        -1128.520263671875,
        -3979.869384765625,
        660.0
      ],
      [
        -1127.7564697265625,
        -3981.154052734375,
        645.9474487304688
      ],
      [
        -1128.749267578125,
        -3987.443115234375,
        639.377685546875
      ],
      [
        -1128.749267578125,
        -3987.443115234375,
        639.377685546875
      ],
      [
        -1130.1776123046875,
        -3996.491943359375,
        629.9266357421875
      ],
      [
        -1125.98583984375,
        -3949.96728515625,
        660.0
      ],
      [
        -1125.98583984375,
        -3949.96728515625,
        660.0
      ],
      [
        -1129.9404296875,
        -3996.571044921875,
        632.2350463867188
      ],
      [
        -1138.8431396484375,
        -4037.942138671875,
        641.5305786132812
      ],
      [
        -1145.87255859375,
        -4070.608154296875,
        648.8706665039062
      ],
      [
        -1138.8431396484375,
        -4037.942138671875,
        641.5305786132812
      ],
      [
        -1127.7200927734375,
        -3981.166259765625,
        646.3017578125
      ],
      [
        -1128.3431396484375,
        -3980.010986328125,
        660.0
      ],
      [
        -1145.87255859375,
        -4070.608154296875,
        648.8706665039062
      ],
      [
        -1147.2730712890625,
        -4074.11474609375,
        660.0
      ],
      [
        -1127.7200927734375,
        -3981.166259765625,
        646.3017578125
      ],
      [
        -1128.6611328125,
        -3987.695068359375,
        640.3395385742188
      ],
      [
        -1128.6611328125,
        -3987.695068359375,
        640.3395385742188
      ],
      [
        -1129.9404296875,
        -3996.571044921875,
        632.2350463867188
      ],
      [
        -1127.087890625,
        -3997.521728515625,
        660.0
      ],
      [
        -1132.2794189453125,
        -4019.142333984375,
        660.0
      ],
      [
        -1144.7291259765625,
        -4070.9892578125,
        660.0
      ],
      [
        -1132.2794189453125,
        -4019.142333984375,
        660.0
      ],
      [
        -1126.312744140625,
        -3981.63525390625,
        660.0
      ],
      [
        -1126.859619140625,
        -3992.843994140625,
        660.0
      ],
      [
        -1126.859619140625,
        -3992.843994140625,
        660.0
      ],
      [
        -1127.087890625,
        -3997.521728515625,
        660.0
      ],
      [
        -1126.312744140625,
        -3981.63525390625,
        660.0
      ],
      [
        -1144.7291259765625,
        -4070.9892578125,
        660.0
      ],
      [
        -1180.0,
        -4279.16796875,
        660.0
      ],
      [
        -1138.9462890625,
        -3730.0,
        1302.5999755859375
      ],
      [
        -1078.2181396484375,
        -3730.0,
        743.8411254882812
      ],
      [
        -1070.2890625,
        -3730.0,
        667.3118286132812
      ],
      [
        -1078.2181396484375,
        -3730.0,
        743.8411254882812
      ],
      [
        -1070.2890625,
        -3730.0,
        667.3118286132812
      ],
      [
        -1069.8994140625,
        -3730.0,
        660.0
      ],
      [
        -1072.234130859375,
        -3727.158935546875,
        679.90185546875
      ],
      [
        -1071.7784423828125,
        -3729.395263671875,
        680.37109375
      ],
      [
        -1072.2828369140625,
        -3730.0,
        680.4926147460938
      ],
      [
        -1074.33935546875,
        -3730.0,
        680.4750366210938
      ],
      [
        -1105.9620361328125,
        -3650.0,
        663.5565185546875
      ],
      [
        -1071.6546630859375,
        -3730.0,
        680.4926147460938
      ],
      [
        -1072.2828369140625,
        -3730.0,
        680.4926147460938
      ],
      [
        -1071.7784423828125,
        -3729.395263671875,
        680.37109375
      ],
      [
        -1101.379150390625,
        -3660.98583984375,
        669.9990234375
      ],
      [
        -1078.8277587890625,
        -3712.345703125,
        678.9856567382812
      ],
      [
        -1078.8277587890625,
        -3712.345703125,
        678.9856567382812
      ],
      [
        -1080.7603759765625,
        -3713.330322265625,
        723.5331420898438
      ],
      [
        -1103.2484130859375,
        -3661.93798828125,
        713.083740234375
      ],
      [
        -1101.379150390625,
        -3660.98583984375,
        669.9990234375
      ],
      [
        -1080.7603759765625,
        -3713.330322265625,
        723.5331420898438
      ],
      [
        -1097.0975341796875,
        -3676.31396484375,
        718.6273193359375
      ],
      [
        -1097.0975341796875,
        -3676.31396484375,
        718.6273193359375
      ],
      [
        -1101.2830810546875,
        -3666.53125,
        714.8550415039062
      ],
      [
        -1101.2830810546875,
        -3666.531494140625,
        714.85498046875
      ],
      [
        -1103.2484130859375,
        -3661.93798828125,
        713.083740234375
      ],
      [
        -1078.9261474609375,
        -3694.315673828125,
        673.009765625
      ],
      [
        -1076.8753662109375,
        -3698.46435546875,
        662.2449951171875
      ],
      [
        -1076.1846923828125,
        -3700.49560546875,
        660.0
      ],
      [
        -1079.8343505859375,
        -3689.761962890625,
        671.8638305664062
      ],
      [
        -1076.8753662109375,
        -3698.46435546875,
        662.2449951171875
      ],
      [
        -1079.8343505859375,
        -3689.761962890625,
        671.8638305664062
      ],
      [
        -1078.9261474609375,
        -3694.315673828125,
        673.009765625
      ],
      [
        -1086.3753662109375,
        -3662.398681640625,
        675.441162109375
      ],
      [
        -1075.919921875,
        -3710.864013671875,
        680.0115966796875
      ],
      [
        -1083.48876953125,
        -3688.376220703125,
        704.11962890625
      ],
      [
        -1083.882080078125,
        -3684.836669921875,
        700.2123413085938
      ],
      [
        -1083.8819580078125,
        -3684.8369140625,
        700.212158203125
      ],
      [
        -1086.3753662109375,
        -3662.398681640625,
        675.441162109375
      ],
      [
        -1075.919921875,
        -3710.864013671875,
        680.0115966796875
      ],
      [
        -1079.7301025390625,
        -3712.805419921875,
        721.01025390625
      ],
      [
        -1079.7301025390625,
        -3712.805419921875,
        721.01025390625
      ],
      [
        -1083.48876953125,
        -3688.376220703125,
        704.11962890625
      ],
      [
        -1070.3065185546875,
        -3693.935546875,
        681.7616577148438
      ],
      [
        -1070.775634765625,
        -3708.242919921875,
        681.82666015625
      ],
      [
        -1071.5120849609375,
        -3698.99169921875,
        691.351806640625
      ],
      [
        -1071.2943115234375,
        -3698.07861328125,
        689.619873046875
      ],
      [
        -1071.29443359375,
        -3698.07861328125,
        689.619873046875
      ],
      [
        -1070.3065185546875,
        -3693.935546875,
        681.7616577148438
      ],
      [
        -1070.775634765625,
        -3708.242919921875,
        681.82666015625
      ],
      [
        -1073.389892578125,
        -3709.574951171875,
        705.4850463867188
      ],
      [
        -1073.389892578125,
        -3709.574951171875,
        705.4850463867188
      ],
      [
        -1071.5120849609375,
        -3698.99169921875,
        691.351806640625
      ],
      [
        -1070.189697265625,
        -3709.138916015625,
        676.169189453125
      ],
      [
        -1071.2672119140625,
        -3728.7822265625,
        680.2478637695312
      ],
      [
        -1069.6864013671875,
        -3710.29248046875,
        671.196533203125
      ],
      [
        -1068.641357421875,
        -3715.61376953125,
        660.0
      ],
      [
        -1070.1229248046875,
        -3708.070068359375,
        675.8726196289062
      ],
      [
        -1069.6864013671875,
        -3710.29248046875,
        671.196533203125
      ],
      [
        -1070.1229248046875,
        -3708.070068359375,
        675.8726196289062
      ],
      [
        -1070.189697265625,
        -3709.138916015625,
        676.169189453125
      ],
      [
        -1071.3331298828125,
        -3730.0,
        680.4926147460938
      ],
      [
        -1071.2672119140625,
        -3728.7822265625,
        680.2478637695312
      ],
      [
        -835.9223022460938,
        -3730.0,
        925.9322509765625
      ],
      [
        -859.2266845703125,
        -3730.0,
        660.0
      ],
      [
        -835.9223022460938,
        -3730.0,
        925.9322509765625
      ],
      [
        -798.61328125,
        -3730.0,
        1302.5999755859375
      ],
      [
        -1068.57177734375,
        -3730.0,
        660.0
      ],
      [
        -1066.265380859375,
        -3730.0,
        680.4926147460938
      ],
      [
        -1066.265380859375,
        -3730.0,
        680.4926147460938
      ],
      [
        -1030.0,
        -4170.0,
        735.0
      ],
      [
        -1030.0,
        -4170.0,
        740.0
      ],
      [
        -995.5121459960938,
        -4140.55712890625,
        773.9380493164062
      ],
      [
        -1003.6132202148438,
        -4170.0,
        769.2562866210938
      ],
      [
        -1004.2505493164062,
        -4170.0,
        762.4691162109375
      ],
      [
        -995.5902099609375,
        -4140.42138671875,
        772.7302856445312
      ],
      [
        -995.483154296875,
        -4140.607421875,
        774.3861083984375
      ],
      [
        -1003.3833618164062,
        -4170.0,
        771.7045288085938
      ],
      [
        -1003.6132202148438,
        -4170.0,
        769.2562866210938
      ],
      [
        -995.5121459960938,
        -4140.55712890625,
        773.9380493164062
      ],
      [
        -995.5902099609375,
        -4140.42138671875,
        772.7302856445312
      ],
      [
        -1004.2505493164062,
        -4170.0,
        762.4691162109375
      ],
      [
        -1006.89453125,
        -4170.0,
        734.3095703125
      ],
      [
        -998.6137084960938,
        -4135.16015625,
        725.94775390625
      ],
      [
        -1003.3833618164062,
        -4170.0,
        771.7045288085938
      ],
      [
        -995.483154296875,
        -4140.607421875,
        774.3861083984375
      ],
      [
        -995.4434814453125,
        -4140.67626953125,
        775.0
      ],
      [
        -1003.073974609375,
        -4170.0,
        775.0
      ],
      [
        -998.6137084960938,
        -4135.16015625,
        725.94775390625
      ],
      [
        -1006.89453125,
        -4170.0,
        734.3095703125
      ],
      [
        -1007.7686157226562,
        -4170.0,
        725.0
      ],
      [
        -998.6749877929688,
        -4135.0537109375,
        725.0
      ],
      [
        -998.6749877929688,
        -4135.0537109375,
        725.0
      ],
      [
        -1007.7686157226562,
        -4170.0,
        725.0
      ],
      [
        -1013.87158203125,
        -4170.0,
        660.0
      ],
      [
        -978.5899047851562,
        -4170.0,
        1035.7659912109375
      ],
      [
        -1003.073974609375,
        -4170.0,
        775.0
      ],
      [
        -995.4434814453125,
        -4140.67626953125,
        775.0
      ],
      [
        -958.1337890625,
        -4170.0,
        1253.6326904296875
      ],
      [
        -958.1337280273438,
        -4170.0,
        1253.6328125
      ],
      [
        -952.7698974609375,
        -4170.0,
        1302.5999755859375
      ],
      [
        -1030.0,
        -4255.916015625,
        726.3341674804688
      ],
      [
        -1030.0,
        -4269.8291015625,
        747.1873168945312
      ],
      [
        -1030.0,
        -4255.48779296875,
        725.1480102539062
      ],
      [
        -1030.0,
        -4255.916015625,
        726.3345336914062
      ],
      [
        -1030.0,
        -4255.48779296875,
        725.1480102539062
      ],
      [
        -1030.0,
        -4255.43408203125,
        725.0
      ],
      [
        -1030.0,
        -4255.43408203125,
        725.0
      ],
      [
        -1030.0,
        -4231.98095703125,
        660.0
      ],
      [
        -1006.3602905273438,
        -4170.0,
        740.0
      ],
      [
        -1017.289306640625,
        -4212.0,
        740.0
      ],
      [
        -997.5202026367188,
        -4193.51025390625,
        740.0
      ],
      [
        -999.8734130859375,
        -4202.5537109375,
        740.0
      ],
      [
        -986.642333984375,
        -4183.24365234375,
        740.0
      ],
      [
        -997.5202026367188,
        -4193.51025390625,
        740.0
      ],
      [
        -986.642333984375,
        -4183.24365234375,
        740.0
      ],
      [
        -994.6494750976562,
        -4182.47705078125,
        740.0
      ],
      [
        -1015.2913818359375,
        -4204.32177734375,
        740.0
      ],
      [
        -999.8734130859375,
        -4202.5537109375,
        740.0
      ],
      [
        -1009.243408203125,
        -4181.080078125,
        740.0
      ],
      [
        -1014.3973999023438,
        -4170.0,
        740.0
      ],
      [
        -1021.29296875,
        -4212.0,
        740.0
      ],
      [
        -1014.9451904296875,
        -4170.0,
        735.0
      ],
      [
        -1021.8406372070312,
        -4212.0,
        735.0
      ],
      [
        -1021.2929077148438,
        -4212.0,
        740.0
      ],
      [
        -1021.8406372070312,
        -4212.0,
        735.0
      ],
      [
        -1030.0,
        -4269.8291015625,
        747.1873168945312
      ],
      [
        -1030.0,
        -4336.3515625,
        1020.9401245117188
      ],
      [
        -1030.0,
        -4336.3515625,
        1020.9401245117188
      ],
      [
        -1030.0,
        -4395.6328125,
        1302.5999755859375
      ],
      [
        -1030.0,
        -4170.0,
        740.0
      ],
      [
        -1030.0,
        -4212.0,
        740.0
      ],
      [
        -1030.0,
        -4170.0,
        735.0
      ],
      [
        -1030.0,
        -4212.0,
        735.0
      ],
      [
        -1030.0,
        -4212.0,
        740.0
      ],
      [
        -1030.0,
        -4212.0,
        735.0
      ],
      [
        -1124.26611328125,
        -3924.0,
        733.905029296875
      ],
      [
        -1142.5712890625,
        -3924.0,
        903.507568359375
      ],
      [
        -1142.5712890625,
        -3924.0,
        903.507568359375
      ],
      [
        -1193.2838134765625,
        -3924.0,
        1302.365234375
      ],
      [
        -1074.1226806640625,
        -3753.035400390625,
        688.7144775390625
      ],
      [
        -1085.526123046875,
        -3836.232666015625,
        720.9295043945312
      ],
      [
        -1085.8966064453125,
        -3837.01611328125,
        721.2744140625
      ],
      [
        -1102.6956787109375,
        -3884.59033203125,
        689.3931884765625
      ],
      [
        -1100.1280517578125,
        -3886.01220703125,
        660.0
      ],
      [
        -1102.6956787109375,
        -3884.59033203125,
        689.3931884765625
      ],
      [
        -1114.008544921875,
        -3911.181640625,
        689.3931884765625
      ],
      [
        -1115.6378173828125,
        -3916.865234375,
        682.0844116210938
      ],
      [
        -1113.708740234375,
        -3917.93359375,
        660.0
      ],
      [
        -1086.375,
        -3838.027587890625,
        721.7197265625
      ],
      [
        -1084.5635986328125,
        -3839.79296875,
        697.978759765625
      ],
      [
        -1078.31884765625,
        -3816.90576171875,
        667.6134643554688
      ],
      [
        -1080.9219970703125,
        -3834.068603515625,
        676.7802124023438
      ],
      [
        -1076.1566162109375,
        -3802.64990234375,
        660.0
      ],
      [
        -1078.31884765625,
        -3816.90576171875,
        667.6134643554688
      ],
      [
        -1084.5635986328125,
        -3839.79296875,
        697.978759765625
      ],
      [
        -1083.9219970703125,
        -3838.900634765625,
        695.5507202148438
      ],
      [
        -1080.9219970703125,
        -3834.068603515625,
        676.7802124023438
      ],
      [
        -1083.9219970703125,
        -3838.900634765625,
        695.5507202148438
      ],
      [
        -1082.572021484375,
        -3837.023193359375,
        690.44384765625
      ],
      [
        -1082.92919921875,
        -3818.30712890625,
        712.5823364257812
      ],
      [
        -1100.665771484375,
        -3815.1796875,
        715.628662109375
      ],
      [
        -1083.065673828125,
        -3818.282958984375,
        713.97900390625
      ],
      [
        -1071.3541259765625,
        -3731.25048828125,
        680.3134765625
      ],
      [
        -1071.5926513671875,
        -3730.0,
        679.8941040039062
      ],
      [
        -1080.73291015625,
        -3802.447509765625,
        706.2144775390625
      ],
      [
        -1080.8914794921875,
        -3802.419677734375,
        707.8366088867188
      ],
      [
        -1097.2034912109375,
        -3799.54345703125,
        709.3654174804688
      ],
      [
        -1078.156982421875,
        -3783.0908203125,
        699.4954223632812
      ],
      [
        -1094.665771484375,
        -3780.1796875,
        701.885986328125
      ],
      [
        -1078.240234375,
        -3783.076171875,
        700.3464965820312
      ],
      [
        -1075.9605712890625,
        -3767.231201171875,
        693.1275634765625
      ],
      [
        -1076.0657958984375,
        -3767.212646484375,
        694.2039794921875
      ],
      [
        -1091.318115234375,
        -3764.523193359375,
        695.633544921875
      ],
      [
        -1079.688232421875,
        -3766.573974609375,
        731.2590942382812
      ],
      [
        -1078.56201171875,
        -3766.7724609375,
        719.7393188476562
      ],
      [
        -1078.56201171875,
        -3766.7724609375,
        719.7393188476562
      ],
      [
        -1084.3336181640625,
        -3801.812744140625,
        743.0487060546875
      ],
      [
        -1082.9200439453125,
        -3802.06201171875,
        728.5880126953125
      ],
      [
        -1082.9200439453125,
        -3802.06201171875,
        728.5880126953125
      ],
      [
        -1085.792236328125,
        -3817.80224609375,
        741.869384765625
      ],
      [
        -1085.792236328125,
        -3817.80224609375,
        741.869384765625
      ],
      [
        -1084.3336181640625,
        -3801.812744140625,
        743.0487060546875
      ],
      [
        -1085.8966064453125,
        -3837.01611328125,
        721.2744140625
      ],
      [
        -1086.384033203125,
        -3838.018798828125,
        721.8385009765625
      ],
      [
        -1086.384033203125,
        -3838.018798828125,
        721.8385009765625
      ],
      [
        -1081.146728515625,
        -3782.5634765625,
        730.0797119140625
      ],
      [
        -1081.146728515625,
        -3782.5634765625,
        730.0797119140625
      ],
      [
        -1079.688232421875,
        -3766.573974609375,
        731.2590942382812
      ],
      [
        -1071.4224853515625,
        -3731.650390625,
        680.8242797851562
      ],
      [
        -1071.5230712890625,
        -3733.039306640625,
        681.3367309570312
      ],
      [
        -1071.5230712890625,
        -3733.039306640625,
        681.3367309570312
      ],
      [
        -1071.643798828125,
        -3734.70751953125,
        681.9522094726562
      ],
      [
        -1074.1226806640625,
        -3753.035400390625,
        688.7144775390625
      ],
      [
        -1071.4224853515625,
        -3731.650390625,
        680.8242797851562
      ],
      [
        -1071.6546630859375,
        -3730.0,
        680.4926147460938
      ],
      [
        -1071.400390625,
        -3731.2421875,
        680.7422485351562
      ],
      [
        -1071.3331298828125,
        -3730.0,
        680.4926147460938
      ],
      [
        -1193.3072509765625,
        -3924.0,
        1302.5999755859375
      ],
      [
        -1193.28369140625,
        -3924.0,
        1302.365234375
      ],
      [
        -1109.6734619140625,
        -3924.0,
        660.0
      ],
      [
        -1124.26611328125,
        -3924.0,
        733.905029296875
      ],
      [
        -1101.8441162109375,
        -3884.900390625,
        689.3931884765625
      ],
      [
        -1113.250244140625,
        -3917.613037109375,
        689.3931884765625
      ],
      [
        -1097.76123046875,
        -3886.784423828125,
        665.387939453125
      ],
      [
        -1101.8441162109375,
        -3884.900390625,
        689.3931884765625
      ],
      [
        -1113.250244140625,
        -3917.613037109375,
        689.3931884765625
      ],
      [
        -1109.405517578125,
        -3919.38720703125,
        666.7886352539062
      ],
      [
        -1109.405517578125,
        -3919.38720703125,
        666.7886352539062
      ],
      [
        -1105.50537109375,
        -3912.0458984375,
        660.0
      ],
      [
        -1097.76123046875,
        -3886.784423828125,
        665.387939453125
      ],
      [
        -1099.26416015625,
        -3894.14599609375,
        660.0
      ],
      [
        -1085.8021240234375,
        -3838.11572265625,
        721.8385009765625
      ],
      [
        -1084.0172119140625,
        -3839.61083984375,
        702.4108276367188
      ],
      [
        -1084.0172119140625,
        -3839.61083984375,
        702.4108276367188
      ],
      [
        -1083.3729248046875,
        -3838.457275390625,
        697.0752563476562
      ],
      [
        -1083.3729248046875,
        -3838.457275390625,
        697.0752563476562
      ],
      [
        -1085.61572265625,
        -3836.886474609375,
        721.1826171875
      ],
      [
        -1085.8021240234375,
        -3838.11572265625,
        721.8385009765625
      ],
      [
        -1085.61572265625,
        -3836.886474609375,
        721.1826171875
      ],
      [
        -1071.2303466796875,
        -3731.650390625,
        680.8242797851562
      ],
      [
        -1071.4266357421875,
        -3733.10205078125,
        681.35986328125
      ],
      [
        -1071.4266357421875,
        -3733.10205078125,
        681.35986328125
      ],
      [
        -1071.2303466796875,
        -3731.650390625,
        680.8242797851562
      ],
      [
        -1071.03466796875,
        -3730.0,
        680.4926147460938
      ],
      [
        -1081.80126953125,
        -3838.872314453125,
        720.3847045898438
      ],
      [
        -1081.80126953125,
        -3838.872314453125,
        720.3847045898438
      ],
      [
        -1085.6473388671875,
        -3838.245361328125,
        720.1536254882812
      ],
      [
        -1073.97607421875,
        -3803.638916015625,
        707.3850708007812
      ],
      [
        -1076.9305419921875,
        -3819.212890625,
        713.1311645507812
      ],
      [
        -1067.941650390625,
        -3768.64501953125,
        694.4737548828125
      ],
      [
        -1070.8828125,
        -3784.1484375,
        700.1939086914062
      ],
      [
        -1067.941650390625,
        -3768.64501953125,
        694.4737548828125
      ],
      [
        -1068.5528564453125,
        -3768.537353515625,
        694.4340209960938
      ],
      [
        -1068.5528564453125,
        -3768.537353515625,
        694.4340209960938
      ],
      [
        -1076.0406494140625,
        -3767.217041015625,
        693.9468994140625
      ],
      [
        -1078.1868896484375,
        -3783.08544921875,
        699.8017578125
      ],
      [
        -1070.9241943359375,
        -3784.3662109375,
        700.2742309570312
      ],
      [
        -1074.8380126953125,
        -3803.487060546875,
        706.6317749023438
      ],
      [
        -1074.560791015625,
        -3803.535888671875,
        707.3470458984375
      ],
      [
        -1080.803955078125,
        -3802.43505859375,
        706.9409790039062
      ],
      [
        -1077.616455078125,
        -3819.244140625,
        712.95849609375
      ],
      [
        -1082.9500732421875,
        -3818.303466796875,
        712.7957153320312
      ],
      [
        -1077.543212890625,
        -3819.257080078125,
        713.1475219726562
      ],
      [
        -1073.97607421875,
        -3803.638916015625,
        707.3850708007812
      ],
      [
        -1074.51953125,
        -3803.543212890625,
        707.3497314453125
      ],
      [
        -1074.51953125,
        -3803.543212890625,
        707.3497314453125
      ],
      [
        -1076.95849609375,
        -3819.360107421875,
        713.185546875
      ],
      [
        -1070.8828125,
        -3784.1484375,
        700.1939086914062
      ],
      [
        -1070.874267578125,
        -3784.375,
        700.2774658203125
      ],
      [
        -1070.874267578125,
        -3784.375,
        700.2774658203125
      ],
      [
        -1076.9305419921875,
        -3819.212890625,
        713.1311645507812
      ],
      [
        -1076.9248046875,
        -3819.365966796875,
        713.187744140625
      ],
      [
        -1076.9248046875,
        -3819.365966796875,
        713.187744140625
      ],
      [
        -1066.296630859375,
        -3730.0,
        680.21533203125
      ],
      [
        -1081.691650390625,
        -3838.835693359375,
        721.2743530273438
      ],
      [
        -1076.8094482421875,
        -3819.38623046875,
        713.3927001953125
      ],
      [
        -1083.0657958984375,
        -3818.282958984375,
        713.9790649414062
      ],
      [
        -1075.3795166015625,
        -3811.03662109375,
        710.114501953125
      ],
      [
        -1076.8199462890625,
        -3819.063720703125,
        713.2764892578125
      ],
      [
        -1080.8914794921875,
        -3802.419677734375,
        707.8365478515625
      ],
      [
        -1075.2139892578125,
        -3803.420654296875,
        707.3045654296875
      ],
      [
        -1074.787353515625,
        -3783.68505859375,
        700.0228881835938
      ],
      [
        -1078.2401123046875,
        -3783.076171875,
        700.346435546875
      ],
      [
        -1076.0657958984375,
        -3767.212646484375,
        694.2040405273438
      ],
      [
        -1074.43603515625,
        -3767.5,
        694.05126953125
      ],
      [
        -1076.8199462890625,
        -3819.063720703125,
        713.2764892578125
      ],
      [
        -1076.8094482421875,
        -3819.38623046875,
        713.3927001953125
      ],
      [
        -1081.691650390625,
        -3838.835693359375,
        721.2743530273438
      ],
      [
        -1085.7860107421875,
        -3838.129150390625,
        721.6637573242188
      ],
      [
        -1063.9368896484375,
        -3769.35107421875,
        704.8065185546875
      ],
      [
        -1062.693115234375,
        -3769.570556640625,
        716.0726928710938
      ],
      [
        -1067.01220703125,
        -3785.055908203125,
        707.1402587890625
      ],
      [
        -1065.976318359375,
        -3785.238525390625,
        716.5238037109375
      ],
      [
        -1065.976318359375,
        -3785.238525390625,
        716.5238037109375
      ],
      [
        -1062.693115234375,
        -3769.570556640625,
        716.0726928710938
      ],
      [
        -1063.9368896484375,
        -3769.35107421875,
        704.8065185546875
      ],
      [
        -1065.073486328125,
        -3776.316162109375,
        707.8256225585938
      ],
      [
        -1065.073486328125,
        -3776.316162109375,
        707.8256225585938
      ],
      [
        -1067.01220703125,
        -3785.055908203125,
        707.1402587890625
      ],
      [
        -1069.8837890625,
        -3804.360595703125,
        717.9434814453125
      ],
      [
        -1068.6585693359375,
        -3804.57666015625,
        729.0418090820312
      ],
      [
        -1072.965087890625,
        -3820.064208984375,
        720.2240600585938
      ],
      [
        -1071.94189453125,
        -3820.24462890625,
        729.4929809570312
      ],
      [
        -1071.94189453125,
        -3820.24462890625,
        729.4929809570312
      ],
      [
        -1068.6585693359375,
        -3804.57666015625,
        729.0418090820312
      ],
      [
        -1069.8837890625,
        -3804.360595703125,
        717.9434814453125
      ],
      [
        -1071.0035400390625,
        -3811.2216796875,
        720.9176025390625
      ],
      [
        -1071.0035400390625,
        -3811.2216796875,
        720.9176025390625
      ],
      [
        -1072.965087890625,
        -3820.064208984375,
        720.2240600585938
      ],
      [
        -1063.5439453125,
        -3769.42041015625,
        708.3660278320312
      ],
      [
        -1069.4967041015625,
        -3804.428955078125,
        721.4503173828125
      ],
      [
        -1180.0,
        -3933.420654296875,
        1160.84033203125
      ],
      [
        -1180.0,
        -4011.48681640625,
        1087.7275390625
      ],
      [
        -1180.0,
        -4011.48681640625,
        1087.7275390625
      ],
      [
        -1180.0,
        -4070.130615234375,
        983.9453125
      ],
      [
        -1158.0130615234375,
        -4083.829833984375,
        700.981201171875
      ],
      [
        -1154.5142822265625,
        -4080.884521484375,
        660.0
      ],
      [
        -1138.6402587890625,
        -3963.11474609375,
        700.942626953125
      ],
      [
        -1135.96630859375,
        -3964.7470703125,
        661.1834106445312
      ],
      [
        -1135.4951171875,
        -3943.306640625,
        701.3931884765625
      ],
      [
        -1138.4268798828125,
        -3961.577880859375,
        701.3931884765625
      ],
      [
        -1131.0723876953125,
        -3929.49267578125,
        671.5169677734375
      ],
      [
        -1130.2979736328125,
        -3929.965576171875,
        660.0
      ],
      [
        -1135.96630859375,
        -3964.7470703125,
        661.1834106445312
      ],
      [
        -1135.7911376953125,
        -3964.199951171875,
        660.0
      ],
      [
        -1180.0,
        -4011.041259765625,
        726.1341552734375
      ],
      [
        -1179.6881103515625,
        -4011.041259765625,
        726.1341552734375
      ],
      [
        -1179.6881103515625,
        -4011.041259765625,
        726.1341552734375
      ],
      [
        -1157.989990234375,
        -4083.709716796875,
        700.9307250976562
      ],
      [
        -1157.8370361328125,
        -4082.846435546875,
        700.7359619140625
      ],
      [
        -1156.99951171875,
        -4078.117431640625,
        699.6690673828125
      ],
      [
        -1157.8370361328125,
        -4082.846435546875,
        700.7359619140625
      ],
      [
        -1158.0130615234375,
        -4083.829833984375,
        700.981201171875
      ],
      [
        -1157.989990234375,
        -4083.709716796875,
        700.9307250976562
      ],
      [
        -1150.9093017578125,
        -4037.363525390625,
        717.635986328125
      ],
      [
        -1156.751708984375,
        -4083.57763671875,
        700.981201171875
      ],
      [
        -1152.5867919921875,
        -4080.4990234375,
        660.0
      ],
      [
        -1156.5943603515625,
        -4082.776611328125,
        700.6447143554688
      ],
      [
        -1155.554931640625,
        -4076.9697265625,
        699.333984375
      ],
      [
        -1149.5712890625,
        -4043.541015625,
        691.7887573242188
      ],
      [
        -1155.554931640625,
        -4076.9697265625,
        699.333984375
      ],
      [
        -1135.7015380859375,
        -3964.813232421875,
        663.0035400390625
      ],
      [
        -1136.61865234375,
        -3964.348876953125,
        670.8826904296875
      ],
      [
        -1135.7015380859375,
        -3964.813232421875,
        663.0035400390625
      ],
      [
        -1135.151123046875,
        -3963.27099609375,
        660.0
      ],
      [
        -1149.6973876953125,
        -4041.31884765625,
        697.12548828125
      ],
      [
        -1150.9093017578125,
        -4037.363525390625,
        717.635986328125
      ],
      [
        -1156.751708984375,
        -4083.57763671875,
        700.981201171875
      ],
      [
        -1156.5943603515625,
        -4082.776611328125,
        700.6447143554688
      ],
      [
        -1148.6671142578125,
        -4038.318359375,
        690.951416015625
      ],
      [
        -1149.6973876953125,
        -4041.31884765625,
        697.12548828125
      ],
      [
        -1148.6671142578125,
        -4038.318359375,
        690.951416015625
      ],
      [
        -1146.0355224609375,
        -4019.126708984375,
        695.3768920898438
      ],
      [
        -1146.05029296875,
        -4019.42578125,
        695.2135620117188
      ],
      [
        -1145.2373046875,
        -4010.32373046875,
        697.2422485351562
      ],
      [
        -1146.0355224609375,
        -4019.126708984375,
        695.3768920898438
      ],
      [
        -1145.2373046875,
        -4010.32373046875,
        697.2422485351562
      ],
      [
        -1146.69189453125,
        -4012.5869140625,
        702.4780883789062
      ],
      [
        -1145.6065673828125,
        -4010.451904296875,
        700.1163330078125
      ],
      [
        -1146.1500244140625,
        -4010.640380859375,
        704.34619140625
      ],
      [
        -1147.3013916015625,
        -4011.680908203125,
        712.699951171875
      ],
      [
        -1146.1500244140625,
        -4010.640380859375,
        704.34619140625
      ],
      [
        -1146.6849365234375,
        -4008.26953125,
        722.0310668945312
      ],
      [
        -1137.7174072265625,
        -3963.443115234375,
        701.3931884765625
      ],
      [
        -1134.9708251953125,
        -3964.995849609375,
        668.0272827148438
      ],
      [
        -1134.8470458984375,
        -3942.365966796875,
        701.3931884765625
      ],
      [
        -1135.5330810546875,
        -3949.683349609375,
        701.3931884765625
      ],
      [
        -1137.7174072265625,
        -3963.443115234375,
        701.3931884765625
      ],
      [
        -1130.8253173828125,
        -3929.554443359375,
        673.2157592773438
      ],
      [
        -1129.56591796875,
        -3930.23193359375,
        660.0
      ],
      [
        -1134.9708251953125,
        -3964.995849609375,
        668.0272827148438
      ],
      [
        -1133.625244140625,
        -3961.05615234375,
        660.0
      ],
      [
        -1144.7591552734375,
        -4007.96875,
        701.096435546875
      ],
      [
        -1146.6849365234375,
        -4008.26953125,
        722.0310668945312
      ],
      [
        -1144.332763671875,
        -4008.51416015625,
        695.3775634765625
      ],
      [
        -1145.9957275390625,
        -4019.031982421875,
        695.3023681640625
      ],
      [
        -1145.9957275390625,
        -4019.031982421875,
        695.3023681640625
      ],
      [
        -1144.332763671875,
        -4008.51416015625,
        695.3775634765625
      ],
      [
        -1144.7591552734375,
        -4007.96875,
        701.096435546875
      ],
      [
        -1180.0,
        -4070.130615234375,
        983.9453125
      ],
      [
        -1171.9205322265625,
        -4170.0,
        725.9437255859375
      ],
      [
        -1180.0,
        -4170.0,
        816.77099609375
      ],
      [
        -1171.9205322265625,
        -4170.0,
        725.9437255859375
      ],
      [
        -1163.848388671875,
        -4170.0,
        660.0
      ],
      [
        -1154.19384765625,
        -4083.06591796875,
        700.981201171875
      ],
      [
        -1150.835205078125,
        -4081.00830078125,
        675.6862182617188
      ],
      [
        -1153.8330078125,
        -4080.93017578125,
        700.0787963867188
      ],
      [
        -1151.9041748046875,
        -4067.568359375,
        697.0912475585938
      ],
      [
        -1149.3841552734375,
        -4042.669921875,
        691.5902099609375
      ],
      [
        -1150.2381591796875,
        -4056.0263671875,
        694.5106201171875
      ],
      [
        -1151.9041748046875,
        -4067.568359375,
        697.0912475585938
      ],
      [
        -1149.1881103515625,
        -4077.127685546875,
        664.1153564453125
      ],
      [
        -1150.835205078125,
        -4081.00830078125,
        675.6862182617188
      ],
      [
        -1149.448974609375,
        -4077.96337890625,
        667.3250122070312
      ],
      [
        -1148.853759765625,
        -4076.056396484375,
        660.0
      ],
      [
        -1149.1881103515625,
        -4077.127685546875,
        664.1153564453125
      ],
      [
        -1153.1103515625,
        -4074.595947265625,
        700.2171020507812
      ],
      [
        -1151.7354736328125,
        -4065.419677734375,
        697.7583618164062
      ],
      [
        -1151.635986328125,
        -4065.7099609375,
        696.6757202148438
      ],
      [
        -1151.7354736328125,
        -4065.419677734375,
        697.7583618164062
      ],
      [
        -1152.9761962890625,
        -4074.986572265625,
        698.759033203125
      ],
      [
        -1153.1103515625,
        -4074.595947265625,
        700.2171020507812
      ],
      [
        -1154.19384765625,
        -4083.06591796875,
        700.981201171875
      ],
      [
        -1153.8330078125,
        -4080.93017578125,
        700.0787963867188
      ],
      [
        -1146.05029296875,
        -4019.42578125,
        695.2135620117188
      ],
      [
        -1147.930419921875,
        -4035.903076171875,
        690.0479736328125
      ],
      [
        -1146.1107177734375,
        -4027.432861328125,
        688.1175537109375
      ],
      [
        -1146.620849609375,
        -4030.966796875,
        688.90771484375
      ],
      [
        -1149.1048583984375,
        -4077.0791015625,
        664.4491577148438
      ],
      [
        -1149.2423095703125,
        -4077.301513671875,
        664.7828369140625
      ],
      [
        -1148.2344970703125,
        -4075.295654296875,
        660.0
      ],
      [
        -1149.1048583984375,
        -4077.0791015625,
        664.4491577148438
      ],
      [
        -1148.8826904296875,
        -4076.719482421875,
        663.9097290039062
      ],
      [
        -1148.8551025390625,
        -4040.207275390625,
        691.0289306640625
      ],
      [
        -1149.6396484375,
        -4046.665283203125,
        692.4638061523438
      ],
      [
        -1149.15234375,
        -4077.15576171875,
        664.5643310546875
      ],
      [
        -1149.3055419921875,
        -4077.50390625,
        665.560302734375
      ],
      [
        -1149.025146484375,
        -4077.032470703125,
        664.7689819335938
      ],
      [
        -1149.025146484375,
        -4077.032470703125,
        664.7689819335938
      ],
      [
        -1138.2342529296875,
        -4000.54052734375,
        680.7471923828125
      ],
      [
        -1138.5517578125,
        -4010.101318359375,
        674.9646606445312
      ],
      [
        -1136.0159912109375,
        -3980.444091796875,
        677.4082641601562
      ],
      [
        -1138.1893310546875,
        -3999.1865234375,
        681.5662231445312
      ],
      [
        -1146.620849609375,
        -4030.966796875,
        688.90771484375
      ],
      [
        -1134.1866455078125,
        -3965.19189453125,
        673.4183349609375
      ],
      [
        -1132.271484375,
        -3959.091064453125,
        660.0
      ],
      [
        -1134.2437744140625,
        -3965.1611328125,
        674.017822265625
      ],
      [
        -1134.1866455078125,
        -3965.19189453125,
        673.4182739257812
      ],
      [
        -1135.4622802734375,
        -3964.718017578125,
        673.9974365234375
      ],
      [
        -1138.0931396484375,
        -3998.357666015625,
        681.3822631835938
      ],
      [
        -1138.2342529296875,
        -4000.54052734375,
        680.7471923828125
      ],
      [
        -1139.0885009765625,
        -4002.57568359375,
        682.34912109375
      ],
      [
        -1147.6614990234375,
        -4074.591796875,
        660.0
      ],
      [
        -1148.8826904296875,
        -4076.719482421875,
        663.9097290039062
      ],
      [
        -1147.9913330078125,
        -4075.27685546875,
        661.7446899414062
      ],
      [
        -1133.9156494140625,
        -3975.50244140625,
        661.0550537109375
      ],
      [
        -1133.8218994140625,
        -3975.628173828125,
        660.0
      ],
      [
        -1136.8525390625,
        -3963.7578125,
        701.3931884765625
      ],
      [
        -1136.8525390625,
        -3963.7578125,
        701.3931884765625
      ],
      [
        -1137.92041015625,
        -3995.686767578125,
        682.1592407226562
      ],
      [
        -1137.92041015625,
        -3995.686767578125,
        682.1592407226562
      ],
      [
        -1144.5078125,
        -4008.290283203125,
        697.7256469726562
      ],
      [
        -1138.0709228515625,
        -3995.626953125,
        683.7188110351562
      ],
      [
        -1139.748291015625,
        -3996.15283203125,
        699.9810180664062
      ],
      [
        -1138.944580078125,
        -4005.700439453125,
        683.0112915039062
      ],
      [
        -1147.178955078125,
        -4034.832763671875,
        689.7720947265625
      ],
      [
        -1138.2890625,
        -3995.540283203125,
        685.978759765625
      ],
      [
        -1139.748291015625,
        -3996.15283203125,
        699.9810180664062
      ],
      [
        -1138.2890625,
        -3995.540283203125,
        685.978759765625
      ],
      [
        -1153.6123046875,
        -4080.782470703125,
        700.0335693359375
      ],
      [
        -1150.07177734375,
        -4062.849609375,
        695.965576171875
      ],
      [
        -1139.166259765625,
        -4007.612060546875,
        683.4353637695312
      ],
      [
        -1150.07177734375,
        -4062.849609375,
        695.965576171875
      ],
      [
        -1154.052734375,
        -4083.013671875,
        700.5397338867188
      ],
      [
        -1150.7618408203125,
        -4081.03271484375,
        676.4002685546875
      ],
      [
        -1154.1363525390625,
        -4083.03076171875,
        700.5484619140625
      ],
      [
        -1148.7623291015625,
        -4076.878662109375,
        665.8233032226562
      ],
      [
        -1150.7618408203125,
        -4081.03271484375,
        676.4002685546875
      ],
      [
        -1148.7623291015625,
        -4076.878662109375,
        665.8233032226562
      ],
      [
        -1151.5,
        -4069.236328125,
        698.7810668945312
      ],
      [
        -1151.118408203125,
        -4067.3515625,
        698.2760009765625
      ],
      [
        -1152.5850830078125,
        -4074.595947265625,
        700.2171020507812
      ],
      [
        -1150.727294921875,
        -4065.419677734375,
        697.7583618164062
      ],
      [
        -1154.1129150390625,
        -4083.0498046875,
        700.981201171875
      ],
      [
        -1153.6123046875,
        -4080.782470703125,
        700.0335693359375
      ],
      [
        -1154.1129150390625,
        -4083.0498046875,
        700.981201171875
      ],
      [
        -1152.4713134765625,
        -4074.9921875,
        698.7379150390625
      ],
      [
        -1152.5850830078125,
        -4074.595947265625,
        700.2171020507812
      ],
      [
        -1150.6395263671875,
        -4065.725341796875,
        696.617919921875
      ],
      [
        -1150.727294921875,
        -4065.419677734375,
        697.7583618164062
      ],
      [
        -1139.373291015625,
        -4034.843505859375,
        660.0
      ],
      [
        -1147.27294921875,
        -4074.114501953125,
        660.0
      ],
      [
        -1147.9913330078125,
        -4075.27685546875,
        661.7446899414062
      ],
      [
        -1147.1497802734375,
        -4076.4609375,
        698.7091064453125
      ],
      [
        -1143.655517578125,
        -4046.32666015625,
        692.02392578125
      ],
      [
        -1143.655517578125,
        -4046.32666015625,
        692.02392578125
      ],
      [
        -1145.1495361328125,
        -4074.765625,
        680.3151245117188
      ],
      [
        -1148.3436279296875,
        -4081.8388671875,
        699.9371337890625
      ],
      [
        -1147.673828125,
        -4080.979736328125,
        699.7116088867188
      ],
      [
        -1143.748291015625,
        -4071.316162109375,
        669.5472412109375
      ],
      [
        -1145.1495361328125,
        -4074.765625,
        680.3151245117188
      ],
      [
        -1148.3436279296875,
        -4081.8388671875,
        699.9371337890625
      ],
      [
        -1154.052734375,
        -4083.013671875,
        700.5397338867188
      ],
      [
        -1143.748291015625,
        -4071.316162109375,
        669.5472412109375
      ],
      [
        -1141.501953125,
        -4057.549560546875,
        660.0
      ],
      [
        -1146.8929443359375,
        -4072.6640625,
        699.699462890625
      ],
      [
        -1146.25244140625,
        -4067.3515625,
        698.2760009765625
      ],
      [
        -1147.1259765625,
        -4074.595947265625,
        700.2171020507812
      ],
      [
        -1146.0194091796875,
        -4065.419677734375,
        697.7583618164062
      ],
      [
        -1147.8123779296875,
        -4081.32080078125,
        700.7761840820312
      ],
      [
        -1147.1497802734375,
        -4076.4609375,
        698.7091064453125
      ],
      [
        -1147.8123779296875,
        -4081.32080078125,
        700.7761840820312
      ],
      [
        -1146.9979248046875,
        -4075.053466796875,
        698.5091552734375
      ],
      [
        -1147.1259765625,
        -4074.595947265625,
        700.2171020507812
      ],
      [
        -1145.91357421875,
        -4065.798828125,
        696.34375
      ],
      [
        -1146.0194091796875,
        -4065.419677734375,
        697.7583618164062
      ],
      [
        -1180.0,
        -3933.4208984375,
        1160.83935546875
      ],
      [
        -1180.0,
        -3924.0,
        1197.8870849609375
      ],
      [
        -1121.838134765625,
        -3932.76513671875,
        676.8589477539062
      ],
      [
        -1123.9813232421875,
        -3931.578369140625,
        701.3931884765625
      ],
      [
        -1123.9813232421875,
        -3931.578369140625,
        701.3931884765625
      ],
      [
        -1136.6209716796875,
        -3961.2880859375,
        701.3931884765625
      ],
      [
        -1121.838134765625,
        -3932.76513671875,
        676.8589477539062
      ],
      [
        -1125.596435546875,
        -3945.8759765625,
        660.0
      ],
      [
        -1129.5189208984375,
        -3955.095703125,
        660.0
      ],
      [
        -1133.2186279296875,
        -3962.108154296875,
        666.6360473632812
      ],
      [
        -1115.11376953125,
        -3924.0,
        687.552490234375
      ],
      [
        -1121.173583984375,
        -3932.600341796875,
        701.3931884765625
      ],
      [
        -1136.767822265625,
        -3963.78857421875,
        701.3931884765625
      ],
      [
        -1125.2896728515625,
        -3950.141357421875,
        664.7857055664062
      ],
      [
        -1119.986572265625,
        -3933.22802734375,
        689.5886840820312
      ],
      [
        -1136.767822265625,
        -3963.78857421875,
        701.3931884765625
      ],
      [
        -1134.049560546875,
        -3965.22607421875,
        674.3606567382812
      ],
      [
        -1119.986572265625,
        -3933.22802734375,
        689.5886840820312
      ],
      [
        -1121.173583984375,
        -3932.600341796875,
        701.3931884765625
      ],
      [
        -1134.049560546875,
        -3965.22607421875,
        674.3607177734375
      ],
      [
        -1125.2896728515625,
        -3950.141357421875,
        664.7857055664062
      ],
      [
        -1120.8822021484375,
        -3932.706298828125,
        701.3931884765625
      ],
      [
        -1132.288330078125,
        -3965.419189453125,
        701.3931884765625
      ],
      [
        -1123.0167236328125,
        -3950.70947265625,
        680.412109375
      ],
      [
        -1119.473876953125,
        -3933.356201171875,
        693.113037109375
      ],
      [
        -1131.1181640625,
        -3965.958984375,
        694.5136108398438
      ],
      [
        -1123.0167236328125,
        -3950.70947265625,
        680.412109375
      ],
      [
        -1132.288330078125,
        -3965.419189453125,
        701.3931884765625
      ],
      [
        -1131.1181640625,
        -3965.958984375,
        694.5136108398438
      ],
      [
        -1119.473876953125,
        -3933.356201171875,
        693.113037109375
      ],
      [
        -1120.8822021484375,
        -3932.706298828125,
        701.3931884765625
      ],
      [
        -1131.2738037109375,
        -3976.900146484375,
        675.981201171875
      ],
      [
        -1129.0155029296875,
        -3979.47314453125,
        660.0
      ],
      [
        -1132.4517822265625,
        -3979.686279296875,
        677.02685546875
      ],
      [
        -1137.3682861328125,
        -3992.105712890625,
        679.995361328125
      ],
      [
        -1131.2738037109375,
        -3976.900146484375,
        675.981201171875
      ],
      [
        -1132.4517822265625,
        -3979.686279296875,
        677.02685546875
      ],
      [
        -1131.9461669921875,
        -3980.940185546875,
        677.2650756835938
      ],
      [
        -1132.8304443359375,
        -3984.068603515625,
        677.9910888671875
      ],
      [
        -1137.7398681640625,
        -3995.309814453125,
        680.7061157226562
      ],
      [
        -1130.826904296875,
        -3977.257568359375,
        675.981201171875
      ],
      [
        -1129.4268798828125,
        -3979.00439453125,
        662.9111938476562
      ],
      [
        -1129.677490234375,
        -3978.561279296875,
        667.9688720703125
      ],
      [
        -1130.826904296875,
        -3977.257568359375,
        675.981201171875
      ],
      [
        -1131.9461669921875,
        -3980.940185546875,
        677.2650756835938
      ],
      [
        -1138.55810546875,
        -4010.292236328125,
        674.84912109375
      ],
      [
        -1138.093505859375,
        -3998.360107421875,
        681.3827514648438
      ],
      [
        -1136.94384765625,
        -3993.487060546875,
        680.265869140625
      ],
      [
        -1128.534423828125,
        -3979.85791015625,
        660.0
      ],
      [
        -1128.84814453125,
        -3979.501953125,
        662.1871948242188
      ],
      [
        -1129.23828125,
        -3979.10888671875,
        663.8770141601562
      ],
      [
        -1129.5244140625,
        -3978.83203125,
        664.880615234375
      ],
      [
        -1138.0709228515625,
        -3995.626953125,
        683.7188110351562
      ],
      [
        -1137.0537109375,
        -3993.95263671875,
        680.37255859375
      ],
      [
        -1136.264404296875,
        -3991.931396484375,
        679.89013671875
      ],
      [
        -1136.3426513671875,
        -3992.2265625,
        679.9583129882812
      ],
      [
        -1129.527099609375,
        -3978.81787109375,
        665.128173828125
      ],
      [
        -1129.539306640625,
        -3978.8056640625,
        665.1808471679688
      ],
      [
        -1129.504638671875,
        -3978.85107421875,
        664.8112182617188
      ],
      [
        -1138.189453125,
        -3999.1875,
        681.5663452148438
      ],
      [
        -1136.3426513671875,
        -3992.2265625,
        679.9583129882812
      ],
      [
        -1135.503173828125,
        -3990.1884765625,
        679.4691772460938
      ],
      [
        -1129.558837890625,
        -3978.771240234375,
        665.574951171875
      ],
      [
        -1129.527099609375,
        -3978.81787109375,
        665.128173828125
      ],
      [
        -1138.9447021484375,
        -4005.70068359375,
        683.0112915039062
      ],
      [
        -1128.84814453125,
        -3979.501953125,
        662.1873779296875
      ],
      [
        -1128.3431396484375,
        -3980.010986328125,
        660.0
      ],
      [
        -1147.673828125,
        -4080.979736328125,
        699.7116088867188
      ],
      [
        -1192.4200439453125,
        -4170.0,
        956.3939208984375
      ],
      [
        -1180.0,
        -4003.867431640625,
        1094.863525390625
      ],
      [
        -1214.7994384765625,
        -4015.0,
        727.1101684570312
      ],
      [
        -1180.0,
        -4018.5,
        739.5
      ],
      [
        -1214.7994384765625,
        -4015.0,
        727.1101684570312
      ],
      [
        -1214.500732421875,
        -4022.0,
        728.2122802734375
      ],
      [
        -1180.0,
        -4024.20556640625,
        735.904052734375
      ],
      [
        -1214.500732421875,
        -4022.0,
        728.2122802734375
      ],
      [
        -1260.0,
        -4027.964599609375,
        705.5302734375
      ],
      [
        -1260.0,
        -4017.6591796875,
        705.0
      ],
      [
        -1260.0,
        -4016.916748046875,
        705.0
      ],
      [
        -1260.0,
        -4017.6591796875,
        705.0
      ],
      [
        -1258.62158203125,
        -4027.512939453125,
        705.6698608398438
      ],
      [
        -1258.076171875,
        -4022.968017578125,
        705.7088623046875
      ],
      [
        -1254.0,
        -4021.834228515625,
        708.4000244140625
      ],
      [
        -1257.9671630859375,
        -4022.059814453125,
        708.7967529296875
      ],
      [
        -1256.1717529296875,
        -4021.987548828125,
        708.6171875
      ],
      [
        -1256.1717529296875,
        -4021.987548828125,
        708.6171875
      ],
      [
        -1254.0,
        -4021.834228515625,
        708.4000244140625
      ],
      [
        -1254.0,
        -4027.95703125,
        708.4000244140625
      ],
      [
        -1258.6920166015625,
        -4028.099853515625,
        708.8692016601562
      ],
      [
        -1255.164794921875,
        -4027.979248046875,
        708.5164794921875
      ],
      [
        -1254.0,
        -4027.95703125,
        708.4000244140625
      ],
      [
        -1255.164794921875,
        -4027.979248046875,
        708.5164794921875
      ],
      [
        -1254.0,
        -4029.182373046875,
        714.8327026367188
      ],
      [
        -1254.0,
        -4029.182373046875,
        714.8327026367188
      ],
      [
        -1255.00341796875,
        -4029.5,
        716.5
      ],
      [
        -1258.846923828125,
        -4029.39111328125,
        716.4891357421875
      ],
      [
        -1255.00341796875,
        -4029.5,
        716.5
      ],
      [
        -1256.9456787109375,
        -4029.433837890625,
        716.493408203125
      ],
      [
        -1258.84423828125,
        -4029.369140625,
        716.4869384765625
      ],
      [
        -1254.0,
        -4024.8486328125,
        716.0693359375
      ],
      [
        -1251.5494384765625,
        -4029.237548828125,
        714.8370971679688
      ],
      [
        -1258.8387451171875,
        -4029.32373046875,
        716.482421875
      ],
      [
        -1253.4886474609375,
        -4029.13916015625,
        714.546630859375
      ],
      [
        -1251.5494384765625,
        -4029.237548828125,
        714.8370971679688
      ],
      [
        -1254.0,
        -4024.8486328125,
        716.0693359375
      ],
      [
        -1255.7164306640625,
        -4024.26123046875,
        716.0
      ],
      [
        -1258.231201171875,
        -4024.260009765625,
        715.5761108398438
      ],
      [
        -1255.7164306640625,
        -4024.26123046875,
        716.0
      ],
      [
        -1228.494140625,
        -4018.158447265625,
        722.8823852539062
      ],
      [
        -1256.41162109375,
        -4022.492431640625,
        712.7227783203125
      ],
      [
        -1258.137451171875,
        -4023.479248046875,
        714.1966552734375
      ],
      [
        -1256.41162109375,
        -4022.492431640625,
        712.7227783203125
      ],
      [
        -1254.57421875,
        -4024.652099609375,
        716.046142578125
      ],
      [
        -1254.557373046875,
        -4024.657958984375,
        716.0468139648438
      ],
      [
        -1208.4189453125,
        -4170.0,
        1302.5999755859375
      ],
      [
        -1192.4200439453125,
        -4170.0,
        956.3939208984375
      ],
      [
        -1382.9248046875,
        -4018.9423828125,
        715.0944213867188
      ],
      [
        -1385.6263427734375,
        -4003.607421875,
        718.5511474609375
      ],
      [
        -1382.9248046875,
        -4018.9423828125,
        715.0944213867188
      ],
      [
        -1349.1776123046875,
        -4026.177490234375,
        710.2824096679688
      ],
      [
        -1349.0430908203125,
        -4033.456787109375,
        708.7540893554688
      ],
      [
        -1281.6451416015625,
        -4020.145263671875,
        704.9228515625
      ],
      [
        -1281.5,
        -4026.912109375,
        703.5
      ],
      [
        -1281.6529541015625,
        -4020.153076171875,
        705.0
      ],
      [
        -1281.653076171875,
        -4028.346923828125,
        705.0
      ],
      [
        -1382.7137451171875,
        -4019.191162109375,
        715.02197265625
      ],
      [
        -622.244140625,
        -3450.85888671875,
        1505.8404541015625
      ],
      [
        -602.25048828125,
        -3312.0322265625,
        1302.5999755859375
      ],
      [
        -643.5195922851562,
        -3432.42822265625,
        1453.2525634765625
      ],
      [
        -643.4113159179688,
        -3339.25146484375,
        1302.5999755859375
      ],
      [
        -1100.0,
        -4385.80615234375,
        1534.9000244140625
      ],
      [
        -1100.0,
        -4386.7568359375,
        1364.652587890625
      ],
      [
        -1100.0,
        -4385.45263671875,
        1302.5999755859375
      ],
      [
        -1100.0,
        -4386.7568359375,
        1364.652587890625
      ],
      [
        -977.8182983398438,
        -3572.979736328125,
        1302.5999755859375
      ],
      [
        -1100.0,
        -2963.177978515625,
        1363.51953125
      ],
      [
        -1100.0,
        -2856.87744140625,
        1472.906982421875
      ],
      [
        -1100.0,
        -2963.177978515625,
        1363.51953125
      ],
      [
        -1100.0,
        -3017.20947265625,
        1302.5999755859375
      ],
      [
        -1552.1339111328125,
        -3027.011962890625,
        1501.2713623046875
      ],
      [
        -1583.84765625,
        -3013.635498046875,
        1534.9000244140625
      ],
      [
        -1509.300537109375,
        -3106.068359375,
        1384.676025390625
      ],
      [
        -1552.1339111328125,
        -3027.011962890625,
        1501.2713623046875
      ],
      [
        -1509.300537109375,
        -3106.068359375,
        1384.676025390625
      ],
      [
        -1760.0,
        -3203.987060546875,
        1302.5999755859375
      ],
      [
        -1760.0,
        -3105.5673828125,
        1459.6031494140625
      ],
      [
        -1760.0,
        -3059.423095703125,
        1534.9000244140625
      ],
      [
        -1760.0,
        -3105.5673828125,
        1459.6031494140625
      ],
      [
        -1203.6212158203125,
        -2901.427490234375,
        1449.8204345703125
      ],
      [
        -1203.6212158203125,
        -2901.427490234375,
        1449.8204345703125
      ],
      [
        -1167.873291015625,
        -2811.119384765625,
        1534.9000244140625
      ],
      [
        -1760.0,
        -3630.6875,
        1574.9000244140625
      ],
      [
        -1760.0,
        -3542.7783203125,
        1393.7564697265625
      ],
      [
        -1642.5057373046875,
        -3443.77099609375,
        1455.83544921875
      ],
      [
        -1727.3770751953125,
        -3462.68505859375,
        1302.5999755859375
      ],
      [
        -1544.56396484375,
        -3476.30908203125,
        1552.2667236328125
      ],
      [
        -1545.341552734375,
        -3478.544677734375,
        1557.000244140625
      ],
      [
        -1544.56396484375,
        -3476.30908203125,
        1552.2667236328125
      ],
      [
        -1217.202392578125,
        -3589.865234375,
        1306.0477294921875
      ],
      [
        -1217.0596923828125,
        -3589.814208984375,
        1302.5999755859375
      ],
      [
        -1550.0,
        -3439.0,
        1459.5447998046875
      ],
      [
        -1549.7508544921875,
        -3438.771728515625,
        1459.0
      ],
      [
        -1599.9825439453125,
        -3465.617431640625,
        1521.376708984375
      ],
      [
        -1545.341552734375,
        -3478.544677734375,
        1557.000244140625
      ],
      [
        -1547.0858154296875,
        -3480.648681640625,
        1562.798583984375
      ],
      [
        -1550.7261962890625,
        -3485.0400390625,
        1574.9000244140625
      ],
      [
        -1546.6260986328125,
        -3435.9072265625,
        1485.0
      ],
      [
        -1550.0,
        -3439.0,
        1497.6932373046875
      ],
      [
        -1546.78759765625,
        -3436.055419921875,
        1488.55517578125
      ],
      [
        -1546.6260986328125,
        -3435.9072265625,
        1485.0
      ],
      [
        -1545.4453125,
        -3434.824951171875,
        1459.0
      ],
      [
        -1620.0,
        -3439.0,
        1496.973388671875
      ],
      [
        -1620.8994140625,
        -3438.175537109375,
        1485.0
      ],
      [
        -1620.214599609375,
        -3438.80322265625,
        1496.0819091796875
      ],
      [
        -1534.71923828125,
        -3409.7333984375,
        1302.5999755859375
      ],
      [
        -1545.5377197265625,
        -3434.90966796875,
        1485.0
      ],
      [
        -1545.5377197265625,
        -3434.90966796875,
        1485.0
      ],
      [
        -1542.92431640625,
        -3432.51416015625,
        1477.56591796875
      ],
      [
        -1540.9151611328125,
        -3430.67236328125,
        1459.0
      ],
      [
        -1642.5057373046875,
        -3443.77099609375,
        1455.83544921875
      ],
      [
        -1637.2723388671875,
        -3382.0,
        1302.5999755859375
      ],
      [
        -1634.29931640625,
        -3382.0,
        1345.208984375
      ],
      [
        -1634.7877197265625,
        -3386.785888671875,
        1355.8927001953125
      ],
      [
        -1622.8826904296875,
        -3436.357666015625,
        1485.0
      ],
      [
        -1634.787841796875,
        -3386.786865234375,
        1355.8946533203125
      ],
      [
        -1634.29931640625,
        -3382.0,
        1345.2088623046875
      ],
      [
        -1634.2630615234375,
        -3382.0,
        1347.219482421875
      ],
      [
        -1760.0,
        -3526.5615234375,
        1368.846435546875
      ],
      [
        -1760.0,
        -3542.7783203125,
        1393.7564697265625
      ],
      [
        -1760.0,
        -3526.5615234375,
        1368.846435546875
      ],
      [
        -1620.0,
        -3439.0,
        1499.5546875
      ],
      [
        -1620.214599609375,
        -3438.80322265625,
        1496.0819091796875
      ],
      [
        -1633.61083984375,
        -3382.0,
        1383.4417724609375
      ],
      [
        -1629.2470703125,
        -3430.5234375,
        1485.0
      ],
      [
        -1624.6888427734375,
        -3434.701904296875,
        1503.2625732421875
      ],
      [
        -1624.184326171875,
        -3435.164306640625,
        1505.0
      ],
      [
        -1632.0,
        -3428.0,
        1473.971435546875
      ],
      [
        -1632.0,
        -3420.07177734375,
        1459.0
      ],
      [
        -1633.3604736328125,
        -3382.0,
        1397.349365234375
      ],
      [
        -1633.395751953125,
        -3383.444091796875,
        1406.7978515625
      ],
      [
        -1632.0,
        -3428.0,
        1478.0806884765625
      ],
      [
        -1632.0,
        -3415.578125,
        1459.0
      ],
      [
        -1629.9910888671875,
        -3429.841552734375,
        1485.0
      ],
      [
        -1633.395751953125,
        -3383.444091796875,
        1406.7977294921875
      ],
      [
        -1633.3604736328125,
        -3382.0,
        1397.3492431640625
      ],
      [
        -1633.291748046875,
        -3382.0,
        1404.7913818359375
      ],
      [
        -1627.617431640625,
        -3390.847900390625,
        1485.0
      ],
      [
        -1629.9166259765625,
        -3392.763916015625,
        1505.0
      ],
      [
        -1627.617431640625,
        -3390.847900390625,
        1485.0
      ],
      [
        -1624.62841796875,
        -3388.35693359375,
        1459.0
      ],
      [
        -1633.0465087890625,
        -3387.20556640625,
        1479.166748046875
      ],
      [
        -1632.9208984375,
        -3382.0,
        1444.9298095703125
      ],
      [
        -1552.311279296875,
        -3382.0,
        1312.15576171875
      ],
      [
        -1551.8511962890625,
        -3382.0,
        1302.5999755859375
      ],
      [
        -1632.6080322265625,
        -3382.0,
        1478.7926025390625
      ],
      [
        -1620.0,
        -3384.5,
        1500.3006591796875
      ],
      [
        -1621.736328125,
        -3385.947021484375,
        1505.0
      ],
      [
        -1538.0,
        -3428.0,
        1463.557861328125
      ],
      [
        -1538.0,
        -3428.0,
        1463.557861328125
      ],
      [
        -1538.0,
        -3425.24755859375,
        1459.0
      ],
      [
        -1543.1268310546875,
        -3383.273681640625,
        1396.290771484375
      ],
      [
        -1544.6763916015625,
        -3382.0,
        1384.2362060546875
      ],
      [
        -1552.311279296875,
        -3382.0,
        1312.15576171875
      ],
      [
        -1544.6763916015625,
        -3382.0,
        1384.2362060546875
      ],
      [
        -1543.1268310546875,
        -3383.273681640625,
        1396.290771484375
      ],
      [
        -1543.5052490234375,
        -3382.0,
        1394.68359375
      ],
      [
        -1192.1842041015625,
        -3610.783447265625,
        1307.5003662109375
      ],
      [
        -1191.810546875,
        -3610.853271484375,
        1302.5999755859375
      ],
      [
        -1166.3531494140625,
        -3632.38134765625,
        1309.000244140625
      ],
      [
        -1165.968505859375,
        -3632.38623046875,
        1302.5999755859375
      ],
      [
        -1156.126708984375,
        -3776.983642578125,
        1534.9000244140625
      ],
      [
        -1152.5513916015625,
        -3744.62109375,
        1476.563720703125
      ],
      [
        -1149.1083984375,
        -3646.800048828125,
        1310.0015869140625
      ],
      [
        -1141.8896484375,
        -3695.3720703125,
        1302.5999755859375
      ],
      [
        -1146.9715576171875,
        -3694.11376953125,
        1385.519775390625
      ],
      [
        -1149.1083984375,
        -3646.800048828125,
        1310.00146484375
      ],
      [
        -1152.5513916015625,
        -3744.62109375,
        1476.563720703125
      ],
      [
        -1148.0684814453125,
        -3718.9775390625,
        1428.1500244140625
      ],
      [
        -1146.8795166015625,
        -3696.152099609375,
        1388.7730712890625
      ],
      [
        -1148.0684814453125,
        -3718.9775390625,
        1428.1500244140625
      ],
      [
        -1146.8795166015625,
        -3696.152099609375,
        1388.7730712890625
      ],
      [
        -1163.4052734375,
        -3646.800048828125,
        1551.6312255859375
      ],
      [
        -1163.4052734375,
        -3646.800048828125,
        1551.6312255859375
      ],
      [
        -1163.525146484375,
        -3650.26513671875,
        1561.8316650390625
      ],
      [
        -1163.525146484375,
        -3650.26513671875,
        1561.8316650390625
      ],
      [
        -1163.990966796875,
        -3653.395263671875,
        1571.2440185546875
      ],
      [
        -1547.0858154296875,
        -3480.648681640625,
        1562.798583984375
      ],
      [
        -1542.77392578125,
        -3432.376220703125,
        1485.0
      ],
      [
        -1547.946533203125,
        -3437.11767578125,
        1505.0
      ],
      [
        -1542.77392578125,
        -3432.376220703125,
        1485.0
      ],
      [
        -1538.0,
        -3428.0,
        1466.54052734375
      ],
      [
        -1605.670654296875,
        -3384.5,
        1505.0
      ],
      [
        -1604.445068359375,
        -3384.5,
        1502.63720703125
      ],
      [
        -1538.0,
        -3428.0,
        1466.54052734375
      ],
      [
        -1538.0,
        -3424.4345703125,
        1459.0
      ],
      [
        -1563.4156494140625,
        -3384.5,
        1531.309814453125
      ],
      [
        -1554.9222412109375,
        -3384.5,
        1526.001220703125
      ],
      [
        -1554.9222412109375,
        -3384.5,
        1526.001220703125
      ],
      [
        -1554.422119140625,
        -3384.5,
        1526.8013916015625
      ],
      [
        -1573.5,
        -3382.0,
        1486.5
      ],
      [
        -1557.0,
        -3382.0,
        1486.5
      ],
      [
        -1563.3309326171875,
        -3382.0,
        1531.2568359375
      ],
      [
        -1554.83740234375,
        -3382.0,
        1525.9482421875
      ],
      [
        -1554.83740234375,
        -3382.0,
        1525.9482421875
      ],
      [
        -1554.3372802734375,
        -3382.0,
        1526.7484130859375
      ],
      [
        -1557.0,
        -3382.0,
        1488.0
      ],
      [
        -1557.0,
        -3382.0,
        1486.5
      ],
      [
        -1536.1141357421875,
        -3382.0,
        1460.61669921875
      ],
      [
        -1547.0,
        -3329.227294921875,
        1485.0
      ],
      [
        -1547.0,
        -3329.5,
        1488.0
      ],
      [
        -1627.0,
        -3329.5,
        1488.0
      ],
      [
        -1627.0,
        -3329.227294921875,
        1485.0
      ],
      [
        -1554.891845703125,
        -3372.608154296875,
        1496.0
      ],
      [
        -1552.108154296875,
        -3372.608154296875,
        1496.0
      ],
      [
        -1554.891845703125,
        -3375.391845703125,
        1496.0
      ],
      [
        -1552.108154296875,
        -3375.391845703125,
        1496.0
      ],
      [
        -1552.108154296875,
        -3375.391845703125,
        1496.0
      ],
      [
        -1552.108154296875,
        -3372.608154296875,
        1496.0
      ],
      [
        -1554.891845703125,
        -3334.891845703125,
        1496.0
      ],
      [
        -1552.108154296875,
        -3334.891845703125,
        1496.0
      ],
      [
        -1552.108154296875,
        -3334.891845703125,
        1496.0
      ],
      [
        -1552.108154296875,
        -3332.108154296875,
        1496.0
      ],
      [
        -1554.891845703125,
        -3332.108154296875,
        1496.0
      ],
      [
        -1552.108154296875,
        -3332.108154296875,
        1496.0
      ],
      [
        -1549.0,
        -3378.5,
        1482.0
      ],
      [
        -1548.5,
        -3375.0,
        1482.0
      ],
      [
        -1548.5,
        -3375.0,
        1485.0
      ],
      [
        -1548.5,
        -3375.0,
        1482.0
      ],
      [
        -1625.5,
        -3330.0,
        1485.0
      ],
      [
        -1625.5,
        -3333.0,
        1485.0
      ],
      [
        -1625.5,
        -3333.0,
        1482.0
      ],
      [
        -1625.5,
        -3330.0,
        1482.0
      ],
      [
        -1625.5,
        -3330.0,
        1482.0
      ],
      [
        -1625.5,
        -3333.0,
        1482.0
      ],
      [
        -1552.5,
        -3330.0,
        1482.0
      ],
      [
        -1552.5,
        -3333.0,
        1482.0
      ],
      [
        -1549.0,
        -3329.5,
        1482.0
      ],
      [
        -1549.0,
        -3329.5,
        1485.0
      ],
      [
        -1549.0,
        -3329.5,
        1482.0
      ],
      [
        -1548.5,
        -3333.0,
        1482.0
      ],
      [
        -1548.5,
        -3333.0,
        1485.0
      ],
      [
        -1548.5,
        -3333.0,
        1482.0
      ],
      [
        -1632.8424072265625,
        -3372.64794921875,
        1302.5999755859375
      ],
      [
        -1636.6453857421875,
        -3382.0,
        1311.5850830078125
      ],
      [
        -1552.4217529296875,
        -3381.076416015625,
        1302.5999755859375
      ],
      [
        -1551.9346923828125,
        -3382.0,
        1304.333251953125
      ],
      [
        -1582.3048095703125,
        -3364.035400390625,
        1529.2672119140625
      ],
      [
        -1593.5556640625,
        -3359.504638671875,
        1513.9002685546875
      ],
      [
        -1631.9603271484375,
        -3321.473388671875,
        1503.693359375
      ],
      [
        -1620.1619873046875,
        -3336.699462890625,
        1500.197509765625
      ],
      [
        -1554.5999755859375,
        -3374.989013671875,
        1525.7999267578125
      ],
      [
        -1554.5999755859375,
        -3373.0107421875,
        1525.7999267578125
      ],
      [
        -1554.8775634765625,
        -3373.01318359375,
        1525.973388671875
      ],
      [
        -1554.8839111328125,
        -3374.986572265625,
        1525.9774169921875
      ],
      [
        -1554.8839111328125,
        -3374.986572265625,
        1525.9774169921875
      ],
      [
        -1563.090576171875,
        -3374.917236328125,
        1531.106689453125
      ],
      [
        -1554.8775634765625,
        -3373.01318359375,
        1525.973388671875
      ],
      [
        -1563.090576171875,
        -3373.08251953125,
        1531.106689453125
      ],
      [
        -1621.6109619140625,
        -3334.829345703125,
        1500.6268310546875
      ],
      [
        -1616.9332275390625,
        -3334.850341796875,
        1499.0863037109375
      ],
      [
        -1592.4892578125,
        -3334.821044921875,
        1501.25244140625
      ],
      [
        -1599.06689453125,
        -3334.850341796875,
        1499.0863037109375
      ],
      [
        -1579.2174072265625,
        -3334.724609375,
        1508.380615234375
      ],
      [
        -1592.4892578125,
        -3334.821044921875,
        1501.25244140625
      ],
      [
        -1574.6907958984375,
        -3334.6806640625,
        1511.629150390625
      ],
      [
        -1579.2174072265625,
        -3334.724609375,
        1508.380615234375
      ],
      [
        -1574.92041015625,
        -3334.67431640625,
        1512.1103515625
      ],
      [
        -1574.6907958984375,
        -3334.6806640625,
        1511.629150390625
      ],
      [
        -1554.5999755859375,
        -3334.4892578125,
        1525.7999267578125
      ],
      [
        -1554.8775634765625,
        -3334.48681640625,
        1525.973388671875
      ],
      [
        -1554.8775634765625,
        -3334.48681640625,
        1525.973388671875
      ],
      [
        -1563.090576171875,
        -3334.41748046875,
        1531.106689453125
      ],
      [
        -1553.320068359375,
        -3332.5,
        1525.0
      ],
      [
        -1553.320068359375,
        -3332.5,
        1525.0
      ],
      [
        -1552.4930419921875,
        -3332.492919921875,
        1524.4830322265625
      ],
      [
        -1554.5506591796875,
        -3332.44921875,
        1521.2489013671875
      ],
      [
        -1552.4644775390625,
        -3332.464599609375,
        1522.3746337890625
      ],
      [
        -1554.6533203125,
        -3332.3466796875,
        1513.6531982421875
      ],
      [
        -1552.35693359375,
        -3332.35693359375,
        1514.4100341796875
      ],
      [
        -1554.7879638671875,
        -3332.212158203125,
        1503.6915283203125
      ],
      [
        -1552.2159423828125,
        -3332.2158203125,
        1503.975830078125
      ],
      [
        -1554.784423828125,
        -3334.487548828125,
        1525.9151611328125
      ],
      [
        -1554.7855224609375,
        -3334.4912109375,
        1525.9158935546875
      ],
      [
        -1554.7855224609375,
        -3334.4912109375,
        1525.9158935546875
      ],
      [
        -1559.3817138671875,
        -3344.282470703125,
        1528.78857421875
      ],
      [
        -1555.8203125,
        -3337.707763671875,
        1526.562744140625
      ],
      [
        -1559.3817138671875,
        -3344.282470703125,
        1528.78857421875
      ],
      [
        -1558.63232421875,
        -3344.29443359375,
        1529.432861328125
      ],
      [
        -1554.3109130859375,
        -3334.5,
        1526.2623291015625
      ],
      [
        -1554.1160888671875,
        -3334.97802734375,
        1526.6102294921875
      ],
      [
        -1554.3109130859375,
        -3334.5,
        1526.2623291015625
      ],
      [
        -1553.9921875,
        -3334.5,
        1526.492431640625
      ],
      [
        -1554.634521484375,
        -3335.5185546875,
        1525.821533203125
      ],
      [
        -1554.1514892578125,
        -3336.022216796875,
        1526.63232421875
      ],
      [
        -1554.634521484375,
        -3335.5185546875,
        1525.821533203125
      ],
      [
        -1554.513916015625,
        -3334.5,
        1525.1114501953125
      ],
      [
        -1553.48388671875,
        -3334.5,
        1525.9840087890625
      ],
      [
        -1554.8863525390625,
        -3342.93994140625,
        1525.978759765625
      ],
      [
        -1554.3966064453125,
        -3343.245849609375,
        1526.7855224609375
      ],
      [
        -1556.1658935546875,
        -3344.434326171875,
        1526.778564453125
      ],
      [
        -1554.8863525390625,
        -3342.93994140625,
        1525.978759765625
      ],
      [
        -1556.1658935546875,
        -3344.434326171875,
        1526.778564453125
      ],
      [
        -1555.4239501953125,
        -3344.44580078125,
        1527.4276123046875
      ],
      [
        -1553.3201904296875,
        -3373.0,
        1525.0
      ],
      [
        -3080.90087890625,
        -3903.1513671875,
        1082.623779296875
      ],
      [
        -3080.90576171875,
        -3903.15185546875,
        1139.785888671875
      ],
      [
        -3085.076904296875,
        -3903.60498046875,
        1187.623779296875
      ],
      [
        -3080.909912109375,
        -3903.15234375,
        1187.623779296875
      ],
      [
        -2010.0,
        -3394.35986328125,
        1007.42724609375
      ],
      [
        -2010.0,
        -3336.106689453125,
        1160.166015625
      ],
      [
        -2010.0,
        -3336.106689453125,
        1160.166015625
      ],
      [
        -2010.0,
        -3271.035888671875,
        1302.5999755859375
      ],
      [
        -2010.0,
        -3490.472412109375,
        1109.14892578125
      ],
      [
        -2010.0,
        -3440.84375,
        1011.8688354492188
      ],
      [
        -1945.0341796875,
        -3544.979736328125,
        1233.892822265625
      ],
      [
        -1945.0,
        -3545.0,
        1233.8914794921875
      ],
      [
        -1945.0955810546875,
        -3544.943359375,
        1233.895263671875
      ],
      [
        -1958.655029296875,
        -3536.908203125,
        1219.030029296875
      ],
      [
        -2010.0,
        -3506.4814453125,
        1140.5296630859375
      ],
      [
        -2010.0,
        -3506.4814453125,
        1114.91552734375
      ],
      [
        -1945.0341796875,
        -3544.979736328125,
        1233.892822265625
      ],
      [
        -1945.0,
        -3545.0,
        1233.8914794921875
      ],
      [
        -1944.74267578125,
        -3545.23583984375,
        1234.0
      ],
      [
        -1812.5399169921875,
        -3483.12548828125,
        1167.27783203125
      ],
      [
        -1809.959716796875,
        -3551.677978515625,
        1302.5999755859375
      ],
      [
        -1822.9830322265625,
        -3407.556884765625,
        1000.8163452148438
      ],
      [
        -1822.9830322265625,
        -3407.556884765625,
        1000.8163452148438
      ],
      [
        -1826.2652587890625,
        -3393.506103515625,
        966.8154296875
      ],
      [
        -1826.2652587890625,
        -3393.506103515625,
        966.8154296875
      ],
      [
        -1816.41650390625,
        -3380.125732421875,
        963.95751953125
      ],
      [
        -1760.0,
        -3362.54541015625,
        950.2199096679688
      ],
      [
        -1760.0,
        -3462.17236328125,
        1145.504638671875
      ],
      [
        -1812.5399169921875,
        -3483.12548828125,
        1167.27783203125
      ],
      [
        -1760.0,
        -3491.47998046875,
        1302.5999755859375
      ],
      [
        -1813.3851318359375,
        -3376.00732421875,
        963.077880859375
      ],
      [
        -1816.41650390625,
        -3380.125732421875,
        963.95751953125
      ],
      [
        -1790.718017578125,
        -3344.77978515625,
        955.6844482421875
      ],
      [
        -1813.3851318359375,
        -3376.00732421875,
        963.077880859375
      ],
      [
        -2010.0,
        -3440.84375,
        1011.8688354492188
      ],
      [
        -2010.0,
        -3424.79638671875,
        1010.5689086914062
      ],
      [
        -2010.0,
        -3424.79638671875,
        1010.5689086914062
      ],
      [
        -2010.0,
        -3394.35986328125,
        1007.42724609375
      ],
      [
        -2010.0,
        -3506.4814453125,
        1162.74072265625
      ],
      [
        -2010.0,
        -3383.088623046875,
        1036.9803466796875
      ],
      [
        -2010.0,
        -3396.96630859375,
        1007.6962890625
      ],
      [
        -2010.0,
        -3405.365966796875,
        1008.5632934570312
      ],
      [
        -2105.0,
        -3430.0,
        1029.0665283203125
      ],
      [
        -2097.0009765625,
        -3421.197998046875,
        1027.69921875
      ],
      [
        -2097.061767578125,
        -3421.0947265625,
        1027.7003173828125
      ],
      [
        -2097.0009765625,
        -3421.197998046875,
        1027.69921875
      ],
      [
        -2010.0,
        -3441.03564453125,
        1012.2451171875
      ],
      [
        -2010.0,
        -3444.63427734375,
        1019.2987060546875
      ],
      [
        -1760.0,
        -3196.338134765625,
        1314.8016357421875
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        -0.7832221984863281,
        -0.4408717155456543,
        0.43840065598487854
      ],
      "plane_d": -2407.586669921875,
      "bbox_min": [
        -660.0,
        -3350.221435546875,
        1094.86962890625
      ],
      "bbox_max": [
        -513.5322265625,
        -2993.1591796875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4566386640071869,
        0.6905266642570496,
        0.5609403848648071
      ],
      "plane_d": 1281.354736328125,
      "bbox_min": [
        -660.0,
        -3253.36376953125,
        1094.86962890625
      ],
      "bbox_max": [
        -513.5322265625,
        -3153.4228515625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7552521228790283,
        -0.561424732208252,
        0.3382256329059601
      ],
      "plane_d": -2654.937744140625,
      "bbox_min": [
        -660.0,
        -3253.36376953125,
        1094.86962890625
      ],
      "bbox_max": [
        -513.5322265625,
        -3153.4228515625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4566386640071869,
        0.6905266642570496,
        0.5609403848648071
      ],
      "plane_d": 1281.354736328125,
      "bbox_min": [
        -660.0,
        -3350.221435546875,
        1104.97119140625
      ],
      "bbox_max": [
        -513.5322265625,
        -3189.680419921875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": 0.0,
      "bbox_min": [
        -1236.751220703125,
        -3650.0,
        0.0
      ],
      "bbox_max": [
        -917.23828125,
        -3394.232421875,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6477525234222412,
        -0.7609485387802124,
        0.03706754744052887
      ],
      "plane_d": -3420.204345703125,
      "bbox_min": [
        -1224.5528564453125,
        -3650.0,
        0.0
      ],
      "bbox_max": [
        -977.0939331054688,
        -3394.232421875,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8973290324211121,
        -0.4287506937980652,
        0.1047549843788147
      ],
      "plane_d": -2564.411865234375,
      "bbox_min": [
        -1208.414794921875,
        -3440.52197265625,
        225.0
      ],
      "bbox_max": [
        -1182.7503662109375,
        -3394.232421875,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8235416412353516,
        -0.5580507516860962,
        0.10177668184041977
      ],
      "plane_d": -2915.920166015625,
      "bbox_min": [
        -1208.414794921875,
        -3409.848388671875,
        225.0
      ],
      "bbox_max": [
        -1198.09375,
        -3394.232421875,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6944899559020996,
        -0.6407128572463989,
        0.3273695409297943
      ],
      "plane_d": -1423.39990234375,
      "bbox_min": [
        -1208.414794921875,
        -3409.848388671875,
        225.0
      ],
      "bbox_max": [
        -1202.3095703125,
        -3394.232421875,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1290990114212036,
        -0.8996244668960571,
        0.41714420914649963
      ],
      "plane_d": -3006.223388671875,
      "bbox_min": [
        -1224.5528564453125,
        -3507.97802734375,
        0.0
      ],
      "bbox_max": [
        -1159.1053466796875,
        -3395.00634765625,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04223942756652832,
        -0.9113441109657288,
        0.4094725549221039
      ],
      "plane_d": -3270.52197265625,
      "bbox_min": [
        -1224.50634765625,
        -3412.709228515625,
        265.3875427246094
      ],
      "bbox_max": [
        -1223.98681640625,
        -3411.963134765625,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9405732750892639,
        -0.10687936842441559,
        0.3223331570625305
      ],
      "plane_d": 700.9578857421875,
      "bbox_min": [
        -1224.50634765625,
        -3412.709228515625,
        265.3875427246094
      ],
      "bbox_max": [
        -1223.98681640625,
        -3411.963134765625,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9691129922866821,
        0.23761551082134247,
        0.06602242588996887
      ],
      "plane_d": 1979.57275390625,
      "bbox_min": [
        -1224.5528564453125,
        -3466.518310546875,
        120.43780517578125
      ],
      "bbox_max": [
        -1200.9185791015625,
        -3395.00634765625,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9327303767204285,
        0.12842270731925964,
        0.33692970871925354
      ],
      "plane_d": 1490.5020751953125,
      "bbox_min": [
        -1224.5528564453125,
        -3448.7548828125,
        252.16676330566406
      ],
      "bbox_max": [
        -1214.2481689453125,
        -3412.418212890625,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9405732750892639,
        -0.10687936842441559,
        0.3223331570625305
      ],
      "plane_d": 700.9578857421875,
      "bbox_min": [
        -1224.5528564453125,
        -3412.828125,
        265.3875427246094
      ],
      "bbox_max": [
        -1223.98681640625,
        -3412.418212890625,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6944899559020996,
        -0.6407128572463989,
        0.3273695409297943
      ],
      "plane_d": -1423.39990234375,
      "bbox_min": [
        -1224.1302490234375,
        -3412.709228515625,
        225.0
      ],
      "bbox_max": [
        -1202.3095703125,
        -3395.00634765625,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04223942756652832,
        -0.9113441109657288,
        0.4094725549221039
      ],
      "plane_d": -3270.52197265625,
      "bbox_min": [
        -1224.1302490234375,
        -3412.709228515625,
        265.3875427246094
      ],
      "bbox_max": [
        -1223.98681640625,
        -3411.97802734375,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6831920742988586,
        -0.7259601950645447,
        0.07893336564302444
      ],
      "plane_d": -3338.5439453125,
      "bbox_min": [
        -1220.430419921875,
        -3650.0,
        0.0
      ],
      "bbox_max": [
        -977.0939331054688,
        -3442.76953125,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6572308540344238,
        -0.7498543858528137,
        0.07593389600515366
      ],
      "plane_d": -3399.419189453125,
      "bbox_min": [
        -1011.593017578125,
        -3650.0,
        0.0
      ],
      "bbox_max": [
        -977.0939331054688,
        -3646.800048828125,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6998437643051147,
        -0.7020972967147827,
        0.13144628703594208
      ],
      "plane_d": -3268.36572265625,
      "bbox_min": [
        -1011.593017578125,
        -3650.0,
        0.0
      ],
      "bbox_max": [
        -1007.23779296875,
        -3646.800048828125,
        6.09613037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7116605639457703,
        0.7005480527877808,
        0.05264675244688988
      ],
      "plane_d": 3300.78955078125,
      "bbox_min": [
        -1220.430419921875,
        -3650.0,
        0.0
      ],
      "bbox_max": [
        -1007.8887329101562,
        -3442.76953125,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7090446352958679,
        0.7030144929885864,
        0.055013131350278854
      ],
      "plane_d": 3306.3583984375,
      "bbox_min": [
        -1204.3563232421875,
        -3650.0,
        0.0
      ],
      "bbox_max": [
        -1045.9185791015625,
        -3508.329345703125,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9034790992736816,
        0.42338916659355164,
        0.06683698296546936
      ],
      "plane_d": 2491.129150390625,
      "bbox_min": [
        -1203.686767578125,
        -3650.0,
        0.0
      ],
      "bbox_max": [
        -1045.9185791015625,
        -3509.99755859375,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7080089449882507,
        0.7036092877388,
        0.06047677621245384
      ],
      "plane_d": 3305.96240234375,
      "bbox_min": [
        -1203.686767578125,
        -3646.800048828125,
        228.19198608398438
      ],
      "bbox_max": [
        -1068.0478515625,
        -3509.99755859375,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9202737212181091,
        0.3693651854991913,
        0.12909552454948425
      ],
      "plane_d": 2369.723876953125,
      "bbox_min": [
        -1203.474609375,
        -3515.152099609375,
        228.19198608398438
      ],
      "bbox_max": [
        -1196.587890625,
        -3510.526123046875,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9202737212181091,
        0.3693651854991913,
        0.12909552454948425
      ],
      "plane_d": 2369.723876953125,
      "bbox_min": [
        -1203.686767578125,
        -3514.12060546875,
        228.19198608398438
      ],
      "bbox_max": [
        -1196.587890625,
        -3509.99755859375,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7952687740325928,
        0.5908210277557373,
        0.13593456149101257
      ],
      "plane_d": 2988.283203125,
      "bbox_min": [
        -1048.2958984375,
        -3650.0,
        0.0
      ],
      "bbox_max": [
        -1045.9185791015625,
        -3646.800048828125,
        9.053411483764648
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9691129922866821,
        0.23761551082134247,
        0.06602242588996887
      ],
      "plane_d": 1979.57275390625,
      "bbox_min": [
        -1204.3563232421875,
        -3514.12060546875,
        0.0
      ],
      "bbox_max": [
        -1181.751220703125,
        -3508.329345703125,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9202737212181091,
        0.3693651854991913,
        0.12909552454948425
      ],
      "plane_d": 2369.723876953125,
      "bbox_min": [
        -1204.3563232421875,
        -3514.12060546875,
        228.19198608398438
      ],
      "bbox_max": [
        -1196.587890625,
        -3508.329345703125,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9327303767204285,
        0.12842270731925964,
        0.33692970871925354
      ],
      "plane_d": 1490.5020751953125,
      "bbox_min": [
        -1197.494384765625,
        -3514.12060546875,
        228.19198608398438
      ],
      "bbox_max": [
        -1196.587890625,
        -3512.52685546875,
        230.0940399169922
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9691129922866821,
        0.23761551082134247,
        0.06602242588996887
      ],
      "plane_d": 1979.57275390625,
      "bbox_min": [
        -1220.430419921875,
        -3650.0,
        0.0
      ],
      "bbox_max": [
        -1007.8887329101562,
        -3442.76953125,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9327303767204285,
        0.12842270731925964,
        0.33692970871925354
      ],
      "plane_d": 1490.5020751953125,
      "bbox_min": [
        -1220.430419921875,
        -3513.037353515625,
        228.58932495117188
      ],
      "bbox_max": [
        -1196.880615234375,
        -3442.76953125,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9202737212181091,
        0.3693651854991913,
        0.12909552454948425
      ],
      "plane_d": 2369.723876953125,
      "bbox_min": [
        -1215.0838623046875,
        -3512.52685546875,
        230.0940399169922
      ],
      "bbox_max": [
        -1197.494384765625,
        -3481.6015625,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7149500250816345,
        -0.6106722354888916,
        0.3404790163040161
      ],
      "plane_d": -1299.316162109375,
      "bbox_min": [
        -1200.9185791015625,
        -3650.0,
        0.0
      ],
      "bbox_max": [
        -1007.8887329101562,
        -3466.518310546875,
        120.43780517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1290990114212036,
        -0.8996244668960571,
        0.41714420914649963
      ],
      "plane_d": -3006.223388671875,
      "bbox_min": [
        -1188.102294921875,
        -3650.0,
        0.0
      ],
      "bbox_max": [
        -1007.8887329101562,
        -3479.90869140625,
        69.50926208496094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6998437643051147,
        -0.7020972967147827,
        0.13144628703594208
      ],
      "plane_d": -3268.36572265625,
      "bbox_min": [
        -1011.593017578125,
        -3650.0,
        0.0
      ],
      "bbox_max": [
        -1007.8887329101562,
        -3646.800048828125,
        2.6302847862243652
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2930.0,
      "bbox_min": [
        -1760.0,
        -3650.0,
        267.0
      ],
      "bbox_max": [
        -660.0,
        -2382.162353515625,
        1302.5999755859375
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.00834949966520071,
        0.011480561457574368,
        0.9998992085456848
      ],
      "plane_d": -605.692626953125,
      "bbox_min": [
        -852.0359497070312,
        -2450.52392578125,
        640.3125
      ],
      "bbox_max": [
        -789.134033203125,
        -2400.9833984375,
        687.8262939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.675027072429657,
        -0.49037832021713257,
        -0.5512418150901794
      ],
      "plane_d": -246.33090209960938,
      "bbox_min": [
        -852.0359497070312,
        -2450.52392578125,
        640.3125
      ],
      "bbox_max": [
        -789.134033203125,
        -2400.9833984375,
        687.8262939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7721387147903442,
        -0.5362740755081177,
        0.34089893102645874
      ],
      "plane_d": -867.376708984375,
      "bbox_min": [
        -852.0359497070312,
        -2450.52392578125,
        640.3125
      ],
      "bbox_max": [
        -789.134033203125,
        -2400.9833984375,
        687.8262939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7694186568260193,
        -0.5282776355743408,
        0.35905107855796814
      ],
      "plane_d": -862.0191650390625,
      "bbox_min": [
        -846.2428588867188,
        -2450.52392578125,
        640.3125
      ],
      "bbox_max": [
        -789.134033203125,
        -2405.9833984375,
        687.8262939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6145997047424316,
        -0.3962254226207733,
        -0.682108998298645
      ],
      "plane_d": 20.72467041015625,
      "bbox_min": [
        -841.2787475585938,
        -2450.52392578125,
        640.3125
      ],
      "bbox_max": [
        -789.134033203125,
        -2410.9833984375,
        687.8262939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.007539494428783655,
        0.012942798435688019,
        0.9998877644538879
      ],
      "plane_d": -602.7625122070312,
      "bbox_min": [
        -806.9904174804688,
        -2450.52392578125,
        640.3125
      ],
      "bbox_max": [
        -789.134033203125,
        -2435.9833984375,
        640.5751342773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.007539494428783655,
        0.012942798435688019,
        0.9998877644538879
      ],
      "plane_d": -602.7625122070312,
      "bbox_min": [
        -904.4310913085938,
        -2530.56689453125,
        640.5693969726562
      ],
      "bbox_max": [
        -798.2432250976562,
        -2421.921875,
        696.3748168945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.00834949966520071,
        0.011480561457574368,
        0.9998992085456848
      ],
      "plane_d": -605.692626953125,
      "bbox_min": [
        -904.4310913085938,
        -2530.56689453125,
        640.5751342773438
      ],
      "bbox_max": [
        -806.9904174804688,
        -2421.921875,
        696.3748168945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6145997047424316,
        -0.3962254226207733,
        -0.682108998298645
      ],
      "plane_d": 20.72467041015625,
      "bbox_min": [
        -904.4310913085938,
        -2530.56689453125,
        640.658935546875
      ],
      "bbox_max": [
        -836.911376953125,
        -2421.921875,
        696.3748168945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5358163714408875,
        -0.5204083919525146,
        -0.6648879051208496
      ],
      "plane_d": -370.36444091796875,
      "bbox_min": [
        -904.4310913085938,
        -2512.5654296875,
        665.9375
      ],
      "bbox_max": [
        -877.5479736328125,
        -2487.185546875,
        696.2402954101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6902700662612915,
        -0.46761155128479004,
        -0.552147388458252
      ],
      "plane_d": -175.41311645507812,
      "bbox_min": [
        -904.4310913085938,
        -2512.5654296875,
        665.9375
      ],
      "bbox_max": [
        -877.5479736328125,
        -2487.185546875,
        696.2402954101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07835977524518967,
        -0.35017022490501404,
        -0.9334027171134949
      ],
      "plane_d": -298.9742431640625,
      "bbox_min": [
        -904.4310913085938,
        -2512.5654296875,
        665.9375
      ],
      "bbox_max": [
        -877.5479736328125,
        -2487.185546875,
        696.2402954101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8801541328430176,
        -0.36512237787246704,
        0.3033384680747986
      ],
      "plane_d": -319.669677734375,
      "bbox_min": [
        -904.4310913085938,
        -2500.1484375,
        665.9375
      ],
      "bbox_max": [
        -898.0948486328125,
        -2487.185546875,
        668.8807983398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7694186568260193,
        -0.5282776355743408,
        0.35905107855796814
      ],
      "plane_d": -862.0191650390625,
      "bbox_min": [
        -904.178466796875,
        -2530.56689453125,
        640.658935546875
      ],
      "bbox_max": [
        -841.2787475585938,
        -2421.921875,
        696.3748168945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.675027072429657,
        -0.49037832021713257,
        -0.5512418150901794
      ],
      "plane_d": -246.33090209960938,
      "bbox_min": [
        -904.178466796875,
        -2530.56689453125,
        641.796875
      ],
      "bbox_max": [
        -841.2787475585938,
        -2421.921875,
        696.3748168945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7721387147903442,
        -0.5362740755081177,
        0.34089893102645874
      ],
      "plane_d": -867.376708984375,
      "bbox_min": [
        -904.178466796875,
        -2530.56689453125,
        641.796875
      ],
      "bbox_max": [
        -841.7667236328125,
        -2421.921875,
        696.3748168945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08756548166275024,
        0.15032073855400085,
        0.9847517609596252
      ],
      "plane_d": -179.49295043945312,
      "bbox_min": [
        -904.178466796875,
        -2530.56689453125,
        641.796875
      ],
      "bbox_max": [
        -841.7667236328125,
        -2487.185546875,
        696.3748168945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.038054414093494415,
        0.13913646340370178,
        0.98954176902771
      ],
      "plane_d": -254.50421142578125,
      "bbox_min": [
        -896.3795776367188,
        -2509.9560546875,
        641.796875
      ],
      "bbox_max": [
        -885.7332153320312,
        -2491.873046875,
        644.2561645507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8587960600852966,
        -0.3669477105140686,
        0.3575173616409302
      ],
      "plane_d": -379.470947265625,
      "bbox_min": [
        -896.3795776367188,
        -2504.37890625,
        641.796875
      ],
      "bbox_max": [
        -890.0479736328125,
        -2491.873046875,
        644.2561645507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20010554790496826,
        -0.33017414808273315,
        -0.9224656224250793
      ],
      "plane_d": -363.43182373046875,
      "bbox_min": [
        -904.178466796875,
        -2524.273193359375,
        641.796875
      ],
      "bbox_max": [
        -851.7667236328125,
        -2487.185546875,
        696.3748168945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8587960600852966,
        -0.3669477105140686,
        0.3575173616409302
      ],
      "plane_d": -379.470947265625,
      "bbox_min": [
        -904.178466796875,
        -2513.1845703125,
        641.796875
      ],
      "bbox_max": [
        -877.5479736328125,
        -2487.185546875,
        696.3748168945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07835977524518967,
        -0.35017022490501404,
        -0.9334027171134949
      ],
      "plane_d": -298.9742431640625,
      "bbox_min": [
        -904.178466796875,
        -2513.1845703125,
        663.5715942382812
      ],
      "bbox_max": [
        -877.5479736328125,
        -2487.185546875,
        696.3748168945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8801541328430176,
        -0.36512237787246704,
        0.3033384680747986
      ],
      "plane_d": -319.669677734375,
      "bbox_min": [
        -904.178466796875,
        -2500.811279296875,
        663.5715942382812
      ],
      "bbox_max": [
        -898.0948486328125,
        -2487.185546875,
        667.9860229492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6902700662612915,
        -0.46761155128479004,
        -0.552147388458252
      ],
      "plane_d": -175.41311645507812,
      "bbox_min": [
        -941.46484375,
        -2585.62548828125,
        643.792724609375
      ],
      "bbox_max": [
        -846.969482421875,
        -2500.01416015625,
        726.8148803710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6333297491073608,
        -0.5605108141899109,
        -0.5335926413536072
      ],
      "plane_d": -479.0087890625,
      "bbox_min": [
        -941.46484375,
        -2576.886474609375,
        682.5
      ],
      "bbox_max": [
        -909.609375,
        -2559.375,
        726.4923095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6916763782501221,
        -0.6534191370010376,
        -0.3076155185699463
      ],
      "plane_d": -826.90478515625,
      "bbox_min": [
        -918.32568359375,
        -2576.589599609375,
        717.738525390625
      ],
      "bbox_max": [
        -909.609375,
        -2566.875,
        726.2710571289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5975612998008728,
        -0.8018232583999634
      ],
      "plane_d": -957.3291625976562,
      "bbox_min": [
        -915.2291870117188,
        -2576.589599609375,
        719.03125
      ],
      "bbox_max": [
        -909.609375,
        -2566.875,
        726.2710571289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7656795978546143,
        -0.3308616876602173,
        0.5516024231910706
      ],
      "plane_d": -508.3144226074219,
      "bbox_min": [
        -941.46484375,
        -2576.886474609375,
        682.5
      ],
      "bbox_max": [
        -909.609375,
        -2559.375,
        726.4923095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5975612998008728,
        -0.8018232583999634
      ],
      "plane_d": -957.3291625976562,
      "bbox_min": [
        -912.107177734375,
        -2576.886474609375,
        719.03125
      ],
      "bbox_max": [
        -909.609375,
        -2566.875,
        726.4923095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.038054414093494415,
        0.13913646340370178,
        0.98954176902771
      ],
      "plane_d": -254.50421142578125,
      "bbox_min": [
        -940.4493408203125,
        -2585.62548828125,
        643.792724609375
      ],
      "bbox_max": [
        -846.969482421875,
        -2500.01416015625,
        726.8148803710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08756548166275024,
        0.15032073855400085,
        0.9847517609596252
      ],
      "plane_d": -179.49295043945312,
      "bbox_min": [
        -885.7332153320312,
        -2576.875,
        643.8728637695312
      ],
      "bbox_max": [
        -846.969482421875,
        -2509.9560546875,
        652.96875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5358163714408875,
        -0.5204083919525146,
        -0.6648879051208496
      ],
      "plane_d": -370.36444091796875,
      "bbox_min": [
        -940.4493408203125,
        -2585.62548828125,
        643.792724609375
      ],
      "bbox_max": [
        -858.8065795898438,
        -2500.01416015625,
        726.8148803710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5975612998008728,
        -0.8018232583999634
      ],
      "plane_d": -957.3291625976562,
      "bbox_min": [
        -910.4232788085938,
        -2576.947509765625,
        719.03125
      ],
      "bbox_max": [
        -909.609375,
        -2566.875,
        726.5377197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8801541328430176,
        -0.36512237787246704,
        0.3033384680747986
      ],
      "plane_d": -319.669677734375,
      "bbox_min": [
        -940.4493408203125,
        -2585.62548828125,
        643.792724609375
      ],
      "bbox_max": [
        -858.8065795898438,
        -2500.01416015625,
        726.8148803710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7656795978546143,
        -0.3308616876602173,
        0.5516024231910706
      ],
      "plane_d": -508.3144226074219,
      "bbox_min": [
        -940.4493408203125,
        -2571.892578125,
        681.9244995117188
      ],
      "bbox_max": [
        -933.75,
        -2559.375,
        684.4713134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8587960600852966,
        -0.3669477105140686,
        0.3575173616409302
      ],
      "plane_d": -379.470947265625,
      "bbox_min": [
        -938.7444458007812,
        -2585.62548828125,
        643.792724609375
      ],
      "bbox_max": [
        -858.8065795898438,
        -2500.811279296875,
        726.8148803710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07835977524518967,
        -0.35017022490501404,
        -0.9334027171134949
      ],
      "plane_d": -298.9742431640625,
      "bbox_min": [
        -938.7444458007812,
        -2585.62548828125,
        652.96875
      ],
      "bbox_max": [
        -858.8065795898438,
        -2510.893798828125,
        726.8148803710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13552974164485931,
        -0.6056485176086426,
        -0.7841055393218994
      ],
      "plane_d": -1114.1068115234375,
      "bbox_min": [
        -910.0775756835938,
        -2581.052490234375,
        719.03125
      ],
      "bbox_max": [
        -886.7967529296875,
        -2566.875,
        726.8148803710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5975612998008728,
        -0.8018232583999634
      ],
      "plane_d": -957.3291625976562,
      "bbox_min": [
        -910.0775756835938,
        -2581.052490234375,
        719.03125
      ],
      "bbox_max": [
        -886.7967529296875,
        -2566.875,
        726.8148803710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8622605800628662,
        -0.21425026655197144,
        -0.4589155912399292
      ],
      "plane_d": -986.1044921875,
      "bbox_min": [
        -888.8445434570312,
        -2581.052490234375,
        719.03125
      ],
      "bbox_max": [
        -886.7967529296875,
        -2571.875,
        726.1139526367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20010554790496826,
        -0.33017414808273315,
        -0.9224656224250793
      ],
      "plane_d": -363.43182373046875,
      "bbox_min": [
        -938.7444458007812,
        -2585.62548828125,
        652.96875
      ],
      "bbox_max": [
        -858.8065795898438,
        -2513.1845703125,
        722.434814453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8622605800628662,
        -0.21425026655197144,
        -0.4589155912399292
      ],
      "plane_d": -986.1044921875,
      "bbox_min": [
        -887.265625,
        -2581.076171875,
        719.03125
      ],
      "bbox_max": [
        -886.6625366210938,
        -2571.875,
        722.434814453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.055350881069898605,
        0.20237666368484497,
        0.9777422547340393
      ],
      "plane_d": -68.79345703125,
      "bbox_min": [
        -938.7444458007812,
        -2585.62548828125,
        652.96875
      ],
      "bbox_max": [
        -860.625,
        -2559.375,
        722.1937255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.17309880256652832,
        0.9849044680595398
      ],
      "plane_d": -199.65432739257812,
      "bbox_min": [
        -929.7709350585938,
        -2575.733154296875,
        652.96875
      ],
      "bbox_max": [
        -916.9639282226562,
        -2561.875,
        655.6619262695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944882154464722,
        -0.3273007273674011,
        0.3045734167098999
      ],
      "plane_d": -210.32826232910156,
      "bbox_min": [
        -929.7709350585938,
        -2573.511474609375,
        652.96875
      ],
      "bbox_max": [
        -924.609375,
        -2561.875,
        655.6619262695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.811839759349823,
        -0.18294356763362885,
        -0.5544798374176025
      ],
      "plane_d": -792.13720703125,
      "bbox_min": [
        -938.7444458007812,
        -2585.62548828125,
        652.96875
      ],
      "bbox_max": [
        -860.625,
        -2559.375,
        722.1937255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8622605800628662,
        -0.21425026655197144,
        -0.4589155912399292
      ],
      "plane_d": -986.1044921875,
      "bbox_min": [
        -887.265625,
        -2581.53173828125,
        717.5496826171875
      ],
      "bbox_max": [
        -884.07763671875,
        -2571.875,
        722.1937255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944882154464722,
        -0.3273007273674011,
        0.3045734167098999
      ],
      "plane_d": -210.32826232910156,
      "bbox_min": [
        -938.7444458007812,
        -2573.474853515625,
        652.96875
      ],
      "bbox_max": [
        -924.609375,
        -2559.375,
        682.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7656795978546143,
        -0.3308616876602173,
        0.5516024231910706
      ],
      "plane_d": -508.3144226074219,
      "bbox_min": [
        -938.7444458007812,
        -2572.086181640625,
        680.2847900390625
      ],
      "bbox_max": [
        -933.75,
        -2559.375,
        682.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6916763782501221,
        -0.6534191370010376,
        -0.3076155185699463
      ],
      "plane_d": -826.90478515625,
      "bbox_min": [
        -985.4205932617188,
        -2640.0,
        654.4735717773438
      ],
      "bbox_max": [
        -860.8630981445312,
        -2571.4130859375,
        771.9608154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6333297491073608,
        -0.5605108141899109,
        -0.5335926413536072
      ],
      "plane_d": -479.0087890625,
      "bbox_min": [
        -985.4205932617188,
        -2640.0,
        673.092529296875
      ],
      "bbox_max": [
        -918.32568359375,
        -2571.4130859375,
        717.738525390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7656795978546143,
        -0.3308616876602173,
        0.5516024231910706
      ],
      "plane_d": -508.3144226074219,
      "bbox_min": [
        -985.4205932617188,
        -2640.0,
        673.092529296875
      ],
      "bbox_max": [
        -935.3463134765625,
        -2571.4130859375,
        705.8635864257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.17309880256652832,
        0.9849044680595398
      ],
      "plane_d": -199.65432739257812,
      "bbox_min": [
        -984.8797607421875,
        -2640.0,
        654.4735717773438
      ],
      "bbox_max": [
        -860.8630981445312,
        -2572.491943359375,
        771.9608154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.055350881069898605,
        0.20237666368484497,
        0.9777422547340393
      ],
      "plane_d": -68.79345703125,
      "bbox_min": [
        -916.9639282226562,
        -2640.0,
        654.4735717773438
      ],
      "bbox_max": [
        -870.6910400390625,
        -2575.733154296875,
        666.6993408203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5975612998008728,
        -0.8018232583999634
      ],
      "plane_d": -957.3291625976562,
      "bbox_min": [
        -984.8797607421875,
        -2640.0,
        655.013916015625
      ],
      "bbox_max": [
        -860.8630981445312,
        -2572.491943359375,
        771.9608154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7656795978546143,
        -0.3308616876602173,
        0.5516024231910706
      ],
      "plane_d": -508.3144226074219,
      "bbox_min": [
        -984.8797607421875,
        -2640.0,
        655.013916015625
      ],
      "bbox_max": [
        -860.8630981445312,
        -2572.491943359375,
        771.9608154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8359991908073425,
        -0.3471871614456177,
        -0.424931138753891
      ],
      "plane_d": -1339.1102294921875,
      "bbox_min": [
        -898.75,
        -2640.0,
        742.6649169921875
      ],
      "bbox_max": [
        -882.9166870117188,
        -2636.0,
        770.9197387695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7879047393798828,
        -0.21060298383235931,
        -0.5786644220352173
      ],
      "plane_d": -817.3908081054688,
      "bbox_min": [
        -898.75,
        -2640.0,
        767.9290771484375
      ],
      "bbox_max": [
        -895.7581787109375,
        -2636.0,
        770.9197387695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13552974164485931,
        -0.6056485176086426,
        -0.7841055393218994
      ],
      "plane_d": -1114.1068115234375,
      "bbox_min": [
        -968.2777709960938,
        -2640.0,
        726.1139526367188
      ],
      "bbox_max": [
        -888.8445434570312,
        -2577.3193359375,
        771.9608154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.33327484130859375,
        -0.9428297281265259
      ],
      "plane_d": -152.0179443359375,
      "bbox_min": [
        -968.2777709960938,
        -2640.0,
        742.4426879882812
      ],
      "bbox_max": [
        -897.95458984375,
        -2636.0,
        771.9608154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.772372841835022,
        -0.513153076171875,
        -0.3743181824684143
      ],
      "plane_d": -328.9428405761719,
      "bbox_min": [
        -968.2777709960938,
        -2640.0,
        742.4426879882812
      ],
      "bbox_max": [
        -897.95458984375,
        -2636.0,
        771.9608154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7142226696014404,
        -0.28173136711120605,
        -0.640713095664978
      ],
      "plane_d": 430.9955749511719,
      "bbox_min": [
        -955.9262084960938,
        -2640.0,
        767.9290771484375
      ],
      "bbox_max": [
        -897.95458984375,
        -2636.0,
        771.9608154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7879047393798828,
        -0.21060298383235931,
        -0.5786644220352173
      ],
      "plane_d": -817.3908081054688,
      "bbox_min": [
        -898.75,
        -2640.0,
        770.546875
      ],
      "bbox_max": [
        -897.95458984375,
        -2636.0,
        771.9608154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.40613847970962524,
        0.9138115644454956
      ],
      "plane_d": 465.8408203125,
      "bbox_min": [
        -985.7762451171875,
        -2930.0,
        761.111083984375
      ],
      "bbox_max": [
        -869.7720336914062,
        -2859.5,
        863.8005981445312
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 2919.999755859375,
      "bbox_min": [
        -966.0363159179688,
        -2930.0,
        769.9266357421875
      ],
      "bbox_max": [
        -877.9636840820312,
        -2920.0,
        792.4444580078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7739577293395996,
        0.0,
        0.6332372426986694
      ],
      "plane_d": -1200.1966552734375,
      "bbox_min": [
        -906.0,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -903.927734375,
        -2920.0,
        790.5327758789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7739577293395996,
        0.0,
        0.6332372426986694
      ],
      "plane_d": 226.98138427734375,
      "bbox_min": [
        -941.6363525390625,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -902.3636474609375,
        -2920.0,
        792.4444580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7739577293395996,
        0.0,
        0.6332372426986694
      ],
      "plane_d": -1200.1966552734375,
      "bbox_min": [
        -940.416259765625,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -902.3636474609375,
        -2920.0,
        792.4444580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8273747563362122,
        0.04876469075679779,
        0.5595293641090393
      ],
      "plane_d": 477.5612487792969,
      "bbox_min": [
        -940.416259765625,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -904.2719116210938,
        -2920.0,
        792.4444580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.718767523765564,
        0.17485763132572174,
        0.6729028224945068
      ],
      "plane_d": -670.8665161132812,
      "bbox_min": [
        -906.0615234375,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -904.2719116210938,
        -2920.0,
        792.4444580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -932.0,
      "bbox_min": [
        -985.7762451171875,
        -2930.0,
        761.111083984375
      ],
      "bbox_max": [
        -869.7720336914062,
        -2859.5,
        863.8005981445312
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8156455159187317,
        -0.09158384799957275,
        -0.5712573528289795
      ],
      "plane_d": -519.972900390625,
      "bbox_min": [
        -932.0,
        -2930.0,
        761.111083984375
      ],
      "bbox_max": [
        -869.7720336914062,
        -2859.5,
        863.8005981445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -914.6135864257812,
        -2920.0,
        790.1911010742188
      ],
      "bbox_max": [
        -869.7720336914062,
        -2859.5,
        863.8005981445312
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7563967704772949,
        -0.07589671015739441,
        -0.6496949791908264
      ],
      "plane_d": -361.36248779296875,
      "bbox_min": [
        -871.22314453125,
        -2863.125,
        790.1911010742188
      ],
      "bbox_max": [
        -869.7720336914062,
        -2859.5,
        792.14794921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9069707989692688,
        0.3202887773513794,
        0.27353084087371826
      ],
      "plane_d": -89.20687866210938,
      "bbox_min": [
        -870.625,
        -2863.125,
        790.1911010742188
      ],
      "bbox_max": [
        -869.7720336914062,
        -2859.5,
        791.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.920820951461792,
        0.2899842858314514,
        0.26076391339302063
      ],
      "plane_d": -177.9209442138672,
      "bbox_min": [
        -932.0,
        -2930.0,
        761.111083984375
      ],
      "bbox_max": [
        -869.8526611328125,
        -2859.5,
        863.8005981445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9512509107589722,
        0.15018445253372192,
        0.26938122510910034
      ],
      "plane_d": -620.7452392578125,
      "bbox_min": [
        -891.4382934570312,
        -2930.0,
        784.3419189453125
      ],
      "bbox_max": [
        -869.8526611328125,
        -2859.5,
        820.7681884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -889.6334228515625,
        -2920.0,
        784.3419189453125
      ],
      "bbox_max": [
        -869.8526611328125,
        -2859.5,
        816.5783081054688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9069707989692688,
        0.3202887773513794,
        0.27353084087371826
      ],
      "plane_d": -89.20687866210938,
      "bbox_min": [
        -871.61669921875,
        -2863.125,
        784.3419189453125
      ],
      "bbox_max": [
        -869.8526611328125,
        -2859.5,
        791.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.016610853374004364,
        0.44841963052749634,
        0.8936688303947449
      ],
      "plane_d": 620.2237548828125,
      "bbox_min": [
        -891.4382934570312,
        -2930.0,
        790.2222290039062
      ],
      "bbox_max": [
        -882.5,
        -2925.0,
        820.7681884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9808734059333801,
        0.14385229349136353,
        -0.13112545013427734
      ],
      "plane_d": -337.4938659667969,
      "bbox_min": [
        -883.5030517578125,
        -2930.0,
        818.75
      ],
      "bbox_max": [
        -882.5,
        -2925.0,
        820.7681884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9162713289260864,
        0.28804752230644226,
        0.27834439277648926
      ],
      "plane_d": -193.42660522460938,
      "bbox_min": [
        -932.0,
        -2930.0,
        761.111083984375
      ],
      "bbox_max": [
        -870.625,
        -2859.5,
        863.8005981445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9069707989692688,
        0.3202887773513794,
        0.27353084087371826
      ],
      "plane_d": -89.20687866210938,
      "bbox_min": [
        -889.681884765625,
        -2920.0,
        761.111083984375
      ],
      "bbox_max": [
        -870.625,
        -2859.5,
        791.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9188836812973022,
        0.3240675628185272,
        0.22501777112483978
      ],
      "plane_d": -51.82562255859375,
      "bbox_min": [
        -889.681884765625,
        -2920.0,
        761.111083984375
      ],
      "bbox_max": [
        -877.9344482421875,
        -2859.5,
        790.3522338867188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 2919.999755859375,
      "bbox_min": [
        -889.681884765625,
        -2920.0,
        788.0
      ],
      "bbox_max": [
        -888.96728515625,
        -2920.0,
        790.3522338867188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7111465930938721,
        -0.03083941340446472,
        -0.7023670673370361
      ],
      "plane_d": -142.72918701171875,
      "bbox_min": [
        -932.0,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -870.625,
        -2859.5,
        863.8005981445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7073557376861572,
        -0.10758212953805923,
        -0.6986229419708252
      ],
      "plane_d": -366.921630859375,
      "bbox_min": [
        -927.2113037109375,
        -2930.0,
        818.75
      ],
      "bbox_max": [
        -882.5,
        -2920.0,
        863.8005981445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -927.2113037109375,
        -2930.0,
        818.75
      ],
      "bbox_max": [
        -882.5,
        -2920.0,
        863.8005981445312
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9808734059333801,
        0.14385229349136353,
        -0.13112545013427734
      ],
      "plane_d": -337.4938659667969,
      "bbox_min": [
        -883.5282592773438,
        -2930.0,
        818.75
      ],
      "bbox_max": [
        -882.5,
        -2925.0,
        820.9566040039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.3147980272769928,
        -0.9491586685180664
      ],
      "plane_d": -119.635009765625,
      "bbox_min": [
        -908.921142578125,
        -2930.0,
        844.0625
      ],
      "bbox_max": [
        -907.5,
        -2925.0,
        845.7208251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.16682107746601105,
        -0.9859871864318848
      ],
      "plane_d": 344.28314208984375,
      "bbox_min": [
        -932.0,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -870.625,
        -2859.5,
        863.8005981445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 914.0,
      "bbox_min": [
        -932.0,
        -2930.0,
        832.9804077148438
      ],
      "bbox_max": [
        -906.88134765625,
        -2859.5,
        863.8005981445312
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -932.0,
        -2930.0,
        843.2164916992188
      ],
      "bbox_max": [
        -914.0,
        -2920.0,
        863.8005981445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.3147980272769928,
        -0.9491586685180664
      ],
      "plane_d": -119.635009765625,
      "bbox_min": [
        -932.0,
        -2930.0,
        844.0625
      ],
      "bbox_max": [
        -914.0,
        -2925.0,
        845.7208251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -914.0,
        -2930.0,
        843.2164916992188
      ],
      "bbox_max": [
        -906.88134765625,
        -2920.0,
        850.4241333007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.34984517097473145,
        -0.9368076324462891
      ],
      "plane_d": -234.6295166015625,
      "bbox_min": [
        -932.0,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -870.625,
        -2859.5,
        843.216552734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 914.0,
      "bbox_min": [
        -932.0,
        -2920.0,
        817.4066162109375
      ],
      "bbox_max": [
        -889.0310668945312,
        -2859.5,
        843.216552734375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.27098217606544495,
        -0.962584376335144
      ],
      "plane_d": 26.5484619140625,
      "bbox_min": [
        -932.0,
        -2920.0,
        832.5732421875
      ],
      "bbox_max": [
        -914.0,
        -2859.5,
        843.216552734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -932.0,
        -2920.0,
        840.0
      ],
      "bbox_max": [
        -914.0,
        -2920.0,
        843.216552734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.813399076461792,
        -0.11765268445014954,
        -0.5696839690208435
      ],
      "plane_d": -593.9013671875,
      "bbox_min": [
        -914.0,
        -2920.0,
        817.4066162109375
      ],
      "bbox_max": [
        -889.0310668945312,
        -2859.5,
        843.2164916992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -914.0,
        -2920.0,
        840.0
      ],
      "bbox_max": [
        -903.70458984375,
        -2920.0,
        843.2164916992188
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7563967704772949,
        -0.07589671015739441,
        -0.6496949791908264
      ],
      "plane_d": -361.36248779296875,
      "bbox_min": [
        -871.8587036132812,
        -2863.125,
        791.875
      ],
      "bbox_max": [
        -870.625,
        -2859.5,
        792.8878784179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 838.0,
      "bbox_min": [
        -932.0,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -881.5404052734375,
        -2920.0,
        840.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -932.0,
        -2920.0,
        838.0
      ],
      "bbox_max": [
        -901.729248046875,
        -2920.0,
        840.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8115347027778625,
        0.0,
        -0.5843042731285095
      ],
      "plane_d": -245.60345458984375,
      "bbox_min": [
        -906.0,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -881.5404052734375,
        -2920.0,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -906.0,
        -2920.0,
        807.571044921875
      ],
      "bbox_max": [
        -881.5404052734375,
        -2920.0,
        838.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 2919.999755859375,
      "bbox_min": [
        -906.0,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -884.0911865234375,
        -2920.0,
        821.3333129882812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.016610853374004364,
        0.44841963052749634,
        0.8936688303947449
      ],
      "plane_d": 620.2237548828125,
      "bbox_min": [
        -894.0,
        -2930.0,
        789.7291870117188
      ],
      "bbox_max": [
        -890.5786743164062,
        -2923.890625,
        792.794677734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.016610853374004364,
        0.44841963052749634,
        0.8936688303947449
      ],
      "plane_d": 620.2237548828125,
      "bbox_min": [
        -906.0,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -894.0,
        -2920.0,
        792.9425659179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.016610853374004364,
        0.44841963052749634,
        0.8936688303947449
      ],
      "plane_d": 620.2237548828125,
      "bbox_min": [
        -906.0,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -901.9560546875,
        -2920.0,
        792.9763793945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.718767523765564,
        0.17485763132572174,
        0.6729028224945068
      ],
      "plane_d": -670.8665161132812,
      "bbox_min": [
        -906.0,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -903.77392578125,
        -2920.0,
        792.9763793945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7959103584289551,
        0.01854807510972023,
        -0.6051303148269653
      ],
      "plane_d": 1315.767333984375,
      "bbox_min": [
        -985.7762451171875,
        -2930.0,
        761.111083984375
      ],
      "bbox_max": [
        -932.0,
        -2859.5,
        863.8005981445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -985.7762451171875,
        -2930.0,
        790.23095703125
      ],
      "bbox_max": [
        -932.0,
        -2859.5,
        863.8005981445312
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9949972033500671,
        0.09980414807796478,
        0.004440675489604473
      ],
      "plane_d": 1245.9761962890625,
      "bbox_min": [
        -962.5,
        -2930.0,
        818.75
      ],
      "bbox_max": [
        -962.000732421875,
        -2925.0,
        820.943359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8648011088371277,
        0.433379590511322,
        0.25357678532600403
      ],
      "plane_d": 1891.3072509765625,
      "bbox_min": [
        -985.7762451171875,
        -2863.125,
        790.23095703125
      ],
      "bbox_max": [
        -984.375,
        -2859.5,
        791.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6862487196922302,
        -0.018855048343539238,
        -0.72712242603302
      ],
      "plane_d": 1197.331787109375,
      "bbox_min": [
        -985.7762451171875,
        -2863.125,
        790.45849609375
      ],
      "bbox_max": [
        -984.375,
        -2859.5,
        791.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8746123313903809,
        0.4167838394641876,
        0.2476782649755478
      ],
      "plane_d": 1858.1204833984375,
      "bbox_min": [
        -985.7095336914062,
        -2930.0,
        761.111083984375
      ],
      "bbox_max": [
        -932.0,
        -2859.5,
        859.0191040039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9567331075668335,
        0.10609757900238037,
        0.27093374729156494
      ],
      "plane_d": 1009.364013671875,
      "bbox_min": [
        -985.7095336914062,
        -2930.0,
        782.986328125
      ],
      "bbox_max": [
        -952.7792358398438,
        -2859.5,
        819.2536010742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -985.7095336914062,
        -2920.0,
        782.986328125
      ],
      "bbox_max": [
        -956.1746826171875,
        -2859.5,
        816.578369140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8648011088371277,
        0.433379590511322,
        0.25357678532600403
      ],
      "plane_d": 1891.3072509765625,
      "bbox_min": [
        -985.7095336914062,
        -2863.125,
        782.986328125
      ],
      "bbox_max": [
        -983.5852661132812,
        -2859.5,
        791.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.019330233335494995,
        0.45839300751686096,
        0.8885392546653748
      ],
      "plane_d": 620.2069091796875,
      "bbox_min": [
        -962.5,
        -2930.0,
        790.2222290039062
      ],
      "bbox_max": [
        -952.7792358398438,
        -2925.0,
        819.2536010742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9949972033500671,
        0.09980414807796478,
        0.004440675489604473
      ],
      "plane_d": 1245.9761962890625,
      "bbox_min": [
        -962.5,
        -2930.0,
        818.75
      ],
      "bbox_max": [
        -961.9993286132812,
        -2925.0,
        819.2536010742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8725059032440186,
        0.4155133366584778,
        0.25706446170806885
      ],
      "plane_d": 1844.9765625,
      "bbox_min": [
        -984.927490234375,
        -2930.0,
        761.111083984375
      ],
      "bbox_max": [
        -932.0,
        -2859.5,
        859.0191040039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8648011088371277,
        0.433379590511322,
        0.25357678532600403
      ],
      "plane_d": 1891.3072509765625,
      "bbox_min": [
        -984.375,
        -2920.0,
        761.111083984375
      ],
      "bbox_max": [
        -956.1475219726562,
        -2859.5,
        791.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -956.8463745117188,
        -2920.0,
        788.0
      ],
      "bbox_max": [
        -956.1475219726562,
        -2920.0,
        790.3719482421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8552238941192627,
        0.42890995740890503,
        0.29090940952301025
      ],
      "plane_d": 1840.6619873046875,
      "bbox_min": [
        -977.84033203125,
        -2864.73291015625,
        761.111083984375
      ],
      "bbox_max": [
        -975.2305908203125,
        -2859.5,
        763.4368286132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7103961706161499,
        0.055301763117313385,
        -0.7016258835792542
      ],
      "plane_d": 1419.9700927734375,
      "bbox_min": [
        -984.927490234375,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -932.0,
        -2859.5,
        859.0191040039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6921083927154541,
        -0.23178932070732117,
        -0.6835638880729675
      ],
      "plane_d": 547.8385009765625,
      "bbox_min": [
        -962.5,
        -2930.0,
        818.75
      ],
      "bbox_max": [
        -932.0,
        -2920.0,
        859.0191040039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -961.7053833007812,
        -2920.0,
        819.948486328125
      ],
      "bbox_max": [
        -932.0,
        -2920.0,
        859.0191040039062
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.016984544694423676,
        -0.3070979416370392,
        -0.9515263438224792
      ],
      "plane_d": -79.1907958984375,
      "bbox_min": [
        -939.4589233398438,
        -2930.0,
        843.7745361328125
      ],
      "bbox_max": [
        -935.4811401367188,
        -2925.0,
        845.7122802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6902596354484558,
        -0.23094093799591064,
        -0.685716986656189
      ],
      "plane_d": 550.4041748046875,
      "bbox_min": [
        -939.4589233398438,
        -2930.0,
        843.7745361328125
      ],
      "bbox_max": [
        -937.5,
        -2925.0,
        845.6749267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.16682107746601105,
        -0.9859871864318848
      ],
      "plane_d": 344.28314208984375,
      "bbox_min": [
        -984.927490234375,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -932.0,
        -2859.5,
        850.0250854492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -938.7245483398438,
        -2930.0,
        843.216552734375
      ],
      "bbox_max": [
        -932.0,
        -2920.0,
        850.0250854492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.3147980272769928,
        -0.9491586685180664
      ],
      "plane_d": -119.635009765625,
      "bbox_min": [
        -937.5,
        -2930.0,
        844.0625
      ],
      "bbox_max": [
        -932.0,
        -2925.0,
        845.7208251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.016984544694423676,
        -0.3070979416370392,
        -0.9515263438224792
      ],
      "plane_d": -79.1907958984375,
      "bbox_min": [
        -937.5,
        -2930.0,
        844.0625
      ],
      "bbox_max": [
        -935.0020141601562,
        -2925.0,
        845.7208251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7929525971412659,
        -0.08809126913547516,
        -0.6028815507888794
      ],
      "plane_d": 1005.753173828125,
      "bbox_min": [
        -984.927490234375,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -932.0,
        -2859.5,
        843.216552734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6862487196922302,
        -0.018855048343539238,
        -0.72712242603302
      ],
      "plane_d": 1197.331787109375,
      "bbox_min": [
        -984.927490234375,
        -2863.125,
        791.2595825195312
      ],
      "bbox_max": [
        -983.2022094726562,
        -2859.5,
        792.8878784179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -964.2676391601562,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -932.0,
        -2859.5,
        843.216552734375
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 950.0,
      "bbox_min": [
        -954.4213256835938,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -932.0,
        -2920.0,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.019330233335494995,
        0.45839300751686096,
        0.8885392546653748
      ],
      "plane_d": 620.2069091796875,
      "bbox_min": [
        -954.4213256835938,
        -2930.0,
        789.6239013671875
      ],
      "bbox_max": [
        -950.0,
        -2923.65380859375,
        792.89794921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.019330233335494995,
        0.45839300751686096,
        0.8885392546653748
      ],
      "plane_d": 620.2069091796875,
      "bbox_min": [
        -950.0,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -938.0,
        -2920.0,
        793.0687255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.019330233335494995,
        0.45839300751686096,
        0.8885392546653748
      ],
      "plane_d": 620.2069091796875,
      "bbox_min": [
        -942.1470947265625,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -932.0,
        -2920.0,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8273747563362122,
        0.04876469075679779,
        0.5595293641090393
      ],
      "plane_d": 477.5612487792969,
      "bbox_min": [
        -940.857421875,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -938.0,
        -2920.0,
        793.0968017578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 838.0,
      "bbox_min": [
        -938.0,
        -2930.0,
        838.0
      ],
      "bbox_max": [
        -932.0,
        -2920.0,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.27098217606544495,
        -0.962584376335144
      ],
      "plane_d": 26.5484619140625,
      "bbox_min": [
        -953.0294189453125,
        -2863.125,
        832.5732421875
      ],
      "bbox_max": [
        -932.0,
        -2859.5,
        833.59375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 970.0,
      "bbox_min": [
        -1020.0,
        -2712.0,
        670.0
      ],
      "bbox_max": [
        -853.0,
        -2670.0,
        752.3527221679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -719.9999389648438,
      "bbox_min": [
        -1020.0,
        -2712.0,
        678.9081420898438
      ],
      "bbox_max": [
        -970.0,
        -2674.543212890625,
        752.3527221679688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.5216583051369525e-06,
        0.40613892674446106,
        0.9138113260269165
      ],
      "plane_d": 465.84381103515625,
      "bbox_min": [
        -1007.907958984375,
        -2712.0,
        678.9081420898438
      ],
      "bbox_max": [
        -970.0,
        -2674.543212890625,
        720.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9701426029205322,
        0.0,
        -0.24253565073013306
      ],
      "plane_d": 1125.365478515625,
      "bbox_min": [
        -1012.0521240234375,
        -2712.0,
        720.0
      ],
      "bbox_max": [
        -971.9118041992188,
        -2695.500244140625,
        752.3527221679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9062294363975525,
        -0.25349634885787964,
        0.33836036920547485
      ],
      "plane_d": -13.903305053710938,
      "bbox_min": [
        -1009.0059204101562,
        -2697.0,
        720.0
      ],
      "bbox_max": [
        -1007.4884643554688,
        -2695.500244140625,
        722.940673828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.40613847970962524,
        0.9138115644454956
      ],
      "plane_d": 465.8408203125,
      "bbox_min": [
        -970.0,
        -2712.0,
        670.0
      ],
      "bbox_max": [
        -853.0,
        -2670.0,
        752.3527221679688
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -894.0,
      "bbox_min": [
        -894.0,
        -2712.0,
        670.0
      ],
      "bbox_max": [
        -853.0,
        -2670.0,
        695.5555419921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -894.0,
      "bbox_min": [
        -894.0,
        -2712.0,
        678.9081420898438
      ],
      "bbox_max": [
        -853.0,
        -2674.543212890625,
        752.3527221679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -719.9999389648438,
      "bbox_min": [
        -894.0,
        -2712.0,
        720.0
      ],
      "bbox_max": [
        -853.125,
        -2695.5,
        752.3527221679688
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7891456484794617,
        -0.2033252865076065,
        -0.579575777053833
      ],
      "plane_d": -798.1556396484375,
      "bbox_min": [
        -865.2177734375,
        -2712.0,
        732.2994384765625
      ],
      "bbox_max": [
        -853.125,
        -2701.77294921875,
        752.3527221679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.40613847970962524,
        0.9138115644454956
      ],
      "plane_d": 465.8408203125,
      "bbox_min": [
        -1015.0,
        -2712.0,
        658.0
      ],
      "bbox_max": [
        -815.0,
        -2640.0,
        860.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -2649.999755859375,
      "bbox_min": [
        -991.0,
        -2650.0,
        658.0
      ],
      "bbox_max": [
        -858.5,
        -2650.0,
        668.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -932.0,
      "bbox_min": [
        -1015.0,
        -2712.0,
        665.7777709960938
      ],
      "bbox_max": [
        -853.0,
        -2640.0,
        860.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -757.0,
      "bbox_min": [
        -932.0,
        -2660.0,
        666.505859375
      ],
      "bbox_max": [
        -858.5,
        -2640.0,
        779.0304565429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2650.0,
      "bbox_min": [
        -932.0,
        -2660.0,
        666.505859375
      ],
      "bbox_max": [
        -858.5,
        -2640.0,
        757.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.17309880256652832,
        0.9849044680595398
      ],
      "plane_d": -199.65432739257812,
      "bbox_min": [
        -932.0,
        -2650.0,
        666.505859375
      ],
      "bbox_max": [
        -862.1634521484375,
        -2640.0,
        757.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -668.0,
      "bbox_min": [
        -932.0,
        -2650.0,
        666.505859375
      ],
      "bbox_max": [
        -878.090576171875,
        -2640.0,
        668.4568481445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.055350881069898605,
        0.20237666368484497,
        0.9777422547340393
      ],
      "plane_d": -68.79345703125,
      "bbox_min": [
        -881.5084838867188,
        -2645.0,
        666.505859375
      ],
      "bbox_max": [
        -878.090576171875,
        -2640.0,
        667.578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7896519899368286,
        0.0,
        0.6135550141334534
      ],
      "plane_d": -1116.6708984375,
      "bbox_min": [
        -895.098388671875,
        -2650.0,
        668.0
      ],
      "bbox_max": [
        -894.743408203125,
        -2647.400634765625,
        668.4568481445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8359991908073425,
        -0.3471871614456177,
        -0.424931138753891
      ],
      "plane_d": -1339.1102294921875,
      "bbox_min": [
        -932.0,
        -2650.0,
        668.0
      ],
      "bbox_max": [
        -862.1634521484375,
        -2640.0,
        757.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8622605800628662,
        -0.21425026655197144,
        -0.4589155912399292
      ],
      "plane_d": -986.1044921875,
      "bbox_min": [
        -882.9166870117188,
        -2645.0,
        705.8839111328125
      ],
      "bbox_max": [
        -862.9345092773438,
        -2640.0,
        742.6649169921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.811839759349823,
        -0.18294356763362885,
        -0.5544798374176025
      ],
      "plane_d": -792.13720703125,
      "bbox_min": [
        -864.775634765625,
        -2645.0,
        705.8839111328125
      ],
      "bbox_max": [
        -862.9345092773438,
        -2640.0,
        708.57958984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -668.0,
      "bbox_min": [
        -932.0,
        -2650.0,
        668.0
      ],
      "bbox_max": [
        -876.0,
        -2640.0,
        748.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7896519899368286,
        0.0,
        0.6135550141334534
      ],
      "plane_d": -1116.6708984375,
      "bbox_min": [
        -895.098388671875,
        -2650.0,
        668.0
      ],
      "bbox_max": [
        -876.0,
        -2640.0,
        748.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.763513445854187,
        -0.0,
        -0.6457920074462891
      ],
      "plane_d": -200.36721801757812,
      "bbox_min": [
        -895.098388671875,
        -2650.0,
        725.420166015625
      ],
      "bbox_max": [
        -876.0,
        -2640.0,
        748.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8359991908073425,
        -0.3471871614456177,
        -0.424931138753891
      ],
      "plane_d": -1339.1102294921875,
      "bbox_min": [
        -932.0,
        -2660.0,
        710.0059814453125
      ],
      "bbox_max": [
        -860.2403564453125,
        -2650.0,
        757.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 914.0,
      "bbox_min": [
        -914.0,
        -2660.0,
        750.0
      ],
      "bbox_max": [
        -914.0,
        -2650.0,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7879047393798828,
        -0.21060298383235931,
        -0.5786644220352173
      ],
      "plane_d": -817.3908081054688,
      "bbox_min": [
        -883.2678833007812,
        -2660.0,
        754.8399047851562
      ],
      "bbox_max": [
        -880.7991943359375,
        -2656.699462890625,
        757.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.33327484130859375,
        -0.9428297281265259
      ],
      "plane_d": -152.0179443359375,
      "bbox_min": [
        -932.0,
        -2660.0,
        757.0
      ],
      "bbox_max": [
        -882.3856201171875,
        -2640.0,
        779.0304565429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 909.0,
      "bbox_min": [
        -927.0,
        -2648.0,
        772.6678466796875
      ],
      "bbox_max": [
        -909.0,
        -2642.0,
        777.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -927.0,
      "bbox_min": [
        -927.0,
        -2648.0,
        772.6678466796875
      ],
      "bbox_max": [
        -909.0,
        -2642.0,
        777.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2648.0,
      "bbox_min": [
        -927.0,
        -2648.0,
        774.7887573242188
      ],
      "bbox_max": [
        -909.0,
        -2648.0,
        777.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7879047393798828,
        -0.21060298383235931,
        -0.5786644220352173
      ],
      "plane_d": -817.3908081054688,
      "bbox_min": [
        -927.0,
        -2660.0,
        757.0
      ],
      "bbox_max": [
        -882.3856201171875,
        -2640.0,
        779.0304565429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8359991908073425,
        -0.3471871614456177,
        -0.424931138753891
      ],
      "plane_d": -1339.1102294921875,
      "bbox_min": [
        -927.0,
        -2656.699462890625,
        757.0
      ],
      "bbox_max": [
        -883.2678833007812,
        -2640.0,
        774.7887573242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2648.0,
      "bbox_min": [
        -927.0,
        -2648.0,
        757.0
      ],
      "bbox_max": [
        -909.0,
        -2642.0,
        774.7887573242188
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 909.0,
      "bbox_min": [
        -927.0,
        -2648.0,
        757.0
      ],
      "bbox_max": [
        -909.0,
        -2642.0,
        774.7887573242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -927.0,
      "bbox_min": [
        -927.0,
        -2648.0,
        757.0
      ],
      "bbox_max": [
        -927.0,
        -2642.0,
        774.7887573242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7879047393798828,
        -0.21060298383235931,
        -0.5786644220352173
      ],
      "plane_d": -817.3908081054688,
      "bbox_min": [
        -932.0,
        -2712.0,
        714.3930053710938
      ],
      "bbox_max": [
        -853.125,
        -2660.0,
        795.4685668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7891456484794617,
        -0.2033252865076065,
        -0.579575777053833
      ],
      "plane_d": -798.1556396484375,
      "bbox_min": [
        -932.0,
        -2712.0,
        714.3930053710938
      ],
      "bbox_max": [
        -853.125,
        -2660.0,
        795.4685668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.33327484130859375,
        -0.9428297281265259
      ],
      "plane_d": -152.0179443359375,
      "bbox_min": [
        -932.0,
        -2712.0,
        750.0
      ],
      "bbox_max": [
        -890.8987426757812,
        -2660.0,
        795.4685668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.21853138506412506,
        -0.9758298397064209
      ],
      "plane_d": 183.5848388671875,
      "bbox_min": [
        -932.0,
        -2712.0,
        750.0
      ],
      "bbox_max": [
        -890.8987426757812,
        -2660.0,
        795.4685668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 914.0,
      "bbox_min": [
        -932.0,
        -2712.0,
        750.0
      ],
      "bbox_max": [
        -890.8987426757812,
        -2660.0,
        795.468505859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -754.0,
      "bbox_min": [
        -932.0,
        -2679.0,
        754.0
      ],
      "bbox_max": [
        -914.0,
        -2660.0,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7484292387962341,
        -0.16308142244815826,
        -0.6428514719009399
      ],
      "plane_d": -602.9218139648438,
      "bbox_min": [
        -898.28125,
        -2712.0,
        787.3197021484375
      ],
      "bbox_max": [
        -890.8987426757812,
        -2697.0,
        795.468505859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -757.0,
      "bbox_min": [
        -995.3317260742188,
        -2660.0,
        665.7777709960938
      ],
      "bbox_max": [
        -932.0,
        -2640.0,
        779.0304565429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2650.0,
      "bbox_min": [
        -995.3317260742188,
        -2660.0,
        665.7777709960938
      ],
      "bbox_max": [
        -932.0,
        -2640.0,
        757.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.804488480091095,
        -0.30020061135292053,
        0.512520968914032
      ],
      "plane_d": -361.2057189941406,
      "bbox_min": [
        -990.860595703125,
        -2650.0,
        665.7777709960938
      ],
      "bbox_max": [
        -932.0,
        -2640.0,
        748.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7656795978546143,
        -0.3308616876602173,
        0.5516024231910706
      ],
      "plane_d": -508.3144226074219,
      "bbox_min": [
        -990.860595703125,
        -2650.0,
        666.6993408203125
      ],
      "bbox_max": [
        -932.0,
        -2640.0,
        748.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.17309880256652832,
        0.9849044680595398
      ],
      "plane_d": -199.65432739257812,
      "bbox_min": [
        -960.0,
        -2645.0,
        666.6993408203125
      ],
      "bbox_max": [
        -957.2064208984375,
        -2640.0,
        668.449462890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944882154464722,
        -0.3273007273674011,
        0.3045734167098999
      ],
      "plane_d": -210.32826232910156,
      "bbox_min": [
        -960.0,
        -2645.0,
        666.6993408203125
      ],
      "bbox_max": [
        -957.8712158203125,
        -2640.0,
        668.449462890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6916763782501221,
        -0.6534191370010376,
        -0.3076155185699463
      ],
      "plane_d": -826.90478515625,
      "bbox_min": [
        -990.860595703125,
        -2650.0,
        666.6993408203125
      ],
      "bbox_max": [
        -932.0,
        -2640.0,
        748.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6333297491073608,
        -0.5605108141899109,
        -0.5335926413536072
      ],
      "plane_d": -479.0087890625,
      "bbox_min": [
        -988.625,
        -2645.0,
        705.8635864257812
      ],
      "bbox_max": [
        -983.5679931640625,
        -2640.0,
        708.0625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 972.0,
      "bbox_min": [
        -990.860595703125,
        -2650.0,
        666.6993408203125
      ],
      "bbox_max": [
        -932.0,
        -2640.0,
        748.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9062294363975525,
        -0.25349634885787964,
        0.33836036920547485
      ],
      "plane_d": -13.903305053710938,
      "bbox_min": [
        -990.860595703125,
        -2650.0,
        705.541015625
      ],
      "bbox_max": [
        -988.625,
        -2645.0,
        709.5540771484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7896519899368286,
        0.0,
        0.6135550141334534
      ],
      "plane_d": 342.6059265136719,
      "bbox_min": [
        -972.0,
        -2650.0,
        666.6993408203125
      ],
      "bbox_max": [
        -932.0,
        -2640.0,
        748.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.17309880256652832,
        0.9849044680595398
      ],
      "plane_d": -199.65432739257812,
      "bbox_min": [
        -960.0,
        -2645.0,
        666.6993408203125
      ],
      "bbox_max": [
        -951.8910522460938,
        -2640.0,
        667.578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.17309880256652832,
        0.9849044680595398
      ],
      "plane_d": -199.65432739257812,
      "bbox_min": [
        -952.5738525390625,
        -2645.0,
        666.6993408203125
      ],
      "bbox_max": [
        -932.0,
        -2640.0,
        667.578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.772372841835022,
        -0.513153076171875,
        -0.3743181824684143
      ],
      "plane_d": -328.9428405761719,
      "bbox_min": [
        -995.3317260742188,
        -2660.0,
        668.0
      ],
      "bbox_max": [
        -965.4456787109375,
        -2650.0,
        757.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9062294363975525,
        -0.25349634885787964,
        0.33836036920547485
      ],
      "plane_d": -13.903305053710938,
      "bbox_min": [
        -995.3317260742188,
        -2660.0,
        701.9979858398438
      ],
      "bbox_max": [
        -972.3176879882812,
        -2650.0,
        757.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7142226696014404,
        -0.28173136711120605,
        -0.640713095664978
      ],
      "plane_d": 430.9955749511719,
      "bbox_min": [
        -975.557373046875,
        -2660.0,
        754.8399047851562
      ],
      "bbox_max": [
        -972.3176879882812,
        -2656.699462890625,
        757.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7142226696014404,
        -0.28173136711120605,
        -0.640713095664978
      ],
      "plane_d": 430.9955749511719,
      "bbox_min": [
        -973.61962890625,
        -2660.0,
        757.0
      ],
      "bbox_max": [
        -932.0,
        -2640.0,
        779.0304565429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -940.0,
      "bbox_min": [
        -940.0,
        -2648.0,
        772.6678466796875
      ],
      "bbox_max": [
        -934.0,
        -2642.0,
        777.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2648.0,
      "bbox_min": [
        -940.0,
        -2648.0,
        774.7887573242188
      ],
      "bbox_max": [
        -934.0,
        -2648.0,
        777.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.772372841835022,
        -0.513153076171875,
        -0.3743181824684143
      ],
      "plane_d": -328.9428405761719,
      "bbox_min": [
        -972.317626953125,
        -2656.699462890625,
        757.0
      ],
      "bbox_max": [
        -934.0,
        -2640.0,
        774.7887573242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -940.0,
      "bbox_min": [
        -940.0,
        -2648.0,
        757.0
      ],
      "bbox_max": [
        -940.0,
        -2642.0,
        774.7887573242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7142226696014404,
        -0.28173136711120605,
        -0.640713095664978
      ],
      "plane_d": 430.9955749511719,
      "bbox_min": [
        -1011.9400024414062,
        -2712.0,
        672.4444580078125
      ],
      "bbox_max": [
        -932.0,
        -2660.0,
        795.4685668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7230917811393738,
        -0.23741567134857178,
        -0.6486693620681763
      ],
      "plane_d": 565.302490234375,
      "bbox_min": [
        -1011.9400024414062,
        -2712.0,
        672.4444580078125
      ],
      "bbox_max": [
        -932.0,
        -2660.0,
        795.4685668945312
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.772372841835022,
        -0.513153076171875,
        -0.3743181824684143
      ],
      "plane_d": -328.9428405761719,
      "bbox_min": [
        -1011.875,
        -2712.0,
        672.4444580078125
      ],
      "bbox_max": [
        -932.0,
        -2660.0,
        795.4685668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.33327484130859375,
        -0.9428297281265259
      ],
      "plane_d": -152.0179443359375,
      "bbox_min": [
        -1011.875,
        -2712.0,
        672.4444580078125
      ],
      "bbox_max": [
        -932.0,
        -2660.0,
        795.4685668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.804488480091095,
        -0.30020061135292053,
        0.512520968914032
      ],
      "plane_d": -361.2057189941406,
      "bbox_min": [
        -994.123291015625,
        -2712.0,
        672.4444580078125
      ],
      "bbox_max": [
        -932.0,
        -2660.0,
        795.4685668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.21853138506412506,
        -0.9758298397064209
      ],
      "plane_d": 183.5848388671875,
      "bbox_min": [
        -972.8922729492188,
        -2712.0,
        748.4310302734375
      ],
      "bbox_max": [
        -932.0,
        -2697.0,
        795.4685668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701426029205322,
        0.0,
        -0.24253565073013306
      ],
      "plane_d": 1125.365478515625,
      "bbox_min": [
        -972.8922729492188,
        -2712.0,
        748.4310302734375
      ],
      "bbox_max": [
        -970.0,
        -2710.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6743385195732117,
        -0.18642187118530273,
        -0.7145029306411743
      ],
      "plane_d": 708.3369750976562,
      "bbox_min": [
        -965.9404907226562,
        -2712.0,
        787.3197021484375
      ],
      "bbox_max": [
        -956.71875,
        -2697.0,
        795.4685668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -873.5,
      "bbox_min": [
        -1067.0,
        -2859.5,
        670.0
      ],
      "bbox_max": [
        -853.0,
        -2712.0,
        832.5732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.46370114812089e-07,
        0.40613844990730286,
        0.9138115644454956
      ],
      "plane_d": 465.8411865234375,
      "bbox_min": [
        -873.5,
        -2859.5,
        695.5555419921875
      ],
      "bbox_max": [
        -853.125,
        -2712.0,
        795.2313232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9517086744308472,
        -0.3070027828216553,
        0.0
      ],
      "plane_d": -1683.250244140625,
      "bbox_min": [
        -873.5,
        -2790.5,
        720.0
      ],
      "bbox_max": [
        -868.5,
        -2775.0,
        730.4443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7891456484794617,
        -0.2033252865076065,
        -0.579575777053833
      ],
      "plane_d": -798.1556396484375,
      "bbox_min": [
        -873.5,
        -2859.5,
        720.0
      ],
      "bbox_max": [
        -853.125,
        -2712.0,
        795.2313232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9517086744308472,
        -0.3070027828216553,
        0.0
      ],
      "plane_d": -1683.250244140625,
      "bbox_min": [
        -873.5,
        -2790.5,
        784.36083984375
      ],
      "bbox_max": [
        -868.5,
        -2775.0,
        792.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7563967704772949,
        -0.07589671015739441,
        -0.6496949791908264
      ],
      "plane_d": -361.36248779296875,
      "bbox_min": [
        -873.5,
        -2859.5,
        720.0
      ],
      "bbox_max": [
        -853.125,
        -2712.0,
        795.2313232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2873479127883911,
        -0.9578263163566589,
        -0.0
      ],
      "plane_d": -2922.376220703125,
      "bbox_min": [
        -873.5,
        -2859.5,
        763.9791870117188
      ],
      "bbox_max": [
        -853.5,
        -2775.0,
        795.2313232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9517086744308472,
        -0.3070027828216553,
        0.0
      ],
      "plane_d": -1683.250244140625,
      "bbox_min": [
        -873.5,
        -2790.5,
        780.9170532226562
      ],
      "bbox_max": [
        -868.5,
        -2775.0,
        785.7310791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.813399076461792,
        -0.11765268445014954,
        -0.5696839690208435
      ],
      "plane_d": -593.9013671875,
      "bbox_min": [
        -873.5,
        -2859.5,
        792.8878784179688
      ],
      "bbox_max": [
        -871.8587036132812,
        -2854.677490234375,
        795.2313232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9069707989692688,
        0.3202887773513794,
        0.27353084087371826
      ],
      "plane_d": -89.20687866210938,
      "bbox_min": [
        -873.5,
        -2859.5,
        720.0
      ],
      "bbox_max": [
        -853.125,
        -2712.0,
        790.45849609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2873479127883911,
        -0.9578263163566589,
        -0.0
      ],
      "plane_d": -2922.376220703125,
      "bbox_min": [
        -862.13427734375,
        -2795.0,
        731.2930908203125
      ],
      "bbox_max": [
        -853.5,
        -2792.409912109375,
        765.134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2873479127883911,
        -0.9578263163566589,
        -0.0
      ],
      "plane_d": -2922.376220703125,
      "bbox_min": [
        -863.8128662109375,
        -2794.5068359375,
        731.0692749023438
      ],
      "bbox_max": [
        -855.143798828125,
        -2791.90625,
        762.8594970703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9517086744308472,
        -0.3070027828216553,
        0.0
      ],
      "plane_d": -1683.250244140625,
      "bbox_min": [
        -873.5,
        -2794.69287109375,
        720.0
      ],
      "bbox_max": [
        -853.125,
        -2712.0,
        786.5337524414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2873479127883911,
        -0.9578263163566589,
        -0.0
      ],
      "plane_d": -2922.376220703125,
      "bbox_min": [
        -873.5,
        -2794.69287109375,
        720.0
      ],
      "bbox_max": [
        -853.125,
        -2712.0,
        783.045654296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7484292387962341,
        -0.16308142244815826,
        -0.6428514719009399
      ],
      "plane_d": -602.9218139648438,
      "bbox_min": [
        -873.5,
        -2788.75,
        720.0
      ],
      "bbox_max": [
        -853.125,
        -2712.0,
        783.045654296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -719.9999389648438,
      "bbox_min": [
        -873.5,
        -2715.5,
        720.0
      ],
      "bbox_max": [
        -870.0,
        -2712.0,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7484292387962341,
        -0.16308142244815826,
        -0.6428514719009399
      ],
      "plane_d": -602.9218139648438,
      "bbox_min": [
        -873.5,
        -2788.75,
        781.3699340820312
      ],
      "bbox_max": [
        -869.0645751953125,
        -2775.000244140625,
        786.5337524414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 970.0,
      "bbox_min": [
        -1067.0,
        -2859.5,
        670.0
      ],
      "bbox_max": [
        -873.5,
        -2712.0,
        832.5732421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 720.0,
      "bbox_min": [
        -1067.0,
        -2859.5,
        695.5555419921875
      ],
      "bbox_max": [
        -970.0,
        -2712.0,
        810.2523193359375
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.6743385195732117,
        -0.18642187118530273,
        -0.7145029306411743
      ],
      "plane_d": 708.3369750976562,
      "bbox_min": [
        -1020.0,
        -2859.5,
        720.0
      ],
      "bbox_max": [
        -970.0,
        -2712.0,
        810.2523193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9322125315666199,
        0.07008834928274155,
        0.35505980253219604
      ],
      "plane_d": 869.0626220703125,
      "bbox_min": [
        -1020.0,
        -2788.75,
        752.997314453125
      ],
      "bbox_max": [
        -1012.5802612304688,
        -2776.0,
        762.8125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2776.0,
      "bbox_min": [
        -1020.0,
        -2776.0,
        752.997314453125
      ],
      "bbox_max": [
        -1012.8981323242188,
        -2776.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2776.0,
      "bbox_min": [
        -1013.0123901367188,
        -2776.0,
        759.7000122070312
      ],
      "bbox_max": [
        -1012.5802612304688,
        -2776.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8648011088371277,
        0.433379590511322,
        0.25357678532600403
      ],
      "plane_d": 1891.3072509765625,
      "bbox_min": [
        -1020.0,
        -2859.5,
        720.0
      ],
      "bbox_max": [
        -970.0,
        -2712.0,
        810.2523193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2776.0,
      "bbox_min": [
        -1020.0,
        -2776.0,
        720.0
      ],
      "bbox_max": [
        -1006.9607543945312,
        -2776.0,
        755.4839477539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8552238941192627,
        0.42890995740890503,
        0.29090940952301025
      ],
      "plane_d": 1840.6619873046875,
      "bbox_min": [
        -1017.3652954101562,
        -2859.5,
        720.0
      ],
      "bbox_max": [
        -970.0,
        -2712.0,
        810.2523193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2776.0,
      "bbox_min": [
        -1017.3652954101562,
        -2776.0,
        720.0
      ],
      "bbox_max": [
        -1004.9563598632812,
        -2776.0,
        755.7260131835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7230919003486633,
        -0.23741605877876282,
        -0.6486691832542419
      ],
      "plane_d": 565.3014526367188,
      "bbox_min": [
        -1017.1087646484375,
        -2859.5,
        720.0
      ],
      "bbox_max": [
        -970.0,
        -2712.0,
        810.2523193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2776.0,
      "bbox_min": [
        -1017.1087646484375,
        -2776.49169921875,
        754.2606811523438
      ],
      "bbox_max": [
        -1012.5502319335938,
        -2776.0,
        759.7164306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9355461001396179,
        0.10546036809682846,
        0.3370926082134247
      ],
      "plane_d": 984.2843017578125,
      "bbox_min": [
        -1012.9002685546875,
        -2776.49169921875,
        758.7694091796875
      ],
      "bbox_max": [
        -1012.565673828125,
        -2776.0,
        759.7164306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2776.0,
      "bbox_min": [
        -1012.8981323242188,
        -2776.0,
        758.7865600585938
      ],
      "bbox_max": [
        -1011.461669921875,
        -2776.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6862487196922302,
        -0.018855048343539238,
        -0.72712242603302
      ],
      "plane_d": 1197.331787109375,
      "bbox_min": [
        -1016.6103515625,
        -2859.5,
        720.0
      ],
      "bbox_max": [
        -970.0,
        -2712.0,
        810.2523193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7929525971412659,
        -0.08809126913547516,
        -0.6028815507888794
      ],
      "plane_d": 1005.753173828125,
      "bbox_min": [
        -983.2022094726562,
        -2859.5,
        792.8878784179688
      ],
      "bbox_max": [
        -970.0,
        -2818.693115234375,
        810.2523193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.606892050811439e-06,
        0.4061366319656372,
        0.9138123393058777
      ],
      "plane_d": 465.8314208984375,
      "bbox_min": [
        -1016.6103515625,
        -2859.5,
        720.0
      ],
      "bbox_max": [
        -970.0,
        -2712.0,
        800.1867065429688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2776.0,
      "bbox_min": [
        -1006.3170166015625,
        -2776.0,
        720.0
      ],
      "bbox_max": [
        -978.9999389648438,
        -2766.99951171875,
        724.000244140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9701426029205322,
        0.0,
        -0.24253565073013306
      ],
      "plane_d": 1125.365478515625,
      "bbox_min": [
        -980.0,
        -2776.0,
        720.0
      ],
      "bbox_max": [
        -978.9999389648438,
        -2766.99951171875,
        724.000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2720.0,
      "bbox_min": [
        -1016.6103515625,
        -2791.787109375,
        720.0
      ],
      "bbox_max": [
        -970.0,
        -2712.0,
        800.1867065429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701426029205322,
        0.0,
        -0.24253565073013306
      ],
      "plane_d": 1125.365478515625,
      "bbox_min": [
        -980.0,
        -2720.0,
        720.0
      ],
      "bbox_max": [
        -970.0,
        -2712.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701426029205322,
        0.0,
        -0.24253565073013306
      ],
      "plane_d": 1125.365478515625,
      "bbox_min": [
        -1016.6103515625,
        -2791.787109375,
        720.0
      ],
      "bbox_max": [
        -970.0,
        -2720.0,
        800.1867065429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2776.0,
      "bbox_min": [
        -1016.6103515625,
        -2791.787109375,
        720.0
      ],
      "bbox_max": [
        -970.0,
        -2720.0,
        800.1867065429688
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 990.0,
      "bbox_min": [
        -993.0,
        -2724.0,
        720.0
      ],
      "bbox_max": [
        -990.0,
        -2720.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2724.0,
      "bbox_min": [
        -993.0,
        -2724.0,
        720.0
      ],
      "bbox_max": [
        -990.0,
        -2724.0,
        753.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9355461001396179,
        0.10546036809682846,
        0.3370926082134247
      ],
      "plane_d": 984.2843017578125,
      "bbox_min": [
        -1013.125,
        -2791.787109375,
        724.0000610351562
      ],
      "bbox_max": [
        -980.0,
        -2776.0,
        790.7488403320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9322125315666199,
        0.07008834928274155,
        0.35505980253219604
      ],
      "plane_d": 869.0626220703125,
      "bbox_min": [
        -1013.125,
        -2791.787109375,
        731.0165405273438
      ],
      "bbox_max": [
        -1000.7862548828125,
        -2776.49169921875,
        763.3161010742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2790.0,
      "bbox_min": [
        -1012.6417846679688,
        -2790.0,
        760.0
      ],
      "bbox_max": [
        -1011.430908203125,
        -2790.0,
        763.3161010742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8137334585189819,
        -0.5812382102012634,
        0.0
      ],
      "plane_d": -816.0584106445312,
      "bbox_min": [
        -1012.6257934570312,
        -2790.0,
        760.0
      ],
      "bbox_max": [
        -980.0,
        -2776.0,
        790.7488403320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2790.0,
      "bbox_min": [
        -1012.6257934570312,
        -2790.0,
        760.0
      ],
      "bbox_max": [
        -990.0,
        -2790.0,
        784.6699829101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.5216583051369525e-06,
        0.40613892674446106,
        0.9138113260269165
      ],
      "plane_d": 465.84381103515625,
      "bbox_min": [
        -990.0,
        -2767.0,
        695.5555419921875
      ],
      "bbox_max": [
        -970.0,
        -2712.0,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.40613847970962524,
        0.9138115644454956
      ],
      "plane_d": 465.8408203125,
      "bbox_min": [
        -970.0,
        -2859.5,
        670.0
      ],
      "bbox_max": [
        -873.5,
        -2712.0,
        832.5732421875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.857492983341217,
        0.0,
        0.5144957900047302
      ],
      "plane_d": -1131.4620361328125,
      "bbox_min": [
        -887.5,
        -2775.0,
        720.0
      ],
      "bbox_max": [
        -885.3666381835938,
        -2766.999755859375,
        723.5556030273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -894.0,
      "bbox_min": [
        -970.0,
        -2859.5,
        695.5555419921875
      ],
      "bbox_max": [
        -873.5,
        -2712.0,
        832.5732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7563967704772949,
        -0.07589671015739441,
        -0.6496949791908264
      ],
      "plane_d": -361.36248779296875,
      "bbox_min": [
        -894.0,
        -2854.677490234375,
        766.4002075195312
      ],
      "bbox_max": [
        -873.5,
        -2719.897216796875,
        811.0656127929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7891456484794617,
        -0.2033252865076065,
        -0.579575777053833
      ],
      "plane_d": -798.1556396484375,
      "bbox_min": [
        -884.5225219726562,
        -2747.351318359375,
        766.4002075195312
      ],
      "bbox_max": [
        -873.5,
        -2719.897216796875,
        783.182861328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -745.0,
      "bbox_min": [
        -894.0,
        -2859.5,
        720.0
      ],
      "bbox_max": [
        -873.5,
        -2712.0,
        787.3197021484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -878.5,
      "bbox_min": [
        -894.0,
        -2775.0,
        720.0
      ],
      "bbox_max": [
        -873.5,
        -2712.0,
        745.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -719.9999389648438,
      "bbox_min": [
        -878.5,
        -2775.0,
        720.0
      ],
      "bbox_max": [
        -873.5,
        -2712.0,
        745.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2735.5,
      "bbox_min": [
        -878.5,
        -2775.0,
        720.0
      ],
      "bbox_max": [
        -873.5,
        -2735.5,
        745.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2775.0,
      "bbox_min": [
        -878.5,
        -2775.0,
        723.5556030273438
      ],
      "bbox_max": [
        -873.5,
        -2775.0,
        745.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -719.9999389648438,
      "bbox_min": [
        -894.0,
        -2775.0,
        720.0
      ],
      "bbox_max": [
        -878.5,
        -2712.0,
        735.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8574929237365723,
        0.0,
        0.5144957900047302
      ],
      "plane_d": -1131.4619140625,
      "bbox_min": [
        -887.5,
        -2775.0,
        720.0
      ],
      "bbox_max": [
        -878.5,
        -2715.5,
        735.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2735.5,
      "bbox_min": [
        -887.5,
        -2775.0,
        720.0
      ],
      "bbox_max": [
        -878.5,
        -2735.5,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2775.0,
      "bbox_min": [
        -885.3666381835938,
        -2775.0,
        723.5556030273438
      ],
      "bbox_max": [
        -878.5,
        -2775.0,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7891456484794617,
        -0.2033252865076065,
        -0.579575777053833
      ],
      "plane_d": -798.1556396484375,
      "bbox_min": [
        -890.8987426757812,
        -2859.5,
        752.0096435546875
      ],
      "bbox_max": [
        -873.5,
        -2712.0,
        787.3197021484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9188836812973022,
        0.3240675628185272,
        0.22501777112483978
      ],
      "plane_d": -51.82562255859375,
      "bbox_min": [
        -878.493408203125,
        -2859.5,
        752.0096435546875
      ],
      "bbox_max": [
        -873.5,
        -2839.021728515625,
        778.097412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9069707989692688,
        0.3202887773513794,
        0.27353084087371826
      ],
      "plane_d": -89.20687866210938,
      "bbox_min": [
        -877.9344482421875,
        -2859.5,
        763.2899169921875
      ],
      "bbox_max": [
        -873.5,
        -2846.85400390625,
        778.097412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -932.0,
      "bbox_min": [
        -970.0,
        -2788.75,
        762.3236694335938
      ],
      "bbox_max": [
        -894.0,
        -2712.0,
        812.65625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.21853138506412506,
        -0.9758298397064209
      ],
      "plane_d": 183.5848388671875,
      "bbox_min": [
        -932.0,
        -2788.75,
        762.3236694335938
      ],
      "bbox_max": [
        -894.0,
        -2712.0,
        812.65625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 914.0,
      "bbox_min": [
        -914.0,
        -2788.75,
        762.3236694335938
      ],
      "bbox_max": [
        -894.0,
        -2712.0,
        812.65625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7484292387962341,
        -0.16308142244815826,
        -0.6428514719009399
      ],
      "plane_d": -602.9218139648438,
      "bbox_min": [
        -897.8980712890625,
        -2788.75,
        790.9302978515625
      ],
      "bbox_max": [
        -894.0,
        -2712.0,
        812.65625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.21853138506412506,
        -0.9758298397064209
      ],
      "plane_d": 183.5848388671875,
      "bbox_min": [
        -970.0,
        -2788.75,
        782.79443359375
      ],
      "bbox_max": [
        -932.0,
        -2712.0,
        812.65625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7230919003486633,
        -0.23741605877876282,
        -0.6486691832542419
      ],
      "plane_d": 565.3014526367188,
      "bbox_min": [
        -970.0,
        -2718.603271484375,
        782.79443359375
      ],
      "bbox_max": [
        -965.9404907226562,
        -2712.0,
        787.3197021484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -932.0,
      "bbox_min": [
        -970.0,
        -2859.5,
        790.9854736328125
      ],
      "bbox_max": [
        -894.0,
        -2788.75,
        832.5732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.34984517097473145,
        -0.9368076324462891
      ],
      "plane_d": -234.6295166015625,
      "bbox_min": [
        -932.0,
        -2859.5,
        790.9854736328125
      ],
      "bbox_max": [
        -894.0,
        -2788.75,
        832.5732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 914.0,
      "bbox_min": [
        -932.0,
        -2859.5,
        790.9854736328125
      ],
      "bbox_max": [
        -894.0,
        -2788.75,
        832.5732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.2709794342517853,
        -0.9625852108001709
      ],
      "plane_d": 26.5570068359375,
      "bbox_min": [
        -932.0,
        -2859.5,
        812.65625
      ],
      "bbox_max": [
        -914.0,
        -2788.75,
        832.5732421875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.813399076461792,
        -0.11765268445014954,
        -0.5696839690208435
      ],
      "plane_d": -593.9013671875,
      "bbox_min": [
        -914.0,
        -2859.5,
        810.4005737304688
      ],
      "bbox_max": [
        -894.0,
        -2788.75,
        832.5732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7563967704772949,
        -0.07589671015739441,
        -0.6496949791908264
      ],
      "plane_d": -361.36248779296875,
      "bbox_min": [
        -895.9375,
        -2794.44287109375,
        810.4005737304688
      ],
      "bbox_max": [
        -894.0,
        -2788.75,
        812.65625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.4982432503529708e-06,
        -0.270979642868042,
        -0.9625850319862366
      ],
      "plane_d": 26.5576171875,
      "bbox_min": [
        -914.0,
        -2859.5,
        812.65625
      ],
      "bbox_max": [
        -895.9375,
        -2788.75,
        832.5732421875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -9.996506378229242e-07,
        -0.2709798812866211,
        -0.9625849723815918
      ],
      "plane_d": 26.5545654296875,
      "bbox_min": [
        -970.0,
        -2859.5,
        803.5133056640625
      ],
      "bbox_max": [
        -932.0,
        -2788.75,
        832.5732421875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7929525971412659,
        -0.08809126913547516,
        -0.6028815507888794
      ],
      "plane_d": 1005.753173828125,
      "bbox_min": [
        -970.0,
        -2859.5,
        803.5133056640625
      ],
      "bbox_max": [
        -953.0294189453125,
        -2788.75,
        832.5732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6862487196922302,
        -0.018855048343539238,
        -0.72712242603302
      ],
      "plane_d": 1197.331787109375,
      "bbox_min": [
        -970.0,
        -2818.693115234375,
        803.5133056640625
      ],
      "bbox_max": [
        -960.3125,
        -2788.75,
        812.65625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -780.0,
      "bbox_min": [
        -1595.0,
        -3208.19580078125,
        577.0269165039062
      ],
      "bbox_max": [
        -1197.2042236328125,
        -3031.0859375,
        1302.5999755859375
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.8137342929840088,
        -0.5748793482780457,
        0.08573256433010101
      ],
      "plane_d": -2924.1494140625,
      "bbox_min": [
        -1367.9073486328125,
        -3107.087646484375,
        577.0269165039062
      ],
      "bbox_max": [
        -1333.1427001953125,
        -3089.99560546875,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7995961308479309,
        -0.5955905318260193,
        0.0769285261631012
      ],
      "plane_d": -2963.00537109375,
      "bbox_min": [
        -1335.0894775390625,
        -3092.033935546875,
        711.556884765625
      ],
      "bbox_max": [
        -1333.54833984375,
        -3090.4482421875,
        718.38525390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.796037495136261,
        -0.5924747586250305,
        0.12368514388799667
      ],
      "plane_d": -2981.951171875,
      "bbox_min": [
        -1335.0894775390625,
        -3092.033935546875,
        711.556884765625
      ],
      "bbox_max": [
        -1333.9539794921875,
        -3090.4482421875,
        712.7704467773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44718649983406067,
        -0.8943867683410645,
        0.009831518866121769
      ],
      "plane_d": -2174.02978515625,
      "bbox_min": [
        -1367.9073486328125,
        -3107.087646484375,
        577.0269165039062
      ],
      "bbox_max": [
        -1333.1427001953125,
        -3089.99560546875,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4278530180454254,
        -0.903739333152771,
        0.014034316875040531
      ],
      "plane_d": -2231.740478515625,
      "bbox_min": [
        -1367.668701171875,
        -3106.9814453125,
        613.0665893554688
      ],
      "bbox_max": [
        -1335.0894775390625,
        -3090.4482421875,
        712.7554321289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44900059700012207,
        -0.8935260772705078,
        0.003092230297625065
      ],
      "plane_d": -2164.14404296875,
      "bbox_min": [
        -1367.668701171875,
        -3106.9814453125,
        638.2857666015625
      ],
      "bbox_max": [
        -1335.0894775390625,
        -3090.4482421875,
        712.7554321289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4523264467716217,
        -0.8918522596359253,
        0.0003948037629015744
      ],
      "plane_d": -2152.6083984375,
      "bbox_min": [
        -1367.668701171875,
        -3106.9814453125,
        662.6285400390625
      ],
      "bbox_max": [
        -1335.0894775390625,
        -3090.4482421875,
        712.7554321289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4523264467716217,
        -0.8918522596359253,
        0.0003948037629015744
      ],
      "plane_d": -2152.6083984375,
      "bbox_min": [
        -1367.9073486328125,
        -3107.087646484375,
        690.6090087890625
      ],
      "bbox_max": [
        -1333.1427001953125,
        -3089.99560546875,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7995961308479309,
        -0.5955905318260193,
        0.0769285261631012
      ],
      "plane_d": -2963.00537109375,
      "bbox_min": [
        -1335.0894775390625,
        -3090.4482421875,
        712.7554321289062
      ],
      "bbox_max": [
        -1334.3070068359375,
        -3089.99560546875,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7995961308479309,
        -0.5955905318260193,
        0.0769285261631012
      ],
      "plane_d": -2963.00537109375,
      "bbox_min": [
        -1335.0894775390625,
        -3091.7900390625,
        712.7554321289062
      ],
      "bbox_max": [
        -1333.1427001953125,
        -3090.04638671875,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4553416073322296,
        -0.8902986645698547,
        0.005685432814061642
      ],
      "plane_d": -2147.55224609375,
      "bbox_min": [
        -1372.2021484375,
        -3109.0,
        724.0
      ],
      "bbox_max": [
        -1329.0966796875,
        -3035.300048828125,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -780.0,
      "bbox_min": [
        -1367.9959716796875,
        -3107.127197265625,
        724.0
      ],
      "bbox_max": [
        -1330.8385009765625,
        -3035.300048828125,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4523264467716217,
        -0.8918522596359253,
        0.0003948037629015744
      ],
      "plane_d": -2152.6083984375,
      "bbox_min": [
        -1367.9959716796875,
        -3107.127197265625,
        724.0
      ],
      "bbox_max": [
        -1344.187255859375,
        -3042.10009765625,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47822824120521545,
        0.24448950588703156,
        0.8435180187225342
      ],
      "plane_d": 735.2036743164062,
      "bbox_min": [
        -1357.9000244140625,
        -3068.819091796875,
        779.9929809570312
      ],
      "bbox_max": [
        -1344.187255859375,
        -3042.10009765625,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8882412314414978,
        0.4593772888183594,
        -2.415353992546443e-05
      ],
      "plane_d": 2603.727294921875,
      "bbox_min": [
        -1348.809814453125,
        -3061.589599609375,
        779.9929809570312
      ],
      "bbox_max": [
        -1347.9261474609375,
        -3059.89990234375,
        780.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6119579076766968,
        0.7908903360366821,
        0.0
      ],
      "plane_d": 1594.63623046875,
      "bbox_min": [
        -1348.809814453125,
        -3059.90673828125,
        779.9929809570312
      ],
      "bbox_max": [
        -1348.800048828125,
        -3059.89990234375,
        780.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8882412314414978,
        0.4593772888183594,
        -2.415353992546443e-05
      ],
      "plane_d": 2603.727294921875,
      "bbox_min": [
        -1348.7978515625,
        -3068.819091796875,
        779.9943237304688
      ],
      "bbox_max": [
        -1344.187255859375,
        -3059.904052734375,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7995961308479309,
        -0.5955905318260193,
        0.0769285261631012
      ],
      "plane_d": -2963.00537109375,
      "bbox_min": [
        -1371.2357177734375,
        -3108.569580078125,
        724.0
      ],
      "bbox_max": [
        -1329.0966796875,
        -3087.7412109375,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 770.0,
      "bbox_min": [
        -1371.2357177734375,
        -3108.569580078125,
        770.0
      ],
      "bbox_max": [
        -1332.0350341796875,
        -3089.06298828125,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660235404968262,
        0.5000033378601074,
        -2.6594350401865086e-06
      ],
      "plane_d": 2699.14404296875,
      "bbox_min": [
        -1333.2205810546875,
        -3091.116455078125,
        770.0
      ],
      "bbox_max": [
        -1332.0350341796875,
        -3089.06298828125,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7746099233627319,
        -0.5822634696960449,
        0.2468777596950531
      ],
      "plane_d": -3030.36767578125,
      "bbox_min": [
        -1595.0,
        -3208.19580078125,
        780.0
      ],
      "bbox_max": [
        -1197.2042236328125,
        -3031.0859375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8900717496871948,
        -0.4558204412460327,
        -0.0
      ],
      "plane_d": -2580.253173828125,
      "bbox_min": [
        -1368.22216796875,
        -3092.128662109375,
        780.0
      ],
      "bbox_max": [
        -1197.2042236328125,
        -3031.0859375,
        1302.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.14039453864097595,
        -0.9834563732147217,
        0.11446819454431534
      ],
      "plane_d": -2961.9658203125,
      "bbox_min": [
        -1216.4732666015625,
        -3039.0107421875,
        1278.9141845703125
      ],
      "bbox_max": [
        -1197.2042236328125,
        -3031.0859375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9190670251846313,
        -0.001398043823428452,
        0.39409878849983215
      ],
      "plane_d": 600.4259643554688,
      "bbox_min": [
        -1216.4732666015625,
        -3039.0107421875,
        1278.9141845703125
      ],
      "bbox_max": [
        -1206.3187255859375,
        -3033.836669921875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6744422316551208,
        -0.542770504951477,
        0.5005276203155518
      ],
      "plane_d": -1478.223388671875,
      "bbox_min": [
        -1216.4732666015625,
        -3039.0107421875,
        1292.563720703125
      ],
      "bbox_max": [
        -1212.1756591796875,
        -3033.836669921875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45253151655197144,
        -0.8917484879493713,
        0.0
      ],
      "plane_d": -2098.29541015625,
      "bbox_min": [
        -1368.22216796875,
        -3092.128662109375,
        780.0
      ],
      "bbox_max": [
        -1321.71875,
        -3035.300048828125,
        839.0567016601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6115233302116394,
        -0.7912264466285706,
        0.0
      ],
      "plane_d": -1576.6024169921875,
      "bbox_min": [
        -1368.22216796875,
        -3092.128662109375,
        780.0
      ],
      "bbox_max": [
        -1321.71875,
        -3035.300048828125,
        839.0567016601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45704153180122375,
        -0.8894281387329102,
        0.005541317164897919
      ],
      "plane_d": -2142.489990234375,
      "bbox_min": [
        -1368.22216796875,
        -3092.128662109375,
        780.0
      ],
      "bbox_max": [
        -1321.71875,
        -3035.300048828125,
        839.0567016601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4561203718185425,
        0.8899181485176086,
        0.0
      ],
      "plane_d": 2117.8759765625,
      "bbox_min": [
        -1353.24755859375,
        -3092.128662109375,
        780.0
      ],
      "bbox_max": [
        -1321.71875,
        -3050.535400390625,
        839.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0017874430632218719,
        0.0034160418435931206,
        -0.9999926090240479
      ],
      "plane_d": 803.067138671875,
      "bbox_min": [
        -1353.24755859375,
        -3092.128662109375,
        780.0
      ],
      "bbox_max": [
        -1321.71875,
        -3061.9677734375,
        794.9983520507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20462147891521454,
        0.39741915464401245,
        -0.894532322883606
      ],
      "plane_d": 1655.69970703125,
      "bbox_min": [
        -1349.80224609375,
        -3071.69482421875,
        794.9924926757812
      ],
      "bbox_max": [
        -1344.1917724609375,
        -3068.8095703125,
        794.9983520507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8956573009490967,
        -0.4447450339794159,
        1.2627120668184943e-05
      ],
      "plane_d": -2553.7841796875,
      "bbox_min": [
        -1353.24755859375,
        -3092.128662109375,
        780.0
      ],
      "bbox_max": [
        -1321.71875,
        -3061.9677734375,
        794.99267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.45612025260925293,
        0.8899179100990295,
        -0.00070630555273965
      ],
      "plane_d": 2138.94091796875,
      "bbox_min": [
        -1353.24755859375,
        -3092.128662109375,
        780.0
      ],
      "bbox_max": [
        -1321.71875,
        -3068.8095703125,
        794.99267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.455343633890152,
        -0.8903152346611023,
        0.0010533728636801243
      ],
      "plane_d": -2143.98779296875,
      "bbox_min": [
        -1339.2152099609375,
        -3092.128662109375,
        780.0
      ],
      "bbox_max": [
        -1330.6363525390625,
        -3087.7412109375,
        783.7042236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8954063653945923,
        0.44450998306274414,
        0.02565733902156353
      ],
      "plane_d": 2547.317138671875,
      "bbox_min": [
        -1353.24755859375,
        -3087.18505859375,
        780.0
      ],
      "bbox_max": [
        -1335.0675048828125,
        -3068.8095703125,
        794.99267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9009795188903809,
        0.43386155366897583,
        -6.166891125758411e-06
      ],
      "plane_d": 2542.2841796875,
      "bbox_min": [
        -1353.24755859375,
        -3087.18505859375,
        780.0
      ],
      "bbox_max": [
        -1335.0675048828125,
        -3068.8095703125,
        794.99267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4559670388698578,
        -0.8899964690208435,
        0.0007025855593383312
      ],
      "plane_d": -2118.881103515625,
      "bbox_min": [
        -1353.24755859375,
        -3081.573974609375,
        780.0
      ],
      "bbox_max": [
        -1339.626220703125,
        -3068.8095703125,
        794.99267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8882412314414978,
        0.4593772888183594,
        -2.415353992546443e-05
      ],
      "plane_d": 2603.727294921875,
      "bbox_min": [
        -1344.192138671875,
        -3068.819091796875,
        780.0
      ],
      "bbox_max": [
        -1344.187255859375,
        -3068.8095703125,
        794.9924926757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20462147891521454,
        0.39741915464401245,
        -0.894532322883606
      ],
      "plane_d": 1655.69970703125,
      "bbox_min": [
        -1349.796630859375,
        -3081.573974609375,
        780.0
      ],
      "bbox_max": [
        -1339.626220703125,
        -3068.8095703125,
        794.99267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.45610228180885315,
        0.8899267911911011,
        -0.001053757150657475
      ],
      "plane_d": 2128.75927734375,
      "bbox_min": [
        -1347.1490478515625,
        -3081.573974609375,
        780.0
      ],
      "bbox_max": [
        -1339.626220703125,
        -3077.708740234375,
        789.9956665039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8882246613502502,
        0.45940932631492615,
        0.0
      ],
      "plane_d": 2603.7841796875,
      "bbox_min": [
        -1348.800048828125,
        -3068.8095703125,
        780.0
      ],
      "bbox_max": [
        -1330.843017578125,
        -3050.535400390625,
        839.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 839.0,
      "bbox_min": [
        -1346.1680908203125,
        -3066.496337890625,
        839.0
      ],
      "bbox_max": [
        -1330.843017578125,
        -3050.535400390625,
        839.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47822824120521545,
        0.24448950588703156,
        0.8435180187225342
      ],
      "plane_d": 735.2036743164062,
      "bbox_min": [
        -1368.22216796875,
        -3066.077880859375,
        780.0
      ],
      "bbox_max": [
        -1336.6976318359375,
        -3035.300048828125,
        839.0567016601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4771321713924408,
        0.2466089278459549,
        0.8435217142105103
      ],
      "plane_d": 740.2075805664062,
      "bbox_min": [
        -1357.8485107421875,
        -3066.077880859375,
        780.0
      ],
      "bbox_max": [
        -1348.8089599609375,
        -3059.905029296875,
        786.4833374023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 839.0,
      "bbox_min": [
        -1357.9627685546875,
        -3057.86328125,
        839.0
      ],
      "bbox_max": [
        -1336.6976318359375,
        -3035.300048828125,
        839.0567016601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5239031314849854,
        -0.26784032583236694,
        -0.8085709810256958
      ],
      "plane_d": -847.8140258789062,
      "bbox_min": [
        -1357.9627685546875,
        -3042.587646484375,
        839.0
      ],
      "bbox_max": [
        -1357.6507568359375,
        -3042.10009765625,
        839.0567016601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7995961308479309,
        -0.5955905318260193,
        0.0769285261631012
      ],
      "plane_d": -2963.00537109375,
      "bbox_min": [
        -1330.6363525390625,
        -3089.80810546875,
        780.0
      ],
      "bbox_max": [
        -1325.2467041015625,
        -3085.589599609375,
        833.44384765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4557587504386902,
        -0.8900548815727234,
        -0.00928233191370964
      ],
      "plane_d": -2133.771484375,
      "bbox_min": [
        -1595.0,
        -3208.19580078125,
        780.0
      ],
      "bbox_max": [
        -1216.4732666015625,
        -3033.836669921875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43772801756858826,
        -0.8991074562072754,
        0.0
      ],
      "plane_d": -2195.2607421875,
      "bbox_min": [
        -1595.0,
        -3208.19580078125,
        780.0
      ],
      "bbox_max": [
        -1216.4732666015625,
        -3033.836669921875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6115233302116394,
        -0.7912264466285706,
        0.0
      ],
      "plane_d": -1576.6024169921875,
      "bbox_min": [
        -1595.0,
        -3208.19580078125,
        780.0
      ],
      "bbox_max": [
        -1339.6785888671875,
        -3042.148681640625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1012493446469307,
        -0.9274534583091736,
        0.35997048020362854
      ],
      "plane_d": -3251.482177734375,
      "bbox_min": [
        -1595.0,
        -3208.19580078125,
        850.0
      ],
      "bbox_max": [
        -1446.4000244140625,
        -3110.5,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4433528184890747,
        -0.8963472843170166,
        0.0
      ],
      "plane_d": -2146.82275390625,
      "bbox_min": [
        -1465.0,
        -3124.875244140625,
        850.0
      ],
      "bbox_max": [
        -1446.4000244140625,
        -3110.5,
        919.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1465.0,
      "bbox_min": [
        -1465.0,
        -3124.875244140625,
        850.0
      ],
      "bbox_max": [
        -1446.4000244140625,
        -3110.5,
        919.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -850.0,
      "bbox_min": [
        -1465.0,
        -3124.875244140625,
        850.0
      ],
      "bbox_max": [
        -1446.4000244140625,
        -3110.5,
        919.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 918.9999389648438,
      "bbox_min": [
        -1465.0,
        -3124.875244140625,
        919.0
      ],
      "bbox_max": [
        -1446.4000244140625,
        -3110.5,
        919.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6119579076766968,
        0.7908903360366821,
        0.0
      ],
      "plane_d": 1594.63623046875,
      "bbox_min": [
        -1542.645263671875,
        -3184.885986328125,
        780.0
      ],
      "bbox_max": [
        -1339.6785888671875,
        -3042.148681640625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9598785042762756,
        0.28041622042655945,
        0.0
      ],
      "plane_d": -502.311279296875,
      "bbox_min": [
        -1466.539794921875,
        -3151.001708984375,
        780.0
      ],
      "bbox_max": [
        -1339.6785888671875,
        -3057.86328125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4561040997505188,
        -0.8899263739585876,
        0.0001992674806388095
      ],
      "plane_d": -2118.081787109375,
      "bbox_min": [
        -1387.807373046875,
        -3108.965087890625,
        780.0
      ],
      "bbox_max": [
        -1339.6785888671875,
        -3057.86328125,
        839.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.888224720954895,
        0.4594093859195709,
        0.0
      ],
      "plane_d": 2603.7841796875,
      "bbox_min": [
        -1348.800048828125,
        -3068.8095703125,
        819.3839721679688
      ],
      "bbox_max": [
        -1339.683837890625,
        -3057.86328125,
        839.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 839.0,
      "bbox_min": [
        -1348.800048828125,
        -3068.802001953125,
        839.0
      ],
      "bbox_max": [
        -1339.683837890625,
        -3057.86328125,
        839.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4559670388698578,
        -0.8899964690208435,
        0.0007025855593383312
      ],
      "plane_d": -2118.881103515625,
      "bbox_min": [
        -1387.807373046875,
        -3108.965087890625,
        780.0
      ],
      "bbox_max": [
        -1339.6785888671875,
        -3066.489501953125,
        839.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20462147891521454,
        0.39741915464401245,
        -0.894532322883606
      ],
      "plane_d": 1655.69970703125,
      "bbox_min": [
        -1387.807373046875,
        -3108.965087890625,
        780.0
      ],
      "bbox_max": [
        -1339.6785888671875,
        -3066.489501953125,
        839.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4561203718185425,
        0.8899181485176086,
        0.0
      ],
      "plane_d": 2117.8759765625,
      "bbox_min": [
        -1383.2276611328125,
        -3108.95849609375,
        783.8877563476562
      ],
      "bbox_max": [
        -1339.6785888671875,
        -3066.489501953125,
        839.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0018678884953260422,
        -0.001293403678573668,
        -0.9999974966049194
      ],
      "plane_d": 783.4458618164062,
      "bbox_min": [
        -1383.2276611328125,
        -3108.95849609375,
        785.0340576171875
      ],
      "bbox_max": [
        -1369.7674560546875,
        -3095.515380859375,
        790.0441284179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8899227380752563,
        -0.45610570907592773,
        0.002248078119009733
      ],
      "plane_d": -2636.693603515625,
      "bbox_min": [
        -1374.31640625,
        -3104.3974609375,
        785.0340576171875
      ],
      "bbox_max": [
        -1369.7674560546875,
        -3095.515625,
        790.0216064453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.00013704881712328643,
        -0.00026740593602880836,
        -1.0
      ],
      "plane_d": 789.356689453125,
      "bbox_min": [
        -1365.4051513671875,
        -3101.888916015625,
        783.8877563476562
      ],
      "bbox_max": [
        -1351.8116455078125,
        -3086.86279296875,
        789.9998168945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8899282813072205,
        -0.4561007022857666,
        3.233041934436187e-05
      ],
      "plane_d": -2615.946044921875,
      "bbox_min": [
        -1357.412841796875,
        -3097.791748046875,
        783.8877563476562
      ],
      "bbox_max": [
        -1351.8116455078125,
        -3086.86279296875,
        789.9998168945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.888224720954895,
        0.4594093859195709,
        0.0
      ],
      "plane_d": 2603.7841796875,
      "bbox_min": [
        -1344.1956787109375,
        -3068.8095703125,
        819.3839721679688
      ],
      "bbox_max": [
        -1339.6785888671875,
        -3066.489501953125,
        839.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 839.0,
      "bbox_min": [
        -1344.1956787109375,
        -3068.8095703125,
        839.0
      ],
      "bbox_max": [
        -1339.6785888671875,
        -3066.489501953125,
        839.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.889582097530365,
        0.45677289366722107,
        -0.001497850869782269
      ],
      "plane_d": 2647.697998046875,
      "bbox_min": [
        -1387.807373046875,
        -3108.965087890625,
        780.0
      ],
      "bbox_max": [
        -1344.8558349609375,
        -3080.38671875,
        795.0381469726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8899224400520325,
        0.4561063051223755,
        -0.002243035938590765
      ],
      "plane_d": 2646.69091796875,
      "bbox_min": [
        -1387.807373046875,
        -3108.965087890625,
        780.0
      ],
      "bbox_max": [
        -1378.6656494140625,
        -3091.166748046875,
        790.0411376953125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.45610806345939636,
        0.8899243474006653,
        -0.000299005419947207
      ],
      "plane_d": 2138.1474609375,
      "bbox_min": [
        -1378.685302734375,
        -3108.965087890625,
        780.0
      ],
      "bbox_max": [
        -1378.6656494140625,
        -3108.953369140625,
        785.0433959960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8899263143539429,
        0.45609888434410095,
        -0.002252260921522975
      ],
      "plane_d": 2626.68115234375,
      "bbox_min": [
        -1383.2276611328125,
        -3108.958251953125,
        780.0
      ],
      "bbox_max": [
        -1344.8558349609375,
        -3080.38671875,
        790.0411376953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8899227380752563,
        -0.45610570907592773,
        0.002248078119009733
      ],
      "plane_d": -2636.693603515625,
      "bbox_min": [
        -1383.2276611328125,
        -3108.958251953125,
        780.0
      ],
      "bbox_max": [
        -1369.7767333984375,
        -3095.491943359375,
        790.0411376953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.45610806345939636,
        0.8899243474006653,
        -0.000299005419947207
      ],
      "plane_d": 2138.1474609375,
      "bbox_min": [
        -1383.2276611328125,
        -3108.958251953125,
        780.0
      ],
      "bbox_max": [
        -1369.7767333984375,
        -3095.491943359375,
        790.0411376953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0018678884953260422,
        -0.001293403678573668,
        -0.9999974966049194
      ],
      "plane_d": 783.4458618164062,
      "bbox_min": [
        -1383.2276611328125,
        -3100.052978515625,
        790.0186157226562
      ],
      "bbox_max": [
        -1374.31640625,
        -3095.491943359375,
        790.0411376953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.45610228180885315,
        0.8899267911911011,
        -0.001053757150657475
      ],
      "plane_d": 2128.75927734375,
      "bbox_min": [
        -1365.4293212890625,
        -3097.7412109375,
        780.0
      ],
      "bbox_max": [
        -1344.8558349609375,
        -3080.38671875,
        789.99609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8899282813072205,
        -0.4561007022857666,
        3.233041934436187e-05
      ],
      "plane_d": -2615.946044921875,
      "bbox_min": [
        -1365.4293212890625,
        -3097.7412109375,
        780.0
      ],
      "bbox_max": [
        -1351.8377685546875,
        -3086.830810546875,
        789.99609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.00013704881712328643,
        -0.00026740593602880836,
        -1.0
      ],
      "plane_d": 789.356689453125,
      "bbox_min": [
        -1365.4293212890625,
        -3090.97802734375,
        789.99609375
      ],
      "bbox_max": [
        -1357.412841796875,
        -3086.830810546875,
        789.99609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1465.0,
      "bbox_min": [
        -1466.539794921875,
        -3151.001708984375,
        849.9962158203125
      ],
      "bbox_max": [
        -1437.199951171875,
        -3128.300048828125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3377978503704071,
        -0.8362663984298706,
        0.4319157302379608
      ],
      "plane_d": -2702.277587890625,
      "bbox_min": [
        -1466.539794921875,
        -3151.001708984375,
        1302.5567626953125
      ],
      "bbox_max": [
        -1465.99853515625,
        -3150.7607421875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 918.9999389648438,
      "bbox_min": [
        -1465.0,
        -3150.316162109375,
        919.0
      ],
      "bbox_max": [
        -1437.199951171875,
        -3128.300048828125,
        919.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5227028131484985,
        -0.270162433385849,
        -0.8085753321647644
      ],
      "plane_d": -853.2969360351562,
      "bbox_min": [
        -1542.645263671875,
        -3184.885986328125,
        786.3157348632812
      ],
      "bbox_max": [
        -1346.1680908203125,
        -3042.148681640625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5239031314849854,
        -0.26784032583236694,
        -0.8085709810256958
      ],
      "plane_d": -847.8140258789062,
      "bbox_min": [
        -1542.645263671875,
        -3184.885986328125,
        839.0
      ],
      "bbox_max": [
        -1346.1680908203125,
        -3042.148681640625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1012493446469307,
        -0.9274534583091736,
        0.35997048020362854
      ],
      "plane_d": -3251.482177734375,
      "bbox_min": [
        -1542.645263671875,
        -3184.885986328125,
        839.0
      ],
      "bbox_max": [
        -1346.1680908203125,
        -3042.587646484375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11021039634943008,
        -0.9280050992965698,
        0.3558935821056366
      ],
      "plane_d": -3234.49072265625,
      "bbox_min": [
        -1501.1502685546875,
        -3166.4111328125,
        1296.7000732421875
      ],
      "bbox_max": [
        -1497.9498291015625,
        -3163.810791015625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.001288205268792808,
        -0.936079740524292,
        0.3517853915691376
      ],
      "plane_d": -3417.884521484375,
      "bbox_min": [
        -1498.3060302734375,
        -3165.048583984375,
        1299.30517578125
      ],
      "bbox_max": [
        -1497.9498291015625,
        -3163.810791015625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.001288205268792808,
        -0.936079740524292,
        0.3517853915691376
      ],
      "plane_d": -3417.884521484375,
      "bbox_min": [
        -1498.3060302734375,
        -3164.986083984375,
        1299.470703125
      ],
      "bbox_max": [
        -1497.2191162109375,
        -3163.810791015625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3377978503704071,
        -0.8362663984298706,
        0.4319157302379608
      ],
      "plane_d": -2702.277587890625,
      "bbox_min": [
        -1498.3060302734375,
        -3164.75390625,
        1300.087158203125
      ],
      "bbox_max": [
        -1497.2191162109375,
        -3163.810791015625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4771321713924408,
        0.2466089278459549,
        0.8435217142105103
      ],
      "plane_d": 740.2075805664062,
      "bbox_min": [
        -1465.0,
        -3149.810302734375,
        786.3157348632812
      ],
      "bbox_max": [
        -1356.784423828125,
        -3050.077880859375,
        919.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47822824120521545,
        0.24448950588703156,
        0.8435180187225342
      ],
      "plane_d": 735.2036743164062,
      "bbox_min": [
        -1465.0,
        -3149.810302734375,
        786.4833374023438
      ],
      "bbox_max": [
        -1357.8485107421875,
        -3062.949462890625,
        872.0136108398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -850.0,
      "bbox_min": [
        -1465.0,
        -3149.810302734375,
        849.9962158203125
      ],
      "bbox_max": [
        -1437.266845703125,
        -3110.5,
        871.9390258789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1465.0,
      "bbox_min": [
        -1465.0,
        -3149.810302734375,
        850.0
      ],
      "bbox_max": [
        -1465.0,
        -3124.875244140625,
        871.9390258789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1465.0,
      "bbox_min": [
        -1465.0,
        -3149.810302734375,
        849.9962158203125
      ],
      "bbox_max": [
        -1437.199951171875,
        -3110.5,
        872.0136108398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -850.0,
      "bbox_min": [
        -1446.4000244140625,
        -3128.351806640625,
        849.9962158203125
      ],
      "bbox_max": [
        -1437.199951171875,
        -3110.5,
        850.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47822824120521545,
        0.24448950588703156,
        0.8435180187225342
      ],
      "plane_d": 735.2036743164062,
      "bbox_min": [
        -1465.0,
        -3149.810302734375,
        786.6734619140625
      ],
      "bbox_max": [
        -1359.0218505859375,
        -3050.077880859375,
        919.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1465.0,
      "bbox_min": [
        -1465.0,
        -3149.810302734375,
        864.7236938476562
      ],
      "bbox_max": [
        -1437.199951171875,
        -3110.5,
        919.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 918.9999389648438,
      "bbox_min": [
        -1465.0,
        -3149.810302734375,
        919.0
      ],
      "bbox_max": [
        -1437.199951171875,
        -3110.5,
        919.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4556112587451935,
        -0.8901628255844116,
        0.005325810518115759
      ],
      "plane_d": -2146.4755859375,
      "bbox_min": [
        -1377.009033203125,
        -3111.14013671875,
        780.0
      ],
      "bbox_max": [
        -1325.112548828125,
        -3085.589599609375,
        833.904541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8899282813072205,
        -0.4561007022857666,
        3.233041934436187e-05
      ],
      "plane_d": -2615.946044921875,
      "bbox_min": [
        -1359.8756103515625,
        -3102.505615234375,
        780.0
      ],
      "bbox_max": [
        -1351.5003662109375,
        -3097.709228515625,
        790.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8899263143539429,
        0.45609888434410095,
        -0.002252260921522975
      ],
      "plane_d": 2626.68115234375,
      "bbox_min": [
        -1359.8756103515625,
        -3102.505615234375,
        780.0
      ],
      "bbox_max": [
        -1351.5244140625,
        -3097.791748046875,
        790.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.00013704881712328643,
        -0.00026740593602880836,
        -1.0
      ],
      "plane_d": 789.356689453125,
      "bbox_min": [
        -1359.813232421875,
        -3102.44775390625,
        789.9998168945312
      ],
      "bbox_max": [
        -1351.5244140625,
        -3097.791748046875,
        790.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4522756338119507,
        -0.8918243050575256,
        0.009807907976210117
      ],
      "plane_d": -2159.764404296875,
      "bbox_min": [
        -1373.1944580078125,
        -3109.44189453125,
        780.0
      ],
      "bbox_max": [
        -1325.112548828125,
        -3085.589599609375,
        833.904541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4560905694961548,
        -0.8899116516113281,
        0.006218035239726305
      ],
      "plane_d": -2145.807861328125,
      "bbox_min": [
        -1372.228271484375,
        -3109.01171875,
        780.0
      ],
      "bbox_max": [
        -1327.09716796875,
        -3085.589599609375,
        833.44384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45704153180122375,
        -0.8894281387329102,
        0.005541317164897919
      ],
      "plane_d": -2142.489990234375,
      "bbox_min": [
        -1372.228271484375,
        -3109.01171875,
        780.0
      ],
      "bbox_max": [
        -1327.09716796875,
        -3085.589599609375,
        833.44384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.455343633890152,
        -0.8903152346611023,
        0.0010533728636801243
      ],
      "plane_d": -2143.98779296875,
      "bbox_min": [
        -1359.5267333984375,
        -3102.512939453125,
        780.0
      ],
      "bbox_max": [
        -1338.36474609375,
        -3091.689453125,
        790.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8899263143539429,
        0.45609888434410095,
        -0.002252260921522975
      ],
      "plane_d": 2626.68115234375,
      "bbox_min": [
        -1359.5267333984375,
        -3102.512939453125,
        780.0
      ],
      "bbox_max": [
        -1351.4954833984375,
        -3098.352294921875,
        790.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.00013704881712328643,
        -0.00026740593602880836,
        -1.0
      ],
      "plane_d": 789.356689453125,
      "bbox_min": [
        -1359.5267333984375,
        -3102.4931640625,
        790.0
      ],
      "bbox_max": [
        -1351.5,
        -3098.352294921875,
        790.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8899263143539429,
        0.45609888434410095,
        -0.002252260921522975
      ],
      "plane_d": 2626.68115234375,
      "bbox_min": [
        -1359.5186767578125,
        -3102.512939453125,
        780.0
      ],
      "bbox_max": [
        -1351.5,
        -3098.39990234375,
        790.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.00013704881712328643,
        -0.00026740593602880836,
        -1.0
      ],
      "plane_d": 789.356689453125,
      "bbox_min": [
        -1359.5035400390625,
        -3102.5,
        790.0
      ],
      "bbox_max": [
        -1351.5,
        -3098.39990234375,
        790.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7215278148651123,
        -0.4943443834781647,
        0.48478996753692627
      ],
      "plane_d": -2886.926513671875,
      "bbox_min": [
        -1327.09716796875,
        -3088.09423828125,
        833.34326171875
      ],
      "bbox_max": [
        -1325.112548828125,
        -3085.589599609375,
        833.904541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8007402420043945,
        -0.5945212841033936,
        0.073208749294281
      ],
      "plane_d": -2958.124267578125,
      "bbox_min": [
        -1327.09716796875,
        -3088.09423828125,
        833.34326171875
      ],
      "bbox_max": [
        -1325.222900390625,
        -3085.589599609375,
        833.690185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.022194361314177513,
        0.23613107204437256,
        0.9714676737785339
      ],
      "plane_d": -96.8321533203125,
      "bbox_min": [
        -962.0082397460938,
        -2991.783447265625,
        790.4069213867188
      ],
      "bbox_max": [
        -883.2512817382812,
        -2930.0,
        858.8014526367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.24552778899669647,
        0.9693895578384399
      ],
      "plane_d": -46.93780517578125,
      "bbox_min": [
        -945.4766235351562,
        -2991.783447265625,
        790.5328369140625
      ],
      "bbox_max": [
        -905.461181640625,
        -2930.0,
        805.8817749023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.021621091291308403,
        0.10562144964933395,
        0.9941713809967041
      ],
      "plane_d": -504.9111633300781,
      "bbox_min": [
        -945.4766235351562,
        -2991.783447265625,
        805.068359375
      ],
      "bbox_max": [
        -906.4345703125,
        -2990.6005859375,
        805.8817749023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7762428522109985,
        0.04481952264904976,
        0.6288387775421143
      ],
      "plane_d": 361.6246032714844,
      "bbox_min": [
        -945.4766235351562,
        -2991.783447265625,
        805.068359375
      ],
      "bbox_max": [
        -945.36328125,
        -2990.9130859375,
        805.267333984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.718767523765564,
        0.17485763132572174,
        0.6729028224945068
      ],
      "plane_d": -670.8665161132812,
      "bbox_min": [
        -906.4345703125,
        -2990.6005859375,
        790.5328369140625
      ],
      "bbox_max": [
        -905.461181640625,
        -2930.0,
        805.8817749023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8273747563362122,
        0.04876469075679779,
        0.5595293641090393
      ],
      "plane_d": 477.5612487792969,
      "bbox_min": [
        -962.0082397460938,
        -2991.7421875,
        790.4069213867188
      ],
      "bbox_max": [
        -883.2512817382812,
        -2930.0,
        858.8014526367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.019330233335494995,
        0.45839300751686096,
        0.8885392546653748
      ],
      "plane_d": 620.2069091796875,
      "bbox_min": [
        -962.0082397460938,
        -2991.7421875,
        792.7979125976562
      ],
      "bbox_max": [
        -940.857421875,
        -2930.0,
        823.9703979492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8210588693618774,
        0.007935827597975731,
        0.5707883238792419
      ],
      "plane_d": 340.41064453125,
      "bbox_min": [
        -956.5881958007812,
        -2991.7421875,
        805.068359375
      ],
      "bbox_max": [
        -945.36328125,
        -2984.7890625,
        821.1939697265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7762428522109985,
        0.04481952264904976,
        0.6288387775421143
      ],
      "plane_d": 361.6246032714844,
      "bbox_min": [
        -956.5881958007812,
        -2991.7421875,
        805.068359375
      ],
      "bbox_max": [
        -945.36328125,
        -2984.7890625,
        821.1939697265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9939219355583191,
        -0.10033050924539566,
        -0.045308977365493774
      ],
      "plane_d": 688.4334716796875,
      "bbox_min": [
        -956.5881958007812,
        -2985.588623046875,
        821.0216064453125
      ],
      "bbox_max": [
        -956.512939453125,
        -2984.7890625,
        821.1939697265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9567331075668335,
        0.10609757900238037,
        0.27093374729156494
      ],
      "plane_d": 1009.364013671875,
      "bbox_min": [
        -962.0082397460938,
        -2984.7890625,
        792.7979125976562
      ],
      "bbox_max": [
        -954.5962524414062,
        -2930.0,
        823.9703979492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9949972033500671,
        0.09980414807796478,
        0.004440675489604473
      ],
      "plane_d": 1245.9761962890625,
      "bbox_min": [
        -962.0082397460938,
        -2984.7890625,
        818.93994140625
      ],
      "bbox_max": [
        -956.512939453125,
        -2930.0,
        823.9703979492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6921083927154541,
        -0.23178932070732117,
        -0.6835638880729675
      ],
      "plane_d": 547.8385009765625,
      "bbox_min": [
        -962.0082397460938,
        -2936.900634765625,
        820.943359375
      ],
      "bbox_max": [
        -960.6317138671875,
        -2930.0,
        823.9703979492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.718767523765564,
        0.17485763132572174,
        0.6729028224945068
      ],
      "plane_d": -670.8665161132812,
      "bbox_min": [
        -961.32958984375,
        -2990.6005859375,
        791.174072265625
      ],
      "bbox_max": [
        -883.2512817382812,
        -2930.0,
        858.8014526367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9512509107589722,
        0.15018445253372192,
        0.26938122510910034
      ],
      "plane_d": -620.7452392578125,
      "bbox_min": [
        -891.5132446289062,
        -2984.51708984375,
        792.7325439453125
      ],
      "bbox_max": [
        -884.869873046875,
        -2930.0,
        820.2880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6411095261573792,
        -0.19564983248710632,
        -0.7420914173126221
      ],
      "plane_d": -530.467529296875,
      "bbox_min": [
        -961.32958984375,
        -2985.567138671875,
        813.1690063476562
      ],
      "bbox_max": [
        -883.2512817382812,
        -2930.0,
        858.8014526367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.3147980272769928,
        -0.9491586685180664
      ],
      "plane_d": -119.635009765625,
      "bbox_min": [
        -915.298095703125,
        -2969.43994140625,
        845.7208251953125
      ],
      "bbox_max": [
        -908.3773803710938,
        -2930.0,
        858.8014526367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9808734059333801,
        0.14385229349136353,
        -0.13112545013427734
      ],
      "plane_d": -337.4938659667969,
      "bbox_min": [
        -961.32958984375,
        -2985.567138671875,
        813.1690063476562
      ],
      "bbox_max": [
        -883.2512817382812,
        -2930.0,
        858.8014526367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9512509107589722,
        0.15018445253372192,
        0.26938122510910034
      ],
      "plane_d": -620.7452392578125,
      "bbox_min": [
        -961.32958984375,
        -2985.567138671875,
        813.1690063476562
      ],
      "bbox_max": [
        -883.2512817382812,
        -2930.0,
        858.8014526367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6921083927154541,
        -0.23178932070732117,
        -0.6835638880729675
      ],
      "plane_d": 547.8385009765625,
      "bbox_min": [
        -961.32958984375,
        -2985.567138671875,
        821.0216064453125
      ],
      "bbox_max": [
        -912.193115234375,
        -2930.0,
        858.8014526367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9949972033500671,
        0.09980414807796478,
        0.004440675489604473
      ],
      "plane_d": 1245.9761962890625,
      "bbox_min": [
        -961.32958984375,
        -2985.567138671875,
        821.0216064453125
      ],
      "bbox_max": [
        -912.193115234375,
        -2930.0,
        858.8014526367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9939219355583191,
        -0.10033050924539566,
        -0.045308977365493774
      ],
      "plane_d": 688.4334716796875,
      "bbox_min": [
        -956.5836181640625,
        -2985.567138671875,
        821.0216064453125
      ],
      "bbox_max": [
        -956.512939453125,
        -2984.7890625,
        821.3839111328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6870704293251038,
        -0.14160729944705963,
        -0.712658166885376
      ],
      "plane_d": 835.868896484375,
      "bbox_min": [
        -957.56005859375,
        -2977.45703125,
        841.1246948242188
      ],
      "bbox_max": [
        -957.3480834960938,
        -2976.006103515625,
        841.527587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.016984544694423676,
        -0.3070979416370392,
        -0.9515263438224792
      ],
      "plane_d": -79.1907958984375,
      "bbox_min": [
        -957.483642578125,
        -2977.376220703125,
        841.1246948242188
      ],
      "bbox_max": [
        -912.193115234375,
        -2930.0,
        858.8014526367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.3147980272769928,
        -0.9491586685180664
      ],
      "plane_d": -119.635009765625,
      "bbox_min": [
        -957.483642578125,
        -2977.376220703125,
        841.1246948242188
      ],
      "bbox_max": [
        -912.193115234375,
        -2930.0,
        858.8014526367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6870704293251038,
        -0.14160729944705963,
        -0.712658166885376
      ],
      "plane_d": 835.868896484375,
      "bbox_min": [
        -957.483642578125,
        -2977.376220703125,
        841.1246948242188
      ],
      "bbox_max": [
        -938.139892578125,
        -2970.04833984375,
        858.590087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.024503104388713837,
        0.08246573805809021,
        0.9962926506996155
      ],
      "plane_d": -534.0615234375,
      "bbox_min": [
        -1247.3983154296875,
        -3392.85400390625,
        805.1602783203125
      ],
      "bbox_max": [
        -660.0,
        -2930.939453125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.021621091291308403,
        0.10562144964933395,
        0.9941713809967041
      ],
      "plane_d": -504.9111633300781,
      "bbox_min": [
        -947.618408203125,
        -3071.92578125,
        805.1602783203125
      ],
      "bbox_max": [
        -906.4345703125,
        -2990.6005859375,
        813.6261596679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5389724969863892,
        0.6360949873924255,
        0.5521700382232666
      ],
      "plane_d": 1050.81884765625,
      "bbox_min": [
        -1247.3983154296875,
        -3392.85400390625,
        805.8817749023438
      ],
      "bbox_max": [
        -660.0,
        -2930.939453125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4566386640071869,
        0.6905266642570496,
        0.5609403848648071
      ],
      "plane_d": 1281.354736328125,
      "bbox_min": [
        -845.512451171875,
        -3379.62841796875,
        831.763671875
      ],
      "bbox_max": [
        -660.0,
        -3090.42138671875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7552521228790283,
        -0.561424732208252,
        0.3382256329059601
      ],
      "plane_d": -2654.937744140625,
      "bbox_min": [
        -845.512451171875,
        -3181.474609375,
        831.763671875
      ],
      "bbox_max": [
        -660.0,
        -3090.42138671875,
        1108.3670654296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2074883133172989,
        0.8826481699943542,
        0.42175933718681335
      ],
      "plane_d": 2287.469970703125,
      "bbox_min": [
        -1247.3983154296875,
        -3392.85400390625,
        805.8817749023438
      ],
      "bbox_max": [
        -660.0,
        -2930.939453125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6744422316551208,
        -0.542770504951477,
        0.5005276203155518
      ],
      "plane_d": -1478.223388671875,
      "bbox_min": [
        -1247.3983154296875,
        -3209.46337890625,
        852.3694458007812
      ],
      "bbox_max": [
        -1023.68017578125,
        -3037.751708984375,
        1295.0089111328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7746099233627319,
        -0.5822634696960449,
        0.2468777596950531
      ],
      "plane_d": -3030.36767578125,
      "bbox_min": [
        -1247.3983154296875,
        -3085.17333984375,
        1159.3487548828125
      ],
      "bbox_max": [
        -1201.8896484375,
        -3039.0107421875,
        1295.0087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.872733473777771,
        -0.4598384499549866,
        0.16396620869636536
      ],
      "plane_d": -700.0397338867188,
      "bbox_min": [
        -1206.3187255859375,
        -3231.95166015625,
        805.8817749023438
      ],
      "bbox_max": [
        -660.0,
        -2930.939453125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12456259876489639,
        -0.9855428338050842,
        0.11484554409980774
      ],
      "plane_d": -2984.98828125,
      "bbox_min": [
        -1206.3187255859375,
        -3163.423828125,
        806.9124755859375
      ],
      "bbox_max": [
        -923.9130249023438,
        -2969.66943359375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6870704293251038,
        -0.14160729944705963,
        -0.712658166885376
      ],
      "plane_d": 835.868896484375,
      "bbox_min": [
        -962.9921875,
        -3053.61669921875,
        806.9124755859375
      ],
      "bbox_max": [
        -923.9130249023438,
        -2969.66943359375,
        860.2791748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9968570470809937,
        -0.04264342784881592,
        0.06676524132490158
      ],
      "plane_d": 771.4093627929688,
      "bbox_min": [
        -961.00341796875,
        -3042.81494140625,
        821.3839111328125
      ],
      "bbox_max": [
        -956.5671997070312,
        -2977.45703125,
        851.0064086914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8210588693618774,
        0.007935827597975731,
        0.5707883238792419
      ],
      "plane_d": 340.41064453125,
      "bbox_min": [
        -962.9921875,
        -3053.61669921875,
        806.9124755859375
      ],
      "bbox_max": [
        -923.9130249023438,
        -2969.66943359375,
        860.2791748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.012172247283160686,
        -0.11178828030824661,
        -0.9936575293540955
      ],
      "plane_d": 532.547119140625,
      "bbox_min": [
        -938.139892578125,
        -2984.3896484375,
        858.590087890625
      ],
      "bbox_max": [
        -923.9130249023438,
        -2969.66943359375,
        860.2791748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14039453864097595,
        -0.9834563732147217,
        0.11446819454431534
      ],
      "plane_d": -2961.9658203125,
      "bbox_min": [
        -1206.3187255859375,
        -3163.423828125,
        828.5869140625
      ],
      "bbox_max": [
        -962.9921875,
        -3006.767333984375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5448715090751648,
        -0.06585269421339035,
        0.8359296917915344
      ],
      "plane_d": -366.09857177734375,
      "bbox_min": [
        -1030.471435546875,
        -3163.423828125,
        828.5869140625
      ],
      "bbox_max": [
        -962.9921875,
        -3053.61669921875,
        868.7452392578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.46676844358444214,
        -0.37923112511634827,
        0.7989436984062195
      ],
      "plane_d": -1372.69287109375,
      "bbox_min": [
        -1030.471435546875,
        -3068.086669921875,
        828.5869140625
      ],
      "bbox_max": [
        -962.9921875,
        -3053.61669921875,
        868.7452392578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.060430631041526794,
        -0.9956679344177246,
        0.07066542655229568
      ],
      "plane_d": -3147.843994140625,
      "bbox_min": [
        -1026.85400390625,
        -3231.95166015625,
        805.8817749023438
      ],
      "bbox_max": [
        -660.0,
        -2930.939453125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09297493100166321,
        -0.989263117313385,
        0.11275718361139297
      ],
      "plane_d": -3025.889892578125,
      "bbox_min": [
        -1026.85400390625,
        -3049.037353515625,
        805.8817749023438
      ],
      "bbox_max": [
        -660.0,
        -2930.939453125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35227170586586,
        -0.9041997790336609,
        0.2415105253458023
      ],
      "plane_d": -2671.578125,
      "bbox_min": [
        -1026.85400390625,
        -3049.037353515625,
        805.8817749023438
      ],
      "bbox_max": [
        -671.1575317382812,
        -2930.939453125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6384236216545105,
        -0.16553433239459991,
        -0.7516739964485168
      ],
      "plane_d": -430.353515625,
      "bbox_min": [
        -961.00341796875,
        -3049.037353515625,
        805.8817749023438
      ],
      "bbox_max": [
        -887.49853515625,
        -2969.43994140625,
        867.4175415039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.28555822372436523,
        0.010150653310120106,
        -0.9583075642585754
      ],
      "plane_d": 1120.8348388671875,
      "bbox_min": [
        -961.00341796875,
        -3049.037353515625,
        805.8817749023438
      ],
      "bbox_max": [
        -887.49853515625,
        -2969.43994140625,
        867.4175415039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9954870343208313,
        -0.08357247710227966,
        -0.044957485049963
      ],
      "plane_d": -1100.083740234375,
      "bbox_min": [
        -956.9534912109375,
        -3049.037353515625,
        805.8817749023438
      ],
      "bbox_max": [
        -887.49853515625,
        -2969.43994140625,
        858.8014526367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9808734059333801,
        0.14385229349136353,
        -0.13112545013427734
      ],
      "plane_d": -337.4938659667969,
      "bbox_min": [
        -893.23828125,
        -2985.04052734375,
        820.1036987304688
      ],
      "bbox_max": [
        -891.4276123046875,
        -2975.936767578125,
        841.642578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6411095261573792,
        -0.19564983248710632,
        -0.7420914173126221
      ],
      "plane_d": -530.467529296875,
      "bbox_min": [
        -893.23828125,
        -2985.04052734375,
        820.1036987304688
      ],
      "bbox_max": [
        -891.4276123046875,
        -2975.936767578125,
        841.642578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9512509107589722,
        0.15018445253372192,
        0.26938122510910034
      ],
      "plane_d": -620.7452392578125,
      "bbox_min": [
        -891.5535888671875,
        -2985.04052734375,
        820.1036987304688
      ],
      "bbox_max": [
        -891.4276123046875,
        -2984.415771484375,
        820.3665161132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.016610853374004364,
        0.44841963052749634,
        0.8936688303947449
      ],
      "plane_d": 620.2237548828125,
      "bbox_min": [
        -891.5535888671875,
        -2985.04052734375,
        820.1036987304688
      ],
      "bbox_max": [
        -891.5132446289062,
        -2984.51708984375,
        820.3665161132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9980483651161194,
        -0.052817005664110184,
        0.03331343084573746
      ],
      "plane_d": -1074.771728515625,
      "bbox_min": [
        -956.9534912109375,
        -3049.037353515625,
        805.8817749023438
      ],
      "bbox_max": [
        -887.49853515625,
        -2969.43994140625,
        858.8014526367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7026313543319702,
        0.032863739877939224,
        0.7107947468757629
      ],
      "plane_d": -1111.423583984375,
      "bbox_min": [
        -956.9534912109375,
        -3049.037353515625,
        805.8817749023438
      ],
      "bbox_max": [
        -887.9783325195312,
        -2969.43994140625,
        858.8014526367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.718767523765564,
        0.17485763132572174,
        0.6729028224945068
      ],
      "plane_d": -670.8665161132812,
      "bbox_min": [
        -906.4345703125,
        -2990.6005859375,
        805.8817749023438
      ],
      "bbox_max": [
        -891.521484375,
        -2984.517578125,
        820.3665161132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.016610853374004364,
        0.44841963052749634,
        0.8936688303947449
      ],
      "plane_d": 620.2237548828125,
      "bbox_min": [
        -891.6376342773438,
        -2985.04052734375,
        820.104736328125
      ],
      "bbox_max": [
        -891.521484375,
        -2984.517578125,
        820.3665161132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6638638377189636,
        0.052185166627168655,
        0.7460305094718933
      ],
      "plane_d": -1046.896484375,
      "bbox_min": [
        -956.9534912109375,
        -3049.037353515625,
        805.8817749023438
      ],
      "bbox_max": [
        -892.4285278320312,
        -2969.43994140625,
        858.8014526367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6411095261573792,
        -0.19564983248710632,
        -0.7420914173126221
      ],
      "plane_d": -530.467529296875,
      "bbox_min": [
        -956.9534912109375,
        -3046.445068359375,
        810.24658203125
      ],
      "bbox_max": [
        -893.16796875,
        -2969.43994140625,
        858.8014526367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7762428522109985,
        0.04481952264904976,
        0.6288387775421143
      ],
      "plane_d": 361.6246032714844,
      "bbox_min": [
        -956.9534912109375,
        -3046.445068359375,
        810.24658203125
      ],
      "bbox_max": [
        -947.2314453125,
        -3031.210693359375,
        823.232666015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7832221984863281,
        -0.4408717155456543,
        0.43840065598487854
      ],
      "plane_d": -2407.586669921875,
      "bbox_min": [
        -840.498779296875,
        -3030.260986328125,
        942.820068359375
      ],
      "bbox_max": [
        -671.1575317382812,
        -2930.939453125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9639432430267334,
        0.2661080062389374
      ],
      "plane_d": -3171.8916015625,
      "bbox_min": [
        -840.498779296875,
        -3030.260986328125,
        942.820068359375
      ],
      "bbox_max": [
        -695.023193359375,
        -2930.939453125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7832221984863281,
        -0.4408717155456543,
        0.43840065598487854
      ],
      "plane_d": -2407.586669921875,
      "bbox_min": [
        -905.8515625,
        -3049.0068359375,
        821.7789306640625
      ],
      "bbox_max": [
        -660.0,
        -2973.337646484375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7552521228790283,
        -0.561424732208252,
        0.3382256329059601
      ],
      "plane_d": -2654.937744140625,
      "bbox_min": [
        -893.1610717773438,
        -3049.0068359375,
        821.7789306640625
      ],
      "bbox_max": [
        -821.4185180664062,
        -3030.260986328125,
        963.815185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3876725137233734,
        -0.8030712008476257,
        0.4525335431098938
      ],
      "plane_d": -3186.01123046875,
      "bbox_min": [
        -893.1610717773438,
        -3049.0068359375,
        821.7789306640625
      ],
      "bbox_max": [
        -840.498779296875,
        -3030.260986328125,
        942.820068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9980483651161194,
        -0.052817005664110184,
        0.03331343084573746
      ],
      "plane_d": -1074.771728515625,
      "bbox_min": [
        -893.1610717773438,
        -3049.0068359375,
        821.7789306640625
      ],
      "bbox_max": [
        -887.5009155273438,
        -3046.073974609375,
        842.8760986328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7026313543319702,
        0.032863739877939224,
        0.7107947468757629
      ],
      "plane_d": -1111.423583984375,
      "bbox_min": [
        -893.1610717773438,
        -3049.0068359375,
        821.7789306640625
      ],
      "bbox_max": [
        -887.9212646484375,
        -3047.949951171875,
        826.880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6638638377189636,
        0.052185166627168655,
        0.7460305094718933
      ],
      "plane_d": -1046.896484375,
      "bbox_min": [
        -893.1610717773438,
        -3049.0068359375,
        821.7789306640625
      ],
      "bbox_max": [
        -892.3948364257812,
        -3048.86474609375,
        822.4606323242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29665228724479675,
        -0.8555408120155334,
        0.42431989312171936
      ],
      "plane_d": -3241.9052734375,
      "bbox_min": [
        -905.8515625,
        -3047.984375,
        841.0252685546875
      ],
      "bbox_max": [
        -840.498779296875,
        -3030.260986328125,
        942.820068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9954870343208313,
        -0.08357247710227966,
        -0.044957485049963
      ],
      "plane_d": -1100.083740234375,
      "bbox_min": [
        -887.7254638671875,
        -3047.984375,
        841.0252685546875
      ],
      "bbox_max": [
        -887.379150390625,
        -3045.440185546875,
        848.7921752929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9980483651161194,
        -0.052817005664110184,
        0.03331343084573746
      ],
      "plane_d": -1074.771728515625,
      "bbox_min": [
        -887.540283203125,
        -3047.984375,
        841.0252685546875
      ],
      "bbox_max": [
        -887.379150390625,
        -3045.895263671875,
        845.1235961914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3876725137233734,
        -0.8030712008476257,
        0.4525335431098938
      ],
      "plane_d": -3186.01123046875,
      "bbox_min": [
        -863.9329833984375,
        -3045.5390625,
        895.6318969726562
      ],
      "bbox_max": [
        -840.498779296875,
        -3030.260986328125,
        942.820068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7832221984863281,
        -0.4408717155456543,
        0.43840065598487854
      ],
      "plane_d": -2407.586669921875,
      "bbox_min": [
        -1025.741455078125,
        -3231.95166015625,
        810.6986083984375
      ],
      "bbox_max": [
        -660.0,
        -3031.7900390625,
        1263.7513427734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3876725137233734,
        -0.8030712008476257,
        0.4525335431098938
      ],
      "plane_d": -3186.01123046875,
      "bbox_min": [
        -902.1748046875,
        -3104.3193359375,
        813.7594604492188
      ],
      "bbox_max": [
        -841.7717895507812,
        -3045.536376953125,
        914.62158203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9980483651161194,
        -0.052817005664110184,
        0.03331343084573746
      ],
      "plane_d": -1074.771728515625,
      "bbox_min": [
        -902.1748046875,
        -3061.287353515625,
        813.7594604492188
      ],
      "bbox_max": [
        -887.2271118164062,
        -3047.984375,
        841.0252685546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6638638377189636,
        0.052185166627168655,
        0.7460305094718933
      ],
      "plane_d": -1046.896484375,
      "bbox_min": [
        -902.1748046875,
        -3061.287353515625,
        813.7594604492188
      ],
      "bbox_max": [
        -887.2271118164062,
        -3048.962646484375,
        828.1368408203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7026313543319702,
        0.032863739877939224,
        0.7107947468757629
      ],
      "plane_d": -1111.423583984375,
      "bbox_min": [
        -892.3948364257812,
        -3061.287353515625,
        822.4606323242188
      ],
      "bbox_max": [
        -887.2271118164062,
        -3048.962646484375,
        828.1368408203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35836493968963623,
        -0.7902532815933228,
        0.49706581234931946
      ],
      "plane_d": -3158.65869140625,
      "bbox_min": [
        -877.2920532226562,
        -3104.3193359375,
        822.6123046875
      ],
      "bbox_max": [
        -845.512451171875,
        -3069.9794921875,
        844.1968994140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.28822508454322815,
        -0.5853193998336792,
        0.7578439116477966
      ],
      "plane_d": -2682.9287109375,
      "bbox_min": [
        -877.2920532226562,
        -3104.3193359375,
        822.6123046875
      ],
      "bbox_max": [
        -845.512451171875,
        -3077.17919921875,
        833.787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23609928786754608,
        0.3740059733390808,
        0.896870493888855
      ],
      "plane_d": 210.2269287109375,
      "bbox_min": [
        -875.5863647460938,
        -3104.3193359375,
        822.6123046875
      ],
      "bbox_max": [
        -845.512451171875,
        -3087.461181640625,
        833.787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23609928786754608,
        0.3740059733390808,
        0.896870493888855
      ],
      "plane_d": 210.2269287109375,
      "bbox_min": [
        -1025.741455078125,
        -3231.95166015625,
        810.6986083984375
      ],
      "bbox_max": [
        -853.132080078125,
        -3044.99755859375,
        904.8870849609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0647813007235527,
        0.2180229127407074,
        0.9737911820411682
      ],
      "plane_d": -61.163818359375,
      "bbox_min": [
        -1025.741455078125,
        -3231.95166015625,
        810.6986083984375
      ],
      "bbox_max": [
        -853.132080078125,
        -3044.99755859375,
        904.8870849609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1376151144504547,
        0.1973152607679367,
        0.9706331491470337
      ],
      "plane_d": -53.18804931640625,
      "bbox_min": [
        -1025.741455078125,
        -3231.95166015625,
        810.6986083984375
      ],
      "bbox_max": [
        -853.132080078125,
        -3044.99755859375,
        904.8870849609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5448715090751648,
        -0.06585269421339035,
        0.8359296917915344
      ],
      "plane_d": -366.09857177734375,
      "bbox_min": [
        -1025.741455078125,
        -3209.46337890625,
        810.6986083984375
      ],
      "bbox_max": [
        -853.132080078125,
        -3044.99755859375,
        904.8870849609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7762428522109985,
        0.04481952264904976,
        0.6288387775421143
      ],
      "plane_d": 361.6246032714844,
      "bbox_min": [
        -954.449951171875,
        -3071.92578125,
        811.5111083984375
      ],
      "bbox_max": [
        -947.376220703125,
        -3045.4013671875,
        820.1685791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3876725137233734,
        -0.8030712008476257,
        0.4525335431098938
      ],
      "plane_d": -3186.01123046875,
      "bbox_min": [
        -970.10693359375,
        -3087.461181640625,
        810.6986083984375
      ],
      "bbox_max": [
        -853.132080078125,
        -3044.99755859375,
        904.8870849609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7160930037498474,
        -0.12640127539634705,
        -0.6864644289016724
      ],
      "plane_d": -438.1142578125,
      "bbox_min": [
        -901.7431030273438,
        -3072.021240234375,
        825.3636474609375
      ],
      "bbox_max": [
        -886.54736328125,
        -3045.5439453125,
        863.2323608398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9954870343208313,
        -0.08357247710227966,
        -0.044957485049963
      ],
      "plane_d": -1100.083740234375,
      "bbox_min": [
        -889.9364013671875,
        -3072.021240234375,
        825.3636474609375
      ],
      "bbox_max": [
        -886.54736328125,
        -3047.428955078125,
        850.0946655273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7026313543319702,
        0.032863739877939224,
        0.7107947468757629
      ],
      "plane_d": -1111.423583984375,
      "bbox_min": [
        -889.9364013671875,
        -3072.021240234375,
        825.3636474609375
      ],
      "bbox_max": [
        -886.62353515625,
        -3059.231689453125,
        829.22900390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29665228724479675,
        -0.8555408120155334,
        0.42431989312171936
      ],
      "plane_d": -3241.9052734375,
      "bbox_min": [
        -970.10693359375,
        -3087.461181640625,
        812.6204223632812
      ],
      "bbox_max": [
        -863.9329833984375,
        -3044.99755859375,
        895.6318969726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6638638377189636,
        0.052185166627168655,
        0.7460305094718933
      ],
      "plane_d": -1046.896484375,
      "bbox_min": [
        -905.2882690429688,
        -3072.369873046875,
        812.6204223632812
      ],
      "bbox_max": [
        -905.055419921875,
        -3072.3486328125,
        812.8273315429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.46676844358444214,
        -0.37923112511634827,
        0.7989436984062195
      ],
      "plane_d": -1372.69287109375,
      "bbox_min": [
        -970.10693359375,
        -3087.461181640625,
        812.621826171875
      ],
      "bbox_max": [
        -873.3448486328125,
        -3047.46533203125,
        850.0946655273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7762428522109985,
        0.04481952264904976,
        0.6288387775421143
      ],
      "plane_d": 361.6246032714844,
      "bbox_min": [
        -962.9921875,
        -3071.92578125,
        813.6261596679688
      ],
      "bbox_max": [
        -947.618408203125,
        -3047.46533203125,
        831.2987060546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.28822508454322815,
        -0.5853193998336792,
        0.7578439116477966
      ],
      "plane_d": -2682.9287109375,
      "bbox_min": [
        -905.2880249023438,
        -3087.461181640625,
        812.621826171875
      ],
      "bbox_max": [
        -873.3448486328125,
        -3060.28271484375,
        850.0946655273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6638638377189636,
        0.052185166627168655,
        0.7460305094718933
      ],
      "plane_d": -1046.896484375,
      "bbox_min": [
        -905.2880249023438,
        -3084.55419921875,
        812.621826171875
      ],
      "bbox_max": [
        -886.54931640625,
        -3070.885498046875,
        831.2197875976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7026313543319702,
        0.032863739877939224,
        0.7107947468757629
      ],
      "plane_d": -1111.423583984375,
      "bbox_min": [
        -886.8619384765625,
        -3073.32177734375,
        828.9940795898438
      ],
      "bbox_max": [
        -886.54931640625,
        -3072.00390625,
        829.36328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35836493968963623,
        -0.7902532815933228,
        0.49706581234931946
      ],
      "plane_d": -3158.65869140625,
      "bbox_min": [
        -886.6162719726562,
        -3077.17919921875,
        829.36328125
      ],
      "bbox_max": [
        -873.3448486328125,
        -3060.28271484375,
        850.0946655273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9980483651161194,
        -0.052817005664110184,
        0.03331343084573746
      ],
      "plane_d": -1074.771728515625,
      "bbox_min": [
        -886.6162719726562,
        -3073.32177734375,
        829.36328125
      ],
      "bbox_max": [
        -886.54736328125,
        -3060.28271484375,
        850.0946655273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7080089449882507,
        0.7036092877388,
        0.06047677621245384
      ],
      "plane_d": 3305.96240234375,
      "bbox_min": [
        -1246.8746337890625,
        -3650.0,
        267.0
      ],
      "bbox_max": [
        -949.8262939453125,
        -3484.438720703125,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9087146520614624,
        0.40747883915901184,
        0.09054633975028992
      ],
      "plane_d": 2432.368896484375,
      "bbox_min": [
        -1242.9605712890625,
        -3650.0,
        267.0
      ],
      "bbox_max": [
        -1066.54833984375,
        -3522.844482421875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22353629767894745,
        0.44706445932388306,
        0.8661205768585205
      ],
      "plane_d": 805.0186157226562,
      "bbox_min": [
        -1242.9605712890625,
        -3650.0,
        523.410888671875
      ],
      "bbox_max": [
        -1103.9747314453125,
        -3522.844482421875,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6972339153289795,
        0.7075531482696533,
        -0.11503651738166809
      ],
      "plane_d": 3414.776123046875,
      "bbox_min": [
        -1241.79443359375,
        -3650.0,
        523.410888671875
      ],
      "bbox_max": [
        -1103.9747314453125,
        -3522.844482421875,
        654.0177612304688
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.4176754653453827,
        0.9039462208747864,
        -0.09180637449026108
      ],
      "plane_d": 2831.480224609375,
      "bbox_min": [
        -1241.79443359375,
        -3625.268798828125,
        523.410888671875
      ],
      "bbox_max": [
        -1129.3582763671875,
        -3522.844482421875,
        646.0672607421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6204783320426941,
        -0.25381484627723694,
        0.7420139312744141
      ],
      "plane_d": -692.9743041992188,
      "bbox_min": [
        -1136.913330078125,
        -3625.268798828125,
        639.978271484375
      ],
      "bbox_max": [
        -1129.3582763671875,
        -3617.101318359375,
        646.0672607421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12399445474147797,
        0.9919556379318237,
        -0.025480808690190315
      ],
      "plane_d": 3355.08447265625,
      "bbox_min": [
        -1241.79443359375,
        -3582.49755859375,
        523.410888671875
      ],
      "bbox_max": [
        -1174.7884521484375,
        -3522.844482421875,
        616.3447265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.29443126916885376,
        0.9526895880699158,
        -0.075450100004673
      ],
      "plane_d": 3762.1982421875,
      "bbox_min": [
        -1241.79443359375,
        -3582.49755859375,
        523.410888671875
      ],
      "bbox_max": [
        -1174.7884521484375,
        -3522.915771484375,
        616.3447265625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9682903289794922,
        -0.24441856145858765,
        0.05170512571930885
      ],
      "plane_d": 230.69781494140625,
      "bbox_min": [
        -1241.79443359375,
        -3582.49755859375,
        568.3588256835938
      ],
      "bbox_max": [
        -1174.7884521484375,
        -3522.98095703125,
        616.3447265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2920478880405426,
        0.9552298188209534,
        0.04737013578414917
      ],
      "plane_d": 3025.978759765625,
      "bbox_min": [
        -1241.79443359375,
        -3563.61962890625,
        568.3588256835938
      ],
      "bbox_max": [
        -1195.3304443359375,
        -3522.98095703125,
        601.184814453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10194253921508789,
        0.8155403137207031,
        0.5696505308151245
      ],
      "plane_d": 2422.86572265625,
      "bbox_min": [
        -1241.79443359375,
        -3523.43115234375,
        568.3588256835938
      ],
      "bbox_max": [
        -1240.4544677734375,
        -3522.98095703125,
        569.0844116210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9916691780090332,
        -0.07369291037321091,
        -0.10564820468425751
      ],
      "plane_d": 903.1526489257812,
      "bbox_min": [
        -1117.3878173828125,
        -3650.0,
        598.1708374023438
      ],
      "bbox_max": [
        -1103.9747314453125,
        -3627.469482421875,
        654.0177612304688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9870774745941162,
        0.09929077327251434,
        -0.1257752925157547
      ],
      "plane_d": 1538.393798828125,
      "bbox_min": [
        -1117.3878173828125,
        -3630.75146484375,
        598.1708374023438
      ],
      "bbox_max": [
        -1114.6973876953125,
        -3627.469482421875,
        617.580322265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9176634550094604,
        0.3884923756122589,
        -0.08347219973802567
      ],
      "plane_d": 2484.70263671875,
      "bbox_min": [
        -1112.0267333984375,
        -3650.0,
        630.5394897460938
      ],
      "bbox_max": [
        -1103.9747314453125,
        -3636.540283203125,
        654.0177612304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12280482798814774,
        0.990196704864502,
        -0.06655322015285492
      ],
      "plane_d": 3780.97509765625,
      "bbox_min": [
        -1112.0267333984375,
        -3638.3671875,
        630.5394897460938
      ],
      "bbox_max": [
        -1109.3212890625,
        -3636.540283203125,
        654.0177612304688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3108421266078949,
        0.9476532340049744,
        -0.07301102578639984
      ],
      "plane_d": 3839.369140625,
      "bbox_min": [
        -1112.0267333984375,
        -3637.294921875,
        643.9386596679688
      ],
      "bbox_max": [
        -1110.956298828125,
        -3636.540283203125,
        654.0177612304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.887483537197113,
        0.44281768798828125,
        -0.12761466205120087
      ],
      "plane_d": 2677.966796875,
      "bbox_min": [
        -1104.3135986328125,
        -3650.0,
        641.0706787109375
      ],
      "bbox_max": [
        -1103.9747314453125,
        -3649.27734375,
        642.104736328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2920549213886261,
        0.9552275538444519,
        0.047371167689561844
      ],
      "plane_d": 3025.9619140625,
      "bbox_min": [
        -1197.915283203125,
        -3620.802734375,
        601.0028686523438
      ],
      "bbox_max": [
        -1134.010498046875,
        -3563.087890625,
        646.978271484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9682872891426086,
        -0.24442988634109497,
        0.05170728266239166
      ],
      "plane_d": 230.65228271484375,
      "bbox_min": [
        -1179.875732421875,
        -3620.802734375,
        615.672119140625
      ],
      "bbox_max": [
        -1134.010498046875,
        -3580.985595703125,
        646.978271484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8414545059204102,
        -0.21241281926631927,
        0.49682489037513733
      ],
      "plane_d": -88.76022338867188,
      "bbox_min": [
        -1179.875732421875,
        -3583.088623046875,
        639.978271484375
      ],
      "bbox_max": [
        -1176.79248046875,
        -3581.075927734375,
        645.9127807617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -646.978271484375,
      "bbox_min": [
        -1159.2259521484375,
        -3620.802734375,
        631.5980834960938
      ],
      "bbox_max": [
        -1134.010498046875,
        -3600.622802734375,
        646.978271484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3877667486667633,
        0.5277730226516724,
        0.7557066679000854
      ],
      "plane_d": 968.4140625,
      "bbox_min": [
        -1159.2259521484375,
        -3620.802734375,
        631.5980834960938
      ],
      "bbox_max": [
        -1134.010498046875,
        -3600.622802734375,
        646.978271484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4176754653453827,
        0.9039462208747864,
        -0.09180637449026108
      ],
      "plane_d": 2831.480224609375,
      "bbox_min": [
        -1159.2259521484375,
        -3620.802734375,
        631.5980834960938
      ],
      "bbox_max": [
        -1134.010498046875,
        -3600.622802734375,
        646.978271484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6204783320426941,
        -0.25381484627723694,
        0.7420139312744141
      ],
      "plane_d": -692.9743041992188,
      "bbox_min": [
        -1137.7294921875,
        -3620.802734375,
        644.906005859375
      ],
      "bbox_max": [
        -1134.010498046875,
        -3616.549560546875,
        646.978271484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7145941853523254,
        -0.5343031287193298,
        0.4515254497528076
      ],
      "plane_d": -1413.361572265625,
      "bbox_min": [
        -1137.7294921875,
        -3620.134521484375,
        645.08935546875
      ],
      "bbox_max": [
        -1134.18359375,
        -3616.549560546875,
        646.978271484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.887483537197113,
        0.44281768798828125,
        -0.12761466205120087
      ],
      "plane_d": 2677.966796875,
      "bbox_min": [
        -1110.995849609375,
        -3650.0,
        267.0
      ],
      "bbox_max": [
        -1066.54833984375,
        -3636.739013671875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12280482798814774,
        0.990196704864502,
        -0.06655322015285492
      ],
      "plane_d": 3780.97509765625,
      "bbox_min": [
        -1110.995849609375,
        -3637.43896484375,
        644.5646362304688
      ],
      "bbox_max": [
        -1109.74462890625,
        -3636.739013671875,
        652.7423095703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3108421266078949,
        0.9476532340049744,
        -0.07301102578639984
      ],
      "plane_d": 3839.369140625,
      "bbox_min": [
        -1110.995849609375,
        -3636.771240234375,
        652.4913330078125
      ],
      "bbox_max": [
        -1110.952880859375,
        -3636.739013671875,
        652.7423095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9176634550094604,
        0.3884923756122589,
        -0.08347219973802567
      ],
      "plane_d": 2484.70263671875,
      "bbox_min": [
        -1109.866943359375,
        -3650.0,
        267.0
      ],
      "bbox_max": [
        -1066.54833984375,
        -3637.38427734375,
        653.7352294921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12280482798814774,
        0.990196704864502,
        -0.06655322015285492
      ],
      "plane_d": 3780.97509765625,
      "bbox_min": [
        -1109.866943359375,
        -3637.773681640625,
        640.5932006835938
      ],
      "bbox_max": [
        -1109.1982421875,
        -3637.38427734375,
        645.6044311523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9015147686004639,
        0.4224686026573181,
        0.09376233071088791
      ],
      "plane_d": 2478.485107421875,
      "bbox_min": [
        -1068.0897216796875,
        -3650.0,
        267.0
      ],
      "bbox_max": [
        -1066.54833984375,
        -3646.800048828125,
        281.8211669921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9202737212181091,
        0.3693651854991913,
        0.12909552454948425
      ],
      "plane_d": 2369.723876953125,
      "bbox_min": [
        -1246.8746337890625,
        -3636.550048828125,
        267.0
      ],
      "bbox_max": [
        -1111.803466796875,
        -3508.74365234375,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12399445474147797,
        0.9919556379318237,
        -0.025480808690190315
      ],
      "plane_d": 3355.08447265625,
      "bbox_min": [
        -1240.95556640625,
        -3523.169677734375,
        557.7251586914062
      ],
      "bbox_max": [
        -1239.2996826171875,
        -3522.814453125,
        569.8958740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10194253921508789,
        0.8155403137207031,
        0.5696505308151245
      ],
      "plane_d": 2422.86572265625,
      "bbox_min": [
        -1240.906982421875,
        -3523.169677734375,
        568.3394165039062
      ],
      "bbox_max": [
        -1240.7171630859375,
        -3522.960693359375,
        568.6631469726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7327849268913269,
        0.6294608116149902,
        0.25846728682518005
      ],
      "plane_d": 2979.97509765625,
      "bbox_min": [
        -1240.8531494140625,
        -3523.1552734375,
        567.5443725585938
      ],
      "bbox_max": [
        -1240.6463623046875,
        -3522.888916015625,
        568.58544921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7646611928939819,
        0.6164575219154358,
        0.18781177699565887
      ],
      "plane_d": 3013.850341796875,
      "bbox_min": [
        -1240.8531494140625,
        -3523.1552734375,
        568.0107421875
      ],
      "bbox_max": [
        -1240.6463623046875,
        -3522.92724609375,
        568.58544921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10194253921508789,
        0.8155403137207031,
        0.5696505308151245
      ],
      "plane_d": 2422.86572265625,
      "bbox_min": [
        -1240.8531494140625,
        -3523.11669921875,
        568.3074951171875
      ],
      "bbox_max": [
        -1240.7275390625,
        -3522.92724609375,
        568.58544921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6330804824829102,
        0.7714124321937561,
        0.06428063660860062
      ],
      "plane_d": 3466.7158203125,
      "bbox_min": [
        -1246.8746337890625,
        -3636.550048828125,
        533.7691650390625
      ],
      "bbox_max": [
        -1111.803466796875,
        -3522.1552734375,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22353629767894745,
        0.44706445932388306,
        0.8661205768585205
      ],
      "plane_d": 805.0186157226562,
      "bbox_min": [
        -1240.724609375,
        -3635.74853515625,
        568.6075439453125
      ],
      "bbox_max": [
        -1112.7955322265625,
        -3523.1318359375,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9682903289794922,
        -0.24441856145858765,
        0.05170512571930885
      ],
      "plane_d": 230.69781494140625,
      "bbox_min": [
        -1240.724609375,
        -3617.375732421875,
        568.6075439453125
      ],
      "bbox_max": [
        -1133.5897216796875,
        -3523.1318359375,
        644.906005859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2920478880405426,
        0.9552298188209534,
        0.04737013578414917
      ],
      "plane_d": 3025.978759765625,
      "bbox_min": [
        -1240.724609375,
        -3563.087890625,
        568.6075439453125
      ],
      "bbox_max": [
        -1195.3304443359375,
        -3523.1318359375,
        601.1883544921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10194253921508789,
        0.8155403137207031,
        0.5696505308151245
      ],
      "plane_d": 2422.86572265625,
      "bbox_min": [
        -1240.724609375,
        -3523.435546875,
        568.6075439453125
      ],
      "bbox_max": [
        -1240.4049072265625,
        -3523.1318359375,
        569.0994262695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4176754653453827,
        0.9039462208747864,
        -0.09180637449026108
      ],
      "plane_d": 2831.480224609375,
      "bbox_min": [
        -1152.5810546875,
        -3617.375732421875,
        631.0070190429688
      ],
      "bbox_max": [
        -1133.5897216796875,
        -3600.7470703125,
        644.906005859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2920549213886261,
        0.9552275538444519,
        0.047371167689561844
      ],
      "plane_d": 3025.9619140625,
      "bbox_min": [
        -1197.9991455078125,
        -3617.101318359375,
        601.184814453125
      ],
      "bbox_max": [
        -1133.9940185546875,
        -3563.07763671875,
        649.5787353515625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9682872891426086,
        -0.24442988634109497,
        0.05170728266239166
      ],
      "plane_d": 230.65228271484375,
      "bbox_min": [
        -1197.9991455078125,
        -3617.101318359375,
        615.658935546875
      ],
      "bbox_max": [
        -1133.9940185546875,
        -3565.357421875,
        649.5787353515625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5614482760429382,
        0.6272249817848206,
        0.5397820472717285
      ],
      "plane_d": 2558.77978515625,
      "bbox_min": [
        -1197.9991455078125,
        -3582.7421875,
        639.978271484375
      ],
      "bbox_max": [
        -1176.54248046875,
        -3565.357421875,
        649.5787353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2544113099575043,
        0.8321059942245483,
        0.49282306432724
      ],
      "plane_d": 2346.951171875,
      "bbox_min": [
        -1197.9991455078125,
        -3582.7421875,
        639.978271484375
      ],
      "bbox_max": [
        -1176.54248046875,
        -3565.357421875,
        649.5787353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8414545059204102,
        -0.21241281926631927,
        0.49682489037513733
      ],
      "plane_d": -88.76022338867188,
      "bbox_min": [
        -1181.111083984375,
        -3582.7421875,
        639.978271484375
      ],
      "bbox_max": [
        -1176.54248046875,
        -3579.67138671875,
        648.3598022460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -646.978271484375,
      "bbox_min": [
        -1154.1099853515625,
        -3617.101318359375,
        631.677978515625
      ],
      "bbox_max": [
        -1133.9940185546875,
        -3600.456787109375,
        646.978271484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4176754653453827,
        0.9039462208747864,
        -0.09180637449026108
      ],
      "plane_d": 2831.480224609375,
      "bbox_min": [
        -1154.1099853515625,
        -3617.101318359375,
        631.677978515625
      ],
      "bbox_max": [
        -1133.9940185546875,
        -3600.456787109375,
        646.978271484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3877667486667633,
        0.5277730226516724,
        0.7557066679000854
      ],
      "plane_d": 968.4140625,
      "bbox_min": [
        -1154.1099853515625,
        -3617.101318359375,
        639.978271484375
      ],
      "bbox_max": [
        -1133.9940185546875,
        -3600.456787109375,
        646.978271484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34775376319885254,
        0.7526194453239441,
        0.5591343641281128
      ],
      "plane_d": 1950.7188720703125,
      "bbox_min": [
        -1154.1099853515625,
        -3617.101318359375,
        639.978271484375
      ],
      "bbox_max": [
        -1133.9940185546875,
        -3600.456787109375,
        646.978271484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7145941853523254,
        -0.5343031287193298,
        0.4515254497528076
      ],
      "plane_d": -1413.361572265625,
      "bbox_min": [
        -1135.0489501953125,
        -3617.101318359375,
        644.8994140625
      ],
      "bbox_max": [
        -1133.9940185546875,
        -3616.449462890625,
        646.978271484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6204783320426941,
        -0.25381484627723694,
        0.7420139312744141
      ],
      "plane_d": -692.9743041992188,
      "bbox_min": [
        -1134.18359375,
        -3617.101318359375,
        644.8994140625
      ],
      "bbox_max": [
        -1133.9940185546875,
        -3616.963134765625,
        645.08935546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22353629767894745,
        0.44706445932388306,
        0.8661205768585205
      ],
      "plane_d": 805.0186157226562,
      "bbox_min": [
        -1245.0706787109375,
        -3635.73583984375,
        533.7691650390625
      ],
      "bbox_max": [
        -1112.6732177734375,
        -3522.1552734375,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6972339153289795,
        0.7075531482696533,
        -0.11503651738166809
      ],
      "plane_d": 3414.776123046875,
      "bbox_min": [
        -1240.7701416015625,
        -3621.659912109375,
        533.7691650390625
      ],
      "bbox_max": [
        -1122.1151123046875,
        -3522.1552734375,
        644.8994140625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.29443126916885376,
        0.9526895880699158,
        -0.075450100004673
      ],
      "plane_d": 3762.1982421875,
      "bbox_min": [
        -1240.7701416015625,
        -3620.13427734375,
        533.7691650390625
      ],
      "bbox_max": [
        -1128.4976806640625,
        -3522.1552734375,
        644.8994140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9221007227897644,
        -0.3771974444389343,
        -0.08632692694664001
      ],
      "plane_d": -268.8760681152344,
      "bbox_min": [
        -1240.7701416015625,
        -3620.13427734375,
        549.6126098632812
      ],
      "bbox_max": [
        -1128.4976806640625,
        -3522.1552734375,
        644.8994140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4176754653453827,
        0.9039462208747864,
        -0.09180637449026108
      ],
      "plane_d": 2831.480224609375,
      "bbox_min": [
        -1240.7701416015625,
        -3620.13427734375,
        549.6126098632812
      ],
      "bbox_max": [
        -1128.4976806640625,
        -3522.1552734375,
        644.8994140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6204783320426941,
        -0.25381484627723694,
        0.7420139312744141
      ],
      "plane_d": -692.9743041992188,
      "bbox_min": [
        -1133.9940185546875,
        -3620.13427734375,
        639.978271484375
      ],
      "bbox_max": [
        -1128.4976806640625,
        -3614.833984375,
        644.8994140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7145941853523254,
        -0.5343031287193298,
        0.4515254497528076
      ],
      "plane_d": -1413.361572265625,
      "bbox_min": [
        -1133.3232421875,
        -3616.225341796875,
        643.8668823242188
      ],
      "bbox_max": [
        -1131.8887939453125,
        -3614.833984375,
        644.6310424804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6635910868644714,
        0.7413342595100403,
        0.10035180300474167
      ],
      "plane_d": 3368.36376953125,
      "bbox_min": [
        -1240.7701416015625,
        -3580.9560546875,
        549.6126098632812
      ],
      "bbox_max": [
        -1172.5892333984375,
        -3522.1552734375,
        615.658935546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9682903289794922,
        -0.24441856145858765,
        0.05170512571930885
      ],
      "plane_d": 230.69781494140625,
      "bbox_min": [
        -1240.7701416015625,
        -3580.9560546875,
        549.6126098632812
      ],
      "bbox_max": [
        -1172.5892333984375,
        -3522.1552734375,
        615.658935546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12399445474147797,
        0.9919556379318237,
        -0.025480808690190315
      ],
      "plane_d": 3355.08447265625,
      "bbox_min": [
        -1240.7701416015625,
        -3563.07763671875,
        549.6126098632812
      ],
      "bbox_max": [
        -1188.42578125,
        -3522.1552734375,
        601.8727416992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10194253921508789,
        0.8155403137207031,
        0.5696505308151245
      ],
      "plane_d": 2422.86572265625,
      "bbox_min": [
        -1240.7701416015625,
        -3563.07763671875,
        568.1181640625
      ],
      "bbox_max": [
        -1188.42578125,
        -3522.1552734375,
        601.8727416992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2920478880405426,
        0.9552298188209534,
        0.04737013578414917
      ],
      "plane_d": 3025.978759765625,
      "bbox_min": [
        -1240.7275390625,
        -3563.07763671875,
        568.1181640625
      ],
      "bbox_max": [
        -1188.42578125,
        -3523.116455078125,
        601.8727416992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7217350602149963,
        0.6888043284416199,
        0.06816939264535904
      ],
      "plane_d": 3283.454345703125,
      "bbox_min": [
        -1240.7275390625,
        -3523.170166015625,
        568.1181640625
      ],
      "bbox_max": [
        -1240.6463623046875,
        -3523.116455078125,
        568.66943359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7217350602149963,
        0.6888043284416199,
        0.06816939264535904
      ],
      "plane_d": 3283.454345703125,
      "bbox_min": [
        -1240.7701416015625,
        -3523.176025390625,
        568.5850219726562
      ],
      "bbox_max": [
        -1240.684326171875,
        -3523.095947265625,
        568.889404296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7217350602149963,
        0.6888043284416199,
        0.06816939264535904
      ],
      "plane_d": 3283.454345703125,
      "bbox_min": [
        -1245.0706787109375,
        -3617.08056640625,
        568.829833984375
      ],
      "bbox_max": [
        -1132.038818359375,
        -3523.00732421875,
        647.521484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6635910868644714,
        0.7413342595100403,
        0.10035180300474167
      ],
      "plane_d": 3368.36376953125,
      "bbox_min": [
        -1196.519287109375,
        -3617.08056640625,
        601.1883544921875
      ],
      "bbox_max": [
        -1132.038818359375,
        -3561.078125,
        647.521484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2920478880405426,
        0.9552298188209534,
        0.04737013578414917
      ],
      "plane_d": 3025.978759765625,
      "bbox_min": [
        -1196.519287109375,
        -3617.08056640625,
        601.1883544921875
      ],
      "bbox_max": [
        -1133.4244384765625,
        -3561.078125,
        647.521484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9682903289794922,
        -0.24441856145858765,
        0.05170512571930885
      ],
      "plane_d": 230.69781494140625,
      "bbox_min": [
        -1196.519287109375,
        -3617.08056640625,
        613.4913330078125
      ],
      "bbox_max": [
        -1133.4244384765625,
        -3563.800048828125,
        647.521484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2544113099575043,
        0.8321059942245483,
        0.49282306432724
      ],
      "plane_d": 2346.951171875,
      "bbox_min": [
        -1196.519287109375,
        -3581.751708984375,
        639.978271484375
      ],
      "bbox_max": [
        -1175.5892333984375,
        -3563.800048828125,
        647.521484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8414545059204102,
        -0.21241281926631927,
        0.49682489037513733
      ],
      "plane_d": -88.76022338867188,
      "bbox_min": [
        -1179.7132568359375,
        -3581.751708984375,
        639.978271484375
      ],
      "bbox_max": [
        -1175.5892333984375,
        -3577.975830078125,
        646.238037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -646.978271484375,
      "bbox_min": [
        -1153.75048828125,
        -3617.08056640625,
        631.678466796875
      ],
      "bbox_max": [
        -1133.4244384765625,
        -3599.45849609375,
        646.978271484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4176754653453827,
        0.9039462208747864,
        -0.09180637449026108
      ],
      "plane_d": 2831.480224609375,
      "bbox_min": [
        -1153.75048828125,
        -3617.08056640625,
        631.678466796875
      ],
      "bbox_max": [
        -1133.4244384765625,
        -3599.45849609375,
        646.978271484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3877667486667633,
        0.5277730226516724,
        0.7557066679000854
      ],
      "plane_d": 968.4140625,
      "bbox_min": [
        -1153.75048828125,
        -3617.08056640625,
        639.978271484375
      ],
      "bbox_max": [
        -1133.4244384765625,
        -3599.45849609375,
        646.978271484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34775376319885254,
        0.7526194453239441,
        0.5591343641281128
      ],
      "plane_d": 1950.7188720703125,
      "bbox_min": [
        -1153.75048828125,
        -3617.08056640625,
        639.978271484375
      ],
      "bbox_max": [
        -1133.4244384765625,
        -3599.45849609375,
        646.978271484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7145941853523254,
        -0.5343031287193298,
        0.4515254497528076
      ],
      "plane_d": -1413.361572265625,
      "bbox_min": [
        -1134.97412109375,
        -3617.08056640625,
        644.6715087890625
      ],
      "bbox_max": [
        -1133.4244384765625,
        -3615.74853515625,
        646.978271484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6204783320426941,
        -0.25381484627723694,
        0.7420139312744141
      ],
      "plane_d": -692.9743041992188,
      "bbox_min": [
        -1134.1549072265625,
        -3617.08056640625,
        644.6715087890625
      ],
      "bbox_max": [
        -1133.4244384765625,
        -3616.33642578125,
        645.0740356445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -646.978271484375,
      "bbox_min": [
        -1151.5899658203125,
        -3616.354248046875,
        631.7232666015625
      ],
      "bbox_max": [
        -1132.038818359375,
        -3597.990478515625,
        646.978271484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4176754653453827,
        0.9039462208747864,
        -0.09180637449026108
      ],
      "plane_d": 2831.480224609375,
      "bbox_min": [
        -1151.5899658203125,
        -3616.354248046875,
        631.7232666015625
      ],
      "bbox_max": [
        -1132.038818359375,
        -3597.990478515625,
        646.978271484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34775376319885254,
        0.7526194453239441,
        0.5591343641281128
      ],
      "plane_d": 1950.7188720703125,
      "bbox_min": [
        -1151.5899658203125,
        -3616.354248046875,
        639.978271484375
      ],
      "bbox_max": [
        -1132.038818359375,
        -3597.990478515625,
        646.978271484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3877667486667633,
        0.5277730226516724,
        0.7557066679000854
      ],
      "plane_d": 968.4140625,
      "bbox_min": [
        -1149.94580078125,
        -3616.354248046875,
        643.6510009765625
      ],
      "bbox_max": [
        -1132.038818359375,
        -3600.77880859375,
        646.978271484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7145941853523254,
        -0.5343031287193298,
        0.4515254497528076
      ],
      "plane_d": -1413.361572265625,
      "bbox_min": [
        -1134.4500732421875,
        -3616.354248046875,
        644.244384765625
      ],
      "bbox_max": [
        -1132.038818359375,
        -3613.97607421875,
        646.978271484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6204783320426941,
        -0.25381484627723694,
        0.7420139312744141
      ],
      "plane_d": -692.9743041992188,
      "bbox_min": [
        -1133.448486328125,
        -3616.354248046875,
        644.6310424804688
      ],
      "bbox_max": [
        -1133.3232421875,
        -3616.225341796875,
        644.69775390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6450628638267517,
        -0.7628151178359985,
        0.04480097442865372
      ],
      "plane_d": -3426.438232421875,
      "bbox_min": [
        -1206.89111328125,
        -3650.0,
        267.0
      ],
      "bbox_max": [
        -949.8262939453125,
        -3484.438720703125,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6477525234222412,
        -0.7609485387802124,
        0.03706754744052887
      ],
      "plane_d": -3420.204345703125,
      "bbox_min": [
        -1143.2298583984375,
        -3646.800048828125,
        267.0
      ],
      "bbox_max": [
        -980.744873046875,
        -3484.438720703125,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6477525234222412,
        -0.7609485387802124,
        0.03706754744052887
      ],
      "plane_d": -3420.204345703125,
      "bbox_min": [
        -1155.2579345703125,
        -3508.48583984375,
        267.0
      ],
      "bbox_max": [
        -1140.9757080078125,
        -3487.271240234375,
        369.31988525390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8701116442680359,
        -0.4906183183193207,
        0.04689646139740944
      ],
      "plane_d": -2729.62939453125,
      "bbox_min": [
        -1155.2579345703125,
        -3506.523681640625,
        267.0
      ],
      "bbox_max": [
        -1140.9757080078125,
        -3487.271240234375,
        369.31988525390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8973290324211121,
        -0.4287506937980652,
        0.1047549843788147
      ],
      "plane_d": -2564.411865234375,
      "bbox_min": [
        -1152.176513671875,
        -3506.034912109375,
        332.6519775390625
      ],
      "bbox_max": [
        -1140.9757080078125,
        -3487.271240234375,
        369.31988525390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6611984968185425,
        -0.7488041520118713,
        0.045921631157398224
      ],
      "plane_d": -3391.467041015625,
      "bbox_min": [
        -1206.89111328125,
        -3650.0,
        267.0
      ],
      "bbox_max": [
        -949.8262939453125,
        -3493.7353515625,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6585033535957336,
        -0.7513062953948975,
        0.04372837394475937
      ],
      "plane_d": -3397.36328125,
      "bbox_min": [
        -980.744873046875,
        -3650.0,
        267.0
      ],
      "bbox_max": [
        -976.505615234375,
        -3646.800048828125,
        275.8599548339844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6285895705223083,
        -0.7772358059883118,
        0.02792278490960598
      ],
      "plane_d": -3452.181396484375,
      "bbox_min": [
        -1206.89111328125,
        -3646.800048828125,
        267.0
      ],
      "bbox_max": [
        -953.4501953125,
        -3493.7353515625,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9201366305351257,
        -0.3901376724243164,
        0.03378250449895859
      ],
      "plane_d": -2429.739990234375,
      "bbox_min": [
        -1140.9757080078125,
        -3506.034912109375,
        356.70367431640625
      ],
      "bbox_max": [
        -1131.06005859375,
        -3493.7353515625,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9524388313293457,
        -0.2936769425868988,
        0.08132689446210861
      ],
      "plane_d": -2159.927490234375,
      "bbox_min": [
        -1135.727294921875,
        -3501.4384765625,
        641.6961059570312
      ],
      "bbox_max": [
        -1131.7891845703125,
        -3493.7353515625,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2235339730978012,
        0.44706639647483826,
        0.8661202788352966
      ],
      "plane_d": 805.0284423828125,
      "bbox_min": [
        -1206.89111328125,
        -3644.052734375,
        267.0
      ],
      "bbox_max": [
        -1104.3472900390625,
        -3507.775390625,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6972339153289795,
        0.707552969455719,
        -0.11503762751817703
      ],
      "plane_d": 3414.776123046875,
      "bbox_min": [
        -1206.89111328125,
        -3644.052734375,
        267.0
      ],
      "bbox_max": [
        -1104.3472900390625,
        -3507.775390625,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9870774745941162,
        0.09929077327251434,
        -0.1257752925157547
      ],
      "plane_d": 1538.393798828125,
      "bbox_min": [
        -1147.3653564453125,
        -3644.052734375,
        606.9952392578125
      ],
      "bbox_max": [
        -1104.3472900390625,
        -3596.57177734375,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9916691780090332,
        -0.07369291037321091,
        -0.10564820468425751
      ],
      "plane_d": 903.1526489257812,
      "bbox_min": [
        -1147.3653564453125,
        -3637.1904296875,
        608.774169921875
      ],
      "bbox_max": [
        -1108.632080078125,
        -3596.57177734375,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9221007227897644,
        -0.3771974444389343,
        -0.08632692694664001
      ],
      "plane_d": -268.8760681152344,
      "bbox_min": [
        -1147.3653564453125,
        -3618.030517578125,
        608.774169921875
      ],
      "bbox_max": [
        -1126.1817626953125,
        -3596.57177734375,
        644.2445068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6479190587997437,
        0.7238216996192932,
        -0.23724038898944855
      ],
      "plane_d": 3492.364501953125,
      "bbox_min": [
        -1147.3653564453125,
        -3618.030517578125,
        608.774169921875
      ],
      "bbox_max": [
        -1126.1817626953125,
        -3596.57177734375,
        644.2445068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4176754653453827,
        0.9039462208747864,
        -0.09180637449026108
      ],
      "plane_d": 2831.480224609375,
      "bbox_min": [
        -1147.3653564453125,
        -3618.030517578125,
        612.8455200195312
      ],
      "bbox_max": [
        -1126.1817626953125,
        -3596.57177734375,
        644.2445068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6204783320426941,
        -0.25381484627723694,
        0.7420139312744141
      ],
      "plane_d": -692.9743041992188,
      "bbox_min": [
        -1132.038818359375,
        -3618.030517578125,
        639.978271484375
      ],
      "bbox_max": [
        -1126.1817626953125,
        -3610.265869140625,
        644.2445068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7145941853523254,
        -0.5343031287193298,
        0.4515254497528076
      ],
      "plane_d": -1413.361572265625,
      "bbox_min": [
        -1132.038818359375,
        -3614.952392578125,
        641.4635009765625
      ],
      "bbox_max": [
        -1127.377197265625,
        -3610.265869140625,
        644.2445068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12278418987989426,
        0.9901995658874512,
        -0.06654910743236542
      ],
      "plane_d": 3780.9599609375,
      "bbox_min": [
        -1111.3021240234375,
        -3637.1904296875,
        647.7892456054688
      ],
      "bbox_max": [
        -1108.632080078125,
        -3636.29443359375,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9176634550094604,
        0.3884923756122589,
        -0.08347219973802567
      ],
      "plane_d": 2484.70263671875,
      "bbox_min": [
        -1110.1240234375,
        -3644.052734375,
        642.4576416015625
      ],
      "bbox_max": [
        -1104.3472900390625,
        -3636.554931640625,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12280482798814774,
        0.990196704864502,
        -0.06655322015285492
      ],
      "plane_d": 3780.97509765625,
      "bbox_min": [
        -1110.1240234375,
        -3637.66357421875,
        642.4576416015625
      ],
      "bbox_max": [
        -1108.0408935546875,
        -3636.554931640625,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6479190587997437,
        0.7238216996192932,
        -0.23724038898944855
      ],
      "plane_d": 3492.364501953125,
      "bbox_min": [
        -1206.89111328125,
        -3613.888427734375,
        267.0
      ],
      "bbox_max": [
        -1124.5892333984375,
        -3507.775390625,
        642.97509765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9221007227897644,
        -0.3771974444389343,
        -0.08632692694664001
      ],
      "plane_d": -268.8760681152344,
      "bbox_min": [
        -1144.155029296875,
        -3613.888427734375,
        609.6682739257812
      ],
      "bbox_max": [
        -1124.5892333984375,
        -3595.746337890625,
        642.97509765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4176754653453827,
        0.9039462208747864,
        -0.09180637449026108
      ],
      "plane_d": 2831.480224609375,
      "bbox_min": [
        -1144.155029296875,
        -3612.368896484375,
        617.6029663085938
      ],
      "bbox_max": [
        -1124.5892333984375,
        -3595.746337890625,
        642.97509765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6204783320426941,
        -0.25381484627723694,
        0.7420139312744141
      ],
      "plane_d": -692.9743041992188,
      "bbox_min": [
        -1127.8212890625,
        -3612.368896484375,
        639.978271484375
      ],
      "bbox_max": [
        -1124.5892333984375,
        -3608.475830078125,
        642.97509765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7145941853523254,
        -0.5343031287193298,
        0.4515254497528076
      ],
      "plane_d": -1413.361572265625,
      "bbox_min": [
        -1127.8212890625,
        -3610.949462890625,
        639.978271484375
      ],
      "bbox_max": [
        -1124.5892333984375,
        -3608.475830078125,
        642.97509765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9202737212181091,
        0.3693651854991913,
        0.12909552454948425
      ],
      "plane_d": 2369.723876953125,
      "bbox_min": [
        -1206.89111328125,
        -3510.526611328125,
        267.0
      ],
      "bbox_max": [
        -1203.474365234375,
        -3507.775390625,
        286.2550048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5427155494689941,
        0.6063084602355957,
        0.5812486410140991
      ],
      "plane_d": 2426.19482421875,
      "bbox_min": [
        -1148.4129638671875,
        -3614.833984375,
        631.7750244140625
      ],
      "bbox_max": [
        -1126.7498779296875,
        -3594.300048828125,
        646.978271484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6479190587997437,
        0.7238216996192932,
        -0.23724038898944855
      ],
      "plane_d": 3492.364501953125,
      "bbox_min": [
        -1148.4129638671875,
        -3614.833984375,
        631.7750244140625
      ],
      "bbox_max": [
        -1126.7498779296875,
        -3594.300048828125,
        646.978271484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -646.978271484375,
      "bbox_min": [
        -1148.4129638671875,
        -3614.833984375,
        631.7750244140625
      ],
      "bbox_max": [
        -1126.7498779296875,
        -3594.300048828125,
        646.978271484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4176754653453827,
        0.9039462208747864,
        -0.09180637449026108
      ],
      "plane_d": 2831.480224609375,
      "bbox_min": [
        -1148.4129638671875,
        -3614.833984375,
        631.7750244140625
      ],
      "bbox_max": [
        -1126.7498779296875,
        -3594.300048828125,
        646.978271484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7145941853523254,
        -0.5343031287193298,
        0.4515254497528076
      ],
      "plane_d": -1413.361572265625,
      "bbox_min": [
        -1146.086181640625,
        -3614.833984375,
        642.652587890625
      ],
      "bbox_max": [
        -1126.7498779296875,
        -3600.0146484375,
        646.978271484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3877667486667633,
        0.5277730226516724,
        0.7557066679000854
      ],
      "plane_d": 968.4140625,
      "bbox_min": [
        -1146.086181640625,
        -3602.33349609375,
        645.1785278320312
      ],
      "bbox_max": [
        -1141.53857421875,
        -3600.0146484375,
        646.978271484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6607861518859863,
        -0.7483370900154114,
        0.05790644884109497
      ],
      "plane_d": -3397.280517578125,
      "bbox_min": [
        -1276.5831298828125,
        -3650.0,
        660.0
      ],
      "bbox_max": [
        -760.7306518554688,
        -3362.595947265625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2074883133172989,
        0.8826481699943542,
        0.42175933718681335
      ],
      "plane_d": 2287.469970703125,
      "bbox_min": [
        -1136.84423828125,
        -3650.0,
        660.0
      ],
      "bbox_max": [
        -760.7306518554688,
        -3362.595947265625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9792153239250183,
        -0.19332727789878845,
        0.061334479600191116
      ],
      "plane_d": -1825.3980712890625,
      "bbox_min": [
        -1136.84423828125,
        -3650.0,
        660.0
      ],
      "bbox_max": [
        -893.34814453125,
        -3470.2734375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6438754796981812,
        -0.7624677419662476,
        0.06377595663070679
      ],
      "plane_d": -3441.28662109375,
      "bbox_min": [
        -897.137451171875,
        -3650.0,
        1288.1129150390625
      ],
      "bbox_max": [
        -893.34814453125,
        -3646.800048828125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9528772234916687,
        -0.2737281024456024,
        0.130758598446846
      ],
      "plane_d": -2123.362548828125,
      "bbox_min": [
        -1136.84423828125,
        -3486.420166015625,
        660.0
      ],
      "bbox_max": [
        -1132.9666748046875,
        -3483.275146484375,
        687.8972778320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6443679928779602,
        -0.762627899646759,
        0.0564676970243454
      ],
      "plane_d": -3432.79296875,
      "bbox_min": [
        -1276.5831298828125,
        -3650.0,
        660.0
      ],
      "bbox_max": [
        -897.137451171875,
        -3475.992919921875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9792153239250183,
        -0.19332727789878845,
        0.061334479600191116
      ],
      "plane_d": -1825.3980712890625,
      "bbox_min": [
        -1136.681396484375,
        -3646.800048828125,
        660.0
      ],
      "bbox_max": [
        -897.137451171875,
        -3475.992919921875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6707790493965149,
        -0.7331188917160034,
        0.11221480369567871
      ],
      "plane_d": -3421.490234375,
      "bbox_min": [
        -1109.4647216796875,
        -3646.800048828125,
        1090.7999267578125
      ],
      "bbox_max": [
        -897.137451171875,
        -3475.992919921875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9945406317710876,
        -0.05085870251059532,
        0.09111718833446503
      ],
      "plane_d": -1379.3016357421875,
      "bbox_min": [
        -1109.4647216796875,
        -3483.7431640625,
        1090.7999267578125
      ],
      "bbox_max": [
        -1097.50732421875,
        -3475.992919921875,
        1217.9898681640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9931049346923828,
        0.0022958379704505205,
        0.11720679700374603
      ],
      "plane_d": -1221.6827392578125,
      "bbox_min": [
        -1109.4647216796875,
        -3483.7431640625,
        1090.7999267578125
      ],
      "bbox_max": [
        -1106.3704833984375,
        -3476.015625,
        1117.1605224609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9528772234916687,
        -0.2737281024456024,
        0.130758598446846
      ],
      "plane_d": -2123.362548828125,
      "bbox_min": [
        -1136.681396484375,
        -3494.98193359375,
        660.0
      ],
      "bbox_max": [
        -1131.9222412109375,
        -3485.005615234375,
        684.1095581054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6268800497055054,
        -0.7762154936790466,
        0.06716372817754745
      ],
      "plane_d": -3472.729736328125,
      "bbox_min": [
        -1276.5831298828125,
        -3650.0,
        660.0
      ],
      "bbox_max": [
        -953.4501953125,
        -3483.7431640625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9792153239250183,
        -0.19332727789878845,
        0.061334479600191116
      ],
      "plane_d": -1825.3980712890625,
      "bbox_min": [
        -1134.008544921875,
        -3646.800048828125,
        660.0
      ],
      "bbox_max": [
        -953.4501953125,
        -3483.7431640625,
        1117.1605224609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6285895705223083,
        -0.7772358059883118,
        0.02792278490960598
      ],
      "plane_d": -3452.181396484375,
      "bbox_min": [
        -1131.270263671875,
        -3646.800048828125,
        660.0
      ],
      "bbox_max": [
        -953.4501953125,
        -3502.662109375,
        663.99609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9201366305351257,
        -0.3901376724243164,
        0.03378250449895859
      ],
      "plane_d": -2429.739990234375,
      "bbox_min": [
        -1131.270263671875,
        -3503.157958984375,
        660.0
      ],
      "bbox_max": [
        -1130.929443359375,
        -3502.662109375,
        663.99609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9528772234916687,
        -0.2737281024456024,
        0.130758598446846
      ],
      "plane_d": -2123.362548828125,
      "bbox_min": [
        -1134.008544921875,
        -3503.1201171875,
        660.0
      ],
      "bbox_max": [
        -1130.929443359375,
        -3494.23974609375,
        673.7976684570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9524388313293457,
        -0.2936769425868988,
        0.08132689446210861
      ],
      "plane_d": -2159.927490234375,
      "bbox_min": [
        -1134.008544921875,
        -3503.1201171875,
        660.0
      ],
      "bbox_max": [
        -1130.929443359375,
        -3494.23974609375,
        663.99609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9201366305351257,
        -0.3901376724243164,
        0.03378250449895859
      ],
      "plane_d": -2429.739990234375,
      "bbox_min": [
        -1131.7891845703125,
        -3503.1201171875,
        660.0
      ],
      "bbox_max": [
        -1130.929443359375,
        -3501.4384765625,
        663.99609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6207442283630371,
        0.782613217830658,
        0.046831756830215454
      ],
      "plane_d": 3505.248779296875,
      "bbox_min": [
        -1276.5831298828125,
        -3650.0,
        660.0
      ],
      "bbox_max": [
        -1100.9259033203125,
        -3525.7001953125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9113858938217163,
        0.4086766242980957,
        0.04857178404927254
      ],
      "plane_d": 2467.397705078125,
      "bbox_min": [
        -1269.7215576171875,
        -3650.0,
        660.0
      ],
      "bbox_max": [
        -1100.9259033203125,
        -3530.838623046875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6149458289146423,
        0.787019670009613,
        0.04941307380795479
      ],
      "plane_d": 3512.108154296875,
      "bbox_min": [
        -1269.7215576171875,
        -3650.0,
        660.0
      ],
      "bbox_max": [
        -1105.9620361328125,
        -3530.838623046875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9872744679450989,
        0.13782483339309692,
        0.07933098822832108
      ],
      "plane_d": 1533.3360595703125,
      "bbox_min": [
        -1148.67041015625,
        -3650.0,
        660.0
      ],
      "bbox_max": [
        -1105.9620361328125,
        -3635.74658203125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.008366312831640244,
        0.20373092591762543,
        0.9789910912513733
      ],
      "plane_d": 84.7491455078125,
      "bbox_min": [
        -1113.7535400390625,
        -3650.0,
        660.0
      ],
      "bbox_max": [
        -1105.9620361328125,
        -3635.74658203125,
        663.5565185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22353629767894745,
        0.44706445932388306,
        0.8661205768585205
      ],
      "plane_d": 805.0186157226562,
      "bbox_min": [
        -1113.7535400390625,
        -3637.259521484375,
        660.0
      ],
      "bbox_max": [
        -1111.9892578125,
        -3635.74658203125,
        660.848876953125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.17656511068344116,
        -0.3531302213668823,
        0.9187620282173157
      ],
      "plane_d": -1695.1510009765625,
      "bbox_min": [
        -1112.553466796875,
        -3637.259521484375,
        660.7158203125
      ],
      "bbox_max": [
        -1111.58544921875,
        -3636.9580078125,
        660.848876953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22353330254554749,
        0.44706660509109497,
        0.8661202788352966
      ],
      "plane_d": 805.0299072265625,
      "bbox_min": [
        -1112.553466796875,
        -3637.259521484375,
        660.7279663085938
      ],
      "bbox_max": [
        -1111.6629638671875,
        -3636.647705078125,
        660.848876953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17656511068344116,
        -0.3531302213668823,
        0.9187620282173157
      ],
      "plane_d": -1695.1510009765625,
      "bbox_min": [
        -1112.553466796875,
        -3637.259521484375,
        660.793701171875
      ],
      "bbox_max": [
        -1111.6629638671875,
        -3636.841796875,
        660.848876953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.970560610294342,
        0.21886040270328522,
        0.10055909305810928
      ],
      "plane_d": 1788.025390625,
      "bbox_min": [
        -1127.74462890625,
        -3650.0,
        1021.7411499023438
      ],
      "bbox_max": [
        -1125.0511474609375,
        -3646.800048828125,
        1047.7374267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6398068070411682,
        0.7678380608558655,
        0.03273991122841835
      ],
      "plane_d": 3492.43212890625,
      "bbox_min": [
        -1269.7215576171875,
        -3646.800048828125,
        833.2398681640625
      ],
      "bbox_max": [
        -1127.2415771484375,
        -3530.838623046875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6140355467796326,
        0.7874341607093811,
        0.05392313003540039
      ],
      "plane_d": 3507.92138671875,
      "bbox_min": [
        -1267.1397705078125,
        -3646.800048828125,
        833.2398681640625
      ],
      "bbox_max": [
        -1127.2415771484375,
        -3530.838623046875,
        1035.9180908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09491465240716934,
        0.2607119083404541,
        0.9607395529747009
      ],
      "plane_d": 418.97088623046875,
      "bbox_min": [
        -1111.831298828125,
        -3650.0,
        660.0
      ],
      "bbox_max": [
        -1100.9259033203125,
        -3636.568603515625,
        663.5643920898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.887483537197113,
        0.44281768798828125,
        -0.12761466205120087
      ],
      "plane_d": 2677.966796875,
      "bbox_min": [
        -1108.596435546875,
        -3650.0,
        660.0
      ],
      "bbox_max": [
        -1100.9259033203125,
        -3641.42333984375,
        663.5643920898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.008366312831640244,
        0.20373092591762543,
        0.9789910912513733
      ],
      "plane_d": 84.7491455078125,
      "bbox_min": [
        -1108.596435546875,
        -3650.0,
        662.2799072265625
      ],
      "bbox_max": [
        -1105.0445556640625,
        -3643.9736328125,
        663.5643920898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17656511068344116,
        -0.3531302213668823,
        0.9187620282173157
      ],
      "plane_d": -1695.1510009765625,
      "bbox_min": [
        -1111.831298828125,
        -3637.121826171875,
        660.6630859375
      ],
      "bbox_max": [
        -1111.201904296875,
        -3636.568603515625,
        660.848876953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22353330254554749,
        0.44706660509109497,
        0.8661202788352966
      ],
      "plane_d": 805.0299072265625,
      "bbox_min": [
        -1111.831298828125,
        -3636.841796875,
        660.6786499023438
      ],
      "bbox_max": [
        -1111.584228515625,
        -3636.568603515625,
        660.848876953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6398068070411682,
        0.7678380608558655,
        0.03273991122841835
      ],
      "plane_d": 3492.43212890625,
      "bbox_min": [
        -1276.5831298828125,
        -3641.81640625,
        660.0
      ],
      "bbox_max": [
        -1105.266845703125,
        -3525.7001953125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6330804824829102,
        0.7714124321937561,
        0.06428063660860062
      ],
      "plane_d": 3466.7158203125,
      "bbox_min": [
        -1258.0595703125,
        -3641.81640625,
        660.0
      ],
      "bbox_max": [
        -1105.266845703125,
        -3525.7001953125,
        831.288330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2235339730978012,
        0.44706639647483826,
        0.8661202788352966
      ],
      "plane_d": 805.0284423828125,
      "bbox_min": [
        -1112.8165283203125,
        -3636.275390625,
        660.0
      ],
      "bbox_max": [
        -1112.1827392578125,
        -3635.736083984375,
        660.4365844726562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.22353330254554749,
        0.44706660509109497,
        0.8661202788352966
      ],
      "plane_d": 805.0299072265625,
      "bbox_min": [
        -1112.79541015625,
        -3641.81640625,
        660.0
      ],
      "bbox_max": [
        -1105.266845703125,
        -3634.598388671875,
        661.3656005859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.09491465240716934,
        0.2607119083404541,
        0.9607395529747009
      ],
      "plane_d": 418.97088623046875,
      "bbox_min": [
        -1111.584228515625,
        -3641.81640625,
        660.0
      ],
      "bbox_max": [
        -1105.266845703125,
        -3636.259521484375,
        661.3656005859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.887483537197113,
        0.44281768798828125,
        -0.12761466205120087
      ],
      "plane_d": 2677.966796875,
      "bbox_min": [
        -1108.0408935546875,
        -3641.81640625,
        660.0
      ],
      "bbox_max": [
        -1105.266845703125,
        -3636.61474609375,
        661.3656005859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9176634550094604,
        0.3884923756122589,
        -0.08347219973802567
      ],
      "plane_d": 2484.70263671875,
      "bbox_min": [
        -1108.0408935546875,
        -3636.773193359375,
        660.0
      ],
      "bbox_max": [
        -1107.9796142578125,
        -3636.61474609375,
        660.2266235351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17656511068344116,
        -0.3531302213668823,
        0.9187620282173157
      ],
      "plane_d": -1695.1510009765625,
      "bbox_min": [
        -1111.584228515625,
        -3637.067138671875,
        660.2266235351562
      ],
      "bbox_max": [
        -1108.0260009765625,
        -3636.259521484375,
        660.848876953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.991669237613678,
        -0.07369301468133926,
        -0.10564810782670975
      ],
      "plane_d": 903.1522216796875,
      "bbox_min": [
        -1110.646484375,
        -3636.3115234375,
        660.0
      ],
      "bbox_max": [
        -1110.5205078125,
        -3634.598388671875,
        660.848876953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3108421266078949,
        0.9476532340049744,
        -0.07301102578639984
      ],
      "plane_d": 3839.369140625,
      "bbox_min": [
        -1110.646484375,
        -3636.3115234375,
        660.0
      ],
      "bbox_max": [
        -1110.553466796875,
        -3636.259521484375,
        660.848876953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2074883133172989,
        0.8826481699943542,
        0.42175933718681335
      ],
      "plane_d": 2287.469970703125,
      "bbox_min": [
        -1105.0,
        -3320.0,
        852.3694458007812
      ],
      "bbox_max": [
        -865.1904296875,
        -3152.747802734375,
        1098.7425537109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6382936835289001,
        0.7293487191200256,
        0.2462347000837326
      ],
      "plane_d": 1514.509521484375,
      "bbox_min": [
        -1105.0,
        -3320.0,
        852.3694458007812
      ],
      "bbox_max": [
        -991.43603515625,
        -3231.95166015625,
        1018.707763671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17790910601615906,
        -0.0,
        0.984046995639801
      ],
      "plane_d": -662.3861083984375,
      "bbox_min": [
        -1105.0,
        -3320.0,
        852.3694458007812
      ],
      "bbox_max": [
        -991.43603515625,
        -3231.95166015625,
        889.4143676757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09315899014472961,
        0.1335732340812683,
        0.9866505861282349
      ],
      "plane_d": -316.9273681640625,
      "bbox_min": [
        -1105.0,
        -3304.406494140625,
        852.3694458007812
      ],
      "bbox_max": [
        -991.43603515625,
        -3231.95166015625,
        872.9010620117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6744422316551208,
        -0.542770504951477,
        0.5005276203155518
      ],
      "plane_d": -1478.223388671875,
      "bbox_min": [
        -1105.0,
        -3293.0009765625,
        862.6844482421875
      ],
      "bbox_max": [
        -1067.857177734375,
        -3254.84521484375,
        872.9010620117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6744422316551208,
        -0.542770504951477,
        0.5005276203155518
      ],
      "plane_d": -1478.223388671875,
      "bbox_min": [
        -1105.0,
        -3291.5771484375,
        867.3606567382812
      ],
      "bbox_max": [
        -1074.35498046875,
        -3258.607177734375,
        889.4143676757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6744422316551208,
        -0.542770504951477,
        0.5005276203155518
      ],
      "plane_d": -1478.223388671875,
      "bbox_min": [
        -1105.0,
        -3276.348876953125,
        852.3694458007812
      ],
      "bbox_max": [
        -991.43603515625,
        -3152.747802734375,
        1023.4471435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2074883133172989,
        0.8826481699943542,
        0.42175933718681335
      ],
      "plane_d": 2287.469970703125,
      "bbox_min": [
        -1105.0,
        -3475.00244140625,
        869.3729248046875
      ],
      "bbox_max": [
        -804.115478515625,
        -3320.0,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9945406317710876,
        -0.05085870251059532,
        0.09111718833446503
      ],
      "plane_d": -1379.3016357421875,
      "bbox_min": [
        -1105.0,
        -3475.00244140625,
        1136.998046875
      ],
      "bbox_max": [
        -1090.06982421875,
        -3434.97412109375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17790910601615906,
        -0.0,
        0.984046995639801
      ],
      "plane_d": -662.3861083984375,
      "bbox_min": [
        -1105.0,
        -3338.26953125,
        869.3729248046875
      ],
      "bbox_max": [
        -1085.4853515625,
        -3320.0,
        872.9010620117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -724.0,
      "bbox_min": [
        -1465.0,
        -3531.997802734375,
        267.0
      ],
      "bbox_max": [
        -1105.0,
        -3083.3251953125,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.796037495136261,
        -0.5924747586250305,
        0.12368514388799667
      ],
      "plane_d": -2981.951171875,
      "bbox_min": [
        -1400.39306640625,
        -3320.0,
        465.73052978515625
      ],
      "bbox_max": [
        -1163.061767578125,
        -3091.609375,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8137342929840088,
        -0.5748793482780457,
        0.08573256433010101
      ],
      "plane_d": -2924.1494140625,
      "bbox_min": [
        -1352.2418212890625,
        -3317.8837890625,
        533.1758422851562
      ],
      "bbox_max": [
        -1192.5257568359375,
        -3092.033935546875,
        711.556884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7564704418182373,
        -0.5494663715362549,
        0.3547379672527313
      ],
      "plane_d": -2917.031494140625,
      "bbox_min": [
        -1352.2418212890625,
        -3317.8837890625,
        533.1758422851562
      ],
      "bbox_max": [
        -1192.5257568359375,
        -3096.834228515625,
        592.5193481445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11611118167638779,
        -0.3397166132926941,
        0.933333158493042
      ],
      "plane_d": -1724.796630859375,
      "bbox_min": [
        -1352.2418212890625,
        -3140.562255859375,
        540.0993041992188
      ],
      "bbox_max": [
        -1324.617431640625,
        -3096.834228515625,
        592.5193481445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44718649983406067,
        -0.8943867683410645,
        0.009831518866121769
      ],
      "plane_d": -2174.02978515625,
      "bbox_min": [
        -1352.2418212890625,
        -3116.5771484375,
        546.7369384765625
      ],
      "bbox_max": [
        -1341.437744140625,
        -3096.834228515625,
        592.5193481445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.137528657913208,
        -0.27506157755851746,
        0.9515392780303955
      ],
      "plane_d": -1193.0062255859375,
      "bbox_min": [
        -1352.2418212890625,
        -3116.5771484375,
        546.7369384765625
      ],
      "bbox_max": [
        -1341.437744140625,
        -3097.97119140625,
        552.8644409179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7995961308479309,
        -0.5955905318260193,
        0.0769285261631012
      ],
      "plane_d": -2963.00537109375,
      "bbox_min": [
        -1400.39306640625,
        -3320.0,
        465.73052978515625
      ],
      "bbox_max": [
        -1163.061767578125,
        -3091.609375,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.573469877243042,
        -0.17084632813930511,
        0.8012139201164246
      ],
      "plane_d": -214.29714965820312,
      "bbox_min": [
        -1384.3837890625,
        -3320.0,
        465.73052978515625
      ],
      "bbox_max": [
        -1276.442626953125,
        -3115.6298828125,
        593.9807739257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04223942756652832,
        -0.9113441109657288,
        0.4094725549221039
      ],
      "plane_d": -3270.52197265625,
      "bbox_min": [
        -1286.90576171875,
        -3320.0,
        465.73052978515625
      ],
      "bbox_max": [
        -1276.442626953125,
        -3312.349365234375,
        482.2633972167969
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9405732750892639,
        -0.10687936842441559,
        0.3223331570625305
      ],
      "plane_d": 700.9578857421875,
      "bbox_min": [
        -1286.90576171875,
        -3320.0,
        465.73052978515625
      ],
      "bbox_max": [
        -1282.109375,
        -3312.349365234375,
        482.2633972167969
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9710849523544312,
        0.01423729583621025,
        0.2383090704679489
      ],
      "plane_d": 1181.926025390625,
      "bbox_min": [
        -1286.90576171875,
        -3320.0,
        472.17510986328125
      ],
      "bbox_max": [
        -1284.31787109375,
        -3312.349365234375,
        482.2633972167969
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9655990600585938,
        0.23379258811473846,
        0.11383970826864243
      ],
      "plane_d": 1997.5523681640625,
      "bbox_min": [
        -1384.3837890625,
        -3320.0,
        480.18701171875
      ],
      "bbox_max": [
        -1286.2840576171875,
        -3115.6298828125,
        593.9807739257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9792866706848145,
        0.167245551943779,
        0.11413394659757614
      ],
      "plane_d": 1794.639404296875,
      "bbox_min": [
        -1328.328857421875,
        -3320.0,
        507.9460754394531
      ],
      "bbox_max": [
        -1324.77734375,
        -3319.427978515625,
        538.2327880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9461557865142822,
        0.2541045844554901,
        0.20054952800273895
      ],
      "plane_d": 1995.172119140625,
      "bbox_min": [
        -1324.896728515625,
        -3320.0,
        507.9460754394531
      ],
      "bbox_max": [
        -1324.77734375,
        -3319.427978515625,
        508.53228759765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5087251663208008,
        0.25412195920944214,
        0.8225695490837097
      ],
      "plane_d": 1099.726806640625,
      "bbox_min": [
        -1324.896728515625,
        -3320.0,
        480.18701171875
      ],
      "bbox_max": [
        -1286.2840576171875,
        -3312.349365234375,
        508.1073303222656
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9710849523544312,
        0.01423729583621025,
        0.2383090704679489
      ],
      "plane_d": 1181.926025390625,
      "bbox_min": [
        -1287.4573974609375,
        -3320.0,
        480.18701171875
      ],
      "bbox_max": [
        -1286.2840576171875,
        -3312.349365234375,
        484.96807861328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9461557865142822,
        0.2541045844554901,
        0.20054952800273895
      ],
      "plane_d": 1995.172119140625,
      "bbox_min": [
        -1324.896728515625,
        -3320.0,
        507.9460754394531
      ],
      "bbox_max": [
        -1324.7630615234375,
        -3319.427978515625,
        508.1073303222656
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.137528657913208,
        -0.27506157755851746,
        0.9515392780303955
      ],
      "plane_d": -1193.0062255859375,
      "bbox_min": [
        -1400.39306640625,
        -3320.0,
        466.3150939941406
      ],
      "bbox_max": [
        -1163.061767578125,
        -3098.218994140625,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04223942756652832,
        -0.9113441109657288,
        0.4094725549221039
      ],
      "plane_d": -3270.52197265625,
      "bbox_min": [
        -1286.90576171875,
        -3320.0,
        466.3150939941406
      ],
      "bbox_max": [
        -1232.641845703125,
        -3312.349365234375,
        482.2633972167969
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8235416412353516,
        -0.5580507516860962,
        0.10177668184041977
      ],
      "plane_d": -2915.920166015625,
      "bbox_min": [
        -1234.159423828125,
        -3320.0,
        466.6517028808594
      ],
      "bbox_max": [
        -1232.81396484375,
        -3317.593505859375,
        473.12396240234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8235416412353516,
        -0.5580507516860962,
        0.10177668184041977
      ],
      "plane_d": -2915.920166015625,
      "bbox_min": [
        -1233.12890625,
        -3320.0,
        470.816162109375
      ],
      "bbox_max": [
        -1232.641845703125,
        -3319.2275390625,
        472.50262451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9616638422012329,
        0.25931838154792786,
        0.08920101076364517
      ],
      "plane_d": 2092.123291015625,
      "bbox_min": [
        -1400.39306640625,
        -3320.0,
        472.2089538574219
      ],
      "bbox_max": [
        -1163.061767578125,
        -3098.218994140625,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 698.0,
      "bbox_min": [
        -1359.5350341796875,
        -3320.0,
        639.3223266601562
      ],
      "bbox_max": [
        -1343.6630859375,
        -3290.031982421875,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -700.5,
      "bbox_min": [
        -1359.5350341796875,
        -3320.0,
        698.0
      ],
      "bbox_max": [
        -1345.2430419921875,
        -3290.031982421875,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10452920198440552,
        0.9945218563079834,
        0.0
      ],
      "plane_d": 3130.571044921875,
      "bbox_min": [
        -1359.5350341796875,
        -3290.709228515625,
        698.0
      ],
      "bbox_max": [
        -1353.09228515625,
        -3290.031982421875,
        700.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10453145951032639,
        0.9945215582847595,
        0.0
      ],
      "plane_d": 3138.567138671875,
      "bbox_min": [
        -1358.6988525390625,
        -3298.66552734375,
        700.5
      ],
      "bbox_max": [
        -1351.2083740234375,
        -3297.878173828125,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7032346129417419,
        -0.07390657812356949,
        0.7071059942245483
      ],
      "plane_d": -1652.1783447265625,
      "bbox_min": [
        -1354.374755859375,
        -3307.7138671875,
        639.3223266601562
      ],
      "bbox_max": [
        -1343.6630859375,
        -3302.231201171875,
        653.7886352539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10452968627214432,
        0.9945218563079834,
        1.0296703294443432e-05
      ],
      "plane_d": 3143.56396484375,
      "bbox_min": [
        -1354.374755859375,
        -3307.7138671875,
        639.3223266601562
      ],
      "bbox_max": [
        -1343.6630859375,
        -3302.231201171875,
        653.7886352539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10452838987112045,
        -0.9945218563079834,
        -9.006318578030914e-06
      ],
      "plane_d": -3148.06640625,
      "bbox_min": [
        -1353.9044189453125,
        -3307.7138671875,
        639.3223266601562
      ],
      "bbox_max": [
        -1343.6630859375,
        -3302.231201171875,
        653.7886352539062
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7032297253608704,
        0.07392524182796478,
        -0.7071089148521423
      ],
      "plane_d": 1645.164306640625,
      "bbox_min": [
        -1349.402099609375,
        -3307.19140625,
        639.3223266601562
      ],
      "bbox_max": [
        -1343.6630859375,
        -3302.231201171875,
        644.6200561523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9655990600585938,
        0.23379258811473846,
        0.11383970826864243
      ],
      "plane_d": 1997.5523681640625,
      "bbox_min": [
        -1400.39306640625,
        -3320.0,
        472.2089538574219
      ],
      "bbox_max": [
        -1163.061767578125,
        -3098.218994140625,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9320849776268005,
        0.2389715313911438,
        0.2722319960594177
      ],
      "plane_d": 1873.2095947265625,
      "bbox_min": [
        -1400.39306640625,
        -3320.0,
        593.9807739257812
      ],
      "bbox_max": [
        -1336.874267578125,
        -3115.6298828125,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9549922347068787,
        0.29370102286338806,
        0.04158574342727661
      ],
      "plane_d": 2226.488525390625,
      "bbox_min": [
        -1400.39306640625,
        -3320.0,
        593.9807739257812
      ],
      "bbox_max": [
        -1337.023193359375,
        -3115.6298828125,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4523264467716217,
        -0.8918522596359253,
        0.0003948037629015744
      ],
      "plane_d": -2152.6083984375,
      "bbox_min": [
        -1400.39306640625,
        -3123.563720703125,
        593.9807739257812
      ],
      "bbox_max": [
        -1384.3837890625,
        -3115.6298828125,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44900059700012207,
        -0.8935260772705078,
        0.003092230297625065
      ],
      "plane_d": -2164.14404296875,
      "bbox_min": [
        -1392.2449951171875,
        -3119.475341796875,
        593.9807739257812
      ],
      "bbox_max": [
        -1384.3837890625,
        -3115.6298828125,
        630.4634399414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11611118167638779,
        -0.3397166132926941,
        0.933333158493042
      ],
      "plane_d": -1724.796630859375,
      "bbox_min": [
        -1398.0760498046875,
        -3320.0,
        472.2089538574219
      ],
      "bbox_max": [
        -1163.061767578125,
        -3098.218994140625,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04223942756652832,
        -0.9113441109657288,
        0.4094725549221039
      ],
      "plane_d": -3270.52197265625,
      "bbox_min": [
        -1286.90576171875,
        -3320.0,
        472.2089538574219
      ],
      "bbox_max": [
        -1226.1395263671875,
        -3311.770263671875,
        488.7859802246094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6944899559020996,
        -0.6407128572463989,
        0.3273695409297943
      ],
      "plane_d": -1423.39990234375,
      "bbox_min": [
        -1236.1697998046875,
        -3318.94921875,
        472.8973083496094
      ],
      "bbox_max": [
        -1234.159423828125,
        -3311.770263671875,
        488.7859802246094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8235416412353516,
        -0.5580507516860962,
        0.10177668184041977
      ],
      "plane_d": -2915.920166015625,
      "bbox_min": [
        -1236.1697998046875,
        -3320.0,
        472.2089538574219
      ],
      "bbox_max": [
        -1226.1395263671875,
        -3311.770263671875,
        488.7859802246094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4483394920825958,
        -0.6716778874397278,
        0.5897800326347351
      ],
      "plane_d": -3066.94287109375,
      "bbox_min": [
        -1236.1697998046875,
        -3320.0,
        483.1204528808594
      ],
      "bbox_max": [
        -1226.1395263671875,
        -3311.770263671875,
        488.7859802246094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49946901202201843,
        -0.47514525055885315,
        0.7244084477424622
      ],
      "plane_d": -2545.081298828125,
      "bbox_min": [
        -1398.0760498046875,
        -3320.0,
        487.03826904296875
      ],
      "bbox_max": [
        -1163.061767578125,
        -3098.218994140625,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4483394920825958,
        -0.6716778874397278,
        0.5897800326347351
      ],
      "plane_d": -3066.94287109375,
      "bbox_min": [
        -1236.1697998046875,
        -3320.0,
        487.03826904296875
      ],
      "bbox_max": [
        -1210.31494140625,
        -3311.770263671875,
        503.0541687011719
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9192844033241272,
        -0.38526779413223267,
        0.08052864670753479
      ],
      "plane_d": -2432.07470703125,
      "bbox_min": [
        -1212.1279296875,
        -3320.0,
        498.9146728515625
      ],
      "bbox_max": [
        -1210.31494140625,
        -3315.28955078125,
        503.0541687011719
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9549922347068787,
        0.29370102286338806,
        0.04158574342727661
      ],
      "plane_d": 2226.488525390625,
      "bbox_min": [
        -1398.0760498046875,
        -3320.0,
        501.2149658203125
      ],
      "bbox_max": [
        -1163.061767578125,
        -3098.218994140625,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -700.5,
      "bbox_min": [
        -1353.3280029296875,
        -3320.0,
        698.0
      ],
      "bbox_max": [
        -1340.8819580078125,
        -3289.716064453125,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10452920198440552,
        0.9945218563079834,
        0.0
      ],
      "plane_d": 3130.571044921875,
      "bbox_min": [
        -1353.3177490234375,
        -3290.0556640625,
        698.0
      ],
      "bbox_max": [
        -1350.086669921875,
        -3289.716064453125,
        700.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10453145951032639,
        0.9945215582847595,
        0.0
      ],
      "plane_d": 3138.567138671875,
      "bbox_min": [
        -1353.3280029296875,
        -3298.10107421875,
        700.5
      ],
      "bbox_max": [
        -1347.795654296875,
        -3297.51953125,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10452968627214432,
        0.9945218563079834,
        1.0296703294443432e-05
      ],
      "plane_d": 3143.56396484375,
      "bbox_min": [
        -1345.6170654296875,
        -3306.724365234375,
        643.9597778320312
      ],
      "bbox_max": [
        -1342.6363525390625,
        -3302.142822265625,
        655.2455444335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10451199859380722,
        -0.9945236444473267,
        2.0489096641540527e-05
      ],
      "plane_d": -3148.113525390625,
      "bbox_min": [
        -1345.6170654296875,
        -3306.724365234375,
        643.9597778320312
      ],
      "bbox_max": [
        -1342.6363525390625,
        -3302.142822265625,
        655.2455444335938
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7032346129417419,
        -0.07390657812356949,
        0.7071059942245483
      ],
      "plane_d": -1652.1783447265625,
      "bbox_min": [
        -1345.6170654296875,
        -3306.724365234375,
        643.9597778320312
      ],
      "bbox_max": [
        -1342.6363525390625,
        -3302.142822265625,
        655.2455444335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7032297253608704,
        0.07392524182796478,
        -0.7071089148521423
      ],
      "plane_d": 1645.164306640625,
      "bbox_min": [
        -1344.7900390625,
        -3306.6376953125,
        643.9597778320312
      ],
      "bbox_max": [
        -1342.6363525390625,
        -3302.142822265625,
        645.6524658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7564704418182373,
        -0.5494663715362549,
        0.3547379672527313
      ],
      "plane_d": -2917.031494140625,
      "bbox_min": [
        -1398.0760498046875,
        -3320.0,
        501.2149658203125
      ],
      "bbox_max": [
        -1163.061767578125,
        -3098.218994140625,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4523264467716217,
        -0.8918522596359253,
        0.0003948037629015744
      ],
      "plane_d": -2152.6083984375,
      "bbox_min": [
        -1398.0760498046875,
        -3320.0,
        501.2149658203125
      ],
      "bbox_max": [
        -1163.061767578125,
        -3098.218994140625,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4278530180454254,
        -0.903739333152771,
        0.014034316875040531
      ],
      "plane_d": -2231.740478515625,
      "bbox_min": [
        -1388.2457275390625,
        -3320.0,
        501.2149658203125
      ],
      "bbox_max": [
        -1163.061767578125,
        -3098.218994140625,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44718649983406067,
        -0.8943867683410645,
        0.009831518866121769
      ],
      "plane_d": -2174.02978515625,
      "bbox_min": [
        -1362.39306640625,
        -3105.857421875,
        552.8644409179688
      ],
      "bbox_max": [
        -1347.9879150390625,
        -3098.218994140625,
        613.0665893554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8672640323638916,
        0.18403863906860352,
        0.46258267760276794
      ],
      "plane_d": -673.7977294921875,
      "bbox_min": [
        -1350.1922607421875,
        -3320.0,
        501.2149658203125
      ],
      "bbox_max": [
        -1163.061767578125,
        -3287.259765625,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9192844033241272,
        -0.38526779413223267,
        0.08052864670753479
      ],
      "plane_d": -2432.07470703125,
      "bbox_min": [
        -1212.1279296875,
        -3320.0,
        501.2149658203125
      ],
      "bbox_max": [
        -1209.5694580078125,
        -3315.28955078125,
        509.7249450683594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -700.5,
      "bbox_min": [
        -1350.1922607421875,
        -3320.0,
        644.8056640625
      ],
      "bbox_max": [
        -1163.061767578125,
        -3287.259765625,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10452920198440552,
        0.9945218563079834,
        0.0
      ],
      "plane_d": 3130.571044921875,
      "bbox_min": [
        -1350.1922607421875,
        -3289.72705078125,
        698.0
      ],
      "bbox_max": [
        -1326.7158203125,
        -3287.259765625,
        700.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10453738272190094,
        -0.9945210218429565,
        0.0
      ],
      "plane_d": -3148.0576171875,
      "bbox_min": [
        -1344.353271484375,
        -3308.61376953125,
        644.8056640625
      ],
      "bbox_max": [
        -1328.6033935546875,
        -3297.623291015625,
        698.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.9945200085639954,
        0.10454639792442322,
        0.0
      ],
      "plane_d": 1669.6168212890625,
      "bbox_min": [
        -1344.353271484375,
        -3306.572021484375,
        644.8056640625
      ],
      "bbox_max": [
        -1328.86474609375,
        -3297.623291015625,
        698.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.1045399084687233,
        0.9945207238197327,
        0.0
      ],
      "plane_d": 3143.553466796875,
      "bbox_min": [
        -1344.353271484375,
        -3306.572021484375,
        644.8056640625
      ],
      "bbox_max": [
        -1331.350830078125,
        -3297.884521484375,
        698.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9945229291915894,
        -0.10451958328485489,
        -0.0
      ],
      "plane_d": -1674.5322265625,
      "bbox_min": [
        -1344.353271484375,
        -3306.572021484375,
        644.8056640625
      ],
      "bbox_max": [
        -1331.350830078125,
        -3300.8681640625,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7032297253608704,
        0.07392524182796478,
        -0.7071089148521423
      ],
      "plane_d": 1645.164306640625,
      "bbox_min": [
        -1336.7939453125,
        -3305.8662109375,
        651.9998779296875
      ],
      "bbox_max": [
        -1331.350830078125,
        -3300.8681640625,
        691.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 691.0,
      "bbox_min": [
        -1336.7939453125,
        -3305.8662109375,
        691.0
      ],
      "bbox_max": [
        -1331.3509521484375,
        -3300.8681640625,
        691.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7032346129417419,
        -0.07390657812356949,
        0.7071059942245483
      ],
      "plane_d": -1652.1783447265625,
      "bbox_min": [
        -1344.353271484375,
        -3306.572021484375,
        644.8056640625
      ],
      "bbox_max": [
        -1336.3236083984375,
        -3301.390869140625,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7032297253608704,
        0.07392524182796478,
        -0.7071089148521423
      ],
      "plane_d": 1645.164306640625,
      "bbox_min": [
        -1343.9488525390625,
        -3306.52978515625,
        644.8056640625
      ],
      "bbox_max": [
        -1336.3236083984375,
        -3301.390869140625,
        651.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9945220351219177,
        -0.10452784597873688,
        -0.0
      ],
      "plane_d": -1677.058349609375,
      "bbox_min": [
        -1339.2802734375,
        -3306.127685546875,
        691.0
      ],
      "bbox_max": [
        -1336.3236083984375,
        -3301.390869140625,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 691.0,
      "bbox_min": [
        -1339.2802734375,
        -3306.127685546875,
        691.0
      ],
      "bbox_max": [
        -1336.3236083984375,
        -3301.390869140625,
        691.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10451702773571014,
        0.9945231080055237,
        0.0
      ],
      "plane_d": 3140.591552734375,
      "bbox_min": [
        -1339.5938720703125,
        -3301.65234375,
        691.0
      ],
      "bbox_max": [
        -1331.8214111328125,
        -3297.884521484375,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 691.0,
      "bbox_min": [
        -1339.5938720703125,
        -3301.65234375,
        691.0
      ],
      "bbox_max": [
        -1331.8214111328125,
        -3297.884521484375,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9945220351219177,
        -0.10452784597873688,
        -0.0
      ],
      "plane_d": -1677.058349609375,
      "bbox_min": [
        -1339.5938720703125,
        -3301.65234375,
        691.0
      ],
      "bbox_max": [
        -1339.2802734375,
        -3298.66845703125,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9945217370986938,
        0.10453037172555923,
        -0.0
      ],
      "plane_d": 1667.0662841796875,
      "bbox_min": [
        -1332.135009765625,
        -3305.343505859375,
        691.0
      ],
      "bbox_max": [
        -1328.86474609375,
        -3297.623291015625,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 691.0,
      "bbox_min": [
        -1332.135009765625,
        -3305.343505859375,
        691.0
      ],
      "bbox_max": [
        -1328.86474609375,
        -3297.623291015625,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10451702773571014,
        0.9945231080055237,
        0.0
      ],
      "plane_d": 3140.591552734375,
      "bbox_min": [
        -1332.135009765625,
        -3297.884521484375,
        691.0
      ],
      "bbox_max": [
        -1329.648681640625,
        -3297.623291015625,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10454117506742477,
        -0.9945205450057983,
        0.0
      ],
      "plane_d": -3150.551025390625,
      "bbox_min": [
        -1338.8099365234375,
        -3308.61376953125,
        691.0
      ],
      "bbox_max": [
        -1328.6033935546875,
        -3305.08203125,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 691.0,
      "bbox_min": [
        -1338.8099365234375,
        -3308.61376953125,
        691.0
      ],
      "bbox_max": [
        -1328.6033935546875,
        -3305.08203125,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9945217370986938,
        0.10453037172555923,
        -0.0
      ],
      "plane_d": 1667.0662841796875,
      "bbox_min": [
        -1338.8099365234375,
        -3308.61376953125,
        691.0
      ],
      "bbox_max": [
        -1328.6033935546875,
        -3305.08203125,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9945220351219177,
        -0.10452784597873688,
        -0.0
      ],
      "plane_d": -1677.058349609375,
      "bbox_min": [
        -1338.8099365234375,
        -3308.61376953125,
        691.0
      ],
      "bbox_max": [
        -1338.548583984375,
        -3306.127685546875,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9945220351219177,
        0.10452785342931747,
        0.0
      ],
      "plane_d": 1665.058349609375,
      "bbox_min": [
        -1348.7869873046875,
        -3320.0,
        700.5
      ],
      "bbox_max": [
        -1163.061767578125,
        -3295.425048828125,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10453145951032639,
        0.9945215582847595,
        0.0
      ],
      "plane_d": 3138.567138671875,
      "bbox_min": [
        -1348.7869873046875,
        -3297.623779296875,
        700.5
      ],
      "bbox_max": [
        -1327.86865234375,
        -3295.425048828125,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8007402420043945,
        -0.5945212841033936,
        0.073208749294281
      ],
      "plane_d": -2958.124267578125,
      "bbox_min": [
        -1175.145263671875,
        -3320.0,
        715.8345947265625
      ],
      "bbox_max": [
        -1163.061767578125,
        -3303.725341796875,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9202737212181091,
        0.3693651854991913,
        0.12909552454948425
      ],
      "plane_d": 2369.723876953125,
      "bbox_min": [
        -1356.4564208984375,
        -3527.603515625,
        267.0
      ],
      "bbox_max": [
        -1131.2100830078125,
        -3320.0,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070278525352478,
        0.7070142030715942,
        -0.015574500896036625
      ],
      "plane_d": 1539.5325927734375,
      "bbox_min": [
        -1311.8009033203125,
        -3523.752197265625,
        556.07275390625
      ],
      "bbox_max": [
        -1240.494384765625,
        -3468.60302734375,
        638.3435668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.706993818283081,
        -0.7070481181144714,
        0.015581655316054821
      ],
      "plane_d": -1574.3360595703125,
      "bbox_min": [
        -1305.4368896484375,
        -3523.752197265625,
        556.07275390625
      ],
      "bbox_max": [
        -1240.494384765625,
        -3468.60302734375,
        632.0310668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5011059641838074,
        0.8528707027435303,
        -0.14664393663406372
      ],
      "plane_d": 3702.4765625,
      "bbox_min": [
        -1305.4368896484375,
        -3494.068115234375,
        608.3931884765625
      ],
      "bbox_max": [
        -1280.75146484375,
        -3468.60302734375,
        616.72265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8538200855255127,
        0.5016542673110962,
        -0.13904793560504913
      ],
      "plane_d": 2931.10400390625,
      "bbox_min": [
        -1283.3319091796875,
        -3494.068115234375,
        608.3931884765625
      ],
      "bbox_max": [
        -1280.75146484375,
        -3490.00048828125,
        610.4110107421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12399445474147797,
        0.9919556379318237,
        -0.025480808690190315
      ],
      "plane_d": 3355.08447265625,
      "bbox_min": [
        -1243.6463623046875,
        -3523.752197265625,
        556.07275390625
      ],
      "bbox_max": [
        -1240.494384765625,
        -3522.80419921875,
        568.6787719726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10194253921508789,
        0.8155403137207031,
        0.5696505308151245
      ],
      "plane_d": 2422.86572265625,
      "bbox_min": [
        -1243.6463623046875,
        -3523.752197265625,
        568.1181640625
      ],
      "bbox_max": [
        -1240.88525390625,
        -3522.816650390625,
        568.6787719726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22353629767894745,
        0.44706445932388306,
        0.8661205768585205
      ],
      "plane_d": 805.0186157226562,
      "bbox_min": [
        -1243.6463623046875,
        -3523.752197265625,
        568.1181640625
      ],
      "bbox_max": [
        -1241.79443359375,
        -3523.1552734375,
        568.6787719726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9710849523544312,
        0.01423729583621025,
        0.2383090704679489
      ],
      "plane_d": 1181.926025390625,
      "bbox_min": [
        -1356.4564208984375,
        -3523.00732421875,
        342.435546875
      ],
      "bbox_max": [
        -1240.6817626953125,
        -3320.0,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -700.5,
      "bbox_min": [
        -1350.604736328125,
        -3405.079345703125,
        698.0
      ],
      "bbox_max": [
        -1342.3243408203125,
        -3375.675537109375,
        717.0403442382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10452882945537567,
        -0.994521975517273,
        0.0
      ],
      "plane_d": -3245.572265625,
      "bbox_min": [
        -1347.5142822265625,
        -3405.079345703125,
        698.0
      ],
      "bbox_max": [
        -1342.3243408203125,
        -3404.533935546875,
        700.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10452409088611603,
        -0.9945224523544312,
        0.0
      ],
      "plane_d": -3237.580078125,
      "bbox_min": [
        -1348.3504638671875,
        -3397.123046875,
        700.5
      ],
      "bbox_max": [
        -1344.94091796875,
        -3396.7646484375,
        717.0403442382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10451489686965942,
        -0.9945234060287476,
        1.8302351236343384e-05
      ],
      "plane_d": -3233.107666015625,
      "bbox_min": [
        -1345.4898681640625,
        -3392.248291015625,
        639.3223266601562
      ],
      "bbox_max": [
        -1334.63330078125,
        -3386.7431640625,
        653.0486450195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7032317519187927,
        -0.07390627264976501,
        0.7071089744567871
      ],
      "plane_d": -1652.1749267578125,
      "bbox_min": [
        -1345.4898681640625,
        -3392.248291015625,
        639.3223266601562
      ],
      "bbox_max": [
        -1334.63330078125,
        -3386.7431640625,
        653.0486450195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1045287549495697,
        0.9945218563079834,
        8.653848453832325e-06
      ],
      "plane_d": 3228.56640625,
      "bbox_min": [
        -1345.4898681640625,
        -3391.725830078125,
        639.3223266601562
      ],
      "bbox_max": [
        -1334.63330078125,
        -3386.7431640625,
        652.4561157226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.703239381313324,
        0.07390304654836655,
        -0.7071017026901245
      ],
      "plane_d": 1645.098388671875,
      "bbox_min": [
        -1340.51708984375,
        -3391.725830078125,
        639.3223266601562
      ],
      "bbox_max": [
        -1334.63330078125,
        -3386.7431640625,
        644.7656860351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9792866706848145,
        0.167245551943779,
        0.11413394659757614
      ],
      "plane_d": 1794.639404296875,
      "bbox_min": [
        -1356.4564208984375,
        -3441.9873046875,
        500.58746337890625
      ],
      "bbox_max": [
        -1291.38037109375,
        -3320.0,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9655990600585938,
        0.23379258811473846,
        0.11383970826864243
      ],
      "plane_d": 1997.5523681640625,
      "bbox_min": [
        -1356.4564208984375,
        -3404.587890625,
        538.2327880859375
      ],
      "bbox_max": [
        -1328.328857421875,
        -3320.0,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -700.5,
      "bbox_min": [
        -1356.4564208984375,
        -3404.587890625,
        610.715576171875
      ],
      "bbox_max": [
        -1329.3118896484375,
        -3320.0,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 698.0,
      "bbox_min": [
        -1356.4564208984375,
        -3404.587890625,
        610.715576171875
      ],
      "bbox_max": [
        -1329.3118896484375,
        -3320.0,
        700.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10452882945537567,
        -0.994521975517273,
        0.0
      ],
      "plane_d": -3245.572265625,
      "bbox_min": [
        -1342.83984375,
        -3404.587890625,
        698.0
      ],
      "bbox_max": [
        -1338.5029296875,
        -3404.13232421875,
        700.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1045287549495697,
        0.9945218563079834,
        8.653848453832325e-06
      ],
      "plane_d": 3228.56640625,
      "bbox_min": [
        -1337.400634765625,
        -3391.3359375,
        610.715576171875
      ],
      "bbox_max": [
        -1329.3118896484375,
        -3320.0,
        659.0840454101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10451489686965942,
        -0.9945234060287476,
        1.8302351236343384e-05
      ],
      "plane_d": -3233.107666015625,
      "bbox_min": [
        -1337.400634765625,
        -3391.3359375,
        644.1729736328125
      ],
      "bbox_max": [
        -1329.3118896484375,
        -3386.149169921875,
        659.0840454101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7032317519187927,
        -0.07390627264976501,
        0.7071089744567871
      ],
      "plane_d": -1652.1749267578125,
      "bbox_min": [
        -1337.400634765625,
        -3391.3359375,
        644.1729736328125
      ],
      "bbox_max": [
        -1329.3118896484375,
        -3386.149169921875,
        659.0840454101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.703239381313324,
        0.07390304654836655,
        -0.7071017026901245
      ],
      "plane_d": 1645.098388671875,
      "bbox_min": [
        -1335.693115234375,
        -3391.15673828125,
        644.1729736328125
      ],
      "bbox_max": [
        -1329.3118896484375,
        -3386.149169921875,
        650.1165161132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9549922347068787,
        0.29370102286338806,
        0.04158574342727661
      ],
      "plane_d": 2226.488525390625,
      "bbox_min": [
        -1337.0296630859375,
        -3321.37109375,
        610.715576171875
      ],
      "bbox_max": [
        -1336.5555419921875,
        -3320.0,
        612.033203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9616638422012329,
        0.25931838154792786,
        0.08920101076364517
      ],
      "plane_d": 2092.123291015625,
      "bbox_min": [
        -1337.023193359375,
        -3321.37109375,
        610.715576171875
      ],
      "bbox_max": [
        -1336.5555419921875,
        -3320.0,
        611.8834228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9320849776268005,
        0.2389715313911438,
        0.2722319960594177
      ],
      "plane_d": 1873.2095947265625,
      "bbox_min": [
        -1336.9337158203125,
        -3321.37109375,
        610.715576171875
      ],
      "bbox_max": [
        -1336.5555419921875,
        -3320.0,
        610.9191284179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10452409088611603,
        -0.9945224523544312,
        0.0
      ],
      "plane_d": -3237.580078125,
      "bbox_min": [
        -1348.3504638671875,
        -3397.123046875,
        700.5
      ],
      "bbox_max": [
        -1339.2333984375,
        -3396.164794921875,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 698.0,
      "bbox_min": [
        -1347.4595947265625,
        -3323.0673828125,
        610.8278198242188
      ],
      "bbox_max": [
        -1336.5555419921875,
        -3320.0,
        700.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5087251663208008,
        0.25412195920944214,
        0.8225695490837097
      ],
      "plane_d": 1099.726806640625,
      "bbox_min": [
        -1347.24072265625,
        -3441.9873046875,
        500.58746337890625
      ],
      "bbox_max": [
        -1291.38037109375,
        -3320.0,
        702.3347778320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 698.0,
      "bbox_min": [
        -1347.24072265625,
        -3390.705078125,
        610.8278198242188
      ],
      "bbox_max": [
        -1328.82177734375,
        -3320.0,
        700.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -700.5,
      "bbox_min": [
        -1347.24072265625,
        -3364.13720703125,
        700.5
      ],
      "bbox_max": [
        -1339.7030029296875,
        -3320.0,
        700.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1045287549495697,
        0.9945218563079834,
        8.653848453832325e-06
      ],
      "plane_d": 3228.56640625,
      "bbox_min": [
        -1337.1494140625,
        -3390.705078125,
        610.8278198242188
      ],
      "bbox_max": [
        -1328.82177734375,
        -3320.0,
        659.7679443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10451489686965942,
        -0.9945234060287476,
        1.8302351236343384e-05
      ],
      "plane_d": -3233.107666015625,
      "bbox_min": [
        -1331.0679931640625,
        -3390.705078125,
        649.8560791015625
      ],
      "bbox_max": [
        -1328.82177734375,
        -3386.095947265625,
        659.7679443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7032317519187927,
        -0.07390627264976501,
        0.7071089744567871
      ],
      "plane_d": -1652.1749267578125,
      "bbox_min": [
        -1331.0679931640625,
        -3390.705078125,
        649.8560791015625
      ],
      "bbox_max": [
        -1328.82177734375,
        -3386.095947265625,
        659.7679443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.703239381313324,
        0.07390304654836655,
        -0.7071017026901245
      ],
      "plane_d": 1645.098388671875,
      "bbox_min": [
        -1330.0411376953125,
        -3390.597412109375,
        649.8560791015625
      ],
      "bbox_max": [
        -1328.82177734375,
        -3386.095947265625,
        650.609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9549922347068787,
        0.29370102286338806,
        0.04158574342727661
      ],
      "plane_d": 2226.488525390625,
      "bbox_min": [
        -1337.1494140625,
        -3321.37109375,
        610.8278198242188
      ],
      "bbox_max": [
        -1336.5555419921875,
        -3320.0,
        614.7799072265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9927957653999329,
        0.11212077736854553,
        0.042255036532878876
      ],
      "plane_d": 1673.5107421875,
      "bbox_min": [
        -1345.1156005859375,
        -3390.633544921875,
        610.8278198242188
      ],
      "bbox_max": [
        -1327.4202880859375,
        -3320.0,
        702.3347778320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9549922347068787,
        0.29370102286338806,
        0.04158574342727661
      ],
      "plane_d": 2226.488525390625,
      "bbox_min": [
        -1345.1156005859375,
        -3354.178466796875,
        610.8278198242188
      ],
      "bbox_max": [
        -1336.5555419921875,
        -3320.0,
        702.3347778320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 698.0,
      "bbox_min": [
        -1345.1156005859375,
        -3354.178466796875,
        698.0
      ],
      "bbox_max": [
        -1339.2353515625,
        -3320.0,
        700.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -700.5,
      "bbox_min": [
        -1345.1156005859375,
        -3351.646728515625,
        700.5
      ],
      "bbox_max": [
        -1339.8861083984375,
        -3320.0,
        700.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 698.0,
      "bbox_min": [
        -1340.8819580078125,
        -3321.811767578125,
        698.0
      ],
      "bbox_max": [
        -1340.2159423828125,
        -3320.0,
        700.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -700.5,
      "bbox_min": [
        -1340.8819580078125,
        -3321.79931640625,
        700.5
      ],
      "bbox_max": [
        -1340.32373046875,
        -3320.0,
        700.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1045287549495697,
        0.9945218563079834,
        8.653848453832325e-06
      ],
      "plane_d": 3228.56640625,
      "bbox_min": [
        -1340.43701171875,
        -3390.633544921875,
        650.3655395507812
      ],
      "bbox_max": [
        -1327.4202880859375,
        -3320.0,
        700.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10451489686965942,
        -0.9945234060287476,
        1.8302351236343384e-05
      ],
      "plane_d": -3233.107666015625,
      "bbox_min": [
        -1330.37109375,
        -3390.633544921875,
        650.3655395507812
      ],
      "bbox_max": [
        -1327.4202880859375,
        -3385.88916015625,
        660.36767578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.703239381313324,
        0.07390304654836655,
        -0.7071017026901245
      ],
      "plane_d": 1645.098388671875,
      "bbox_min": [
        -1330.37109375,
        -3390.633544921875,
        650.3655395507812
      ],
      "bbox_max": [
        -1327.4202880859375,
        -3385.88916015625,
        660.36767578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7032317519187927,
        -0.07390627264976501,
        0.7071089744567871
      ],
      "plane_d": -1652.1749267578125,
      "bbox_min": [
        -1330.37109375,
        -3390.633544921875,
        659.5243530273438
      ],
      "bbox_max": [
        -1329.38623046875,
        -3386.095703125,
        660.36767578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 698.0,
      "bbox_min": [
        -1340.43701171875,
        -3326.95947265625,
        698.0
      ],
      "bbox_max": [
        -1339.634521484375,
        -3320.0,
        700.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -700.5,
      "bbox_min": [
        -1340.43701171875,
        -3321.79931640625,
        700.5
      ],
      "bbox_max": [
        -1340.32373046875,
        -3320.796142578125,
        700.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7217350602149963,
        0.6888043284416199,
        0.06816939264535904
      ],
      "plane_d": 3283.454345703125,
      "bbox_min": [
        -1344.9915771484375,
        -3523.00732421875,
        528.0936279296875
      ],
      "bbox_max": [
        -1240.6817626953125,
        -3320.55224609375,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6911952495574951,
        0.7170864343643188,
        0.08964577317237854
      ],
      "plane_d": 3326.97998046875,
      "bbox_min": [
        -1325.949951171875,
        -3522.972900390625,
        568.2194213867188
      ],
      "bbox_max": [
        -1240.85302734375,
        -3449.04052734375,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.706993818283081,
        -0.7070481181144714,
        0.015581655316054821
      ],
      "plane_d": -1574.3360595703125,
      "bbox_min": [
        -1308.97265625,
        -3522.972900390625,
        568.2194213867188
      ],
      "bbox_max": [
        -1240.85302734375,
        -3465.75,
        663.3931884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070278525352478,
        0.7070142030715942,
        -0.015574500896036625
      ],
      "plane_d": 1539.5325927734375,
      "bbox_min": [
        -1308.97265625,
        -3494.0263671875,
        608.3931884765625
      ],
      "bbox_max": [
        -1278.19384765625,
        -3465.75,
        663.3931884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -663.3931884765625,
      "bbox_min": [
        -1306.607177734375,
        -3494.0263671875,
        608.3931884765625
      ],
      "bbox_max": [
        -1278.19384765625,
        -3465.75,
        663.3931884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5011059641838074,
        0.8528707027435303,
        -0.14664393663406372
      ],
      "plane_d": 3702.4765625,
      "bbox_min": [
        -1304.650390625,
        -3493.8330078125,
        608.3931884765625
      ],
      "bbox_max": [
        -1278.19384765625,
        -3465.75,
        641.2197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8538200855255127,
        0.5016542673110962,
        -0.13904793560504913
      ],
      "plane_d": 2931.10400390625,
      "bbox_min": [
        -1290.0074462890625,
        -3493.8330078125,
        608.3931884765625
      ],
      "bbox_max": [
        -1278.19384765625,
        -3477.446533203125,
        637.4962768554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10194253921508789,
        0.8155403137207031,
        0.5696505308151245
      ],
      "plane_d": 2422.86572265625,
      "bbox_min": [
        -1240.914306640625,
        -3522.972900390625,
        568.2194213867188
      ],
      "bbox_max": [
        -1240.85302734375,
        -3522.884521484375,
        568.3509521484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9824994802474976,
        0.16235168278217316,
        0.09130601584911346
      ],
      "plane_d": 1796.623046875,
      "bbox_min": [
        -1325.949951171875,
        -3452.548583984375,
        640.7750854492188
      ],
      "bbox_max": [
        -1318.2420654296875,
        -3449.04052734375,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7646611928939819,
        0.6164575219154358,
        0.18781177699565887
      ],
      "plane_d": 3013.850341796875,
      "bbox_min": [
        -1344.9915771484375,
        -3522.960693359375,
        528.0936279296875
      ],
      "bbox_max": [
        -1240.6817626953125,
        -3320.55224609375,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10194253921508789,
        0.8155403137207031,
        0.5696505308151245
      ],
      "plane_d": 2422.86572265625,
      "bbox_min": [
        -1240.936767578125,
        -3522.960693359375,
        567.9523315429688
      ],
      "bbox_max": [
        -1240.85302734375,
        -3522.81396484375,
        568.33935546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12399445474147797,
        0.9919556379318237,
        -0.025480808690190315
      ],
      "plane_d": 3355.08447265625,
      "bbox_min": [
        -1240.936767578125,
        -3522.816650390625,
        567.9523315429688
      ],
      "bbox_max": [
        -1240.880615234375,
        -3522.81396484375,
        568.1181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9927957653999329,
        0.11212077736854553,
        0.042255036532878876
      ],
      "plane_d": 1673.5107421875,
      "bbox_min": [
        -1344.9915771484375,
        -3522.960693359375,
        567.364501953125
      ],
      "bbox_max": [
        -1240.6817626953125,
        -3320.55224609375,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9549922347068787,
        0.29370102286338806,
        0.04158574342727661
      ],
      "plane_d": 2226.488525390625,
      "bbox_min": [
        -1340.3232421875,
        -3321.824462890625,
        700.4888916015625
      ],
      "bbox_max": [
        -1340.3204345703125,
        -3321.81689453125,
        700.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10452409088611603,
        -0.9945224523544312,
        0.0
      ],
      "plane_d": -3237.580078125,
      "bbox_min": [
        -1344.9915771484375,
        -3396.77001953125,
        700.5
      ],
      "bbox_max": [
        -1332.010986328125,
        -3320.55224609375,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9549922347068787,
        0.29370102286338806,
        0.04158574342727661
      ],
      "plane_d": 2226.488525390625,
      "bbox_min": [
        -1340.7921142578125,
        -3321.840087890625,
        700.5
      ],
      "bbox_max": [
        -1340.3209228515625,
        -3320.55224609375,
        703.5836181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9824994802474976,
        0.16235168278217316,
        0.09130601584911346
      ],
      "plane_d": 1796.623046875,
      "bbox_min": [
        -1340.334716796875,
        -3522.960693359375,
        567.364501953125
      ],
      "bbox_max": [
        -1240.6817626953125,
        -3321.051025390625,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -700.5,
      "bbox_min": [
        -1340.334716796875,
        -3522.960693359375,
        567.364501953125
      ],
      "bbox_max": [
        -1240.6817626953125,
        -3321.051025390625,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 698.0,
      "bbox_min": [
        -1339.711181640625,
        -3522.960693359375,
        567.364501953125
      ],
      "bbox_max": [
        -1240.6817626953125,
        -3321.730712890625,
        700.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9945218563079834,
        0.1045292466878891,
        0.0
      ],
      "plane_d": 1663.0626220703125,
      "bbox_min": [
        -1331.1131591796875,
        -3403.35546875,
        698.0
      ],
      "bbox_max": [
        -1314.6949462890625,
        -3377.82470703125,
        700.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10452882945537567,
        -0.994521975517273,
        0.0
      ],
      "plane_d": -3245.572265625,
      "bbox_min": [
        -1331.1131591796875,
        -3403.35546875,
        698.0
      ],
      "bbox_max": [
        -1314.6949462890625,
        -3401.6298828125,
        700.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5011059641838074,
        0.8528707027435303,
        -0.14664393663406372
      ],
      "plane_d": 3702.4765625,
      "bbox_min": [
        -1330.708984375,
        -3522.960693359375,
        567.364501953125
      ],
      "bbox_max": [
        -1240.6817626953125,
        -3382.15771484375,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8538200855255127,
        0.5016542673110962,
        -0.13904793560504913
      ],
      "plane_d": 2931.10400390625,
      "bbox_min": [
        -1303.6473388671875,
        -3522.960693359375,
        567.364501953125
      ],
      "bbox_max": [
        -1240.6817626953125,
        -3463.167724609375,
        663.3931884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -663.3931884765625,
      "bbox_min": [
        -1303.6473388671875,
        -3491.638427734375,
        637.4962768554688
      ],
      "bbox_max": [
        -1275.7484130859375,
        -3463.167724609375,
        663.3931884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.706993818283081,
        -0.7070481181144714,
        0.015581655316054821
      ],
      "plane_d": -1574.3360595703125,
      "bbox_min": [
        -1303.6473388671875,
        -3491.638427734375,
        637.4962768554688
      ],
      "bbox_max": [
        -1275.7484130859375,
        -3463.167724609375,
        663.3931884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070278525352478,
        0.7070142030715942,
        -0.015574500896036625
      ],
      "plane_d": 1539.5325927734375,
      "bbox_min": [
        -1303.6473388671875,
        -3466.57177734375,
        641.2197265625
      ],
      "bbox_max": [
        -1300.2432861328125,
        -3463.167724609375,
        663.3931884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12399445474147797,
        0.9919556379318237,
        -0.025480808690190315
      ],
      "plane_d": 3355.08447265625,
      "bbox_min": [
        -1240.9207763671875,
        -3522.960693359375,
        567.364501953125
      ],
      "bbox_max": [
        -1240.6817626953125,
        -3522.79833984375,
        568.33935546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10194253921508789,
        0.8155403137207031,
        0.5696505308151245
      ],
      "plane_d": 2422.86572265625,
      "bbox_min": [
        -1240.9207763671875,
        -3522.960693359375,
        568.1181640625
      ],
      "bbox_max": [
        -1240.7646484375,
        -3522.79833984375,
        568.33935546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9792866706848145,
        0.167245551943779,
        0.11413394659757614
      ],
      "plane_d": 1794.639404296875,
      "bbox_min": [
        -1330.708984375,
        -3449.04052734375,
        621.0050048828125
      ],
      "bbox_max": [
        -1318.2420654296875,
        -3382.15771484375,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10449415445327759,
        0.9945255517959595,
        0.0
      ],
      "plane_d": 3228.630126953125,
      "bbox_min": [
        -1330.708984375,
        -3393.148193359375,
        652.0185546875
      ],
      "bbox_max": [
        -1319.7183837890625,
        -3382.15771484375,
        698.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.10449669510126114,
        -0.9945253133773804,
        0.0
      ],
      "plane_d": -3233.126220703125,
      "bbox_min": [
        -1330.3953857421875,
        -3393.148193359375,
        652.0185546875
      ],
      "bbox_max": [
        -1319.7183837890625,
        -3385.14111328125,
        698.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.994525671005249,
        0.10449273884296417,
        0.0
      ],
      "plane_d": 1669.4442138671875,
      "bbox_min": [
        -1330.3953857421875,
        -3390.661865234375,
        652.0185546875
      ],
      "bbox_max": [
        -1319.9796142578125,
        -3385.14111328125,
        698.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9945229291915894,
        -0.10451958328485489,
        -0.0
      ],
      "plane_d": -1674.5313720703125,
      "bbox_min": [
        -1330.3953857421875,
        -3390.661865234375,
        652.0185546875
      ],
      "bbox_max": [
        -1322.466064453125,
        -3385.40234375,
        691.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.703239381313324,
        0.07390304654836655,
        -0.7071017026901245
      ],
      "plane_d": 1645.098388671875,
      "bbox_min": [
        -1327.908935546875,
        -3390.400634765625,
        652.0185546875
      ],
      "bbox_max": [
        -1322.466064453125,
        -3385.40234375,
        691.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 691.0,
      "bbox_min": [
        -1327.908935546875,
        -3390.400634765625,
        691.0
      ],
      "bbox_max": [
        -1322.466064453125,
        -3385.40234375,
        691.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7032317519187927,
        -0.07390627264976501,
        0.7071089744567871
      ],
      "plane_d": -1652.1749267578125,
      "bbox_min": [
        -1330.3953857421875,
        -3390.661865234375,
        660.0416870117188
      ],
      "bbox_max": [
        -1327.4384765625,
        -3385.925048828125,
        691.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 691.0,
      "bbox_min": [
        -1330.3953857421875,
        -3390.661865234375,
        691.0
      ],
      "bbox_max": [
        -1327.4384765625,
        -3385.925048828125,
        691.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9945217370986938,
        0.10453037172555923,
        -0.0
      ],
      "plane_d": 1667.06640625,
      "bbox_min": [
        -1322.9365234375,
        -3389.878173828125,
        691.0
      ],
      "bbox_max": [
        -1319.9796142578125,
        -3385.14111328125,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 691.0,
      "bbox_min": [
        -1322.9365234375,
        -3389.878173828125,
        691.0
      ],
      "bbox_max": [
        -1319.9796142578125,
        -3385.14111328125,
        691.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10454117506742477,
        -0.9945205450057983,
        0.0
      ],
      "plane_d": -3235.551025390625,
      "bbox_min": [
        -1329.9249267578125,
        -3393.148193359375,
        691.0
      ],
      "bbox_max": [
        -1319.7183837890625,
        -3389.616943359375,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 691.0,
      "bbox_min": [
        -1329.9249267578125,
        -3393.148193359375,
        691.0
      ],
      "bbox_max": [
        -1319.7183837890625,
        -3389.616943359375,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9945217370986938,
        0.10453037172555923,
        -0.0
      ],
      "plane_d": 1667.06640625,
      "bbox_min": [
        -1319.9796142578125,
        -3392.102783203125,
        691.0
      ],
      "bbox_max": [
        -1319.7183837890625,
        -3389.616943359375,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10451576113700867,
        0.994523286819458,
        0.0
      ],
      "plane_d": 3225.593994140625,
      "bbox_min": [
        -1330.708984375,
        -3386.186279296875,
        691.0
      ],
      "bbox_max": [
        -1320.4500732421875,
        -3382.15771484375,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 691.0,
      "bbox_min": [
        -1330.708984375,
        -3386.186279296875,
        691.0
      ],
      "bbox_max": [
        -1320.4500732421875,
        -3382.15771484375,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9945217370986938,
        0.10453037172555923,
        -0.0
      ],
      "plane_d": 1667.06640625,
      "bbox_min": [
        -1320.763671875,
        -3385.14111328125,
        691.0
      ],
      "bbox_max": [
        -1320.4500732421875,
        -3382.15771484375,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9945220351219177,
        0.10452785342931747,
        0.0
      ],
      "plane_d": 1665.058349609375,
      "bbox_min": [
        -1332.9993896484375,
        -3395.509765625,
        700.5
      ],
      "bbox_max": [
        -1317.5203857421875,
        -3372.2197265625,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10452409088611603,
        -0.9945224523544312,
        0.0
      ],
      "plane_d": -3237.580078125,
      "bbox_min": [
        -1332.9993896484375,
        -3395.509765625,
        700.5
      ],
      "bbox_max": [
        -1317.5203857421875,
        -3393.8828125,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9201366305351257,
        -0.3901376724243164,
        0.03378250449895859
      ],
      "plane_d": -2429.739990234375,
      "bbox_min": [
        -1341.9053955078125,
        -3527.603515625,
        267.0
      ],
      "bbox_max": [
        -1131.2100830078125,
        -3320.0,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9524388313293457,
        -0.2936769425868988,
        0.08132689446210861
      ],
      "plane_d": -2159.927490234375,
      "bbox_min": [
        -1214.751220703125,
        -3485.4150390625,
        426.0061340332031
      ],
      "bbox_max": [
        -1131.2100830078125,
        -3320.0,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9753258228302002,
        -0.14798365533351898,
        0.1638302057981491
      ],
      "plane_d": -1742.69921875,
      "bbox_min": [
        -1198.85009765625,
        -3484.58642578125,
        529.8218994140625
      ],
      "bbox_max": [
        -1131.2100830078125,
        -3320.0,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9528772234916687,
        -0.2737281024456024,
        0.130758598446846
      ],
      "plane_d": -2123.362548828125,
      "bbox_min": [
        -1166.6292724609375,
        -3484.58642578125,
        621.68359375
      ],
      "bbox_max": [
        -1131.2100830078125,
        -3399.0576171875,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9792153239250183,
        -0.19332727789878845,
        0.061334479600191116
      ],
      "plane_d": -1825.3980712890625,
      "bbox_min": [
        -1137.0072021484375,
        -3483.275146484375,
        687.8972778320312
      ],
      "bbox_max": [
        -1131.2100830078125,
        -3453.29931640625,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9856189489364624,
        -0.10732632130384445,
        0.13052378594875336
      ],
      "plane_d": -1595.8048095703125,
      "bbox_min": [
        -1198.85009765625,
        -3422.269775390625,
        529.8218994140625
      ],
      "bbox_max": [
        -1145.9208984375,
        -3320.0,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9528772234916687,
        -0.2737281024456024,
        0.130758598446846
      ],
      "plane_d": -2123.362548828125,
      "bbox_min": [
        -1166.6292724609375,
        -3422.269775390625,
        621.68359375
      ],
      "bbox_max": [
        -1145.9208984375,
        -3396.30615234375,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8672640323638916,
        0.18403863906860352,
        0.46258267760276794
      ],
      "plane_d": -673.7977294921875,
      "bbox_min": [
        -1198.85009765625,
        -3399.0576171875,
        529.8218994140625
      ],
      "bbox_max": [
        -1160.6263427734375,
        -3320.0,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.796037495136261,
        -0.5924747586250305,
        0.12368514388799667
      ],
      "plane_d": -2981.951171875,
      "bbox_min": [
        -1175.486083984375,
        -3329.75439453125,
        640.3673095703125
      ],
      "bbox_max": [
        -1160.6263427734375,
        -3320.0,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9845805764198303,
        -0.14805786311626434,
        0.09316641837358475
      ],
      "plane_d": -1703.1788330078125,
      "bbox_min": [
        -1163.886474609375,
        -3329.75439453125,
        715.0223388671875
      ],
      "bbox_max": [
        -1160.6263427734375,
        -3320.0,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8007402420043945,
        -0.5945212841033936,
        0.073208749294281
      ],
      "plane_d": -2958.124267578125,
      "bbox_min": [
        -1163.886474609375,
        -3321.635986328125,
        715.0223388671875
      ],
      "bbox_max": [
        -1161.8470458984375,
        -3320.0,
        724.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9192844033241272,
        -0.38526779413223267,
        0.08052864670753479
      ],
      "plane_d": -2432.07470703125,
      "bbox_min": [
        -1214.751220703125,
        -3402.96435546875,
        426.0061340332031
      ],
      "bbox_max": [
        -1166.6292724609375,
        -3320.0,
        621.68359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8672640323638916,
        0.18403863906860352,
        0.46258267760276794
      ],
      "plane_d": -673.7977294921875,
      "bbox_min": [
        -1209.5694580078125,
        -3399.0576171875,
        509.7249450683594
      ],
      "bbox_max": [
        -1166.6292724609375,
        -3320.0,
        621.68359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4483394920825958,
        -0.6716778874397278,
        0.5897800326347351
      ],
      "plane_d": -3066.94287109375,
      "bbox_min": [
        -1214.751220703125,
        -3402.96435546875,
        426.0061340332031
      ],
      "bbox_max": [
        -1182.1331787109375,
        -3320.0,
        498.9146728515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04223942756652832,
        -0.9113441109657288,
        0.4094725549221039
      ],
      "plane_d": -3270.52197265625,
      "bbox_min": [
        -1341.9053955078125,
        -3527.603515625,
        267.0
      ],
      "bbox_max": [
        -1148.46826171875,
        -3320.0,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6944899559020996,
        -0.6407128572463989,
        0.3273695409297943
      ],
      "plane_d": -1423.39990234375,
      "bbox_min": [
        -1235.176513671875,
        -3413.29296875,
        267.0
      ],
      "bbox_max": [
        -1195.7606201171875,
        -3320.0,
        470.81585693359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8235416412353516,
        -0.5580507516860962,
        0.10177668184041977
      ],
      "plane_d": -2915.920166015625,
      "bbox_min": [
        -1233.32861328125,
        -3413.29296875,
        267.0
      ],
      "bbox_max": [
        -1195.7606201171875,
        -3320.0,
        470.81585693359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9405732750892639,
        -0.10687936842441559,
        0.3223331570625305
      ],
      "plane_d": 700.9578857421875,
      "bbox_min": [
        -1341.9053955078125,
        -3527.603515625,
        267.0
      ],
      "bbox_max": [
        -1148.46826171875,
        -3320.0,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5087251663208008,
        0.25412195920944214,
        0.8225695490837097
      ],
      "plane_d": 1099.726806640625,
      "bbox_min": [
        -1312.7127685546875,
        -3355.306884765625,
        485.9448547363281
      ],
      "bbox_max": [
        -1289.0367431640625,
        -3320.0,
        502.93450927734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4483394920825958,
        -0.6716778874397278,
        0.5897800326347351
      ],
      "plane_d": -3066.94287109375,
      "bbox_min": [
        -1231.2933349609375,
        -3402.96435546875,
        426.0061340332031
      ],
      "bbox_max": [
        -1182.1331787109375,
        -3320.0,
        495.6954345703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9710849523544312,
        0.01423729583621025,
        0.2383090704679489
      ],
      "plane_d": 1181.926025390625,
      "bbox_min": [
        -1341.9053955078125,
        -3527.603515625,
        267.0
      ],
      "bbox_max": [
        -1148.46826171875,
        -3320.0,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 698.0,
      "bbox_min": [
        -1340.996826171875,
        -3321.730712890625,
        698.0
      ],
      "bbox_max": [
        -1339.711181640625,
        -3320.0,
        703.1358032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9549922347068787,
        0.29370102286338806,
        0.04158574342727661
      ],
      "plane_d": 2226.488525390625,
      "bbox_min": [
        -1340.996826171875,
        -3321.051025390625,
        700.5
      ],
      "bbox_max": [
        -1340.334716796875,
        -3320.0,
        703.1358032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -700.5,
      "bbox_min": [
        -1340.7564697265625,
        -3321.051025390625,
        700.5
      ],
      "bbox_max": [
        -1340.334716796875,
        -3320.0,
        700.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8973290324211121,
        -0.4287506937980652,
        0.1047549843788147
      ],
      "plane_d": -2564.411865234375,
      "bbox_min": [
        -1341.9053955078125,
        -3527.603515625,
        267.0
      ],
      "bbox_max": [
        -1148.46826171875,
        -3320.0,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6330804824829102,
        0.7714124321937561,
        0.06428063660860062
      ],
      "plane_d": 3466.7158203125,
      "bbox_min": [
        -1341.9053955078125,
        -3527.603515625,
        566.0579833984375
      ],
      "bbox_max": [
        -1240.2393798828125,
        -3320.0,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -700.5,
      "bbox_min": [
        -1341.9053955078125,
        -3372.2197265625,
        698.0
      ],
      "bbox_max": [
        -1319.7972412109375,
        -3320.0,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 698.0,
      "bbox_min": [
        -1339.7364501953125,
        -3371.036376953125,
        698.0
      ],
      "bbox_max": [
        -1319.921630859375,
        -3320.0,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9927957653999329,
        0.11212077736854553,
        0.042255036532878876
      ],
      "plane_d": 1673.5107421875,
      "bbox_min": [
        -1341.9053955078125,
        -3328.757080078125,
        702.3347778320312
      ],
      "bbox_max": [
        -1340.450439453125,
        -3320.0,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9945218563079834,
        0.1045292466878891,
        0.0
      ],
      "plane_d": 1663.0626220703125,
      "bbox_min": [
        -1325.2857666015625,
        -3522.927490234375,
        566.0579833984375
      ],
      "bbox_max": [
        -1240.2393798828125,
        -3320.0,
        700.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -700.5,
      "bbox_min": [
        -1325.2857666015625,
        -3379.008544921875,
        698.0
      ],
      "bbox_max": [
        -1317.072509765625,
        -3320.0,
        700.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 698.0,
      "bbox_min": [
        -1325.2857666015625,
        -3377.82470703125,
        698.0
      ],
      "bbox_max": [
        -1317.197021484375,
        -3320.0,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12399445474147797,
        0.9919556379318237,
        -0.025480808690190315
      ],
      "plane_d": 3355.08447265625,
      "bbox_min": [
        -1240.7899169921875,
        -3522.927490234375,
        566.0579833984375
      ],
      "bbox_max": [
        -1240.2393798828125,
        -3522.7294921875,
        568.3074951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10194253921508789,
        0.8155403137207031,
        0.5696505308151245
      ],
      "plane_d": 2422.86572265625,
      "bbox_min": [
        -1240.7899169921875,
        -3522.927490234375,
        568.1181640625
      ],
      "bbox_max": [
        -1240.2393798828125,
        -3522.7294921875,
        568.3074951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8007402420043945,
        -0.5945212841033936,
        0.073208749294281
      ],
      "plane_d": -2958.124267578125,
      "bbox_min": [
        -1465.0,
        -3531.997802734375,
        724.0
      ],
      "bbox_max": [
        -1105.0,
        -3083.3251953125,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7746099233627319,
        -0.5822634696960449,
        0.2468777596950531
      ],
      "plane_d": -3030.36767578125,
      "bbox_min": [
        -1325.222900390625,
        -3355.479736328125,
        833.690185546875
      ],
      "bbox_max": [
        -1105.0,
        -3083.3251953125,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6744422316551208,
        -0.542770504951477,
        0.5005276203155518
      ],
      "plane_d": -1478.223388671875,
      "bbox_min": [
        -1146.5478515625,
        -3348.796142578125,
        860.0
      ],
      "bbox_max": [
        -1105.0,
        -3286.692138671875,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3314.0,
      "bbox_min": [
        -1146.5478515625,
        -3322.0,
        860.0
      ],
      "bbox_max": [
        -1126.0,
        -3314.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3322.0,
      "bbox_min": [
        -1146.5478515625,
        -3322.0,
        860.0
      ],
      "bbox_max": [
        -1126.0,
        -3314.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1126.0,
      "bbox_min": [
        -1146.5478515625,
        -3322.0,
        860.0
      ],
      "bbox_max": [
        -1126.0,
        -3314.0,
        876.88232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9138116240501404,
        -0.0,
        -0.40613850951194763
      ],
      "plane_d": -697.9490356445312,
      "bbox_min": [
        -1146.5478515625,
        -3315.25146484375,
        860.0
      ],
      "bbox_max": [
        -1146.0,
        -3314.0,
        861.2327880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17790910601615906,
        -0.0,
        0.984046995639801
      ],
      "plane_d": -662.3861083984375,
      "bbox_min": [
        -1134.300048828125,
        -3348.796142578125,
        868.207275390625
      ],
      "bbox_max": [
        -1105.0,
        -3293.0009765625,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3322.0,
      "bbox_min": [
        -1133.22900390625,
        -3322.0,
        868.207275390625
      ],
      "bbox_max": [
        -1126.0,
        -3314.573486328125,
        877.9481811523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1126.0,
      "bbox_min": [
        -1126.0,
        -3322.0,
        868.207275390625
      ],
      "bbox_max": [
        -1126.0,
        -3314.573486328125,
        876.69775390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1126.0,
      "bbox_min": [
        -1133.2774658203125,
        -3322.0,
        876.2603149414062
      ],
      "bbox_max": [
        -1126.0,
        -3314.170166015625,
        878.013427734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6382936835289001,
        0.7293487191200256,
        0.2462347000837326
      ],
      "plane_d": 1514.509521484375,
      "bbox_min": [
        -1133.4146728515625,
        -3348.796142578125,
        872.9010620117188
      ],
      "bbox_max": [
        -1105.0,
        -3314.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1126.0,
      "bbox_min": [
        -1133.4146728515625,
        -3322.0,
        876.6976928710938
      ],
      "bbox_max": [
        -1126.0,
        -3314.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3314.0,
      "bbox_min": [
        -1126.9766845703125,
        -3314.0,
        876.88232421875
      ],
      "bbox_max": [
        -1126.0,
        -3314.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7215278148651123,
        -0.4943443834781647,
        0.48478996753692627
      ],
      "plane_d": -2886.926513671875,
      "bbox_min": [
        -1325.222900390625,
        -3355.479736328125,
        833.690185546875
      ],
      "bbox_max": [
        -1114.98486328125,
        -3088.034423828125,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17790910601615906,
        -0.0,
        0.984046995639801
      ],
      "plane_d": -662.3861083984375,
      "bbox_min": [
        -1148.6920166015625,
        -3350.2001953125,
        860.0
      ],
      "bbox_max": [
        -1114.98486328125,
        -3314.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3322.0,
      "bbox_min": [
        -1148.6920166015625,
        -3322.0,
        860.0
      ],
      "bbox_max": [
        -1135.193359375,
        -3314.0,
        877.9904174804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3314.0,
      "bbox_min": [
        -1148.6920166015625,
        -3322.0,
        860.0
      ],
      "bbox_max": [
        -1141.6875,
        -3314.0,
        876.482421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9138116240501404,
        -0.0,
        -0.40613850951194763
      ],
      "plane_d": -697.9490356445312,
      "bbox_min": [
        -1148.6920166015625,
        -3322.0,
        860.0
      ],
      "bbox_max": [
        -1146.0,
        -3314.0,
        866.0571899414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6382936835289001,
        0.7293487191200256,
        0.2462347000837326
      ],
      "plane_d": 1514.509521484375,
      "bbox_min": [
        -1117.7437744140625,
        -3350.2001953125,
        874.9114379882812
      ],
      "bbox_max": [
        -1114.98486328125,
        -3348.679931640625,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8208402991294861,
        1.7694263831913304e-08,
        0.5711577534675598
      ],
      "plane_d": -1432.6689453125,
      "bbox_min": [
        -1150.0,
        -3355.479736328125,
        856.8275146484375
      ],
      "bbox_max": [
        -1116.0537109375,
        -3314.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17790910601615906,
        -0.0,
        0.984046995639801
      ],
      "plane_d": -662.3861083984375,
      "bbox_min": [
        -1134.300048828125,
        -3355.479736328125,
        875.2050170898438
      ],
      "bbox_max": [
        -1116.0537109375,
        -3323.10009765625,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6382936835289001,
        0.7293487191200256,
        0.2462347000837326
      ],
      "plane_d": 1514.509521484375,
      "bbox_min": [
        -1123.043701171875,
        -3355.479736328125,
        875.2050170898438
      ],
      "bbox_max": [
        -1116.0537109375,
        -3349.731689453125,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3322.0,
      "bbox_min": [
        -1150.0,
        -3322.0,
        861.1472778320312
      ],
      "bbox_max": [
        -1135.1270751953125,
        -3314.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3314.0,
      "bbox_min": [
        -1150.0,
        -3322.0,
        861.1472778320312
      ],
      "bbox_max": [
        -1141.140625,
        -3314.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.950871467590332,
        0.0,
        0.3095860481262207
      ],
      "plane_d": -1362.532470703125,
      "bbox_min": [
        -1150.0,
        -3322.0,
        861.1472778320312
      ],
      "bbox_max": [
        -1146.5098876953125,
        -3314.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9138116240501404,
        -0.0,
        -0.40613850951194763
      ],
      "plane_d": -697.9490356445312,
      "bbox_min": [
        -1150.0,
        -3322.0,
        861.1472778320312
      ],
      "bbox_max": [
        -1146.5098876953125,
        -3314.0,
        869.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7995961308479309,
        -0.5955905318260193,
        0.0769285261631012
      ],
      "plane_d": -2963.00537109375,
      "bbox_min": [
        -1465.0,
        -3531.997802734375,
        724.0
      ],
      "bbox_max": [
        -1122.068603515625,
        -3088.130126953125,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9897537231445312,
        0.0914701595902443,
        0.10963901877403259
      ],
      "plane_d": 1547.7437744140625,
      "bbox_min": [
        -1465.0,
        -3500.86328125,
        724.0
      ],
      "bbox_max": [
        -1282.6756591796875,
        -3139.3798828125,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9927957653999329,
        0.11212077736854553,
        0.042255036532878876
      ],
      "plane_d": 1673.5107421875,
      "bbox_min": [
        -1465.0,
        -3453.564697265625,
        724.0
      ],
      "bbox_max": [
        -1324.8431396484375,
        -3139.3798828125,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9549922347068787,
        0.29370102286338806,
        0.04158574342727661
      ],
      "plane_d": 2226.488525390625,
      "bbox_min": [
        -1465.0,
        -3410.0,
        724.0
      ],
      "bbox_max": [
        -1341.3077392578125,
        -3139.3798828125,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5241461396217346,
        0.8516283631324768
      ],
      "plane_d": 929.7969360351562,
      "bbox_min": [
        -1465.0,
        -3410.0,
        849.997802734375
      ],
      "bbox_max": [
        -1347.2169189453125,
        -3139.3798828125,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1370.0,
      "bbox_min": [
        -1405.0,
        -3410.0,
        860.0
      ],
      "bbox_max": [
        -1347.2169189453125,
        -3315.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1405.0,
      "bbox_min": [
        -1405.0,
        -3410.0,
        870.0
      ],
      "bbox_max": [
        -1370.0,
        -3368.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3368.0,
      "bbox_min": [
        -1405.0,
        -3368.0,
        870.0
      ],
      "bbox_max": [
        -1370.0,
        -3368.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1356.0,
      "bbox_min": [
        -1356.0,
        -3374.0,
        860.0
      ],
      "bbox_max": [
        -1347.2169189453125,
        -3315.0,
        878.1983032226562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3374.0,
      "bbox_min": [
        -1356.0,
        -3374.0,
        860.0
      ],
      "bbox_max": [
        -1347.2169189453125,
        -3315.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3366.0,
      "bbox_min": [
        -1356.0,
        -3374.0,
        860.0
      ],
      "bbox_max": [
        -1347.2169189453125,
        -3315.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 860.0,
      "bbox_min": [
        -1356.0,
        -3374.0,
        860.0
      ],
      "bbox_max": [
        -1347.2169189453125,
        -3366.0,
        860.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3323.0,
      "bbox_min": [
        -1356.0,
        -3323.0,
        860.0
      ],
      "bbox_max": [
        -1351.93017578125,
        -3315.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3315.0,
      "bbox_min": [
        -1356.0,
        -3323.0,
        860.0
      ],
      "bbox_max": [
        -1351.93017578125,
        -3315.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 860.0,
      "bbox_min": [
        -1356.0,
        -3323.0,
        860.0
      ],
      "bbox_max": [
        -1351.93017578125,
        -3315.0,
        860.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1465.0,
      "bbox_min": [
        -1465.0,
        -3200.81640625,
        849.997802734375
      ],
      "bbox_max": [
        -1440.436767578125,
        -3139.3798828125,
        878.1983032226562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9598785042762756,
        0.28041622042655945,
        0.0
      ],
      "plane_d": -502.311279296875,
      "bbox_min": [
        -1445.0,
        -3155.0,
        849.997802734375
      ],
      "bbox_max": [
        -1440.436767578125,
        -3139.3798828125,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -850.0,
      "bbox_min": [
        -1445.0,
        -3155.0,
        849.997802734375
      ],
      "bbox_max": [
        -1440.436767578125,
        -3139.3798828125,
        850.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -850.0,
      "bbox_min": [
        -1465.0,
        -3155.0,
        849.9982299804688
      ],
      "bbox_max": [
        -1445.0,
        -3141.41162109375,
        850.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9824994802474976,
        0.16235168278217316,
        0.09130601584911346
      ],
      "plane_d": 1796.623046875,
      "bbox_min": [
        -1329.06494140625,
        -3453.564697265625,
        724.0
      ],
      "bbox_max": [
        -1324.8431396484375,
        -3430.349365234375,
        748.108642578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6911952495574951,
        0.7170864343643188,
        0.08964577317237854
      ],
      "plane_d": 3326.97998046875,
      "bbox_min": [
        -1327.46923828125,
        -3453.564697265625,
        724.0
      ],
      "bbox_max": [
        -1324.8431396484375,
        -3452.548583984375,
        748.108642578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9832573533058167,
        0.1745198667049408,
        0.052420713007450104
      ],
      "plane_d": 1868.7430419921875,
      "bbox_min": [
        -1354.6854248046875,
        -3500.86328125,
        724.0
      ],
      "bbox_max": [
        -1282.6756591796875,
        -3315.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3374.0,
      "bbox_min": [
        -1349.97216796875,
        -3374.0,
        865.9097900390625
      ],
      "bbox_max": [
        -1347.87158203125,
        -3366.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3366.0,
      "bbox_min": [
        -1349.97216796875,
        -3366.0,
        877.7510986328125
      ],
      "bbox_max": [
        -1349.922607421875,
        -3366.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7219356298446655,
        0.69008469581604,
        0.05091238394379616
      ],
      "plane_d": 3303.51171875,
      "bbox_min": [
        -1354.6854248046875,
        -3500.86328125,
        724.0
      ],
      "bbox_max": [
        -1282.6756591796875,
        -3315.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7124058604240417,
        0.6995056867599487,
        0.05629853904247284
      ],
      "plane_d": 3319.36767578125,
      "bbox_min": [
        -1354.6854248046875,
        -3500.86328125,
        724.0
      ],
      "bbox_max": [
        -1282.6756591796875,
        -3315.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3315.0,
      "bbox_min": [
        -1354.6854248046875,
        -3323.0,
        860.0
      ],
      "bbox_max": [
        -1348.7904052734375,
        -3315.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3323.0,
      "bbox_min": [
        -1353.9461669921875,
        -3323.0,
        860.0
      ],
      "bbox_max": [
        -1348.7904052734375,
        -3315.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6911952495574951,
        0.7170864343643188,
        0.08964577317237854
      ],
      "plane_d": 3326.97998046875,
      "bbox_min": [
        -1349.9464111328125,
        -3499.70263671875,
        724.0
      ],
      "bbox_max": [
        -1282.6756591796875,
        -3322.9326171875,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7217350602149963,
        0.6888043284416199,
        0.06816939264535904
      ],
      "plane_d": 3283.454345703125,
      "bbox_min": [
        -1292.409912109375,
        -3495.6044921875,
        724.0
      ],
      "bbox_max": [
        -1282.6756591796875,
        -3484.34423828125,
        750.545166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3374.0,
      "bbox_min": [
        -1348.5267333984375,
        -3374.0,
        860.0
      ],
      "bbox_max": [
        -1332.47998046875,
        -3366.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 860.0,
      "bbox_min": [
        -1347.956298828125,
        -3374.0,
        860.0
      ],
      "bbox_max": [
        -1332.47998046875,
        -3366.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9138116240501404,
        0.0,
        -0.40613850951194763
      ],
      "plane_d": 1570.1314697265625,
      "bbox_min": [
        -1336.0,
        -3374.0,
        860.0
      ],
      "bbox_max": [
        -1332.47998046875,
        -3366.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.950871467590332,
        -0.0,
        0.3095860481262207
      ],
      "plane_d": 997.530517578125,
      "bbox_min": [
        -1334.9947509765625,
        -3374.0,
        871.167236328125
      ],
      "bbox_max": [
        -1332.70556640625,
        -3368.547119140625,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3323.0,
      "bbox_min": [
        -1349.2763671875,
        -3323.0,
        860.0
      ],
      "bbox_max": [
        -1348.7681884765625,
        -3322.9326171875,
        867.3114624023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 860.0,
      "bbox_min": [
        -1348.7904052734375,
        -3323.0,
        860.0
      ],
      "bbox_max": [
        -1348.7681884765625,
        -3322.9326171875,
        860.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9465469121932983,
        0.3008812665939331,
        0.11627301573753357
      ],
      "plane_d": 2180.1689453125,
      "bbox_min": [
        -1411.0396728515625,
        -3531.997802734375,
        724.0
      ],
      "bbox_max": [
        -1122.068603515625,
        -3091.116455078125,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9549922347068787,
        0.29370102286338806,
        0.04158574342727661
      ],
      "plane_d": 2226.488525390625,
      "bbox_min": [
        -1403.4910888671875,
        -3496.543701171875,
        724.0
      ],
      "bbox_max": [
        -1280.76708984375,
        -3123.09814453125,
        787.6017456054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9616638422012329,
        0.25931838154792786,
        0.08920101076364517
      ],
      "plane_d": 2092.123291015625,
      "bbox_min": [
        -1403.4910888671875,
        -3496.543701171875,
        724.0
      ],
      "bbox_max": [
        -1280.76708984375,
        -3123.09814453125,
        761.9190673828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4523264467716217,
        -0.8918522596359253,
        0.0003948037629015744
      ],
      "plane_d": -2152.6083984375,
      "bbox_min": [
        -1403.4910888671875,
        -3496.543701171875,
        724.0
      ],
      "bbox_max": [
        -1280.76708984375,
        -3123.09814453125,
        761.9190673828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7217350602149963,
        0.6888043284416199,
        0.06816939264535904
      ],
      "plane_d": 3283.454345703125,
      "bbox_min": [
        -1284.0076904296875,
        -3496.543701171875,
        724.0
      ],
      "bbox_max": [
        -1280.76708984375,
        -3494.5439453125,
        747.6505737304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3315.0,
      "bbox_min": [
        -1352.674560546875,
        -3315.0,
        876.2842407226562
      ],
      "bbox_max": [
        -1352.54150390625,
        -3315.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9533829092979431,
        -0.23182019591331482,
        0.1931847333908081
      ],
      "plane_d": -2031.31396484375,
      "bbox_min": [
        -1149.1702880859375,
        -3407.154296875,
        794.9396362304688
      ],
      "bbox_max": [
        -1122.6217041015625,
        -3322.353759765625,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8208402991294861,
        1.7694263831913304e-08,
        0.5711577534675598
      ],
      "plane_d": -1432.6689453125,
      "bbox_min": [
        -1149.1702880859375,
        -3374.0,
        856.8275146484375
      ],
      "bbox_max": [
        -1122.6217041015625,
        -3322.353759765625,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3366.0,
      "bbox_min": [
        -1137.91455078125,
        -3374.0,
        860.0
      ],
      "bbox_max": [
        -1126.0,
        -3366.0,
        878.185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 860.0,
      "bbox_min": [
        -1137.91455078125,
        -3374.0,
        860.0
      ],
      "bbox_max": [
        -1126.0,
        -3366.0,
        860.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6382936835289001,
        0.7293487191200256,
        0.2462347000837326
      ],
      "plane_d": 1514.509521484375,
      "bbox_min": [
        -1134.300048828125,
        -3374.0,
        876.1632080078125
      ],
      "bbox_max": [
        -1122.6217041015625,
        -3355.161865234375,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3366.0,
      "bbox_min": [
        -1134.2296142578125,
        -3374.0,
        876.6976928710938
      ],
      "bbox_max": [
        -1126.0,
        -3366.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1126.0,
      "bbox_min": [
        -1132.3531494140625,
        -3374.0,
        876.6976928710938
      ],
      "bbox_max": [
        -1126.0,
        -3366.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3374.0,
      "bbox_min": [
        -1132.3531494140625,
        -3374.0,
        876.6976928710938
      ],
      "bbox_max": [
        -1126.0,
        -3374.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9931049346923828,
        0.0022958379704505205,
        0.11720679700374603
      ],
      "plane_d": -1221.6827392578125,
      "bbox_min": [
        -1144.192626953125,
        -3407.154296875,
        794.9396362304688
      ],
      "bbox_max": [
        -1132.2818603515625,
        -3365.699951171875,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 860.0,
      "bbox_min": [
        -1136.4671630859375,
        -3374.0,
        860.0
      ],
      "bbox_max": [
        -1134.22705078125,
        -3366.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3374.0,
      "bbox_min": [
        -1142.3065185546875,
        -3374.0,
        860.0
      ],
      "bbox_max": [
        -1134.30078125,
        -3366.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3366.0,
      "bbox_min": [
        -1142.3065185546875,
        -3374.0,
        860.0
      ],
      "bbox_max": [
        -1134.30078125,
        -3366.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 860.0,
      "bbox_min": [
        -1142.3065185546875,
        -3374.0,
        860.0
      ],
      "bbox_max": [
        -1136.46240234375,
        -3366.0,
        860.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9856189489364624,
        -0.10732632130384445,
        0.13052378594875336
      ],
      "plane_d": -1595.8048095703125,
      "bbox_min": [
        -1160.6263427734375,
        -3417.484375,
        724.0
      ],
      "bbox_max": [
        -1134.3958740234375,
        -3319.7373046875,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9931049346923828,
        0.0022958379704505205,
        0.11720679700374603
      ],
      "plane_d": -1221.6827392578125,
      "bbox_min": [
        -1150.0,
        -3417.484375,
        794.9396362304688
      ],
      "bbox_max": [
        -1134.3958740234375,
        -3319.7373046875,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3366.0,
      "bbox_min": [
        -1150.0,
        -3374.0,
        860.0
      ],
      "bbox_max": [
        -1139.381591796875,
        -3319.7373046875,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3374.0,
      "bbox_min": [
        -1145.7242431640625,
        -3374.0,
        860.0
      ],
      "bbox_max": [
        -1139.381591796875,
        -3366.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 860.0,
      "bbox_min": [
        -1145.7242431640625,
        -3374.0,
        860.0
      ],
      "bbox_max": [
        -1141.1036376953125,
        -3366.0,
        860.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3322.0,
      "bbox_min": [
        -1150.0,
        -3322.0,
        865.864990234375
      ],
      "bbox_max": [
        -1147.6640625,
        -3319.7373046875,
        876.1748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.950871467590332,
        0.0,
        0.3095860481262207
      ],
      "plane_d": -1362.532470703125,
      "bbox_min": [
        -1150.0,
        -3322.0,
        865.864990234375
      ],
      "bbox_max": [
        -1147.6640625,
        -3319.7373046875,
        876.1748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9138116240501404,
        -0.0,
        -0.40613850951194763
      ],
      "plane_d": -697.9490356445312,
      "bbox_min": [
        -1150.0,
        -3322.0,
        865.864990234375
      ],
      "bbox_max": [
        -1148.606689453125,
        -3319.7373046875,
        869.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6330804824829102,
        0.7714124321937561,
        0.06428063660860062
      ],
      "plane_d": 3466.7158203125,
      "bbox_min": [
        -1411.0396728515625,
        -3531.997802734375,
        724.0
      ],
      "bbox_max": [
        -1137.0072021484375,
        -3091.116455078125,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6911952495574951,
        0.7170864343643188,
        0.08964577317237854
      ],
      "plane_d": 3326.97998046875,
      "bbox_min": [
        -1291.3076171875,
        -3530.23779296875,
        750.545166015625
      ],
      "bbox_max": [
        -1258.8291015625,
        -3495.6044921875,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7124058604240417,
        0.6995056867599487,
        0.05629853904247284
      ],
      "plane_d": 3319.36767578125,
      "bbox_min": [
        -1291.3076171875,
        -3530.23779296875,
        798.7042846679688
      ],
      "bbox_max": [
        -1258.8291015625,
        -3499.70263671875,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9528772234916687,
        -0.2737281024456024,
        0.130758598446846
      ],
      "plane_d": -2123.362548828125,
      "bbox_min": [
        -1411.0396728515625,
        -3531.997802734375,
        724.0
      ],
      "bbox_max": [
        -1137.0072021484375,
        -3091.116455078125,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9856189489364624,
        -0.10732632130384445,
        0.13052378594875336
      ],
      "plane_d": -1595.8048095703125,
      "bbox_min": [
        -1159.6761474609375,
        -3396.30615234375,
        724.0
      ],
      "bbox_max": [
        -1144.192626953125,
        -3338.47998046875,
        794.9396362304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4556112587451935,
        -0.8901628255844116,
        0.005325810518115759
      ],
      "plane_d": -2146.4755859375,
      "bbox_min": [
        -1411.0396728515625,
        -3531.997802734375,
        724.0
      ],
      "bbox_max": [
        -1143.0048828125,
        -3091.116455078125,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4523264467716217,
        -0.8918522596359253,
        0.0003948037629015744
      ],
      "plane_d": -2152.6083984375,
      "bbox_min": [
        -1403.4910888671875,
        -3125.1181640625,
        724.0
      ],
      "bbox_max": [
        -1367.9073486328125,
        -3107.087646484375,
        761.9190673828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7124058604240417,
        0.6995056867599487,
        0.05629853904247284
      ],
      "plane_d": 3319.36767578125,
      "bbox_min": [
        -1411.0396728515625,
        -3531.997802734375,
        732.121826171875
      ],
      "bbox_max": [
        -1143.0048828125,
        -3091.116455078125,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4557587504386902,
        -0.8900548815727234,
        -0.00928233191370964
      ],
      "plane_d": -2133.771484375,
      "bbox_min": [
        -1411.0396728515625,
        -3531.997802734375,
        732.121826171875
      ],
      "bbox_max": [
        -1143.0048828125,
        -3091.116455078125,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43772801756858826,
        -0.8991074562072754,
        0.0
      ],
      "plane_d": -2195.2607421875,
      "bbox_min": [
        -1411.0396728515625,
        -3128.560791015625,
        832.278564453125
      ],
      "bbox_max": [
        -1392.043212890625,
        -3119.3125,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4553416073322296,
        -0.8902986645698547,
        0.005685432814061642
      ],
      "plane_d": -2147.55224609375,
      "bbox_min": [
        -1403.4910888671875,
        -3531.997802734375,
        732.121826171875
      ],
      "bbox_max": [
        -1143.0048828125,
        -3091.116455078125,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4523264467716217,
        -0.8918522596359253,
        0.0003948037629015744
      ],
      "plane_d": -2152.6083984375,
      "bbox_min": [
        -1403.4910888671875,
        -3125.1181640625,
        732.121826171875
      ],
      "bbox_max": [
        -1367.96533203125,
        -3107.113525390625,
        761.9190673828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6140355467796326,
        0.7874341607093811,
        0.05392313003540039
      ],
      "plane_d": 3507.92138671875,
      "bbox_min": [
        -1384.1793212890625,
        -3531.997802734375,
        770.0
      ],
      "bbox_max": [
        -1143.0048828125,
        -3091.116455078125,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6207442283630371,
        0.782613217830658,
        0.046831756830215454
      ],
      "plane_d": 3505.248779296875,
      "bbox_min": [
        -1258.8291015625,
        -3530.838623046875,
        831.288330078125
      ],
      "bbox_max": [
        -1258.0595703125,
        -3530.23779296875,
        833.2398071289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -780.0,
      "bbox_min": [
        -1384.1793212890625,
        -3374.0,
        770.0
      ],
      "bbox_max": [
        -1143.0048828125,
        -3091.116455078125,
        878.1983032226562
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 770.0,
      "bbox_min": [
        -1377.7938232421875,
        -3147.320556640625,
        770.0
      ],
      "bbox_max": [
        -1314.019287109375,
        -3091.116455078125,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11668606102466583,
        -0.20210716128349304,
        -0.9723873138427734
      ],
      "plane_d": 276.85693359375,
      "bbox_min": [
        -1377.7938232421875,
        -3147.320556640625,
        770.0
      ],
      "bbox_max": [
        -1314.019287109375,
        -3091.116455078125,
        780.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8660253882408142,
        -0.5,
        -0.0
      ],
      "plane_d": -2749.13427734375,
      "bbox_min": [
        -1377.7938232421875,
        -3147.320556640625,
        770.0
      ],
      "bbox_max": [
        -1314.019287109375,
        -3091.116455078125,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660235404968262,
        0.5000033378601074,
        -2.6594350401865086e-06
      ],
      "plane_d": 2699.14404296875,
      "bbox_min": [
        -1357.320556640625,
        -3147.320556640625,
        770.0
      ],
      "bbox_max": [
        -1314.019287109375,
        -3091.116455078125,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660253882408142,
        -0.5,
        -0.0
      ],
      "plane_d": -2716.63427734375,
      "bbox_min": [
        -1357.320556640625,
        -3147.320556640625,
        770.0
      ],
      "bbox_max": [
        -1314.019287109375,
        -3109.419921875,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000012516975403,
        -0.8660247921943665,
        0.0
      ],
      "plane_d": -2046.995849609375,
      "bbox_min": [
        -1329.1746826171875,
        -3131.070556640625,
        776.0
      ],
      "bbox_max": [
        -1314.019287109375,
        -3122.320556640625,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": 2731.64453125,
      "bbox_min": [
        -1357.320556640625,
        -3147.320556640625,
        770.0
      ],
      "bbox_max": [
        -1341.6746826171875,
        -3109.419921875,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49999821186065674,
        -0.8660264611244202,
        0.0
      ],
      "plane_d": -2047.0050048828125,
      "bbox_min": [
        -1357.320556640625,
        -3147.320556640625,
        776.0
      ],
      "bbox_max": [
        -1342.1650390625,
        -3138.570556640625,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000007748603821,
        -0.8660250902175903,
        0.0
      ],
      "plane_d": -2021.997314453125,
      "bbox_min": [
        -1354.6650390625,
        -3116.919921875,
        770.0
      ],
      "bbox_max": [
        -1341.6746826171875,
        -3109.419921875,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3315.0,
      "bbox_min": [
        -1384.1793212890625,
        -3374.0,
        780.0
      ],
      "bbox_max": [
        -1143.0048828125,
        -3109.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3323.0,
      "bbox_min": [
        -1351.4095458984375,
        -3374.0,
        860.0
      ],
      "bbox_max": [
        -1143.0048828125,
        -3315.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9138116240501404,
        0.0,
        -0.40613850951194763
      ],
      "plane_d": 1570.1314697265625,
      "bbox_min": [
        -1336.0,
        -3323.0,
        860.0
      ],
      "bbox_max": [
        -1332.0,
        -3315.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.950871467590332,
        -0.0,
        0.3095860481262207
      ],
      "plane_d": 997.530517578125,
      "bbox_min": [
        -1334.9947509765625,
        -3323.0,
        869.0
      ],
      "bbox_max": [
        -1332.0,
        -3315.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3374.0,
      "bbox_min": [
        -1335.8358154296875,
        -3374.0,
        860.0
      ],
      "bbox_max": [
        -1143.0048828125,
        -3366.0,
        878.1983032226562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.950871467590332,
        0.0,
        0.3095860481262207
      ],
      "plane_d": -1362.532470703125,
      "bbox_min": [
        -1150.0,
        -3374.0,
        860.0
      ],
      "bbox_max": [
        -1144.144775390625,
        -3366.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 860.0,
      "bbox_min": [
        -1146.0,
        -3374.0,
        860.0
      ],
      "bbox_max": [
        -1144.144775390625,
        -3366.0,
        860.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.950871467590332,
        -0.0,
        0.3095860481262207
      ],
      "plane_d": 997.530517578125,
      "bbox_min": [
        -1334.9947509765625,
        -3374.0,
        862.7809448242188
      ],
      "bbox_max": [
        -1332.0,
        -3366.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9138116240501404,
        0.0,
        -0.40613850951194763
      ],
      "plane_d": 1570.1314697265625,
      "bbox_min": [
        -1334.7640380859375,
        -3374.0,
        862.7809448242188
      ],
      "bbox_max": [
        -1332.0,
        -3366.0,
        869.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6437028050422668,
        0.3716461658477783,
        0.6689738035202026
      ],
      "plane_d": 1483.693115234375,
      "bbox_min": [
        -1384.1793212890625,
        -3141.070556640625,
        780.0
      ],
      "bbox_max": [
        -1324.8446044921875,
        -3109.0,
        808.8885498046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5,
        0.866025447845459,
        0.0
      ],
      "plane_d": 2041.99951171875,
      "bbox_min": [
        -1384.1793212890625,
        -3141.070556640625,
        780.0
      ],
      "bbox_max": [
        -1324.8446044921875,
        -3109.0,
        808.8885498046875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.6437028050422668,
        -0.3716461658477783,
        0.6689738035202026
      ],
      "plane_d": -2565.94384765625,
      "bbox_min": [
        -1348.9952392578125,
        -3141.070556640625,
        780.0
      ],
      "bbox_max": [
        -1324.8446044921875,
        -3124.240478515625,
        808.8885498046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49999716877937317,
        -0.8660269975662231,
        0.0
      ],
      "plane_d": -2047.008056640625,
      "bbox_min": [
        -1348.9952392578125,
        -3141.070556640625,
        780.0
      ],
      "bbox_max": [
        -1324.8446044921875,
        -3124.240478515625,
        808.8885498046875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": -2736.64453125,
      "bbox_min": [
        -1348.9952392578125,
        -3141.070556640625,
        780.0
      ],
      "bbox_max": [
        -1324.8446044921875,
        -3124.240478515625,
        800.8885498046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": 2711.64453125,
      "bbox_min": [
        -1344.6650390625,
        -3138.570556640625,
        780.0
      ],
      "bbox_max": [
        -1324.8446044921875,
        -3124.240478515625,
        800.8885498046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        0.500004231929779,
        -0.0
      ],
      "plane_d": 2731.64453125,
      "bbox_min": [
        -1344.6650390625,
        -3138.570556640625,
        780.0
      ],
      "bbox_max": [
        -1329.1746826171875,
        -3126.740478515625,
        800.8885498046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": -2716.64453125,
      "bbox_min": [
        -1344.6650390625,
        -3138.570556640625,
        780.0
      ],
      "bbox_max": [
        -1329.1746826171875,
        -3126.740478515625,
        800.8885498046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6276309490203857,
        -0.3623669743537903,
        -0.6890352964401245
      ],
      "plane_d": -1422.422607421875,
      "bbox_min": [
        -1344.6650390625,
        -3138.570556640625,
        793.0
      ],
      "bbox_max": [
        -1329.1746826171875,
        -3126.740478515625,
        800.8885498046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6276351809501648,
        0.3623694181442261,
        -0.6890302300453186
      ],
      "plane_d": 2526.113037109375,
      "bbox_min": [
        -1344.6650390625,
        -3138.570556640625,
        793.0
      ],
      "bbox_max": [
        -1335.669921875,
        -3130.490478515625,
        800.8885498046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4522756338119507,
        -0.8918243050575256,
        0.009807907976210117
      ],
      "plane_d": -2159.764404296875,
      "bbox_min": [
        -1384.1793212890625,
        -3115.125732421875,
        780.0
      ],
      "bbox_max": [
        -1372.2021484375,
        -3109.0,
        790.2847290039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.455353319644928,
        -0.8903108239173889,
        0.0003015612019225955
      ],
      "plane_d": -2143.375,
      "bbox_min": [
        -1384.1793212890625,
        -3115.125732421875,
        780.0
      ],
      "bbox_max": [
        -1372.2021484375,
        -3109.0,
        784.842529296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4469253122806549,
        0.8841609358787537,
        0.13607771694660187
      ],
      "plane_d": 3523.403076171875,
      "bbox_min": [
        -1595.0,
        -3540.2158203125,
        878.1983032226562
      ],
      "bbox_max": [
        -1105.0,
        -3362.948486328125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7247740030288696,
        0.6881459951400757,
        0.034025806933641434
      ],
      "plane_d": 3317.09765625,
      "bbox_min": [
        -1595.0,
        -3540.2158203125,
        878.1983032226562
      ],
      "bbox_max": [
        -1260.6123046875,
        -3398.449462890625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3426.5,
      "bbox_min": [
        -1595.0,
        -3426.5,
        892.0
      ],
      "bbox_max": [
        -1455.3385009765625,
        -3398.449462890625,
        1115.2313232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -892.0,
      "bbox_min": [
        -1595.0,
        -3426.5,
        892.0
      ],
      "bbox_max": [
        -1455.3385009765625,
        -3398.449462890625,
        1115.2313232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01903552934527397,
        0.9815307855606079,
        -0.19035546481609344
      ],
      "plane_d": 3524.079833984375,
      "bbox_min": [
        -1595.0,
        -3419.54296875,
        989.502685546875
      ],
      "bbox_max": [
        -1515.6566162109375,
        -3398.449462890625,
        1115.2313232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.038227956742048264,
        0.9232555031776428,
        0.3822798430919647
      ],
      "plane_d": 2820.343505859375,
      "bbox_min": [
        -1595.0,
        -3419.54296875,
        989.502685546875
      ],
      "bbox_max": [
        -1515.6566162109375,
        -3398.449462890625,
        1040.4466552734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7219356298446655,
        0.69008469581604,
        0.05091238394379616
      ],
      "plane_d": 3303.51171875,
      "bbox_min": [
        -1338.7542724609375,
        -3535.07177734375,
        878.1983032226562
      ],
      "bbox_max": [
        -1260.6123046875,
        -3454.531982421875,
        997.4153442382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7124058604240417,
        0.6995056867599487,
        0.05629853904247284
      ],
      "plane_d": 3319.36767578125,
      "bbox_min": [
        -1338.7542724609375,
        -3535.07177734375,
        878.1983032226562
      ],
      "bbox_max": [
        -1260.6123046875,
        -3454.531982421875,
        997.4153442382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6140355467796326,
        0.7874341607093811,
        0.05392313003540039
      ],
      "plane_d": 3507.92138671875,
      "bbox_min": [
        -1338.7542724609375,
        -3535.07177734375,
        878.1983032226562
      ],
      "bbox_max": [
        -1260.6123046875,
        -3454.531982421875,
        997.4153442382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9832573533058167,
        0.1745198667049408,
        0.052420713007450104
      ],
      "plane_d": 1868.7430419921875,
      "bbox_min": [
        -1338.7542724609375,
        -3458.6162109375,
        878.1983032226562
      ],
      "bbox_max": [
        -1333.894287109375,
        -3454.531982421875,
        976.6000366210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8500498533248901,
        0.5251100659370422,
        0.04092385247349739
      ],
      "plane_d": 3041.765869140625,
      "bbox_min": [
        -1595.0,
        -3458.6162109375,
        878.1983032226562
      ],
      "bbox_max": [
        -1334.2330322265625,
        -3362.948486328125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.056889183819293976,
        0.9831775426864624,
        -0.17356735467910767
      ],
      "plane_d": 3449.109619140625,
      "bbox_min": [
        -1595.0,
        -3388.281494140625,
        1201.640625
      ],
      "bbox_max": [
        -1576.020751953125,
        -3375.162109375,
        1275.9561767578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.038227956742048264,
        0.9232555031776428,
        0.3822798430919647
      ],
      "plane_d": 2820.343505859375,
      "bbox_min": [
        -1595.0,
        -3419.54296875,
        892.0
      ],
      "bbox_max": [
        -1513.0611572265625,
        -3394.36962890625,
        1032.5123291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -892.0,
      "bbox_min": [
        -1518.510986328125,
        -3412.7939453125,
        892.0
      ],
      "bbox_max": [
        -1513.0611572265625,
        -3411.5,
        892.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22641703486442566,
        -0.020128117874264717,
        0.9738224148750305
      ],
      "plane_d": -595.3028564453125,
      "bbox_min": [
        -1595.0,
        -3368.02783203125,
        900.3103637695312
      ],
      "bbox_max": [
        -1542.261474609375,
        -3362.948486328125,
        912.6388549804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3184397518634796,
        0.8545204997062683,
        0.4103544354438782
      ],
      "plane_d": 2981.018798828125,
      "bbox_min": [
        -1544.2786865234375,
        -3458.6162109375,
        878.1983032226562
      ],
      "bbox_max": [
        -1334.2330322265625,
        -3362.948486328125,
        1032.5123291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -892.0,
      "bbox_min": [
        -1513.8604736328125,
        -3426.5,
        878.1983032226562
      ],
      "bbox_max": [
        -1380.0,
        -3409.98583984375,
        915.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1380.0,
      "bbox_min": [
        -1380.0,
        -3426.5,
        892.0
      ],
      "bbox_max": [
        -1380.0,
        -3424.746826171875,
        903.3905639648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22641703486442566,
        -0.020128117874264717,
        0.9738224148750305
      ],
      "plane_d": -595.3028564453125,
      "bbox_min": [
        -1544.2786865234375,
        -3366.172119140625,
        890.1369018554688
      ],
      "bbox_max": [
        -1498.367919921875,
        -3362.948486328125,
        900.8460083007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9945406317710876,
        -0.05085870251059532,
        0.09111718833446503
      ],
      "plane_d": -1379.3016357421875,
      "bbox_min": [
        -1595.0,
        -3480.0439453125,
        878.1983032226562
      ],
      "bbox_max": [
        -1105.0,
        -3362.948486328125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1126.0,
      "bbox_min": [
        -1134.2847900390625,
        -3374.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1126.0,
        -3366.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3366.0,
      "bbox_min": [
        -1134.2847900390625,
        -3374.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1126.0,
        -3366.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -912.0,
      "bbox_min": [
        -1130.744384765625,
        -3374.0,
        912.0
      ],
      "bbox_max": [
        -1126.0,
        -3369.847900390625,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3366.0,
      "bbox_min": [
        -1134.17333984375,
        -3374.0,
        879.4154052734375
      ],
      "bbox_max": [
        -1126.0,
        -3366.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -912.0,
      "bbox_min": [
        -1131.1878662109375,
        -3374.0,
        911.8829956054688
      ],
      "bbox_max": [
        -1126.0,
        -3366.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3374.0,
      "bbox_min": [
        -1130.78955078125,
        -3374.0,
        911.8829956054688
      ],
      "bbox_max": [
        -1130.744384765625,
        -3374.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9931049346923828,
        0.0022958379704505205,
        0.11720679700374603
      ],
      "plane_d": -1221.6827392578125,
      "bbox_min": [
        -1595.0,
        -3476.598876953125,
        878.1983032226562
      ],
      "bbox_max": [
        -1108.1988525390625,
        -3362.948486328125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3374.0,
      "bbox_min": [
        -1134.3193359375,
        -3374.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1132.3359375,
        -3366.0,
        895.0037231445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3184397518634796,
        0.8545204997062683,
        0.4103544354438782
      ],
      "plane_d": 2981.018798828125,
      "bbox_min": [
        -1595.0,
        -3458.6162109375,
        878.1983032226562
      ],
      "bbox_max": [
        -1130.77880859375,
        -3362.948486328125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05185391753911972,
        0.9296181201934814,
        0.36485806107521057
      ],
      "plane_d": 2880.741455078125,
      "bbox_min": [
        -1501.9542236328125,
        -3426.5,
        878.1983032226562
      ],
      "bbox_max": [
        -1370.0,
        -3362.948486328125,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -894.0,
      "bbox_min": [
        -1406.20703125,
        -3426.5,
        878.1983032226562
      ],
      "bbox_max": [
        -1370.0,
        -3386.67529296875,
        918.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1405.0,
      "bbox_min": [
        -1406.20703125,
        -3425.0546875,
        878.1983032226562
      ],
      "bbox_max": [
        -1370.0,
        -3386.67529296875,
        894.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1370.0,
      "bbox_min": [
        -1405.0,
        -3425.0546875,
        878.1983032226562
      ],
      "bbox_max": [
        -1370.0,
        -3399.71826171875,
        894.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -892.0,
      "bbox_min": [
        -1405.0,
        -3425.0546875,
        892.0
      ],
      "bbox_max": [
        -1380.0,
        -3411.5,
        894.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -892.0,
      "bbox_min": [
        -1406.20703125,
        -3412.110107421875,
        892.0
      ],
      "bbox_max": [
        -1405.0,
        -3411.5,
        892.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1401.5,
      "bbox_min": [
        -1401.5,
        -3426.5,
        894.0
      ],
      "bbox_max": [
        -1373.0,
        -3395.56787109375,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1399.5,
      "bbox_min": [
        -1401.5,
        -3426.5,
        894.0
      ],
      "bbox_max": [
        -1373.0,
        -3396.313232421875,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6585046052932739,
        0.0,
        0.7525767087936401
      ],
      "plane_d": -1611.501953125,
      "bbox_min": [
        -1401.5,
        -3410.0,
        915.0
      ],
      "bbox_max": [
        -1399.5,
        -3405.65234375,
        916.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 3409.999755859375,
      "bbox_min": [
        -1399.5,
        -3426.5,
        894.0
      ],
      "bbox_max": [
        -1373.0,
        -3396.5,
        918.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1380.0,
      "bbox_min": [
        -1392.5,
        -3426.5,
        894.0
      ],
      "bbox_max": [
        -1380.0,
        -3410.0,
        915.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1382.0,
      "bbox_min": [
        -1392.5,
        -3426.5,
        894.0
      ],
      "bbox_max": [
        -1380.0,
        -3410.0,
        915.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3426.5,
      "bbox_min": [
        -1382.0,
        -3426.5,
        903.3905639648438
      ],
      "bbox_max": [
        -1380.0,
        -3426.5,
        915.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 908.0,
      "bbox_min": [
        -1392.5,
        -3426.5,
        908.0
      ],
      "bbox_max": [
        -1382.0,
        -3410.0,
        915.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3426.5,
      "bbox_min": [
        -1383.534912109375,
        -3426.5,
        909.958984375
      ],
      "bbox_max": [
        -1382.0,
        -3426.5,
        915.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1375.0,
      "bbox_min": [
        -1399.5,
        -3410.0,
        894.0
      ],
      "bbox_max": [
        -1373.0,
        -3396.5,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1373.0,
      "bbox_min": [
        -1373.0,
        -3410.0,
        894.0
      ],
      "bbox_max": [
        -1373.0,
        -3406.188720703125,
        901.9366455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547001957893372,
        -0.0,
        0.8320503234863281
      ],
      "plane_d": 19.96917724609375,
      "bbox_min": [
        -1399.5,
        -3410.0,
        894.0
      ],
      "bbox_max": [
        -1392.410888671875,
        -3396.5,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1396.5,
      "bbox_min": [
        -1399.5,
        -3410.0,
        894.0
      ],
      "bbox_max": [
        -1396.5,
        -3396.5,
        907.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3403.0,
      "bbox_min": [
        -1399.5,
        -3408.5,
        894.0
      ],
      "bbox_max": [
        -1396.5,
        -3396.5,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3408.5,
      "bbox_min": [
        -1399.0,
        -3408.5,
        895.0
      ],
      "bbox_max": [
        -1396.5,
        -3404.0,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 905.0,
      "bbox_min": [
        -1399.0,
        -3408.5,
        895.0
      ],
      "bbox_max": [
        -1396.5,
        -3404.0,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -895.0,
      "bbox_min": [
        -1399.0,
        -3408.5,
        895.0
      ],
      "bbox_max": [
        -1396.5,
        -3404.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -895.0,
      "bbox_min": [
        -1399.5,
        -3403.0,
        894.0
      ],
      "bbox_max": [
        -1396.5,
        -3396.5,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3396.5,
      "bbox_min": [
        -1399.5,
        -3396.5,
        894.0
      ],
      "bbox_max": [
        -1398.99853515625,
        -3396.5,
        894.3890991210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 905.0,
      "bbox_min": [
        -1399.0,
        -3403.0,
        905.0
      ],
      "bbox_max": [
        -1396.5,
        -3401.78173828125,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6585046052932739,
        0.0,
        0.7525767087936401
      ],
      "plane_d": -1611.501953125,
      "bbox_min": [
        -1399.5,
        -3410.0,
        915.0
      ],
      "bbox_max": [
        -1392.410888671875,
        -3406.397705078125,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -918.5,
      "bbox_min": [
        -1397.5,
        -3410.0,
        918.5
      ],
      "bbox_max": [
        -1394.3436279296875,
        -3408.82373046875,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": 1636.5987548828125,
      "bbox_min": [
        -1399.5,
        -3410.0,
        915.0
      ],
      "bbox_max": [
        -1397.5,
        -3406.397705078125,
        917.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22641703486442566,
        -0.020128117874264717,
        0.9738224148750305
      ],
      "plane_d": -595.3028564453125,
      "bbox_min": [
        -1501.9542236328125,
        -3364.627685546875,
        884.6555786132812
      ],
      "bbox_max": [
        -1474.71875,
        -3362.948486328125,
        891.0054321289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.046494390815496445,
        0.7289436459541321,
        0.6829929947853088
      ],
      "plane_d": 1916.369873046875,
      "bbox_min": [
        -1595.0,
        -3458.6162109375,
        878.1983032226562
      ],
      "bbox_max": [
        -1130.77880859375,
        -3362.948486328125,
        1302.5999755859375
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.9832573533058167,
        0.1745198667049408,
        0.052420713007450104
      ],
      "plane_d": 1868.7430419921875,
      "bbox_min": [
        -1405.0,
        -3458.6162109375,
        878.1983032226562
      ],
      "bbox_max": [
        -1334.9947509765625,
        -3365.699951171875,
        976.6000366210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1370.0,
      "bbox_min": [
        -1405.0,
        -3413.664306640625,
        878.1983032226562
      ],
      "bbox_max": [
        -1348.526611328125,
        -3368.0,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -894.0,
      "bbox_min": [
        -1405.0,
        -3413.664306640625,
        878.1983032226562
      ],
      "bbox_max": [
        -1370.0,
        -3368.0,
        918.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1405.0,
      "bbox_min": [
        -1405.0,
        -3394.263671875,
        878.1983032226562
      ],
      "bbox_max": [
        -1405.0,
        -3368.0,
        894.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6585046052932739,
        -0.0,
        0.7525767087936401
      ],
      "plane_d": 215.5191650390625,
      "bbox_min": [
        -1375.0,
        -3410.0,
        915.0
      ],
      "bbox_max": [
        -1373.0,
        -3398.715087890625,
        916.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6585046052932739,
        0.0,
        0.7525767087936401
      ],
      "plane_d": -1611.501953125,
      "bbox_min": [
        -1401.5,
        -3407.238037109375,
        915.0
      ],
      "bbox_max": [
        -1399.5,
        -3396.897216796875,
        916.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 915.0,
      "bbox_min": [
        -1399.5,
        -3413.664306640625,
        894.0
      ],
      "bbox_max": [
        -1375.0,
        -3385.0,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -918.5,
      "bbox_min": [
        -1399.5,
        -3410.0,
        915.0
      ],
      "bbox_max": [
        -1375.0,
        -3397.0244140625,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 917.0,
      "bbox_min": [
        -1399.5,
        -3410.0,
        915.0
      ],
      "bbox_max": [
        -1375.0,
        -3397.0244140625,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6585046052932739,
        -0.0,
        0.7525767087936401
      ],
      "plane_d": 215.5191650390625,
      "bbox_min": [
        -1399.2142333984375,
        -3410.0,
        917.0
      ],
      "bbox_max": [
        -1375.2857666015625,
        -3398.9169921875,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6585046052932739,
        0.0,
        0.7525767087936401
      ],
      "plane_d": -1611.501953125,
      "bbox_min": [
        -1399.2142333984375,
        -3408.82373046875,
        917.0
      ],
      "bbox_max": [
        -1397.5,
        -3398.9169921875,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 3401.499755859375,
      "bbox_min": [
        -1399.5,
        -3410.0,
        915.0
      ],
      "bbox_max": [
        -1375.0,
        -3397.0244140625,
        917.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 3409.999755859375,
      "bbox_min": [
        -1399.5,
        -3410.0,
        915.0
      ],
      "bbox_max": [
        -1375.0,
        -3401.5,
        917.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.0,
        -0.7071068286895752
      ],
      "plane_d": -325.2691650390625,
      "bbox_min": [
        -1399.5,
        -3410.0,
        915.0
      ],
      "bbox_max": [
        -1375.0,
        -3401.5,
        917.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6585046052932739,
        -0.0,
        0.7525767087936401
      ],
      "plane_d": 215.5191650390625,
      "bbox_min": [
        -1375.2857666015625,
        -3410.0,
        916.75
      ],
      "bbox_max": [
        -1375.0,
        -3401.5,
        917.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": 1636.5987548828125,
      "bbox_min": [
        -1399.5,
        -3408.103515625,
        915.0
      ],
      "bbox_max": [
        -1397.5,
        -3401.5,
        917.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6585046052932739,
        0.0,
        0.7525767087936401
      ],
      "plane_d": -1611.501953125,
      "bbox_min": [
        -1399.5,
        -3407.464599609375,
        916.75
      ],
      "bbox_max": [
        -1399.2142333984375,
        -3401.5,
        917.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": 1636.5987548828125,
      "bbox_min": [
        -1399.5,
        -3401.5,
        915.0
      ],
      "bbox_max": [
        -1375.0,
        -3397.0244140625,
        917.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6585046052932739,
        0.0,
        0.7525767087936401
      ],
      "plane_d": -1611.501953125,
      "bbox_min": [
        -1399.5,
        -3401.5,
        916.75
      ],
      "bbox_max": [
        -1399.2142333984375,
        -3398.66455078125,
        917.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.0,
        -0.7071068286895752
      ],
      "plane_d": -325.2691650390625,
      "bbox_min": [
        -1377.0,
        -3401.5,
        915.0
      ],
      "bbox_max": [
        -1375.0,
        -3398.58740234375,
        917.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6585046052932739,
        -0.0,
        0.7525767087936401
      ],
      "plane_d": 215.5191650390625,
      "bbox_min": [
        -1375.2857666015625,
        -3401.5,
        916.75
      ],
      "bbox_max": [
        -1375.0,
        -3400.22705078125,
        917.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        -0.0
      ],
      "plane_d": 3409.999755859375,
      "bbox_min": [
        -1399.5,
        -3413.664306640625,
        894.0
      ],
      "bbox_max": [
        -1375.0,
        -3385.0,
        915.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1380.0,
      "bbox_min": [
        -1380.0,
        -3413.664306640625,
        910.4931640625
      ],
      "bbox_max": [
        -1380.0,
        -3411.5,
        915.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9615239500999451,
        -0.0,
        -0.2747211158275604
      ],
      "plane_d": -1074.57177734375,
      "bbox_min": [
        -1399.5,
        -3403.674072265625,
        894.0
      ],
      "bbox_max": [
        -1375.0,
        -3385.0,
        915.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 904.5,
      "bbox_min": [
        -1376.0,
        -3398.5,
        904.5
      ],
      "bbox_max": [
        -1375.0,
        -3388.685546875,
        904.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6000000238418579,
        0.0,
        0.800000011920929
      ],
      "plane_d": -1545.2000732421875,
      "bbox_min": [
        -1399.5,
        -3403.674072265625,
        894.0
      ],
      "bbox_max": [
        -1375.0,
        -3385.0,
        909.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1379.0,
      "bbox_min": [
        -1379.5999755859375,
        -3397.0,
        894.0
      ],
      "bbox_max": [
        -1375.0,
        -3385.0,
        899.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3385.0,
      "bbox_min": [
        -1379.0,
        -3385.0,
        894.0
      ],
      "bbox_max": [
        -1375.0,
        -3385.0,
        899.7999877929688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3396.5,
      "bbox_min": [
        -1399.5,
        -3403.674072265625,
        894.0
      ],
      "bbox_max": [
        -1396.5,
        -3396.5,
        909.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1396.5,
      "bbox_min": [
        -1399.5,
        -3403.674072265625,
        894.0
      ],
      "bbox_max": [
        -1396.5,
        -3396.5,
        909.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.5547001957893372,
        -0.0,
        0.8320503234863281
      ],
      "plane_d": 19.96917724609375,
      "bbox_min": [
        -1399.5,
        -3403.674072265625,
        905.0
      ],
      "bbox_max": [
        -1396.5,
        -3396.5,
        909.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 905.0,
      "bbox_min": [
        -1399.0,
        -3402.71337890625,
        905.0
      ],
      "bbox_max": [
        -1396.5,
        -3398.5,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3374.0,
      "bbox_min": [
        -1356.0,
        -3374.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1348.526611328125,
        -3368.0,
        887.4649658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1356.0,
      "bbox_min": [
        -1356.0,
        -3374.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1356.0,
        -3368.0,
        887.4649658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3366.0,
      "bbox_min": [
        -1356.0,
        -3368.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1349.9466552734375,
        -3366.0,
        881.0613403320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1356.0,
      "bbox_min": [
        -1356.0,
        -3368.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1356.0,
        -3366.0,
        881.0613403320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3374.0,
      "bbox_min": [
        -1349.9635009765625,
        -3374.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1334.9947509765625,
        -3366.0,
        886.9880981445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.950871467590332,
        -0.0,
        0.3095860481262207
      ],
      "plane_d": 997.530517578125,
      "bbox_min": [
        -1349.9635009765625,
        -3374.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1334.9947509765625,
        -3366.0,
        886.212646484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3366.0,
      "bbox_min": [
        -1349.9635009765625,
        -3366.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1345.2991943359375,
        -3366.0,
        878.515869140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05163498595356941,
        -0.004590269178152084,
        0.9986554980278015
      ],
      "plane_d": -822.7598266601562,
      "bbox_min": [
        -1595.0,
        -3409.7333984375,
        878.1983032226562
      ],
      "bbox_max": [
        -1130.77880859375,
        -3362.948486328125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05333402752876282,
        0.0,
        0.9985767602920532
      ],
      "plane_d": -804.9474487304688,
      "bbox_min": [
        -1357.415283203125,
        -3365.699951171875,
        878.1983032226562
      ],
      "bbox_max": [
        -1350.0,
        -3362.948486328125,
        878.5943603515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8500498533248901,
        0.5251100659370422,
        0.04092385247349739
      ],
      "plane_d": 3041.765869140625,
      "bbox_min": [
        -1595.0,
        -3409.7333984375,
        878.1983032226562
      ],
      "bbox_max": [
        -1130.77880859375,
        -3362.948486328125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.056889183819293976,
        0.9831775426864624,
        -0.17356735467910767
      ],
      "plane_d": 3449.109619140625,
      "bbox_min": [
        -1595.0,
        -3379.77587890625,
        1243.6004638671875
      ],
      "bbox_max": [
        -1557.488037109375,
        -3368.8896484375,
        1301.6318359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39672571420669556,
        0.18136583268642426,
        -0.8998417854309082
      ],
      "plane_d": 1149.486572265625,
      "bbox_min": [
        -1595.0,
        -3371.47021484375,
        1284.5732421875
      ],
      "bbox_max": [
        -1557.488037109375,
        -3368.8896484375,
        1301.6318359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39672571420669556,
        0.18136583268642426,
        -0.8998417854309082
      ],
      "plane_d": 1149.486572265625,
      "bbox_min": [
        -1595.0,
        -3371.47021484375,
        1284.5732421875
      ],
      "bbox_max": [
        -1557.488037109375,
        -3362.948486328125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.950871467590332,
        0.0,
        0.3095860481262207
      ],
      "plane_d": -1362.532470703125,
      "bbox_min": [
        -1562.950927734375,
        -3401.7392578125,
        878.1983032226562
      ],
      "bbox_max": [
        -1130.77880859375,
        -3362.948486328125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3366.0,
      "bbox_min": [
        -1147.0052490234375,
        -3374.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1130.77880859375,
        -3366.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3374.0,
      "bbox_min": [
        -1147.0052490234375,
        -3374.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1130.77880859375,
        -3366.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -912.0,
      "bbox_min": [
        -1136.0,
        -3374.0,
        912.0
      ],
      "bbox_max": [
        -1130.77880859375,
        -3366.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3366.0,
      "bbox_min": [
        -1562.950927734375,
        -3401.7392578125,
        878.1983032226562
      ],
      "bbox_max": [
        -1334.9947509765625,
        -3362.948486328125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3368.0,
      "bbox_min": [
        -1405.0,
        -3401.7392578125,
        878.1983032226562
      ],
      "bbox_max": [
        -1334.9947509765625,
        -3366.0,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.950871467590332,
        -0.0,
        0.3095860481262207
      ],
      "plane_d": 997.530517578125,
      "bbox_min": [
        -1405.0,
        -3401.7392578125,
        879.6638793945312
      ],
      "bbox_max": [
        -1335.471923828125,
        -3368.0,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -894.0,
      "bbox_min": [
        -1405.0,
        -3401.7392578125,
        881.0613403320312
      ],
      "bbox_max": [
        -1337.6041259765625,
        -3368.0,
        918.5
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1370.0,
      "bbox_min": [
        -1405.0,
        -3379.22998046875,
        881.0613403320312
      ],
      "bbox_max": [
        -1337.6041259765625,
        -3368.0,
        894.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1405.0,
      "bbox_min": [
        -1405.0,
        -3376.99755859375,
        884.3970947265625
      ],
      "bbox_max": [
        -1405.0,
        -3368.0,
        894.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3374.0,
      "bbox_min": [
        -1356.0,
        -3374.0,
        881.0613403320312
      ],
      "bbox_max": [
        -1337.6041259765625,
        -3368.0,
        894.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1356.0,
      "bbox_min": [
        -1356.0,
        -3374.0,
        881.0613403320312
      ],
      "bbox_max": [
        -1356.0,
        -3368.0,
        894.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1373.0,
      "bbox_min": [
        -1401.5,
        -3401.7392578125,
        894.0
      ],
      "bbox_max": [
        -1340.1395263671875,
        -3368.0,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1401.5,
      "bbox_min": [
        -1401.5,
        -3401.7392578125,
        894.0
      ],
      "bbox_max": [
        -1373.0,
        -3374.5,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 917.0,
      "bbox_min": [
        -1401.5,
        -3401.7392578125,
        894.0
      ],
      "bbox_max": [
        -1373.0,
        -3374.5,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6585046052932739,
        -0.0,
        0.7525767087936401
      ],
      "plane_d": 215.5191650390625,
      "bbox_min": [
        -1399.2142333984375,
        -3401.7392578125,
        917.0
      ],
      "bbox_max": [
        -1375.2857666015625,
        -3374.5,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6585046052932739,
        0.0,
        0.7525767087936401
      ],
      "plane_d": -1611.501953125,
      "bbox_min": [
        -1399.2142333984375,
        -3400.431640625,
        917.0
      ],
      "bbox_max": [
        -1375.2857666015625,
        -3374.5,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3374.5,
      "bbox_min": [
        -1399.2142333984375,
        -3374.5,
        917.0
      ],
      "bbox_max": [
        -1375.2857666015625,
        -3374.5,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3374.5,
      "bbox_min": [
        -1401.5,
        -3400.443115234375,
        894.0
      ],
      "bbox_max": [
        -1373.0,
        -3374.5,
        917.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1375.0,
      "bbox_min": [
        -1401.5,
        -3400.443115234375,
        894.0
      ],
      "bbox_max": [
        -1373.0,
        -3374.5,
        917.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1399.5,
      "bbox_min": [
        -1401.5,
        -3400.443115234375,
        894.0
      ],
      "bbox_max": [
        -1375.0,
        -3374.5,
        917.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6585046052932739,
        0.0,
        0.7525767087936401
      ],
      "plane_d": -1611.501953125,
      "bbox_min": [
        -1401.5,
        -3398.66455078125,
        915.0
      ],
      "bbox_max": [
        -1399.5,
        -3374.5,
        916.7499389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6585046052932739,
        -0.0,
        0.7525767087936401
      ],
      "plane_d": 215.5191650390625,
      "bbox_min": [
        -1399.5,
        -3400.443115234375,
        894.0
      ],
      "bbox_max": [
        -1375.0,
        -3374.5,
        917.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 915.0,
      "bbox_min": [
        -1399.5,
        -3400.333740234375,
        894.0
      ],
      "bbox_max": [
        -1375.0,
        -3374.5,
        917.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6585046052932739,
        0.0,
        0.7525767087936401
      ],
      "plane_d": -1611.501953125,
      "bbox_min": [
        -1399.5,
        -3400.333740234375,
        915.0
      ],
      "bbox_max": [
        -1375.0,
        -3374.5,
        917.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.0,
        -0.7071068286895752
      ],
      "plane_d": -325.2691650390625,
      "bbox_min": [
        -1399.5,
        -3400.333740234375,
        915.0
      ],
      "bbox_max": [
        -1375.0,
        -3376.0,
        917.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -3375.999755859375,
      "bbox_min": [
        -1399.5,
        -3399.026123046875,
        915.0
      ],
      "bbox_max": [
        -1375.0,
        -3376.0,
        917.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": 1636.5987548828125,
      "bbox_min": [
        -1399.5,
        -3399.026123046875,
        915.0
      ],
      "bbox_max": [
        -1375.0,
        -3376.0,
        917.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 3391.499755859375,
      "bbox_min": [
        -1399.5,
        -3391.5,
        915.0
      ],
      "bbox_max": [
        -1375.0,
        -3381.5,
        917.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 3381.499755859375,
      "bbox_min": [
        -1399.5,
        -3381.5,
        915.0
      ],
      "bbox_max": [
        -1375.0,
        -3381.5,
        917.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3376.0,
      "bbox_min": [
        -1399.5,
        -3398.332275390625,
        894.0
      ],
      "bbox_max": [
        -1375.0,
        -3374.5,
        915.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1385.0,
      "bbox_min": [
        -1395.0,
        -3376.0,
        894.0
      ],
      "bbox_max": [
        -1385.0,
        -3374.5,
        908.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1395.0,
      "bbox_min": [
        -1395.0,
        -3376.0,
        894.0
      ],
      "bbox_max": [
        -1385.0,
        -3374.5,
        908.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 908.0,
      "bbox_min": [
        -1395.0,
        -3376.0,
        908.0
      ],
      "bbox_max": [
        -1385.0,
        -3374.5,
        908.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9615239500999451,
        -0.0,
        -0.2747211158275604
      ],
      "plane_d": -1074.57177734375,
      "bbox_min": [
        -1379.0,
        -3398.332275390625,
        904.5
      ],
      "bbox_max": [
        -1375.0,
        -3384.0,
        915.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3384.0,
      "bbox_min": [
        -1379.0,
        -3388.749267578125,
        904.5
      ],
      "bbox_max": [
        -1375.0,
        -3384.0,
        915.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 904.5,
      "bbox_min": [
        -1376.0,
        -3388.749267578125,
        904.5
      ],
      "bbox_max": [
        -1375.0,
        -3384.0,
        904.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3374.0,
      "bbox_min": [
        -1356.0,
        -3374.0,
        894.0
      ],
      "bbox_max": [
        -1340.1395263671875,
        -3368.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1356.0,
      "bbox_min": [
        -1356.0,
        -3374.0,
        894.0
      ],
      "bbox_max": [
        -1346.0,
        -3368.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -912.0,
      "bbox_min": [
        -1356.0,
        -3374.0,
        912.0
      ],
      "bbox_max": [
        -1346.0,
        -3368.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.950871467590332,
        -0.0,
        0.3095860481262207
      ],
      "plane_d": 997.530517578125,
      "bbox_min": [
        -1356.0,
        -3368.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1334.9947509765625,
        -3366.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1356.0,
      "bbox_min": [
        -1356.0,
        -3368.0,
        878.9268188476562
      ],
      "bbox_max": [
        -1346.0,
        -3366.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -912.0,
      "bbox_min": [
        -1356.0,
        -3368.0,
        912.0
      ],
      "bbox_max": [
        -1346.0,
        -3366.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.982089102268219,
        0.1529073566198349,
        -0.11009181290864944
      ],
      "plane_d": 2186.53564453125,
      "bbox_min": [
        -1560.9947509765625,
        -3378.35205078125,
        1284.5732421875
      ],
      "bbox_max": [
        -1554.104736328125,
        -3366.0,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39672571420669556,
        0.18136583268642426,
        -0.8998417854309082
      ],
      "plane_d": 1149.486572265625,
      "bbox_min": [
        -1560.9947509765625,
        -3371.47021484375,
        1284.5732421875
      ],
      "bbox_max": [
        -1557.488037109375,
        -3366.0,
        1287.2218017578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0412130132317543,
        0.43465206027030945,
        -0.8996549844741821
      ],
      "plane_d": 2685.27783203125,
      "bbox_min": [
        -1560.65283203125,
        -3371.47021484375,
        1284.5732421875
      ],
      "bbox_max": [
        -1557.488037109375,
        -3366.0,
        1287.1690673828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9726229310035706,
        0.20830567181110382,
        -0.10302186012268066
      ],
      "plane_d": 2349.484130859375,
      "bbox_min": [
        -1557.488037109375,
        -3378.35205078125,
        1284.5732421875
      ],
      "bbox_max": [
        -1554.104736328125,
        -3371.47021484375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9593862891197205,
        0.24561771750450134,
        -0.13874416053295135
      ],
      "plane_d": 2500.552490234375,
      "bbox_min": [
        -1562.950927734375,
        -3366.0,
        884.6555786132812
      ],
      "bbox_max": [
        -1474.6434326171875,
        -3362.948486328125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39672571420669556,
        0.18136583268642426,
        -0.8998417854309082
      ],
      "plane_d": 1149.486572265625,
      "bbox_min": [
        -1562.950927734375,
        -3366.0,
        1287.071044921875
      ],
      "bbox_max": [
        -1556.3189697265625,
        -3362.948486328125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.982089102268219,
        0.1529073566198349,
        -0.11009181290864944
      ],
      "plane_d": 2186.53564453125,
      "bbox_min": [
        -1556.447998046875,
        -3366.0,
        1301.4490966796875
      ],
      "bbox_max": [
        -1556.3189697265625,
        -3365.626953125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22641703486442566,
        -0.020128117874264717,
        0.9738224148750305
      ],
      "plane_d": -595.3028564453125,
      "bbox_min": [
        -1477.9952392578125,
        -3363.79541015625,
        884.6555786132812
      ],
      "bbox_max": [
        -1474.6434326171875,
        -3362.948486328125,
        885.4348754882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3377978503704071,
        -0.8362663984298706,
        0.4319157302379608
      ],
      "plane_d": -2702.277587890625,
      "bbox_min": [
        -1595.0,
        -3362.948486328125,
        878.1983032226562
      ],
      "bbox_max": [
        -1105.0,
        -3053.433837890625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9541356563568115,
        0.2993745803833008,
        0.0
      ],
      "plane_d": 2282.934814453125,
      "bbox_min": [
        -1595.0,
        -3362.948486328125,
        878.1983032226562
      ],
      "bbox_max": [
        -1184.539306640625,
        -3053.433837890625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.001288205268792808,
        -0.936079740524292,
        0.3517853915691376
      ],
      "plane_d": -3417.884521484375,
      "bbox_min": [
        -1595.0,
        -3362.948486328125,
        878.1983032226562
      ],
      "bbox_max": [
        -1350.0,
        -3139.3798828125,
        1300.087158203125
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.1961391419172287,
        -0.9805760383605957
      ],
      "plane_d": 282.33038330078125,
      "bbox_min": [
        -1465.0,
        -3323.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1350.031494140625,
        -3139.3798828125,
        945.003173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 918.9999389648438,
      "bbox_min": [
        -1465.0,
        -3155.0,
        915.8756103515625
      ],
      "bbox_max": [
        -1440.436767578125,
        -3139.3798828125,
        919.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9598785042762756,
        0.28041622042655945,
        0.0
      ],
      "plane_d": -502.311279296875,
      "bbox_min": [
        -1465.0,
        -3155.0,
        915.8756103515625
      ],
      "bbox_max": [
        -1440.436767578125,
        -3139.3798828125,
        919.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1465.0,
      "bbox_min": [
        -1465.0,
        -3155.0,
        918.0631713867188
      ],
      "bbox_max": [
        -1465.0,
        -3150.316162109375,
        919.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        -0.0
      ],
      "plane_d": -1444.9998779296875,
      "bbox_min": [
        -1465.0,
        -3323.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1350.031494140625,
        -3139.3798828125,
        945.003173828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9598785042762756,
        0.28041622042655945,
        0.0
      ],
      "plane_d": -502.311279296875,
      "bbox_min": [
        -1445.0,
        -3323.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1350.031494140625,
        -3139.3798828125,
        919.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3323.0,
      "bbox_min": [
        -1356.0,
        -3323.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1350.031494140625,
        -3323.0,
        878.4849853515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1465.0,
      "bbox_min": [
        -1465.0,
        -3303.789306640625,
        878.1983032226562
      ],
      "bbox_max": [
        -1445.0,
        -3150.316162109375,
        945.003173828125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        2.136230432370212e-05,
        0.0,
        1.0
      ],
      "plane_d": -929.9793701171875,
      "bbox_min": [
        -1465.0,
        -3303.789306640625,
        930.0027465820312
      ],
      "bbox_max": [
        -1445.0,
        -3285.0,
        930.0106811523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.136230432370212e-05,
        0.0,
        -1.0
      ],
      "plane_d": 944.9718627929688,
      "bbox_min": [
        -1465.0,
        -3298.15234375,
        945.0027465820312
      ],
      "bbox_max": [
        -1445.0,
        -3285.0,
        945.003173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11021039634943008,
        -0.9280050992965698,
        0.3558935821056366
      ],
      "plane_d": -3234.49072265625,
      "bbox_min": [
        -1595.0,
        -3362.948486328125,
        878.1983032226562
      ],
      "bbox_max": [
        -1350.0,
        -3165.048583984375,
        1299.30517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1012493446469307,
        -0.9274534583091736,
        0.35997048020362854
      ],
      "plane_d": -3251.482177734375,
      "bbox_min": [
        -1595.0,
        -3252.21533203125,
        1102.025146484375
      ],
      "bbox_max": [
        -1501.1502685546875,
        -3166.4111328125,
        1296.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21167901158332825,
        0.041101183742284775,
        0.9764747023582458
      ],
      "plane_d": -415.9947204589844,
      "bbox_min": [
        -1595.0,
        -3351.9326171875,
        884.6555786132812
      ],
      "bbox_max": [
        -1470.9000244140625,
        -3320.83935546875,
        912.8665771484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05333402752876282,
        0.0,
        0.9985767602920532
      ],
      "plane_d": -804.9474487304688,
      "bbox_min": [
        -1474.6434326171875,
        -3362.948486328125,
        878.1983032226562
      ],
      "bbox_max": [
        -1350.0,
        -3316.65380859375,
        895.3721923828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1356.0,
      "bbox_min": [
        -1356.0,
        -3323.0,
        878.4635009765625
      ],
      "bbox_max": [
        -1350.0911865234375,
        -3316.65380859375,
        895.3721923828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3323.0,
      "bbox_min": [
        -1356.0,
        -3323.0,
        878.4635009765625
      ],
      "bbox_max": [
        -1350.0911865234375,
        -3323.0,
        883.0848388671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43772801756858826,
        -0.8991074562072754,
        0.0
      ],
      "plane_d": -2195.2607421875,
      "bbox_min": [
        -1411.0396728515625,
        -3323.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1184.539306640625,
        -3053.433837890625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4557587504386902,
        -0.8900548815727234,
        -0.00928233191370964
      ],
      "plane_d": -2133.771484375,
      "bbox_min": [
        -1392.043212890625,
        -3119.3125,
        878.1983032226562
      ],
      "bbox_max": [
        -1356.511474609375,
        -3102.013916015625,
        964.08837890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.950871467590332,
        -0.0,
        0.3095860481262207
      ],
      "plane_d": 997.530517578125,
      "bbox_min": [
        -1350.031494140625,
        -3323.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1334.9947509765625,
        -3315.0,
        883.4946899414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3323.0,
      "bbox_min": [
        -1350.031494140625,
        -3323.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1349.7520751953125,
        -3323.0,
        878.4168090820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7746099233627319,
        -0.5822634696960449,
        0.2468777596950531
      ],
      "plane_d": -3030.36767578125,
      "bbox_min": [
        -1594.4798583984375,
        -3362.948486328125,
        878.1983032226562
      ],
      "bbox_max": [
        -1105.0,
        -3084.35595703125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6744422316551208,
        -0.542770504951477,
        0.5005276203155518
      ],
      "plane_d": -1478.223388671875,
      "bbox_min": [
        -1201.8896484375,
        -3349.819580078125,
        878.1983032226562
      ],
      "bbox_max": [
        -1105.0,
        -3085.17333984375,
        1227.2801513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3314.0,
      "bbox_min": [
        -1141.140625,
        -3322.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1126.9766845703125,
        -3314.0,
        891.550048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3322.0,
      "bbox_min": [
        -1135.1270751953125,
        -3322.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1133.4146728515625,
        -3322.0,
        879.8125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1126.0,
      "bbox_min": [
        -1136.8853759765625,
        -3349.819580078125,
        878.1983032226562
      ],
      "bbox_max": [
        -1105.0,
        -3314.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3314.0,
      "bbox_min": [
        -1136.8853759765625,
        -3322.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1126.0,
        -3314.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3322.0,
      "bbox_min": [
        -1134.6126708984375,
        -3322.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1126.0,
        -3314.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -912.0,
      "bbox_min": [
        -1130.3677978515625,
        -3319.810546875,
        912.0
      ],
      "bbox_max": [
        -1126.0,
        -3314.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6382936835289001,
        0.7293487191200256,
        0.2462347000837326
      ],
      "plane_d": 1514.509521484375,
      "bbox_min": [
        -1114.98486328125,
        -3349.819580078125,
        878.1983032226562
      ],
      "bbox_max": [
        -1105.0,
        -3340.057861328125,
        907.11279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05163498595356941,
        -0.004590269178152084,
        0.9986554980278015
      ],
      "plane_d": -822.7598266601562,
      "bbox_min": [
        -1594.4798583984375,
        -3362.948486328125,
        878.1983032226562
      ],
      "bbox_max": [
        -1105.0,
        -3314.0,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05333402752876282,
        0.0,
        0.9985767602920532
      ],
      "plane_d": -804.9474487304688,
      "bbox_min": [
        -1406.996826171875,
        -3362.948486328125,
        878.1983032226562
      ],
      "bbox_max": [
        -1346.2037353515625,
        -3323.0,
        881.2424926757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3323.0,
      "bbox_min": [
        -1350.0032958984375,
        -3323.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1346.2037353515625,
        -3323.0,
        878.394775390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6382936835289001,
        0.7293487191200256,
        0.2462347000837326
      ],
      "plane_d": 1514.509521484375,
      "bbox_min": [
        -1594.4798583984375,
        -3362.948486328125,
        878.1983032226562
      ],
      "bbox_max": [
        -1105.0,
        -3314.0,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39672571420669556,
        0.18136583268642426,
        -0.8998417854309082
      ],
      "plane_d": 1149.486572265625,
      "bbox_min": [
        -1594.4798583984375,
        -3362.948486328125,
        878.1983032226562
      ],
      "bbox_max": [
        -1126.0,
        -3314.0,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9593862891197205,
        0.24561771750450134,
        -0.13874416053295135
      ],
      "plane_d": 2500.552490234375,
      "bbox_min": [
        -1564.6063232421875,
        -3362.948486328125,
        1288.6171875
      ],
      "bbox_max": [
        -1557.062744140625,
        -3333.48291015625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.950871467590332,
        0.0,
        0.3095860481262207
      ],
      "plane_d": -1362.532470703125,
      "bbox_min": [
        -1356.0,
        -3323.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1126.0,
        -3314.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3314.0,
      "bbox_min": [
        -1147.0052490234375,
        -3322.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1126.0,
        -3314.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1126.0,
      "bbox_min": [
        -1126.0,
        -3322.0,
        906.8358154296875
      ],
      "bbox_max": [
        -1126.0,
        -3319.810546875,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3323.0,
      "bbox_min": [
        -1356.0,
        -3323.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1334.9947509765625,
        -3315.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.950871467590332,
        -0.0,
        0.3095860481262207
      ],
      "plane_d": 997.530517578125,
      "bbox_min": [
        -1356.0,
        -3323.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1334.9947509765625,
        -3315.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1356.0,
      "bbox_min": [
        -1356.0,
        -3323.0,
        883.0848388671875
      ],
      "bbox_max": [
        -1346.0,
        -3315.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -912.0,
      "bbox_min": [
        -1356.0,
        -3323.0,
        912.0
      ],
      "bbox_max": [
        -1346.0,
        -3315.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9661343693733215,
        0.24907872080802917,
        0.0674104243516922
      ],
      "plane_d": -827.2496337890625,
      "bbox_min": [
        -1760.0,
        -3491.47998046875,
        892.0
      ],
      "bbox_max": [
        -1595.0,
        -3362.948486328125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.056889183819293976,
        0.9831775426864624,
        -0.17356735467910767
      ],
      "plane_d": 3449.109619140625,
      "bbox_min": [
        -1664.755859375,
        -3426.5,
        892.0
      ],
      "bbox_max": [
        -1595.0,
        -3362.948486328125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01903552934527397,
        0.9815307855606079,
        -0.19035546481609344
      ],
      "plane_d": 3524.079833984375,
      "bbox_min": [
        -1664.755859375,
        -3419.54296875,
        1035.6976318359375
      ],
      "bbox_max": [
        -1595.0,
        -3388.281494140625,
        1201.640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.038227956742048264,
        0.9232555031776428,
        0.3822798430919647
      ],
      "plane_d": 2820.343505859375,
      "bbox_min": [
        -1664.755859375,
        -3419.54296875,
        1035.6976318359375
      ],
      "bbox_max": [
        -1595.0,
        -3417.57666015625,
        1047.4222412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.038227956742048264,
        0.9232555031776428,
        0.3822798430919647
      ],
      "plane_d": 2820.343505859375,
      "bbox_min": [
        -1664.755859375,
        -3426.5,
        892.0
      ],
      "bbox_max": [
        -1595.0,
        -3362.948486328125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3426.5,
      "bbox_min": [
        -1610.0,
        -3426.5,
        892.0
      ],
      "bbox_max": [
        -1595.0,
        -3411.5,
        915.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -892.0,
      "bbox_min": [
        -1610.0,
        -3426.5,
        892.0
      ],
      "bbox_max": [
        -1595.0,
        -3411.5,
        892.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22641703486442566,
        -0.020128117874264717,
        0.9738224148750305
      ],
      "plane_d": -595.3028564453125,
      "bbox_min": [
        -1660.4217529296875,
        -3370.329833984375,
        912.5338745117188
      ],
      "bbox_max": [
        -1595.0,
        -3366.591796875,
        927.6970825195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22641703486442566,
        -0.020128117874264717,
        0.9738224148750305
      ],
      "plane_d": -595.3028564453125,
      "bbox_min": [
        -1660.3753662109375,
        -3370.693603515625,
        912.5635375976562
      ],
      "bbox_max": [
        -1595.0,
        -3362.948486328125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21167901158332825,
        0.041101183742284775,
        0.9764747023582458
      ],
      "plane_d": -415.9947204589844,
      "bbox_min": [
        -1659.8751220703125,
        -3368.18701171875,
        922.8613891601562
      ],
      "bbox_max": [
        -1638.9671630859375,
        -3362.948486328125,
        927.6143188476562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39672571420669556,
        0.18136583268642426,
        -0.8998417854309082
      ],
      "plane_d": 1149.486572265625,
      "bbox_min": [
        -1597.9923095703125,
        -3370.693603515625,
        1301.2681884765625
      ],
      "bbox_max": [
        -1595.0,
        -3364.086181640625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34272027015686035,
        0.9365004897117615,
        0.07422665506601334
      ],
      "plane_d": 2554.111572265625,
      "bbox_min": [
        -1760.0,
        -3491.47998046875,
        927.1087036132812
      ],
      "bbox_max": [
        -1650.8538818359375,
        -3362.948486328125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7289522290229797,
        0.6049720644950867,
        0.3203705847263336
      ],
      "plane_d": 411.9771423339844,
      "bbox_min": [
        -1760.0,
        -3491.47998046875,
        1265.1668701171875
      ],
      "bbox_max": [
        -1739.9085693359375,
        -3467.27099609375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05185391753911972,
        0.9296181201934814,
        0.36485806107521057
      ],
      "plane_d": 2880.741455078125,
      "bbox_min": [
        -1669.7366943359375,
        -3373.532470703125,
        927.6900634765625
      ],
      "bbox_max": [
        -1660.37548828125,
        -3370.148193359375,
        935.89306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22641703486442566,
        -0.020128117874264717,
        0.9738224148750305
      ],
      "plane_d": -595.3028564453125,
      "bbox_min": [
        -1669.7366943359375,
        -3370.65771484375,
        927.6900634765625
      ],
      "bbox_max": [
        -1660.37548828125,
        -3370.148193359375,
        929.8560791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22641703486442566,
        -0.020128117874264717,
        0.9738224148750305
      ],
      "plane_d": -595.3028564453125,
      "bbox_min": [
        -1669.7366943359375,
        -3370.65771484375,
        927.65673828125
      ],
      "bbox_max": [
        -1660.1552734375,
        -3369.285400390625,
        929.8560791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2235765904188156,
        0.04341130331158638,
        0.9737191796302795
      ],
      "plane_d": -385.780029296875,
      "bbox_min": [
        -1760.0,
        -3383.83349609375,
        927.1087036132812
      ],
      "bbox_max": [
        -1658.5599365234375,
        -3362.948486328125,
        951.1689453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21167901158332825,
        0.041101183742284775,
        0.9764747023582458
      ],
      "plane_d": -415.9947204589844,
      "bbox_min": [
        -1671.2335205078125,
        -3370.65771484375,
        927.1087036132812
      ],
      "bbox_max": [
        -1658.5599365234375,
        -3362.948486328125,
        929.8560791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22641703486442566,
        -0.020128117874264717,
        0.9738224148750305
      ],
      "plane_d": -595.3028564453125,
      "bbox_min": [
        -1669.7366943359375,
        -3370.65771484375,
        927.6143188476562
      ],
      "bbox_max": [
        -1659.8751220703125,
        -3368.18701171875,
        929.8560791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21603241562843323,
        -0.9093504548072815,
        0.35554423928260803
      ],
      "plane_d": -2994.511962890625,
      "bbox_min": [
        -1760.0,
        -3362.948486328125,
        911.740966796875
      ],
      "bbox_max": [
        -1595.0,
        -3174.36669921875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1012493446469307,
        -0.9274534583091736,
        0.35997048020362854
      ],
      "plane_d": -3251.482177734375,
      "bbox_min": [
        -1760.0,
        -3362.948486328125,
        911.740966796875
      ],
      "bbox_max": [
        -1595.0,
        -3174.36669921875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11021039634943008,
        -0.9280050992965698,
        0.3558935821056366
      ],
      "plane_d": -3234.49072265625,
      "bbox_min": [
        -1678.0,
        -3328.10009765625,
        911.740966796875
      ],
      "bbox_max": [
        -1595.0,
        -3252.21533203125,
        1102.025146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21167901158332825,
        0.041101183742284775,
        0.9764747023582458
      ],
      "plane_d": -415.9947204589844,
      "bbox_min": [
        -1678.0,
        -3328.10009765625,
        911.740966796875
      ],
      "bbox_max": [
        -1595.0,
        -3325.190185546875,
        929.8560791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24250808358192444,
        -0.909406840801239,
        0.3378889858722687
      ],
      "plane_d": -2927.0478515625,
      "bbox_min": [
        -1760.0,
        -3362.948486328125,
        911.7774047851562
      ],
      "bbox_max": [
        -1595.0,
        -3184.333984375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2235765904188156,
        0.04341130331158638,
        0.9737191796302795
      ],
      "plane_d": -385.780029296875,
      "bbox_min": [
        -1760.0,
        -3362.948486328125,
        911.7774047851562
      ],
      "bbox_max": [
        -1595.0,
        -3326.0556640625,
        950.2378540039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21186989545822144,
        0.07687602192163467,
        0.9742696285247803
      ],
      "plane_d": -294.561767578125,
      "bbox_min": [
        -1760.0,
        -3357.116455078125,
        929.8560791015625
      ],
      "bbox_max": [
        -1678.0,
        -3328.10009765625,
        949.9778442382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21167901158332825,
        0.041101183742284775,
        0.9764747023582458
      ],
      "plane_d": -415.9947204589844,
      "bbox_min": [
        -1678.0,
        -3362.948486328125,
        911.7774047851562
      ],
      "bbox_max": [
        -1595.0,
        -3326.0556640625,
        929.8560791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22641703486442566,
        -0.020128117874264717,
        0.9738224148750305
      ],
      "plane_d": -595.3028564453125,
      "bbox_min": [
        -1638.9671630859375,
        -3362.948486328125,
        912.6388549804688
      ],
      "bbox_max": [
        -1595.0,
        -3351.9326171875,
        922.8613891601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": 0.0,
      "bbox_min": [
        -1223.9951171875,
        -4402.3603515625,
        0.0
      ],
      "bbox_max": [
        -751.310546875,
        -3650.0,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6998437643051147,
        -0.7020972967147827,
        0.13144628703594208
      ],
      "plane_d": -3268.36572265625,
      "bbox_min": [
        -1170.4541015625,
        -4373.39892578125,
        0.0
      ],
      "bbox_max": [
        -820.840576171875,
        -3650.0,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6572308540344238,
        -0.7498543858528137,
        0.07593389600515366
      ],
      "plane_d": -3399.419189453125,
      "bbox_min": [
        -1170.4541015625,
        -4373.39892578125,
        0.0
      ],
      "bbox_max": [
        -820.840576171875,
        -3650.0,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6737403869628906,
        0.7137011289596558,
        0.1915842890739441
      ],
      "plane_d": 2197.3564453125,
      "bbox_min": [
        -1170.4541015625,
        -4373.39892578125,
        0.0
      ],
      "bbox_max": [
        -820.840576171875,
        -3650.0,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7375126481056213,
        0.6615926623344421,
        0.13553683459758759
      ],
      "plane_d": 1933.0264892578125,
      "bbox_min": [
        -1170.4541015625,
        -4373.39892578125,
        0.0
      ],
      "bbox_max": [
        -919.74755859375,
        -3947.069091796875,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9486221075057983,
        0.298395574092865,
        0.10524357110261917
      ],
      "plane_d": 232.280517578125,
      "bbox_min": [
        -1170.4541015625,
        -4373.39892578125,
        0.0
      ],
      "bbox_max": [
        -1019.15966796875,
        -4079.2041015625,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9584220051765442,
        0.2534164488315582,
        0.13117706775665283
      ],
      "plane_d": 30.388076782226562,
      "bbox_min": [
        -1093.373046875,
        -4311.3466796875,
        0.0
      ],
      "bbox_max": [
        -1019.15966796875,
        -4112.587890625,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9070167541503906,
        0.39627647399902344,
        0.1424275040626526
      ],
      "plane_d": 693.7762451171875,
      "bbox_min": [
        -1093.373046875,
        -4311.3466796875,
        0.0
      ],
      "bbox_max": [
        -1063.9075927734375,
        -4250.61767578125,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8524890542030334,
        0.5132246017456055,
        0.09931252151727676
      ],
      "plane_d": 1264.0517578125,
      "bbox_min": [
        -1093.373046875,
        -4311.3466796875,
        155.5010528564453
      ],
      "bbox_max": [
        -1063.9075927734375,
        -4281.82470703125,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.964597225189209,
        -0.2396222949028015,
        0.11015146225690842
      ],
      "plane_d": 69.89508056640625,
      "bbox_min": [
        -1170.4541015625,
        -4373.39892578125,
        0.0
      ],
      "bbox_max": [
        -1081.6805419921875,
        -4150.77587890625,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.969648003578186,
        -0.21079306304454803,
        0.12389089167118073
      ],
      "plane_d": 196.02403259277344,
      "bbox_min": [
        -1170.4541015625,
        -4297.2265625,
        0.0
      ],
      "bbox_max": [
        -1109.2020263671875,
        -4162.927734375,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9526576995849609,
        -0.2719799280166626,
        0.1359049379825592
      ],
      "plane_d": -78.6370849609375,
      "bbox_min": [
        -1114.1038818359375,
        -4180.40576171875,
        0.0
      ],
      "bbox_max": [
        -1109.2020263671875,
        -4162.927734375,
        39.380271911621094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8288319706916809,
        0.5594579577445984,
        0.006665459834039211
      ],
      "plane_d": 3372.44775390625,
      "bbox_min": [
        -1170.4541015625,
        -4373.39892578125,
        0.0
      ],
      "bbox_max": [
        -1081.6805419921875,
        -4150.77587890625,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8734025359153748,
        0.4862821102142334,
        0.026412880048155785
      ],
      "plane_d": 3104.8896484375,
      "bbox_min": [
        -1170.4541015625,
        -4373.39892578125,
        0.0
      ],
      "bbox_max": [
        -1081.6805419921875,
        -4150.77587890625,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8524890542030334,
        0.5132246017456055,
        0.09931252151727676
      ],
      "plane_d": 1264.0517578125,
      "bbox_min": [
        -1134.466796875,
        -4373.39892578125,
        0.0
      ],
      "bbox_max": [
        -1081.6805419921875,
        -4150.77587890625,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9070167541503906,
        0.39627647399902344,
        0.1424275040626526
      ],
      "plane_d": 693.7762451171875,
      "bbox_min": [
        -1134.466796875,
        -4347.3603515625,
        0.0
      ],
      "bbox_max": [
        -1092.1998291015625,
        -4150.77587890625,
        155.50106811523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9526576995849609,
        -0.2719799280166626,
        0.1359049379825592
      ],
      "plane_d": -78.6370849609375,
      "bbox_min": [
        -1110.9439697265625,
        -4180.40576171875,
        0.0
      ],
      "bbox_max": [
        -1102.48486328125,
        -4150.77587890625,
        22.76639175415039
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.969648003578186,
        -0.21079306304454803,
        0.12389089167118073
      ],
      "plane_d": 196.02403259277344,
      "bbox_min": [
        -1165.8682861328125,
        -4276.1318359375,
        0.0
      ],
      "bbox_max": [
        -1090.2904052734375,
        -4108.06298828125,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9526576995849609,
        -0.2719799280166626,
        0.1359049379825592
      ],
      "plane_d": -78.6370849609375,
      "bbox_min": [
        -1118.4781494140625,
        -4171.7958984375,
        0.0
      ],
      "bbox_max": [
        -1090.2904052734375,
        -4108.06298828125,
        93.89518737792969
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9488316774368286,
        0.23572899401187897,
        0.2101198136806488
      ],
      "plane_d": 57.75299072265625,
      "bbox_min": [
        -1159.0166015625,
        -4244.61376953125,
        0.0
      ],
      "bbox_max": [
        -820.840576171875,
        -3650.0,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9344744086265564,
        0.3212260901927948,
        0.1535298079252243
      ],
      "plane_d": 408.4210510253906,
      "bbox_min": [
        -919.74755859375,
        -3947.069091796875,
        0.0
      ],
      "bbox_max": [
        -820.840576171875,
        -3786.95263671875,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9688401222229004,
        -0.1625845581293106,
        0.18685577809810638
      ],
      "plane_d": 331.1572265625,
      "bbox_min": [
        -1159.0166015625,
        -4244.61376953125,
        0.0
      ],
      "bbox_max": [
        -971.204345703125,
        -3650.0,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8639434576034546,
        -0.4744519889354706,
        0.16881096363067627
      ],
      "plane_d": -992.2029418945312,
      "bbox_min": [
        -1159.0166015625,
        -4244.61376953125,
        0.0
      ],
      "bbox_max": [
        -971.204345703125,
        -3650.0,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9699033498764038,
        -0.14417482912540436,
        0.19621716439723969
      ],
      "plane_d": 401.2367858886719,
      "bbox_min": [
        -1105.7080078125,
        -4009.677734375,
        0.0
      ],
      "bbox_max": [
        -971.204345703125,
        -3650.0,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8846758008003235,
        -0.42253169417381287,
        0.19701673090457916
      ],
      "plane_d": -768.6262817382812,
      "bbox_min": [
        -1105.7080078125,
        -4009.677734375,
        0.0
      ],
      "bbox_max": [
        -971.204345703125,
        -3650.0,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7952687740325928,
        0.5908210277557373,
        0.13593456149101257
      ],
      "plane_d": 2988.283203125,
      "bbox_min": [
        -1066.54833984375,
        -3750.568359375,
        0.0
      ],
      "bbox_max": [
        -971.204345703125,
        -3650.0,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9034790992736816,
        0.42338916659355164,
        0.06683698296546936
      ],
      "plane_d": 2491.129150390625,
      "bbox_min": [
        -1066.54833984375,
        -3741.171875,
        9.05340576171875
      ],
      "bbox_max": [
        -1023.8232421875,
        -3650.0,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9618238806724548,
        -0.22822940349578857,
        0.15101738274097443
      ],
      "plane_d": 108.04841613769531,
      "bbox_min": [
        -1159.0166015625,
        -4244.61376953125,
        0.0
      ],
      "bbox_max": [
        -1071.5833740234375,
        -4009.677734375,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9526576995849609,
        -0.2719799280166626,
        0.1359049379825592
      ],
      "plane_d": -78.6370849609375,
      "bbox_min": [
        -1144.364501953125,
        -4213.98681640625,
        0.0
      ],
      "bbox_max": [
        -1071.5833740234375,
        -4042.538330078125,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.969648003578186,
        -0.21079306304454803,
        0.12389089167118073
      ],
      "plane_d": 196.02403259277344,
      "bbox_min": [
        -1144.364501953125,
        -4213.98681640625,
        93.89517974853516
      ],
      "bbox_max": [
        -1118.4781494140625,
        -4122.03125,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.969648003578186,
        -0.21079306304454803,
        0.12389089167118073
      ],
      "plane_d": 196.02403259277344,
      "bbox_min": [
        -1159.0166015625,
        -4244.61376953125,
        204.43331909179688
      ],
      "bbox_max": [
        -1132.3681640625,
        -4122.03125,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6585033535957336,
        -0.7513062953948975,
        0.04372837394475937
      ],
      "plane_d": -3397.36328125,
      "bbox_min": [
        -1122.57470703125,
        -3924.0,
        267.0
      ],
      "bbox_max": [
        -792.70361328125,
        -3650.0,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6611984968185425,
        -0.7488041520118713,
        0.045921631157398224
      ],
      "plane_d": -3391.467041015625,
      "bbox_min": [
        -976.505615234375,
        -3788.740234375,
        275.85992431640625
      ],
      "bbox_max": [
        -792.70361328125,
        -3650.0,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9823543429374695,
        -0.1460256427526474,
        0.11686121672391891
      ],
      "plane_d": 428.248291015625,
      "bbox_min": [
        -1122.57470703125,
        -3924.0,
        267.0
      ],
      "bbox_max": [
        -792.70361328125,
        -3650.0,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9015147686004639,
        0.4224686026573181,
        0.09376233071088791
      ],
      "plane_d": 2478.485107421875,
      "bbox_min": [
        -1122.57470703125,
        -3924.0,
        267.0
      ],
      "bbox_max": [
        -1023.8232421875,
        -3650.0,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8949941992759705,
        -0.4274598956108093,
        0.1275285929441452
      ],
      "plane_d": -758.42431640625,
      "bbox_min": [
        -1122.57470703125,
        -3924.0,
        267.0
      ],
      "bbox_max": [
        -1044.7705078125,
        -3650.0,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8874832987785339,
        0.44281822443008423,
        -0.12761376798152924
      ],
      "plane_d": 2677.968017578125,
      "bbox_min": [
        -1122.57470703125,
        -3918.13037109375,
        610.09814453125
      ],
      "bbox_max": [
        -1067.032958984375,
        -3650.0,
        660.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9720087051391602,
        -0.20689089596271515,
        -0.11133354157209396
      ],
      "plane_d": 332.78009033203125,
      "bbox_min": [
        -1122.57470703125,
        -3918.13037109375,
        610.1184692382812
      ],
      "bbox_max": [
        -1067.032958984375,
        -3722.0146484375,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9618260860443115,
        -0.25134047865867615,
        -0.10825211554765701
      ],
      "plane_d": 161.72654724121094,
      "bbox_min": [
        -1122.57470703125,
        -3918.13037109375,
        610.1184692382812
      ],
      "bbox_max": [
        -1067.032958984375,
        -3722.0146484375,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.34197601675987244,
        -0.9395796060562134,
        0.015575435012578964
      ],
      "plane_d": -4072.351806640625,
      "bbox_min": [
        -1120.069580078125,
        -3918.13037109375,
        634.3931884765625
      ],
      "bbox_max": [
        -1100.6282958984375,
        -3882.5791015625,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34197160601615906,
        0.9395811557769775,
        -0.015574740245938301
      ],
      "plane_d": 4037.7158203125,
      "bbox_min": [
        -1110.726806640625,
        -3894.6650390625,
        634.3931884765625
      ],
      "bbox_max": [
        -1100.6282958984375,
        -3882.5791015625,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9847401976585388,
        -0.09371570497751236,
        -0.1466427892446518
      ],
      "plane_d": 814.3311767578125,
      "bbox_min": [
        -1103.1268310546875,
        -3894.6650390625,
        634.3931884765625
      ],
      "bbox_max": [
        -1100.6282958984375,
        -3885.6572265625,
        645.6766357421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9176634550094604,
        0.3884923756122589,
        -0.08347219973802567
      ],
      "plane_d": 2484.70263671875,
      "bbox_min": [
        -1105.0377197265625,
        -3657.0859375,
        630.7821044921875
      ],
      "bbox_max": [
        -1102.0244140625,
        -3650.0,
        635.10400390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9411426186561584,
        -0.3281519114971161,
        0.08103643357753754
      ],
      "plane_d": -296.7911682128906,
      "bbox_min": [
        -1117.2698974609375,
        -3924.0,
        462.91717529296875
      ],
      "bbox_max": [
        -1082.5556640625,
        -3857.140380859375,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34197601675987244,
        -0.9395796060562134,
        0.015575435012578964
      ],
      "plane_d": -4072.351806640625,
      "bbox_min": [
        -1117.2698974609375,
        -3919.140380859375,
        634.3931884765625
      ],
      "bbox_max": [
        -1098.544921875,
        -3885.232421875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9847401976585388,
        -0.09371570497751236,
        -0.1466427892446518
      ],
      "plane_d": 814.3311767578125,
      "bbox_min": [
        -1103.9649658203125,
        -3904.016357421875,
        634.3931884765625
      ],
      "bbox_max": [
        -1098.544921875,
        -3885.232421875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34197160601615906,
        0.9395811557769775,
        -0.015574740245938301
      ],
      "plane_d": 4037.7158203125,
      "bbox_min": [
        -1102.2703857421875,
        -3886.58837890625,
        645.6766357421875
      ],
      "bbox_max": [
        -1098.544921875,
        -3885.232421875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9847401976585388,
        -0.09371570497751236,
        -0.1466427892446518
      ],
      "plane_d": 814.3311767578125,
      "bbox_min": [
        -1105.5054931640625,
        -3912.046142578125,
        649.3531494140625
      ],
      "bbox_max": [
        -1099.26416015625,
        -3894.14599609375,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8154934048652649,
        -0.5618152618408203,
        -0.13904687762260437
      ],
      "plane_d": -1204.5438232421875,
      "bbox_min": [
        -1105.5054931640625,
        -3912.046142578125,
        649.3531494140625
      ],
      "bbox_max": [
        -1100.2403564453125,
        -3904.016357421875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9087146520614624,
        0.40747883915901184,
        0.09054633975028992
      ],
      "plane_d": 2432.368896484375,
      "bbox_min": [
        -1105.7723388671875,
        -3731.666748046875,
        281.8211669921875
      ],
      "bbox_max": [
        -1066.857177734375,
        -3650.0,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8874832987785339,
        0.44281822443008423,
        -0.12761376798152924
      ],
      "plane_d": 2677.968017578125,
      "bbox_min": [
        -1104.732666015625,
        -3730.187255859375,
        626.797607421875
      ],
      "bbox_max": [
        -1069.257080078125,
        -3650.0,
        654.3456420898438
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9618260860443115,
        -0.25134047865867615,
        -0.10825211554765701
      ],
      "plane_d": 161.72654724121094,
      "bbox_min": [
        -1070.221923828125,
        -3730.187255859375,
        626.797607421875
      ],
      "bbox_max": [
        -1069.257080078125,
        -3722.006103515625,
        654.3456420898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9176634550094604,
        0.3884923756122589,
        -0.08347219973802567
      ],
      "plane_d": 2484.70263671875,
      "bbox_min": [
        -1104.732666015625,
        -3654.169189453125,
        634.1361694335938
      ],
      "bbox_max": [
        -1102.8795166015625,
        -3650.0,
        641.0706787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8874832987785339,
        0.44281822443008423,
        -0.12761376798152924
      ],
      "plane_d": 2677.968017578125,
      "bbox_min": [
        -1103.9747314453125,
        -3731.666748046875,
        627.004638671875
      ],
      "bbox_max": [
        -1066.857177734375,
        -3650.0,
        660.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9618260860443115,
        -0.25134047865867615,
        -0.10825211554765701
      ],
      "plane_d": 161.72654724121094,
      "bbox_min": [
        -1070.1964111328125,
        -3731.666748046875,
        627.004638671875
      ],
      "bbox_max": [
        -1066.857177734375,
        -3720.89306640625,
        659.332763671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9903077483177185,
        -0.09759942442178726,
        0.09881734848022461
      ],
      "plane_d": 629.3703002929688,
      "bbox_min": [
        -1088.8924560546875,
        -3924.0,
        267.0
      ],
      "bbox_max": [
        -792.70361328125,
        -3718.49462890625,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8949941992759705,
        -0.4274598956108093,
        0.1275285929441452
      ],
      "plane_d": -758.42431640625,
      "bbox_min": [
        -1088.8924560546875,
        -3882.08984375,
        267.0
      ],
      "bbox_max": [
        -1044.7705078125,
        -3731.86669921875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9720087051391602,
        -0.20689089596271515,
        -0.11133354157209396
      ],
      "plane_d": 332.78009033203125,
      "bbox_min": [
        -1081.54736328125,
        -3827.976318359375,
        628.5555419921875
      ],
      "bbox_max": [
        -1067.2076416015625,
        -3731.86669921875,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9411426186561584,
        -0.3281519114971161,
        0.08103643357753754
      ],
      "plane_d": -296.7911682128906,
      "bbox_min": [
        -1088.8924560546875,
        -3864.400146484375,
        615.8033447265625
      ],
      "bbox_max": [
        -1079.6220703125,
        -3837.8125,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9720523357391357,
        0.22389337420463562,
        0.07061281055212021
      ],
      "plane_d": 31.119951248168945,
      "bbox_min": [
        -1076.1566162109375,
        -3924.0,
        267.0
      ],
      "bbox_max": [
        -792.70361328125,
        -3718.49462890625,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9674496054649353,
        0.24035444855690002,
        0.07918946444988251
      ],
      "plane_d": 94.94546508789062,
      "bbox_min": [
        -1076.1566162109375,
        -3924.0,
        267.0
      ],
      "bbox_max": [
        -820.840576171875,
        -3718.49462890625,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9720087051391602,
        -0.20689089596271515,
        -0.11133354157209396
      ],
      "plane_d": 332.78009033203125,
      "bbox_min": [
        -1076.1566162109375,
        -3802.64990234375,
        628.290771484375
      ],
      "bbox_max": [
        -1063.12353515625,
        -3718.49462890625,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8874824047088623,
        0.4428201913833618,
        -0.1276135891675949
      ],
      "plane_d": 2677.97412109375,
      "bbox_min": [
        -1067.203857421875,
        -3720.89306640625,
        654.0894165039062
      ],
      "bbox_max": [
        -1066.12841796875,
        -3718.49462890625,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6494391560554504,
        0.7583372592926025,
        0.0561547577381134
      ],
      "plane_d": 2441.852783203125,
      "bbox_min": [
        -1180.0,
        -4396.25048828125,
        267.0
      ],
      "bbox_max": [
        -823.8580932617188,
        -3924.0,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9655038714408875,
        0.2552889585494995,
        0.05128243938088417
      ],
      "plane_d": 52.20327377319336,
      "bbox_min": [
        -1180.0,
        -4396.25048828125,
        267.0
      ],
      "bbox_max": [
        -1002.8759765625,
        -4112.587890625,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9665732383728027,
        0.2515176832675934,
        0.0497492253780365
      ],
      "plane_d": 36.01310729980469,
      "bbox_min": [
        -1180.0,
        -4396.25048828125,
        267.0
      ],
      "bbox_max": [
        -1002.8759765625,
        -4112.587890625,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8927859663963318,
        0.4463912546634674,
        0.0605643056333065
      ],
      "plane_d": 937.014892578125,
      "bbox_min": [
        -1180.0,
        -4396.25048828125,
        267.0
      ],
      "bbox_max": [
        -1039.040771484375,
        -4229.5576171875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8562182188034058,
        0.5154696702957153,
        0.034370310604572296
      ],
      "plane_d": 1287.0367431640625,
      "bbox_min": [
        -1119.0380859375,
        -4373.39892578125,
        267.0
      ],
      "bbox_max": [
        -1039.040771484375,
        -4266.72412109375,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8381403088569641,
        0.5454541444778442,
        -0.0007736951811239123
      ],
      "plane_d": 3323.60595703125,
      "bbox_min": [
        -1180.0,
        -4396.25048828125,
        267.0
      ],
      "bbox_max": [
        -1103.8037109375,
        -4229.5576171875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9764060378074646,
        -0.21226218342781067,
        0.03970105201005936
      ],
      "plane_d": 220.09959411621094,
      "bbox_min": [
        -1180.0,
        -4297.2265625,
        267.0
      ],
      "bbox_max": [
        -1169.992431640625,
        -4279.255859375,
        597.8519897460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9764060378074646,
        -0.21226218342781067,
        0.03970105201005936
      ],
      "plane_d": 220.09959411621094,
      "bbox_min": [
        -1180.0,
        -4295.1025390625,
        267.0
      ],
      "bbox_max": [
        -1155.7435302734375,
        -4229.5576171875,
        614.8013916015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6840948462486267,
        0.7246696949005127,
        0.0828745886683464
      ],
      "plane_d": 2260.9384765625,
      "bbox_min": [
        -1180.0,
        -4279.337890625,
        267.0
      ],
      "bbox_max": [
        -823.8580932617188,
        -3924.0,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9842250943183899,
        -0.1669844537973404,
        0.05845712497830391
      ],
      "plane_d": 410.5820007324219,
      "bbox_min": [
        -1180.0,
        -4279.337890625,
        267.0
      ],
      "bbox_max": [
        -823.8580932617188,
        -3924.0,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9764060378074646,
        -0.21226218342781067,
        0.03970105201005936
      ],
      "plane_d": 220.09959411621094,
      "bbox_min": [
        -1180.0,
        -4276.08544921875,
        267.0
      ],
      "bbox_max": [
        -1124.2904052734375,
        -3928.5791015625,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9667492508888245,
        -0.23213884234428406,
        -0.10727354139089584
      ],
      "plane_d": 232.43179321289062,
      "bbox_min": [
        -1155.15673828125,
        -4081.012939453125,
        594.2785034179688
      ],
      "bbox_max": [
        -1124.2904052734375,
        -3928.5791015625,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6242576837539673,
        0.7803220748901367,
        -0.03741450980305672
      ],
      "plane_d": 3834.7607421875,
      "bbox_min": [
        -1155.15673828125,
        -4081.012939453125,
        594.2785034179688
      ],
      "bbox_max": [
        -1124.2904052734375,
        -3928.5791015625,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.771613359451294,
        -0.6280569434165955,
        -0.10078349709510803
      ],
      "plane_d": -1607.0076904296875,
      "bbox_min": [
        -1155.15673828125,
        -4081.012939453125,
        594.2785034179688
      ],
      "bbox_max": [
        -1129.724853515625,
        -3979.94921875,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9934242963790894,
        -0.04847213998436928,
        -0.1037239283323288
      ],
      "plane_d": 994.3659057617188,
      "bbox_min": [
        -1155.15673828125,
        -4081.012939453125,
        594.2785034179688
      ],
      "bbox_max": [
        -1129.724853515625,
        -3979.94921875,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.19583363831043243,
        -0.979168176651001,
        -0.05365469306707382
      ],
      "plane_d": -3734.36767578125,
      "bbox_min": [
        -1155.15673828125,
        -4081.012939453125,
        644.7652587890625
      ],
      "bbox_max": [
        -1152.44677734375,
        -4079.94921875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8154934048652649,
        -0.5618152618408203,
        -0.13904687762260437
      ],
      "plane_d": -1209.14697265625,
      "bbox_min": [
        -1146.57470703125,
        -3964.7041015625,
        646.3931884765625
      ],
      "bbox_max": [
        -1124.2904052734375,
        -3928.5791015625,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34197601675987244,
        -0.9395796060562134,
        0.015575435012578964
      ],
      "plane_d": -4123.966796875,
      "bbox_min": [
        -1146.57470703125,
        -3964.7041015625,
        646.3931884765625
      ],
      "bbox_max": [
        -1136.138427734375,
        -3961.131103515625,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.970330536365509,
        -0.23024792969226837,
        0.07378792762756348
      ],
      "plane_d": 129.98094177246094,
      "bbox_min": [
        -1180.0,
        -4279.337890625,
        267.0
      ],
      "bbox_max": [
        -823.8580932617188,
        -3924.0,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9667492508888245,
        -0.23213884234428406,
        -0.10727354139089584
      ],
      "plane_d": 232.43179321289062,
      "bbox_min": [
        -1138.773193359375,
        -4032.541015625,
        615.3554077148438
      ],
      "bbox_max": [
        -1125.306640625,
        -3942.830078125,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9934242963790894,
        -0.04847213998436928,
        -0.1037239283323288
      ],
      "plane_d": 994.3659057617188,
      "bbox_min": [
        -1131.6746826171875,
        -3996.491943359375,
        615.3554077148438
      ],
      "bbox_max": [
        -1127.7564697265625,
        -3980.498046875,
        645.9474487304688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9847401976585388,
        -0.09371570497751236,
        -0.1466427892446518
      ],
      "plane_d": 835.4137573242188,
      "bbox_min": [
        -1126.6912841796875,
        -3950.9912109375,
        657.4804077148438
      ],
      "bbox_max": [
        -1125.306640625,
        -3942.830078125,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8154934048652649,
        -0.5618152618408203,
        -0.13904687762260437
      ],
      "plane_d": -1209.14697265625,
      "bbox_min": [
        -1126.6912841796875,
        -3950.9912109375,
        657.4804077148438
      ],
      "bbox_max": [
        -1125.98583984375,
        -3949.875732421875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.978529155254364,
        -0.1968403160572052,
        0.061111390590667725
      ],
      "plane_d": 280.3565979003906,
      "bbox_min": [
        -1180.0,
        -4279.337890625,
        267.0
      ],
      "bbox_max": [
        -823.8580932617188,
        -3924.0,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9667492508888245,
        -0.23213884234428406,
        -0.10727354139089584
      ],
      "plane_d": 232.43179321289062,
      "bbox_min": [
        -1147.661376953125,
        -4074.591796875,
        629.9266357421875
      ],
      "bbox_max": [
        -1127.7200927734375,
        -3979.869384765625,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.771613359451294,
        -0.6280569434165955,
        -0.10078349709510803
      ],
      "plane_d": -1607.0076904296875,
      "bbox_min": [
        -1147.661376953125,
        -4074.591796875,
        629.9266357421875
      ],
      "bbox_max": [
        -1127.7200927734375,
        -3981.154052734375,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9934242963790894,
        -0.04847213998436928,
        -0.1037239283323288
      ],
      "plane_d": 994.3659057617188,
      "bbox_min": [
        -1130.1776123046875,
        -3996.571044921875,
        629.9266357421875
      ],
      "bbox_max": [
        -1127.7200927734375,
        -3981.154052734375,
        646.3017578125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9674496054649353,
        0.24035444855690002,
        0.07918946444988251
      ],
      "plane_d": 94.94546508789062,
      "bbox_min": [
        -1180.0,
        -4279.337890625,
        267.0
      ],
      "bbox_max": [
        -823.8580932617188,
        -3924.0,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9411426186561584,
        -0.3281519114971161,
        0.08103643357753754
      ],
      "plane_d": -296.7911682128906,
      "bbox_min": [
        -1180.0,
        -4279.337890625,
        267.0
      ],
      "bbox_max": [
        -823.8580932617188,
        -3924.0,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8949941992759705,
        -0.4274598956108093,
        0.1275285929441452
      ],
      "plane_d": -758.42431640625,
      "bbox_min": [
        -1180.0,
        -4279.337890625,
        267.0
      ],
      "bbox_max": [
        -823.8580932617188,
        -3924.0,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9720523357391357,
        0.22389337420463562,
        0.07061281055212021
      ],
      "plane_d": 31.119951248168945,
      "bbox_min": [
        -1180.0,
        -4279.337890625,
        536.4684448242188
      ],
      "bbox_max": [
        -823.8580932617188,
        -3924.0,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9667491316795349,
        -0.23213931918144226,
        -0.10727303475141525
      ],
      "plane_d": 232.429443359375,
      "bbox_min": [
        -1180.0,
        -4279.337890625,
        632.2350463867188
      ],
      "bbox_max": [
        -1126.312744140625,
        -3980.010986328125,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9934242963790894,
        -0.04847213998436928,
        -0.1037239283323288
      ],
      "plane_d": 994.3659057617188,
      "bbox_min": [
        -1147.2730712890625,
        -4074.11474609375,
        632.2350463867188
      ],
      "bbox_max": [
        -1126.312744140625,
        -3980.010986328125,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6242576837539673,
        0.7803220748901367,
        -0.03741450980305672
      ],
      "plane_d": 3834.7607421875,
      "bbox_min": [
        -1147.2730712890625,
        -4074.11474609375,
        646.3017578125
      ],
      "bbox_max": [
        -1126.312744140625,
        -3980.010986328125,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8381403088569641,
        0.5454541444778442,
        -0.0007736951811239123
      ],
      "plane_d": 3323.60595703125,
      "bbox_min": [
        -1180.0,
        -4279.337890625,
        656.4935302734375
      ],
      "bbox_max": [
        -1179.889404296875,
        -4279.16796875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8288367390632629,
        0.559461236000061,
        -0.005722843110561371
      ],
      "plane_d": 3375.775146484375,
      "bbox_min": [
        -1181.8798828125,
        -4279.7255859375,
        595.3397216796875
      ],
      "bbox_max": [
        -1180.0,
        -4265.19921875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8381403088569641,
        0.5454541444778442,
        -0.0007736951811239123
      ],
      "plane_d": 3323.60595703125,
      "bbox_min": [
        -1181.8798828125,
        -4279.1845703125,
        648.2435913085938
      ],
      "bbox_max": [
        -1180.0,
        -4276.279296875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9764060378074646,
        -0.21226218342781067,
        0.03970105201005936
      ],
      "plane_d": 220.09959411621094,
      "bbox_min": [
        -1181.8798828125,
        -4279.7255859375,
        595.3397216796875
      ],
      "bbox_max": [
        -1180.0,
        -4265.19921875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9842250943183899,
        -0.1669844537973404,
        0.05845712497830391
      ],
      "plane_d": 410.5820007324219,
      "bbox_min": [
        -1181.8798828125,
        -4276.279296875,
        645.0784301757812
      ],
      "bbox_max": [
        -1180.0,
        -4265.19921875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9936339259147644,
        -0.03208557143807411,
        0.10799193382263184
      ],
      "plane_d": 871.3460693359375,
      "bbox_min": [
        -1148.2236328125,
        -3730.0,
        660.0
      ],
      "bbox_max": [
        -798.61328125,
        -3650.0,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.970560610294342,
        0.21886040270328522,
        0.10055909305810928
      ],
      "plane_d": 1788.025390625,
      "bbox_min": [
        -1148.2236328125,
        -3730.0,
        660.0
      ],
      "bbox_max": [
        -1068.641357421875,
        -3650.0,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9113858938217163,
        0.4086766242980957,
        0.04857178404927254
      ],
      "plane_d": 2467.397705078125,
      "bbox_min": [
        -1125.0511474609375,
        -3730.0,
        660.0
      ],
      "bbox_max": [
        -1069.8994140625,
        -3650.0,
        1021.7411499023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.008366312831640244,
        0.20373092591762543,
        0.9789910912513733
      ],
      "plane_d": 84.7491455078125,
      "bbox_min": [
        -1107.3037109375,
        -3730.0,
        663.5450439453125
      ],
      "bbox_max": [
        -1071.6546630859375,
        -3650.0,
        730.3077392578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.19703593850135803,
        0.9803962111473083
      ],
      "plane_d": 67.79168701171875,
      "bbox_min": [
        -1072.2828369140625,
        -3730.0,
        680.37109375
      ],
      "bbox_max": [
        -1071.6546630859375,
        -3729.395263671875,
        680.4926147460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4539933204650879,
        0.8910050988197327,
        -3.567880185073591e-06
      ],
      "plane_d": 2761.940673828125,
      "bbox_min": [
        -1104.865966796875,
        -3714.739990234375,
        669.5352783203125
      ],
      "bbox_max": [
        -1080.7603759765625,
        -3660.98583984375,
        730.3077392578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8099832534790039,
        0.41270411014556885,
        0.4166563153266907
      ],
      "plane_d": 2106.439697265625,
      "bbox_min": [
        -1104.865966796875,
        -3714.739990234375,
        713.083740234375
      ],
      "bbox_max": [
        -1080.7603759765625,
        -3661.93798828125,
        730.3077392578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8027299642562866,
        0.47994333505630493,
        0.35394755005836487
      ],
      "plane_d": 2390.739013671875,
      "bbox_min": [
        -1104.865966796875,
        -3676.31396484375,
        713.083740234375
      ],
      "bbox_max": [
        -1097.0975341796875,
        -3661.93798828125,
        722.522705078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.008366312831640244,
        0.20373092591762543,
        0.9789910912513733
      ],
      "plane_d": 84.7491455078125,
      "bbox_min": [
        -1105.9620361328125,
        -3727.158935546875,
        660.0
      ],
      "bbox_max": [
        -1072.234130859375,
        -3650.0,
        723.5331420898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.887483537197113,
        0.44281768798828125,
        -0.12761466205120087
      ],
      "plane_d": 2677.966796875,
      "bbox_min": [
        -1105.0445556640625,
        -3700.49560546875,
        660.0
      ],
      "bbox_max": [
        -1076.1846923828125,
        -3650.0,
        673.009765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.09491465240716934,
        0.2607119083404541,
        0.9607395529747009
      ],
      "plane_d": 418.97088623046875,
      "bbox_min": [
        -1105.0445556640625,
        -3694.315673828125,
        663.157470703125
      ],
      "bbox_max": [
        -1078.9261474609375,
        -3650.0,
        673.009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33965566754341125,
        -0.015412183478474617,
        -0.9404236078262329
      ],
      "plane_d": 947.748779296875,
      "bbox_min": [
        -1103.2484130859375,
        -3713.330322265625,
        669.9990234375
      ],
      "bbox_max": [
        -1075.919921875,
        -3655.207763671875,
        723.5331420898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8027299642562866,
        0.47994598746299744,
        0.35394418239593506
      ],
      "plane_d": 2390.7509765625,
      "bbox_min": [
        -1103.2484130859375,
        -3713.330322265625,
        669.9990234375
      ],
      "bbox_max": [
        -1075.919921875,
        -3655.207763671875,
        723.5331420898438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.4539933204650879,
        0.8910050988197327,
        -3.567880185073591e-06
      ],
      "plane_d": 2761.940673828125,
      "bbox_min": [
        -1103.2484130859375,
        -3713.330322265625,
        669.9990234375
      ],
      "bbox_max": [
        -1075.919921875,
        -3655.207763671875,
        723.5331420898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45399174094200134,
        -0.8910059332847595,
        -1.2316695574554615e-07
      ],
      "plane_d": -2817.94287109375,
      "bbox_min": [
        -1097.0975341796875,
        -3713.330322265625,
        678.9856567382812
      ],
      "bbox_max": [
        -1075.919921875,
        -3676.31396484375,
        723.5331420898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8099832534790039,
        0.41270411014556885,
        0.4166563153266907
      ],
      "plane_d": 2106.439697265625,
      "bbox_min": [
        -1097.0975341796875,
        -3713.330322265625,
        704.11962890625
      ],
      "bbox_max": [
        -1079.7301025390625,
        -3676.31396484375,
        723.5331420898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9872744679450989,
        0.13782483339309692,
        0.07933098822832108
      ],
      "plane_d": 1533.3360595703125,
      "bbox_min": [
        -1148.2236328125,
        -3730.0,
        660.0
      ],
      "bbox_max": [
        -1068.641357421875,
        -3650.0,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33965566754341125,
        -0.015412183478474617,
        -0.9404236078262329
      ],
      "plane_d": 947.748779296875,
      "bbox_min": [
        -1086.3753662109375,
        -3730.0,
        660.0
      ],
      "bbox_max": [
        -1068.641357421875,
        -3662.398681640625,
        721.01025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8027299642562866,
        0.47994598746299744,
        0.35394418239593506
      ],
      "plane_d": 2390.7509765625,
      "bbox_min": [
        -1086.3753662109375,
        -3712.805419921875,
        675.441162109375
      ],
      "bbox_max": [
        -1070.3065185546875,
        -3662.398681640625,
        721.01025390625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.45399174094200134,
        -0.8910059332847595,
        -1.2316695574554615e-07
      ],
      "plane_d": -2817.94287109375,
      "bbox_min": [
        -1083.48876953125,
        -3712.805419921875,
        680.0115966796875
      ],
      "bbox_max": [
        -1070.775634765625,
        -3688.376220703125,
        721.01025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8099832534790039,
        0.41270411014556885,
        0.4166563153266907
      ],
      "plane_d": 2106.439697265625,
      "bbox_min": [
        -1083.48876953125,
        -3712.805419921875,
        691.351806640625
      ],
      "bbox_max": [
        -1071.5120849609375,
        -3688.376220703125,
        721.01025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.008366312831640244,
        0.20373092591762543,
        0.9789910912513733
      ],
      "plane_d": 84.7491455078125,
      "bbox_min": [
        -1079.8343505859375,
        -3730.0,
        660.0
      ],
      "bbox_max": [
        -1068.641357421875,
        -3689.761962890625,
        680.4926147460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.887483537197113,
        0.44281768798828125,
        -0.12761466205120087
      ],
      "plane_d": 2677.966796875,
      "bbox_min": [
        -1079.8343505859375,
        -3730.0,
        660.0
      ],
      "bbox_max": [
        -1068.641357421875,
        -3689.761962890625,
        680.4926147460938
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.09491465240716934,
        0.2607119083404541,
        0.9607395529747009
      ],
      "plane_d": 418.97088623046875,
      "bbox_min": [
        -1079.8343505859375,
        -3730.0,
        671.8638305664062
      ],
      "bbox_max": [
        -1070.1229248046875,
        -3689.761962890625,
        680.4926147460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.19703593850135803,
        0.9803962111473083
      ],
      "plane_d": 67.79168701171875,
      "bbox_min": [
        -1071.7784423828125,
        -3730.0,
        680.2478637695312
      ],
      "bbox_max": [
        -1071.2672119140625,
        -3728.7822265625,
        680.4926147460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6607861518859863,
        -0.7483370900154114,
        0.05790644884109497
      ],
      "plane_d": -3397.280517578125,
      "bbox_min": [
        -1073.389892578125,
        -3730.0,
        660.0
      ],
      "bbox_max": [
        -798.61328125,
        -3650.0,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6438754796981812,
        -0.7624677419662476,
        0.06377595663070679
      ],
      "plane_d": -3441.28662109375,
      "bbox_min": [
        -894.7830810546875,
        -3730.0,
        925.9322509765625
      ],
      "bbox_max": [
        -798.61328125,
        -3650.0,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45399174094200134,
        -0.8910059332847595,
        -1.2316695574554615e-07
      ],
      "plane_d": -2817.94287109375,
      "bbox_min": [
        -1073.389892578125,
        -3730.0,
        660.0
      ],
      "bbox_max": [
        -1063.8524169921875,
        -3693.935546875,
        705.4850463867188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8099832534790039,
        0.41270411014556885,
        0.4166563153266907
      ],
      "plane_d": 2106.439697265625,
      "bbox_min": [
        -1073.389892578125,
        -3709.574951171875,
        681.7616577148438
      ],
      "bbox_max": [
        -1064.6158447265625,
        -3693.935546875,
        705.4850463867188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33965566754341125,
        -0.015412183478474617,
        -0.9404236078262329
      ],
      "plane_d": 947.748779296875,
      "bbox_min": [
        -1071.5120849609375,
        -3708.242919921875,
        681.7616577148438
      ],
      "bbox_max": [
        -1064.6158447265625,
        -3693.935546875,
        691.351806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8027299642562866,
        0.47994598746299744,
        0.35394418239593506
      ],
      "plane_d": 2390.7509765625,
      "bbox_min": [
        -1071.5120849609375,
        -3705.104248046875,
        681.7616577148438
      ],
      "bbox_max": [
        -1064.6158447265625,
        -3693.935546875,
        691.351806640625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.961825430393219,
        -0.25134381651878357,
        -0.10825055837631226
      ],
      "plane_d": 161.71240234375,
      "bbox_min": [
        -1071.3331298828125,
        -3730.0,
        660.0
      ],
      "bbox_max": [
        -1063.8524169921875,
        -3708.070068359375,
        680.4926147460938
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8874832987785339,
        0.44281822443008423,
        -0.12761376798152924
      ],
      "plane_d": 2677.968017578125,
      "bbox_min": [
        -1071.3331298828125,
        -3730.0,
        660.0
      ],
      "bbox_max": [
        -1063.8524169921875,
        -3708.070068359375,
        680.4926147460938
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.09491465240716934,
        0.2607119083404541,
        0.9607395529747009
      ],
      "plane_d": 418.97088623046875,
      "bbox_min": [
        -1071.3331298828125,
        -3730.0,
        675.8726196289062
      ],
      "bbox_max": [
        -1063.8524169921875,
        -3708.070068359375,
        680.4926147460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.19703593850135803,
        0.9803962111473083
      ],
      "plane_d": 67.79168701171875,
      "bbox_min": [
        -1071.3331298828125,
        -3730.0,
        678.4609985351562
      ],
      "bbox_max": [
        -1063.8524169921875,
        -3719.891357421875,
        680.4926147460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        -1387.0,
        -4443.85791015625,
        660.0
      ],
      "bbox_max": [
        -726.752685546875,
        -3730.0,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4170.0,
      "bbox_min": [
        -1030.0,
        -4395.6328125,
        660.0
      ],
      "bbox_max": [
        -726.752685546875,
        -3730.0,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9783579707145691,
        0.18061994016170502,
        0.10095646232366562
      ],
      "plane_d": -157.85714721679688,
      "bbox_min": [
        -1013.87158203125,
        -4170.0,
        660.0
      ],
      "bbox_max": [
        -726.752685546875,
        -3730.0,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6452460289001465,
        0.7534409165382385,
        0.12642896175384521
      ],
      "plane_d": 2379.466552734375,
      "bbox_min": [
        -1013.87158203125,
        -4170.0,
        660.0
      ],
      "bbox_max": [
        -726.752685546875,
        -3730.0,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.963800847530365,
        0.25079625844955444,
        0.09049401432275772
      ],
      "plane_d": 8.92401123046875,
      "bbox_min": [
        -1013.87158203125,
        -4170.0,
        660.0
      ],
      "bbox_max": [
        -978.5899047851562,
        -4127.744140625,
        1035.7659912109375
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -0.566495954990387,
        0.819241464138031,
        0.08902643620967865
      ],
      "plane_d": 2754.736328125,
      "bbox_min": [
        -1002.8759765625,
        -4170.0,
        660.0
      ],
      "bbox_max": [
        -726.752685546875,
        -3730.0,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.963800847530365,
        0.25079625844955444,
        0.09049401432275772
      ],
      "plane_d": 8.92401123046875,
      "bbox_min": [
        -1002.8759765625,
        -4170.0,
        660.0
      ],
      "bbox_max": [
        -951.4599609375,
        -4127.744140625,
        1302.5999755859375
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -0.9810741543769836,
        0.16107186675071716,
        0.10746750980615616
      ],
      "plane_d": -403.0553894042969,
      "bbox_min": [
        -958.1337280273438,
        -4170.0,
        1253.6328125
      ],
      "bbox_max": [
        -951.4599609375,
        -4162.021484375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.967786967754364,
        0.22291091084480286,
        0.11704368144273758
      ],
      "plane_d": 0.13446807861328125,
      "bbox_min": [
        -859.2266845703125,
        -4038.2421875,
        660.0
      ],
      "bbox_max": [
        -726.752685546875,
        -3730.0,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6438754796981812,
        -0.7624677419662476,
        0.06377595663070679
      ],
      "plane_d": -3441.28662109375,
      "bbox_min": [
        -859.2266845703125,
        -3790.68359375,
        660.0
      ],
      "bbox_max": [
        -726.752685546875,
        -3730.0,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6607861518859863,
        -0.7483370900154114,
        0.05790644884109497
      ],
      "plane_d": -3397.280517578125,
      "bbox_min": [
        -859.2266845703125,
        -3788.740234375,
        660.0
      ],
      "bbox_max": [
        -792.70361328125,
        -3730.0,
        925.9322509765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9810741543769836,
        0.16107186675071716,
        0.10746750980615616
      ],
      "plane_d": -403.0553894042969,
      "bbox_min": [
        -1030.0,
        -4395.6328125,
        660.0
      ],
      "bbox_max": [
        -952.7698974609375,
        -4170.0,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.963800847530365,
        0.25079625844955444,
        0.09049401432275772
      ],
      "plane_d": 8.92401123046875,
      "bbox_min": [
        -1030.0,
        -4255.916015625,
        660.0
      ],
      "bbox_max": [
        -958.1337890625,
        -4170.0,
        1253.6326904296875
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -740.0,
      "bbox_min": [
        -1017.289306640625,
        -4212.0,
        737.0096435546875
      ],
      "bbox_max": [
        -980.0,
        -4170.0,
        768.9903564453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19232173264026642,
        0.05004517361521721,
        0.9800549745559692
      ],
      "plane_d": -707.2205810546875,
      "bbox_min": [
        -1015.4232788085938,
        -4204.32177734375,
        737.0096435546875
      ],
      "bbox_max": [
        -986.642333984375,
        -4181.080078125,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11766355484724045,
        0.1246652752161026,
        0.9851973652839661
      ],
      "plane_d": -323.6327209472656,
      "bbox_min": [
        -1009.5684204101562,
        -4193.51025390625,
        737.0096435546875
      ],
      "bbox_max": [
        -986.642333984375,
        -4181.25,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09507948905229568,
        -0.9932264685630798,
        0.06679175049066544
      ],
      "plane_d": -4298.1435546875,
      "bbox_min": [
        -1009.5684204101562,
        -4183.24365234375,
        737.0096435546875
      ],
      "bbox_max": [
        -986.642333984375,
        -4181.25,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11182716488838196,
        0.9751096367835999,
        0.1914573758840561
      ],
      "plane_d": 3844.459228515625,
      "bbox_min": [
        -1015.4232788085938,
        -4204.32177734375,
        737.0096435546875
      ],
      "bbox_max": [
        -994.6494750976562,
        -4181.080078125,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09507948905229568,
        -0.9932264685630798,
        0.06679175049066544
      ],
      "plane_d": -4298.1435546875,
      "bbox_min": [
        -1009.5684204101562,
        -4182.47705078125,
        737.0096435546875
      ],
      "bbox_max": [
        -994.6494750976562,
        -4181.080078125,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09507948905229568,
        -0.9932264685630798,
        0.06679175049066544
      ],
      "plane_d": -4298.1435546875,
      "bbox_min": [
        -1015.2913818359375,
        -4207.0,
        740.0
      ],
      "bbox_max": [
        -984.1784057617188,
        -4180.0,
        768.9903564453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22465400397777557,
        -0.9713456034660339,
        -0.07757844775915146
      ],
      "plane_d": -4227.609375,
      "bbox_min": [
        -1015.2913818359375,
        -4207.0,
        740.0
      ],
      "bbox_max": [
        -984.1784057617188,
        -4180.0,
        768.9903564453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17370472848415375,
        0.9826855063438416,
        0.06446682661771774
      ],
      "plane_d": 3909.296630859375,
      "bbox_min": [
        -1015.2913818359375,
        -4207.0,
        740.0
      ],
      "bbox_max": [
        -984.1784057617188,
        -4180.0,
        768.9903564453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13940393924713135,
        0.9031103253364563,
        -0.4061507284641266
      ],
      "plane_d": 3964.17333984375,
      "bbox_min": [
        -1015.2913818359375,
        -4207.0,
        740.0
      ],
      "bbox_max": [
        -984.1784057617188,
        -4180.0,
        768.9903564453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11182716488838196,
        0.9751096367835999,
        0.1914573758840561
      ],
      "plane_d": 3844.459228515625,
      "bbox_min": [
        -1015.2913818359375,
        -4207.0,
        740.0
      ],
      "bbox_max": [
        -984.1784057617188,
        -4180.0,
        768.9903564453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1634165495634079,
        -0.08626612275838852,
        -0.9827782511711121
      ],
      "plane_d": 228.1746826171875,
      "bbox_min": [
        -1011.379638671875,
        -4203.0,
        740.0
      ],
      "bbox_max": [
        -984.1784057617188,
        -4180.0,
        768.9903564453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1509142369031906,
        0.8946962356567383,
        -0.42040878534317017
      ],
      "plane_d": 3928.1591796875,
      "bbox_min": [
        -1011.379638671875,
        -4203.0,
        740.0
      ],
      "bbox_max": [
        -984.1784057617188,
        -4180.0,
        768.9903564453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.28681355714797974,
        -0.27080902457237244,
        -0.9189125895500183
      ],
      "plane_d": -717.3099975585938,
      "bbox_min": [
        -1007.5340576171875,
        -4203.0,
        740.0
      ],
      "bbox_max": [
        -984.1784057617188,
        -4180.0,
        766.9903564453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26488083600997925,
        -0.8408960103988647,
        -0.47194477915763855
      ],
      "plane_d": -3423.521484375,
      "bbox_min": [
        -1007.5340576171875,
        -4203.0,
        740.0
      ],
      "bbox_max": [
        -984.1784057617188,
        -4180.0,
        766.9903564453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26753267645835876,
        -0.845711350440979,
        -0.4617342948913574
      ],
      "plane_d": -3454.0703125,
      "bbox_min": [
        -1007.5340576171875,
        -4188.25,
        759.0
      ],
      "bbox_max": [
        -984.5340576171875,
        -4180.0,
        766.9903564453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9701484441757202,
        0.16855931282043457,
        0.17435529828071594
      ],
      "plane_d": -381.01666259765625,
      "bbox_min": [
        -999.8734130859375,
        -4203.0,
        740.0
      ],
      "bbox_max": [
        -984.1784057617188,
        -4183.24365234375,
        764.9903564453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9162644147872925,
        0.3815375864505768,
        -0.12201853096485138
      ],
      "plane_d": 787.091064453125,
      "bbox_min": [
        -999.8734130859375,
        -4203.0,
        740.0
      ],
      "bbox_max": [
        -984.1784057617188,
        -4183.24365234375,
        764.9903564453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9124410152435303,
        0.3799455165863037,
        0.15196284651756287
      ],
      "plane_d": 577.3353271484375,
      "bbox_min": [
        -991.6737060546875,
        -4203.0,
        755.0
      ],
      "bbox_max": [
        -984.1784057617188,
        -4185.0,
        764.9903564453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9100977778434753,
        0.4051172733306885,
        0.08718980103731155
      ],
      "plane_d": 734.3595581054688,
      "bbox_min": [
        -991.6737060546875,
        -4203.0,
        755.0
      ],
      "bbox_max": [
        -984.5340576171875,
        -4188.25,
        764.9903564453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11766355484724045,
        0.1246652752161026,
        0.9851973652839661
      ],
      "plane_d": -323.6327209472656,
      "bbox_min": [
        -999.8734130859375,
        -4202.5537109375,
        740.0
      ],
      "bbox_max": [
        -986.5684204101562,
        -4183.24365234375,
        742.0096435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19232173264026642,
        0.05004517361521721,
        0.9800549745559692
      ],
      "plane_d": -707.2205810546875,
      "bbox_min": [
        -999.8734130859375,
        -4202.5537109375,
        740.0
      ],
      "bbox_max": [
        -989.4232788085938,
        -4193.51025390625,
        742.0096435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -740.0,
      "bbox_min": [
        -1021.8406372070312,
        -4212.0,
        735.0
      ],
      "bbox_max": [
        -1006.3602905273438,
        -4170.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 735.0,
      "bbox_min": [
        -1021.8406372070312,
        -4212.0,
        735.0
      ],
      "bbox_max": [
        -1007.1583251953125,
        -4170.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4212.0,
      "bbox_min": [
        -1021.8406372070312,
        -4212.0,
        735.0
      ],
      "bbox_max": [
        -1017.617919921875,
        -4212.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8891926407814026,
        0.4445946514606476,
        0.10803722590208054
      ],
      "plane_d": 901.750732421875,
      "bbox_min": [
        -1030.0,
        -4395.6328125,
        735.0
      ],
      "bbox_max": [
        -972.4072265625,
        -4170.0,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8743228316307068,
        0.4749393165111542,
        0.09996094554662704
      ],
      "plane_d": 1056.8970947265625,
      "bbox_min": [
        -1030.0,
        -4395.6328125,
        735.0
      ],
      "bbox_max": [
        -972.4072265625,
        -4170.0,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -740.0,
      "bbox_min": [
        -1030.0,
        -4212.0,
        735.0
      ],
      "bbox_max": [
        -1014.3973999023438,
        -4170.0,
        746.2070922851562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 735.0,
      "bbox_min": [
        -1030.0,
        -4212.0,
        735.0
      ],
      "bbox_max": [
        -1014.9451904296875,
        -4170.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4212.0,
      "bbox_min": [
        -1030.0,
        -4212.0,
        735.0
      ],
      "bbox_max": [
        -1021.2929077148438,
        -4212.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4206.0,
      "bbox_min": [
        -1030.0,
        -4206.0,
        740.0
      ],
      "bbox_max": [
        -1027.2928466796875,
        -4202.0,
        746.2070922851562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4201.99951171875,
      "bbox_min": [
        -1030.0,
        -4206.0,
        740.0
      ],
      "bbox_max": [
        -1027.2928466796875,
        -4202.0,
        746.2070922851562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.0,
        0.7071068286895752
      ],
      "plane_d": 200.171875,
      "bbox_min": [
        -1030.0,
        -4206.0,
        740.0
      ],
      "bbox_max": [
        -1027.2928466796875,
        -4202.0,
        746.2070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1028.0,
      "bbox_min": [
        -1030.0,
        -4206.0,
        740.0
      ],
      "bbox_max": [
        -1027.2928466796875,
        -4202.0,
        746.2070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070762515068054,
        0.0,
        0.7071372866630554
      ],
      "plane_d": -1255.4593505859375,
      "bbox_min": [
        -1030.0,
        -4206.0,
        745.5
      ],
      "bbox_max": [
        -1029.2928466796875,
        -4202.0,
        746.2070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070762515068054,
        0.0,
        -0.7071372866630554
      ],
      "plane_d": 1252.6309814453125,
      "bbox_min": [
        -1028.0,
        -4206.0,
        743.5
      ],
      "bbox_max": [
        -1027.2928466796875,
        -4202.0,
        744.2070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4170.0,
      "bbox_min": [
        -1260.0,
        -4443.85791015625,
        660.0
      ],
      "bbox_max": [
        -1030.0,
        -3730.0,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9903396964073181,
        -0.09760256856679916,
        0.09849382936954498
      ],
      "plane_d": 629.6063232421875,
      "bbox_min": [
        -1193.3072509765625,
        -3924.0,
        660.0
      ],
      "bbox_max": [
        -1060.1568603515625,
        -3730.0,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9936339259147644,
        -0.03208557143807411,
        0.10799193382263184
      ],
      "plane_d": 871.3460693359375,
      "bbox_min": [
        -1193.3072509765625,
        -3924.0,
        660.0
      ],
      "bbox_max": [
        -1069.1593017578125,
        -3730.0,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9156805276870728,
        -0.3895663022994995,
        0.09882889688014984
      ],
      "plane_d": -571.7205810546875,
      "bbox_min": [
        -1193.3072509765625,
        -3924.0,
        660.0
      ],
      "bbox_max": [
        -1069.1593017578125,
        -3730.0,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8886986970901489,
        -0.4443504214286804,
        0.11299305409193039
      ],
      "plane_d": -830.3196411132812,
      "bbox_min": [
        -1193.3072509765625,
        -3924.0,
        660.0
      ],
      "bbox_max": [
        -1069.1593017578125,
        -3730.0,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14695137739181519,
        0.3395877182483673,
        0.9290239810943604
      ],
      "plane_d": 792.496337890625,
      "bbox_min": [
        -1118.85009765625,
        -3917.93359375,
        660.0
      ],
      "bbox_max": [
        -1069.1593017578125,
        -3730.0,
        749.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34197601675987244,
        -0.9395796060562134,
        0.015575435012578964
      ],
      "plane_d": -4072.351806640625,
      "bbox_min": [
        -1118.85009765625,
        -3917.93359375,
        660.0
      ],
      "bbox_max": [
        -1113.708740234375,
        -3916.062255859375,
        682.0844116210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1640959084033966,
        -0.9845755100250244,
        0.06069443002343178
      ],
      "plane_d": -4000.902099609375,
      "bbox_min": [
        -1100.665771484375,
        -3840.05615234375,
        660.0
      ],
      "bbox_max": [
        -1069.1593017578125,
        -3730.0,
        721.8385009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9720087051391602,
        -0.20689089596271515,
        -0.11133354157209396
      ],
      "plane_d": 332.78009033203125,
      "bbox_min": [
        -1100.665771484375,
        -3840.05615234375,
        660.0
      ],
      "bbox_max": [
        -1069.1593017578125,
        -3730.0,
        715.628662109375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.17364419996738434,
        0.9848084449768066,
        1.4249357036533183e-06
      ],
      "plane_d": 3932.344482421875,
      "bbox_min": [
        -1097.887451171875,
        -3802.447509765625,
        660.0
      ],
      "bbox_max": [
        -1069.1593017578125,
        -3730.0,
        709.3654174804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1736554205417633,
        -0.984806478023529,
        5.438104381028097e-06
      ],
      "plane_d": -3912.843994140625,
      "bbox_min": [
        -1094.665771484375,
        -3783.0908203125,
        660.0
      ],
      "bbox_max": [
        -1069.1593017578125,
        -3730.0,
        701.885986328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17364419996738434,
        0.9848084449768066,
        1.4249357036533183e-06
      ],
      "plane_d": 3896.834228515625,
      "bbox_min": [
        -1091.887451171875,
        -3767.231201171875,
        660.0
      ],
      "bbox_max": [
        -1069.1593017578125,
        -3730.0,
        695.633544921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9113858938217163,
        0.4086766242980957,
        0.04857178404927254
      ],
      "plane_d": 2467.397705078125,
      "bbox_min": [
        -1070.2890625,
        -3731.650390625,
        660.0
      ],
      "bbox_max": [
        -1069.1593017578125,
        -3730.0,
        667.3118286132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.970560610294342,
        0.21886040270328522,
        0.10055909305810928
      ],
      "plane_d": 1788.025390625,
      "bbox_min": [
        -1100.665771484375,
        -3838.027587890625,
        679.8941040039062
      ],
      "bbox_max": [
        -1071.3331298828125,
        -3730.0,
        749.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17364419996738434,
        0.9848084449768066,
        1.4249357036533183e-06
      ],
      "plane_d": 3896.834228515625,
      "bbox_min": [
        -1100.665771484375,
        -3838.027587890625,
        680.4750366210938
      ],
      "bbox_max": [
        -1071.400390625,
        -3730.0,
        749.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.17364419996738434,
        0.9848084449768066,
        1.4249357036533183e-06
      ],
      "plane_d": 3932.344482421875,
      "bbox_min": [
        -1100.665771484375,
        -3838.027587890625,
        700.3464965820312
      ],
      "bbox_max": [
        -1078.240234375,
        -3765.638427734375,
        749.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.1736554205417633,
        -0.984806478023529,
        5.438104381028097e-06
      ],
      "plane_d": -3948.35400390625,
      "bbox_min": [
        -1100.665771484375,
        -3838.027587890625,
        713.97900390625
      ],
      "bbox_max": [
        -1083.065673828125,
        -3800.638427734375,
        749.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.650592029094696,
        -0.1147187352180481,
        0.7507128119468689
      ],
      "plane_d": -288.49652099609375,
      "bbox_min": [
        -1093.7720947265625,
        -3817.80224609375,
        741.869384765625
      ],
      "bbox_max": [
        -1084.3336181640625,
        -3800.638427734375,
        749.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07670561969280243,
        0.4602333605289459,
        0.8844780921936035
      ],
      "plane_d": 1211.2657470703125,
      "bbox_min": [
        -1087.6220703125,
        -3838.027587890625,
        721.2744140625
      ],
      "bbox_max": [
        -1085.8966064453125,
        -3837.01611328125,
        721.8385009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1640959084033966,
        -0.9845755100250244,
        0.06069443002343178
      ],
      "plane_d": -4000.902099609375,
      "bbox_min": [
        -1087.6220703125,
        -3838.027587890625,
        721.7197265625
      ],
      "bbox_max": [
        -1086.375,
        -3837.8125,
        721.8385009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1736554205417633,
        -0.984806478023529,
        5.438104381028097e-06
      ],
      "plane_d": -3912.843994140625,
      "bbox_min": [
        -1094.665771484375,
        -3783.076171875,
        700.3464965820312
      ],
      "bbox_max": [
        -1078.240234375,
        -3765.638427734375,
        736.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.650592029094696,
        -0.1147187352180481,
        0.7507128119468689
      ],
      "plane_d": -278.6257019042969,
      "bbox_min": [
        -1087.7720947265625,
        -3782.5634765625,
        730.0797119140625
      ],
      "bbox_max": [
        -1079.688232421875,
        -3765.638427734375,
        736.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.3964721549418755e-06,
        0.3461495637893677,
        0.9381793141365051
      ],
      "plane_d": 652.9764404296875,
      "bbox_min": [
        -1074.33935546875,
        -3753.035400390625,
        680.4750366210938
      ],
      "bbox_max": [
        -1071.400390625,
        -3730.0,
        688.7144775390625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.19703593850135803,
        0.9803962111473083
      ],
      "plane_d": 67.79168701171875,
      "bbox_min": [
        -1073.6593017578125,
        -3731.650390625,
        680.4926147460938
      ],
      "bbox_max": [
        -1071.400390625,
        -3730.0,
        680.8242797851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.19703593850135803,
        0.9803962111473083
      ],
      "plane_d": 67.79168701171875,
      "bbox_min": [
        -1071.6546630859375,
        -3731.2421875,
        680.4926147460938
      ],
      "bbox_max": [
        -1071.3331298828125,
        -3730.0,
        680.7422485351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9907258749008179,
        -0.09288055449724197,
        0.09917348623275757
      ],
      "plane_d": 688.5936279296875,
      "bbox_min": [
        -1193.3072509765625,
        -3924.0,
        1302.365234375
      ],
      "bbox_max": [
        -1193.28369140625,
        -3923.984375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9282523393630981,
        -0.32365739345550537,
        0.1832856684923172
      ],
      "plane_d": -360.9432067871094,
      "bbox_min": [
        -1124.26611328125,
        -3924.0,
        660.0
      ],
      "bbox_max": [
        -1079.6220703125,
        -3836.232666015625,
        733.905029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -689.3931884765625,
      "bbox_min": [
        -1115.6378173828125,
        -3919.38720703125,
        660.0
      ],
      "bbox_max": [
        -1097.76123046875,
        -3884.59033203125,
        689.3931884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34197601675987244,
        -0.9395796060562134,
        0.015575435012578964
      ],
      "plane_d": -4072.351806640625,
      "bbox_min": [
        -1115.6378173828125,
        -3919.38720703125,
        660.0
      ],
      "bbox_max": [
        -1097.76123046875,
        -3886.58837890625,
        689.3931884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8154934048652649,
        -0.5618152618408203,
        -0.13904687762260437
      ],
      "plane_d": -1204.5438232421875,
      "bbox_min": [
        -1110.3929443359375,
        -3919.38720703125,
        660.0
      ],
      "bbox_max": [
        -1097.76123046875,
        -3886.58837890625,
        666.7886352539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9847401976585388,
        -0.09371570497751236,
        -0.1466427892446518
      ],
      "plane_d": 814.3311767578125,
      "bbox_min": [
        -1099.26416015625,
        -3894.14599609375,
        660.0
      ],
      "bbox_max": [
        -1097.76123046875,
        -3886.58837890625,
        665.387939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -689.3931884765625,
      "bbox_min": [
        -1113.250244140625,
        -3920.209228515625,
        660.0
      ],
      "bbox_max": [
        -1082.572021484375,
        -3836.232666015625,
        721.8385009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9847401976585388,
        -0.09371570497751236,
        -0.1466427892446518
      ],
      "plane_d": 814.3311767578125,
      "bbox_min": [
        -1113.250244140625,
        -3920.209228515625,
        660.0
      ],
      "bbox_max": [
        -1094.26953125,
        -3884.900390625,
        689.3931884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34197601675987244,
        -0.9395796060562134,
        0.015575435012578964
      ],
      "plane_d": -4072.351806640625,
      "bbox_min": [
        -1113.250244140625,
        -3920.209228515625,
        666.7886352539062
      ],
      "bbox_max": [
        -1106.1175537109375,
        -3917.613037109375,
        689.3931884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1640959084033966,
        -0.9845755100250244,
        0.06069443002343178
      ],
      "plane_d": -4000.902099609375,
      "bbox_min": [
        -1086.384033203125,
        -3839.79296875,
        690.44384765625
      ],
      "bbox_max": [
        -1082.572021484375,
        -3836.232666015625,
        721.8385009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7242292165756226,
        -0.6868503093719482,
        -0.06106248497962952
      ],
      "plane_d": -1809.2698974609375,
      "bbox_min": [
        -1086.384033203125,
        -3839.79296875,
        690.44384765625
      ],
      "bbox_max": [
        -1082.572021484375,
        -3836.232666015625,
        721.8385009765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.14695137739181519,
        0.3395877182483673,
        0.9290239810943604
      ],
      "plane_d": 792.496337890625,
      "bbox_min": [
        -1085.8966064453125,
        -3837.01611328125,
        720.9295043945312
      ],
      "bbox_max": [
        -1085.526123046875,
        -3836.232666015625,
        721.2744140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.3964721549418755e-06,
        0.3461495637893677,
        0.9381793141365051
      ],
      "plane_d": 652.9764404296875,
      "bbox_min": [
        -1071.643798828125,
        -3734.70751953125,
        680.4926147460938
      ],
      "bbox_max": [
        -1071.03466796875,
        -3730.0,
        681.9522094726562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.19703593850135803,
        0.9803962111473083
      ],
      "plane_d": 67.79168701171875,
      "bbox_min": [
        -1071.4224853515625,
        -3731.650390625,
        680.4926147460938
      ],
      "bbox_max": [
        -1071.03466796875,
        -3730.0,
        680.8242797851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9720087051391602,
        -0.20689064264297485,
        -0.11133477091789246
      ],
      "plane_d": 332.7818603515625,
      "bbox_min": [
        -1085.8021240234375,
        -3839.61083984375,
        660.0
      ],
      "bbox_max": [
        -1060.1568603515625,
        -3730.0,
        743.0487060546875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        2.3964721549418755e-06,
        0.3461495637893677,
        0.9381793141365051
      ],
      "plane_d": 652.9764404296875,
      "bbox_min": [
        -1085.8021240234375,
        -3839.61083984375,
        660.0
      ],
      "bbox_max": [
        -1060.1568603515625,
        -3730.0,
        743.0487060546875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7242292165756226,
        -0.6868503093719482,
        -0.06106248497962952
      ],
      "plane_d": -1809.2698974609375,
      "bbox_min": [
        -1085.6473388671875,
        -3839.61083984375,
        660.0
      ],
      "bbox_max": [
        -1060.1568603515625,
        -3730.0,
        720.3847045898438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8187175989151001,
        0.5606518387794495,
        -0.12397938221693039
      ],
      "plane_d": 3049.857421875,
      "bbox_min": [
        -1085.6473388671875,
        -3839.61083984375,
        660.0
      ],
      "bbox_max": [
        -1060.1568603515625,
        -3730.0,
        720.3847045898438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.1640959084033966,
        -0.9845755100250244,
        0.06069443002343178
      ],
      "plane_d": -4000.902099609375,
      "bbox_min": [
        -1085.6473388671875,
        -3839.61083984375,
        693.1275634765625
      ],
      "bbox_max": [
        -1067.941650390625,
        -3767.217041015625,
        720.3847045898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8820419907569885,
        -0.3010576665401459,
        -0.3624447286128998
      ],
      "plane_d": 59.09832763671875,
      "bbox_min": [
        -1082.9500732421875,
        -3819.360107421875,
        693.1275634765625
      ],
      "bbox_max": [
        -1067.941650390625,
        -3767.217041015625,
        713.185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17364419996738434,
        0.9848084449768066,
        1.4249357036533183e-06
      ],
      "plane_d": 3896.834228515625,
      "bbox_min": [
        -1082.9500732421875,
        -3819.257080078125,
        693.1275634765625
      ],
      "bbox_max": [
        -1067.941650390625,
        -3767.217041015625,
        713.1475219726562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.1736554205417633,
        -0.984806478023529,
        5.438104381028097e-06
      ],
      "plane_d": -3948.35400390625,
      "bbox_min": [
        -1082.9500732421875,
        -3819.257080078125,
        712.5823364257812
      ],
      "bbox_max": [
        -1077.543212890625,
        -3818.303466796875,
        713.1475219726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17364419996738434,
        0.9848084449768066,
        1.4249357036533183e-06
      ],
      "plane_d": 3932.344482421875,
      "bbox_min": [
        -1077.616455078125,
        -3819.360107421875,
        700.0
      ],
      "bbox_max": [
        -1070.874267578125,
        -3784.1484375,
        713.185546875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.1736554205417633,
        -0.984806478023529,
        5.438104381028097e-06
      ],
      "plane_d": -3948.35400390625,
      "bbox_min": [
        -1077.616455078125,
        -3819.360107421875,
        712.95849609375
      ],
      "bbox_max": [
        -1076.95849609375,
        -3819.244140625,
        713.185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8550534248352051,
        -0.1507713496685028,
        -0.49613672494888306
      ],
      "plane_d": 692.5126953125,
      "bbox_min": [
        -1071.0303955078125,
        -3784.375,
        700.0
      ],
      "bbox_max": [
        -1070.874267578125,
        -3784.1484375,
        700.2774658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1736554205417633,
        -0.984806478023529,
        5.438104381028097e-06
      ],
      "plane_d": -3912.843994140625,
      "bbox_min": [
        -1071.0303955078125,
        -3784.375,
        700.0
      ],
      "bbox_max": [
        -1070.874267578125,
        -3784.347412109375,
        700.2774658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8550534248352051,
        -0.1507713496685028,
        -0.49613672494888306
      ],
      "plane_d": 698.8158569335938,
      "bbox_min": [
        -1077.0303955078125,
        -3819.365966796875,
        713.0
      ],
      "bbox_max": [
        -1076.9248046875,
        -3819.212890625,
        713.187744140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1736554205417633,
        -0.984806478023529,
        5.438104381028097e-06
      ],
      "plane_d": -3948.35400390625,
      "bbox_min": [
        -1077.0303955078125,
        -3819.365966796875,
        713.0
      ],
      "bbox_max": [
        -1076.9248046875,
        -3819.347412109375,
        713.187744140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.961825430393219,
        -0.25134381651878357,
        -0.10825055837631226
      ],
      "plane_d": 161.71240234375,
      "bbox_min": [
        -1069.2266845703125,
        -3732.506103515625,
        660.0
      ],
      "bbox_max": [
        -1066.296630859375,
        -3730.0,
        680.8242797851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14695137739181519,
        0.3395877182483673,
        0.9290239810943604
      ],
      "plane_d": 792.496337890625,
      "bbox_min": [
        -1085.8021240234375,
        -3838.872314453125,
        680.21533203125
      ],
      "bbox_max": [
        -1062.693115234375,
        -3730.0,
        743.0487060546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7242263555526733,
        -0.6868535280227661,
        -0.06106049194931984
      ],
      "plane_d": -1809.286865234375,
      "bbox_min": [
        -1085.7860107421875,
        -3838.872314453125,
        693.9468994140625
      ],
      "bbox_max": [
        -1074.43603515625,
        -3767.212646484375,
        721.6637573242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1736554205417633,
        -0.984806478023529,
        5.438104381028097e-06
      ],
      "plane_d": -3948.35400390625,
      "bbox_min": [
        -1085.7860107421875,
        -3838.872314453125,
        693.9468994140625
      ],
      "bbox_max": [
        -1074.43603515625,
        -3767.212646484375,
        721.6637573242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8820419907569885,
        -0.3010576665401459,
        -0.3624447286128998
      ],
      "plane_d": 58.56536865234375,
      "bbox_min": [
        -1080.8914794921875,
        -3819.38623046875,
        693.9468994140625
      ],
      "bbox_max": [
        -1074.43603515625,
        -3767.212646484375,
        713.3927001953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8550534248352051,
        -0.1507713496685028,
        -0.49613672494888306
      ],
      "plane_d": 698.8158569335938,
      "bbox_min": [
        -1076.9305419921875,
        -3819.38623046875,
        713.1311645507812
      ],
      "bbox_max": [
        -1076.8094482421875,
        -3819.063720703125,
        713.3927001953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1640959084033966,
        -0.9845755100250244,
        0.06069443002343178
      ],
      "plane_d": -4000.902099609375,
      "bbox_min": [
        -1085.7860107421875,
        -3838.872314453125,
        720.1536254882812
      ],
      "bbox_max": [
        -1081.691650390625,
        -3838.129150390625,
        721.6637573242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17364338040351868,
        0.984808623790741,
        1.0773861731649959e-06
      ],
      "plane_d": 3896.83447265625,
      "bbox_min": [
        -1085.8021240234375,
        -3838.835693359375,
        680.21533203125
      ],
      "bbox_max": [
        -1062.693115234375,
        -3730.0,
        743.0487060546875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.1736554205417633,
        -0.984806478023529,
        5.438104381028097e-06
      ],
      "plane_d": -3912.843994140625,
      "bbox_min": [
        -1085.8021240234375,
        -3838.835693359375,
        694.4737548828125
      ],
      "bbox_max": [
        -1062.693115234375,
        -3766.573974609375,
        743.0487060546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.650592029094696,
        -0.1147187352180481,
        0.7507128119468689
      ],
      "plane_d": -278.6257019042969,
      "bbox_min": [
        -1081.146728515625,
        -3785.238525390625,
        694.4737548828125
      ],
      "bbox_max": [
        -1062.693115234375,
        -3766.573974609375,
        731.2590942382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8820419907569885,
        -0.3010576665401459,
        -0.3624447286128998
      ],
      "plane_d": 59.09832763671875,
      "bbox_min": [
        -1070.8828125,
        -3785.055908203125,
        694.4737548828125
      ],
      "bbox_max": [
        -1063.9368896484375,
        -3768.64501953125,
        707.8256225585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8550534248352051,
        -0.1507713496685028,
        -0.49613672494888306
      ],
      "plane_d": 692.5126953125,
      "bbox_min": [
        -1070.8828125,
        -3785.055908203125,
        700.1939086914062
      ],
      "bbox_max": [
        -1065.073486328125,
        -3776.316162109375,
        707.8256225585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17364338040351868,
        0.984808623790741,
        1.0773861731649959e-06
      ],
      "plane_d": 3932.344482421875,
      "bbox_min": [
        -1085.8021240234375,
        -3838.835693359375,
        707.3045654296875
      ],
      "bbox_max": [
        -1068.6585693359375,
        -3801.812744140625,
        743.0487060546875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.1736554205417633,
        -0.984806478023529,
        5.438104381028097e-06
      ],
      "plane_d": -3948.35400390625,
      "bbox_min": [
        -1085.8021240234375,
        -3838.835693359375,
        707.3850708007812
      ],
      "bbox_max": [
        -1068.6585693359375,
        -3801.812744140625,
        743.0487060546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8820419907569885,
        -0.3010576665401459,
        -0.3624447286128998
      ],
      "plane_d": 58.56536865234375,
      "bbox_min": [
        -1076.8199462890625,
        -3820.064208984375,
        707.3850708007812
      ],
      "bbox_max": [
        -1069.8837890625,
        -3803.638916015625,
        720.9176025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8550534248352051,
        -0.1507713496685028,
        -0.49613672494888306
      ],
      "plane_d": 698.8158569335938,
      "bbox_min": [
        -1076.8199462890625,
        -3820.064208984375,
        713.2764892578125
      ],
      "bbox_max": [
        -1071.0035400390625,
        -3811.2216796875,
        720.9176025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07670561969280243,
        0.4602333605289459,
        0.8844780921936035
      ],
      "plane_d": 1211.2657470703125,
      "bbox_min": [
        -1085.8021240234375,
        -3838.835693359375,
        717.9876098632812
      ],
      "bbox_max": [
        -1075.8416748046875,
        -3832.375244140625,
        721.8385009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7242263555526733,
        -0.6868535280227661,
        -0.06106049194931984
      ],
      "plane_d": -1809.286865234375,
      "bbox_min": [
        -1085.8021240234375,
        -3838.835693359375,
        717.9876098632812
      ],
      "bbox_max": [
        -1075.8416748046875,
        -3832.375244140625,
        721.8385009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1640959084033966,
        -0.9845755100250244,
        0.06069443002343178
      ],
      "plane_d": -4000.902099609375,
      "bbox_min": [
        -1085.8021240234375,
        -3838.835693359375,
        721.2743530273438
      ],
      "bbox_max": [
        -1081.6220703125,
        -3838.11572265625,
        721.8385009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.19703593850135803,
        0.9803962111473083
      ],
      "plane_d": 67.79168701171875,
      "bbox_min": [
        -1071.2303466796875,
        -3731.650390625,
        680.21533203125
      ],
      "bbox_max": [
        -1066.265380859375,
        -3730.0,
        680.8242797851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.961825430393219,
        -0.25134381651878357,
        -0.10825055837631226
      ],
      "plane_d": 161.71240234375,
      "bbox_min": [
        -1066.6593017578125,
        -3731.650390625,
        680.21533203125
      ],
      "bbox_max": [
        -1066.265380859375,
        -3730.0,
        680.8242797851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.650592029094696,
        -0.1147187352180481,
        0.7507128119468689
      ],
      "plane_d": -278.6257019042969,
      "bbox_min": [
        -1072.965087890625,
        -3820.736572265625,
        704.8065185546875
      ],
      "bbox_max": [
        -1060.37353515625,
        -3769.35107421875,
        729.4929809570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8550534248352051,
        -0.1507713496685028,
        -0.49613672494888306
      ],
      "plane_d": 692.5126953125,
      "bbox_min": [
        -1067.01220703125,
        -3785.736572265625,
        704.8065185546875
      ],
      "bbox_max": [
        -1060.37353515625,
        -3769.35107421875,
        716.5238037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1736554205417633,
        -0.984806478023529,
        5.438104381028097e-06
      ],
      "plane_d": -3912.843994140625,
      "bbox_min": [
        -1067.01220703125,
        -3785.736572265625,
        707.1402587890625
      ],
      "bbox_max": [
        -1060.37353515625,
        -3769.42041015625,
        716.5238037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17364338040351868,
        0.984808623790741,
        1.0773861731649959e-06
      ],
      "plane_d": 3896.83447265625,
      "bbox_min": [
        -1063.5439453125,
        -3769.9794921875,
        708.3660278320312
      ],
      "bbox_max": [
        -1060.37353515625,
        -3769.42041015625,
        716.0726928710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8820419907569885,
        -0.3010576665401459,
        -0.3624447286128998
      ],
      "plane_d": 59.09832763671875,
      "bbox_min": [
        -1065.073486328125,
        -3776.316162109375,
        704.8065185546875
      ],
      "bbox_max": [
        -1060.37353515625,
        -3769.35107421875,
        714.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17364338040351868,
        0.984808623790741,
        1.0773861731649959e-06
      ],
      "plane_d": 3896.83447265625,
      "bbox_min": [
        -1063.9368896484375,
        -3769.9794921875,
        704.8065185546875
      ],
      "bbox_max": [
        -1060.37353515625,
        -3769.35107421875,
        714.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.650592029094696,
        -0.1147187352180481,
        0.7507128119468689
      ],
      "plane_d": -288.49652099609375,
      "bbox_min": [
        -1072.965087890625,
        -3820.736572265625,
        717.9434814453125
      ],
      "bbox_max": [
        -1066.37353515625,
        -3804.360595703125,
        729.4929809570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8550534248352051,
        -0.1507713496685028,
        -0.49613672494888306
      ],
      "plane_d": 698.8158569335938,
      "bbox_min": [
        -1072.965087890625,
        -3820.736572265625,
        717.9434814453125
      ],
      "bbox_max": [
        -1066.37353515625,
        -3804.360595703125,
        729.4929809570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1736554205417633,
        -0.984806478023529,
        5.438104381028097e-06
      ],
      "plane_d": -3948.35400390625,
      "bbox_min": [
        -1072.965087890625,
        -3820.736572265625,
        720.2240600585938
      ],
      "bbox_max": [
        -1066.37353515625,
        -3804.428955078125,
        729.4929809570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17364338040351868,
        0.984808623790741,
        1.0773861731649959e-06
      ],
      "plane_d": 3932.344482421875,
      "bbox_min": [
        -1069.4967041015625,
        -3804.9794921875,
        721.4503173828125
      ],
      "bbox_max": [
        -1066.37353515625,
        -3804.428955078125,
        729.0418090820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8820419907569885,
        -0.3010576665401459,
        -0.3624447286128998
      ],
      "plane_d": 58.56536865234375,
      "bbox_min": [
        -1071.0035400390625,
        -3811.2216796875,
        717.9434814453125
      ],
      "bbox_max": [
        -1066.37353515625,
        -3804.360595703125,
        727.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17364338040351868,
        0.984808623790741,
        1.0773861731649959e-06
      ],
      "plane_d": 3932.344482421875,
      "bbox_min": [
        -1069.8837890625,
        -3804.9794921875,
        717.9434814453125
      ],
      "bbox_max": [
        -1066.37353515625,
        -3804.360595703125,
        727.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9907258749008179,
        -0.09288055449724197,
        0.09917348623275757
      ],
      "plane_d": 688.5936279296875,
      "bbox_min": [
        -1180.0,
        -4170.0,
        660.0
      ],
      "bbox_max": [
        -1109.6734619140625,
        -3924.0,
        1197.8870849609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.98377925157547,
        -0.15617449581623077,
        0.08824894577264786
      ],
      "plane_d": 438.3768310546875,
      "bbox_min": [
        -1180.0,
        -4170.0,
        660.0
      ],
      "bbox_max": [
        -1129.56591796875,
        -3929.073974609375,
        1087.7275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.98475581407547,
        -0.15801365673542023,
        0.07271608710289001
      ],
      "plane_d": 444.0865173339844,
      "bbox_min": [
        -1180.0,
        -4085.802734375,
        660.0
      ],
      "bbox_max": [
        -1129.56591796875,
        -3929.073974609375,
        778.18603515625
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.19583363831043243,
        -0.979168176651001,
        -0.05365469306707382
      ],
      "plane_d": -3734.36767578125,
      "bbox_min": [
        -1180.0,
        -4083.87451171875,
        660.0
      ],
      "bbox_max": [
        -1130.2979736328125,
        -3929.073974609375,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -701.3931884765625,
      "bbox_min": [
        -1138.4268798828125,
        -3964.7470703125,
        660.0
      ],
      "bbox_max": [
        -1130.2979736328125,
        -3929.073974609375,
        701.3931884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34197160601615906,
        0.9395811557769775,
        -0.015574740245938301
      ],
      "plane_d": 4089.33056640625,
      "bbox_min": [
        -1136.138427734375,
        -3964.7470703125,
        660.0
      ],
      "bbox_max": [
        -1130.2979736328125,
        -3929.073974609375,
        671.5169677734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9988681077957153,
        0.047565147280693054
      ],
      "plane_d": -4041.039794921875,
      "bbox_min": [
        -1180.0,
        -4083.87451171875,
        699.6690673828125
      ],
      "bbox_max": [
        -1146.5751953125,
        -4011.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0015727397985756397,
        -0.9987512230873108,
        0.04993755742907524
      ],
      "plane_d": -4044.1015625,
      "bbox_min": [
        -1180.0,
        -4012.0,
        706.0
      ],
      "bbox_max": [
        -1148.248046875,
        -4011.0,
        727.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.009923006407916546,
        -0.9490150213241577,
        -0.3150748312473297
      ],
      "plane_d": -3566.0458984375,
      "bbox_min": [
        -1180.0,
        -4011.041259765625,
        726.0
      ],
      "bbox_max": [
        -1148.248046875,
        -4011.0,
        727.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9988681077957153,
        -0.047565147280693054
      ],
      "plane_d": 4059.067138671875,
      "bbox_min": [
        -1180.0,
        -4083.87451171875,
        699.6690673828125
      ],
      "bbox_max": [
        -1146.5751953125,
        -4011.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.059878092259168625,
        0.20956800878047943,
        0.9759589433670044
      ],
      "plane_d": 241.07354736328125,
      "bbox_min": [
        -1158.236328125,
        -4083.87451171875,
        699.6690673828125
      ],
      "bbox_max": [
        -1156.99951171875,
        -4078.117431640625,
        700.981201171875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.07986977696418762,
        0.3993488848209381,
        0.9133132696151733
      ],
      "plane_d": 898.1671752929688,
      "bbox_min": [
        -1158.236328125,
        -4083.87451171875,
        700.9307250976562
      ],
      "bbox_max": [
        -1157.989990234375,
        -4083.709716796875,
        700.981201171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.001734549761749804,
        0.9987508654594421,
        -0.04993754252791405
      ],
      "plane_d": 4062.31884765625,
      "bbox_min": [
        -1180.0,
        -4030.0,
        700.0
      ],
      "bbox_max": [
        -1146.5751953125,
        -4011.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.02990417554974556,
        -0.004798466805368662,
        0.9995412230491638
      ],
      "plane_d": -684.647705078125,
      "bbox_min": [
        -1180.0,
        -4030.0,
        700.0
      ],
      "bbox_max": [
        -1146.5751953125,
        -4011.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.004925165791064501,
        -0.9863442778587341,
        0.1646226942539215
      ],
      "plane_d": -4067.788330078125,
      "bbox_min": [
        -1180.0,
        -4030.0,
        700.0
      ],
      "bbox_max": [
        -1146.5751953125,
        -4011.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9805806875228882,
        0.1961161345243454
      ],
      "plane_d": -4072.5478515625,
      "bbox_min": [
        -1180.0,
        -4013.0,
        701.0
      ],
      "bbox_max": [
        -1146.8577880859375,
        -4012.0,
        706.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.031730785965919495,
        -0.0,
        0.9994965195655823
      ],
      "plane_d": -663.2047729492188,
      "bbox_min": [
        -1180.0,
        -4030.0,
        700.0
      ],
      "bbox_max": [
        -1148.248046875,
        -4011.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9557790160179138,
        -0.294085830450058
      ],
      "plane_d": -3620.123291015625,
      "bbox_min": [
        -1180.0,
        -4030.0,
        700.0
      ],
      "bbox_max": [
        -1148.248046875,
        -4011.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.009923006407916546,
        -0.9490150213241577,
        -0.3150748312473297
      ],
      "plane_d": -3566.0458984375,
      "bbox_min": [
        -1179.6881103515625,
        -4015.0,
        726.1341552734375
      ],
      "bbox_max": [
        -1148.248046875,
        -4011.0,
        739.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.018522577360272408,
        0.8119395971298218,
        0.5834475755691528
      ],
      "plane_d": 2880.916748046875,
      "bbox_min": [
        -1180.0,
        -4030.0,
        700.0
      ],
      "bbox_max": [
        -1148.500732421875,
        -4015.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7682212591171265,
        0.6401844620704651
      ],
      "plane_d": 2643.3212890625,
      "bbox_min": [
        -1180.0,
        -4030.0,
        701.0
      ],
      "bbox_max": [
        -1149.8199462890625,
        -4025.0,
        707.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.1414213627576828,
        -0.9899495840072632
      ],
      "plane_d": 163.7659912109375,
      "bbox_min": [
        -1180.0,
        -4022.0,
        739.0
      ],
      "bbox_max": [
        -1149.7760009765625,
        -4015.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9858867526054382,
        -0.11514042317867279,
        0.12153195589780807
      ],
      "plane_d": 582.5867309570312,
      "bbox_min": [
        -1164.030517578125,
        -4085.802734375,
        660.0
      ],
      "bbox_max": [
        -1129.56591796875,
        -3929.49267578125,
        778.18603515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.059878092259168625,
        0.20956800878047943,
        0.9759589433670044
      ],
      "plane_d": 241.07354736328125,
      "bbox_min": [
        -1158.0130615234375,
        -4083.829833984375,
        660.0
      ],
      "bbox_max": [
        -1135.151123046875,
        -3963.27099609375,
        728.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.34197601675987244,
        -0.9395796060562134,
        0.015575435012578964
      ],
      "plane_d": -4123.966796875,
      "bbox_min": [
        -1136.61865234375,
        -3964.813232421875,
        660.0
      ],
      "bbox_max": [
        -1135.151123046875,
        -3963.27099609375,
        670.8826904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8154934048652649,
        -0.5618152618408203,
        -0.13904687762260437
      ],
      "plane_d": -1209.14697265625,
      "bbox_min": [
        -1135.96630859375,
        -3964.813232421875,
        660.0
      ],
      "bbox_max": [
        -1135.151123046875,
        -3963.27099609375,
        663.0035400390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9964726567268372,
        -0.04877805709838867,
        0.06828624755144119
      ],
      "plane_d": 900.9102172851562,
      "bbox_min": [
        -1158.0130615234375,
        -4083.829833984375,
        690.951416015625
      ],
      "bbox_max": [
        -1145.2373046875,
        -4010.32373046875,
        728.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07986977696418762,
        0.3993488848209381,
        0.9133132696151733
      ],
      "plane_d": 898.1671752929688,
      "bbox_min": [
        -1158.0130615234375,
        -4083.829833984375,
        700.6447143554688
      ],
      "bbox_max": [
        -1156.5943603515625,
        -4082.776611328125,
        700.981201171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9884225726127625,
        -0.0935225710272789,
        0.11947541683912277
      ],
      "plane_d": 675.142822265625,
      "bbox_min": [
        -1149.8199462890625,
        -4041.31884765625,
        690.951416015625
      ],
      "bbox_max": [
        -1145.2373046875,
        -4010.32373046875,
        712.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9459352493286133,
        -0.19028374552726746,
        0.2626759111881256
      ],
      "plane_d": 136.6421356201172,
      "bbox_min": [
        -1148.6671142578125,
        -4038.318359375,
        690.951416015625
      ],
      "bbox_max": [
        -1145.2373046875,
        -4010.32373046875,
        712.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9281700253486633,
        -0.35753133893013,
        0.10330425202846527
      ],
      "plane_d": -442.8694152832031,
      "bbox_min": [
        -1146.69189453125,
        -4013.0,
        697.2422485351562
      ],
      "bbox_max": [
        -1145.2373046875,
        -4010.32373046875,
        702.4780883789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9204105138778687,
        -0.38285428285598755,
        0.07916491478681564
      ],
      "plane_d": -536.3218383789062,
      "bbox_min": [
        -1147.3013916015625,
        -4012.5869140625,
        700.1163330078125
      ],
      "bbox_max": [
        -1145.6065673828125,
        -4010.451904296875,
        712.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9281700253486633,
        -0.35753133893013,
        0.10330425202846527
      ],
      "plane_d": -442.8694152832031,
      "bbox_min": [
        -1146.8577880859375,
        -4012.5869140625,
        700.1163330078125
      ],
      "bbox_max": [
        -1145.6065673828125,
        -4010.451904296875,
        706.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34197601675987244,
        -0.9395796060562134,
        0.015575435012578964
      ],
      "plane_d": -4123.966796875,
      "bbox_min": [
        -1148.248046875,
        -4019.42578125,
        660.0
      ],
      "bbox_max": [
        -1129.56591796875,
        -3929.49267578125,
        727.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8154934048652649,
        -0.5618152618408203,
        -0.13904687762260437
      ],
      "plane_d": -1209.14697265625,
      "bbox_min": [
        -1135.7015380859375,
        -3964.995849609375,
        660.0
      ],
      "bbox_max": [
        -1133.625244140625,
        -3961.05615234375,
        668.0272827148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9204105138778687,
        -0.38285428285598755,
        0.07916491478681564
      ],
      "plane_d": -536.3218383789062,
      "bbox_min": [
        -1148.248046875,
        -4019.42578125,
        695.2135620117188
      ],
      "bbox_max": [
        -1144.332763671875,
        -4007.96875,
        727.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9389578104019165,
        -0.1506665050983429,
        0.3092862665653229
      ],
      "plane_d": 255.4606170654297,
      "bbox_min": [
        -1146.1500244140625,
        -4019.42578125,
        695.2135620117188
      ],
      "bbox_max": [
        -1144.332763671875,
        -4007.96875,
        704.34619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9459352493286133,
        -0.19028374552726746,
        0.2626759111881256
      ],
      "plane_d": 136.6421356201172,
      "bbox_min": [
        -1146.05029296875,
        -4019.42578125,
        695.2135620117188
      ],
      "bbox_max": [
        -1145.9957275390625,
        -4019.031982421875,
        695.3768920898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9281700253486633,
        -0.35753133893013,
        0.10330425202846527
      ],
      "plane_d": -442.8694152832031,
      "bbox_min": [
        -1146.1500244140625,
        -4010.640380859375,
        695.3775634765625
      ],
      "bbox_max": [
        -1144.332763671875,
        -4007.96875,
        704.34619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.985288679599762,
        -0.14671219885349274,
        0.08764538168907166
      ],
      "plane_d": 479.2646484375,
      "bbox_min": [
        -1180.0,
        -4170.0,
        660.0
      ],
      "bbox_max": [
        -1132.271484375,
        -3949.683349609375,
        983.9453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9858867526054382,
        -0.11514042317867279,
        0.12153195589780807
      ],
      "plane_d": 582.5867309570312,
      "bbox_min": [
        -1164.030517578125,
        -4085.802734375,
        660.0
      ],
      "bbox_max": [
        -1132.271484375,
        -3949.683349609375,
        778.18603515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19583363831043243,
        -0.979168176651001,
        -0.05365469306707382
      ],
      "plane_d": -3734.36767578125,
      "bbox_min": [
        -1156.751708984375,
        -4083.57763671875,
        660.0
      ],
      "bbox_max": [
        -1148.853759765625,
        -4042.669921875,
        700.981201171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7716186046600342,
        -0.6280501484870911,
        -0.10078578442335129
      ],
      "plane_d": -1606.972412109375,
      "bbox_min": [
        -1152.44677734375,
        -4081.00830078125,
        660.0
      ],
      "bbox_max": [
        -1148.853759765625,
        -4076.056396484375,
        675.6862182617188
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -7.614157766511198e-06,
        -0.9659246206283569,
        0.2588233947753906
      ],
      "plane_d": -4116.99365234375,
      "bbox_min": [
        -1153.5,
        -4074.986572265625,
        698.759033203125
      ],
      "bbox_max": [
        -1152.9761962890625,
        -4074.595947265625,
        700.2171020507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07986977696418762,
        0.3993488848209381,
        0.9133132696151733
      ],
      "plane_d": 898.1671752929688,
      "bbox_min": [
        -1156.751708984375,
        -4083.57763671875,
        700.0787963867188
      ],
      "bbox_max": [
        -1153.8330078125,
        -4080.93017578125,
        700.981201171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9459352493286133,
        -0.19028374552726746,
        0.2626759111881256
      ],
      "plane_d": 136.6421356201172,
      "bbox_min": [
        -1150.2381591796875,
        -4083.87451171875,
        660.0
      ],
      "bbox_max": [
        -1146.05029296875,
        -4019.42578125,
        697.12548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.059878092259168625,
        0.20956800878047943,
        0.9759589433670044
      ],
      "plane_d": 241.07354736328125,
      "bbox_min": [
        -1149.2423095703125,
        -4077.301513671875,
        660.0
      ],
      "bbox_max": [
        -1146.1107177734375,
        -4027.432861328125,
        690.0479736328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.771613359451294,
        -0.6280569434165955,
        -0.10078349709510803
      ],
      "plane_d": -1607.0076904296875,
      "bbox_min": [
        -1149.2423095703125,
        -4077.301513671875,
        660.0
      ],
      "bbox_max": [
        -1148.2344970703125,
        -4075.295654296875,
        664.7828369140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9884225726127625,
        -0.0935225710272789,
        0.11947541683912277
      ],
      "plane_d": 675.142822265625,
      "bbox_min": [
        -1150.2381591796875,
        -4083.87451171875,
        660.0
      ],
      "bbox_max": [
        -1146.620849609375,
        -4030.966796875,
        697.12548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.059878092259168625,
        0.20956800878047943,
        0.9759589433670044
      ],
      "plane_d": 241.07354736328125,
      "bbox_min": [
        -1149.6396484375,
        -4077.50390625,
        664.5643310546875
      ],
      "bbox_max": [
        -1148.8551025390625,
        -4040.207275390625,
        692.4638061523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7716186046600342,
        -0.6280501484870911,
        -0.10078578442335129
      ],
      "plane_d": -1606.972412109375,
      "bbox_min": [
        -1149.3055419921875,
        -4077.50390625,
        664.5643310546875
      ],
      "bbox_max": [
        -1149.15234375,
        -4077.15576171875,
        665.560302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.059878092259168625,
        0.20956800878047943,
        0.9759589433670044
      ],
      "plane_d": 241.07354736328125,
      "bbox_min": [
        -1150.2381591796875,
        -4077.96337890625,
        663.9097290039062
      ],
      "bbox_max": [
        -1146.620849609375,
        -4030.966796875,
        694.5106201171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7716186046600342,
        -0.6280501484870911,
        -0.10078578442335129
      ],
      "plane_d": -1606.972412109375,
      "bbox_min": [
        -1149.448974609375,
        -4077.96337890625,
        663.9097290039062
      ],
      "bbox_max": [
        -1148.8826904296875,
        -4076.719482421875,
        667.3250122070312
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9459352493286133,
        -0.19028374552726746,
        0.2626759111881256
      ],
      "plane_d": 136.6421356201172,
      "bbox_min": [
        -1154.19384765625,
        -4083.87451171875,
        660.0
      ],
      "bbox_max": [
        -1132.271484375,
        -3949.683349609375,
        764.6005249023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.059878092259168625,
        0.20956800878047943,
        0.9759589433670044
      ],
      "plane_d": 241.07354736328125,
      "bbox_min": [
        -1148.8826904296875,
        -4076.719482421875,
        660.0
      ],
      "bbox_max": [
        -1132.271484375,
        -3949.683349609375,
        701.3931884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8154934048652649,
        -0.5618152618408203,
        -0.13904687762260437
      ],
      "plane_d": -1209.14697265625,
      "bbox_min": [
        -1148.8826904296875,
        -4076.719482421875,
        660.0
      ],
      "bbox_max": [
        -1132.271484375,
        -3959.091064453125,
        682.34912109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34197601675987244,
        -0.9395796060562134,
        0.015575435012578964
      ],
      "plane_d": -4123.966796875,
      "bbox_min": [
        -1135.4622802734375,
        -3965.19189453125,
        668.0272827148438
      ],
      "bbox_max": [
        -1134.1866455078125,
        -3964.718017578125,
        674.017822265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9389578104019165,
        -0.1506665050983429,
        0.3092862665653229
      ],
      "plane_d": 255.4606170654297,
      "bbox_min": [
        -1148.8826904296875,
        -4076.719482421875,
        660.0
      ],
      "bbox_max": [
        -1133.8218994140625,
        -3975.50244140625,
        682.34912109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6242576837539673,
        0.7803220748901367,
        -0.03741450980305672
      ],
      "plane_d": 3834.7607421875,
      "bbox_min": [
        -1133.9156494140625,
        -3975.628173828125,
        660.0
      ],
      "bbox_max": [
        -1133.8218994140625,
        -3975.50244140625,
        661.0550537109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34197601675987244,
        -0.9395796060562134,
        0.015575435012578964
      ],
      "plane_d": -4123.966796875,
      "bbox_min": [
        -1145.9957275390625,
        -4019.031982421875,
        673.9974365234375
      ],
      "bbox_max": [
        -1134.2437744140625,
        -3949.683349609375,
        701.3931884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -701.3931884765625,
      "bbox_min": [
        -1137.7174072265625,
        -3963.7578125,
        701.3931884765625
      ],
      "bbox_max": [
        -1135.5330810546875,
        -3949.683349609375,
        701.3931884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9281700253486633,
        -0.35753133893013,
        0.10330425202846527
      ],
      "plane_d": -442.8694152832031,
      "bbox_min": [
        -1144.5078125,
        -4008.51416015625,
        682.1592407226562
      ],
      "bbox_max": [
        -1137.92041015625,
        -3995.626953125,
        697.7256469726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9573608040809631,
        -0.23004037141799927,
        0.17476221919059753
      ],
      "plane_d": 49.54359436035156,
      "bbox_min": [
        -1154.19384765625,
        -4083.06591796875,
        661.7446899414062
      ],
      "bbox_max": [
        -1138.0709228515625,
        -3959.796875,
        764.6005249023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.059878092259168625,
        0.20956800878047943,
        0.9759589433670044
      ],
      "plane_d": 241.07354736328125,
      "bbox_min": [
        -1147.178955078125,
        -4034.832763671875,
        681.5662231445312
      ],
      "bbox_max": [
        -1138.0709228515625,
        -3995.540283203125,
        722.0310668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9204105138778687,
        -0.38285428285598755,
        0.07916491478681564
      ],
      "plane_d": -536.3218383789062,
      "bbox_min": [
        -1146.6849365234375,
        -4008.290283203125,
        683.7188110351562
      ],
      "bbox_max": [
        -1138.0709228515625,
        -3995.540283203125,
        722.0310668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9281700253486633,
        -0.35753133893013,
        0.10330425202846527
      ],
      "plane_d": -442.8694152832031,
      "bbox_min": [
        -1144.7591552734375,
        -4008.290283203125,
        683.7188110351562
      ],
      "bbox_max": [
        -1138.0709228515625,
        -3995.540283203125,
        701.096435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.059878092259168625,
        0.20956800878047943,
        0.9759589433670044
      ],
      "plane_d": 241.07354736328125,
      "bbox_min": [
        -1154.19384765625,
        -4083.06591796875,
        661.7446899414062
      ],
      "bbox_max": [
        -1138.944580078125,
        -4005.700439453125,
        700.981201171875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7716186046600342,
        -0.6280501484870911,
        -0.10078578442335129
      ],
      "plane_d": -1606.972412109375,
      "bbox_min": [
        -1150.835205078125,
        -4081.03271484375,
        661.7446899414062
      ],
      "bbox_max": [
        -1147.9913330078125,
        -4075.27685546875,
        676.4002685546875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.258815735578537,
        0.9659267663955688
      ],
      "plane_d": 378.21112060546875,
      "bbox_min": [
        -1154.19384765625,
        -4083.06591796875,
        696.617919921875
      ],
      "bbox_max": [
        -1150.6395263671875,
        -4065.419677734375,
        700.981201171875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.07986977696418762,
        0.3993488848209381,
        0.9133132696151733
      ],
      "plane_d": 898.1671752929688,
      "bbox_min": [
        -1154.19384765625,
        -4083.06591796875,
        696.617919921875
      ],
      "bbox_max": [
        -1150.6395263671875,
        -4065.419677734375,
        700.981201171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19583363831043243,
        -0.979168176651001,
        -0.05365469306707382
      ],
      "plane_d": -3734.36767578125,
      "bbox_min": [
        -1154.19384765625,
        -4083.06591796875,
        700.5397338867188
      ],
      "bbox_max": [
        -1154.052734375,
        -4083.013671875,
        700.981201171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -7.614157766511198e-06,
        -0.9659246206283569,
        0.2588233947753906
      ],
      "plane_d": -4116.99365234375,
      "bbox_min": [
        -1153.1103515625,
        -4074.9921875,
        696.617919921875
      ],
      "bbox_max": [
        -1150.6395263671875,
        -4065.419677734375,
        700.2171020507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -4.152787369093858e-06,
        0.9658967852592468,
        -0.2589276432991028
      ],
      "plane_d": 4107.43994140625,
      "bbox_min": [
        -1151.7354736328125,
        -4065.725341796875,
        696.617919921875
      ],
      "bbox_max": [
        -1150.6395263671875,
        -4065.419677734375,
        697.7583618164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9459352493286133,
        -0.19028374552726746,
        0.2626759111881256
      ],
      "plane_d": 136.6421356201172,
      "bbox_min": [
        -1154.1129150390625,
        -4083.87451171875,
        660.0
      ],
      "bbox_max": [
        -1138.5517578125,
        -4007.612060546875,
        700.981201171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.771613359451294,
        -0.6280569434165955,
        -0.10078349709510803
      ],
      "plane_d": -1607.0076904296875,
      "bbox_min": [
        -1147.9913330078125,
        -4075.27685546875,
        660.0
      ],
      "bbox_max": [
        -1147.27294921875,
        -4074.114501953125,
        661.7446899414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19583363831043243,
        -0.979168176651001,
        -0.05365469306707382
      ],
      "plane_d": -3734.36767578125,
      "bbox_min": [
        -1154.052734375,
        -4083.013671875,
        660.0
      ],
      "bbox_max": [
        -1141.501953125,
        -4057.549560546875,
        700.5397338867188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.258815735578537,
        0.9659267663955688
      ],
      "plane_d": 378.21112060546875,
      "bbox_min": [
        -1154.1129150390625,
        -4083.0498046875,
        696.34375
      ],
      "bbox_max": [
        -1145.91357421875,
        -4065.419677734375,
        700.981201171875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.07986977696418762,
        0.3993488848209381,
        0.9133132696151733
      ],
      "plane_d": 898.1671752929688,
      "bbox_min": [
        -1154.1129150390625,
        -4083.0498046875,
        696.34375
      ],
      "bbox_max": [
        -1145.91357421875,
        -4065.419677734375,
        700.981201171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19583363831043243,
        -0.979168176651001,
        -0.05365469306707382
      ],
      "plane_d": -3734.36767578125,
      "bbox_min": [
        -1154.1129150390625,
        -4083.0498046875,
        699.7116088867188
      ],
      "bbox_max": [
        -1147.673828125,
        -4080.979736328125,
        700.981201171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7716186046600342,
        -0.6280501484870911,
        -0.10078578442335129
      ],
      "plane_d": -1606.972412109375,
      "bbox_min": [
        -1148.3436279296875,
        -4081.87451171875,
        699.7116088867188
      ],
      "bbox_max": [
        -1147.673828125,
        -4080.979736328125,
        700.981201171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -7.614157766511198e-06,
        -0.9659246206283569,
        0.2588233947753906
      ],
      "plane_d": -4116.99365234375,
      "bbox_min": [
        -1152.5850830078125,
        -4075.053466796875,
        696.34375
      ],
      "bbox_max": [
        -1145.91357421875,
        -4065.419677734375,
        700.2171020507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -4.152787369093858e-06,
        0.9658967852592468,
        -0.2589276432991028
      ],
      "plane_d": 4107.43994140625,
      "bbox_min": [
        -1150.727294921875,
        -4065.798828125,
        696.34375
      ],
      "bbox_max": [
        -1145.91357421875,
        -4065.419677734375,
        697.7583618164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8886986970901489,
        -0.4443504214286804,
        0.11299305409193039
      ],
      "plane_d": -830.3196411132812,
      "bbox_min": [
        -1180.0,
        -4081.32080078125,
        660.0
      ],
      "bbox_max": [
        -1109.6734619140625,
        -3924.0,
        1197.8870849609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -701.3931884765625,
      "bbox_min": [
        -1136.6209716796875,
        -3962.108154296875,
        660.0
      ],
      "bbox_max": [
        -1121.838134765625,
        -3930.5791015625,
        701.3931884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9847401976585388,
        -0.09371570497751236,
        -0.1466427892446518
      ],
      "plane_d": 835.4137573242188,
      "bbox_min": [
        -1133.2186279296875,
        -3962.108154296875,
        660.0
      ],
      "bbox_max": [
        -1121.838134765625,
        -3932.152099609375,
        676.8589477539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8154934048652649,
        -0.5618152618408203,
        -0.13904687762260437
      ],
      "plane_d": -1209.14697265625,
      "bbox_min": [
        -1133.2186279296875,
        -3962.108154296875,
        660.0
      ],
      "bbox_max": [
        -1129.5189208984375,
        -3955.095703125,
        666.6360473632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9282523393630981,
        -0.32365739345550537,
        0.1832856684923172
      ],
      "plane_d": -360.9432067871094,
      "bbox_min": [
        -1142.8084716796875,
        -3965.22607421875,
        660.0
      ],
      "bbox_max": [
        -1115.11376953125,
        -3924.0,
        764.6005249023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -701.3931884765625,
      "bbox_min": [
        -1136.8525390625,
        -3965.22607421875,
        660.0
      ],
      "bbox_max": [
        -1119.986572265625,
        -3931.578369140625,
        701.3931884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34197160601615906,
        0.9395811557769775,
        -0.015574740245938301
      ],
      "plane_d": 4089.33056640625,
      "bbox_min": [
        -1134.1866455078125,
        -3965.22607421875,
        660.0
      ],
      "bbox_max": [
        -1119.986572265625,
        -3931.578369140625,
        701.3931884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8154934048652649,
        -0.5618152618408203,
        -0.13904687762260437
      ],
      "plane_d": -1209.14697265625,
      "bbox_min": [
        -1134.1866455078125,
        -3965.22607421875,
        660.0
      ],
      "bbox_max": [
        -1125.2896728515625,
        -3949.96728515625,
        674.3607177734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9282523393630981,
        -0.32365739345550537,
        0.1832856684923172
      ],
      "plane_d": -360.9432067871094,
      "bbox_min": [
        -1147.8123779296875,
        -4081.32080078125,
        660.0
      ],
      "bbox_max": [
        -1109.6734619140625,
        -3924.0,
        764.6005249023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -701.3931884765625,
      "bbox_min": [
        -1137.3682861328125,
        -3992.105712890625,
        660.0
      ],
      "bbox_max": [
        -1119.473876953125,
        -3932.600341796875,
        701.3931884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9847401976585388,
        -0.09371570497751236,
        -0.1466427892446518
      ],
      "plane_d": 835.4137573242188,
      "bbox_min": [
        -1137.3682861328125,
        -3992.105712890625,
        660.0
      ],
      "bbox_max": [
        -1119.473876953125,
        -3932.600341796875,
        701.3931884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8154934048652649,
        -0.5618152618408203,
        -0.13904687762260437
      ],
      "plane_d": -1209.14697265625,
      "bbox_min": [
        -1137.3682861328125,
        -3992.105712890625,
        660.0
      ],
      "bbox_max": [
        -1119.473876953125,
        -3932.600341796875,
        701.3931884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34197601675987244,
        -0.9395796060562134,
        0.015575435012578964
      ],
      "plane_d": -4123.966796875,
      "bbox_min": [
        -1136.767822265625,
        -3965.958984375,
        674.3606567382812
      ],
      "bbox_max": [
        -1119.473876953125,
        -3932.600341796875,
        701.3931884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34197160601615906,
        0.9395811557769775,
        -0.015574740245938301
      ],
      "plane_d": 4089.33056640625,
      "bbox_min": [
        -1121.173583984375,
        -3933.356201171875,
        689.5886840820312
      ],
      "bbox_max": [
        -1119.473876953125,
        -3932.600341796875,
        701.3931884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6242576837539673,
        0.7803220748901367,
        -0.03741450980305672
      ],
      "plane_d": 3834.7607421875,
      "bbox_min": [
        -1137.3682861328125,
        -3992.105712890625,
        660.0
      ],
      "bbox_max": [
        -1129.0155029296875,
        -3974.1826171875,
        679.995361328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.059878092259168625,
        0.20956800878047943,
        0.9759589433670044
      ],
      "plane_d": 241.07354736328125,
      "bbox_min": [
        -1137.3682861328125,
        -3992.105712890625,
        675.981201171875
      ],
      "bbox_max": [
        -1131.2738037109375,
        -3974.1826171875,
        679.995361328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21115902066230774,
        0.2639487683773041,
        0.9411391019821167
      ],
      "plane_d": 652.3842163085938,
      "bbox_min": [
        -1134.6707763671875,
        -3979.686279296875,
        675.981201171875
      ],
      "bbox_max": [
        -1131.2738037109375,
        -3974.1826171875,
        677.02685546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9573608040809631,
        -0.23004037141799927,
        0.17476221919059753
      ],
      "plane_d": 49.54359436035156,
      "bbox_min": [
        -1147.8123779296875,
        -4081.32080078125,
        660.0
      ],
      "bbox_max": [
        -1118.26953125,
        -3932.706298828125,
        764.6005249023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.059878092259168625,
        0.20956800878047943,
        0.9759589433670044
      ],
      "plane_d": 241.07354736328125,
      "bbox_min": [
        -1137.7398681640625,
        -3995.309814453125,
        662.9111938476562
      ],
      "bbox_max": [
        -1129.4268798828125,
        -3976.900146484375,
        680.7061157226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21115902066230774,
        0.2639487683773041,
        0.9411391019821167
      ],
      "plane_d": 652.3842163085938,
      "bbox_min": [
        -1132.4517822265625,
        -3980.940185546875,
        675.981201171875
      ],
      "bbox_max": [
        -1130.826904296875,
        -3976.900146484375,
        677.2650756835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9459352493286133,
        -0.19028374552726746,
        0.2626759111881256
      ],
      "plane_d": 136.6421356201172,
      "bbox_min": [
        -1138.9447021484375,
        -4010.292236328125,
        660.0
      ],
      "bbox_max": [
        -1127.1707763671875,
        -3974.1826171875,
        685.978759765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9389578104019165,
        -0.1506665050983429,
        0.3092862665653229
      ],
      "plane_d": 255.4606170654297,
      "bbox_min": [
        -1138.2342529296875,
        -4000.54052734375,
        660.0
      ],
      "bbox_max": [
        -1127.1707763671875,
        -3974.1826171875,
        683.7188110351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.059878092259168625,
        0.20956800878047943,
        0.9759589433670044
      ],
      "plane_d": 241.07354736328125,
      "bbox_min": [
        -1138.093505859375,
        -3998.360107421875,
        660.0
      ],
      "bbox_max": [
        -1128.534423828125,
        -3978.83203125,
        681.3827514648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6242576837539673,
        0.7803220748901367,
        -0.03741450980305672
      ],
      "plane_d": 3834.7607421875,
      "bbox_min": [
        -1129.5244140625,
        -3979.85791015625,
        660.0
      ],
      "bbox_max": [
        -1128.534423828125,
        -3978.83203125,
        664.880615234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9281700253486633,
        -0.35753133893013,
        0.10330425202846527
      ],
      "plane_d": -442.8694152832031,
      "bbox_min": [
        -1138.189453125,
        -3999.1875,
        660.0
      ],
      "bbox_max": [
        -1127.1707763671875,
        -3974.1826171875,
        683.7188110351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.059878092259168625,
        0.20956800878047943,
        0.9759589433670044
      ],
      "plane_d": 241.07354736328125,
      "bbox_min": [
        -1137.0537109375,
        -3993.95263671875,
        664.8112182617188
      ],
      "bbox_max": [
        -1129.504638671875,
        -3978.8056640625,
        680.37255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6242576837539673,
        0.7803220748901367,
        -0.03741450980305672
      ],
      "plane_d": 3834.7607421875,
      "bbox_min": [
        -1129.539306640625,
        -3978.85107421875,
        664.8112182617188
      ],
      "bbox_max": [
        -1129.504638671875,
        -3978.8056640625,
        665.1808471679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.059878092259168625,
        0.20956800878047943,
        0.9759589433670044
      ],
      "plane_d": 241.07354736328125,
      "bbox_min": [
        -1138.189453125,
        -3999.1875,
        663.8770141601562
      ],
      "bbox_max": [
        -1129.23828125,
        -3978.81787109375,
        681.5663452148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6242576837539673,
        0.7803220748901367,
        -0.03741450980305672
      ],
      "plane_d": 3834.7607421875,
      "bbox_min": [
        -1129.527099609375,
        -3979.10888671875,
        663.8770141601562
      ],
      "bbox_max": [
        -1129.23828125,
        -3978.81787109375,
        665.128173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9281700253486633,
        -0.35753133893013,
        0.10330425202846527
      ],
      "plane_d": -442.8694152832031,
      "bbox_min": [
        -1138.9447021484375,
        -4005.70068359375,
        660.0
      ],
      "bbox_max": [
        -1127.1707763671875,
        -3974.1826171875,
        685.978759765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.059878092259168625,
        0.20956800878047943,
        0.9759589433670044
      ],
      "plane_d": 241.07354736328125,
      "bbox_min": [
        -1136.3426513671875,
        -3992.2265625,
        665.128173828125
      ],
      "bbox_max": [
        -1129.527099609375,
        -3978.771240234375,
        679.9583129882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6242576837539673,
        0.7803220748901367,
        -0.03741450980305672
      ],
      "plane_d": 3834.7607421875,
      "bbox_min": [
        -1129.558837890625,
        -3978.81787109375,
        665.128173828125
      ],
      "bbox_max": [
        -1129.527099609375,
        -3978.771240234375,
        665.574951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.059878092259168625,
        0.20956800878047943,
        0.9759589433670044
      ],
      "plane_d": 241.07354736328125,
      "bbox_min": [
        -1138.9447021484375,
        -4005.70068359375,
        662.1871948242188
      ],
      "bbox_max": [
        -1128.84814453125,
        -3978.561279296875,
        683.0112915039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6242576837539673,
        0.7803220748901367,
        -0.03741450980305672
      ],
      "plane_d": 3834.7607421875,
      "bbox_min": [
        -1129.677490234375,
        -3979.501953125,
        662.1871948242188
      ],
      "bbox_max": [
        -1128.84814453125,
        -3978.561279296875,
        667.9688720703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05987633019685745,
        0.20956869423389435,
        0.9759589433670044
      ],
      "plane_d": 241.0743408203125,
      "bbox_min": [
        -1147.8123779296875,
        -4081.32080078125,
        660.0
      ],
      "bbox_max": [
        -1118.26953125,
        -3932.706298828125,
        701.3931884765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9667491316795349,
        -0.23213931918144226,
        -0.10727303475141525
      ],
      "plane_d": 232.429443359375,
      "bbox_min": [
        -1147.673828125,
        -4080.979736328125,
        660.0
      ],
      "bbox_max": [
        -1124.6707763671875,
        -3974.1826171875,
        699.7116088867188
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6242576837539673,
        0.7803220748901367,
        -0.03741450980305672
      ],
      "plane_d": 3834.7607421875,
      "bbox_min": [
        -1128.84814453125,
        -3980.010986328125,
        660.0
      ],
      "bbox_max": [
        -1128.3431396484375,
        -3979.501953125,
        662.1873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9934239387512207,
        -0.04847683012485504,
        -0.1037251353263855
      ],
      "plane_d": 994.3475341796875,
      "bbox_min": [
        -1131.9461669921875,
        -3998.2255859375,
        660.0
      ],
      "bbox_max": [
        -1124.6707763671875,
        -3977.257568359375,
        680.5491943359375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.21115902066230774,
        0.2639487683773041,
        0.9411391019821167
      ],
      "plane_d": 652.3842163085938,
      "bbox_min": [
        -1131.9461669921875,
        -3998.2255859375,
        660.0
      ],
      "bbox_max": [
        -1124.6707763671875,
        -3977.257568359375,
        680.5491943359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6242576837539673,
        0.7803220748901367,
        -0.03741450980305672
      ],
      "plane_d": 3834.7607421875,
      "bbox_min": [
        -1130.826904296875,
        -3982.1826171875,
        660.0
      ],
      "bbox_max": [
        -1124.6707763671875,
        -3977.257568359375,
        675.981201171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -701.3931884765625,
      "bbox_min": [
        -1147.8123779296875,
        -4081.32080078125,
        680.412109375
      ],
      "bbox_max": [
        -1118.26953125,
        -3932.706298828125,
        701.3931884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8154934048652649,
        -0.5618152618408203,
        -0.13904687762260437
      ],
      "plane_d": -1209.14697265625,
      "bbox_min": [
        -1147.8123779296875,
        -4081.32080078125,
        680.412109375
      ],
      "bbox_max": [
        -1118.26953125,
        -3932.706298828125,
        701.3931884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9847401976585388,
        -0.09371570497751236,
        -0.1466427892446518
      ],
      "plane_d": 835.4137573242188,
      "bbox_min": [
        -1132.288330078125,
        -3966.209228515625,
        680.412109375
      ],
      "bbox_max": [
        -1118.26953125,
        -3932.706298828125,
        701.3931884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34197160601615906,
        0.9395811557769775,
        -0.015574740245938301
      ],
      "plane_d": 4089.33056640625,
      "bbox_min": [
        -1132.288330078125,
        -3966.209228515625,
        693.113037109375
      ],
      "bbox_max": [
        -1118.26953125,
        -3932.706298828125,
        701.3931884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34197601675987244,
        -0.9395796060562134,
        0.015575435012578964
      ],
      "plane_d": -4123.966796875,
      "bbox_min": [
        -1132.288330078125,
        -3966.209228515625,
        694.5136108398438
      ],
      "bbox_max": [
        -1130.1175537109375,
        -3965.419189453125,
        701.3931884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7716186046600342,
        -0.6280501484870911,
        -0.10078578442335129
      ],
      "plane_d": -1606.972412109375,
      "bbox_min": [
        -1147.8123779296875,
        -4081.32080078125,
        696.2327270507812
      ],
      "bbox_max": [
        -1140.8841552734375,
        -4065.419677734375,
        700.7761840820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07986977696418762,
        0.3993488848209381,
        0.9133132696151733
      ],
      "plane_d": 898.1671752929688,
      "bbox_min": [
        -1147.8123779296875,
        -4081.32080078125,
        696.2327270507812
      ],
      "bbox_max": [
        -1140.8841552734375,
        -4065.419677734375,
        700.7761840820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.258815735578537,
        0.9659267663955688
      ],
      "plane_d": 378.21112060546875,
      "bbox_min": [
        -1147.1259765625,
        -4075.087158203125,
        696.2327270507812
      ],
      "bbox_max": [
        -1144.0,
        -4065.419677734375,
        700.2171020507812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1144.0,
      "bbox_min": [
        -1147.1259765625,
        -4075.087158203125,
        696.2327270507812
      ],
      "bbox_max": [
        -1144.0,
        -4065.419677734375,
        700.2171020507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -7.614157766511198e-06,
        -0.9659246206283569,
        0.2588233947753906
      ],
      "plane_d": -4116.99365234375,
      "bbox_min": [
        -1147.1259765625,
        -4075.087158203125,
        696.2327270507812
      ],
      "bbox_max": [
        -1144.0,
        -4065.419677734375,
        700.2171020507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -4.152787369093858e-06,
        0.9658967852592468,
        -0.2589276432991028
      ],
      "plane_d": 4107.43994140625,
      "bbox_min": [
        -1146.0194091796875,
        -4065.82861328125,
        696.2327270507812
      ],
      "bbox_max": [
        -1144.0,
        -4065.419677734375,
        697.7583618164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.985288679599762,
        -0.14671219885349274,
        0.08764538168907166
      ],
      "plane_d": 479.2646484375,
      "bbox_min": [
        -1260.0,
        -4170.0,
        701.0
      ],
      "bbox_max": [
        -1180.0,
        -3924.0,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.054020095616579056,
        -0.997294008731842,
        0.04986470192670822
      ],
      "plane_d": -4100.091796875,
      "bbox_min": [
        -1260.0,
        -4030.0,
        701.0
      ],
      "bbox_max": [
        -1180.0,
        -4008.5,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.007906542159616947,
        0.9987210631370544,
        -0.04993605613708496
      ],
      "plane_d": 4050.82080078125,
      "bbox_min": [
        -1260.0,
        -4030.0,
        701.0
      ],
      "bbox_max": [
        -1180.0,
        -4008.5,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08468224108219147,
        -0.871017336845398,
        -0.4838985204696655
      ],
      "plane_d": -3042.4150390625,
      "bbox_min": [
        -1260.0,
        -4030.0,
        701.0
      ],
      "bbox_max": [
        -1180.0,
        -4008.5,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09997591376304626,
        -0.9509903788566589,
        -0.2926124334335327
      ],
      "plane_d": -3484.01416015625,
      "bbox_min": [
        -1214.7994384765625,
        -4018.5,
        726.0
      ],
      "bbox_max": [
        -1180.0,
        -4011.0,
        739.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32040175795555115,
        -0.1339658796787262,
        -0.937761127948761
      ],
      "plane_d": 533.20654296875,
      "bbox_min": [
        -1214.7994384765625,
        -4018.5,
        727.1101684570312
      ],
      "bbox_max": [
        -1180.0,
        -4015.0,
        739.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13864785432815552,
        -0.5942050814628601,
        -0.7922734618186951
      ],
      "plane_d": -1644.5616455078125,
      "bbox_min": [
        -1260.0,
        -4030.0,
        701.0
      ],
      "bbox_max": [
        -1180.0,
        -4008.5,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09997591376304626,
        -0.9509903788566589,
        -0.2926124334335327
      ],
      "plane_d": -3484.01416015625,
      "bbox_min": [
        -1240.0,
        -4024.20556640625,
        718.5
      ],
      "bbox_max": [
        -1180.0,
        -4011.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32040175795555115,
        -0.1339658796787262,
        -0.937761127948761
      ],
      "plane_d": 533.20654296875,
      "bbox_min": [
        -1240.0,
        -4024.20556640625,
        718.5
      ],
      "bbox_max": [
        -1180.0,
        -4015.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15989989042282104,
        0.8691422343254089,
        -0.467999666929245
      ],
      "plane_d": 4030.69189453125,
      "bbox_min": [
        -1214.500732421875,
        -4024.20556640625,
        728.2122802734375
      ],
      "bbox_max": [
        -1180.0,
        -4022.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09950371831655502,
        -0.0,
        0.9950372576713562
      ],
      "plane_d": -580.1067504882812,
      "bbox_min": [
        -1260.0,
        -4030.0,
        701.0
      ],
      "bbox_max": [
        -1180.0,
        -4008.5,
        735.904052734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07124704867601395,
        0.0,
        0.9974586367607117
      ],
      "plane_d": -793.549560546875,
      "bbox_min": [
        -1260.0,
        -4028.099853515625,
        705.0
      ],
      "bbox_max": [
        -1240.0,
        -4010.0,
        708.8692016601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06758368015289307,
        0.05127038061618805,
        0.996395468711853
      ],
      "plane_d": -581.6273193359375,
      "bbox_min": [
        -1260.0,
        -4027.964599609375,
        705.0
      ],
      "bbox_max": [
        -1254.0,
        -4016.916748046875,
        706.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08625808358192444,
        0.01035171840339899,
        0.9962190389633179
      ],
      "plane_d": -769.8067626953125,
      "bbox_min": [
        -1260.0,
        -4027.512939453125,
        705.0
      ],
      "bbox_max": [
        -1254.0,
        -4016.916748046875,
        706.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -705.0,
      "bbox_min": [
        -1260.0,
        -4017.6591796875,
        705.0
      ],
      "bbox_max": [
        -1259.5,
        -4016.916748046875,
        705.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09757836163043976,
        0.0,
        0.9952278733253479
      ],
      "plane_d": -824.994140625,
      "bbox_min": [
        -1258.62158203125,
        -4027.512939453125,
        705.5999755859375
      ],
      "bbox_max": [
        -1254.0,
        -4022.60009765625,
        706.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.015595672652125359,
        0.9835212230682373,
        0.18011882901191711
      ],
      "plane_d": 3814.410888671875,
      "bbox_min": [
        -1258.62158203125,
        -4027.512939453125,
        705.5999755859375
      ],
      "bbox_max": [
        -1254.0,
        -4022.60009765625,
        706.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06649525463581085,
        -0.9578752517700195,
        0.2793799936771393
      ],
      "plane_d": -3967.00634765625,
      "bbox_min": [
        -1258.0799560546875,
        -4023.0,
        705.5999755859375
      ],
      "bbox_max": [
        -1254.0,
        -4022.60009765625,
        706.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6412478685379028,
        -0.7310077548027039,
        0.23329974710941315
      ],
      "plane_d": -2301.13671875,
      "bbox_min": [
        -1258.6920166015625,
        -4028.099853515625,
        705.6698608398438
      ],
      "bbox_max": [
        -1240.0,
        -4010.0,
        708.8692016601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06649525463581085,
        -0.9578752517700195,
        0.2793799936771393
      ],
      "plane_d": -3967.00634765625,
      "bbox_min": [
        -1258.076171875,
        -4022.968017578125,
        705.7088623046875
      ],
      "bbox_max": [
        -1254.0,
        -4021.834228515625,
        708.7967529296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09722144901752472,
        -0.9481465220451355,
        0.3025991916656494
      ],
      "plane_d": -3905.733642578125,
      "bbox_min": [
        -1256.1717529296875,
        -4022.60009765625,
        706.0
      ],
      "bbox_max": [
        -1254.0,
        -4021.834228515625,
        708.6171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.021713251248002052,
        0.9821070432662964,
        0.18706801533699036
      ],
      "plane_d": 3850.5947265625,
      "bbox_min": [
        -1258.6920166015625,
        -4028.099853515625,
        705.6698608398438
      ],
      "bbox_max": [
        -1240.0,
        -4027.5,
        708.8692016601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.015595672652125359,
        0.9835212230682373,
        0.18011882901191711
      ],
      "plane_d": 3814.410888671875,
      "bbox_min": [
        -1258.6920166015625,
        -4028.099853515625,
        705.6698608398438
      ],
      "bbox_max": [
        -1254.0,
        -4027.5,
        708.8692016601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9823386669158936,
        0.18711212277412415
      ],
      "plane_d": 3824.267822265625,
      "bbox_min": [
        -1255.164794921875,
        -4027.979248046875,
        706.0
      ],
      "bbox_max": [
        -1254.0,
        -4027.5,
        708.5164794921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.025598982349038124,
        0.7679696083068848,
        0.6399745941162109
      ],
      "plane_d": 2672.662109375,
      "bbox_min": [
        -1258.8599853515625,
        -4030.0,
        701.0
      ],
      "bbox_max": [
        -1180.0,
        -4008.5,
        735.904052734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.025350766256451607,
        -0.9360283017158508,
        0.35101062059402466
      ],
      "plane_d": -4033.07275390625,
      "bbox_min": [
        -1258.8599853515625,
        -4030.0,
        701.0
      ],
      "bbox_max": [
        -1180.0,
        -4008.5,
        735.904052734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.02940469980239868,
        -0.9801567196846008,
        0.1960313469171524
      ],
      "plane_d": -4105.484375,
      "bbox_min": [
        -1240.0,
        -4013.0,
        701.0
      ],
      "bbox_max": [
        -1180.0,
        -4010.0,
        707.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.03260098770260811,
        0.9780296683311462,
        0.20590098202228546
      ],
      "plane_d": 3834.356689453125,
      "bbox_min": [
        -1258.8599853515625,
        -4030.0,
        707.0
      ],
      "bbox_max": [
        -1180.0,
        -4008.5,
        735.904052734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.021713251248002052,
        0.9821070432662964,
        0.18706801533699036
      ],
      "plane_d": 3850.5947265625,
      "bbox_min": [
        -1258.8599853515625,
        -4029.5,
        707.0
      ],
      "bbox_max": [
        -1240.0,
        -4027.95703125,
        716.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9823386669158936,
        0.18711212277412415
      ],
      "plane_d": 3824.267822265625,
      "bbox_min": [
        -1258.8599853515625,
        -4029.5,
        708.4000244140625
      ],
      "bbox_max": [
        -1254.0,
        -4027.95703125,
        716.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.015595672652125359,
        0.9835212230682373,
        0.18011882901191711
      ],
      "plane_d": 3814.410888671875,
      "bbox_min": [
        -1258.8599853515625,
        -4029.5,
        708.5164794921875
      ],
      "bbox_max": [
        -1255.164794921875,
        -4027.979248046875,
        716.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.09950371831655502,
        -0.9950371384620667
      ],
      "plane_d": 311.9938659667969,
      "bbox_min": [
        -1258.8599853515625,
        -4029.5,
        716.4891357421875
      ],
      "bbox_max": [
        -1255.00341796875,
        -4029.39111328125,
        716.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.09950371831655502,
        -0.9950371384620667
      ],
      "plane_d": 311.9938659667969,
      "bbox_min": [
        -1258.846923828125,
        -4029.433837890625,
        716.4869384765625
      ],
      "bbox_max": [
        -1256.9456787109375,
        -4029.369140625,
        716.493408203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15606936812400818,
        0.3468208312988281,
        -0.9248554706573486
      ],
      "plane_d": 2253.873046875,
      "bbox_min": [
        -1258.84423828125,
        -4030.0,
        707.0
      ],
      "bbox_max": [
        -1180.0,
        -4008.5,
        735.904052734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15989989042282104,
        0.8691422343254089,
        -0.467999666929245
      ],
      "plane_d": 4030.69189453125,
      "bbox_min": [
        -1258.84423828125,
        -4030.0,
        714.546630859375
      ],
      "bbox_max": [
        -1180.0,
        -4018.158447265625,
        735.904052734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.034926872700452805,
        0.977952778339386,
        0.20588478446006775
      ],
      "plane_d": 3836.942626953125,
      "bbox_min": [
        -1258.84423828125,
        -4030.0,
        714.546630859375
      ],
      "bbox_max": [
        -1240.0,
        -4024.260009765625,
        716.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.09950371831655502,
        -0.9950371384620667
      ],
      "plane_d": 311.9938659667969,
      "bbox_min": [
        -1258.84423828125,
        -4029.5,
        714.546630859375
      ],
      "bbox_max": [
        -1251.5494384765625,
        -4029.13916015625,
        716.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.021713251248002052,
        0.9821070432662964,
        0.18706801533699036
      ],
      "plane_d": 3850.5947265625,
      "bbox_min": [
        -1255.00341796875,
        -4029.5,
        714.546630859375
      ],
      "bbox_max": [
        -1251.5494384765625,
        -4029.13916015625,
        716.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9823386669158936,
        0.18711212277412415
      ],
      "plane_d": 3824.267822265625,
      "bbox_min": [
        -1255.00341796875,
        -4029.5,
        714.8327026367188
      ],
      "bbox_max": [
        -1254.0,
        -4029.182373046875,
        716.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.008654806762933731,
        -0.09219640493392944,
        -0.9957032799720764
      ],
      "plane_d": 352.76910400390625,
      "bbox_min": [
        -1258.8387451171875,
        -4029.5,
        715.5761108398438
      ],
      "bbox_max": [
        -1254.0,
        -4024.260009765625,
        716.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.09950371831655502,
        -0.9950371384620667
      ],
      "plane_d": 311.9938659667969,
      "bbox_min": [
        -1258.8387451171875,
        -4029.5,
        716.0
      ],
      "bbox_max": [
        -1254.0,
        -4024.5,
        716.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08164354413747787,
        -0.8697181344032288,
        -0.4867490231990814
      ],
      "plane_d": -3048.939453125,
      "bbox_min": [
        -1258.260009765625,
        -4024.5,
        715.5761108398438
      ],
      "bbox_max": [
        -1255.7164306640625,
        -4024.260009765625,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32040175795555115,
        -0.1339658796787262,
        -0.937761127948761
      ],
      "plane_d": 533.20654296875,
      "bbox_min": [
        -1240.0,
        -4022.0,
        719.5
      ],
      "bbox_max": [
        -1214.500732421875,
        -4018.158447265625,
        728.2122802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6410201191902161,
        -0.7186553478240967,
        0.2694954574108124
      ],
      "plane_d": -2277.47607421875,
      "bbox_min": [
        -1258.231201171875,
        -4030.0,
        707.0
      ],
      "bbox_max": [
        -1228.494140625,
        -4008.5,
        722.8823852539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6412478685379028,
        -0.7310077548027039,
        0.23329974710941315
      ],
      "plane_d": -2301.13671875,
      "bbox_min": [
        -1258.137451171875,
        -4023.479248046875,
        707.0
      ],
      "bbox_max": [
        -1240.0,
        -4010.0,
        714.1966552734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08888152986764908,
        -0.8668120503425598,
        -0.49064943194389343
      ],
      "plane_d": -3025.3759765625,
      "bbox_min": [
        -1258.137451171875,
        -4023.479248046875,
        708.4000244140625
      ],
      "bbox_max": [
        -1254.0,
        -4021.10009765625,
        714.1966552734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08164354413747787,
        -0.8697181344032288,
        -0.4867490231990814
      ],
      "plane_d": -3048.939453125,
      "bbox_min": [
        -1258.137451171875,
        -4023.479248046875,
        710.7000122070312
      ],
      "bbox_max": [
        -1256.41162109375,
        -4021.5,
        714.1966552734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09722144901752472,
        -0.9481465220451355,
        0.3025991916656494
      ],
      "plane_d": -3905.733642578125,
      "bbox_min": [
        -1257.9671630859375,
        -4022.059814453125,
        708.4000244140625
      ],
      "bbox_max": [
        -1254.0,
        -4021.10009765625,
        710.7000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06649525463581085,
        -0.9578752517700195,
        0.2793799936771393
      ],
      "plane_d": -3967.00634765625,
      "bbox_min": [
        -1257.9671630859375,
        -4022.059814453125,
        708.6171875
      ],
      "bbox_max": [
        -1256.1717529296875,
        -4021.5,
        710.7000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6231316924095154,
        -0.6806421875953674,
        -0.38527002930641174
      ],
      "plane_d": -1681.7119140625,
      "bbox_min": [
        -1258.231201171875,
        -4030.0,
        707.0
      ],
      "bbox_max": [
        -1228.494140625,
        -4008.5,
        722.8823852539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08164354413747787,
        -0.8697181344032288,
        -0.4867490231990814
      ],
      "plane_d": -3048.939453125,
      "bbox_min": [
        -1258.231201171875,
        -4024.652099609375,
        710.7000122070312
      ],
      "bbox_max": [
        -1254.0,
        -4021.10009765625,
        716.046142578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08888152986764908,
        -0.8668120503425598,
        -0.49064943194389343
      ],
      "plane_d": -3025.3759765625,
      "bbox_min": [
        -1256.41162109375,
        -4024.10009765625,
        710.7000122070312
      ],
      "bbox_max": [
        -1254.0,
        -4021.10009765625,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.008654806762933731,
        -0.09219640493392944,
        -0.9957032799720764
      ],
      "plane_d": 352.76910400390625,
      "bbox_min": [
        -1255.7164306640625,
        -4024.652099609375,
        716.0
      ],
      "bbox_max": [
        -1254.0,
        -4024.10009765625,
        716.046142578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6233370304107666,
        -0.6835501194000244,
        -0.3797500729560852
      ],
      "plane_d": -1697.0703125,
      "bbox_min": [
        -1254.57421875,
        -4030.0,
        707.0
      ],
      "bbox_max": [
        -1228.494140625,
        -4008.5,
        722.8823852539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47026392817497253,
        -0.5295156240463257,
        -0.7060206532478333
      ],
      "plane_d": -1035.602294921875,
      "bbox_min": [
        -1254.57421875,
        -4030.0,
        707.0
      ],
      "bbox_max": [
        -1228.494140625,
        -4011.0,
        722.8823852539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.008654806762933731,
        -0.09219640493392944,
        -0.9957032799720764
      ],
      "plane_d": 352.76910400390625,
      "bbox_min": [
        -1254.57421875,
        -4024.657958984375,
        716.0
      ],
      "bbox_max": [
        -1254.0,
        -4024.10009765625,
        716.0468139648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0032928341533988714,
        -0.09219936281442642,
        -0.9957351088523865
      ],
      "plane_d": 337.79766845703125,
      "bbox_min": [
        -1254.557373046875,
        -4030.0,
        707.0
      ],
      "bbox_max": [
        -1228.494140625,
        -4015.0,
        722.8823852539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32040175795555115,
        -0.1339658796787262,
        -0.937761127948761
      ],
      "plane_d": 533.20654296875,
      "bbox_min": [
        -1240.0,
        -4022.0,
        718.5
      ],
      "bbox_max": [
        -1228.494140625,
        -4015.0,
        722.8823852539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17849791049957275,
        0.34548452496528625,
        -0.9212920665740967
      ],
      "plane_d": 2273.745849609375,
      "bbox_min": [
        -1254.0,
        -4030.0,
        716.0
      ],
      "bbox_max": [
        -1240.0,
        -4022.0,
        719.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.021713251248002052,
        0.9821070432662964,
        0.18706801533699036
      ],
      "plane_d": 3850.5947265625,
      "bbox_min": [
        -1254.557373046875,
        -4030.0,
        707.0
      ],
      "bbox_max": [
        -1240.0,
        -4024.10009765625,
        716.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.034926872700452805,
        0.977952778339386,
        0.20588478446006775
      ],
      "plane_d": 3836.942626953125,
      "bbox_min": [
        -1251.5494384765625,
        -4030.0,
        707.0
      ],
      "bbox_max": [
        -1240.0,
        -4028.0,
        716.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.008654806762933731,
        -0.09219640493392944,
        -0.9957032799720764
      ],
      "plane_d": 352.76910400390625,
      "bbox_min": [
        -1254.557373046875,
        -4024.8486328125,
        716.0
      ],
      "bbox_max": [
        -1254.0,
        -4024.10009765625,
        716.0693359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8886986970901489,
        -0.4443504214286804,
        0.11299305409193039
      ],
      "plane_d": -830.3196411132812,
      "bbox_min": [
        -1193.2838134765625,
        -3933.4208984375,
        1160.83935546875
      ],
      "bbox_max": [
        -1180.0,
        -3924.0,
        1302.365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9984944462776184,
        -0.029658252373337746,
        0.04614244028925896
      ],
      "plane_d": 1022.8195190429688,
      "bbox_min": [
        -1208.4189453125,
        -4170.0,
        956.3939208984375
      ],
      "bbox_max": [
        -1180.0,
        -4003.867431640625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.98377925157547,
        -0.15617449581623077,
        0.08824894577264786
      ],
      "plane_d": 438.3768310546875,
      "bbox_min": [
        -1204.7315673828125,
        -4070.130615234375,
        983.9453125
      ],
      "bbox_max": [
        -1180.0,
        -4003.867431640625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9907258749008179,
        -0.09288055449724197,
        0.09917348623275757
      ],
      "plane_d": 688.5936279296875,
      "bbox_min": [
        -1204.7315673828125,
        -4045.859375,
        1087.7275390625
      ],
      "bbox_max": [
        -1180.0,
        -4003.867431640625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7999126315116882,
        0.5999335050582886,
        -0.014815576374530792
      ],
      "plane_d": 3530.182861328125,
      "bbox_min": [
        -1210.4444580078125,
        -4443.85791015625,
        660.0
      ],
      "bbox_max": [
        -1030.0,
        -4170.0,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8381302952766418,
        0.5454476475715637,
        0.00492834160104394
      ],
      "plane_d": 3319.80322265625,
      "bbox_min": [
        -1210.4444580078125,
        -4443.85791015625,
        660.0
      ],
      "bbox_max": [
        -1030.0,
        -4170.0,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8743228316307068,
        0.4749393165111542,
        0.09996094554662704
      ],
      "plane_d": 1056.8970947265625,
      "bbox_min": [
        -1210.4444580078125,
        -4443.85791015625,
        660.0
      ],
      "bbox_max": [
        -1030.0,
        -4170.0,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9984944462776184,
        -0.029658252373337746,
        0.04614244028925896
      ],
      "plane_d": 1022.8195190429688,
      "bbox_min": [
        -1210.4444580078125,
        -4396.25048828125,
        660.0
      ],
      "bbox_max": [
        -1030.0,
        -4170.0,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8891926407814026,
        0.4445946514606476,
        0.10803722590208054
      ],
      "plane_d": 901.750732421875,
      "bbox_min": [
        -1192.4200439453125,
        -4396.25048828125,
        660.0
      ],
      "bbox_max": [
        -1030.0,
        -4170.0,
        1020.9401245117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.985288679599762,
        -0.14671219885349274,
        0.08764538168907166
      ],
      "plane_d": 479.2646484375,
      "bbox_min": [
        -1192.4200439453125,
        -4276.279296875,
        660.0
      ],
      "bbox_max": [
        -1030.0,
        -4170.0,
        956.3939208984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9788087010383606,
        -0.16606548428535461,
        0.11981509625911713
      ],
      "plane_d": 367.6139831542969,
      "bbox_min": [
        -1181.8798828125,
        -4276.279296875,
        660.0
      ],
      "bbox_max": [
        -1030.0,
        -4170.0,
        747.1873168945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9810741543769836,
        0.16107186675071716,
        0.10746750980615616
      ],
      "plane_d": -403.0553894042969,
      "bbox_min": [
        -1039.040771484375,
        -4269.8291015625,
        660.0
      ],
      "bbox_max": [
        -1030.0,
        -4170.0,
        747.1873168945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9638007283210754,
        0.25079670548439026,
        0.09049421548843384
      ],
      "plane_d": 8.925857543945312,
      "bbox_min": [
        -1039.040771484375,
        -4266.72412109375,
        660.0
      ],
      "bbox_max": [
        -1030.0,
        -4231.98095703125,
        726.3345336914062
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 735.0,
      "bbox_min": [
        -1035.0,
        -4212.0,
        735.0
      ],
      "bbox_max": [
        -1030.0,
        -4170.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1035.0,
      "bbox_min": [
        -1035.0,
        -4212.0,
        735.0
      ],
      "bbox_max": [
        -1030.0,
        -4170.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -740.0,
      "bbox_min": [
        -1035.0,
        -4212.0,
        735.0
      ],
      "bbox_max": [
        -1030.0,
        -4170.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4212.0,
      "bbox_min": [
        -1035.0,
        -4212.0,
        735.0
      ],
      "bbox_max": [
        -1030.0,
        -4212.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09546536207199097,
        -0.2028639018535614,
        0.9745422601699829
      ],
      "plane_d": -1380.1666259765625,
      "bbox_min": [
        -1387.0,
        -4059.0,
        702.5800170898438
      ],
      "bbox_max": [
        -1260.0,
        -3989.0,
        757.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3716106712818146,
        0.04514895752072334,
        0.927290141582489
      ],
      "plane_d": 32.260711669921875,
      "bbox_min": [
        -1387.0,
        -4034.0,
        702.5800170898438
      ],
      "bbox_max": [
        -1281.5,
        -4003.607421875,
        718.5511474609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9961532950401306,
        0.0,
        0.08762789517641068
      ],
      "plane_d": 1281.7470703125,
      "bbox_min": [
        -1349.1776123046875,
        -4034.0,
        702.5800170898438
      ],
      "bbox_max": [
        -1281.5,
        -4020.0,
        710.2824096679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9948341250419617,
        0.0,
        0.10151368379592896
      ],
      "plane_d": 1203.465087890625,
      "bbox_min": [
        -1281.6451416015625,
        -4026.912109375,
        703.5
      ],
      "bbox_max": [
        -1281.5,
        -4020.0,
        704.9228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -704.9999389648438,
      "bbox_min": [
        -1385.6263427734375,
        -4059.0,
        703.5
      ],
      "bbox_max": [
        -1260.0,
        -4002.0,
        757.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9948341250419617,
        0.0,
        0.10151368379592896
      ],
      "plane_d": 1203.465087890625,
      "bbox_min": [
        -1281.653076171875,
        -4028.5,
        703.5
      ],
      "bbox_max": [
        -1281.5,
        -4020.145263671875,
        705.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5863916277885437,
        0.7463166117668152,
        -0.3148910701274872
      ],
      "plane_d": 4045.76025390625,
      "bbox_min": [
        -1385.6263427734375,
        -4059.0,
        705.0
      ],
      "bbox_max": [
        -1260.0,
        -4002.0,
        757.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7467644214630127,
        0.45938149094581604,
        -0.48094862699508667
      ],
      "plane_d": 3226.9619140625,
      "bbox_min": [
        -1385.6263427734375,
        -4059.0,
        705.0
      ],
      "bbox_max": [
        -1260.0,
        -4002.0,
        757.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8449393510818481,
        0.250756174325943,
        -0.472439169883728
      ],
      "plane_d": 2513.95068359375,
      "bbox_min": [
        -1385.6263427734375,
        -4059.0,
        705.0
      ],
      "bbox_max": [
        -1260.0,
        -4002.0,
        751.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8338351845741272,
        0.25701743364334106,
        -0.4885293245315552
      ],
      "plane_d": 2535.4140625,
      "bbox_min": [
        -1385.6263427734375,
        -4037.0,
        714.0
      ],
      "bbox_max": [
        -1378.0,
        -4002.0,
        729.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3716106712818146,
        0.04514895752072334,
        0.927290141582489
      ],
      "plane_d": 32.260711669921875,
      "bbox_min": [
        -1382.9248046875,
        -4037.0,
        714.0
      ],
      "bbox_max": [
        -1378.0,
        -4018.9423828125,
        715.0944213867188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47394466400146484,
        0.6032022833824158,
        0.6415008306503296
      ],
      "plane_d": 2630.19189453125,
      "bbox_min": [
        -1382.7137451171875,
        -4059.0,
        705.0
      ],
      "bbox_max": [
        -1260.0,
        -4017.6591796875,
        731.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3346160650253296,
        0.11582861095666885,
        0.9352089762687683
      ],
      "plane_d": 260.96185302734375,
      "bbox_min": [
        -1382.7137451171875,
        -4051.0,
        705.0
      ],
      "bbox_max": [
        -1260.0,
        -4017.6591796875,
        731.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9948341250419617,
        0.0,
        0.10151368379592896
      ],
      "plane_d": 1203.465087890625,
      "bbox_min": [
        -1382.7137451171875,
        -4037.0,
        705.0
      ],
      "bbox_max": [
        -1260.0,
        -4017.6591796875,
        731.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9961532950401306,
        0.0,
        0.08762789517641068
      ],
      "plane_d": 1281.7470703125,
      "bbox_min": [
        -1382.7137451171875,
        -4037.0,
        708.7540893554688
      ],
      "bbox_max": [
        -1349.0430908203125,
        -4019.191162109375,
        731.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3716106712818146,
        0.04514895752072334,
        0.927290141582489
      ],
      "plane_d": 32.260711669921875,
      "bbox_min": [
        -1382.7137451171875,
        -4037.0,
        711.0
      ],
      "bbox_max": [
        -1371.0,
        -4019.191162109375,
        715.02197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06758368015289307,
        0.05127038061618805,
        0.996395468711853
      ],
      "plane_d": -581.6273193359375,
      "bbox_min": [
        -1270.5,
        -4031.5,
        705.0
      ],
      "bbox_max": [
        -1260.0,
        -4017.6591796875,
        705.5302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8214666247367859,
        -0.2627931237220764,
        0.5060952305793762
      ],
      "plane_d": -1936.05078125,
      "bbox_min": [
        -1100.0,
        -4461.56787109375,
        1302.5999755859375
      ],
      "bbox_max": [
        -342.082275390625,
        -2690.8427734375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6356639862060547,
        -0.35781198740005493,
        0.6840335130691528
      ],
      "plane_d": -2381.548583984375,
      "bbox_min": [
        -1100.0,
        -4461.56787109375,
        1302.5999755859375
      ],
      "bbox_max": [
        -342.082275390625,
        -2690.8427734375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.512399435043335,
        0.7244004011154175,
        0.4611842632293701
      ],
      "plane_d": 1486.495849609375,
      "bbox_min": [
        -1100.0,
        -4461.56787109375,
        1302.5999755859375
      ],
      "bbox_max": [
        -342.082275390625,
        -2690.8427734375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3404339551925659,
        0.7671160101890564,
        0.5437257885932922
      ],
      "plane_d": 1612.6265869140625,
      "bbox_min": [
        -1100.0,
        -4461.56787109375,
        1302.5999755859375
      ],
      "bbox_max": [
        -342.082275390625,
        -3253.36376953125,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.971863329410553,
        0.2277802973985672,
        0.05998194217681885
      ],
      "plane_d": 90.97808837890625,
      "bbox_min": [
        -1100.0,
        -4461.56787109375,
        1302.5999755859375
      ],
      "bbox_max": [
        -513.5322265625,
        -3253.36376953125,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4902830421924591,
        0.7414035797119141,
        0.4581957757472992
      ],
      "plane_d": 1563.4337158203125,
      "bbox_min": [
        -622.244140625,
        -3461.04345703125,
        1302.5999755859375
      ],
      "bbox_max": [
        -513.5322265625,
        -3253.36376953125,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9773173928260803,
        0.18042781949043274,
        0.11089008301496506
      ],
      "plane_d": -170.76866149902344,
      "bbox_min": [
        -1100.0,
        -4461.56787109375,
        1302.5999755859375
      ],
      "bbox_max": [
        -602.25048828125,
        -3312.0322265625,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4902830421924591,
        0.7414035797119141,
        0.4581957757472992
      ],
      "plane_d": 1563.4337158203125,
      "bbox_min": [
        -643.5195922851562,
        -3450.85888671875,
        1302.5999755859375
      ],
      "bbox_max": [
        -602.25048828125,
        -3312.0322265625,
        1505.8404541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.567858099937439,
        0.8212112188339233,
        0.05611976608633995
      ],
      "plane_d": 2804.5029296875,
      "bbox_min": [
        -1100.0,
        -4461.56787109375,
        1302.5999755859375
      ],
      "bbox_max": [
        -643.4113159179688,
        -3339.25146484375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5781539082527161,
        0.8130282759666443,
        0.06872465461492538
      ],
      "plane_d": 2744.22998046875,
      "bbox_min": [
        -1100.0,
        -4461.56787109375,
        1302.5999755859375
      ],
      "bbox_max": [
        -759.785888671875,
        -4045.35595703125,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8644177317619324,
        0.49423548579216003,
        0.09226787090301514
      ],
      "plane_d": 1163.1292724609375,
      "bbox_min": [
        -1100.0,
        -4461.56787109375,
        1302.5999755859375
      ],
      "bbox_max": [
        -934.64208984375,
        -4162.021484375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8735374808311462,
        0.47451266646385193,
        0.10848979651927948
      ],
      "plane_d": 1044.720947265625,
      "bbox_min": [
        -1100.0,
        -4461.56787109375,
        1302.5999755859375
      ],
      "bbox_max": [
        -934.64208984375,
        -4162.021484375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9881092309951782,
        0.11624804884195328,
        0.10063126683235168
      ],
      "plane_d": -593.2681274414062,
      "bbox_min": [
        -1100.0,
        -4461.56787109375,
        1302.5999755859375
      ],
      "bbox_max": [
        -934.64208984375,
        -4162.021484375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9838921427726746,
        0.16153454780578613,
        0.07656921446323395
      ],
      "plane_d": -363.56280517578125,
      "bbox_min": [
        -972.4072265625,
        -4289.609375,
        1302.5999755859375
      ],
      "bbox_max": [
        -934.64208984375,
        -4162.021484375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7916321754455566,
        0.6109883785247803,
        -0.003411970566958189
      ],
      "plane_d": 3555.708740234375,
      "bbox_min": [
        -1100.0,
        -4461.56787109375,
        1302.5999755859375
      ],
      "bbox_max": [
        -1041.5263671875,
        -4385.45263671875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7999369502067566,
        0.5999518036842346,
        0.012606487609446049
      ],
      "plane_d": 3494.570068359375,
      "bbox_min": [
        -1100.0,
        -4443.85791015625,
        1302.5999755859375
      ],
      "bbox_max": [
        -1056.1962890625,
        -4385.45263671875,
        1364.652587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6569232940673828,
        -0.7521604299545288,
        0.05202310532331467
      ],
      "plane_d": -3396.388427734375,
      "bbox_min": [
        -977.8182983398438,
        -3796.67138671875,
        1302.5999755859375
      ],
      "bbox_max": [
        -643.4113159179688,
        -3339.25146484375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4902830421924591,
        0.7414035797119141,
        0.4581957757472992
      ],
      "plane_d": 1563.4337158203125,
      "bbox_min": [
        -704.468994140625,
        -3432.42822265625,
        1302.5999755859375
      ],
      "bbox_max": [
        -643.4113159179688,
        -3339.25146484375,
        1453.2525634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6437557935714722,
        -0.7623260021209717,
        0.06661495566368103
      ],
      "plane_d": -3444.360595703125,
      "bbox_min": [
        -977.8182983398438,
        -3790.68359375,
        1302.5999755859375
      ],
      "bbox_max": [
        -726.752685546875,
        -3572.979736328125,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6734017729759216,
        -0.7359853386878967,
        0.06968268007040024
      ],
      "plane_d": -3378.893798828125,
      "bbox_min": [
        -977.8182983398438,
        -3646.800048828125,
        1302.5999755859375
      ],
      "bbox_max": [
        -873.099365234375,
        -3572.979736328125,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4018848240375519,
        -0.6489609479904175,
        0.6460171937942505
      ],
      "plane_d": -3022.886474609375,
      "bbox_min": [
        -1100.0,
        -3646.800048828125,
        1302.5999755859375
      ],
      "bbox_max": [
        -511.1015625,
        -2690.8427734375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6734017729759216,
        -0.7359853386878967,
        0.06968268007040024
      ],
      "plane_d": -3378.893798828125,
      "bbox_min": [
        -1100.0,
        -3646.800048828125,
        1302.5999755859375
      ],
      "bbox_max": [
        -873.099365234375,
        -2856.87744140625,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10619720071554184,
        -0.7439054846763611,
        0.6597930788993835
      ],
      "plane_d": -2987.148193359375,
      "bbox_min": [
        -1100.0,
        -3017.20947265625,
        1302.5999755859375
      ],
      "bbox_max": [
        -1026.85400390625,
        -2963.177978515625,
        1363.51953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34675103425979614,
        -0.7122377753257751,
        0.6103124022483826
      ],
      "plane_d": -2533.99267578125,
      "bbox_min": [
        -1760.0,
        -3203.987060546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -1100.0,
        -2802.316162109375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48143571615219116,
        -0.5738243460655212,
        0.6625293493270874
      ],
      "plane_d": -2018.246337890625,
      "bbox_min": [
        -1760.0,
        -3203.987060546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -1167.873291015625,
        -2811.119384765625,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20202520489692688,
        -0.8296098113059998,
        0.5205125212669373
      ],
      "plane_d": -2979.09912109375,
      "bbox_min": [
        -1760.0,
        -3203.987060546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -1411.0396728515625,
        -3013.635498046875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08832583576440811,
        -0.8090729713439941,
        0.5810332894325256
      ],
      "plane_d": -3184.2685546875,
      "bbox_min": [
        -1760.0,
        -3203.987060546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -1411.0396728515625,
        -3027.011962890625,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.30647212266921997,
        -0.7587150931358337,
        0.5748271346092224
      ],
      "plane_d": -2690.01171875,
      "bbox_min": [
        -1509.300537109375,
        -3163.810791015625,
        1302.5999755859375
      ],
      "bbox_max": [
        -1411.0396728515625,
        -3106.068359375,
        1384.676025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22038745880126953,
        -0.8264544606208801,
        0.5180755853652954
      ],
      "plane_d": -2934.9130859375,
      "bbox_min": [
        -1760.0,
        -3203.987060546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -1680.74951171875,
        -3037.23291015625,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23221024870872498,
        -0.8293224573135376,
        0.5082348585128784
      ],
      "plane_d": -2908.64794921875,
      "bbox_min": [
        -1760.0,
        -3105.5673828125,
        1459.6031494140625
      ],
      "bbox_max": [
        -1680.74951171875,
        -3037.23291015625,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10619720071554184,
        -0.7439054846763611,
        0.6597930788993835
      ],
      "plane_d": -2987.148193359375,
      "bbox_min": [
        -1305.776123046875,
        -3033.836669921875,
        1302.5999755859375
      ],
      "bbox_max": [
        -1167.873291015625,
        -2811.119384765625,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1512952446937561,
        -0.7088976502418518,
        0.6888933181762695
      ],
      "plane_d": -2873.484375,
      "bbox_min": [
        -1305.776123046875,
        -2901.427490234375,
        1449.8204345703125
      ],
      "bbox_max": [
        -1167.873291015625,
        -2811.119384765625,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.41471293568611145,
        -0.6906698942184448,
        0.5924426317214966
      ],
      "plane_d": -2347.342041015625,
      "bbox_min": [
        -1583.84765625,
        -3128.560791015625,
        1302.5999755859375
      ],
      "bbox_max": [
        -1100.0,
        -2802.316162109375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.30647212266921997,
        -0.7587150931358337,
        0.5748271346092224
      ],
      "plane_d": -2690.01171875,
      "bbox_min": [
        -1583.84765625,
        -3128.560791015625,
        1302.5999755859375
      ],
      "bbox_max": [
        -1411.0396728515625,
        -3000.38232421875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20202520489692688,
        -0.8296098113059998,
        0.5205125212669373
      ],
      "plane_d": -2979.09912109375,
      "bbox_min": [
        -1583.84765625,
        -3027.011962890625,
        1501.2713623046875
      ],
      "bbox_max": [
        -1529.423828125,
        -3000.38232421875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10619720071554184,
        -0.7439054846763611,
        0.6597930788993835
      ],
      "plane_d": -2987.148193359375,
      "bbox_min": [
        -1216.4732666015625,
        -3033.836669921875,
        1302.5999755859375
      ],
      "bbox_max": [
        -1100.0,
        -2802.316162109375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1512952446937561,
        -0.7088976502418518,
        0.6888933181762695
      ],
      "plane_d": -2873.484375,
      "bbox_min": [
        -1203.6212158203125,
        -2963.177978515625,
        1363.51953125
      ],
      "bbox_max": [
        -1100.0,
        -2802.316162109375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5655401349067688,
        0.7059893012046814,
        0.4263138175010681
      ],
      "plane_d": 2665.9970703125,
      "bbox_min": [
        -1760.0,
        -4386.7568359375,
        1302.5999755859375
      ],
      "bbox_max": [
        -1100.0,
        -3382.0,
        1574.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9990858435630798,
        0.01019347459077835,
        0.04151429235935211
      ],
      "plane_d": 1198.4632568359375,
      "bbox_min": [
        -1760.0,
        -4386.7568359375,
        1302.5999755859375
      ],
      "bbox_max": [
        -1100.0,
        -3382.0,
        1574.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4469253122806549,
        0.8841609358787537,
        0.13607771694660187
      ],
      "plane_d": 3523.403076171875,
      "bbox_min": [
        -1760.0,
        -3630.6875,
        1302.5999755859375
      ],
      "bbox_max": [
        -1217.0596923828125,
        -3382.0,
        1574.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34272027015686035,
        0.9365004897117615,
        0.07422665506601334
      ],
      "plane_d": 2554.111572265625,
      "bbox_min": [
        -1727.3770751953125,
        -3589.865234375,
        1302.5999755859375
      ],
      "bbox_max": [
        -1217.0596923828125,
        -3382.0,
        1574.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.030036021023988724,
        0.9266842007637024,
        0.3746386170387268
      ],
      "plane_d": 2593.50927734375,
      "bbox_min": [
        -1627.48095703125,
        -3589.865234375,
        1302.5999755859375
      ],
      "bbox_max": [
        -1217.0596923828125,
        -3434.824951171875,
        1574.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6396912932395935,
        0.7676994204521179,
        0.037849828600883484
      ],
      "plane_d": 3485.137451171875,
      "bbox_min": [
        -1550.0,
        -3589.865234375,
        1302.5999755859375
      ],
      "bbox_max": [
        -1217.0596923828125,
        -3438.771728515625,
        1459.5447998046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -1487.699951171875,
      "bbox_min": [
        -1550.0,
        -3439.0,
        1459.0
      ],
      "bbox_max": [
        -1549.7508544921875,
        -3438.771728515625,
        1459.5447998046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9400216937065125,
        0.3411146402359009
      ],
      "plane_d": 2738.791748046875,
      "bbox_min": [
        -1599.9825439453125,
        -3480.648681640625,
        1500.0
      ],
      "bbox_max": [
        -1545.341552734375,
        -3457.8603515625,
        1562.798583984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9400216937065125,
        0.3411146402359009
      ],
      "plane_d": 2738.791748046875,
      "bbox_min": [
        -1627.48095703125,
        -3485.0400390625,
        1459.0
      ],
      "bbox_max": [
        -1545.4453125,
        -3434.824951171875,
        1574.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -3629.7470703125,
      "bbox_min": [
        -1620.8994140625,
        -3439.0,
        1485.0
      ],
      "bbox_max": [
        -1620.0,
        -3438.175537109375,
        1496.973388671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8500498533248901,
        0.5251100659370422,
        0.04092385247349739
      ],
      "plane_d": 3041.765869140625,
      "bbox_min": [
        -1546.78759765625,
        -3440.310546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -1520.6458740234375,
        -3409.7333984375,
        1488.55517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -1487.699951171875,
      "bbox_min": [
        -1546.78759765625,
        -3436.055419921875,
        1459.0
      ],
      "bbox_max": [
        -1540.9151611328125,
        -3430.67236328125,
        1488.55517578125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9661343693733215,
        0.24907872080802917,
        0.0674104243516922
      ],
      "plane_d": -827.2496337890625,
      "bbox_min": [
        -1650.8538818359375,
        -3443.77099609375,
        1302.5999755859375
      ],
      "bbox_max": [
        -1620.214599609375,
        -3382.0,
        1496.0819091796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -3629.7470703125,
      "bbox_min": [
        -1622.8826904296875,
        -3438.80322265625,
        1485.0
      ],
      "bbox_max": [
        -1620.214599609375,
        -3436.357666015625,
        1496.0819091796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9898766279220581,
        0.1408064216375351,
        0.01782338321208954
      ],
      "plane_d": -1165.5235595703125,
      "bbox_min": [
        -1634.787841796875,
        -3386.786865234375,
        1345.2088623046875
      ],
      "bbox_max": [
        -1634.2630615234375,
        -3382.0,
        1355.8946533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7432345151901245,
        0.5606855154037476,
        0.36501291394233704
      ],
      "plane_d": 169.5526123046875,
      "bbox_min": [
        -1760.0,
        -3542.7783203125,
        1302.5999755859375
      ],
      "bbox_max": [
        -1620.0,
        -3382.0,
        1574.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7289522290229797,
        0.6049720644950867,
        0.3203705847263336
      ],
      "plane_d": 411.9771423339844,
      "bbox_min": [
        -1760.0,
        -3526.5615234375,
        1302.5999755859375
      ],
      "bbox_max": [
        -1620.0,
        -3382.0,
        1505.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -3629.7470703125,
      "bbox_min": [
        -1632.0,
        -3439.0,
        1459.0
      ],
      "bbox_max": [
        -1620.0,
        -3420.07177734375,
        1505.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1632.0,
      "bbox_min": [
        -1632.0,
        -3428.0,
        1459.0
      ],
      "bbox_max": [
        -1632.0,
        -3420.07177734375,
        1473.971435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9661343693733215,
        0.24907872080802917,
        0.0674104243516922
      ],
      "plane_d": -827.2496337890625,
      "bbox_min": [
        -1642.5057373046875,
        -3445.635498046875,
        1355.8927001953125
      ],
      "bbox_max": [
        -1634.7877197265625,
        -3386.785888671875,
        1487.26513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9898766279220581,
        0.1408064216375351,
        0.01782338321208954
      ],
      "plane_d": -1165.5235595703125,
      "bbox_min": [
        -1640.79345703125,
        -3445.635498046875,
        1383.4417724609375
      ],
      "bbox_max": [
        -1624.6888427734375,
        -3382.0,
        1503.2625732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -3629.7470703125,
      "bbox_min": [
        -1629.9910888671875,
        -3434.701904296875,
        1485.0
      ],
      "bbox_max": [
        -1624.6888427734375,
        -3429.841552734375,
        1503.2625732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9963745474815369,
        0.0845751017332077,
        0.009205454960465431
      ],
      "plane_d": -1354.2691650390625,
      "bbox_min": [
        -1633.395751953125,
        -3383.444091796875,
        1397.3492431640625
      ],
      "bbox_max": [
        -1633.291748046875,
        -3382.0,
        1406.7977294921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9898766279220581,
        0.1408064216375351,
        0.01782338321208954
      ],
      "plane_d": -1165.5235595703125,
      "bbox_min": [
        -1640.79345703125,
        -3445.635498046875,
        1404.7913818359375
      ],
      "bbox_max": [
        -1624.184326171875,
        -3382.0,
        1505.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1632.0,
      "bbox_min": [
        -1632.0,
        -3435.164306640625,
        1459.0
      ],
      "bbox_max": [
        -1624.184326171875,
        -3388.35693359375,
        1505.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6401844024658203,
        0.768221378326416,
        0.0
      ],
      "plane_d": 1562.9464111328125,
      "bbox_min": [
        -1632.0,
        -3435.164306640625,
        1459.0
      ],
      "bbox_max": [
        -1624.184326171875,
        -3388.35693359375,
        1505.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -3629.7470703125,
      "bbox_min": [
        -1632.0,
        -3435.164306640625,
        1485.0
      ],
      "bbox_max": [
        -1624.184326171875,
        -3428.0,
        1505.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9963745474815369,
        0.0845751017332077,
        0.009205454960465431
      ],
      "plane_d": -1354.2691650390625,
      "bbox_min": [
        -1633.66796875,
        -3394.5849609375,
        1404.7913818359375
      ],
      "bbox_max": [
        -1632.9208984375,
        -3382.0,
        1479.697021484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8500498533248901,
        0.5251100659370422,
        0.04092385247349739
      ],
      "plane_d": 3041.765869140625,
      "bbox_min": [
        -1633.0465087890625,
        -3440.310546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -1523.64404296875,
        -3382.0,
        1505.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9963745474815369,
        0.0845751017332077,
        0.009205454960465431
      ],
      "plane_d": -1354.2691650390625,
      "bbox_min": [
        -1633.0465087890625,
        -3432.51416015625,
        1444.9298095703125
      ],
      "bbox_max": [
        -1538.0,
        -3382.0,
        1505.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401844024658203,
        0.768221378326416,
        0.0
      ],
      "plane_d": 1562.9464111328125,
      "bbox_min": [
        -1629.9166259765625,
        -3432.51416015625,
        1459.0
      ],
      "bbox_max": [
        -1538.0,
        -3384.5,
        1505.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -1487.699951171875,
      "bbox_min": [
        -1542.92431640625,
        -3432.51416015625,
        1459.0
      ],
      "bbox_max": [
        -1538.0,
        -3425.24755859375,
        1477.56591796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1538.0,
      "bbox_min": [
        -1538.0,
        -3428.0,
        1459.0
      ],
      "bbox_max": [
        -1538.0,
        -3425.24755859375,
        1463.557861328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9726229310035706,
        0.20830567181110382,
        -0.10302186012268066
      ],
      "plane_d": 2349.484130859375,
      "bbox_min": [
        -1552.311279296875,
        -3440.310546875,
        1312.15576171875
      ],
      "bbox_max": [
        -1523.64404296875,
        -3382.0,
        1464.900146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.982089102268219,
        0.1529073566198349,
        -0.11009181290864944
      ],
      "plane_d": 2186.53564453125,
      "bbox_min": [
        -1544.6763916015625,
        -3383.273681640625,
        1384.2362060546875
      ],
      "bbox_max": [
        -1543.1268310546875,
        -3382.0,
        1396.290771484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9966359734535217,
        -0.02960304729640484,
        0.0764235183596611
      ],
      "plane_d": 981.3597412109375,
      "bbox_min": [
        -1222.1834716796875,
        -4386.7568359375,
        1302.5999755859375
      ],
      "bbox_max": [
        -1100.0,
        -3589.814208984375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6396912932395935,
        0.7676994204521179,
        0.037849828600883484
      ],
      "plane_d": 3485.137451171875,
      "bbox_min": [
        -1217.202392578125,
        -3610.853271484375,
        1302.5999755859375
      ],
      "bbox_max": [
        -1191.810546875,
        -3589.814208984375,
        1307.5003662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7999369502067566,
        0.5999518036842346,
        0.012606487609446049
      ],
      "plane_d": 3494.570068359375,
      "bbox_min": [
        -1222.1834716796875,
        -4386.7568359375,
        1302.5999755859375
      ],
      "bbox_max": [
        -1100.0,
        -3610.783447265625,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9938523769378662,
        -0.09317367523908615,
        0.059800684452056885
      ],
      "plane_d": 742.4613647460938,
      "bbox_min": [
        -1222.1834716796875,
        -4386.7568359375,
        1302.5999755859375
      ],
      "bbox_max": [
        -1100.0,
        -3610.783447265625,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9879611730575562,
        -0.13172876834869385,
        0.08111798018217087
      ],
      "plane_d": 551.607666015625,
      "bbox_min": [
        -1222.1834716796875,
        -4045.859375,
        1302.5999755859375
      ],
      "bbox_max": [
        -1165.968505859375,
        -3610.783447265625,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6396912932395935,
        0.7676994204521179,
        0.037849828600883484
      ],
      "plane_d": 3485.137451171875,
      "bbox_min": [
        -1192.1842041015625,
        -3632.38623046875,
        1302.5999755859375
      ],
      "bbox_max": [
        -1165.968505859375,
        -3610.783447265625,
        1309.000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7916321754455566,
        0.6109883785247803,
        -0.003411970566958189
      ],
      "plane_d": 3555.708740234375,
      "bbox_min": [
        -1220.1796875,
        -4386.7568359375,
        1302.5999755859375
      ],
      "bbox_max": [
        -1100.0,
        -3632.38134765625,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8925696015357971,
        -0.4462858736515045,
        0.06440897285938263
      ],
      "plane_d": -770.0093994140625,
      "bbox_min": [
        -1206.640625,
        -3923.984375,
        1302.5999755859375
      ],
      "bbox_max": [
        -1138.591064453125,
        -3632.38134765625,
        1534.9000244140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9981271624565125,
        -0.0,
        0.061172593384981155
      ],
      "plane_d": 1060.067626953125,
      "bbox_min": [
        -1166.3531494140625,
        -3821.15234375,
        1302.5999755859375
      ],
      "bbox_max": [
        -1138.591064453125,
        -3632.38134765625,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.988699734210968,
        0.13802379369735718,
        0.058500275015830994
      ],
      "plane_d": 1562.8328857421875,
      "bbox_min": [
        -1166.3531494140625,
        -3695.3720703125,
        1302.5999755859375
      ],
      "bbox_max": [
        -1141.8896484375,
        -3632.38134765625,
        1385.519775390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6396912932395935,
        0.7676994204521179,
        0.037849828600883484
      ],
      "plane_d": 3485.137451171875,
      "bbox_min": [
        -1166.3531494140625,
        -3646.800048828125,
        1302.5999755859375
      ],
      "bbox_max": [
        -1148.67041015625,
        -3632.38134765625,
        1310.00146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9966461062431335,
        -0.03218284249305725,
        0.07523989677429199
      ],
      "plane_d": 917.0767822265625,
      "bbox_min": [
        -1152.5513916015625,
        -3821.15234375,
        1302.5999755859375
      ],
      "bbox_max": [
        -1138.591064453125,
        -3694.11376953125,
        1476.563720703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9941527247428894,
        0.07765709608793259,
        0.07503113150596619
      ],
      "plane_d": 1323.004638671875,
      "bbox_min": [
        -1148.0684814453125,
        -3719.0009765625,
        1302.5999755859375
      ],
      "bbox_max": [
        -1138.591064453125,
        -3694.11376953125,
        1428.1500244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.988699734210968,
        0.13802379369735718,
        0.058500275015830994
      ],
      "plane_d": 1562.8328857421875,
      "bbox_min": [
        -1146.9715576171875,
        -3719.0009765625,
        1302.5999755859375
      ],
      "bbox_max": [
        -1138.591064453125,
        -3694.11376953125,
        1388.7730712890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17638064920902252,
        0.9313802123069763,
        0.3184661865234375
      ],
      "plane_d": 3107.617431640625,
      "bbox_min": [
        -1621.736328125,
        -3776.983642578125,
        1302.5999755859375
      ],
      "bbox_max": [
        -1146.8795166015625,
        -3382.0,
        1574.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6396912932395935,
        0.7676994204521179,
        0.037849828600883484
      ],
      "plane_d": 3485.137451171875,
      "bbox_min": [
        -1276.5831298828125,
        -3776.983642578125,
        1302.5999755859375
      ],
      "bbox_max": [
        -1146.8795166015625,
        -3540.2158203125,
        1571.2440185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.988699734210968,
        0.13802379369735718,
        0.058500275015830994
      ],
      "plane_d": 1562.8328857421875,
      "bbox_min": [
        -1163.990966796875,
        -3776.983642578125,
        1310.0015869140625
      ],
      "bbox_max": [
        -1146.8795166015625,
        -3646.800048828125,
        1571.2440185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9941527247428894,
        0.07765709608793259,
        0.07503113150596619
      ],
      "plane_d": 1323.004638671875,
      "bbox_min": [
        -1163.990966796875,
        -3776.983642578125,
        1388.7730712890625
      ],
      "bbox_max": [
        -1146.8795166015625,
        -3650.26513671875,
        1571.2440185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9966461062431335,
        -0.03218284249305725,
        0.07523989677429199
      ],
      "plane_d": 917.0767822265625,
      "bbox_min": [
        -1156.126708984375,
        -3776.983642578125,
        1428.1500244140625
      ],
      "bbox_max": [
        -1148.0684814453125,
        -3718.95751953125,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9981271624565125,
        -0.0,
        0.061172593384981155
      ],
      "plane_d": 1060.067626953125,
      "bbox_min": [
        -1156.126708984375,
        -3776.983642578125,
        1476.563720703125
      ],
      "bbox_max": [
        -1152.5513916015625,
        -3718.95751953125,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0643240362405777,
        0.9379590749740601,
        0.34072762727737427
      ],
      "plane_d": 2958.86083984375,
      "bbox_min": [
        -1621.736328125,
        -3653.395263671875,
        1302.5999755859375
      ],
      "bbox_max": [
        -1163.4052734375,
        -3382.0,
        1574.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6396912932395935,
        0.7676994204521179,
        0.037849828600883484
      ],
      "plane_d": 3485.137451171875,
      "bbox_min": [
        -1276.5831298828125,
        -3653.395263671875,
        1302.5999755859375
      ],
      "bbox_max": [
        -1163.4052734375,
        -3540.2158203125,
        1574.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9941527247428894,
        0.07765709608793259,
        0.07503113150596619
      ],
      "plane_d": 1323.004638671875,
      "bbox_min": [
        -1164.7821044921875,
        -3653.395263671875,
        1561.8316650390625
      ],
      "bbox_max": [
        -1163.525146484375,
        -3646.800048828125,
        1574.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6359549164772034,
        0.6976706981658936,
        0.3298740088939667
      ],
      "plane_d": 2885.940185546875,
      "bbox_min": [
        -1621.736328125,
        -3611.2421875,
        1394.68359375
      ],
      "bbox_max": [
        -1393.18212890625,
        -3382.0,
        1574.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.030036021023988724,
        0.9266842007637024,
        0.3746386170387268
      ],
      "plane_d": 2593.50927734375,
      "bbox_min": [
        -1621.736328125,
        -3485.0400390625,
        1459.0
      ],
      "bbox_max": [
        -1523.64404296875,
        -3384.5,
        1574.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9400216937065125,
        0.3411146402359009
      ],
      "plane_d": 2738.791748046875,
      "bbox_min": [
        -1547.0858154296875,
        -3485.0400390625,
        1557.000244140625
      ],
      "bbox_max": [
        -1531.6314697265625,
        -3478.544677734375,
        1574.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -1487.699951171875,
      "bbox_min": [
        -1621.736328125,
        -3485.0400390625,
        1459.0
      ],
      "bbox_max": [
        -1531.6314697265625,
        -3384.5,
        1574.9000244140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3384.5,
      "bbox_min": [
        -1621.736328125,
        -3428.0,
        1459.0
      ],
      "bbox_max": [
        -1538.0,
        -3384.5,
        1505.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1538.0,
      "bbox_min": [
        -1621.736328125,
        -3428.0,
        1459.0
      ],
      "bbox_max": [
        -1538.0,
        -3384.5,
        1505.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401844024658203,
        0.768221378326416,
        0.0
      ],
      "plane_d": 1562.946533203125,
      "bbox_min": [
        -1621.736328125,
        -3385.947021484375,
        1500.3006591796875
      ],
      "bbox_max": [
        -1620.0,
        -3384.5,
        1505.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9400216937065125,
        0.3411146402359009
      ],
      "plane_d": 2738.791748046875,
      "bbox_min": [
        -1550.7261962890625,
        -3485.0400390625,
        1562.798583984375
      ],
      "bbox_max": [
        -1531.6314697265625,
        -3480.648681640625,
        1574.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9726229310035706,
        0.20830567181110382,
        -0.10302186012268066
      ],
      "plane_d": 2349.484130859375,
      "bbox_min": [
        -1605.670654296875,
        -3440.310546875,
        1394.68359375
      ],
      "bbox_max": [
        -1523.64404296875,
        -3382.0,
        1531.311767578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3384.5,
      "bbox_min": [
        -1605.670654296875,
        -3437.11767578125,
        1459.0
      ],
      "bbox_max": [
        -1538.0,
        -3382.0,
        1531.311767578125
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1538.0,
      "bbox_min": [
        -1568.5,
        -3437.11767578125,
        1459.0
      ],
      "bbox_max": [
        -1538.0,
        -3384.5,
        1531.311767578125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6401844024658203,
        0.768221378326416,
        0.0
      ],
      "plane_d": 3592.3310546875,
      "bbox_min": [
        -1568.5,
        -3437.11767578125,
        1459.0
      ],
      "bbox_max": [
        -1538.0,
        -3384.5,
        1531.311767578125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -1487.7000732421875,
      "bbox_min": [
        -1568.5,
        -3437.11767578125,
        1466.54052734375
      ],
      "bbox_max": [
        -1538.0,
        -3384.5,
        1531.311767578125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5076730251312256,
        0.6092076897621155,
        0.6092076897621155
      ],
      "plane_d": 1931.8992919921875,
      "bbox_min": [
        -1568.5,
        -3394.5,
        1499.0
      ],
      "bbox_max": [
        -1538.0,
        -3384.5,
        1531.311767578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1499.0,
      "bbox_min": [
        -1568.5,
        -3386.0,
        1499.0
      ],
      "bbox_max": [
        -1561.5,
        -3384.5,
        1499.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5300085544586182,
        6.930902600288391e-06,
        -0.8479923009872437
      ],
      "plane_d": 469.93865966796875,
      "bbox_min": [
        -1563.4188232421875,
        -3384.9921875,
        1526.001220703125
      ],
      "bbox_max": [
        -1554.422119140625,
        -3384.5,
        1531.311767578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.847313404083252,
        -0.03997046872973442,
        -0.5295870304107666
      ],
      "plane_d": 1990.376953125,
      "bbox_min": [
        -1554.93896484375,
        -3384.9921875,
        1526.001220703125
      ],
      "bbox_max": [
        -1554.422119140625,
        -3384.5,
        1526.8118896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1486.5,
      "bbox_min": [
        -1573.5,
        -3384.5,
        1486.5
      ],
      "bbox_max": [
        -1554.3372802734375,
        -3382.0,
        1531.309814453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5300085544586182,
        6.930902600288391e-06,
        -0.8479923009872437
      ],
      "plane_d": 469.93865966796875,
      "bbox_min": [
        -1563.4156494140625,
        -3384.5,
        1486.5
      ],
      "bbox_max": [
        -1554.3372802734375,
        -3382.0,
        1531.309814453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.847313404083252,
        -0.03997046872973442,
        -0.5295870304107666
      ],
      "plane_d": 1990.376953125,
      "bbox_min": [
        -1554.9222412109375,
        -3384.5,
        1525.9482421875
      ],
      "bbox_max": [
        -1554.3372802734375,
        -3382.0,
        1526.8013916015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1557.0,
      "bbox_min": [
        -1557.0,
        -3384.5,
        1486.5
      ],
      "bbox_max": [
        -1557.0,
        -3382.0,
        1488.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.982089102268219,
        0.1529073566198349,
        -0.11009181290864944
      ],
      "plane_d": 2186.53564453125,
      "bbox_min": [
        -1543.5052490234375,
        -3390.09228515625,
        1394.68359375
      ],
      "bbox_max": [
        -1534.83056640625,
        -3382.0,
        1460.8280029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9455833435058594,
        0.3179033696651459,
        -0.06935158371925354
      ],
      "plane_d": -381.4749755859375,
      "bbox_min": [
        -1637.2723388671875,
        -3382.0,
        1302.5999755859375
      ],
      "bbox_max": [
        -1536.1141357421875,
        -3283.58740234375,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9593862891197205,
        0.24561771750450134,
        -0.13874416053295135
      ],
      "plane_d": 2500.552490234375,
      "bbox_min": [
        -1636.6453857421875,
        -3382.0,
        1302.5999755859375
      ],
      "bbox_max": [
        -1536.1141357421875,
        -3283.58740234375,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.982089102268219,
        0.1529073566198349,
        -0.11009181290864944
      ],
      "plane_d": 2186.53564453125,
      "bbox_min": [
        -1636.6453857421875,
        -3382.0,
        1302.5999755859375
      ],
      "bbox_max": [
        -1536.1141357421875,
        -3283.58740234375,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9963745474815369,
        0.0845751017332077,
        0.009205454960465431
      ],
      "plane_d": -1354.2691650390625,
      "bbox_min": [
        -1636.6453857421875,
        -3382.0,
        1302.5999755859375
      ],
      "bbox_max": [
        -1547.0,
        -3283.58740234375,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1485.0,
      "bbox_min": [
        -1633.0650634765625,
        -3382.0,
        1302.5999755859375
      ],
      "bbox_max": [
        -1547.0,
        -3283.58740234375,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3328.0,
      "bbox_min": [
        -1627.0,
        -3382.0,
        1485.0
      ],
      "bbox_max": [
        -1547.0,
        -3328.0,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9958931803703308,
        0.09053574502468109
      ],
      "plane_d": 3181.109130859375,
      "bbox_min": [
        -1627.0,
        -3382.0,
        1485.0
      ],
      "bbox_max": [
        -1547.0,
        -3328.0,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1547.0,
      "bbox_min": [
        -1627.0,
        -3382.0,
        1485.0
      ],
      "bbox_max": [
        -1547.0,
        -3329.227294921875,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1627.0,
      "bbox_min": [
        -1627.0,
        -3382.0,
        1485.0
      ],
      "bbox_max": [
        -1549.0,
        -3329.227294921875,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9958931803703308,
        -0.0,
        0.09053574502468109
      ],
      "plane_d": 1407.92138671875,
      "bbox_min": [
        -1625.5,
        -3382.0,
        1486.5
      ],
      "bbox_max": [
        -1549.0,
        -3329.5,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9958931803703308,
        0.0,
        0.09053574502468109
      ],
      "plane_d": -1753.54150390625,
      "bbox_min": [
        -1625.5,
        -3382.0,
        1486.5
      ],
      "bbox_max": [
        -1552.0,
        -3329.5,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1486.5,
      "bbox_min": [
        -1573.5,
        -3382.0,
        1486.5
      ],
      "bbox_max": [
        -1552.0,
        -3332.0,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999086856842041,
        0.013512278907001019
      ],
      "plane_d": 3352.085693359375,
      "bbox_min": [
        -1557.0,
        -3382.0,
        1486.5
      ],
      "bbox_max": [
        -1552.0,
        -3332.0,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999086856842041,
        0.013512278907001019
      ],
      "plane_d": -3395.2978515625,
      "bbox_min": [
        -1557.0,
        -3382.0,
        1486.5
      ],
      "bbox_max": [
        -1552.0,
        -3372.5,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999086856842041,
        -0.0,
        0.013512278907001019
      ],
      "plane_d": 1531.751953125,
      "bbox_min": [
        -1552.108154296875,
        -3375.5,
        1488.0
      ],
      "bbox_max": [
        -1552.0,
        -3372.5,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1557.0,
      "bbox_min": [
        -1557.0,
        -3382.0,
        1486.5
      ],
      "bbox_max": [
        -1557.0,
        -3380.0,
        1488.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999086856842041,
        0.013512278907001019
      ],
      "plane_d": -3354.8017578125,
      "bbox_min": [
        -1555.0,
        -3335.0,
        1488.0
      ],
      "bbox_max": [
        -1552.0,
        -3332.0,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999086856842041,
        -0.0,
        0.013512278907001019
      ],
      "plane_d": 1531.751953125,
      "bbox_min": [
        -1555.0,
        -3335.0,
        1488.0
      ],
      "bbox_max": [
        -1552.0,
        -3332.0,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999086856842041,
        0.013512278907001019
      ],
      "plane_d": 3311.589599609375,
      "bbox_min": [
        -1555.0,
        -3332.108154296875,
        1488.0
      ],
      "bbox_max": [
        -1552.0,
        -3332.0,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1547.0,
      "bbox_min": [
        -1627.0,
        -3329.5,
        1485.0
      ],
      "bbox_max": [
        -1547.0,
        -3328.0,
        1488.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1627.0,
      "bbox_min": [
        -1627.0,
        -3329.5,
        1485.0
      ],
      "bbox_max": [
        -1627.0,
        -3328.0,
        1488.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39672571420669556,
        0.18136583268642426,
        -0.8998417854309082
      ],
      "plane_d": 1149.486572265625,
      "bbox_min": [
        -1633.0650634765625,
        -3378.5,
        1302.5999755859375
      ],
      "bbox_max": [
        -1548.5,
        -3283.58740234375,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0412130132317543,
        0.43465206027030945,
        -0.8996549844741821
      ],
      "plane_d": 2685.27783203125,
      "bbox_min": [
        -1625.5,
        -3378.5,
        1302.5999755859375
      ],
      "bbox_max": [
        -1548.5,
        -3283.58740234375,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3375.0,
      "bbox_min": [
        -1625.5,
        -3378.5,
        1459.0
      ],
      "bbox_max": [
        -1548.5,
        -3329.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1549.0,
      "bbox_min": [
        -1552.5,
        -3378.5,
        1459.0
      ],
      "bbox_max": [
        -1548.5,
        -3375.0,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1481.9998779296875,
      "bbox_min": [
        -1552.5,
        -3378.5,
        1482.0
      ],
      "bbox_max": [
        -1549.0,
        -3378.0,
        1482.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3333.0,
      "bbox_min": [
        -1625.5,
        -3375.0,
        1459.0
      ],
      "bbox_max": [
        -1548.5,
        -3329.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1549.0,
      "bbox_min": [
        -1625.5,
        -3333.0,
        1459.0
      ],
      "bbox_max": [
        -1548.5,
        -3329.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3330.0,
      "bbox_min": [
        -1625.5,
        -3333.0,
        1459.0
      ],
      "bbox_max": [
        -1549.0,
        -3329.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1625.5,
      "bbox_min": [
        -1625.5,
        -3333.0,
        1482.0
      ],
      "bbox_max": [
        -1552.0,
        -3330.0,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1481.9998779296875,
      "bbox_min": [
        -1625.5,
        -3333.0,
        1482.0
      ],
      "bbox_max": [
        -1552.0,
        -3330.0,
        1482.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3329.5,
      "bbox_min": [
        -1625.5,
        -3330.0,
        1482.0
      ],
      "bbox_max": [
        -1549.0,
        -3329.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1625.5,
      "bbox_min": [
        -1625.5,
        -3330.0,
        1482.0
      ],
      "bbox_max": [
        -1625.5,
        -3329.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1548.5,
      "bbox_min": [
        -1549.0,
        -3333.0,
        1482.0
      ],
      "bbox_max": [
        -1548.5,
        -3329.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1481.9998779296875,
      "bbox_min": [
        -1549.0,
        -3333.0,
        1482.0
      ],
      "bbox_max": [
        -1548.5,
        -3329.5,
        1485.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3329.5,
      "bbox_min": [
        -1549.0,
        -3329.5,
        1482.0
      ],
      "bbox_max": [
        -1548.5,
        -3329.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3333.5,
      "bbox_min": [
        -1625.5,
        -3375.0,
        1482.0
      ],
      "bbox_max": [
        -1548.5,
        -3333.0,
        1485.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 1481.9998779296875,
      "bbox_min": [
        -1625.5,
        -3333.5,
        1482.0
      ],
      "bbox_max": [
        -1548.5,
        -3333.0,
        1485.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3374.5,
      "bbox_min": [
        -1552.5,
        -3375.0,
        1482.0
      ],
      "bbox_max": [
        -1548.5,
        -3374.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1481.9998779296875,
      "bbox_min": [
        -1552.5,
        -3375.0,
        1482.0
      ],
      "bbox_max": [
        -1548.5,
        -3374.5,
        1485.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1548.5,
      "bbox_min": [
        -1548.5,
        -3375.0,
        1482.0
      ],
      "bbox_max": [
        -1548.5,
        -3374.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.056889183819293976,
        0.9831775426864624,
        -0.17356735467910767
      ],
      "plane_d": 3449.109619140625,
      "bbox_min": [
        -1633.0650634765625,
        -3372.64794921875,
        1302.5999755859375
      ],
      "bbox_max": [
        -1597.9923095703125,
        -3369.9052734375,
        1318.2093505859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9898766279220581,
        0.1408064216375351,
        0.01782338321208954
      ],
      "plane_d": -1165.5235595703125,
      "bbox_min": [
        -1636.6453857421875,
        -3382.0,
        1311.5850830078125
      ],
      "bbox_max": [
        -1633.0650634765625,
        -3369.9052734375,
        1397.349365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9661343693733215,
        0.24907872080802917,
        0.0674104243516922
      ],
      "plane_d": -827.2496337890625,
      "bbox_min": [
        -1636.6453857421875,
        -3382.0,
        1311.5850830078125
      ],
      "bbox_max": [
        -1633.0650634765625,
        -3369.9052734375,
        1345.208984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9726229310035706,
        0.20830567181110382,
        -0.10302186012268066
      ],
      "plane_d": 2349.484130859375,
      "bbox_min": [
        -1555.170654296875,
        -3382.0,
        1302.5999755859375
      ],
      "bbox_max": [
        -1544.6763916015625,
        -3373.374755859375,
        1384.2362060546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8500498533248901,
        0.5251100659370422,
        0.04092385247349739
      ],
      "plane_d": 3041.765869140625,
      "bbox_min": [
        -1554.104736328125,
        -3382.0,
        1302.5999755859375
      ],
      "bbox_max": [
        -1551.9346923828125,
        -3378.35205078125,
        1312.15576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8500498533248901,
        0.5251100659370422,
        0.04092385247349739
      ],
      "plane_d": 3041.765869140625,
      "bbox_min": [
        -1552.4217529296875,
        -3382.0,
        1302.5999755859375
      ],
      "bbox_max": [
        -1551.8511962890625,
        -3381.076416015625,
        1304.333251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9661343693733215,
        0.24907872080802917,
        0.0674104243516922
      ],
      "plane_d": -827.2496337890625,
      "bbox_min": [
        -1637.2723388671875,
        -3382.0,
        1302.5999755859375
      ],
      "bbox_max": [
        -1632.8424072265625,
        -3369.9052734375,
        1318.2093505859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.056889183819293976,
        0.9831775426864624,
        -0.17356735467910767
      ],
      "plane_d": 3449.109619140625,
      "bbox_min": [
        -1634.891845703125,
        -3372.7666015625,
        1302.5999755859375
      ],
      "bbox_max": [
        -1632.8424072265625,
        -3369.9052734375,
        1318.2093505859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7066444754600525,
        0.6241137981414795,
        -0.33337000012397766
      ],
      "plane_d": 3727.4794921875,
      "bbox_min": [
        -1643.3553466796875,
        -3382.0,
        1496.0
      ],
      "bbox_max": [
        -1552.108154296875,
        -3313.192626953125,
        1546.3753662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5522074103355408,
        -0.5197985172271729,
        -0.6518255472183228
      ],
      "plane_d": -1656.646484375,
      "bbox_min": [
        -1643.3553466796875,
        -3373.803466796875,
        1500.197509765625
      ],
      "bbox_max": [
        -1582.3048095703125,
        -3321.473388671875,
        1535.136474609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10984108597040176,
        -0.8989793658256531,
        -0.423994243144989
      ],
      "plane_d": -2558.715087890625,
      "bbox_min": [
        -1643.3553466796875,
        -3373.803466796875,
        1500.197509765625
      ],
      "bbox_max": [
        -1582.3048095703125,
        -3321.473388671875,
        1535.136474609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10984160006046295,
        -0.8989806175231934,
        -0.423991322517395
      ],
      "plane_d": -2205.47412109375,
      "bbox_min": [
        -1643.3553466796875,
        -3373.803466796875,
        1500.197509765625
      ],
      "bbox_max": [
        -1582.3048095703125,
        -3321.473388671875,
        1535.136474609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5522040724754333,
        -0.33149459958076477,
        -0.7649718523025513
      ],
      "plane_d": -855.4124755859375,
      "bbox_min": [
        -1643.3553466796875,
        -3371.49658203125,
        1500.197509765625
      ],
      "bbox_max": [
        -1582.3048095703125,
        -3321.473388671875,
        1533.7503662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4681382179260254,
        -0.6937716007232666,
        -0.5472912192344666
      ],
      "plane_d": -2261.712890625,
      "bbox_min": [
        -1640.6640625,
        -3371.49658203125,
        1500.197509765625
      ],
      "bbox_max": [
        -1582.3048095703125,
        -3321.473388671875,
        1533.7503662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4681406617164612,
        -0.15752869844436646,
        -0.8694992661476135
      ],
      "plane_d": 19.9765625,
      "bbox_min": [
        -1640.6640625,
        -3371.49658203125,
        1500.197509765625
      ],
      "bbox_max": [
        -1582.3048095703125,
        -3321.473388671875,
        1533.7503662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3127978444099426,
        -0.8269219398498535,
        -0.467287540435791
      ],
      "plane_d": -2578.472900390625,
      "bbox_min": [
        -1640.6640625,
        -3371.49658203125,
        1500.197509765625
      ],
      "bbox_max": [
        -1582.3048095703125,
        -3321.473388671875,
        1533.7503662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1949397623538971,
        -0.5379993319511414,
        -0.8200947046279907
      ],
      "plane_d": -882.5914306640625,
      "bbox_min": [
        -1640.6640625,
        -3365.4814453125,
        1500.197509765625
      ],
      "bbox_max": [
        -1582.3048095703125,
        -3321.473388671875,
        1529.8031005859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19493962824344635,
        -0.47151145339012146,
        -0.8600438833236694
      ],
      "plane_d": -599.68896484375,
      "bbox_min": [
        -1640.6640625,
        -3365.4814453125,
        1500.197509765625
      ],
      "bbox_max": [
        -1582.3048095703125,
        -3321.473388671875,
        1529.8031005859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16525734961032867,
        -0.5994217395782471,
        -0.7831881046295166
      ],
      "plane_d": -1096.21240234375,
      "bbox_min": [
        -1640.6640625,
        -3365.4814453125,
        1500.197509765625
      ],
      "bbox_max": [
        -1582.3048095703125,
        -3321.473388671875,
        1529.8031005859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11041881889104843,
        -0.646426796913147,
        -0.7549437284469604
      ],
      "plane_d": -1208.0379638671875,
      "bbox_min": [
        -1640.6640625,
        -3365.4814453125,
        1500.197509765625
      ],
      "bbox_max": [
        -1582.3048095703125,
        -3321.473388671875,
        1529.8031005859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16526995599269867,
        -0.4101145565509796,
        -0.8969346284866333
      ],
      "plane_d": -290.7393798828125,
      "bbox_min": [
        -1640.6640625,
        -3365.4814453125,
        1500.197509765625
      ],
      "bbox_max": [
        -1582.3048095703125,
        -3321.473388671875,
        1529.8031005859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03878581523895264,
        -0.6718603372573853,
        -0.7396615743637085
      ],
      "plane_d": -1201.071044921875,
      "bbox_min": [
        -1640.6640625,
        -3365.4814453125,
        1500.197509765625
      ],
      "bbox_max": [
        -1582.3048095703125,
        -3321.473388671875,
        1529.8031005859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.46813642978668213,
        -0.6937713027000427,
        -0.5472930073738098
      ],
      "plane_d": -756.1793823242188,
      "bbox_min": [
        -1640.6640625,
        -3364.92724609375,
        1500.197509765625
      ],
      "bbox_max": [
        -1582.3048095703125,
        -3321.473388671875,
        1529.8031005859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31279879808425903,
        -0.024374349042773247,
        -0.9495065808296204
      ],
      "plane_d": 836.332763671875,
      "bbox_min": [
        -1640.6640625,
        -3337.48291015625,
        1500.197509765625
      ],
      "bbox_max": [
        -1620.1619873046875,
        -3321.473388671875,
        1510.369873046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6955071091651917,
        0.6805833578109741,
        0.23038241267204285
      ],
      "plane_d": 778.6747436523438,
      "bbox_min": [
        -1640.6640625,
        -3331.900634765625,
        1504.0511474609375
      ],
      "bbox_max": [
        -1632.8035888671875,
        -3322.02294921875,
        1510.369873046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999086856842041,
        -0.0,
        0.013512278907001019
      ],
      "plane_d": 1531.751953125,
      "bbox_min": [
        -1631.9603271484375,
        -3382.0,
        1496.0
      ],
      "bbox_max": [
        -1552.108154296875,
        -3313.192626953125,
        1532.1119384765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.9999086856842041,
        0.013512278907001019
      ],
      "plane_d": 3352.085693359375,
      "bbox_min": [
        -1631.9603271484375,
        -3382.0,
        1496.0
      ],
      "bbox_max": [
        -1552.108154296875,
        -3313.192626953125,
        1532.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999086856842041,
        0.013512278907001019
      ],
      "plane_d": -3395.2978515625,
      "bbox_min": [
        -1563.3309326171875,
        -3382.0,
        1496.0
      ],
      "bbox_max": [
        -1552.108154296875,
        -3373.0107421875,
        1531.2568359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.530008852481842,
        -0.0,
        -0.8479921221733093
      ],
      "plane_d": 469.91461181640625,
      "bbox_min": [
        -1563.090576171875,
        -3374.989013671875,
        1525.7999267578125
      ],
      "bbox_max": [
        -1554.5999755859375,
        -3373.0107421875,
        1531.106689453125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.5300085544586182,
        6.930902600288391e-06,
        -0.8479923009872437
      ],
      "plane_d": 469.93865966796875,
      "bbox_min": [
        -1563.3309326171875,
        -3382.0,
        1525.7999267578125
      ],
      "bbox_max": [
        -1554.099853515625,
        -3374.917236328125,
        1531.2568359375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.847313404083252,
        -0.03997046872973442,
        -0.5295870304107666
      ],
      "plane_d": 1990.376953125,
      "bbox_min": [
        -1554.83740234375,
        -3382.0,
        1525.7999267578125
      ],
      "bbox_max": [
        -1554.099853515625,
        -3375.0,
        1526.7484130859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999086856842041,
        0.013512278907001019
      ],
      "plane_d": -3354.8017578125,
      "bbox_min": [
        -1631.9603271484375,
        -3373.08251953125,
        1496.0
      ],
      "bbox_max": [
        -1552.108154296875,
        -3313.192626953125,
        1532.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10984069854021072,
        0.04768303781747818,
        -0.9928048253059387
      ],
      "plane_d": 1469.29345703125,
      "bbox_min": [
        -1631.9603271484375,
        -3334.850341796875,
        1496.0
      ],
      "bbox_max": [
        -1552.108154296875,
        -3313.192626953125,
        1532.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1098410040140152,
        0.04768495261669159,
        -0.9928046464920044
      ],
      "plane_d": 1822.5477294921875,
      "bbox_min": [
        -1631.9603271484375,
        -3334.850341796875,
        1496.0
      ],
      "bbox_max": [
        -1552.108154296875,
        -3313.192626953125,
        1532.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31279879808425903,
        -0.024374349042773247,
        -0.9495065808296204
      ],
      "plane_d": 836.332763671875,
      "bbox_min": [
        -1631.9603271484375,
        -3334.850341796875,
        1498.531982421875
      ],
      "bbox_max": [
        -1552.2159423828125,
        -3315.49951171875,
        1532.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4681396782398224,
        -0.15752960741519928,
        -0.8694996237754822
      ],
      "plane_d": 1525.5126953125,
      "bbox_min": [
        -1594.576416015625,
        -3334.821044921875,
        1500.1038818359375
      ],
      "bbox_max": [
        -1552.35693359375,
        -3315.49951171875,
        1532.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6955666542053223,
        0.6805611848831177,
        0.23026825487613678
      ],
      "plane_d": 3015.617919921875,
      "bbox_min": [
        -1594.576416015625,
        -3334.724609375,
        1500.1038818359375
      ],
      "bbox_max": [
        -1552.4644775390625,
        -3315.49951171875,
        1532.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.46466103196144104,
        0.8784195780754089,
        0.11166514456272125
      ],
      "plane_d": 3485.7783203125,
      "bbox_min": [
        -1594.576416015625,
        -3334.724609375,
        1500.1038818359375
      ],
      "bbox_max": [
        -1574.6907958984375,
        -3315.49951171875,
        1512.1103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5522074103355408,
        -0.33149290084838867,
        -0.7649702429771423
      ],
      "plane_d": 920.4841918945312,
      "bbox_min": [
        -1579.2174072265625,
        -3334.724609375,
        1508.380615234375
      ],
      "bbox_max": [
        -1574.6907958984375,
        -3331.777587890625,
        1512.1103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8204036355018616,
        0.4221179783344269,
        0.3856869637966156
      ],
      "plane_d": 2116.494873046875,
      "bbox_min": [
        -1575.592529296875,
        -3334.6806640625,
        1509.958740234375
      ],
      "bbox_max": [
        -1574.6907958984375,
        -3331.777587890625,
        1512.1103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5300086140632629,
        -6.929040864633862e-06,
        -0.8479923605918884
      ],
      "plane_d": 469.8922119140625,
      "bbox_min": [
        -1563.4188232421875,
        -3334.4892578125,
        1521.2489013671875
      ],
      "bbox_max": [
        -1552.4644775390625,
        -3322.5078125,
        1532.1119384765625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.847313404083252,
        0.03997046872973442,
        -0.5295870304107666
      ],
      "plane_d": 2258.478759765625,
      "bbox_min": [
        -1563.4188232421875,
        -3332.5,
        1524.4830322265625
      ],
      "bbox_max": [
        -1552.4930419921875,
        -3322.5078125,
        1532.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.033905185759067535,
        0.9992004632949829,
        0.021191386505961418
      ],
      "plane_d": 3234.79248046875,
      "bbox_min": [
        -1563.4188232421875,
        -3322.907958984375,
        1526.01171875
      ],
      "bbox_max": [
        -1554.4388427734375,
        -3322.5078125,
        1532.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 3332.499755859375,
      "bbox_min": [
        -1554.5999755859375,
        -3332.5,
        1524.4830322265625
      ],
      "bbox_max": [
        -1552.4930419921875,
        -3332.492919921875,
        1526.60009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999086856842041,
        0.013512278907001019
      ],
      "plane_d": 3311.589599609375,
      "bbox_min": [
        -1553.320068359375,
        -3332.5,
        1524.4830322265625
      ],
      "bbox_max": [
        -1552.4930419921875,
        -3332.492919921875,
        1525.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999086856842041,
        0.013512278907001019
      ],
      "plane_d": 3311.589599609375,
      "bbox_min": [
        -1554.5999755859375,
        -3332.5,
        1521.2489013671875
      ],
      "bbox_max": [
        -1552.4644775390625,
        -3332.44921875,
        1525.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 3332.499755859375,
      "bbox_min": [
        -1554.5999755859375,
        -3332.5,
        1525.0
      ],
      "bbox_max": [
        -1553.320068359375,
        -3332.5,
        1525.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999086856842041,
        0.013512278907001019
      ],
      "plane_d": 3311.589599609375,
      "bbox_min": [
        -1554.6533203125,
        -3332.464599609375,
        1513.6531982421875
      ],
      "bbox_max": [
        -1552.35693359375,
        -3332.3466796875,
        1522.3746337890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999086856842041,
        0.013512278907001019
      ],
      "plane_d": 3311.589599609375,
      "bbox_min": [
        -1554.7879638671875,
        -3332.35693359375,
        1503.6915283203125
      ],
      "bbox_max": [
        -1552.2159423828125,
        -3332.212158203125,
        1514.4100341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999086856842041,
        0.013512278907001019
      ],
      "plane_d": 3311.589599609375,
      "bbox_min": [
        -1554.891845703125,
        -3332.2158203125,
        1496.0
      ],
      "bbox_max": [
        -1552.108154296875,
        -3332.108154296875,
        1503.975830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.46813642978668213,
        -0.6937713027000427,
        -0.5472930073738098
      ],
      "plane_d": -756.1793823242188,
      "bbox_min": [
        -1621.6109619140625,
        -3373.08251953125,
        1499.0863037109375
      ],
      "bbox_max": [
        -1552.5,
        -3334.41748046875,
        1532.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5522068738937378,
        -0.5197986364364624,
        -0.6518258452415466
      ],
      "plane_d": 119.251708984375,
      "bbox_min": [
        -1621.6109619140625,
        -3355.35693359375,
        1499.0863037109375
      ],
      "bbox_max": [
        -1552.5,
        -3334.41748046875,
        1532.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4681396782398224,
        -0.15752960741519928,
        -0.8694996237754822
      ],
      "plane_d": 1525.5126953125,
      "bbox_min": [
        -1621.6109619140625,
        -3349.080322265625,
        1499.0863037109375
      ],
      "bbox_max": [
        -1553.48388671875,
        -3334.41748046875,
        1532.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5522074103355408,
        -0.33149290084838867,
        -0.7649702429771423
      ],
      "plane_d": 920.4841918945312,
      "bbox_min": [
        -1621.6109619140625,
        -3349.080322265625,
        1499.0863037109375
      ],
      "bbox_max": [
        -1553.48388671875,
        -3334.41748046875,
        1532.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5300085544586182,
        6.930902600288391e-06,
        -0.8479923009872437
      ],
      "plane_d": 469.93841552734375,
      "bbox_min": [
        -1621.6109619140625,
        -3344.29443359375,
        1499.0863037109375
      ],
      "bbox_max": [
        -1553.9921875,
        -3334.41748046875,
        1532.1119384765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3334.5,
      "bbox_min": [
        -1554.3109130859375,
        -3334.5,
        1526.2623291015625
      ],
      "bbox_max": [
        -1553.9921875,
        -3334.5,
        1526.60009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8204036355018616,
        0.4221179783344269,
        0.3856869637966156
      ],
      "plane_d": 2116.494873046875,
      "bbox_min": [
        -1621.6109619140625,
        -3343.498046875,
        1499.0863037109375
      ],
      "bbox_max": [
        -1572.6446533203125,
        -3334.67431640625,
        1517.2835693359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3127986788749695,
        -0.024374572560191154,
        -0.9495065808296204
      ],
      "plane_d": 1842.292724609375,
      "bbox_min": [
        -1621.6109619140625,
        -3337.48291015625,
        1499.0863037109375
      ],
      "bbox_max": [
        -1592.4892578125,
        -3334.821044921875,
        1501.25244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31279879808425903,
        -0.024374349042773247,
        -0.9495065808296204
      ],
      "plane_d": 836.332763671875,
      "bbox_min": [
        -1621.6109619140625,
        -3336.699462890625,
        1499.0863037109375
      ],
      "bbox_max": [
        -1616.9332275390625,
        -3334.829345703125,
        1500.6268310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.847313404083252,
        -0.03997046872973442,
        -0.5295870304107666
      ],
      "plane_d": 1991.995849609375,
      "bbox_min": [
        -1555.8203125,
        -3337.707763671875,
        1525.1114501953125
      ],
      "bbox_max": [
        -1553.48388671875,
        -3334.487548828125,
        1526.63232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5300085544586182,
        6.930902600288391e-06,
        -0.8479923009872437
      ],
      "plane_d": 469.93841552734375,
      "bbox_min": [
        -1555.8203125,
        -3337.707763671875,
        1525.7999267578125
      ],
      "bbox_max": [
        -1554.5999755859375,
        -3334.487548828125,
        1526.562744140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.033905185759067535,
        -0.9992004632949829,
        0.021191386505961418
      ],
      "plane_d": -3426.876953125,
      "bbox_min": [
        -1559.3817138671875,
        -3344.44580078125,
        1526.778564453125
      ],
      "bbox_max": [
        -1555.4239501953125,
        -3344.282470703125,
        1529.432861328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3334.5,
      "bbox_min": [
        -1554.513916015625,
        -3334.5,
        1525.0
      ],
      "bbox_max": [
        -1552.5,
        -3334.5,
        1525.9840087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5300086140632629,
        -6.929040864633862e-06,
        -0.8479923605918884
      ],
      "plane_d": 469.89190673828125,
      "bbox_min": [
        -1563.4188232421875,
        -3373.08251953125,
        1525.0
      ],
      "bbox_max": [
        -1552.5,
        -3342.93994140625,
        1532.1119384765625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.033905185759067535,
        0.9992004632949829,
        0.021191386505961418
      ],
      "plane_d": 3275.260009765625,
      "bbox_min": [
        -1563.4188232421875,
        -3373.0,
        1525.0
      ],
      "bbox_max": [
        -1552.5,
        -3342.93994140625,
        1532.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.847313404083252,
        0.03997046872973442,
        -0.5295870304107666
      ],
      "plane_d": 2260.09765625,
      "bbox_min": [
        -1554.93896484375,
        -3373.0,
        1525.0
      ],
      "bbox_max": [
        -1552.5,
        -3363.0078125,
        1526.8118896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 3372.999755859375,
      "bbox_min": [
        -1554.5999755859375,
        -3373.0,
        1525.0
      ],
      "bbox_max": [
        -1552.5,
        -3373.0,
        1526.60009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.847313404083252,
        -0.03997046872973442,
        -0.5295870304107666
      ],
      "plane_d": 1991.995849609375,
      "bbox_min": [
        -1556.1658935546875,
        -3344.4921875,
        1525.978759765625
      ],
      "bbox_max": [
        -1554.3966064453125,
        -3342.93994140625,
        1527.4276123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.033905185759067535,
        -0.9992004632949829,
        0.021191386505961418
      ],
      "plane_d": -3426.876953125,
      "bbox_min": [
        -1556.1658935546875,
        -3344.4921875,
        1526.01171875
      ],
      "bbox_max": [
        -1554.4388427734375,
        -3344.434326171875,
        1527.4276123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 3372.999755859375,
      "bbox_min": [
        -1554.5999755859375,
        -3373.0,
        1525.0
      ],
      "bbox_max": [
        -1553.3201904296875,
        -3373.0,
        1525.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9875902533531189,
        -0.10195229202508926,
        0.11946217715740204
      ],
      "plane_d": 2521.177490234375,
      "bbox_min": [
        -3090.0,
        -3931.60009765625,
        1052.5999755859375
      ],
      "bbox_max": [
        -2766.53173828125,
        -3352.1396484375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9767470955848694,
        0.034353528171777725,
        0.2116248458623886
      ],
      "plane_d": 2855.7041015625,
      "bbox_min": [
        -3088.01416015625,
        -3580.0,
        1052.5999755859375
      ],
      "bbox_max": [
        -3031.9140625,
        -3352.1396484375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9959433078765869,
        -0.08998323231935501,
        8.233218250097707e-05
      ],
      "plane_d": 2717.095458984375,
      "bbox_min": [
        -3090.0,
        -3931.60009765625,
        1052.5999755859375
      ],
      "bbox_max": [
        -2766.53173828125,
        -3580.0,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9951902031898499,
        -0.04628791660070419,
        0.08633600920438766
      ],
      "plane_d": 2787.013916015625,
      "bbox_min": [
        -3090.0,
        -3931.36865234375,
        1052.5999755859375
      ],
      "bbox_max": [
        -3065.32470703125,
        -3580.0,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10799902677536011,
        0.9941509962081909,
        0.0
      ],
      "plane_d": 3547.587646484375,
      "bbox_min": [
        -3086.49267578125,
        -3903.7587890625,
        1082.623779296875
      ],
      "bbox_max": [
        -3080.90087890625,
        -3903.1513671875,
        1187.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10800012946128845,
        0.9941508769989014,
        0.0
      ],
      "plane_d": 3547.583740234375,
      "bbox_min": [
        -3080.909912109375,
        -3903.15234375,
        1082.623779296875
      ],
      "bbox_max": [
        -2766.53173828125,
        -3837.14013671875,
        1226.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.10799754410982132,
        0.9941511750221252,
        0.0
      ],
      "plane_d": 3551.5927734375,
      "bbox_min": [
        -3039.767822265625,
        -3902.659423828125,
        1082.623779296875
      ],
      "bbox_max": [
        -3011.49951171875,
        -3898.682861328125,
        1187.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9941473603248596,
        0.1080329641699791,
        -0.0
      ],
      "plane_d": 3443.163330078125,
      "bbox_min": [
        -3039.767822265625,
        -3902.659423828125,
        1082.623779296875
      ],
      "bbox_max": [
        -3039.335693359375,
        -3898.682861328125,
        1187.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.41285187005996704,
        0.910798192024231,
        0.0
      ],
      "plane_d": 2331.511962890625,
      "bbox_min": [
        -2839.33056640625,
        -3866.815185546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2766.53173828125,
        -3837.14013671875,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20791609585285187,
        0.9781466722488403,
        -0.0
      ],
      "plane_d": 4339.1591796875,
      "bbox_min": [
        -2817.8349609375,
        -3866.815185546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2766.53173828125,
        -3837.14013671875,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9781447649002075,
        -0.2079254388809204,
        0.0
      ],
      "plane_d": 1947.4112548828125,
      "bbox_min": [
        -2812.896728515625,
        -3866.815185546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2766.53173828125,
        -3839.42724609375,
        1226.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.2079077512025833,
        0.9781485199928284,
        -0.0
      ],
      "plane_d": 4351.14306640625,
      "bbox_min": [
        -2809.5703125,
        -3860.31298828125,
        1082.623779296875
      ],
      "bbox_max": [
        -2766.53173828125,
        -3851.1650390625,
        1203.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24250808358192444,
        -0.909406840801239,
        0.3378889858722687
      ],
      "plane_d": -2927.0478515625,
      "bbox_min": [
        -2010.0,
        -3571.833740234375,
        948.6456909179688
      ],
      "bbox_max": [
        -1760.0,
        -3203.987060546875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3485427498817444,
        -0.8757609128952026,
        0.3340070843696594
      ],
      "plane_d": -2608.564453125,
      "bbox_min": [
        -2010.0,
        -3571.833740234375,
        948.6456909179688
      ],
      "bbox_max": [
        -1760.0,
        -3244.978515625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23947833478450775,
        -0.8831087350845337,
        0.4034464955329895
      ],
      "plane_d": -2932.8583984375,
      "bbox_min": [
        -2010.0,
        -3336.106689453125,
        1160.166015625
      ],
      "bbox_max": [
        -1925.2470703125,
        -3248.052978515625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21603241562843323,
        -0.9093504548072815,
        0.35554423928260803
      ],
      "plane_d": -2994.511962890625,
      "bbox_min": [
        -2010.0,
        -3571.833740234375,
        948.6456909179688
      ],
      "bbox_max": [
        -1760.0,
        -3244.978515625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1646440476179123,
        0.8786206841468811,
        0.44823890924453735
      ],
      "plane_d": 2238.702880859375,
      "bbox_min": [
        -2010.0,
        -3571.833740234375,
        948.6456909179688
      ],
      "bbox_max": [
        -1760.0,
        -3340.234130859375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45244094729423523,
        0.7295348644256592,
        0.5129094123840332
      ],
      "plane_d": 2833.32421875,
      "bbox_min": [
        -2010.0,
        -3571.833740234375,
        950.2199096679688
      ],
      "bbox_max": [
        -1760.0,
        -3362.54541015625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5098023414611816,
        0.8602915406227112,
        0.0
      ],
      "plane_d": 4041.298828125,
      "bbox_min": [
        -2010.0,
        -3560.784423828125,
        1114.91552734375
      ],
      "bbox_max": [
        -1927.7806396484375,
        -3506.4814453125,
        1234.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6757248044013977,
        0.7371538877487183,
        -0.0
      ],
      "plane_d": 3927.4951171875,
      "bbox_min": [
        -1945.0,
        -3560.784423828125,
        1192.4141845703125
      ],
      "bbox_max": [
        -1927.7806396484375,
        -3545.0,
        1234.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0967860147356987,
        0.9410552978515625,
        0.324110209941864
      ],
      "plane_d": 3115.90478515625,
      "bbox_min": [
        -1945.0955810546875,
        -3571.833740234375,
        950.2199096679688
      ],
      "bbox_max": [
        -1760.0,
        -3362.54541015625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5098023414611816,
        0.8602915406227112,
        0.0
      ],
      "plane_d": 4041.298828125,
      "bbox_min": [
        -1945.0955810546875,
        -3545.23583984375,
        1233.8914794921875
      ],
      "bbox_max": [
        -1944.74267578125,
        -3544.943359375,
        1234.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6757248044013977,
        0.7371538877487183,
        -0.0
      ],
      "plane_d": 3927.4951171875,
      "bbox_min": [
        -1945.0,
        -3545.23583984375,
        1233.8914794921875
      ],
      "bbox_max": [
        -1944.74267578125,
        -3545.0,
        1234.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7289522290229797,
        0.6049720644950867,
        0.3203705847263336
      ],
      "plane_d": 411.9771423339844,
      "bbox_min": [
        -1888.5152587890625,
        -3571.833740234375,
        950.2199096679688
      ],
      "bbox_max": [
        -1760.0,
        -3362.54541015625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14676129817962646,
        0.7160802483558655,
        0.6824150681495667
      ],
      "plane_d": 1489.5687255859375,
      "bbox_min": [
        -1857.778564453125,
        -3493.00048828125,
        950.2199096679688
      ],
      "bbox_max": [
        -1760.0,
        -3362.54541015625,
        1167.27783203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2235765904188156,
        0.04341130331158638,
        0.9737191796302795
      ],
      "plane_d": -385.780029296875,
      "bbox_min": [
        -1826.2652587890625,
        -3393.506103515625,
        950.2199096679688
      ],
      "bbox_max": [
        -1760.0,
        -3362.54541015625,
        966.8154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34272027015686035,
        0.9365004897117615,
        0.07422665506601334
      ],
      "plane_d": 2554.111572265625,
      "bbox_min": [
        -1857.778564453125,
        -3493.00048828125,
        1064.9735107421875
      ],
      "bbox_max": [
        -1760.0,
        -3455.78955078125,
        1167.27783203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14676129817962646,
        0.7160802483558655,
        0.6824150681495667
      ],
      "plane_d": 1489.5687255859375,
      "bbox_min": [
        -1888.5152587890625,
        -3493.00048828125,
        963.95751953125
      ],
      "bbox_max": [
        -1816.41650390625,
        -3380.125732421875,
        1082.9918212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.043616753071546555,
        0.9218221306800842,
        0.38515132665634155
      ],
      "plane_d": 2676.18310546875,
      "bbox_min": [
        -1888.5152587890625,
        -3407.556884765625,
        966.8154296875
      ],
      "bbox_max": [
        -1822.9830322265625,
        -3393.506103515625,
        1000.8163452148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7289522290229797,
        0.6049720644950867,
        0.3203705847263336
      ],
      "plane_d": 411.9771423339844,
      "bbox_min": [
        -2010.0,
        -3551.677978515625,
        948.6456909179688
      ],
      "bbox_max": [
        -1760.0,
        -3340.234130859375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34272027015686035,
        0.9365004897117615,
        0.07422665506601334
      ],
      "plane_d": 2554.111572265625,
      "bbox_min": [
        -1816.41650390625,
        -3483.12548828125,
        948.6456909179688
      ],
      "bbox_max": [
        -1760.0,
        -3340.234130859375,
        1265.1668701171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21186989545822144,
        0.07687602192163467,
        0.9742696285247803
      ],
      "plane_d": -294.561767578125,
      "bbox_min": [
        -1813.3851318359375,
        -3376.00732421875,
        948.6456909179688
      ],
      "bbox_max": [
        -1760.0,
        -3340.234130859375,
        963.077880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21823850274085999,
        0.07879546284675598,
        0.9727092981338501
      ],
      "plane_d": -274.47198486328125,
      "bbox_min": [
        -2010.0,
        -3536.908203125,
        955.6844482421875
      ],
      "bbox_max": [
        -1790.718017578125,
        -3344.77978515625,
        1219.030029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20575138926506042,
        0.1004783883690834,
        0.9734323620796204
      ],
      "plane_d": -226.04217529296875,
      "bbox_min": [
        -2010.0,
        -3424.79638671875,
        980.9876098632812
      ],
      "bbox_max": [
        -1901.143798828125,
        -3361.1201171875,
        1010.5689086914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21186989545822144,
        0.07687602192163467,
        0.9742696285247803
      ],
      "plane_d": -294.561767578125,
      "bbox_min": [
        -2010.0,
        -3536.908203125,
        955.6844482421875
      ],
      "bbox_max": [
        -1790.718017578125,
        -3344.77978515625,
        1219.030029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2235765904188156,
        0.04341130331158638,
        0.9737191796302795
      ],
      "plane_d": -385.780029296875,
      "bbox_min": [
        -1888.5152587890625,
        -3402.5927734375,
        963.077880859375
      ],
      "bbox_max": [
        -1813.3851318359375,
        -3376.00732421875,
        981.5137939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5098023414611816,
        0.8602915406227112,
        0.0
      ],
      "plane_d": 4041.298828125,
      "bbox_min": [
        -2010.0,
        -3536.908203125,
        1140.5296630859375
      ],
      "bbox_max": [
        -1958.655029296875,
        -3506.4814453125,
        1219.030029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32936930656433105,
        -0.8532378077507019,
        0.40435269474983215
      ],
      "plane_d": -2643.852783203125,
      "bbox_min": [
        -2349.54345703125,
        -3584.349609375,
        1007.42724609375
      ],
      "bbox_max": [
        -2010.0,
        -3271.035888671875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2802785038948059,
        -0.8504679203033447,
        0.4451383650302887
      ],
      "plane_d": -2792.41162109375,
      "bbox_min": [
        -2349.54345703125,
        -3506.75830078125,
        1007.42724609375
      ],
      "bbox_max": [
        -2010.0,
        -3303.68017578125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3485427498817444,
        -0.8757609128952026,
        0.3340070843696594
      ],
      "plane_d": -2608.564453125,
      "bbox_min": [
        -2089.408203125,
        -3418.607421875,
        1007.42724609375
      ],
      "bbox_max": [
        -2010.0,
        -3383.088623046875,
        1036.9803466796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20575138926506042,
        0.1004783883690834,
        0.9734323620796204
      ],
      "plane_d": -226.04217529296875,
      "bbox_min": [
        -2089.408203125,
        -3418.607421875,
        1007.42724609375
      ],
      "bbox_max": [
        -2010.0,
        -3394.35986328125,
        1026.71435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23947833478450775,
        -0.8831087350845337,
        0.4034464955329895
      ],
      "plane_d": -2932.8583984375,
      "bbox_min": [
        -2241.28857421875,
        -3584.349609375,
        1007.6962890625
      ],
      "bbox_max": [
        -2010.0,
        -3271.035888671875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3485427498817444,
        -0.8757609128952026,
        0.3340070843696594
      ],
      "plane_d": -2608.564453125,
      "bbox_min": [
        -2089.408203125,
        -3418.607421875,
        1007.6962890625
      ],
      "bbox_max": [
        -2010.0,
        -3336.106689453125,
        1160.166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20575138926506042,
        0.1004783883690834,
        0.9734323620796204
      ],
      "plane_d": -226.04217529296875,
      "bbox_min": [
        -2089.408203125,
        -3418.607421875,
        1007.6962890625
      ],
      "bbox_max": [
        -2010.0,
        -3396.96630859375,
        1026.71435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1103413850069046,
        0.05388505384325981,
        0.9924319386482239
      ],
      "plane_d": -604.18408203125,
      "bbox_min": [
        -2241.28857421875,
        -3584.349609375,
        1008.5632934570312
      ],
      "bbox_max": [
        -2010.0,
        -3398.669677734375,
        1162.74072265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20575138926506042,
        0.1004783883690834,
        0.9734323620796204
      ],
      "plane_d": -226.04217529296875,
      "bbox_min": [
        -2105.0,
        -3459.55078125,
        1008.5632934570312
      ],
      "bbox_max": [
        -2010.0,
        -3405.365966796875,
        1029.0665283203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21823850274085999,
        0.07879546284675598,
        0.9727092981338501
      ],
      "plane_d": -274.47198486328125,
      "bbox_min": [
        -2105.0,
        -3459.55078125,
        1010.5689086914062
      ],
      "bbox_max": [
        -2010.0,
        -3421.0947265625,
        1029.0665283203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4472135901451111,
        -0.8944271802902222,
        0.0
      ],
      "plane_d": -2126.50048828125,
      "bbox_min": [
        -2105.0,
        -3430.0,
        1027.470703125
      ],
      "bbox_max": [
        -2095.0,
        -3421.0947265625,
        1029.0665283203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8849280476570129,
        0.4657277762889862,
        -0.0
      ],
      "plane_d": 3449.0419921875,
      "bbox_min": [
        -2097.061767578125,
        -3425.0,
        1027.470703125
      ],
      "bbox_max": [
        -2095.0,
        -3421.0947265625,
        1027.7003173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8618017435073853,
        0.5072331428527832,
        0.003500441089272499
      ],
      "plane_d": 3538.946533203125,
      "bbox_min": [
        -2097.061767578125,
        -3421.197998046875,
        1027.470703125
      ],
      "bbox_max": [
        -2097.0009765625,
        -3421.0947265625,
        1027.7003173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1646440476179123,
        0.8786206841468811,
        0.44823890924453735
      ],
      "plane_d": 2238.702880859375,
      "bbox_min": [
        -2069.41357421875,
        -3459.55078125,
        1011.8688354492188
      ],
      "bbox_max": [
        -2010.0,
        -3440.84375,
        1026.71435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1646440476179123,
        0.8786206841468811,
        0.44823890924453735
      ],
      "plane_d": 2238.702880859375,
      "bbox_min": [
        -2069.41357421875,
        -3459.55078125,
        1012.2451171875
      ],
      "bbox_max": [
        -2010.0,
        -3441.03564453125,
        1026.71435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5098023414611816,
        0.8602915406227112,
        0.0
      ],
      "plane_d": 4041.298828125,
      "bbox_min": [
        -2110.497314453125,
        -3506.4814453125,
        1019.2987060546875
      ],
      "bbox_max": [
        -2010.0,
        -3398.669677734375,
        1162.74072265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.8944272398948669,
        0.0
      ],
      "plane_d": 2168.986083984375,
      "bbox_min": [
        -2090.0,
        -3470.0,
        1028.187255859375
      ],
      "bbox_max": [
        -2080.0,
        -3465.0,
        1086.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1646440476179123,
        0.8786206841468811,
        0.44823890924453735
      ],
      "plane_d": 2238.702880859375,
      "bbox_min": [
        -2110.497314453125,
        -3490.472412109375,
        1019.2987060546875
      ],
      "bbox_max": [
        -2010.0,
        -3398.669677734375,
        1109.14892578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8618017435073853,
        0.5072331428527832,
        0.003500441089272499
      ],
      "plane_d": 3538.946533203125,
      "bbox_min": [
        -2110.497314453125,
        -3430.0,
        1027.6832275390625
      ],
      "bbox_max": [
        -2095.0,
        -3398.669677734375,
        1086.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4472135901451111,
        -0.8944271802902222,
        0.0
      ],
      "plane_d": -2126.50048828125,
      "bbox_min": [
        -2105.0,
        -3430.0,
        1027.6832275390625
      ],
      "bbox_max": [
        -2095.0,
        -3421.197998046875,
        1086.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8849280476570129,
        0.4657277762889862,
        -0.0
      ],
      "plane_d": 3449.0419921875,
      "bbox_min": [
        -2097.0009765625,
        -3425.0,
        1027.6832275390625
      ],
      "bbox_max": [
        -2095.0,
        -3421.197998046875,
        1086.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6399935483932495,
        -0.7400472164154053,
        0.20673252642154694
      ],
      "plane_d": -1128.05810546875,
      "bbox_min": [
        -3549.999755859375,
        -4239.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3348.9013671875,
        -4032.349609375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.202193021774292,
        0.9521721005439758,
        0.22909876704216003
      ],
      "plane_d": 4294.4814453125,
      "bbox_min": [
        -3549.999755859375,
        -4126.39453125,
        1052.5999755859375
      ],
      "bbox_max": [
        -3348.9013671875,
        -4032.349609375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7012690901756287,
        0.7012708783149719,
        0.12822175025939941
      ],
      "plane_d": 5107.23486328125,
      "bbox_min": [
        -3442.946533203125,
        -4126.39453125,
        1052.5999755859375
      ],
      "bbox_max": [
        -3348.9013671875,
        -4032.349609375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9412570595741272,
        -0.14917725324630737,
        0.30295413732528687
      ],
      "plane_d": 2217.72314453125,
      "bbox_min": [
        -3429.320556640625,
        -4126.39453125,
        1052.5999755859375
      ],
      "bbox_max": [
        -3348.9013671875,
        -4096.39453125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6449734568595886,
        -0.7364493012428284,
        0.20408721268177032
      ],
      "plane_d": -1092.6890869140625,
      "bbox_min": [
        -3502.01513671875,
        -4239.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3429.320556640625,
        -4126.103515625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8624072670936584,
        -0.13326707482337952,
        0.48835813999176025
      ],
      "plane_d": 1580.2606201171875,
      "bbox_min": [
        -3260.67529296875,
        -3795.0,
        1302.5999755859375
      ],
      "bbox_max": [
        -3080.0,
        -3342.1396484375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7868428826332092,
        0.027674341574311256,
        0.616532564163208
      ],
      "plane_d": 1719.455078125,
      "bbox_min": [
        -3260.67529296875,
        -3795.0,
        1302.5999755859375
      ],
      "bbox_max": [
        -3080.0,
        -3352.1396484375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7917473912239075,
        -0.03682546317577362,
        0.6097375154495239
      ],
      "plane_d": 1512.502685546875,
      "bbox_min": [
        -3260.67529296875,
        -3795.0,
        1302.5999755859375
      ],
      "bbox_max": [
        -3080.0,
        -3580.0,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2753306031227112,
        -0.8354538679122925,
        0.4756152629852295
      ],
      "plane_d": -2793.050048828125,
      "bbox_min": [
        -2319.057373046875,
        -3663.7890625,
        1302.5999755859375
      ],
      "bbox_max": [
        -1760.0,
        -3059.423095703125,
        1574.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22970595955848694,
        -0.8470718264579773,
        0.4792749881744385
      ],
      "plane_d": -2933.39697265625,
      "bbox_min": [
        -2144.25732421875,
        -3663.7890625,
        1302.5999755859375
      ],
      "bbox_max": [
        -1760.0,
        -3059.423095703125,
        1574.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26883310079574585,
        -0.8187206983566284,
        0.5073708295822144
      ],
      "plane_d": -2802.57958984375,
      "bbox_min": [
        -2144.25732421875,
        -3248.052978515625,
        1302.5999755859375
      ],
      "bbox_max": [
        -1760.0,
        -3059.423095703125,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23221024870872498,
        -0.8293224573135376,
        0.5082348585128784
      ],
      "plane_d": -2908.64794921875,
      "bbox_min": [
        -1958.299072265625,
        -3248.052978515625,
        1302.5999755859375
      ],
      "bbox_max": [
        -1760.0,
        -3059.423095703125,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22038745880126953,
        -0.8264544606208801,
        0.5180755853652954
      ],
      "plane_d": -2934.9130859375,
      "bbox_min": [
        -1925.2470703125,
        -3248.052978515625,
        1302.5999755859375
      ],
      "bbox_max": [
        -1760.0,
        -3105.5673828125,
        1459.6031494140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6368418335914612,
        0.7004961371421814,
        0.3220832943916321
      ],
      "plane_d": 919.1990966796875,
      "bbox_min": [
        -1925.2470703125,
        -3663.7890625,
        1302.5999755859375
      ],
      "bbox_max": [
        -1760.0,
        -3196.338134765625,
        1574.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7031068801879883,
        0.6397297978401184,
        0.31046193838119507
      ],
      "plane_d": 596.2442626953125,
      "bbox_min": [
        -1925.2470703125,
        -3663.7890625,
        1302.5999755859375
      ],
      "bbox_max": [
        -1760.0,
        -3196.338134765625,
        1574.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22038745880126953,
        -0.8264544606208801,
        0.5180755853652954
      ],
      "plane_d": -2934.9130859375,
      "bbox_min": [
        -1925.2470703125,
        -3571.833740234375,
        1302.5999755859375
      ],
      "bbox_max": [
        -1760.0,
        -3196.338134765625,
        1393.7564697265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7289522290229797,
        0.6049720644950867,
        0.3203705847263336
      ],
      "plane_d": 411.9771423339844,
      "bbox_min": [
        -1826.687255859375,
        -3571.833740234375,
        1302.5999755859375
      ],
      "bbox_max": [
        -1760.0,
        -3491.47998046875,
        1393.7564697265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7432345151901245,
        0.5606855154037476,
        0.36501291394233704
      ],
      "plane_d": 169.5526123046875,
      "bbox_min": [
        -1826.687255859375,
        -3571.833740234375,
        1302.5999755859375
      ],
      "bbox_max": [
        -1760.0,
        -3526.5615234375,
        1393.7564697265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5327659845352173,
        -0.5439295768737793,
        0.6483063697814941
      ],
      "plane_d": -1163.5986328125,
      "bbox_min": [
        -3634.55712890625,
        -4069.7685546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -3301.525390625,
        -3619.7685546875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5355481505393982,
        -0.5337325930595398,
        0.6544598937034607
      ],
      "plane_d": -1123.4718017578125,
      "bbox_min": [
        -3634.55712890625,
        -4069.7685546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -3301.525390625,
        -3820.448974609375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.735482931137085,
        0.0,
        0.6775433421134949
      ],
      "plane_d": 1875.4927978515625,
      "bbox_min": [
        -4035.11669921875,
        -4584.35205078125,
        1302.5999755859375
      ],
      "bbox_max": [
        -3749.999755859375,
        -3869.7685546875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.75782710313797,
        -0.0,
        0.6524554491043091
      ],
      "plane_d": 2056.467041015625,
      "bbox_min": [
        -4035.11669921875,
        -4584.35205078125,
        1302.5999755859375
      ],
      "bbox_max": [
        -3835.11669921875,
        -4183.41845703125,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6123817563056946,
        -0.43806323409080505,
        0.6580951809883118
      ],
      "plane_d": -415.2310791015625,
      "bbox_min": [
        -4035.11669921875,
        -4352.2294921875,
        1302.5999755859375
      ],
      "bbox_max": [
        -3835.11669921875,
        -4183.41845703125,
        1534.9000244140625
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CSlidingDoor piece: endr",
      "entity_class": "CSlidingDoor",
      "piece_name": "endr",
      "offset": 11657,
      "centroid": [
        -1360.5191040039062,
        -3090.66943359375,
        784.9983520507812
      ],
      "bbox_min": [
        -1364.5357666015625,
        -3092.723876953125,
        780.0
      ],
      "bbox_max": [
        -1356.5123291015625,
        -3088.6201171875,
        789.9967041015625
      ],
      "dimensions_source": {
        "span_x": 8.0234375,
        "span_y": 4.103759765625,
        "height_z": 9.9967041015625,
        "door_width": 8.0234375,
        "door_depth": 4.103759765625,
        "leaf_depth": 4.063759765625,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          0.4554,
          -0.8903,
          0.0
        ]
      },
      "vertices": [
        [
          -1364.5157470703125,
          -3092.713623046875,
          789.9967041015625
        ],
        [
          -1364.5357666015625,
          -3092.723876953125,
          780.0
        ],
        [
          -1356.5123291015625,
          -3088.6201171875,
          789.9967041015625
        ],
        [
          -1356.5125732421875,
          -3088.6201171875,
          780.0
        ]
      ],
      "plane_distance": -2132.1089
    }
  ],
  "tutorial_messages": []
}